export type Postcode = {
  postCode: string;
  suburb?: string;
  state?: string;
};

export const postcodes: Postcode[] = [
  { postCode: '0800', suburb: 'DARWIN', state: 'NT' },
  { postCode: '0804', suburb: 'PARAP', state: 'NT' },
  { postCode: '0810', suburb: 'ALAWA', state: 'NT' },
  { postCode: '0810', suburb: 'BRINKIN', state: 'NT' },
  { postCode: '0810', suburb: 'CASUARINA', state: 'NT' },
  { postCode: '0810', suburb: 'COCONUT GROVE', state: 'NT' },
  { postCode: '0810', suburb: 'JINGILI', state: 'NT' },
  { postCode: '0810', suburb: 'LEE POINT', state: 'NT' },
  { postCode: '0810', suburb: 'LYONS', state: 'NT' },
  { postCode: '0810', suburb: 'MILLNER', state: 'NT' },
  { postCode: '0810', suburb: 'MOIL', state: 'NT' },
  { postCode: '0810', suburb: 'MUIRHEAD', state: 'NT' },
  { postCode: '0810', suburb: 'NAKARA', state: 'NT' },
  { postCode: '0810', suburb: 'NIGHTCLIFF', state: 'NT' },
  { postCode: '0810', suburb: 'RAPID CREEK', state: 'NT' },
  { postCode: '0810', suburb: 'TIWI', state: 'NT' },
  { postCode: '0810', suburb: 'WAGAMAN', state: 'NT' },
  { postCode: '0810', suburb: 'WANGURI', state: 'NT' },
  { postCode: '0811', suburb: 'CASUARINA', state: 'NT' },
  { postCode: '0812', suburb: 'ANULA', state: 'NT' },
  { postCode: '0812', suburb: 'BUFFALO CREEK', state: 'NT' },
  { postCode: '0812', suburb: 'HOLMES', state: 'NT' },
  { postCode: '0812', suburb: 'KARAMA', state: 'NT' },
  { postCode: '0812', suburb: 'LEANYER', state: 'NT' },
  { postCode: '0812', suburb: 'MALAK', state: 'NT' },
  { postCode: '0812', suburb: 'MARRARA', state: 'NT' },
  { postCode: '0812', suburb: 'WULAGI', state: 'NT' },
  { postCode: '0813', suburb: 'KARAMA', state: 'NT' },
  { postCode: '0814', suburb: 'NIGHTCLIFF', state: 'NT' },
  { postCode: '0815', suburb: 'CHARLES DARWIN UNIVERSITY', state: 'NT' },
  { postCode: '0820', suburb: 'BAYVIEW', state: 'NT' },
  { postCode: '0820', suburb: 'CHARLES DARWIN', state: 'NT' },
  { postCode: '0820', suburb: 'COONAWARRA', state: 'NT' },
  { postCode: '0820', suburb: 'DARWIN DC', state: 'NT' },
  { postCode: '0820', suburb: 'EAST POINT', state: 'NT' },
  { postCode: '0820', suburb: 'EATON', state: 'NT' },
  { postCode: '0820', suburb: 'FANNIE BAY', state: 'NT' },
  { postCode: '0820', suburb: 'LARRAKEYAH', state: 'NT' },
  { postCode: '0820', suburb: 'LUDMILLA', state: 'NT' },
  { postCode: '0820', suburb: 'PARAP', state: 'NT' },
  { postCode: '0820', suburb: 'STUART PARK', state: 'NT' },
  { postCode: '0820', suburb: 'THE GARDENS', state: 'NT' },
  { postCode: '0820', suburb: 'THE NARROWS', state: 'NT' },
  { postCode: '0820', suburb: 'WINNELLIE', state: 'NT' },
  { postCode: '0820', suburb: 'WOOLNER', state: 'NT' },
  { postCode: '0821', suburb: 'WINNELLIE', state: 'NT' },
  { postCode: '0822', suburb: 'ACACIA HILLS', state: 'NT' },
  { postCode: '0822', suburb: 'ANGURUGU', state: 'NT' },
  { postCode: '0822', suburb: 'ANINDILYAKWA', state: 'NT' },
  { postCode: '0822', suburb: 'ANNIE RIVER', state: 'NT' },
  { postCode: '0822', suburb: 'BATHURST ISLAND', state: 'NT' },
  { postCode: '0822', suburb: 'BEES CREEK', state: 'NT' },
  { postCode: '0822', suburb: 'BELYUEN', state: 'NT' },
  { postCode: '0822', suburb: 'BLACK JUNGLE', state: 'NT' },
  { postCode: '0822', suburb: 'BLACKMORE', state: 'NT' },
  { postCode: '0822', suburb: 'BURRUNDIE', state: 'NT' },
  { postCode: '0822', suburb: 'BYNOE', state: 'NT' },
  { postCode: '0822', suburb: 'BYNOE HARBOUR', state: 'NT' },
  { postCode: '0822', suburb: 'CAMP CREEK', state: 'NT' },
  { postCode: '0822', suburb: 'CHANNEL ISLAND', state: 'NT' },
  { postCode: '0822', suburb: 'CHARLES DARWIN', state: 'NT' },
  { postCode: '0822', suburb: 'CHARLOTTE', state: 'NT' },
  { postCode: '0822', suburb: 'CLARAVALE', state: 'NT' },
  { postCode: '0822', suburb: 'COBOURG', state: 'NT' },
  { postCode: '0822', suburb: 'COLLETT CREEK', state: 'NT' },
  { postCode: '0822', suburb: 'COOMALIE CREEK', state: 'NT' },
  { postCode: '0822', suburb: 'COX PENINSULA', state: 'NT' },
  { postCode: '0822', suburb: 'DALY RIVER', state: 'NT' },
  { postCode: '0822', suburb: 'DARWIN RIVER DAM', state: 'NT' },
  { postCode: '0822', suburb: 'DELISSAVILLE', state: 'NT' },
  { postCode: '0822', suburb: 'DOUGLAS-DALY', state: 'NT' },
  { postCode: '0822', suburb: 'EAST ARM', state: 'NT' },
  { postCode: '0822', suburb: 'EAST ARNHEM', state: 'NT' },
  { postCode: '0822', suburb: 'ELRUNDIE', state: 'NT' },
  { postCode: '0822', suburb: 'EVA VALLEY', state: 'NT' },
  { postCode: '0822', suburb: 'FINNISS VALLEY', state: 'NT' },
  { postCode: '0822', suburb: 'FLEMING', state: 'NT' },
  { postCode: '0822', suburb: 'FLY CREEK', state: 'NT' },
  { postCode: '0822', suburb: 'FREDS PASS', state: 'NT' },
  { postCode: '0822', suburb: 'GALIWINKU', state: 'NT' },
  { postCode: '0822', suburb: 'GLYDE POINT', state: 'NT' },
  { postCode: '0822', suburb: 'GOULBURN ISLAND', state: 'NT' },
  { postCode: '0822', suburb: 'GUNBALANYA', state: 'NT' },
  { postCode: '0822', suburb: 'GUNN POINT', state: 'NT' },
  { postCode: '0822', suburb: 'HIDDEN VALLEY', state: 'NT' },
  { postCode: '0822', suburb: 'HOTHAM', state: 'NT' },
  { postCode: '0822', suburb: 'HUGHES', state: 'NT' },
  { postCode: '0822', suburb: 'KAKADU', state: 'NT' },
  { postCode: '0822', suburb: 'KOOLPINYAH', state: 'NT' },
  { postCode: '0822', suburb: 'LAKE BENNETT', state: 'NT' },
  { postCode: '0822', suburb: 'LAMBELLS LAGOON', state: 'NT' },
  { postCode: '0822', suburb: 'LITCHFIELD PARK', state: 'NT' },
  { postCode: '0822', suburb: 'LIVINGSTONE', state: 'NT' },
  { postCode: '0822', suburb: 'LLOYD CREEK', state: 'NT' },
  { postCode: '0822', suburb: 'MANDORAH', state: 'NT' },
  { postCode: '0822', suburb: 'MANINGRIDA', state: 'NT' },
  { postCode: '0822', suburb: 'MAPURU', state: 'NT' },
  { postCode: '0822', suburb: 'MARANUNGA', state: 'NT' },
  { postCode: '0822', suburb: 'MARGARET RIVER', state: 'NT' },
  { postCode: '0822', suburb: 'MARRAKAI', state: 'NT' },
  { postCode: '0822', suburb: 'MCMINNS LAGOON', state: 'NT' },
  { postCode: '0822', suburb: 'MICKETT CREEK', state: 'NT' },
  { postCode: '0822', suburb: 'MIDDLE POINT', state: 'NT' },
  { postCode: '0822', suburb: 'MILIKAPITI', state: 'NT' },
  { postCode: '0822', suburb: 'MILINGIMBI', state: 'NT' },
  { postCode: '0822', suburb: 'MILYAKBURRA', state: 'NT' },
  { postCode: '0822', suburb: 'MINJILANG', state: 'NT' },
  { postCode: '0822', suburb: 'MOUNT BUNDEY', state: 'NT' },
  { postCode: '0822', suburb: 'MURRUMUJUK', state: 'NT' },
  { postCode: '0822', suburb: 'NAUIYU', state: 'NT' },
  { postCode: '0822', suburb: 'NEMARLUK', state: 'NT' },
  { postCode: '0822', suburb: 'NGANMARRIYANGA', state: 'NT' },
  { postCode: '0822', suburb: 'NUMBULWAR', state: 'NT' },
  { postCode: '0822', suburb: 'NUMBURINDI', state: 'NT' },
  { postCode: '0822', suburb: 'OENPELLI', state: 'NT' },
  { postCode: '0822', suburb: 'PEPPIMENARTI', state: 'NT' },
  { postCode: '0822', suburb: 'PIRLANGIMPI', state: 'NT' },
  { postCode: '0822', suburb: 'POINT STEPHENS', state: 'NT' },
  { postCode: '0822', suburb: 'POINT STUART', state: 'NT' },
  { postCode: '0822', suburb: 'PULARUMPI', state: 'NT' },
  { postCode: '0822', suburb: 'RAKULA', state: 'NT' },
  { postCode: '0822', suburb: 'RAMINGINING', state: 'NT' },
  { postCode: '0822', suburb: 'ROBIN FALLS', state: 'NT' },
  { postCode: '0822', suburb: 'RUM JUNGLE', state: 'NT' },
  { postCode: '0822', suburb: 'SANDPALMS ROADHOUSE', state: 'NT' },
  { postCode: '0822', suburb: 'SOUTHPORT', state: 'NT' },
  { postCode: '0822', suburb: 'STAPLETON', state: 'NT' },
  { postCode: '0822', suburb: 'THAMARRURR', state: 'NT' },
  { postCode: '0822', suburb: 'TIPPERARY', state: 'NT' },
  { postCode: '0822', suburb: 'TIVENDALE', state: 'NT' },
  { postCode: '0822', suburb: 'TIWI ISLANDS', state: 'NT' },
  { postCode: '0822', suburb: 'TORTILLA FLATS', state: 'NT' },
  { postCode: '0822', suburb: 'TUMBLING WATERS', state: 'NT' },
  { postCode: '0822', suburb: 'UMBAKUMBA', state: 'NT' },
  { postCode: '0822', suburb: 'VERNON ISLANDS', state: 'NT' },
  { postCode: '0822', suburb: 'WADEYE', state: 'NT' },
  { postCode: '0822', suburb: 'WAGAIT BEACH', state: 'NT' },
  { postCode: '0822', suburb: 'WAK WAK', state: 'NT' },
  { postCode: '0822', suburb: 'WARRUWI', state: 'NT' },
  { postCode: '0822', suburb: 'WEDDELL', state: 'NT' },
  { postCode: '0822', suburb: 'WEST ARNHEM', state: 'NT' },
  { postCode: '0822', suburb: 'WICKHAM', state: 'NT' },
  { postCode: '0822', suburb: 'WINNELLIE', state: 'NT' },
  { postCode: '0822', suburb: 'WISHART', state: 'NT' },
  { postCode: '0822', suburb: 'WOOLANING', state: 'NT' },
  { postCode: '0822', suburb: 'WURRUMIYANGA', state: 'NT' },
  { postCode: '0828', suburb: 'BERRIMAH', state: 'NT' },
  { postCode: '0828', suburb: 'KNUCKEY LAGOON', state: 'NT' },
  { postCode: '0829', suburb: 'HOLTZE', state: 'NT' },
  { postCode: '0829', suburb: 'PINELANDS', state: 'NT' },
  { postCode: '0830', suburb: 'ARCHER', state: 'NT' },
  { postCode: '0830', suburb: 'DRIVER', state: 'NT' },
  { postCode: '0830', suburb: 'DURACK', state: 'NT' },
  { postCode: '0830', suburb: 'FARRAR', state: 'NT' },
  { postCode: '0830', suburb: 'GRAY', state: 'NT' },
  { postCode: '0830', suburb: 'MARLOW LAGOON', state: 'NT' },
  { postCode: '0830', suburb: 'MOULDEN', state: 'NT' },
  { postCode: '0830', suburb: 'PALMERSTON', state: 'NT' },
  { postCode: '0830', suburb: 'SHOAL BAY', state: 'NT' },
  { postCode: '0830', suburb: 'WOODROFFE', state: 'NT' },
  { postCode: '0830', suburb: 'YARRAWONGA', state: 'NT' },
  { postCode: '0831', suburb: 'PALMERSTON', state: 'NT' },
  { postCode: '0832', suburb: 'BAKEWELL', state: 'NT' },
  { postCode: '0832', suburb: 'BELLAMACK', state: 'NT' },
  { postCode: '0832', suburb: 'GUNN', state: 'NT' },
  { postCode: '0832', suburb: 'JOHNSTON', state: 'NT' },
  { postCode: '0832', suburb: 'MITCHELL', state: 'NT' },
  { postCode: '0832', suburb: 'ROSEBERY', state: 'NT' },
  { postCode: '0832', suburb: 'ROSEBERY HEIGHTS', state: 'NT' },
  { postCode: '0832', suburb: 'ZUCCOLI', state: 'NT' },
  { postCode: '0834', suburb: 'VIRGINIA', state: 'NT' },
  { postCode: '0835', suburb: 'HOWARD SPRINGS', state: 'NT' },
  { postCode: '0836', suburb: 'GIRRAWEEN', state: 'NT' },
  { postCode: '0836', suburb: 'HERBERT', state: 'NT' },
  { postCode: '0836', suburb: 'HUMPTY DOO', state: 'NT' },
  { postCode: '0837', suburb: 'MANTON', state: 'NT' },
  { postCode: '0837', suburb: 'NOONAMAH', state: 'NT' },
  { postCode: '0838', suburb: 'BERRY SPRINGS', state: 'NT' },
  { postCode: '0839', suburb: 'COOLALINGA', state: 'NT' },
  { postCode: '0840', suburb: 'DUNDEE BEACH', state: 'NT' },
  { postCode: '0840', suburb: 'DUNDEE DOWNS', state: 'NT' },
  { postCode: '0840', suburb: 'DUNDEE FOREST', state: 'NT' },
  { postCode: '0841', suburb: 'DARWIN RIVER', state: 'NT' },
  { postCode: '0845', suburb: 'BATCHELOR', state: 'NT' },
  { postCode: '0846', suburb: 'ADELAIDE RIVER', state: 'NT' },
  { postCode: '0847', suburb: 'PINE CREEK', state: 'NT' },
  { postCode: '0850', suburb: 'COSSACK', state: 'NT' },
  { postCode: '0850', suburb: 'EMUNGALAN', state: 'NT' },
  { postCode: '0850', suburb: 'KATHERINE', state: 'NT' },
  { postCode: '0850', suburb: 'KATHERINE EAST', state: 'NT' },
  { postCode: '0850', suburb: 'KATHERINE SOUTH', state: 'NT' },
  { postCode: '0850', suburb: 'LANSDOWNE', state: 'NT' },
  { postCode: '0851', suburb: 'KATHERINE', state: 'NT' },
  { postCode: '0852', suburb: 'ARNOLD', state: 'NT' },
  { postCode: '0852', suburb: 'BAINES', state: 'NT' },
  { postCode: '0852', suburb: 'BARUNGA', state: 'NT' },
  { postCode: '0852', suburb: 'BESWICK', state: 'NT' },
  { postCode: '0852', suburb: 'BESWICK CREEK', state: 'NT' },
  { postCode: '0852', suburb: 'BINJARI', state: 'NT' },
  { postCode: '0852', suburb: 'BIRDUM', state: 'NT' },
  { postCode: '0852', suburb: 'BRADSHAW', state: 'NT' },
  { postCode: '0852', suburb: 'BUCHANAN', state: 'NT' },
  { postCode: '0852', suburb: 'BULMAN WEEMOL', state: 'NT' },
  { postCode: '0852', suburb: 'CRESWELL', state: 'NT' },
  { postCode: '0852', suburb: 'DAGURAGU', state: 'NT' },
  { postCode: '0852', suburb: 'DALY WATERS', state: 'NT' },
  { postCode: '0852', suburb: 'DELAMERE', state: 'NT' },
  { postCode: '0852', suburb: 'EDITH', state: 'NT' },
  { postCode: '0852', suburb: 'ELSEY', state: 'NT' },
  { postCode: '0852', suburb: 'FLORINA', state: 'NT' },
  { postCode: '0852', suburb: 'FLYING FOX', state: 'NT' },
  { postCode: '0852', suburb: 'GREGORY', state: 'NT' },
  { postCode: '0852', suburb: 'GULUNG MARDRULK', state: 'NT' },
  { postCode: '0852', suburb: 'GURINDJI', state: 'NT' },
  { postCode: '0852', suburb: 'HELEN SPRINGS STATION', state: 'NT' },
  { postCode: '0852', suburb: 'JILKMINGGAN', state: 'NT' },
  { postCode: '0852', suburb: 'KALKARINDJI', state: 'NT' },
  { postCode: '0852', suburb: 'KATHERINE', state: 'NT' },
  { postCode: '0852', suburb: 'LAJAMANU', state: 'NT' },
  { postCode: '0852', suburb: 'LARRIMAH', state: 'NT' },
  { postCode: '0852', suburb: 'LIMMEN', state: 'NT' },
  { postCode: '0852', suburb: 'MANBULLOO', state: 'NT' },
  { postCode: '0852', suburb: 'MARANBOY', state: 'NT' },
  { postCode: '0852', suburb: 'MATARANKA', state: 'NT' },
  { postCode: '0852', suburb: 'MCARTHUR', state: 'NT' },
  { postCode: '0852', suburb: 'MINIYERI', state: 'NT' },
  { postCode: '0852', suburb: 'NGUKURR', state: 'NT' },
  { postCode: '0852', suburb: 'NITMILUK', state: 'NT' },
  { postCode: '0852', suburb: 'NUTWOOD DOWNS', state: 'NT' },
  { postCode: '0852', suburb: 'PELLEW ISLANDS', state: 'NT' },
  { postCode: '0852', suburb: 'PIGEON HOLE', state: 'NT' },
  { postCode: '0852', suburb: 'ROBINSON RIVER', state: 'NT' },
  { postCode: '0852', suburb: 'STURT PLATEAU', state: 'NT' },
  { postCode: '0852', suburb: 'TANAMI EAST', state: 'NT' },
  { postCode: '0852', suburb: 'TIMBER CREEK', state: 'NT' },
  { postCode: '0852', suburb: 'TOP SPRINGS', state: 'NT' },
  { postCode: '0852', suburb: 'URALLA', state: 'NT' },
  { postCode: '0852', suburb: 'VENN', state: 'NT' },
  { postCode: '0852', suburb: 'VICTORIA RIVER', state: 'NT' },
  { postCode: '0852', suburb: 'WARUMUNGU', state: 'NT' },
  { postCode: '0852', suburb: 'WAVE HILL', state: 'NT' },
  { postCode: '0852', suburb: 'WILTON', state: 'NT' },
  { postCode: '0852', suburb: 'YARRALIN', state: 'NT' },
  { postCode: '0853', suburb: 'TINDAL', state: 'NT' },
  { postCode: '0854', suburb: 'BORROLOOLA', state: 'NT' },
  { postCode: '0854', suburb: 'KING ASH BAY', state: 'NT' },
  { postCode: '0860', suburb: 'TENNANT CREEK', state: 'NT' },
  { postCode: '0861', suburb: 'TENNANT CREEK', state: 'NT' },
  { postCode: '0862', suburb: 'CALVERT', state: 'NT' },
  { postCode: '0862', suburb: 'ELLIOTT', state: 'NT' },
  { postCode: '0862', suburb: 'NEWCASTLE WATERS', state: 'NT' },
  { postCode: '0862', suburb: 'NICHOLSON', state: 'NT' },
  { postCode: '0862', suburb: 'PAMAYU', state: 'NT' },
  { postCode: '0862', suburb: 'RENNER SPRINGS', state: 'NT' },
  { postCode: '0862', suburb: 'TABLELANDS', state: 'NT' },
  { postCode: '0862', suburb: 'TENNANT CREEK', state: 'NT' },
  { postCode: '0862', suburb: 'WARREGO', state: 'NT' },
  { postCode: '0870', suburb: 'ALICE SPRINGS', state: 'NT' },
  { postCode: '0870', suburb: 'ARALUEN', state: 'NT' },
  { postCode: '0870', suburb: 'BRAITLING', state: 'NT' },
  { postCode: '0870', suburb: 'CICCONE', state: 'NT' },
  { postCode: '0870', suburb: 'DESERT SPRINGS', state: 'NT' },
  { postCode: '0870', suburb: 'EAST SIDE', state: 'NT' },
  { postCode: '0870', suburb: 'GILLEN', state: 'NT' },
  { postCode: '0870', suburb: 'SADADEEN', state: 'NT' },
  { postCode: '0870', suburb: 'STUART', state: 'NT' },
  { postCode: '0870', suburb: 'THE GAP', state: 'NT' },
  { postCode: '0870', suburb: 'WHITE GUMS', state: 'NT' },
  { postCode: '0871', suburb: 'ALICE SPRINGS', state: 'NT' },
  { postCode: '0872', suburb: 'ALI CURUNG', state: 'NT' },
  { postCode: '0872', suburb: 'ALICE SPRINGS', state: 'NT' },
  { postCode: '0872', suburb: 'AMATA', state: 'SA' },
  { postCode: '0872', suburb: 'AMPILATWATJA', state: 'NT' },
  {
    postCode: '0872',
    suburb: 'ANANGU PITJANTJATJARA YANKUNYTJATJARA',
    state: 'SA',
  },
  { postCode: '0872', suburb: 'ANATYE', state: 'NT' },
  { postCode: '0872', suburb: 'ANMATJERE', state: 'NT' },
  { postCode: '0872', suburb: 'AREYONGA', state: 'NT' },
  { postCode: '0872', suburb: 'ATITJERE', state: 'NT' },
  { postCode: '0872', suburb: 'AYERS RANGE SOUTH', state: 'SA' },
  { postCode: '0872', suburb: 'BARROW CREEK', state: 'NT' },
  { postCode: '0872', suburb: 'BURT PLAIN', state: 'NT' },
  { postCode: '0872', suburb: 'CANTEEN CREEK', state: 'NT' },
  { postCode: '0872', suburb: 'CHILLA WELL', state: 'NT' },
  { postCode: '0872', suburb: 'COSTELLO', state: 'NT' },
  { postCode: '0872', suburb: 'DAVENPORT', state: 'NT' },
  { postCode: '0872', suburb: 'DE ROSE HILL', state: 'SA' },
  { postCode: '0872', suburb: 'ENGAWALA', state: 'NT' },
  { postCode: '0872', suburb: 'ERLDUNDA', state: 'NT' },
  { postCode: '0872', suburb: 'ERNABELLA (PUKATJA)', state: 'SA' },
  { postCode: '0872', suburb: 'FINKE', state: 'NT' },
  { postCode: '0872', suburb: 'GHAN', state: 'NT' },
  { postCode: '0872', suburb: 'GIBSON DESERT NORTH', state: 'WA' },
  { postCode: '0872', suburb: 'GIBSON DESERT SOUTH', state: 'WA' },
  { postCode: '0872', suburb: 'HAASTS BLUFF', state: 'NT' },
  { postCode: '0872', suburb: 'HALE', state: 'NT' },
  { postCode: '0872', suburb: 'HART', state: 'NT' },
  { postCode: '0872', suburb: 'HART RANGE', state: 'NT' },
  { postCode: '0872', suburb: 'HERMANNSBURG', state: 'NT' },
  { postCode: '0872', suburb: 'HUGH', state: 'NT' },
  { postCode: '0872', suburb: 'IMANPA', state: 'NT' },
  { postCode: '0872', suburb: 'INDULKANA (IWANTJA)', state: 'SA' },
  { postCode: '0872', suburb: 'ININTI STORE', state: 'NT' },
  { postCode: '0872', suburb: 'IWANTJA', state: 'SA' },
  { postCode: '0872', suburb: 'KALKA', state: 'SA' },
  { postCode: '0872', suburb: 'KALTJITI', state: 'SA' },
  { postCode: '0872', suburb: 'KALTUKATJARA', state: 'NT' },
  { postCode: '0872', suburb: 'KANPI', state: 'SA' },
  { postCode: '0872', suburb: 'KINGS CREEK STATION', state: 'NT' },
  { postCode: '0872', suburb: 'KINTORE', state: 'NT' },
  { postCode: '0872', suburb: 'KIWIRRKURRA', state: 'WA' },
  { postCode: '0872', suburb: 'KULGERA', state: 'NT' },
  { postCode: '0872', suburb: 'KUNPARRKA', state: 'NT' },
  { postCode: '0872', suburb: 'LAKE MACKAY', state: 'NT' },
  { postCode: '0872', suburb: 'LAMBINA', state: 'SA' },
  { postCode: '0872', suburb: 'LARAMBA', state: 'NT' },
  { postCode: '0872', suburb: 'MACDONNELL RANGE', state: 'NT' },
  { postCode: '0872', suburb: 'MEREENIE', state: 'NT' },
  { postCode: '0872', suburb: 'MIMILI', state: 'SA' },
  { postCode: '0872', suburb: 'MOUNT LIEBIG', state: 'NT' },
  { postCode: '0872', suburb: 'MOUNT ZEIL', state: 'NT' },
  { postCode: '0872', suburb: 'MURPUTJA', state: 'SA' },
  { postCode: '0872', suburb: 'MUTITJULU', state: 'NT' },
  { postCode: '0872', suburb: 'NAMATJIRA', state: 'NT' },
  { postCode: '0872', suburb: 'NAPPERBY STATION', state: 'NT' },
  { postCode: '0872', suburb: 'NGAANYATJARRA-GILES', state: 'WA' },
  { postCode: '0872', suburb: 'NYAPARI', state: 'SA' },
  { postCode: '0872', suburb: 'NYIRRIPI', state: 'NT' },
  { postCode: '0872', suburb: 'PAPUNYA', state: 'NT' },
  { postCode: '0872', suburb: 'PATJARR', state: 'WA' },
  { postCode: '0872', suburb: 'PETERMANN', state: 'NT' },
  { postCode: '0872', suburb: 'PIPALYATJARA', state: 'SA' },
  { postCode: '0872', suburb: 'PUKATJA', state: 'SA' },
  { postCode: '0872', suburb: 'SANDOVER', state: 'NT' },
  { postCode: '0872', suburb: 'SANTA TERESA', state: 'NT' },
  { postCode: '0872', suburb: 'SIMPSON', state: 'NT' },
  { postCode: '0872', suburb: 'TANAMI', state: 'NT' },
  { postCode: '0872', suburb: 'TARA', state: 'NT' },
  { postCode: '0872', suburb: 'TELEGRAPH STATION', state: 'NT' },
  { postCode: '0872', suburb: 'TI TREE', state: 'NT' },
  { postCode: '0872', suburb: 'TIEYON', state: 'SA' },
  { postCode: '0872', suburb: 'TITJIKALA', state: 'NT' },
  { postCode: '0872', suburb: 'TJIRRKARLI', state: 'WA' },
  { postCode: '0872', suburb: 'TJUKURLA', state: 'WA' },
  { postCode: '0872', suburb: 'UMUWA', state: 'SA' },
  { postCode: '0872', suburb: 'WALLACE ROCKHOLE', state: 'NT' },
  { postCode: '0872', suburb: 'WANARN', state: 'WA' },
  { postCode: '0872', suburb: 'WATARRU', state: 'SA' },
  { postCode: '0872', suburb: 'WATINUMA', state: 'SA' },
  { postCode: '0872', suburb: 'WILLOWRA', state: 'NT' },
  { postCode: '0872', suburb: 'WILORA', state: 'NT' },
  { postCode: '0872', suburb: 'WINGELLINA', state: 'WA' },
  { postCode: '0872', suburb: 'WUTUNUGURRA', state: 'NT' },
  { postCode: '0872', suburb: 'YUELAMU', state: 'NT' },
  { postCode: '0872', suburb: 'YUENDUMU', state: 'NT' },
  { postCode: '0872', suburb: 'YULARA', state: 'NT' },
  { postCode: '0872', suburb: 'YUNYARINYI', state: 'SA' },
  { postCode: '0873', suburb: 'AMOONGUNA', state: 'NT' },
  { postCode: '0873', suburb: 'ARUMBERA', state: 'NT' },
  { postCode: '0873', suburb: 'CONNELLAN', state: 'NT' },
  { postCode: '0873', suburb: 'HEAVITREE GAP CPA', state: 'NT' },
  { postCode: '0873', suburb: 'ILPARPA', state: 'NT' },
  { postCode: '0873', suburb: 'KILGARIFF', state: 'NT' },
  { postCode: '0873', suburb: 'ROSS', state: 'NT' },
  { postCode: '0874', suburb: 'IRLPME', state: 'NT' },
  { postCode: '0874', suburb: 'MOUNT JOHNS', state: 'NT' },
  { postCode: '0874', suburb: 'UNDOOLYA', state: 'NT' },
  { postCode: '0875', suburb: 'FLYNN', state: 'NT' },
  { postCode: '0875', suburb: 'LARAPINTA', state: 'NT' },
  { postCode: '0880', suburb: 'GAPUWIYAK', state: 'NT' },
  { postCode: '0880', suburb: 'GUNYANGARA', state: 'NT' },
  { postCode: '0880', suburb: 'NHULUNBUY', state: 'NT' },
  { postCode: '0880', suburb: 'YIRRKALA', state: 'NT' },
  { postCode: '0881', suburb: 'NHULUNBUY', state: 'NT' },
  { postCode: '0885', suburb: 'ALYANGULA', state: 'NT' },
  { postCode: '0886', suburb: 'JABIRU', state: 'NT' },
  { postCode: '0909', suburb: 'CHARLES DARWIN UNIVERSITY', state: 'NT' },
  { postCode: '2000', suburb: 'BARANGAROO', state: 'NSW' },
  { postCode: '2000', suburb: 'DAWES POINT', state: 'NSW' },
  { postCode: '2000', suburb: 'HAYMARKET', state: 'NSW' },
  { postCode: '2000', suburb: 'MILLERS POINT', state: 'NSW' },
  { postCode: '2000', suburb: 'PARLIAMENT HOUSE', state: 'NSW' },
  { postCode: '2000', suburb: 'SYDNEY', state: 'NSW' },
  { postCode: '2000', suburb: 'SYDNEY SOUTH', state: 'NSW' },
  { postCode: '2000', suburb: 'THE ROCKS', state: 'NSW' },
  { postCode: '2002', suburb: 'WORLD SQUARE', state: 'NSW' },
  { postCode: '2004', suburb: 'ALEXANDRIA MC', state: 'NSW' },
  { postCode: '2004', suburb: 'EASTERN SUBURBS MC', state: 'NSW' },
  { postCode: '2006', suburb: 'THE UNIVERSITY OF SYDNEY', state: 'NSW' },
  { postCode: '2007', suburb: 'BROADWAY', state: 'NSW' },
  { postCode: '2007', suburb: 'ULTIMO', state: 'NSW' },
  { postCode: '2008', suburb: 'CHIPPENDALE', state: 'NSW' },
  { postCode: '2008', suburb: 'DARLINGTON', state: 'NSW' },
  { postCode: '2009', suburb: 'PYRMONT', state: 'NSW' },
  { postCode: '2010', suburb: 'DARLINGHURST', state: 'NSW' },
  { postCode: '2010', suburb: 'SURRY HILLS', state: 'NSW' },
  { postCode: '2011', suburb: 'ELIZABETH BAY', state: 'NSW' },
  { postCode: '2011', suburb: 'POTTS POINT', state: 'NSW' },
  { postCode: '2011', suburb: 'RUSHCUTTERS BAY', state: 'NSW' },
  { postCode: '2011', suburb: 'WOOLLOOMOOLOO', state: 'NSW' },
  { postCode: '2012', suburb: 'STRAWBERRY HILLS', state: 'NSW' },
  { postCode: '2015', suburb: 'ALEXANDRIA', state: 'NSW' },
  { postCode: '2015', suburb: 'BEACONSFIELD', state: 'NSW' },
  { postCode: '2015', suburb: 'EVELEIGH', state: 'NSW' },
  { postCode: '2016', suburb: 'REDFERN', state: 'NSW' },
  { postCode: '2017', suburb: 'WATERLOO', state: 'NSW' },
  { postCode: '2017', suburb: 'WATERLOO DC', state: 'NSW' },
  { postCode: '2017', suburb: 'ZETLAND', state: 'NSW' },
  { postCode: '2018', suburb: 'EASTLAKES', state: 'NSW' },
  { postCode: '2018', suburb: 'ROSEBERY', state: 'NSW' },
  { postCode: '2019', suburb: 'BANKSMEADOW', state: 'NSW' },
  { postCode: '2019', suburb: 'BOTANY', state: 'NSW' },
  { postCode: '2020', suburb: 'MASCOT', state: 'NSW' },
  { postCode: '2020', suburb: 'SYDNEY DOMESTIC AIRPORT', state: 'NSW' },
  {
    postCode: '2020',
    suburb: 'SYDNEY INTERNATIONAL AIRPORT',
    state: 'NSW',
  },
  { postCode: '2021', suburb: 'CENTENNIAL PARK', state: 'NSW' },
  { postCode: '2021', suburb: 'MOORE PARK', state: 'NSW' },
  { postCode: '2021', suburb: 'PADDINGTON', state: 'NSW' },
  { postCode: '2022', suburb: 'BONDI JUNCTION', state: 'NSW' },
  { postCode: '2022', suburb: 'QUEENS PARK', state: 'NSW' },
  { postCode: '2023', suburb: 'BELLEVUE HILL', state: 'NSW' },
  { postCode: '2024', suburb: 'BRONTE', state: 'NSW' },
  { postCode: '2024', suburb: 'WAVERLEY', state: 'NSW' },
  { postCode: '2025', suburb: 'WOOLLAHRA', state: 'NSW' },
  { postCode: '2026', suburb: 'BONDI', state: 'NSW' },
  { postCode: '2026', suburb: 'BONDI BEACH', state: 'NSW' },
  { postCode: '2026', suburb: 'NORTH BONDI', state: 'NSW' },
  { postCode: '2026', suburb: 'TAMARAMA', state: 'NSW' },
  { postCode: '2027', suburb: 'DARLING POINT', state: 'NSW' },
  { postCode: '2027', suburb: 'EDGECLIFF', state: 'NSW' },
  { postCode: '2027', suburb: 'HMAS RUSHCUTTERS', state: 'NSW' },
  { postCode: '2027', suburb: 'POINT PIPER', state: 'NSW' },
  { postCode: '2028', suburb: 'DOUBLE BAY', state: 'NSW' },
  { postCode: '2029', suburb: 'ROSE BAY', state: 'NSW' },
  { postCode: '2030', suburb: 'DOVER HEIGHTS', state: 'NSW' },
  { postCode: '2030', suburb: 'HMAS WATSON', state: 'NSW' },
  { postCode: '2030', suburb: 'ROSE BAY NORTH', state: 'NSW' },
  { postCode: '2030', suburb: 'VAUCLUSE', state: 'NSW' },
  { postCode: '2030', suburb: 'WATSONS BAY', state: 'NSW' },
  { postCode: '2031', suburb: 'CLOVELLY', state: 'NSW' },
  { postCode: '2031', suburb: 'CLOVELLY WEST', state: 'NSW' },
  { postCode: '2031', suburb: 'RANDWICK', state: 'NSW' },
  { postCode: '2031', suburb: 'RANDWICK DC', state: 'NSW' },
  { postCode: '2031', suburb: 'ST PAULS', state: 'NSW' },
  { postCode: '2032', suburb: 'DACEYVILLE', state: 'NSW' },
  { postCode: '2032', suburb: 'KINGSFORD', state: 'NSW' },
  { postCode: '2033', suburb: 'KENSINGTON', state: 'NSW' },
  { postCode: '2034', suburb: 'COOGEE', state: 'NSW' },
  { postCode: '2034', suburb: 'SOUTH COOGEE', state: 'NSW' },
  { postCode: '2035', suburb: 'MAROUBRA', state: 'NSW' },
  { postCode: '2035', suburb: 'MAROUBRA SOUTH', state: 'NSW' },
  { postCode: '2035', suburb: 'PAGEWOOD', state: 'NSW' },
  { postCode: '2036', suburb: 'CHIFLEY', state: 'NSW' },
  { postCode: '2036', suburb: 'EASTGARDENS', state: 'NSW' },
  { postCode: '2036', suburb: 'HILLSDALE', state: 'NSW' },
  { postCode: '2036', suburb: 'LA PEROUSE', state: 'NSW' },
  { postCode: '2036', suburb: 'LITTLE BAY', state: 'NSW' },
  { postCode: '2036', suburb: 'MALABAR', state: 'NSW' },
  { postCode: '2036', suburb: 'MATRAVILLE', state: 'NSW' },
  { postCode: '2036', suburb: 'PHILLIP BAY', state: 'NSW' },
  { postCode: '2036', suburb: 'PORT BOTANY', state: 'NSW' },
  { postCode: '2037', suburb: 'FOREST LODGE', state: 'NSW' },
  { postCode: '2037', suburb: 'GLEBE', state: 'NSW' },
  { postCode: '2038', suburb: 'ANNANDALE', state: 'NSW' },
  { postCode: '2039', suburb: 'ROZELLE', state: 'NSW' },
  { postCode: '2040', suburb: 'LEICHHARDT', state: 'NSW' },
  { postCode: '2040', suburb: 'LILYFIELD', state: 'NSW' },
  { postCode: '2041', suburb: 'BALMAIN', state: 'NSW' },
  { postCode: '2041', suburb: 'BALMAIN EAST', state: 'NSW' },
  { postCode: '2041', suburb: 'BIRCHGROVE', state: 'NSW' },
  { postCode: '2042', suburb: 'ENMORE', state: 'NSW' },
  { postCode: '2042', suburb: 'NEWTOWN', state: 'NSW' },
  { postCode: '2043', suburb: 'ERSKINEVILLE', state: 'NSW' },
  { postCode: '2044', suburb: 'ST PETERS', state: 'NSW' },
  { postCode: '2044', suburb: 'ST PETERS DC', state: 'NSW' },
  { postCode: '2044', suburb: 'SYDENHAM', state: 'NSW' },
  { postCode: '2044', suburb: 'TEMPE', state: 'NSW' },
  { postCode: '2045', suburb: 'HABERFIELD', state: 'NSW' },
  { postCode: '2046', suburb: 'ABBOTSFORD', state: 'NSW' },
  { postCode: '2046', suburb: 'CANADA BAY', state: 'NSW' },
  { postCode: '2046', suburb: 'CHISWICK', state: 'NSW' },
  { postCode: '2046', suburb: 'FIVE DOCK', state: 'NSW' },
  { postCode: '2046', suburb: 'RODD POINT', state: 'NSW' },
  { postCode: '2046', suburb: 'RUSSELL LEA', state: 'NSW' },
  { postCode: '2046', suburb: 'WAREEMBA', state: 'NSW' },
  { postCode: '2047', suburb: 'DRUMMOYNE', state: 'NSW' },
  { postCode: '2048', suburb: 'STANMORE', state: 'NSW' },
  { postCode: '2048', suburb: 'WESTGATE', state: 'NSW' },
  { postCode: '2049', suburb: 'LEWISHAM', state: 'NSW' },
  { postCode: '2049', suburb: 'PETERSHAM', state: 'NSW' },
  { postCode: '2049', suburb: 'PETERSHAM NORTH', state: 'NSW' },
  { postCode: '2050', suburb: 'CAMPERDOWN', state: 'NSW' },
  { postCode: '2050', suburb: 'MISSENDEN ROAD', state: 'NSW' },
  { postCode: '2052', suburb: 'UNSW SYDNEY', state: 'NSW' },
  { postCode: '2057', suburb: 'CHATSWOOD', state: 'NSW' },
  { postCode: '2059', suburb: 'NORTH SYDNEY', state: 'NSW' },
  { postCode: '2060', suburb: 'HMAS PLATYPUS', state: 'NSW' },
  { postCode: '2060', suburb: 'HMAS WATERHEN', state: 'NSW' },
  { postCode: '2060', suburb: 'LAVENDER BAY', state: 'NSW' },
  { postCode: '2060', suburb: 'MCMAHONS POINT', state: 'NSW' },
  { postCode: '2060', suburb: 'NORTH SYDNEY', state: 'NSW' },
  { postCode: '2060', suburb: 'NORTH SYDNEY SHOPPINGWORLD', state: 'NSW' },
  { postCode: '2060', suburb: 'WAVERTON', state: 'NSW' },
  { postCode: '2061', suburb: 'KIRRIBILLI', state: 'NSW' },
  { postCode: '2061', suburb: 'MILSONS POINT', state: 'NSW' },
  { postCode: '2062', suburb: 'CAMMERAY', state: 'NSW' },
  { postCode: '2063', suburb: 'NORTHBRIDGE', state: 'NSW' },
  { postCode: '2064', suburb: 'ARTARMON', state: 'NSW' },
  { postCode: '2065', suburb: 'CROWS NEST', state: 'NSW' },
  { postCode: '2065', suburb: 'CROWS NEST DC', state: 'NSW' },
  { postCode: '2065', suburb: 'GREENWICH', state: 'NSW' },
  { postCode: '2065', suburb: 'NAREMBURN', state: 'NSW' },
  { postCode: '2065', suburb: 'ROYAL NORTH SHORE HOSPITAL', state: 'NSW' },
  { postCode: '2065', suburb: 'ST LEONARDS', state: 'NSW' },
  { postCode: '2065', suburb: 'WOLLSTONECRAFT', state: 'NSW' },
  { postCode: '2066', suburb: 'LANE COVE', state: 'NSW' },
  { postCode: '2066', suburb: 'LANE COVE DC', state: 'NSW' },
  { postCode: '2066', suburb: 'LANE COVE NORTH', state: 'NSW' },
  { postCode: '2066', suburb: 'LANE COVE WEST', state: 'NSW' },
  { postCode: '2066', suburb: 'LINLEY POINT', state: 'NSW' },
  { postCode: '2066', suburb: 'LONGUEVILLE', state: 'NSW' },
  { postCode: '2066', suburb: 'NORTHWOOD', state: 'NSW' },
  { postCode: '2066', suburb: 'RIVERVIEW', state: 'NSW' },
  { postCode: '2067', suburb: 'CHATSWOOD', state: 'NSW' },
  { postCode: '2067', suburb: 'CHATSWOOD WEST', state: 'NSW' },
  { postCode: '2068', suburb: 'CASTLECRAG', state: 'NSW' },
  { postCode: '2068', suburb: 'MIDDLE COVE', state: 'NSW' },
  { postCode: '2068', suburb: 'NORTH WILLOUGHBY', state: 'NSW' },
  { postCode: '2068', suburb: 'WILLOUGHBY', state: 'NSW' },
  { postCode: '2068', suburb: 'WILLOUGHBY EAST', state: 'NSW' },
  { postCode: '2068', suburb: 'WILLOUGHBY NORTH', state: 'NSW' },
  { postCode: '2069', suburb: 'CASTLE COVE', state: 'NSW' },
  { postCode: '2069', suburb: 'ROSEVILLE', state: 'NSW' },
  { postCode: '2069', suburb: 'ROSEVILLE CHASE', state: 'NSW' },
  { postCode: '2070', suburb: 'EAST LINDFIELD', state: 'NSW' },
  { postCode: '2070', suburb: 'LINDFIELD', state: 'NSW' },
  { postCode: '2070', suburb: 'LINDFIELD WEST', state: 'NSW' },
  { postCode: '2071', suburb: 'EAST KILLARA', state: 'NSW' },
  { postCode: '2071', suburb: 'KILLARA', state: 'NSW' },
  { postCode: '2072', suburb: 'GORDON', state: 'NSW' },
  { postCode: '2073', suburb: 'PYMBLE', state: 'NSW' },
  { postCode: '2073', suburb: 'WEST PYMBLE', state: 'NSW' },
  { postCode: '2074', suburb: 'NORTH TURRAMURRA', state: 'NSW' },
  { postCode: '2074', suburb: 'SOUTH TURRAMURRA', state: 'NSW' },
  { postCode: '2074', suburb: 'TURRAMURRA', state: 'NSW' },
  { postCode: '2074', suburb: 'WARRAWEE', state: 'NSW' },
  { postCode: '2075', suburb: 'ST IVES', state: 'NSW' },
  { postCode: '2075', suburb: 'ST IVES CHASE', state: 'NSW' },
  { postCode: '2076', suburb: 'NORMANHURST', state: 'NSW' },
  { postCode: '2076', suburb: 'NORTH WAHROONGA', state: 'NSW' },
  { postCode: '2076', suburb: 'WAHROONGA', state: 'NSW' },
  { postCode: '2077', suburb: 'ASQUITH', state: 'NSW' },
  { postCode: '2077', suburb: 'HORNSBY', state: 'NSW' },
  { postCode: '2077', suburb: 'HORNSBY HEIGHTS', state: 'NSW' },
  { postCode: '2077', suburb: 'WAITARA', state: 'NSW' },
  { postCode: '2079', suburb: 'MOUNT COLAH', state: 'NSW' },
  { postCode: '2080', suburb: 'MOUNT KURING-GAI', state: 'NSW' },
  { postCode: '2081', suburb: 'BEROWRA', state: 'NSW' },
  { postCode: '2081', suburb: 'COWAN', state: 'NSW' },
  { postCode: '2082', suburb: 'BEROWRA CREEK', state: 'NSW' },
  { postCode: '2082', suburb: 'BEROWRA HEIGHTS', state: 'NSW' },
  { postCode: '2082', suburb: 'BEROWRA WATERS', state: 'NSW' },
  { postCode: '2083', suburb: 'BAR POINT', state: 'NSW' },
  { postCode: '2083', suburb: 'BROOKLYN', state: 'NSW' },
  { postCode: '2083', suburb: 'CHEERO POINT', state: 'NSW' },
  { postCode: '2083', suburb: 'COGRA BAY', state: 'NSW' },
  { postCode: '2083', suburb: 'DANGAR ISLAND', state: 'NSW' },
  { postCode: '2083', suburb: 'MILSONS PASSAGE', state: 'NSW' },
  { postCode: '2083', suburb: 'MOONEY MOONEY', state: 'NSW' },
  { postCode: '2084', suburb: 'COTTAGE POINT', state: 'NSW' },
  { postCode: '2084', suburb: 'DUFFYS FOREST', state: 'NSW' },
  { postCode: '2084', suburb: 'TERREY HILLS', state: 'NSW' },
  { postCode: '2085', suburb: 'BELROSE', state: 'NSW' },
  { postCode: '2085', suburb: 'BELROSE WEST', state: 'NSW' },
  { postCode: '2085', suburb: 'DAVIDSON', state: 'NSW' },
  { postCode: '2086', suburb: 'FRENCHS FOREST', state: 'NSW' },
  { postCode: '2086', suburb: 'FRENCHS FOREST EAST', state: 'NSW' },
  { postCode: '2087', suburb: 'FORESTVILLE', state: 'NSW' },
  { postCode: '2087', suburb: 'KILLARNEY HEIGHTS', state: 'NSW' },
  { postCode: '2088', suburb: 'MOSMAN', state: 'NSW' },
  { postCode: '2088', suburb: 'SPIT JUNCTION', state: 'NSW' },
  { postCode: '2089', suburb: 'KURRABA POINT', state: 'NSW' },
  { postCode: '2089', suburb: 'NEUTRAL BAY', state: 'NSW' },
  { postCode: '2089', suburb: 'NEUTRAL BAY JUNCTION', state: 'NSW' },
  { postCode: '2090', suburb: 'CREMORNE', state: 'NSW' },
  { postCode: '2090', suburb: 'CREMORNE JUNCTION', state: 'NSW' },
  { postCode: '2090', suburb: 'CREMORNE POINT', state: 'NSW' },
  { postCode: '2092', suburb: 'SEAFORTH', state: 'NSW' },
  { postCode: '2093', suburb: 'BALGOWLAH', state: 'NSW' },
  { postCode: '2093', suburb: 'BALGOWLAH HEIGHTS', state: 'NSW' },
  { postCode: '2093', suburb: 'CLONTARF', state: 'NSW' },
  { postCode: '2093', suburb: 'MANLY VALE', state: 'NSW' },
  { postCode: '2093', suburb: 'NORTH BALGOWLAH', state: 'NSW' },
  { postCode: '2094', suburb: 'FAIRLIGHT', state: 'NSW' },
  { postCode: '2095', suburb: 'MANLY', state: 'NSW' },
  { postCode: '2095', suburb: 'MANLY EAST', state: 'NSW' },
  { postCode: '2096', suburb: 'CURL CURL', state: 'NSW' },
  { postCode: '2096', suburb: 'FRESHWATER', state: 'NSW' },
  { postCode: '2096', suburb: 'QUEENSCLIFF', state: 'NSW' },
  { postCode: '2097', suburb: 'COLLAROY', state: 'NSW' },
  { postCode: '2097', suburb: 'COLLAROY BEACH', state: 'NSW' },
  { postCode: '2097', suburb: 'COLLAROY PLATEAU', state: 'NSW' },
  { postCode: '2097', suburb: 'WHEELER HEIGHTS', state: 'NSW' },
  { postCode: '2099', suburb: 'CROMER', state: 'NSW' },
  { postCode: '2099', suburb: 'DEE WHY', state: 'NSW' },
  { postCode: '2099', suburb: 'NARRAWEENA', state: 'NSW' },
  { postCode: '2099', suburb: 'NORTH CURL CURL', state: 'NSW' },
  { postCode: '2100', suburb: 'ALLAMBIE HEIGHTS', state: 'NSW' },
  { postCode: '2100', suburb: 'BEACON HILL', state: 'NSW' },
  { postCode: '2100', suburb: 'BROOKVALE', state: 'NSW' },
  { postCode: '2100', suburb: 'NORTH MANLY', state: 'NSW' },
  { postCode: '2100', suburb: 'OXFORD FALLS', state: 'NSW' },
  { postCode: '2100', suburb: 'WARRINGAH MALL', state: 'NSW' },
  { postCode: '2101', suburb: 'ELANORA HEIGHTS', state: 'NSW' },
  { postCode: '2101', suburb: 'INGLESIDE', state: 'NSW' },
  { postCode: '2101', suburb: 'NARRABEEN', state: 'NSW' },
  { postCode: '2101', suburb: 'NORTH NARRABEEN', state: 'NSW' },
  { postCode: '2102', suburb: 'WARRIEWOOD', state: 'NSW' },
  { postCode: '2102', suburb: 'WARRIEWOOD DC', state: 'NSW' },
  { postCode: '2102', suburb: 'WARRIEWOOD SHOPPING SQUARE', state: 'NSW' },
  { postCode: '2103', suburb: 'MONA VALE', state: 'NSW' },
  { postCode: '2104', suburb: 'BAYVIEW', state: 'NSW' },
  { postCode: '2105', suburb: 'CHURCH POINT', state: 'NSW' },
  { postCode: '2105', suburb: 'ELVINA BAY', state: 'NSW' },
  { postCode: '2105', suburb: 'LOVETT BAY', state: 'NSW' },
  { postCode: '2105', suburb: 'MCCARRS CREEK', state: 'NSW' },
  { postCode: '2105', suburb: 'MORNING BAY', state: 'NSW' },
  { postCode: '2105', suburb: 'SCOTLAND ISLAND', state: 'NSW' },
  { postCode: '2106', suburb: 'NEWPORT', state: 'NSW' },
  { postCode: '2106', suburb: 'NEWPORT BEACH', state: 'NSW' },
  { postCode: '2107', suburb: 'AVALON BEACH', state: 'NSW' },
  { postCode: '2107', suburb: 'BILGOLA BEACH', state: 'NSW' },
  { postCode: '2107', suburb: 'BILGOLA PLATEAU', state: 'NSW' },
  { postCode: '2107', suburb: 'CLAREVILLE', state: 'NSW' },
  { postCode: '2107', suburb: 'WHALE BEACH', state: 'NSW' },
  { postCode: '2108', suburb: 'COASTERS RETREAT', state: 'NSW' },
  { postCode: '2108', suburb: 'CURRAWONG BEACH', state: 'NSW' },
  { postCode: '2108', suburb: 'GREAT MACKEREL BEACH', state: 'NSW' },
  { postCode: '2108', suburb: 'PALM BEACH', state: 'NSW' },
  { postCode: '2109', suburb: 'MACQUARIE UNIVERSITY', state: 'NSW' },
  { postCode: '2110', suburb: 'HUNTERS HILL', state: 'NSW' },
  { postCode: '2110', suburb: 'WOOLWICH', state: 'NSW' },
  { postCode: '2111', suburb: 'BORONIA PARK', state: 'NSW' },
  { postCode: '2111', suburb: 'GLADESVILLE', state: 'NSW' },
  { postCode: '2111', suburb: 'HENLEY', state: 'NSW' },
  { postCode: '2111', suburb: 'HUNTLEYS COVE', state: 'NSW' },
  { postCode: '2111', suburb: 'HUNTLEYS POINT', state: 'NSW' },
  { postCode: '2111', suburb: 'MONASH PARK', state: 'NSW' },
  { postCode: '2111', suburb: 'TENNYSON POINT', state: 'NSW' },
  { postCode: '2112', suburb: 'DENISTONE EAST', state: 'NSW' },
  { postCode: '2112', suburb: 'PUTNEY', state: 'NSW' },
  { postCode: '2112', suburb: 'RYDE', state: 'NSW' },
  { postCode: '2113', suburb: 'BLENHEIM ROAD', state: 'NSW' },
  { postCode: '2113', suburb: 'EAST RYDE', state: 'NSW' },
  { postCode: '2113', suburb: 'MACQUARIE CENTRE', state: 'NSW' },
  { postCode: '2113', suburb: 'MACQUARIE PARK', state: 'NSW' },
  { postCode: '2113', suburb: 'NORTH RYDE', state: 'NSW' },
  { postCode: '2114', suburb: 'DENISTONE', state: 'NSW' },
  { postCode: '2114', suburb: 'DENISTONE WEST', state: 'NSW' },
  { postCode: '2114', suburb: 'MEADOWBANK', state: 'NSW' },
  { postCode: '2114', suburb: 'MELROSE PARK', state: 'NSW' },
  { postCode: '2114', suburb: 'WEST RYDE', state: 'NSW' },
  { postCode: '2115', suburb: 'ERMINGTON', state: 'NSW' },
  { postCode: '2116', suburb: 'RYDALMERE', state: 'NSW' },
  { postCode: '2117', suburb: 'DUNDAS', state: 'NSW' },
  { postCode: '2117', suburb: 'DUNDAS VALLEY', state: 'NSW' },
  { postCode: '2117', suburb: 'OATLANDS', state: 'NSW' },
  { postCode: '2117', suburb: 'TELOPEA', state: 'NSW' },
  { postCode: '2118', suburb: 'CARLINGFORD', state: 'NSW' },
  { postCode: '2118', suburb: 'CARLINGFORD COURT', state: 'NSW' },
  { postCode: '2118', suburb: 'CARLINGFORD NORTH', state: 'NSW' },
  { postCode: '2118', suburb: 'KINGSDENE', state: 'NSW' },
  { postCode: '2119', suburb: 'BEECROFT', state: 'NSW' },
  { postCode: '2119', suburb: 'CHELTENHAM', state: 'NSW' },
  { postCode: '2120', suburb: 'PENNANT HILLS', state: 'NSW' },
  { postCode: '2120', suburb: 'THORNLEIGH', state: 'NSW' },
  { postCode: '2120', suburb: 'WESTLEIGH', state: 'NSW' },
  { postCode: '2121', suburb: 'EPPING', state: 'NSW' },
  { postCode: '2121', suburb: 'NORTH EPPING', state: 'NSW' },
  { postCode: '2122', suburb: 'EASTWOOD', state: 'NSW' },
  { postCode: '2122', suburb: 'MARSFIELD', state: 'NSW' },
  { postCode: '2123', suburb: 'PARRAMATTA', state: 'NSW' },
  { postCode: '2124', suburb: 'PARRAMATTA', state: 'NSW' },
  { postCode: '2125', suburb: 'WEST PENNANT HILLS', state: 'NSW' },
  { postCode: '2126', suburb: 'CHERRYBROOK', state: 'NSW' },
  { postCode: '2127', suburb: 'NEWINGTON', state: 'NSW' },
  { postCode: '2127', suburb: 'SYDNEY OLYMPIC PARK', state: 'NSW' },
  { postCode: '2127', suburb: 'WENTWORTH POINT', state: 'NSW' },
  { postCode: '2128', suburb: 'SILVERWATER', state: 'NSW' },
  { postCode: '2130', suburb: 'SUMMER HILL', state: 'NSW' },
  { postCode: '2131', suburb: 'ASHFIELD', state: 'NSW' },
  { postCode: '2132', suburb: 'CROYDON', state: 'NSW' },
  { postCode: '2133', suburb: 'CROYDON PARK', state: 'NSW' },
  { postCode: '2133', suburb: 'ENFIELD SOUTH', state: 'NSW' },
  { postCode: '2134', suburb: 'BURWOOD', state: 'NSW' },
  { postCode: '2134', suburb: 'BURWOOD NORTH', state: 'NSW' },
  { postCode: '2135', suburb: 'STRATHFIELD', state: 'NSW' },
  { postCode: '2136', suburb: 'BURWOOD HEIGHTS', state: 'NSW' },
  { postCode: '2136', suburb: 'ENFIELD', state: 'NSW' },
  { postCode: '2136', suburb: 'STRATHFIELD SOUTH', state: 'NSW' },
  { postCode: '2137', suburb: 'BREAKFAST POINT', state: 'NSW' },
  { postCode: '2137', suburb: 'CABARITA', state: 'NSW' },
  { postCode: '2137', suburb: 'CONCORD', state: 'NSW' },
  { postCode: '2137', suburb: 'MORTLAKE', state: 'NSW' },
  { postCode: '2137', suburb: 'NORTH STRATHFIELD', state: 'NSW' },
  { postCode: '2138', suburb: 'CONCORD WEST', state: 'NSW' },
  { postCode: '2138', suburb: 'CONCORD WEST DC', state: 'NSW' },
  { postCode: '2138', suburb: 'LIBERTY GROVE', state: 'NSW' },
  { postCode: '2138', suburb: 'RHODES', state: 'NSW' },
  {
    postCode: '2139',
    suburb: 'CONCORD REPATRIATION HOSPITAL',
    state: 'NSW',
  },
  { postCode: '2140', suburb: 'HOMEBUSH', state: 'NSW' },
  { postCode: '2140', suburb: 'HOMEBUSH SOUTH', state: 'NSW' },
  { postCode: '2140', suburb: 'HOMEBUSH WEST', state: 'NSW' },
  { postCode: '2141', suburb: 'BERALA', state: 'NSW' },
  { postCode: '2141', suburb: 'LIDCOMBE', state: 'NSW' },
  { postCode: '2141', suburb: 'LIDCOMBE NORTH', state: 'NSW' },
  { postCode: '2141', suburb: 'ROOKWOOD', state: 'NSW' },
  { postCode: '2142', suburb: 'BLAXCELL', state: 'NSW' },
  { postCode: '2142', suburb: 'CAMELLIA', state: 'NSW' },
  { postCode: '2142', suburb: 'CLYDE', state: 'NSW' },
  { postCode: '2142', suburb: 'GRANVILLE', state: 'NSW' },
  { postCode: '2142', suburb: 'HOLROYD', state: 'NSW' },
  { postCode: '2142', suburb: 'ROSEHILL', state: 'NSW' },
  { postCode: '2142', suburb: 'SOUTH GRANVILLE', state: 'NSW' },
  { postCode: '2143', suburb: 'BIRRONG', state: 'NSW' },
  { postCode: '2143', suburb: 'POTTS HILL', state: 'NSW' },
  { postCode: '2143', suburb: 'REGENTS PARK', state: 'NSW' },
  { postCode: '2143', suburb: 'REGENTS PARK DC', state: 'NSW' },
  { postCode: '2144', suburb: 'AUBURN', state: 'NSW' },
  { postCode: '2145', suburb: 'CONSTITUTION HILL', state: 'NSW' },
  { postCode: '2145', suburb: 'GIRRAWEEN', state: 'NSW' },
  { postCode: '2145', suburb: 'GREYSTANES', state: 'NSW' },
  { postCode: '2145', suburb: 'MAYS HILL', state: 'NSW' },
  { postCode: '2145', suburb: 'PEMULWUY', state: 'NSW' },
  { postCode: '2145', suburb: 'PENDLE HILL', state: 'NSW' },
  { postCode: '2145', suburb: 'SOUTH WENTWORTHVILLE', state: 'NSW' },
  { postCode: '2145', suburb: 'WENTWORTHVILLE', state: 'NSW' },
  { postCode: '2145', suburb: 'WESTMEAD', state: 'NSW' },
  { postCode: '2146', suburb: 'OLD TOONGABBIE', state: 'NSW' },
  { postCode: '2146', suburb: 'TOONGABBIE', state: 'NSW' },
  { postCode: '2146', suburb: 'TOONGABBIE EAST', state: 'NSW' },
  { postCode: '2147', suburb: 'KINGS LANGLEY', state: 'NSW' },
  { postCode: '2147', suburb: 'LALOR PARK', state: 'NSW' },
  { postCode: '2147', suburb: 'SEVEN HILLS', state: 'NSW' },
  { postCode: '2147', suburb: 'SEVEN HILLS WEST', state: 'NSW' },
  { postCode: '2148', suburb: 'ARNDELL PARK', state: 'NSW' },
  { postCode: '2148', suburb: 'BLACKTOWN', state: 'NSW' },
  { postCode: '2148', suburb: 'BLACKTOWN WESTPOINT', state: 'NSW' },
  { postCode: '2148', suburb: 'HUNTINGWOOD', state: 'NSW' },
  { postCode: '2148', suburb: 'KINGS PARK', state: 'NSW' },
  { postCode: '2148', suburb: 'MARAYONG', state: 'NSW' },
  { postCode: '2148', suburb: 'PROSPECT', state: 'NSW' },
  { postCode: '2150', suburb: 'HARRIS PARK', state: 'NSW' },
  { postCode: '2150', suburb: 'PARRAMATTA', state: 'NSW' },
  { postCode: '2150', suburb: 'PARRAMATTA WESTFIELD', state: 'NSW' },
  { postCode: '2151', suburb: 'NORTH PARRAMATTA', state: 'NSW' },
  { postCode: '2151', suburb: 'NORTH ROCKS', state: 'NSW' },
  { postCode: '2152', suburb: 'NORTHMEAD', state: 'NSW' },
  { postCode: '2153', suburb: 'BAULKHAM HILLS', state: 'NSW' },
  { postCode: '2153', suburb: 'BELLA VISTA', state: 'NSW' },
  { postCode: '2153', suburb: 'NORWEST', state: 'NSW' },
  { postCode: '2153', suburb: 'WINSTON HILLS', state: 'NSW' },
  { postCode: '2154', suburb: 'CASTLE HILL', state: 'NSW' },
  { postCode: '2155', suburb: 'BEAUMONT HILLS', state: 'NSW' },
  { postCode: '2155', suburb: 'KELLYVILLE', state: 'NSW' },
  { postCode: '2155', suburb: 'KELLYVILLE RIDGE', state: 'NSW' },
  { postCode: '2155', suburb: 'NORTH KELLYVILLE', state: 'NSW' },
  { postCode: '2155', suburb: 'ROUSE HILL', state: 'NSW' },
  { postCode: '2156', suburb: 'ANNANGROVE', state: 'NSW' },
  { postCode: '2156', suburb: 'GLENHAVEN', state: 'NSW' },
  { postCode: '2156', suburb: 'KENTHURST', state: 'NSW' },
  { postCode: '2157', suburb: 'CANOELANDS', state: 'NSW' },
  { postCode: '2157', suburb: 'FOREST GLEN', state: 'NSW' },
  { postCode: '2157', suburb: 'GLENORIE', state: 'NSW' },
  { postCode: '2158', suburb: 'DURAL', state: 'NSW' },
  { postCode: '2158', suburb: 'DURAL DC', state: 'NSW' },
  { postCode: '2158', suburb: 'MIDDLE DURAL', state: 'NSW' },
  { postCode: '2158', suburb: 'ROUND CORNER', state: 'NSW' },
  { postCode: '2159', suburb: 'ARCADIA', state: 'NSW' },
  { postCode: '2159', suburb: 'BERRILEE', state: 'NSW' },
  { postCode: '2159', suburb: 'FIDDLETOWN', state: 'NSW' },
  { postCode: '2159', suburb: 'GALSTON', state: 'NSW' },
  { postCode: '2160', suburb: 'MERRYLANDS', state: 'NSW' },
  { postCode: '2160', suburb: 'MERRYLANDS WEST', state: 'NSW' },
  { postCode: '2161', suburb: 'GUILDFORD', state: 'NSW' },
  { postCode: '2161', suburb: 'GUILDFORD WEST', state: 'NSW' },
  { postCode: '2161', suburb: 'OLD GUILDFORD', state: 'NSW' },
  { postCode: '2161', suburb: 'YENNORA', state: 'NSW' },
  { postCode: '2162', suburb: 'CHESTER HILL', state: 'NSW' },
  { postCode: '2162', suburb: 'SEFTON', state: 'NSW' },
  { postCode: '2163', suburb: 'CARRAMAR', state: 'NSW' },
  { postCode: '2163', suburb: 'LANSDOWNE', state: 'NSW' },
  { postCode: '2163', suburb: 'VILLAWOOD', state: 'NSW' },
  { postCode: '2164', suburb: 'SMITHFIELD', state: 'NSW' },
  { postCode: '2164', suburb: 'SMITHFIELD WEST', state: 'NSW' },
  { postCode: '2164', suburb: 'WETHERILL PARK', state: 'NSW' },
  { postCode: '2164', suburb: 'WETHERILL PARK BC', state: 'NSW' },
  { postCode: '2164', suburb: 'WOODPARK', state: 'NSW' },
  { postCode: '2165', suburb: 'FAIRFIELD', state: 'NSW' },
  { postCode: '2165', suburb: 'FAIRFIELD EAST', state: 'NSW' },
  { postCode: '2165', suburb: 'FAIRFIELD HEIGHTS', state: 'NSW' },
  { postCode: '2165', suburb: 'FAIRFIELD WEST', state: 'NSW' },
  { postCode: '2166', suburb: 'CABRAMATTA', state: 'NSW' },
  { postCode: '2166', suburb: 'CABRAMATTA WEST', state: 'NSW' },
  { postCode: '2166', suburb: 'CANLEY HEIGHTS', state: 'NSW' },
  { postCode: '2166', suburb: 'CANLEY VALE', state: 'NSW' },
  { postCode: '2166', suburb: 'LANSVALE', state: 'NSW' },
  { postCode: '2167', suburb: 'GLENFIELD', state: 'NSW' },
  { postCode: '2168', suburb: 'ASHCROFT', state: 'NSW' },
  { postCode: '2168', suburb: 'BUSBY', state: 'NSW' },
  { postCode: '2168', suburb: 'CARTWRIGHT', state: 'NSW' },
  { postCode: '2168', suburb: 'GREEN VALLEY', state: 'NSW' },
  { postCode: '2168', suburb: 'HECKENBERG', state: 'NSW' },
  { postCode: '2168', suburb: 'HINCHINBROOK', state: 'NSW' },
  { postCode: '2168', suburb: 'MILLER', state: 'NSW' },
  { postCode: '2168', suburb: 'SADLEIR', state: 'NSW' },
  { postCode: '2170', suburb: 'CASULA', state: 'NSW' },
  { postCode: '2170', suburb: 'CASULA MALL', state: 'NSW' },
  { postCode: '2170', suburb: 'CHIPPING NORTON', state: 'NSW' },
  { postCode: '2170', suburb: 'HAMMONDVILLE', state: 'NSW' },
  { postCode: '2170', suburb: 'LIVERPOOL', state: 'NSW' },
  { postCode: '2170', suburb: 'LIVERPOOL SOUTH', state: 'NSW' },
  { postCode: '2170', suburb: 'LIVERPOOL WESTFIELD', state: 'NSW' },
  { postCode: '2170', suburb: 'LURNEA', state: 'NSW' },
  { postCode: '2170', suburb: 'MOOREBANK', state: 'NSW' },
  { postCode: '2170', suburb: 'MOUNT PRITCHARD', state: 'NSW' },
  { postCode: '2170', suburb: 'PRESTONS', state: 'NSW' },
  { postCode: '2170', suburb: 'WARWICK FARM', state: 'NSW' },
  { postCode: '2171', suburb: 'CARNES HILL', state: 'NSW' },
  { postCode: '2171', suburb: 'CECIL HILLS', state: 'NSW' },
  { postCode: '2171', suburb: 'ELIZABETH HILLS', state: 'NSW' },
  { postCode: '2171', suburb: 'HORNINGSEA PARK', state: 'NSW' },
  { postCode: '2171', suburb: 'HOXTON PARK', state: 'NSW' },
  { postCode: '2171', suburb: 'LEN WATERS ESTATE', state: 'NSW' },
  { postCode: '2171', suburb: 'MIDDLETON GRANGE', state: 'NSW' },
  { postCode: '2171', suburb: 'WEST HOXTON', state: 'NSW' },
  { postCode: '2172', suburb: 'PLEASURE POINT', state: 'NSW' },
  { postCode: '2172', suburb: 'SANDY POINT', state: 'NSW' },
  { postCode: '2172', suburb: 'VOYAGER POINT', state: 'NSW' },
  { postCode: '2173', suburb: 'HOLSWORTHY', state: 'NSW' },
  { postCode: '2173', suburb: 'WATTLE GROVE', state: 'NSW' },
  { postCode: '2174', suburb: 'EDMONDSON PARK', state: 'NSW' },
  { postCode: '2175', suburb: 'HORSLEY PARK', state: 'NSW' },
  { postCode: '2176', suburb: 'ABBOTSBURY', state: 'NSW' },
  { postCode: '2176', suburb: 'BOSSLEY PARK', state: 'NSW' },
  { postCode: '2176', suburb: 'EDENSOR PARK', state: 'NSW' },
  { postCode: '2176', suburb: 'GREENFIELD PARK', state: 'NSW' },
  { postCode: '2176', suburb: 'PRAIRIEWOOD', state: 'NSW' },
  { postCode: '2176', suburb: 'ST JOHNS PARK', state: 'NSW' },
  { postCode: '2176', suburb: 'WAKELEY', state: 'NSW' },
  { postCode: '2177', suburb: 'BONNYRIGG', state: 'NSW' },
  { postCode: '2177', suburb: 'BONNYRIGG HEIGHTS', state: 'NSW' },
  { postCode: '2178', suburb: 'CECIL PARK', state: 'NSW' },
  { postCode: '2178', suburb: 'KEMPS CREEK', state: 'NSW' },
  { postCode: '2178', suburb: 'MOUNT VERNON', state: 'NSW' },
  { postCode: '2179', suburb: 'AUSTRAL', state: 'NSW' },
  { postCode: '2179', suburb: 'LEPPINGTON', state: 'NSW' },
  { postCode: '2190', suburb: 'CHULLORA', state: 'NSW' },
  { postCode: '2190', suburb: 'GREENACRE', state: 'NSW' },
  { postCode: '2190', suburb: 'MOUNT LEWIS', state: 'NSW' },
  { postCode: '2191', suburb: 'BELFIELD', state: 'NSW' },
  { postCode: '2192', suburb: 'BELMORE', state: 'NSW' },
  { postCode: '2193', suburb: 'ASHBURY', state: 'NSW' },
  { postCode: '2193', suburb: 'CANTERBURY', state: 'NSW' },
  { postCode: '2193', suburb: 'HURLSTONE PARK', state: 'NSW' },
  { postCode: '2194', suburb: 'CAMPSIE', state: 'NSW' },
  { postCode: '2195', suburb: 'LAKEMBA', state: 'NSW' },
  { postCode: '2195', suburb: 'LAKEMBA DC', state: 'NSW' },
  { postCode: '2195', suburb: 'WILEY PARK', state: 'NSW' },
  { postCode: '2196', suburb: 'PUNCHBOWL', state: 'NSW' },
  { postCode: '2196', suburb: 'ROSELANDS', state: 'NSW' },
  { postCode: '2197', suburb: 'BASS HILL', state: 'NSW' },
  { postCode: '2198', suburb: 'GEORGES HALL', state: 'NSW' },
  { postCode: '2199', suburb: 'YAGOONA', state: 'NSW' },
  { postCode: '2199', suburb: 'YAGOONA WEST', state: 'NSW' },
  { postCode: '2200', suburb: 'BANKSTOWN', state: 'NSW' },
  { postCode: '2200', suburb: 'BANKSTOWN AERODROME', state: 'NSW' },
  { postCode: '2200', suburb: 'BANKSTOWN NORTH', state: 'NSW' },
  { postCode: '2200', suburb: 'BANKSTOWN SQUARE', state: 'NSW' },
  { postCode: '2200', suburb: 'CONDELL PARK', state: 'NSW' },
  { postCode: '2200', suburb: 'MANAHAN', state: 'NSW' },
  { postCode: '2200', suburb: 'MOUNT LEWIS', state: 'NSW' },
  { postCode: '2203', suburb: 'DULWICH HILL', state: 'NSW' },
  { postCode: '2204', suburb: 'MARRICKVILLE', state: 'NSW' },
  { postCode: '2204', suburb: 'MARRICKVILLE METRO', state: 'NSW' },
  { postCode: '2204', suburb: 'MARRICKVILLE SOUTH', state: 'NSW' },
  { postCode: '2205', suburb: 'ARNCLIFFE', state: 'NSW' },
  { postCode: '2205', suburb: 'TURRELLA', state: 'NSW' },
  { postCode: '2205', suburb: 'WOLLI CREEK', state: 'NSW' },
  { postCode: '2206', suburb: 'CLEMTON PARK', state: 'NSW' },
  { postCode: '2206', suburb: 'EARLWOOD', state: 'NSW' },
  { postCode: '2207', suburb: 'BARDWELL PARK', state: 'NSW' },
  { postCode: '2207', suburb: 'BARDWELL VALLEY', state: 'NSW' },
  { postCode: '2207', suburb: 'BEXLEY', state: 'NSW' },
  { postCode: '2207', suburb: 'BEXLEY NORTH', state: 'NSW' },
  { postCode: '2207', suburb: 'BEXLEY SOUTH', state: 'NSW' },
  { postCode: '2208', suburb: 'KINGSGROVE', state: 'NSW' },
  { postCode: '2208', suburb: 'KINGSGROVE DC', state: 'NSW' },
  { postCode: '2208', suburb: 'KINGSWAY WEST', state: 'NSW' },
  { postCode: '2209', suburb: 'BEVERLY HILLS', state: 'NSW' },
  { postCode: '2209', suburb: 'NARWEE', state: 'NSW' },
  { postCode: '2210', suburb: 'LUGARNO', state: 'NSW' },
  { postCode: '2210', suburb: 'PEAKHURST', state: 'NSW' },
  { postCode: '2210', suburb: 'PEAKHURST DC', state: 'NSW' },
  { postCode: '2210', suburb: 'PEAKHURST HEIGHTS', state: 'NSW' },
  { postCode: '2210', suburb: 'RIVERWOOD', state: 'NSW' },
  { postCode: '2211', suburb: 'PADSTOW', state: 'NSW' },
  { postCode: '2211', suburb: 'PADSTOW HEIGHTS', state: 'NSW' },
  { postCode: '2212', suburb: 'REVESBY', state: 'NSW' },
  { postCode: '2212', suburb: 'REVESBY HEIGHTS', state: 'NSW' },
  { postCode: '2212', suburb: 'REVESBY NORTH', state: 'NSW' },
  { postCode: '2213', suburb: 'EAST HILLS', state: 'NSW' },
  { postCode: '2213', suburb: 'PANANIA', state: 'NSW' },
  { postCode: '2213', suburb: 'PICNIC POINT', state: 'NSW' },
  { postCode: '2214', suburb: 'MILPERRA', state: 'NSW' },
  { postCode: '2216', suburb: 'BANKSIA', state: 'NSW' },
  { postCode: '2216', suburb: 'BRIGHTON LE SANDS', state: 'NSW' },
  { postCode: '2216', suburb: 'KYEEMAGH', state: 'NSW' },
  { postCode: '2216', suburb: 'ROCKDALE', state: 'NSW' },
  { postCode: '2216', suburb: 'ROCKDALE DC', state: 'NSW' },
  { postCode: '2217', suburb: 'BEVERLEY PARK', state: 'NSW' },
  { postCode: '2217', suburb: 'KOGARAH', state: 'NSW' },
  { postCode: '2217', suburb: 'KOGARAH BAY', state: 'NSW' },
  { postCode: '2217', suburb: 'MONTEREY', state: 'NSW' },
  { postCode: '2217', suburb: 'RAMSGATE', state: 'NSW' },
  { postCode: '2217', suburb: 'RAMSGATE BEACH', state: 'NSW' },
  { postCode: '2218', suburb: 'ALLAWAH', state: 'NSW' },
  { postCode: '2218', suburb: 'CARLTON', state: 'NSW' },
  { postCode: '2219', suburb: 'DOLLS POINT', state: 'NSW' },
  { postCode: '2219', suburb: 'SANDRINGHAM', state: 'NSW' },
  { postCode: '2219', suburb: 'SANS SOUCI', state: 'NSW' },
  { postCode: '2220', suburb: 'HURSTVILLE', state: 'NSW' },
  { postCode: '2220', suburb: 'HURSTVILLE GROVE', state: 'NSW' },
  { postCode: '2220', suburb: 'HURSTVILLE WESTFIELD', state: 'NSW' },
  { postCode: '2221', suburb: 'BLAKEHURST', state: 'NSW' },
  { postCode: '2221', suburb: 'CARSS PARK', state: 'NSW' },
  { postCode: '2221', suburb: 'CONNELLS POINT', state: 'NSW' },
  { postCode: '2221', suburb: 'KYLE BAY', state: 'NSW' },
  { postCode: '2221', suburb: 'SOUTH HURSTVILLE', state: 'NSW' },
  { postCode: '2222', suburb: 'PENSHURST', state: 'NSW' },
  { postCode: '2223', suburb: 'MORTDALE', state: 'NSW' },
  { postCode: '2223', suburb: 'OATLEY', state: 'NSW' },
  { postCode: '2224', suburb: 'KANGAROO POINT', state: 'NSW' },
  { postCode: '2224', suburb: 'SYLVANIA', state: 'NSW' },
  { postCode: '2224', suburb: 'SYLVANIA SOUTHGATE', state: 'NSW' },
  { postCode: '2224', suburb: 'SYLVANIA WATERS', state: 'NSW' },
  { postCode: '2225', suburb: 'OYSTER BAY', state: 'NSW' },
  { postCode: '2226', suburb: 'BONNET BAY', state: 'NSW' },
  { postCode: '2226', suburb: 'COMO', state: 'NSW' },
  { postCode: '2226', suburb: 'JANNALI', state: 'NSW' },
  { postCode: '2227', suburb: 'GYMEA', state: 'NSW' },
  { postCode: '2227', suburb: 'GYMEA BAY', state: 'NSW' },
  { postCode: '2228', suburb: 'MIRANDA', state: 'NSW' },
  { postCode: '2228', suburb: 'YOWIE BAY', state: 'NSW' },
  { postCode: '2229', suburb: 'CARINGBAH', state: 'NSW' },
  { postCode: '2229', suburb: 'CARINGBAH SOUTH', state: 'NSW' },
  { postCode: '2229', suburb: 'DOLANS BAY', state: 'NSW' },
  { postCode: '2229', suburb: 'LILLI PILLI', state: 'NSW' },
  { postCode: '2229', suburb: 'PORT HACKING', state: 'NSW' },
  { postCode: '2229', suburb: 'TAREN POINT', state: 'NSW' },
  { postCode: '2230', suburb: 'BUNDEENA', state: 'NSW' },
  { postCode: '2230', suburb: 'BURRANEER', state: 'NSW' },
  { postCode: '2230', suburb: 'CRONULLA', state: 'NSW' },
  { postCode: '2230', suburb: 'GREENHILLS BEACH', state: 'NSW' },
  { postCode: '2230', suburb: 'MAIANBAR', state: 'NSW' },
  { postCode: '2230', suburb: 'WOOLOOWARE', state: 'NSW' },
  { postCode: '2231', suburb: 'KURNELL', state: 'NSW' },
  { postCode: '2232', suburb: 'GRAYS POINT', state: 'NSW' },
  { postCode: '2232', suburb: 'KAREELA', state: 'NSW' },
  { postCode: '2232', suburb: 'KIRRAWEE', state: 'NSW' },
  { postCode: '2232', suburb: 'KIRRAWEE DC', state: 'NSW' },
  { postCode: '2232', suburb: 'LOFTUS', state: 'NSW' },
  { postCode: '2232', suburb: 'ROYAL NATIONAL PARK', state: 'NSW' },
  { postCode: '2232', suburb: 'SUTHERLAND', state: 'NSW' },
  { postCode: '2232', suburb: 'WORONORA', state: 'NSW' },
  { postCode: '2233', suburb: 'ENGADINE', state: 'NSW' },
  { postCode: '2233', suburb: 'HEATHCOTE', state: 'NSW' },
  { postCode: '2233', suburb: 'WATERFALL', state: 'NSW' },
  { postCode: '2233', suburb: 'WORONORA HEIGHTS', state: 'NSW' },
  { postCode: '2233', suburb: 'YARRAWARRAH', state: 'NSW' },
  { postCode: '2234', suburb: 'ALFORDS POINT', state: 'NSW' },
  { postCode: '2234', suburb: 'BANGOR', state: 'NSW' },
  { postCode: '2234', suburb: 'BARDEN RIDGE', state: 'NSW' },
  { postCode: '2234', suburb: 'ILLAWONG', state: 'NSW' },
  { postCode: '2234', suburb: 'LUCAS HEIGHTS', state: 'NSW' },
  { postCode: '2234', suburb: 'MENAI', state: 'NSW' },
  { postCode: '2234', suburb: 'MENAI CENTRAL', state: 'NSW' },
  { postCode: '2250', suburb: 'BUCKETTY', state: 'NSW' },
  { postCode: '2250', suburb: 'CALGA', state: 'NSW' },
  { postCode: '2250', suburb: 'CENTRAL MANGROVE', state: 'NSW' },
  { postCode: '2250', suburb: 'EAST GOSFORD', state: 'NSW' },
  { postCode: '2250', suburb: 'ERINA', state: 'NSW' },
  { postCode: '2250', suburb: 'ERINA FAIR', state: 'NSW' },
  { postCode: '2250', suburb: 'GLENWORTH VALLEY', state: 'NSW' },
  { postCode: '2250', suburb: 'GOSFORD', state: 'NSW' },
  { postCode: '2250', suburb: 'GREENGROVE', state: 'NSW' },
  { postCode: '2250', suburb: 'HOLGATE', state: 'NSW' },
  { postCode: '2250', suburb: 'KARIONG', state: 'NSW' },
  { postCode: '2250', suburb: 'KULNURA', state: 'NSW' },
  { postCode: '2250', suburb: 'LISAROW', state: 'NSW' },
  { postCode: '2250', suburb: 'LOWER MANGROVE', state: 'NSW' },
  { postCode: '2250', suburb: 'MANGROVE CREEK', state: 'NSW' },
  { postCode: '2250', suburb: 'MANGROVE MOUNTAIN', state: 'NSW' },
  { postCode: '2250', suburb: 'MATCHAM', state: 'NSW' },
  { postCode: '2250', suburb: 'MOONEY MOONEY CREEK', state: 'NSW' },
  { postCode: '2250', suburb: 'MOUNT ELLIOT', state: 'NSW' },
  { postCode: '2250', suburb: 'MOUNT WHITE', state: 'NSW' },
  { postCode: '2250', suburb: 'NARARA', state: 'NSW' },
  { postCode: '2250', suburb: 'NIAGARA PARK', state: 'NSW' },
  { postCode: '2250', suburb: 'NORTH GOSFORD', state: 'NSW' },
  { postCode: '2250', suburb: 'PEATS RIDGE', state: 'NSW' },
  { postCode: '2250', suburb: 'POINT CLARE', state: 'NSW' },
  { postCode: '2250', suburb: 'POINT FREDERICK', state: 'NSW' },
  { postCode: '2250', suburb: 'SOMERSBY', state: 'NSW' },
  { postCode: '2250', suburb: 'SPRINGFIELD', state: 'NSW' },
  { postCode: '2250', suburb: 'TASCOTT', state: 'NSW' },
  { postCode: '2250', suburb: 'TEN MILE HOLLOW', state: 'NSW' },
  { postCode: '2250', suburb: 'UPPER MANGROVE', state: 'NSW' },
  { postCode: '2250', suburb: 'WENDOREE PARK', state: 'NSW' },
  { postCode: '2250', suburb: 'WEST GOSFORD', state: 'NSW' },
  { postCode: '2250', suburb: 'WYOMING', state: 'NSW' },
  { postCode: '2251', suburb: 'AVOCA BEACH', state: 'NSW' },
  { postCode: '2251', suburb: 'BENSVILLE', state: 'NSW' },
  { postCode: '2251', suburb: 'BOUDDI', state: 'NSW' },
  { postCode: '2251', suburb: 'COPACABANA', state: 'NSW' },
  { postCode: '2251', suburb: 'DAVISTOWN', state: 'NSW' },
  { postCode: '2251', suburb: 'GREEN POINT', state: 'NSW' },
  { postCode: '2251', suburb: 'KINCUMBER', state: 'NSW' },
  { postCode: '2251', suburb: 'KINCUMBER SOUTH', state: 'NSW' },
  { postCode: '2251', suburb: 'MACMASTERS BEACH', state: 'NSW' },
  { postCode: '2251', suburb: 'PICKETTS VALLEY', state: 'NSW' },
  { postCode: '2251', suburb: 'SARATOGA', state: 'NSW' },
  { postCode: '2251', suburb: 'YATTALUNGA', state: 'NSW' },
  { postCode: '2256', suburb: 'BLACKWALL', state: 'NSW' },
  { postCode: '2256', suburb: 'HORSFIELD BAY', state: 'NSW' },
  { postCode: '2256', suburb: 'KOOLEWONG', state: 'NSW' },
  { postCode: '2256', suburb: 'LITTLE WOBBY', state: 'NSW' },
  { postCode: '2256', suburb: 'PATONGA', state: 'NSW' },
  { postCode: '2256', suburb: 'PEARL BEACH', state: 'NSW' },
  { postCode: '2256', suburb: 'PHEGANS BAY', state: 'NSW' },
  { postCode: '2256', suburb: 'WONDABYNE', state: 'NSW' },
  { postCode: '2256', suburb: 'WOY WOY', state: 'NSW' },
  { postCode: '2256', suburb: 'WOY WOY BAY', state: 'NSW' },
  { postCode: '2257', suburb: 'BOOKER BAY', state: 'NSW' },
  { postCode: '2257', suburb: 'BOX HEAD', state: 'NSW' },
  { postCode: '2257', suburb: 'DALEYS POINT', state: 'NSW' },
  { postCode: '2257', suburb: 'EMPIRE BAY', state: 'NSW' },
  { postCode: '2257', suburb: 'ETTALONG BEACH', state: 'NSW' },
  { postCode: '2257', suburb: 'HARDYS BAY', state: 'NSW' },
  { postCode: '2257', suburb: 'KILLCARE', state: 'NSW' },
  { postCode: '2257', suburb: 'KILLCARE HEIGHTS', state: 'NSW' },
  { postCode: '2257', suburb: 'PRETTY BEACH', state: 'NSW' },
  { postCode: '2257', suburb: 'ST HUBERTS ISLAND', state: 'NSW' },
  { postCode: '2257', suburb: 'UMINA BEACH', state: 'NSW' },
  { postCode: '2257', suburb: 'WAGSTAFFE', state: 'NSW' },
  { postCode: '2258', suburb: 'FOUNTAINDALE', state: 'NSW' },
  { postCode: '2258', suburb: 'KANGY ANGY', state: 'NSW' },
  { postCode: '2258', suburb: 'OURIMBAH', state: 'NSW' },
  { postCode: '2258', suburb: 'PALM GROVE', state: 'NSW' },
  { postCode: '2258', suburb: 'PALMDALE', state: 'NSW' },
  { postCode: '2259', suburb: 'ALISON', state: 'NSW' },
  { postCode: '2259', suburb: 'BUSHELLS RIDGE', state: 'NSW' },
  { postCode: '2259', suburb: 'CEDAR BRUSH CREEK', state: 'NSW' },
  { postCode: '2259', suburb: 'CHAIN VALLEY BAY', state: 'NSW' },
  { postCode: '2259', suburb: 'CRANGAN BAY', state: 'NSW' },
  { postCode: '2259', suburb: 'DOORALONG', state: 'NSW' },
  { postCode: '2259', suburb: 'DURREN DURREN', state: 'NSW' },
  { postCode: '2259', suburb: 'FRAZER PARK', state: 'NSW' },
  { postCode: '2259', suburb: 'FREEMANS', state: 'NSW' },
  { postCode: '2259', suburb: 'GWANDALAN', state: 'NSW' },
  { postCode: '2259', suburb: 'HALLORAN', state: 'NSW' },
  { postCode: '2259', suburb: 'HAMLYN TERRACE', state: 'NSW' },
  { postCode: '2259', suburb: 'JILLIBY', state: 'NSW' },
  { postCode: '2259', suburb: 'KANWAL', state: 'NSW' },
  { postCode: '2259', suburb: 'KIAR', state: 'NSW' },
  { postCode: '2259', suburb: 'KINGFISHER SHORES', state: 'NSW' },
  { postCode: '2259', suburb: 'LAKE MACQUARIE', state: 'NSW' },
  { postCode: '2259', suburb: 'LAKE MUNMORAH', state: 'NSW' },
  { postCode: '2259', suburb: 'LEMON TREE', state: 'NSW' },
  { postCode: '2259', suburb: 'LITTLE JILLIBY', state: 'NSW' },
  { postCode: '2259', suburb: 'MANNERING PARK', state: 'NSW' },
  { postCode: '2259', suburb: 'MARDI', state: 'NSW' },
  { postCode: '2259', suburb: 'MOONEE', state: 'NSW' },
  { postCode: '2259', suburb: 'POINT WOLSTONCROFT', state: 'NSW' },
  { postCode: '2259', suburb: 'RAVENSDALE', state: 'NSW' },
  { postCode: '2259', suburb: 'ROCKY POINT', state: 'NSW' },
  { postCode: '2259', suburb: 'SUMMERLAND POINT', state: 'NSW' },
  { postCode: '2259', suburb: 'TACOMA', state: 'NSW' },
  { postCode: '2259', suburb: 'TACOMA SOUTH', state: 'NSW' },
  { postCode: '2259', suburb: 'TUGGERAH', state: 'NSW' },
  { postCode: '2259', suburb: 'TUGGERAWONG', state: 'NSW' },
  { postCode: '2259', suburb: 'WADALBA', state: 'NSW' },
  { postCode: '2259', suburb: 'WALLARAH', state: 'NSW' },
  { postCode: '2259', suburb: 'WARNERVALE', state: 'NSW' },
  { postCode: '2259', suburb: 'WATANOBBI', state: 'NSW' },
  { postCode: '2259', suburb: 'WOONGARRAH', state: 'NSW' },
  { postCode: '2259', suburb: 'WYBUNG', state: 'NSW' },
  { postCode: '2259', suburb: 'WYEE', state: 'NSW' },
  { postCode: '2259', suburb: 'WYEE POINT', state: 'NSW' },
  { postCode: '2259', suburb: 'WYONG', state: 'NSW' },
  { postCode: '2259', suburb: 'WYONG CREEK', state: 'NSW' },
  { postCode: '2259', suburb: 'WYONGAH', state: 'NSW' },
  { postCode: '2259', suburb: 'YARRAMALONG', state: 'NSW' },
  { postCode: '2260', suburb: 'ERINA HEIGHTS', state: 'NSW' },
  { postCode: '2260', suburb: 'FORRESTERS BEACH', state: 'NSW' },
  { postCode: '2260', suburb: 'NORTH AVOCA', state: 'NSW' },
  { postCode: '2260', suburb: 'TERRIGAL', state: 'NSW' },
  { postCode: '2260', suburb: 'WAMBERAL', state: 'NSW' },
  { postCode: '2261', suburb: 'BATEAU BAY', state: 'NSW' },
  { postCode: '2261', suburb: 'BAY VILLAGE', state: 'NSW' },
  { postCode: '2261', suburb: 'BERKELEY VALE', state: 'NSW' },
  { postCode: '2261', suburb: 'BLUE BAY', state: 'NSW' },
  { postCode: '2261', suburb: 'CHITTAWAY BAY', state: 'NSW' },
  { postCode: '2261', suburb: 'CHITTAWAY POINT', state: 'NSW' },
  { postCode: '2261', suburb: 'GLENNING VALLEY', state: 'NSW' },
  { postCode: '2261', suburb: 'KILLARNEY VALE', state: 'NSW' },
  { postCode: '2261', suburb: 'LONG JETTY', state: 'NSW' },
  { postCode: '2261', suburb: 'MAGENTA', state: 'NSW' },
  { postCode: '2261', suburb: 'SHELLY BEACH', state: 'NSW' },
  { postCode: '2261', suburb: 'THE ENTRANCE', state: 'NSW' },
  { postCode: '2261', suburb: 'THE ENTRANCE NORTH', state: 'NSW' },
  { postCode: '2261', suburb: 'TOOWOON BAY', state: 'NSW' },
  { postCode: '2261', suburb: 'TUMBI UMBI', state: 'NSW' },
  { postCode: '2262', suburb: 'BLUE HAVEN', state: 'NSW' },
  { postCode: '2262', suburb: 'BUDGEWOI', state: 'NSW' },
  { postCode: '2262', suburb: 'BUDGEWOI PENINSULA', state: 'NSW' },
  { postCode: '2262', suburb: 'BUFF POINT', state: 'NSW' },
  { postCode: '2262', suburb: 'COLONGRA', state: 'NSW' },
  { postCode: '2262', suburb: 'DOYALSON', state: 'NSW' },
  { postCode: '2262', suburb: 'DOYALSON NORTH', state: 'NSW' },
  { postCode: '2262', suburb: 'HALEKULANI', state: 'NSW' },
  { postCode: '2262', suburb: 'SAN REMO', state: 'NSW' },
  { postCode: '2263', suburb: 'CANTON BEACH', state: 'NSW' },
  { postCode: '2263', suburb: 'CHARMHAVEN', state: 'NSW' },
  { postCode: '2263', suburb: 'GOROKAN', state: 'NSW' },
  { postCode: '2263', suburb: 'LAKE HAVEN', state: 'NSW' },
  { postCode: '2263', suburb: 'NORAH HEAD', state: 'NSW' },
  { postCode: '2263', suburb: 'NORAVILLE', state: 'NSW' },
  { postCode: '2263', suburb: 'TOUKLEY', state: 'NSW' },
  { postCode: '2264', suburb: 'BALCOLYN', state: 'NSW' },
  { postCode: '2264', suburb: 'BONNELLS BAY', state: 'NSW' },
  { postCode: '2264', suburb: 'BRIGHTWATERS', state: 'NSW' },
  { postCode: '2264', suburb: 'DORA CREEK', state: 'NSW' },
  { postCode: '2264', suburb: 'ERARING', state: 'NSW' },
  { postCode: '2264', suburb: 'MANDALONG', state: 'NSW' },
  { postCode: '2264', suburb: 'MIRRABOOKA', state: 'NSW' },
  { postCode: '2264', suburb: 'MORISSET', state: 'NSW' },
  { postCode: '2264', suburb: 'MORISSET PARK', state: 'NSW' },
  { postCode: '2264', suburb: 'MYUNA BAY', state: 'NSW' },
  { postCode: '2264', suburb: 'SILVERWATER', state: 'NSW' },
  { postCode: '2264', suburb: 'SUNSHINE', state: 'NSW' },
  { postCode: '2264', suburb: 'WINDERMERE PARK', state: 'NSW' },
  { postCode: '2264', suburb: 'YARRAWONGA PARK', state: 'NSW' },
  { postCode: '2265', suburb: 'COORANBONG', state: 'NSW' },
  { postCode: '2265', suburb: 'MARTINSVILLE', state: 'NSW' },
  { postCode: '2267', suburb: 'WANGI WANGI', state: 'NSW' },
  { postCode: '2278', suburb: 'BARNSLEY', state: 'NSW' },
  { postCode: '2278', suburb: 'KILLINGWORTH', state: 'NSW' },
  { postCode: '2278', suburb: 'WAKEFIELD', state: 'NSW' },
  { postCode: '2280', suburb: 'BELMONT', state: 'NSW' },
  { postCode: '2280', suburb: 'BELMONT NORTH', state: 'NSW' },
  { postCode: '2280', suburb: 'BELMONT SOUTH', state: 'NSW' },
  { postCode: '2280', suburb: 'CROUDACE BAY', state: 'NSW' },
  { postCode: '2280', suburb: 'FLORAVILLE', state: 'NSW' },
  { postCode: '2280', suburb: 'JEWELLS', state: 'NSW' },
  { postCode: '2280', suburb: 'MARKS POINT', state: 'NSW' },
  { postCode: '2280', suburb: 'VALENTINE', state: 'NSW' },
  { postCode: '2281', suburb: 'BLACKSMITHS', state: 'NSW' },
  { postCode: '2281', suburb: 'CAMS WHARF', state: 'NSW' },
  { postCode: '2281', suburb: 'CATHERINE HILL BAY', state: 'NSW' },
  { postCode: '2281', suburb: 'CAVES BEACH', state: 'NSW' },
  { postCode: '2281', suburb: 'LITTLE PELICAN', state: 'NSW' },
  { postCode: '2281', suburb: 'MURRAYS BEACH', state: 'NSW' },
  { postCode: '2281', suburb: 'NORDS WHARF', state: 'NSW' },
  { postCode: '2281', suburb: 'PELICAN', state: 'NSW' },
  { postCode: '2281', suburb: 'PINNY BEACH', state: 'NSW' },
  { postCode: '2281', suburb: 'SWANSEA', state: 'NSW' },
  { postCode: '2281', suburb: 'SWANSEA HEADS', state: 'NSW' },
  { postCode: '2282', suburb: 'ELEEBANA', state: 'NSW' },
  { postCode: '2282', suburb: 'LAKELANDS', state: 'NSW' },
  { postCode: '2282', suburb: 'WARNERS BAY', state: 'NSW' },
  { postCode: '2283', suburb: 'ARCADIA VALE', state: 'NSW' },
  { postCode: '2283', suburb: 'AWABA', state: 'NSW' },
  { postCode: '2283', suburb: 'BALMORAL', state: 'NSW' },
  { postCode: '2283', suburb: 'BLACKALLS PARK', state: 'NSW' },
  { postCode: '2283', suburb: 'BOLTON POINT', state: 'NSW' },
  { postCode: '2283', suburb: 'BUTTABA', state: 'NSW' },
  { postCode: '2283', suburb: 'CAREY BAY', state: 'NSW' },
  { postCode: '2283', suburb: 'COAL POINT', state: 'NSW' },
  { postCode: '2283', suburb: 'FASSIFERN', state: 'NSW' },
  { postCode: '2283', suburb: 'FENNELL BAY', state: 'NSW' },
  { postCode: '2283', suburb: 'FISHING POINT', state: 'NSW' },
  { postCode: '2283', suburb: 'KILABEN BAY', state: 'NSW' },
  { postCode: '2283', suburb: 'RATHMINES', state: 'NSW' },
  { postCode: '2283', suburb: 'RYHOPE', state: 'NSW' },
  { postCode: '2283', suburb: 'TORONTO', state: 'NSW' },
  { postCode: '2284', suburb: 'ARGENTON', state: 'NSW' },
  { postCode: '2284', suburb: 'BOOLAROO', state: 'NSW' },
  { postCode: '2284', suburb: 'BOORAGUL', state: 'NSW' },
  { postCode: '2284', suburb: 'MARMONG POINT', state: 'NSW' },
  { postCode: '2284', suburb: 'SPEERS POINT', state: 'NSW' },
  { postCode: '2284', suburb: 'TERALBA', state: 'NSW' },
  { postCode: '2284', suburb: 'WOODRISING', state: 'NSW' },
  { postCode: '2285', suburb: 'CAMERON PARK', state: 'NSW' },
  { postCode: '2285', suburb: 'CARDIFF', state: 'NSW' },
  { postCode: '2285', suburb: 'CARDIFF HEIGHTS', state: 'NSW' },
  { postCode: '2285', suburb: 'CARDIFF SOUTH', state: 'NSW' },
  { postCode: '2285', suburb: 'EDGEWORTH', state: 'NSW' },
  { postCode: '2285', suburb: 'GLENDALE', state: 'NSW' },
  { postCode: '2285', suburb: 'MACQUARIE HILLS', state: 'NSW' },
  { postCode: '2286', suburb: 'HOLMESVILLE', state: 'NSW' },
  { postCode: '2286', suburb: 'SEAHAMPTON', state: 'NSW' },
  { postCode: '2286', suburb: 'WEST WALLSEND', state: 'NSW' },
  { postCode: '2287', suburb: 'BIRMINGHAM GARDENS', state: 'NSW' },
  { postCode: '2287', suburb: 'ELERMORE VALE', state: 'NSW' },
  { postCode: '2287', suburb: 'FLETCHER', state: 'NSW' },
  { postCode: '2287', suburb: 'MARYLAND', state: 'NSW' },
  { postCode: '2287', suburb: 'MINMI', state: 'NSW' },
  { postCode: '2287', suburb: 'RANKIN PARK', state: 'NSW' },
  { postCode: '2287', suburb: 'WALLSEND', state: 'NSW' },
  { postCode: '2287', suburb: 'WALLSEND DC', state: 'NSW' },
  { postCode: '2287', suburb: 'WALLSEND SOUTH', state: 'NSW' },
  { postCode: '2289', suburb: 'ADAMSTOWN', state: 'NSW' },
  { postCode: '2289', suburb: 'ADAMSTOWN HEIGHTS', state: 'NSW' },
  { postCode: '2289', suburb: 'GARDEN SUBURB', state: 'NSW' },
  { postCode: '2289', suburb: 'HIGHFIELDS', state: 'NSW' },
  { postCode: '2289', suburb: 'KOTARA', state: 'NSW' },
  { postCode: '2289', suburb: 'KOTARA FAIR', state: 'NSW' },
  { postCode: '2289', suburb: 'KOTARA SOUTH', state: 'NSW' },
  { postCode: '2290', suburb: 'BENNETTS GREEN', state: 'NSW' },
  { postCode: '2290', suburb: 'CHARLESTOWN', state: 'NSW' },
  { postCode: '2290', suburb: 'DUDLEY', state: 'NSW' },
  { postCode: '2290', suburb: 'GATESHEAD', state: 'NSW' },
  { postCode: '2290', suburb: 'HILLSBOROUGH', state: 'NSW' },
  { postCode: '2290', suburb: 'KAHIBAH', state: 'NSW' },
  { postCode: '2290', suburb: 'MOUNT HUTTON', state: 'NSW' },
  { postCode: '2290', suburb: 'REDHEAD', state: 'NSW' },
  { postCode: '2290', suburb: 'TINGIRA HEIGHTS', state: 'NSW' },
  { postCode: '2290', suburb: 'WHITEBRIDGE', state: 'NSW' },
  { postCode: '2291', suburb: 'MEREWETHER', state: 'NSW' },
  { postCode: '2291', suburb: 'MEREWETHER HEIGHTS', state: 'NSW' },
  { postCode: '2291', suburb: 'THE JUNCTION', state: 'NSW' },
  { postCode: '2292', suburb: 'BROADMEADOW', state: 'NSW' },
  { postCode: '2292', suburb: 'HAMILTON NORTH', state: 'NSW' },
  { postCode: '2293', suburb: 'MARYVILLE', state: 'NSW' },
  { postCode: '2293', suburb: 'WICKHAM', state: 'NSW' },
  { postCode: '2294', suburb: 'CARRINGTON', state: 'NSW' },
  { postCode: '2295', suburb: 'FERN BAY', state: 'NSW' },
  { postCode: '2295', suburb: 'STOCKTON', state: 'NSW' },
  { postCode: '2296', suburb: 'ISLINGTON', state: 'NSW' },
  { postCode: '2297', suburb: 'TIGHES HILL', state: 'NSW' },
  { postCode: '2298', suburb: 'GEORGETOWN', state: 'NSW' },
  { postCode: '2298', suburb: 'WARATAH', state: 'NSW' },
  { postCode: '2298', suburb: 'WARATAH WEST', state: 'NSW' },
  { postCode: '2299', suburb: 'JESMOND', state: 'NSW' },
  { postCode: '2299', suburb: 'LAMBTON', state: 'NSW' },
  { postCode: '2299', suburb: 'NORTH LAMBTON', state: 'NSW' },
  { postCode: '2300', suburb: 'BAR BEACH', state: 'NSW' },
  { postCode: '2300', suburb: 'COOKS HILL', state: 'NSW' },
  { postCode: '2300', suburb: 'NEWCASTLE', state: 'NSW' },
  { postCode: '2300', suburb: 'NEWCASTLE EAST', state: 'NSW' },
  { postCode: '2300', suburb: 'THE HILL', state: 'NSW' },
  { postCode: '2302', suburb: 'NEWCASTLE WEST', state: 'NSW' },
  { postCode: '2303', suburb: 'HAMILTON', state: 'NSW' },
  { postCode: '2303', suburb: 'HAMILTON DC', state: 'NSW' },
  { postCode: '2303', suburb: 'HAMILTON EAST', state: 'NSW' },
  { postCode: '2303', suburb: 'HAMILTON SOUTH', state: 'NSW' },
  { postCode: '2304', suburb: 'KOORAGANG', state: 'NSW' },
  { postCode: '2304', suburb: 'MAYFIELD', state: 'NSW' },
  { postCode: '2304', suburb: 'MAYFIELD EAST', state: 'NSW' },
  { postCode: '2304', suburb: 'MAYFIELD NORTH', state: 'NSW' },
  { postCode: '2304', suburb: 'MAYFIELD WEST', state: 'NSW' },
  { postCode: '2304', suburb: 'SANDGATE', state: 'NSW' },
  { postCode: '2304', suburb: 'WARABROOK', state: 'NSW' },
  { postCode: '2305', suburb: 'KOTARA EAST', state: 'NSW' },
  { postCode: '2305', suburb: 'NEW LAMBTON', state: 'NSW' },
  { postCode: '2305', suburb: 'NEW LAMBTON HEIGHTS', state: 'NSW' },
  { postCode: '2306', suburb: 'WINDALE', state: 'NSW' },
  { postCode: '2307', suburb: 'SHORTLAND', state: 'NSW' },
  { postCode: '2308', suburb: 'CALLAGHAN', state: 'NSW' },
  { postCode: '2308', suburb: 'NEWCASTLE UNIVERSITY', state: 'NSW' },
  { postCode: '2309', suburb: 'DANGAR', state: 'NSW' },
  { postCode: '2310', suburb: 'HUNTER REGION MC', state: 'NSW' },
  { postCode: '2311', suburb: 'ALLYNBROOK', state: 'NSW' },
  { postCode: '2311', suburb: 'BINGLEBURRA', state: 'NSW' },
  { postCode: '2311', suburb: 'CARRABOLLA', state: 'NSW' },
  { postCode: '2311', suburb: 'EAST GRESFORD', state: 'NSW' },
  { postCode: '2311', suburb: 'ECCLESTON', state: 'NSW' },
  { postCode: '2311', suburb: 'GRESFORD', state: 'NSW' },
  { postCode: '2311', suburb: 'HALTON', state: 'NSW' },
  { postCode: '2311', suburb: 'LEWINSBROOK', state: 'NSW' },
  { postCode: '2311', suburb: 'LOSTOCK', state: 'NSW' },
  { postCode: '2311', suburb: 'MOUNT RIVERS', state: 'NSW' },
  { postCode: '2311', suburb: 'UPPER ALLYN', state: 'NSW' },
  { postCode: '2312', suburb: 'MINIMBAH', state: 'NSW' },
  { postCode: '2312', suburb: 'NABIAC', state: 'NSW' },
  { postCode: '2314', suburb: 'WILLIAMTOWN RAAF', state: 'NSW' },
  { postCode: '2315', suburb: 'CORLETTE', state: 'NSW' },
  { postCode: '2315', suburb: 'FINGAL BAY', state: 'NSW' },
  { postCode: '2315', suburb: 'NELSON BAY', state: 'NSW' },
  { postCode: '2315', suburb: 'SHOAL BAY', state: 'NSW' },
  { postCode: '2316', suburb: 'ANNA BAY', state: 'NSW' },
  { postCode: '2316', suburb: 'BOAT HARBOUR', state: 'NSW' },
  { postCode: '2316', suburb: 'BOBS FARM', state: 'NSW' },
  { postCode: '2316', suburb: 'FISHERMANS BAY', state: 'NSW' },
  { postCode: '2316', suburb: 'ONE MILE', state: 'NSW' },
  { postCode: '2316', suburb: 'TAYLORS BEACH', state: 'NSW' },
  { postCode: '2317', suburb: 'SALAMANDER BAY', state: 'NSW' },
  { postCode: '2317', suburb: 'SOLDIERS POINT', state: 'NSW' },
  { postCode: '2318', suburb: 'CAMPVALE', state: 'NSW' },
  { postCode: '2318', suburb: 'FERODALE', state: 'NSW' },
  { postCode: '2318', suburb: 'FULLERTON COVE', state: 'NSW' },
  { postCode: '2318', suburb: 'MEDOWIE', state: 'NSW' },
  { postCode: '2318', suburb: 'OYSTER COVE', state: 'NSW' },
  { postCode: '2318', suburb: 'SALT ASH', state: 'NSW' },
  { postCode: '2318', suburb: 'WILLIAMTOWN', state: 'NSW' },
  { postCode: '2319', suburb: 'LEMON TREE PASSAGE', state: 'NSW' },
  { postCode: '2319', suburb: 'MALLABULA', state: 'NSW' },
  { postCode: '2319', suburb: 'TANILBA BAY', state: 'NSW' },
  { postCode: '2319', suburb: 'TILLIGERRY CREEK', state: 'NSW' },
  { postCode: '2320', suburb: 'ABERGLASSLYN', state: 'NSW' },
  { postCode: '2320', suburb: 'ALLANDALE', state: 'NSW' },
  { postCode: '2320', suburb: 'ANAMBAH', state: 'NSW' },
  { postCode: '2320', suburb: 'BOLWARRA', state: 'NSW' },
  { postCode: '2320', suburb: 'BOLWARRA HEIGHTS', state: 'NSW' },
  { postCode: '2320', suburb: 'FARLEY', state: 'NSW' },
  { postCode: '2320', suburb: 'GLEN OAK', state: 'NSW' },
  { postCode: '2320', suburb: 'GOSFORTH', state: 'NSW' },
  { postCode: '2320', suburb: 'HILLSBOROUGH', state: 'NSW' },
  { postCode: '2320', suburb: 'HORSESHOE BEND', state: 'NSW' },
  { postCode: '2320', suburb: 'KEINBAH', state: 'NSW' },
  { postCode: '2320', suburb: 'LARGS', state: 'NSW' },
  { postCode: '2320', suburb: 'LORN', state: 'NSW' },
  { postCode: '2320', suburb: 'LOUTH PARK', state: 'NSW' },
  { postCode: '2320', suburb: 'MAITLAND', state: 'NSW' },
  { postCode: '2320', suburb: 'MAITLAND NORTH', state: 'NSW' },
  { postCode: '2320', suburb: 'MAITLAND VALE', state: 'NSW' },
  { postCode: '2320', suburb: 'MELVILLE', state: 'NSW' },
  { postCode: '2320', suburb: 'MINDARIBBA', state: 'NSW' },
  { postCode: '2320', suburb: 'MOUNT DEE', state: 'NSW' },
  { postCode: '2320', suburb: 'OAKHAMPTON', state: 'NSW' },
  { postCode: '2320', suburb: 'OAKHAMPTON HEIGHTS', state: 'NSW' },
  { postCode: '2320', suburb: 'POKOLBIN', state: 'NSW' },
  { postCode: '2320', suburb: 'ROSEBROOK', state: 'NSW' },
  { postCode: '2320', suburb: 'ROTHBURY', state: 'NSW' },
  { postCode: '2320', suburb: 'RUTHERFORD', state: 'NSW' },
  { postCode: '2320', suburb: 'SOUTH MAITLAND', state: 'NSW' },
  { postCode: '2320', suburb: 'TELARAH', state: 'NSW' },
  { postCode: '2320', suburb: 'WALLALONG', state: 'NSW' },
  { postCode: '2320', suburb: 'WINDELLA', state: 'NSW' },
  { postCode: '2321', suburb: 'BERRY PARK', state: 'NSW' },
  { postCode: '2321', suburb: 'BUTTERWICK', state: 'NSW' },
  { postCode: '2321', suburb: 'CLARENCE TOWN', state: 'NSW' },
  { postCode: '2321', suburb: 'CLIFTLEIGH', state: 'NSW' },
  { postCode: '2321', suburb: 'DUCKENFIELD', state: 'NSW' },
  { postCode: '2321', suburb: 'DUNS CREEK', state: 'NSW' },
  { postCode: '2321', suburb: 'GILLIESTON HEIGHTS', state: 'NSW' },
  { postCode: '2321', suburb: 'GLEN MARTIN', state: 'NSW' },
  { postCode: '2321', suburb: 'GLEN WILLIAM', state: 'NSW' },
  { postCode: '2321', suburb: 'HARPERS HILL', state: 'NSW' },
  { postCode: '2321', suburb: 'HEDDON GRETA', state: 'NSW' },
  { postCode: '2321', suburb: 'HINTON', state: 'NSW' },
  { postCode: '2321', suburb: 'LOCHINVAR', state: 'NSW' },
  { postCode: '2321', suburb: 'LUSKINTYRE', state: 'NSW' },
  { postCode: '2321', suburb: 'MORPETH', state: 'NSW' },
  { postCode: '2321', suburb: 'OSWALD', state: 'NSW' },
  { postCode: '2321', suburb: 'PHOENIX PARK', state: 'NSW' },
  { postCode: '2321', suburb: 'RAWORTH', state: 'NSW' },
  { postCode: '2321', suburb: 'WINDERMERE', state: 'NSW' },
  { postCode: '2321', suburb: 'WOODVILLE', state: 'NSW' },
  { postCode: '2322', suburb: 'BERESFIELD', state: 'NSW' },
  { postCode: '2322', suburb: 'BLACK HILL', state: 'NSW' },
  { postCode: '2322', suburb: 'CHISHOLM', state: 'NSW' },
  { postCode: '2322', suburb: 'HEXHAM', state: 'NSW' },
  { postCode: '2322', suburb: 'LENAGHAN', state: 'NSW' },
  { postCode: '2322', suburb: 'STOCKRINGTON', state: 'NSW' },
  { postCode: '2322', suburb: 'TARRO', state: 'NSW' },
  { postCode: '2322', suburb: 'THORNTON', state: 'NSW' },
  { postCode: '2322', suburb: 'TOMAGO', state: 'NSW' },
  { postCode: '2322', suburb: 'WOODBERRY', state: 'NSW' },
  { postCode: '2323', suburb: 'ASHTONFIELD', state: 'NSW' },
  { postCode: '2323', suburb: 'BRUNKERVILLE', state: 'NSW' },
  { postCode: '2323', suburb: 'BUCHANAN', state: 'NSW' },
  { postCode: '2323', suburb: 'BUTTAI', state: 'NSW' },
  { postCode: '2323', suburb: 'EAST MAITLAND', state: 'NSW' },
  { postCode: '2323', suburb: 'FOUR MILE CREEK', state: 'NSW' },
  { postCode: '2323', suburb: 'FREEMANS WATERHOLE', state: 'NSW' },
  { postCode: '2323', suburb: 'GREEN HILLS', state: 'NSW' },
  { postCode: '2323', suburb: 'METFORD', state: 'NSW' },
  { postCode: '2323', suburb: 'METFORD DC', state: 'NSW' },
  { postCode: '2323', suburb: 'MOUNT VINCENT', state: 'NSW' },
  { postCode: '2323', suburb: 'MULBRING', state: 'NSW' },
  { postCode: '2323', suburb: 'PITNACREE', state: 'NSW' },
  { postCode: '2323', suburb: 'RICHMOND VALE', state: 'NSW' },
  { postCode: '2323', suburb: 'TENAMBIT', state: 'NSW' },
  { postCode: '2324', suburb: 'BALICKERA', state: 'NSW' },
  { postCode: '2324', suburb: 'BRANDY HILL', state: 'NSW' },
  { postCode: '2324', suburb: 'BUNDABAH', state: 'NSW' },
  { postCode: '2324', suburb: 'CARRINGTON', state: 'NSW' },
  { postCode: '2324', suburb: 'EAGLETON', state: 'NSW' },
  { postCode: '2324', suburb: 'EAST SEAHAM', state: 'NSW' },
  { postCode: '2324', suburb: 'HAWKS NEST', state: 'NSW' },
  { postCode: '2324', suburb: 'HEATHERBRAE', state: 'NSW' },
  { postCode: '2324', suburb: 'KARUAH', state: 'NSW' },
  { postCode: '2324', suburb: 'KINGS HILL', state: 'NSW' },
  { postCode: '2324', suburb: 'LIMEBURNERS CREEK', state: 'NSW' },
  { postCode: '2324', suburb: 'MILLERS FOREST', state: 'NSW' },
  { postCode: '2324', suburb: 'NELSONS PLAINS', state: 'NSW' },
  { postCode: '2324', suburb: 'NORTH ARM COVE', state: 'NSW' },
  { postCode: '2324', suburb: 'OSTERLEY', state: 'NSW' },
  { postCode: '2324', suburb: 'PINDIMAR', state: 'NSW' },
  { postCode: '2324', suburb: 'RAYMOND TERRACE', state: 'NSW' },
  { postCode: '2324', suburb: 'RAYMOND TERRACE EAST', state: 'NSW' },
  { postCode: '2324', suburb: 'SEAHAM', state: 'NSW' },
  { postCode: '2324', suburb: 'SWAN BAY', state: 'NSW' },
  { postCode: '2324', suburb: 'TAHLEE', state: 'NSW' },
  { postCode: '2324', suburb: 'TEA GARDENS', state: 'NSW' },
  { postCode: '2324', suburb: 'TWELVE MILE CREEK', state: 'NSW' },
  { postCode: '2325', suburb: 'ABERDARE', state: 'NSW' },
  { postCode: '2325', suburb: 'ABERNETHY', state: 'NSW' },
  { postCode: '2325', suburb: 'BELLBIRD', state: 'NSW' },
  { postCode: '2325', suburb: 'BELLBIRD HEIGHTS', state: 'NSW' },
  { postCode: '2325', suburb: 'CEDAR CREEK', state: 'NSW' },
  { postCode: '2325', suburb: 'CESSNOCK', state: 'NSW' },
  { postCode: '2325', suburb: 'CESSNOCK WEST', state: 'NSW' },
  { postCode: '2325', suburb: 'CONGEWAI', state: 'NSW' },
  { postCode: '2325', suburb: 'CORRABARE', state: 'NSW' },
  { postCode: '2325', suburb: 'DAIRY ARM', state: 'NSW' },
  { postCode: '2325', suburb: 'ELLALONG', state: 'NSW' },
  { postCode: '2325', suburb: 'ELRINGTON', state: 'NSW' },
  { postCode: '2325', suburb: 'FERNANCES CROSSING', state: 'NSW' },
  { postCode: '2325', suburb: 'GRETA MAIN', state: 'NSW' },
  { postCode: '2325', suburb: 'KEARSLEY', state: 'NSW' },
  { postCode: '2325', suburb: 'KITCHENER', state: 'NSW' },
  { postCode: '2325', suburb: 'LAGUNA', state: 'NSW' },
  { postCode: '2325', suburb: 'LOVEDALE', state: 'NSW' },
  { postCode: '2325', suburb: 'MILLFIELD', state: 'NSW' },
  { postCode: '2325', suburb: 'MILSONS ARM', state: 'NSW' },
  { postCode: '2325', suburb: 'MORUBEN', state: 'NSW' },
  { postCode: '2325', suburb: 'MOUNT VIEW', state: 'NSW' },
  { postCode: '2325', suburb: 'MURRAYS RUN', state: 'NSW' },
  { postCode: '2325', suburb: 'NARONE CREEK', state: 'NSW' },
  { postCode: '2325', suburb: 'NULKABA', state: 'NSW' },
  { postCode: '2325', suburb: 'OLNEY', state: 'NSW' },
  { postCode: '2325', suburb: 'PAXTON', state: 'NSW' },
  { postCode: '2325', suburb: 'PAYNES CROSSING', state: 'NSW' },
  { postCode: '2325', suburb: 'PELTON', state: 'NSW' },
  { postCode: '2325', suburb: 'QUORROBOLONG', state: 'NSW' },
  { postCode: '2325', suburb: 'SWEETMANS CREEK', state: 'NSW' },
  { postCode: '2325', suburb: 'WATAGAN', state: 'NSW' },
  { postCode: '2325', suburb: 'WOLLOMBI', state: 'NSW' },
  { postCode: '2325', suburb: 'YENGO NATIONAL PARK', state: 'NSW' },
  { postCode: '2326', suburb: 'ABERMAIN', state: 'NSW' },
  { postCode: '2326', suburb: 'BISHOPS BRIDGE', state: 'NSW' },
  { postCode: '2326', suburb: 'LOXFORD', state: 'NSW' },
  { postCode: '2326', suburb: 'NEATH', state: 'NSW' },
  { postCode: '2326', suburb: 'SAWYERS GULLY', state: 'NSW' },
  { postCode: '2326', suburb: 'WESTON', state: 'NSW' },
  { postCode: '2327', suburb: 'KURRI KURRI', state: 'NSW' },
  { postCode: '2327', suburb: 'PELAW MAIN', state: 'NSW' },
  { postCode: '2327', suburb: 'STANFORD MERTHYR', state: 'NSW' },
  { postCode: '2328', suburb: 'BUREEN', state: 'NSW' },
  { postCode: '2328', suburb: 'DALSWINTON', state: 'NSW' },
  { postCode: '2328', suburb: 'DENMAN', state: 'NSW' },
  { postCode: '2328', suburb: 'GIANTS CREEK', state: 'NSW' },
  { postCode: '2328', suburb: 'HOLLYDEEN', state: 'NSW' },
  { postCode: '2328', suburb: 'KERRABEE', state: 'NSW' },
  { postCode: '2328', suburb: 'MANGOOLA', state: 'NSW' },
  { postCode: '2328', suburb: 'MARTINDALE', state: 'NSW' },
  { postCode: '2328', suburb: 'WIDDEN', state: 'NSW' },
  { postCode: '2328', suburb: 'YARRAWA', state: 'NSW' },
  { postCode: '2329', suburb: 'CASSILIS', state: 'NSW' },
  { postCode: '2329', suburb: 'MERRIWA', state: 'NSW' },
  { postCode: '2329', suburb: 'UARBRY', state: 'NSW' },
  { postCode: '2330', suburb: 'APPLETREE FLAT', state: 'NSW' },
  { postCode: '2330', suburb: 'BIG RIDGE', state: 'NSW' },
  { postCode: '2330', suburb: 'BIG YENGO', state: 'NSW' },
  { postCode: '2330', suburb: 'BOWMANS CREEK', state: 'NSW' },
  { postCode: '2330', suburb: 'BRIDGMAN', state: 'NSW' },
  { postCode: '2330', suburb: 'BROKE', state: 'NSW' },
  { postCode: '2330', suburb: 'BULGA', state: 'NSW' },
  { postCode: '2330', suburb: 'CAMBERWELL', state: 'NSW' },
  { postCode: '2330', suburb: 'CARROWBROOK', state: 'NSW' },
  { postCode: '2330', suburb: 'CLYDESDALE', state: 'NSW' },
  { postCode: '2330', suburb: 'COMBO', state: 'NSW' },
  { postCode: '2330', suburb: 'DARLINGTON', state: 'NSW' },
  { postCode: '2330', suburb: 'DOYLES CREEK', state: 'NSW' },
  { postCode: '2330', suburb: 'DUNOLLY', state: 'NSW' },
  { postCode: '2330', suburb: 'DURAL', state: 'NSW' },
  { postCode: '2330', suburb: 'DYRRING', state: 'NSW' },
  { postCode: '2330', suburb: 'FALBROOK', state: 'NSW' },
  { postCode: '2330', suburb: 'FERN GULLY', state: 'NSW' },
  { postCode: '2330', suburb: 'FORDWICH', state: 'NSW' },
  { postCode: '2330', suburb: 'GARLAND VALLEY', state: 'NSW' },
  { postCode: '2330', suburb: 'GLENDON', state: 'NSW' },
  { postCode: '2330', suburb: 'GLENDON BROOK', state: 'NSW' },
  { postCode: '2330', suburb: 'GLENNIES CREEK', state: 'NSW' },
  { postCode: '2330', suburb: 'GLENRIDDING', state: 'NSW' },
  { postCode: '2330', suburb: 'GOORANGOOLA', state: 'NSW' },
  { postCode: '2330', suburb: 'GOULDSVILLE', state: 'NSW' },
  { postCode: '2330', suburb: 'GOWRIE', state: 'NSW' },
  { postCode: '2330', suburb: 'GREENLANDS', state: 'NSW' },
  { postCode: '2330', suburb: 'HAMBLEDON HILL', state: 'NSW' },
  { postCode: '2330', suburb: 'HEBDEN', state: 'NSW' },
  { postCode: '2330', suburb: 'HOWES VALLEY', state: 'NSW' },
  { postCode: '2330', suburb: 'HOWICK', state: 'NSW' },
  { postCode: '2330', suburb: 'HUNTERVIEW', state: 'NSW' },
  { postCode: '2330', suburb: 'JERRYS PLAINS', state: 'NSW' },
  { postCode: '2330', suburb: 'LEMINGTON', state: 'NSW' },
  { postCode: '2330', suburb: 'LONG POINT', state: 'NSW' },
  { postCode: '2330', suburb: 'MAISON DIEU', state: 'NSW' },
  { postCode: '2330', suburb: 'MCDOUGALLS HILL', state: 'NSW' },
  { postCode: '2330', suburb: 'MIDDLE FALBROOK', state: 'NSW' },
  { postCode: '2330', suburb: 'MILBRODALE', state: 'NSW' },
  { postCode: '2330', suburb: 'MIRANNIE', state: 'NSW' },
  { postCode: '2330', suburb: 'MITCHELLS FLAT', state: 'NSW' },
  { postCode: '2330', suburb: 'MOUNT OLIVE', state: 'NSW' },
  { postCode: '2330', suburb: 'MOUNT ROYAL', state: 'NSW' },
  { postCode: '2330', suburb: 'MOUNT THORLEY', state: 'NSW' },
  { postCode: '2330', suburb: 'OBANVALE', state: 'NSW' },
  { postCode: '2330', suburb: 'PUTTY', state: 'NSW' },
  { postCode: '2330', suburb: 'RAVENSWORTH', state: 'NSW' },
  { postCode: '2330', suburb: 'REDBOURNBERRY', state: 'NSW' },
  { postCode: '2330', suburb: 'REEDY CREEK', state: 'NSW' },
  { postCode: '2330', suburb: 'RIXS CREEK', state: 'NSW' },
  { postCode: '2330', suburb: 'ROUGHIT', state: 'NSW' },
  { postCode: '2330', suburb: 'SCOTTS FLAT', state: 'NSW' },
  { postCode: '2330', suburb: 'SEDGEFIELD', state: 'NSW' },
  { postCode: '2330', suburb: 'SINGLETON', state: 'NSW' },
  { postCode: '2330', suburb: 'SINGLETON DC', state: 'NSW' },
  { postCode: '2330', suburb: 'SINGLETON HEIGHTS', state: 'NSW' },
  { postCode: '2330', suburb: 'ST CLAIR', state: 'NSW' },
  { postCode: '2330', suburb: 'WARKWORTH', state: 'NSW' },
  { postCode: '2330', suburb: 'WATTLE PONDS', state: 'NSW' },
  { postCode: '2330', suburb: 'WESTBROOK', state: 'NSW' },
  { postCode: '2330', suburb: 'WHITTINGHAM', state: 'NSW' },
  { postCode: '2330', suburb: 'WOLLEMI', state: 'NSW' },
  { postCode: '2330', suburb: 'WYLIES FLAT', state: 'NSW' },
  { postCode: '2331', suburb: 'SINGLETON MILITARY AREA', state: 'NSW' },
  { postCode: '2331', suburb: 'SINGLETON MILPO', state: 'NSW' },
  { postCode: '2333', suburb: 'BAERAMI', state: 'NSW' },
  { postCode: '2333', suburb: 'BAERAMI CREEK', state: 'NSW' },
  { postCode: '2333', suburb: 'BENGALLA', state: 'NSW' },
  { postCode: '2333', suburb: 'CASTLE ROCK', state: 'NSW' },
  { postCode: '2333', suburb: 'EDDERTON', state: 'NSW' },
  { postCode: '2333', suburb: 'GUNGAL', state: 'NSW' },
  { postCode: '2333', suburb: 'KAYUGA', state: 'NSW' },
  { postCode: '2333', suburb: 'LIDDELL', state: 'NSW' },
  { postCode: '2333', suburb: 'MANOBALAI', state: 'NSW' },
  { postCode: '2333', suburb: 'MCCULLYS GAP', state: 'NSW' },
  { postCode: '2333', suburb: 'MUSCLE CREEK', state: 'NSW' },
  { postCode: '2333', suburb: 'MUSWELLBROOK', state: 'NSW' },
  { postCode: '2333', suburb: 'SANDY HOLLOW', state: 'NSW' },
  { postCode: '2333', suburb: 'WYBONG', state: 'NSW' },
  { postCode: '2334', suburb: 'GRETA', state: 'NSW' },
  { postCode: '2335', suburb: 'BELFORD', state: 'NSW' },
  { postCode: '2335', suburb: 'BRANXTON', state: 'NSW' },
  { postCode: '2335', suburb: 'DALWOOD', state: 'NSW' },
  { postCode: '2335', suburb: 'EAST BRANXTON', state: 'NSW' },
  { postCode: '2335', suburb: 'ELDERSLIE', state: 'NSW' },
  { postCode: '2335', suburb: 'LAMBS VALLEY', state: 'NSW' },
  { postCode: '2335', suburb: 'LECONFIELD', state: 'NSW' },
  { postCode: '2335', suburb: 'LOWER BELFORD', state: 'NSW' },
  { postCode: '2335', suburb: 'NORTH ROTHBURY', state: 'NSW' },
  { postCode: '2335', suburb: 'STANHOPE', state: 'NSW' },
  { postCode: '2336', suburb: 'ABERDEEN', state: 'NSW' },
  { postCode: '2336', suburb: 'DARTBROOK', state: 'NSW' },
  { postCode: '2336', suburb: 'DAVIS CREEK', state: 'NSW' },
  { postCode: '2336', suburb: 'ROSSGOLE', state: 'NSW' },
  { postCode: '2336', suburb: 'ROUCHEL', state: 'NSW' },
  { postCode: '2336', suburb: 'ROUCHEL BROOK', state: 'NSW' },
  { postCode: '2336', suburb: 'UPPER DARTBROOK', state: 'NSW' },
  { postCode: '2336', suburb: 'UPPER ROUCHEL', state: 'NSW' },
  { postCode: '2337', suburb: 'BELLTREES', state: 'NSW' },
  { postCode: '2337', suburb: 'BRAWBOY', state: 'NSW' },
  { postCode: '2337', suburb: 'BUNNAN', state: 'NSW' },
  { postCode: '2337', suburb: 'DRY CREEK', state: 'NSW' },
  { postCode: '2337', suburb: 'ELLERSTON', state: 'NSW' },
  { postCode: '2337', suburb: 'GLENBAWN', state: 'NSW' },
  { postCode: '2337', suburb: 'GLENROCK', state: 'NSW' },
  { postCode: '2337', suburb: 'GUNDY', state: 'NSW' },
  { postCode: '2337', suburb: 'KARS SPRINGS', state: 'NSW' },
  { postCode: '2337', suburb: 'MIDDLE BROOK', state: 'NSW' },
  { postCode: '2337', suburb: 'MOOBI', state: 'NSW' },
  { postCode: '2337', suburb: 'MOONAN BROOK', state: 'NSW' },
  { postCode: '2337', suburb: 'MOONAN FLAT', state: 'NSW' },
  { postCode: '2337', suburb: 'MURULLA', state: 'NSW' },
  { postCode: '2337', suburb: 'OMADALE', state: 'NSW' },
  { postCode: '2337', suburb: 'OWENS GAP', state: 'NSW' },
  { postCode: '2337', suburb: 'PAGES CREEK', state: 'NSW' },
  { postCode: '2337', suburb: 'PARKVILLE', state: 'NSW' },
  { postCode: '2337', suburb: 'SCONE', state: 'NSW' },
  { postCode: '2337', suburb: 'SEGENHOE', state: 'NSW' },
  { postCode: '2337', suburb: 'STEWARTS BROOK', state: 'NSW' },
  { postCode: '2337', suburb: 'TOMALLA', state: 'NSW' },
  { postCode: '2337', suburb: 'WAVERLY', state: 'NSW' },
  { postCode: '2337', suburb: 'WINGEN', state: 'NSW' },
  { postCode: '2337', suburb: 'WOOLOOMA', state: 'NSW' },
  { postCode: '2338', suburb: 'ARDGLEN', state: 'NSW' },
  { postCode: '2338', suburb: 'BLANDFORD', state: 'NSW' },
  { postCode: '2338', suburb: 'CRAWNEY', state: 'NSW' },
  { postCode: '2338', suburb: 'GREEN CREEK', state: 'NSW' },
  { postCode: '2338', suburb: 'MURRURUNDI', state: 'NSW' },
  { postCode: '2338', suburb: 'PAGES RIVER', state: 'NSW' },
  { postCode: '2338', suburb: 'SANDY CREEK', state: 'NSW' },
  { postCode: '2338', suburb: 'SCOTTS CREEK', state: 'NSW' },
  { postCode: '2338', suburb: 'TIMOR', state: 'NSW' },
  { postCode: '2339', suburb: 'BIG JACKS CREEK', state: 'NSW' },
  { postCode: '2339', suburb: 'BRAEFIELD', state: 'NSW' },
  { postCode: '2339', suburb: 'CATTLE CREEK', state: 'NSW' },
  { postCode: '2339', suburb: 'CHILCOTTS CREEK', state: 'NSW' },
  { postCode: '2339', suburb: 'LITTLE JACKS CREEK', state: 'NSW' },
  { postCode: '2339', suburb: 'MACDONALDS CREEK', state: 'NSW' },
  { postCode: '2339', suburb: 'PARRAWEENA', state: 'NSW' },
  { postCode: '2339', suburb: 'WARRAH', state: 'NSW' },
  { postCode: '2339', suburb: 'WARRAH CREEK', state: 'NSW' },
  { postCode: '2339', suburb: 'WILLOW TREE', state: 'NSW' },
  { postCode: '2340', suburb: 'APPLEBY', state: 'NSW' },
  { postCode: '2340', suburb: 'BARRY', state: 'NSW' },
  { postCode: '2340', suburb: 'BECTIVE', state: 'NSW' },
  { postCode: '2340', suburb: 'BITHRAMERE', state: 'NSW' },
  { postCode: '2340', suburb: 'BOWLING ALLEY POINT', state: 'NSW' },
  { postCode: '2340', suburb: 'CALALA', state: 'NSW' },
  { postCode: '2340', suburb: 'CARROLL', state: 'NSW' },
  { postCode: '2340', suburb: 'DARUKA', state: 'NSW' },
  { postCode: '2340', suburb: 'DUNCANS CREEK', state: 'NSW' },
  { postCode: '2340', suburb: 'DUNGOWAN', state: 'NSW' },
  { postCode: '2340', suburb: 'EAST TAMWORTH', state: 'NSW' },
  { postCode: '2340', suburb: 'GAROO', state: 'NSW' },
  { postCode: '2340', suburb: 'GIDLEY', state: 'NSW' },
  { postCode: '2340', suburb: 'GOONOO GOONOO', state: 'NSW' },
  { postCode: '2340', suburb: 'GOWRIE', state: 'NSW' },
  { postCode: '2340', suburb: 'HALLSVILLE', state: 'NSW' },
  { postCode: '2340', suburb: 'HANGING ROCK', state: 'NSW' },
  { postCode: '2340', suburb: 'HILLVUE', state: 'NSW' },
  { postCode: '2340', suburb: 'KEEPIT', state: 'NSW' },
  { postCode: '2340', suburb: 'KINGSWOOD', state: 'NSW' },
  { postCode: '2340', suburb: 'LOOMBERAH', state: 'NSW' },
  { postCode: '2340', suburb: 'MOORE CREEK', state: 'NSW' },
  { postCode: '2340', suburb: 'NEMINGHA', state: 'NSW' },
  { postCode: '2340', suburb: 'NORTH TAMWORTH', state: 'NSW' },
  { postCode: '2340', suburb: 'NUNDLE', state: 'NSW' },
  { postCode: '2340', suburb: 'OGUNBIL', state: 'NSW' },
  { postCode: '2340', suburb: 'OXLEY VALE', state: 'NSW' },
  { postCode: '2340', suburb: 'PIALLAMORE', state: 'NSW' },
  { postCode: '2340', suburb: 'SOMERTON', state: 'NSW' },
  { postCode: '2340', suburb: 'SOUTH TAMWORTH', state: 'NSW' },
  { postCode: '2340', suburb: 'TAMINDA', state: 'NSW' },
  { postCode: '2340', suburb: 'TAMWORTH', state: 'NSW' },
  { postCode: '2340', suburb: 'TIMBUMBURI', state: 'NSW' },
  { postCode: '2340', suburb: 'WALLAMORE', state: 'NSW' },
  { postCode: '2340', suburb: 'WARRAL', state: 'NSW' },
  { postCode: '2340', suburb: 'WEABONGA', state: 'NSW' },
  { postCode: '2340', suburb: 'WEST TAMWORTH', state: 'NSW' },
  { postCode: '2340', suburb: 'WESTDALE', state: 'NSW' },
  { postCode: '2340', suburb: 'WOOLOMIN', state: 'NSW' },
  { postCode: '2341', suburb: 'WERRIS CREEK', state: 'NSW' },
  { postCode: '2342', suburb: 'CURRABUBULA', state: 'NSW' },
  { postCode: '2342', suburb: 'PIALLAWAY', state: 'NSW' },
  { postCode: '2343', suburb: 'BLACKVILLE', state: 'NSW' },
  { postCode: '2343', suburb: 'BORAMBIL', state: 'NSW' },
  { postCode: '2343', suburb: 'BUNDELLA', state: 'NSW' },
  { postCode: '2343', suburb: 'CAROONA', state: 'NSW' },
  { postCode: '2343', suburb: 'COLLY BLUE', state: 'NSW' },
  { postCode: '2343', suburb: 'COOMOO COOMOO', state: 'NSW' },
  { postCode: '2343', suburb: 'PINE RIDGE', state: 'NSW' },
  { postCode: '2343', suburb: 'QUIPOLLY', state: 'NSW' },
  { postCode: '2343', suburb: 'QUIRINDI', state: 'NSW' },
  { postCode: '2343', suburb: 'SPRING RIDGE', state: 'NSW' },
  { postCode: '2343', suburb: 'WALHALLOW', state: 'NSW' },
  { postCode: '2343', suburb: 'WALLABADAH', state: 'NSW' },
  { postCode: '2343', suburb: 'WARRAH RIDGE', state: 'NSW' },
  { postCode: '2343', suburb: 'WINDY', state: 'NSW' },
  { postCode: '2343', suburb: 'YANNERGEE', state: 'NSW' },
  { postCode: '2343', suburb: 'YARRAMAN', state: 'NSW' },
  { postCode: '2344', suburb: 'DURI', state: 'NSW' },
  { postCode: '2344', suburb: 'WINTON', state: 'NSW' },
  { postCode: '2345', suburb: 'ATTUNGA', state: 'NSW' },
  { postCode: '2345', suburb: 'GARTHOWEN', state: 'NSW' },
  { postCode: '2346', suburb: 'BORAH CREEK', state: 'NSW' },
  { postCode: '2346', suburb: 'HALLS CREEK', state: 'NSW' },
  { postCode: '2346', suburb: 'KLORI', state: 'NSW' },
  { postCode: '2346', suburb: 'MANILLA', state: 'NSW' },
  { postCode: '2346', suburb: 'NAMOI RIVER', state: 'NSW' },
  { postCode: '2346', suburb: 'NEW MEXICO', state: 'NSW' },
  { postCode: '2346', suburb: 'RUSHES CREEK', state: 'NSW' },
  { postCode: '2346', suburb: 'UPPER MANILLA', state: 'NSW' },
  { postCode: '2346', suburb: 'WARRABAH', state: 'NSW' },
  { postCode: '2346', suburb: 'WIMBORNE', state: 'NSW' },
  { postCode: '2346', suburb: 'WONGO CREEK', state: 'NSW' },
  { postCode: '2347', suburb: 'BANOON', state: 'NSW' },
  { postCode: '2347', suburb: 'BARRABA', state: 'NSW' },
  { postCode: '2347', suburb: 'COBBADAH', state: 'NSW' },
  { postCode: '2347', suburb: 'GULF CREEK', state: 'NSW' },
  { postCode: '2347', suburb: 'GUNDAMULDA', state: 'NSW' },
  { postCode: '2347', suburb: 'IRONBARK', state: 'NSW' },
  { postCode: '2347', suburb: 'LINDESAY', state: 'NSW' },
  { postCode: '2347', suburb: 'LONGARM', state: 'NSW' },
  { postCode: '2347', suburb: 'MAYVALE', state: 'NSW' },
  { postCode: '2347', suburb: 'RED HILL', state: 'NSW' },
  { postCode: '2347', suburb: 'THIRLDENE', state: 'NSW' },
  { postCode: '2347', suburb: 'UPPER HORTON', state: 'NSW' },
  { postCode: '2347', suburb: 'WOODSREEF', state: 'NSW' },
  { postCode: '2348', suburb: 'NEW ENGLAND MC', state: 'NSW' },
  { postCode: '2350', suburb: 'ABERFOYLE', state: 'NSW' },
  { postCode: '2350', suburb: 'ABINGTON', state: 'NSW' },
  { postCode: '2350', suburb: 'ARGYLE', state: 'NSW' },
  { postCode: '2350', suburb: 'ARMIDALE', state: 'NSW' },
  { postCode: '2350', suburb: 'ARMIDALE DC', state: 'NSW' },
  { postCode: '2350', suburb: 'ARMIDALE EAST', state: 'NSW' },
  { postCode: '2350', suburb: 'BOOROLONG', state: 'NSW' },
  { postCode: '2350', suburb: 'CASTLE DOYLE', state: 'NSW' },
  { postCode: '2350', suburb: 'DANGARSLEIGH', state: 'NSW' },
  { postCode: '2350', suburb: 'DONALD CREEK', state: 'NSW' },
  { postCode: '2350', suburb: 'DUMARESQ', state: 'NSW' },
  { postCode: '2350', suburb: 'DUVAL', state: 'NSW' },
  { postCode: '2350', suburb: 'ENMORE', state: 'NSW' },
  { postCode: '2350', suburb: 'HILLGROVE', state: 'NSW' },
  { postCode: '2350', suburb: 'INVERGOWRIE', state: 'NSW' },
  { postCode: '2350', suburb: 'JEOGLA', state: 'NSW' },
  { postCode: '2350', suburb: 'KELLYS PLAINS', state: 'NSW' },
  { postCode: '2350', suburb: 'LYNDHURST', state: 'NSW' },
  { postCode: '2350', suburb: 'METZ', state: 'NSW' },
  { postCode: '2350', suburb: 'PUDDLEDOCK', state: 'NSW' },
  { postCode: '2350', suburb: 'SAUMAREZ', state: 'NSW' },
  { postCode: '2350', suburb: 'SAUMAREZ PONDS', state: 'NSW' },
  { postCode: '2350', suburb: 'THALGARRAH', state: 'NSW' },
  { postCode: '2350', suburb: 'TILBUSTER', state: 'NSW' },
  { postCode: '2350', suburb: 'WARDS MISTAKE', state: 'NSW' },
  { postCode: '2350', suburb: 'WEST ARMIDALE', state: 'NSW' },
  { postCode: '2350', suburb: 'WOLLOMOMBI', state: 'NSW' },
  { postCode: '2350', suburb: 'WONGWIBINDA', state: 'NSW' },
  { postCode: '2351', suburb: 'UNIVERSITY OF NEW ENGLAND', state: 'NSW' },
  { postCode: '2352', suburb: 'KOOTINGAL', state: 'NSW' },
  { postCode: '2352', suburb: 'LIMBRI', state: 'NSW' },
  { postCode: '2352', suburb: 'MULLA CREEK', state: 'NSW' },
  { postCode: '2352', suburb: 'TINTINHULL', state: 'NSW' },
  { postCode: '2353', suburb: 'MOONBI', state: 'NSW' },
  { postCode: '2354', suburb: 'KENTUCKY', state: 'NSW' },
  { postCode: '2354', suburb: 'KENTUCKY SOUTH', state: 'NSW' },
  { postCode: '2354', suburb: 'NIANGALA', state: 'NSW' },
  { postCode: '2354', suburb: 'NOWENDOC', state: 'NSW' },
  { postCode: '2354', suburb: 'WALCHA', state: 'NSW' },
  { postCode: '2354', suburb: 'WALCHA ROAD', state: 'NSW' },
  { postCode: '2354', suburb: 'WOLLUN', state: 'NSW' },
  { postCode: '2354', suburb: 'WOOLBROOK', state: 'NSW' },
  { postCode: '2354', suburb: 'YARROWITCH', state: 'NSW' },
  { postCode: '2355', suburb: 'BENDEMEER', state: 'NSW' },
  { postCode: '2355', suburb: 'RETREAT', state: 'NSW' },
  { postCode: '2355', suburb: 'WATSONS CREEK', state: 'NSW' },
  { postCode: '2356', suburb: 'GWABEGAR', state: 'NSW' },
  { postCode: '2357', suburb: 'BOMERA', state: 'NSW' },
  { postCode: '2357', suburb: 'BOX RIDGE', state: 'NSW' },
  { postCode: '2357', suburb: 'BUGALDIE', state: 'NSW' },
  { postCode: '2357', suburb: 'COONABARABRAN', state: 'NSW' },
  { postCode: '2357', suburb: 'DANDRY', state: 'NSW' },
  { postCode: '2357', suburb: 'GOWANG', state: 'NSW' },
  { postCode: '2357', suburb: 'PURLEWAUGH', state: 'NSW' },
  { postCode: '2357', suburb: 'ROCKY GLEN', state: 'NSW' },
  { postCode: '2357', suburb: 'TANNABAR', state: 'NSW' },
  { postCode: '2357', suburb: 'ULAMAMBRI', state: 'NSW' },
  { postCode: '2357', suburb: 'WATTLE SPRINGS', state: 'NSW' },
  { postCode: '2358', suburb: 'ARDING', state: 'NSW' },
  { postCode: '2358', suburb: 'BALALA', state: 'NSW' },
  { postCode: '2358', suburb: 'GOSTWYCK', state: 'NSW' },
  { postCode: '2358', suburb: 'KINGSTOWN', state: 'NSW' },
  { postCode: '2358', suburb: 'MIHI', state: 'NSW' },
  { postCode: '2358', suburb: 'ROCKY RIVER', state: 'NSW' },
  { postCode: '2358', suburb: 'SALISBURY PLAINS', state: 'NSW' },
  { postCode: '2358', suburb: 'TORRYBURN', state: 'NSW' },
  { postCode: '2358', suburb: 'URALLA', state: 'NSW' },
  { postCode: '2358', suburb: 'YARROWYCK', state: 'NSW' },
  { postCode: '2359', suburb: 'BAKERS CREEK', state: 'NSW' },
  { postCode: '2359', suburb: 'BUNDARRA', state: 'NSW' },
  { postCode: '2359', suburb: 'CAMERONS CREEK', state: 'NSW' },
  { postCode: '2360', suburb: 'AUBURN VALE', state: 'NSW' },
  { postCode: '2360', suburb: 'BRODIES PLAINS', state: 'NSW' },
  { postCode: '2360', suburb: 'BUKKULLA', state: 'NSW' },
  { postCode: '2360', suburb: 'CHERRY TREE HILL', state: 'NSW' },
  { postCode: '2360', suburb: 'COPETON', state: 'NSW' },
  { postCode: '2360', suburb: 'ELSMORE', state: 'NSW' },
  { postCode: '2360', suburb: 'GILGAI', state: 'NSW' },
  { postCode: '2360', suburb: 'GRAMAN', state: 'NSW' },
  { postCode: '2360', suburb: 'GUM FLAT', state: 'NSW' },
  { postCode: '2360', suburb: 'HOWELL', state: 'NSW' },
  { postCode: '2360', suburb: 'INVERELL', state: 'NSW' },
  { postCode: '2360', suburb: 'KINGS PLAINS', state: 'NSW' },
  { postCode: '2360', suburb: 'LITTLE PLAIN', state: 'NSW' },
  { postCode: '2360', suburb: 'LONG PLAIN', state: 'NSW' },
  { postCode: '2360', suburb: 'MOUNT RUSSELL', state: 'NSW' },
  { postCode: '2360', suburb: 'NEWSTEAD', state: 'NSW' },
  { postCode: '2360', suburb: 'NULLAMANNA', state: 'NSW' },
  { postCode: '2360', suburb: 'OAKWOOD', state: 'NSW' },
  { postCode: '2360', suburb: 'PARADISE', state: 'NSW' },
  { postCode: '2360', suburb: 'ROB ROY', state: 'NSW' },
  { postCode: '2360', suburb: 'SAPPHIRE', state: 'NSW' },
  { postCode: '2360', suburb: 'SPRING MOUNTAIN', state: 'NSW' },
  { postCode: '2360', suburb: 'STANBOROUGH', state: 'NSW' },
  { postCode: '2360', suburb: 'SWANBROOK', state: 'NSW' },
  { postCode: '2360', suburb: 'WALLANGRA', state: 'NSW' },
  { postCode: '2360', suburb: 'WANDERA', state: 'NSW' },
  { postCode: '2360', suburb: 'WOODSTOCK', state: 'NSW' },
  { postCode: '2361', suburb: 'ASHFORD', state: 'NSW' },
  { postCode: '2361', suburb: 'ATHOLWOOD', state: 'NSW' },
  { postCode: '2361', suburb: 'BONSHAW', state: 'NSW' },
  { postCode: '2361', suburb: 'LIMESTONE', state: 'NSW' },
  { postCode: '2361', suburb: 'PINDAROI', state: 'NSW' },
  { postCode: '2365', suburb: 'BACKWATER', state: 'NSW' },
  { postCode: '2365', suburb: 'BALD BLAIR', state: 'NSW' },
  { postCode: '2365', suburb: 'BALDERSLEIGH', state: 'NSW' },
  { postCode: '2365', suburb: 'BASSENDEAN', state: 'NSW' },
  { postCode: '2365', suburb: 'BEN LOMOND', state: 'NSW' },
  { postCode: '2365', suburb: 'BLACK MOUNTAIN', state: 'NSW' },
  { postCode: '2365', suburb: 'BRIARBROOK', state: 'NSW' },
  { postCode: '2365', suburb: 'BROCKLEY', state: 'NSW' },
  { postCode: '2365', suburb: 'BRUSHY CREEK', state: 'NSW' },
  { postCode: '2365', suburb: 'FALCONER', state: 'NSW' },
  { postCode: '2365', suburb: 'GEORGES CREEK', state: 'NSW' },
  { postCode: '2365', suburb: 'GLEN NEVIS', state: 'NSW' },
  { postCode: '2365', suburb: 'GLENCOE', state: 'NSW' },
  { postCode: '2365', suburb: 'GREEN HILLS', state: 'NSW' },
  { postCode: '2365', suburb: 'GUYRA', state: 'NSW' },
  { postCode: '2365', suburb: 'LLANGOTHLIN', state: 'NSW' },
  { postCode: '2365', suburb: 'MAYBOLE', state: 'NSW' },
  { postCode: '2365', suburb: 'MOUNT MITCHELL', state: 'NSW' },
  { postCode: '2365', suburb: 'NEW VALLEY', state: 'NSW' },
  { postCode: '2365', suburb: 'OBAN', state: 'NSW' },
  { postCode: '2365', suburb: 'SOUTH GUYRA', state: 'NSW' },
  { postCode: '2365', suburb: 'TENTERDEN', state: 'NSW' },
  { postCode: '2365', suburb: 'THE BASIN', state: 'NSW' },
  { postCode: '2365', suburb: 'THE GULF', state: 'NSW' },
  { postCode: '2365', suburb: 'TUBBAMURRA', state: 'NSW' },
  { postCode: '2365', suburb: 'WANDSWORTH', state: 'NSW' },
  { postCode: '2369', suburb: 'OLD MILL', state: 'NSW' },
  { postCode: '2369', suburb: 'STANNIFER', state: 'NSW' },
  { postCode: '2369', suburb: 'TINGHA', state: 'NSW' },
  { postCode: '2370', suburb: 'BALD NOB', state: 'NSW' },
  { postCode: '2370', suburb: 'DIEHARD', state: 'NSW' },
  { postCode: '2370', suburb: 'DUNDEE', state: 'NSW' },
  { postCode: '2370', suburb: 'FURRACABAD', state: 'NSW' },
  { postCode: '2370', suburb: 'GIBRALTAR RANGE', state: 'NSW' },
  { postCode: '2370', suburb: 'GLEN ELGIN', state: 'NSW' },
  { postCode: '2370', suburb: 'GLEN INNES', state: 'NSW' },
  { postCode: '2370', suburb: 'KINGSGATE', state: 'NSW' },
  { postCode: '2370', suburb: 'KINGSLAND', state: 'NSW' },
  { postCode: '2370', suburb: 'KOOKABOOKRA', state: 'NSW' },
  { postCode: '2370', suburb: 'LAMBS VALLEY', state: 'NSW' },
  { postCode: '2370', suburb: 'MATHESON', state: 'NSW' },
  { postCode: '2370', suburb: 'MOGGS SWAMP', state: 'NSW' },
  { postCode: '2370', suburb: 'MOOGEM', state: 'NSW' },
  { postCode: '2370', suburb: 'MORVEN', state: 'NSW' },
  { postCode: '2370', suburb: 'NEWTON BOYD', state: 'NSW' },
  { postCode: '2370', suburb: 'PINKETT', state: 'NSW' },
  { postCode: '2370', suburb: 'RANGERS VALLEY', state: 'NSW' },
  { postCode: '2370', suburb: 'RED RANGE', state: 'NSW' },
  { postCode: '2370', suburb: 'REDDESTONE', state: 'NSW' },
  { postCode: '2370', suburb: 'SHANNON VALE', state: 'NSW' },
  { postCode: '2370', suburb: 'STONEHENGE', state: 'NSW' },
  { postCode: '2370', suburb: 'SWAN VALE', state: 'NSW' },
  { postCode: '2370', suburb: 'WELLINGROVE', state: 'NSW' },
  { postCode: '2370', suburb: 'YARROWFORD', state: 'NSW' },
  { postCode: '2371', suburb: 'CAPOOMPETA', state: 'NSW' },
  { postCode: '2371', suburb: 'DEEPWATER', state: 'NSW' },
  { postCode: '2371', suburb: 'EMMAVILLE', state: 'NSW' },
  { postCode: '2371', suburb: 'ROCKY CREEK', state: 'NSW' },
  { postCode: '2371', suburb: 'STANNUM', state: 'NSW' },
  { postCode: '2371', suburb: 'TORRINGTON', state: 'NSW' },
  { postCode: '2371', suburb: 'WELLINGTON VALE', state: 'NSW' },
  { postCode: '2371', suburb: 'YELLOW DAM', state: 'NSW' },
  { postCode: '2372', suburb: 'BACK CREEK', state: 'NSW' },
  { postCode: '2372', suburb: 'BOLIVIA', state: 'NSW' },
  { postCode: '2372', suburb: 'BOOKOOKOORARA', state: 'NSW' },
  { postCode: '2372', suburb: 'BOONOO BOONOO', state: 'NSW' },
  { postCode: '2372', suburb: 'BOOROOK', state: 'NSW' },
  { postCode: '2372', suburb: 'CARROLLS CREEK', state: 'NSW' },
  { postCode: '2372', suburb: 'CULLENDORE', state: 'NSW' },
  { postCode: '2372', suburb: 'DUMARESQ VALLEY', state: 'NSW' },
  { postCode: '2372', suburb: 'FOREST LAND', state: 'NSW' },
  { postCode: '2372', suburb: 'LISTON', state: 'NSW' },
  { postCode: '2372', suburb: 'MOLE RIVER', state: 'NSW' },
  { postCode: '2372', suburb: 'RIVERTREE', state: 'NSW' },
  { postCode: '2372', suburb: 'ROCKY RIVER', state: 'NSW' },
  { postCode: '2372', suburb: 'SANDY FLAT', state: 'NSW' },
  { postCode: '2372', suburb: 'SANDY HILL', state: 'NSW' },
  { postCode: '2372', suburb: 'SILENT GROVE', state: 'NSW' },
  { postCode: '2372', suburb: 'TARBAN', state: 'NSW' },
  { postCode: '2372', suburb: 'TENTERFIELD', state: 'NSW' },
  { postCode: '2372', suburb: 'TIMBARRA', state: 'NSW' },
  { postCode: '2372', suburb: 'WILLSONS DOWNFALL', state: 'NSW' },
  { postCode: '2372', suburb: 'WOODSIDE', state: 'NSW' },
  { postCode: '2372', suburb: 'WYLIE CREEK', state: 'NSW' },
  { postCode: '2379', suburb: 'GOOLHI', state: 'NSW' },
  { postCode: '2379', suburb: 'MULLALEY', state: 'NSW' },
  { postCode: '2379', suburb: 'NAPIER LANE', state: 'NSW' },
  { postCode: '2379', suburb: 'NOMBI', state: 'NSW' },
  { postCode: '2380', suburb: 'BLUE VALE', state: 'NSW' },
  { postCode: '2380', suburb: 'EMERALD HILL', state: 'NSW' },
  { postCode: '2380', suburb: 'GHOOLENDAADI', state: 'NSW' },
  { postCode: '2380', suburb: 'GUNNEDAH', state: 'NSW' },
  { postCode: '2380', suburb: 'KELVIN', state: 'NSW' },
  { postCode: '2380', suburb: 'MARYS MOUNT', state: 'NSW' },
  { postCode: '2380', suburb: 'MILROY', state: 'NSW' },
  { postCode: '2380', suburb: 'ORANGE GROVE', state: 'NSW' },
  { postCode: '2380', suburb: 'RANGARI', state: 'NSW' },
  { postCode: '2381', suburb: 'BREEZA', state: 'NSW' },
  { postCode: '2381', suburb: 'CURLEWIS', state: 'NSW' },
  { postCode: '2381', suburb: 'PREMER', state: 'NSW' },
  { postCode: '2381', suburb: 'TAMBAR SPRINGS', state: 'NSW' },
  { postCode: '2382', suburb: 'BOGGABRI', state: 'NSW' },
  { postCode: '2382', suburb: 'MAULES CREEK', state: 'NSW' },
  { postCode: '2382', suburb: 'WEAN', state: 'NSW' },
  { postCode: '2382', suburb: 'WILLALA', state: 'NSW' },
  { postCode: '2386', suburb: 'BURREN JUNCTION', state: 'NSW' },
  { postCode: '2386', suburb: 'DRILDOOL', state: 'NSW' },
  { postCode: '2386', suburb: 'NOWLEY', state: 'NSW' },
  { postCode: '2387', suburb: 'BULYEROI', state: 'NSW' },
  { postCode: '2387', suburb: 'ROWENA', state: 'NSW' },
  { postCode: '2388', suburb: 'BOOLCARROLL', state: 'NSW' },
  { postCode: '2388', suburb: 'CUTTABRI', state: 'NSW' },
  { postCode: '2388', suburb: 'MERAH NORTH', state: 'NSW' },
  { postCode: '2388', suburb: 'PILLIGA', state: 'NSW' },
  { postCode: '2388', suburb: 'SPRING PLAINS', state: 'NSW' },
  { postCode: '2388', suburb: 'THE PILLIGA', state: 'NSW' },
  { postCode: '2388', suburb: 'WEE WAA', state: 'NSW' },
  { postCode: '2388', suburb: 'YARRIE LAKE', state: 'NSW' },
  { postCode: '2390', suburb: 'BAAN BAA', state: 'NSW' },
  { postCode: '2390', suburb: 'BACK CREEK', state: 'NSW' },
  { postCode: '2390', suburb: 'BERRIGAL', state: 'NSW' },
  { postCode: '2390', suburb: 'BOHENA CREEK', state: 'NSW' },
  { postCode: '2390', suburb: 'BULLAWA CREEK', state: 'NSW' },
  { postCode: '2390', suburb: 'COURADDA', state: 'NSW' },
  { postCode: '2390', suburb: 'EDGEROI', state: 'NSW' },
  { postCode: '2390', suburb: 'EULAH CREEK', state: 'NSW' },
  { postCode: '2390', suburb: 'HARPARARY', state: 'NSW' },
  { postCode: '2390', suburb: 'JACKS CREEK', state: 'NSW' },
  { postCode: '2390', suburb: 'KAPUTAR', state: 'NSW' },
  { postCode: '2390', suburb: 'NARRABRI', state: 'NSW' },
  { postCode: '2390', suburb: 'NARRABRI WEST', state: 'NSW' },
  { postCode: '2390', suburb: 'ROCKY CREEK', state: 'NSW' },
  { postCode: '2390', suburb: 'TARRIARO', state: 'NSW' },
  { postCode: '2390', suburb: 'TURRAWAN', state: 'NSW' },
  { postCode: '2395', suburb: 'BINNAWAY', state: 'NSW' },
  { postCode: '2395', suburb: 'ROPERS ROAD', state: 'NSW' },
  { postCode: '2395', suburb: 'WEETALIBA', state: 'NSW' },
  { postCode: '2396', suburb: 'BARADINE', state: 'NSW' },
  { postCode: '2396', suburb: 'BARWON', state: 'NSW' },
  { postCode: '2396', suburb: 'GOORIANAWA', state: 'NSW' },
  { postCode: '2396', suburb: 'KENEBRI', state: 'NSW' },
  { postCode: '2397', suburb: 'BELLATA', state: 'NSW' },
  { postCode: '2397', suburb: 'JEWS LAGOON', state: 'NSW' },
  { postCode: '2397', suburb: 'MILLIE', state: 'NSW' },
  { postCode: '2398', suburb: 'GURLEY', state: 'NSW' },
  { postCode: '2399', suburb: 'BINIGUY', state: 'NSW' },
  { postCode: '2399', suburb: 'PALLAMALLAWA', state: 'NSW' },
  { postCode: '2400', suburb: 'ASHLEY', state: 'NSW' },
  { postCode: '2400', suburb: 'BULLARAH', state: 'NSW' },
  { postCode: '2400', suburb: 'CROOBLE', state: 'NSW' },
  { postCode: '2400', suburb: 'MALLOWA', state: 'NSW' },
  { postCode: '2400', suburb: 'MOREE', state: 'NSW' },
  { postCode: '2400', suburb: 'MOREE EAST', state: 'NSW' },
  { postCode: '2400', suburb: 'TERRY HIE HIE', state: 'NSW' },
  { postCode: '2400', suburb: 'TULLOONA', state: 'NSW' },
  { postCode: '2401', suburb: 'GRAVESEND', state: 'NSW' },
  { postCode: '2402', suburb: 'COOLATAI', state: 'NSW' },
  { postCode: '2402', suburb: 'WARIALDA', state: 'NSW' },
  { postCode: '2402', suburb: 'WARIALDA RAIL', state: 'NSW' },
  { postCode: '2403', suburb: 'BALFOURS PEAK', state: 'NSW' },
  { postCode: '2403', suburb: 'DELUNGRA', state: 'NSW' },
  { postCode: '2403', suburb: 'GRAGIN', state: 'NSW' },
  { postCode: '2403', suburb: 'MYALL CREEK', state: 'NSW' },
  { postCode: '2404', suburb: 'BANGHEET', state: 'NSW' },
  { postCode: '2404', suburb: 'BINGARA', state: 'NSW' },
  { postCode: '2404', suburb: 'DINOGA', state: 'NSW' },
  { postCode: '2404', suburb: 'ELCOMBE', state: 'NSW' },
  { postCode: '2404', suburb: 'GINEROI', state: 'NSW' },
  { postCode: '2404', suburb: 'KEERA', state: 'NSW' },
  { postCode: '2404', suburb: 'PALLAL', state: 'NSW' },
  { postCode: '2404', suburb: 'UPPER BINGARA', state: 'NSW' },
  { postCode: '2404', suburb: 'WHITLOW', state: 'NSW' },
  { postCode: '2405', suburb: 'BOOMI', state: 'NSW' },
  { postCode: '2405', suburb: 'GARAH', state: 'NSW' },
  { postCode: '2406', suburb: 'MUNGINDI', state: 'NSW' },
  { postCode: '2406', suburb: 'MUNGINDI', state: 'QLD' },
  { postCode: '2406', suburb: 'WEEMELAH', state: 'NSW' },
  { postCode: '2408', suburb: 'BLUE NOBBY', state: 'NSW' },
  { postCode: '2408', suburb: 'NORTH STAR', state: 'NSW' },
  { postCode: '2408', suburb: 'YALLAROI', state: 'NSW' },
  { postCode: '2409', suburb: 'BOGGABILLA', state: 'NSW' },
  { postCode: '2409', suburb: 'BOONAL', state: 'NSW' },
  { postCode: '2410', suburb: 'TWIN RIVERS', state: 'NSW' },
  { postCode: '2410', suburb: 'YETMAN', state: 'NSW' },
  { postCode: '2411', suburb: 'CROPPA CREEK', state: 'NSW' },
  { postCode: '2415', suburb: 'MONKERAI', state: 'NSW' },
  { postCode: '2415', suburb: 'NOOROO', state: 'NSW' },
  { postCode: '2415', suburb: 'STROUD ROAD', state: 'NSW' },
  { postCode: '2415', suburb: 'UPPER KARUAH RIVER', state: 'NSW' },
  { postCode: '2415', suburb: 'WEISMANTELS', state: 'NSW' },
  { postCode: '2420', suburb: 'ALISON', state: 'NSW' },
  { postCode: '2420', suburb: 'BANDON GROVE', state: 'NSW' },
  { postCode: '2420', suburb: 'BENDOLBA', state: 'NSW' },
  { postCode: '2420', suburb: 'BROOKFIELD', state: 'NSW' },
  { postCode: '2420', suburb: 'CAMBRA', state: 'NSW' },
  { postCode: '2420', suburb: 'CHICHESTER', state: 'NSW' },
  { postCode: '2420', suburb: 'DUNGOG', state: 'NSW' },
  { postCode: '2420', suburb: 'FLAT TOPS', state: 'NSW' },
  { postCode: '2420', suburb: 'FOSTERTON', state: 'NSW' },
  { postCode: '2420', suburb: 'HANLEYS CREEK', state: 'NSW' },
  { postCode: '2420', suburb: 'HILLDALE', state: 'NSW' },
  { postCode: '2420', suburb: 'MAIN CREEK', state: 'NSW' },
  { postCode: '2420', suburb: 'MARSHDALE', state: 'NSW' },
  { postCode: '2420', suburb: 'MARTINS CREEK', state: 'NSW' },
  { postCode: '2420', suburb: 'MUNNI', state: 'NSW' },
  { postCode: '2420', suburb: 'SALISBURY', state: 'NSW' },
  { postCode: '2420', suburb: 'STROUD HILL', state: 'NSW' },
  { postCode: '2420', suburb: 'SUGARLOAF', state: 'NSW' },
  { postCode: '2420', suburb: 'TABBIL CREEK', state: 'NSW' },
  { postCode: '2420', suburb: 'UNDERBANK', state: 'NSW' },
  { postCode: '2420', suburb: 'WALLARINGA', state: 'NSW' },
  { postCode: '2420', suburb: 'WALLAROBBA', state: 'NSW' },
  { postCode: '2420', suburb: 'WIRRAGULLA', state: 'NSW' },
  { postCode: '2421', suburb: 'FISHERS HILL', state: 'NSW' },
  { postCode: '2421', suburb: 'PATERSON', state: 'NSW' },
  { postCode: '2421', suburb: 'SUMMER HILL', state: 'NSW' },
  { postCode: '2421', suburb: 'TOCAL', state: 'NSW' },
  { postCode: '2421', suburb: 'TORRYBURN', state: 'NSW' },
  { postCode: '2421', suburb: 'VACY', state: 'NSW' },
  { postCode: '2421', suburb: 'WEBBERS CREEK', state: 'NSW' },
  { postCode: '2422', suburb: 'BACK CREEK', state: 'NSW' },
  { postCode: '2422', suburb: 'BAKERS CREEK', state: 'NSW' },
  { postCode: '2422', suburb: 'BARRINGTON', state: 'NSW' },
  { postCode: '2422', suburb: 'BARRINGTON TOPS', state: 'NSW' },
  { postCode: '2422', suburb: 'BAXTERS RIDGE', state: 'NSW' },
  { postCode: '2422', suburb: 'BELBORA', state: 'NSW' },
  { postCode: '2422', suburb: 'BERRICO', state: 'NSW' },
  { postCode: '2422', suburb: 'BINDERA', state: 'NSW' },
  { postCode: '2422', suburb: 'BOWMAN', state: 'NSW' },
  { postCode: '2422', suburb: 'BOWMAN FARM', state: 'NSW' },
  { postCode: '2422', suburb: 'BRETTI', state: 'NSW' },
  { postCode: '2422', suburb: 'BULLIAC', state: 'NSW' },
  { postCode: '2422', suburb: 'BUNDOOK', state: 'NSW' },
  { postCode: '2422', suburb: 'CALLAGHANS CREEK', state: 'NSW' },
  { postCode: '2422', suburb: 'COBARK', state: 'NSW' },
  { postCode: '2422', suburb: 'CONEAC', state: 'NSW' },
  { postCode: '2422', suburb: 'COPELAND', state: 'NSW' },
  { postCode: '2422', suburb: 'CRAVEN', state: 'NSW' },
  { postCode: '2422', suburb: 'CRAVEN PLATEAU', state: 'NSW' },
  { postCode: '2422', suburb: 'CURRICABARK', state: 'NSW' },
  { postCode: '2422', suburb: 'DEWITT', state: 'NSW' },
  { postCode: '2422', suburb: 'FAULKLAND', state: 'NSW' },
  { postCode: '2422', suburb: 'FORBESDALE', state: 'NSW' },
  { postCode: '2422', suburb: 'GANGAT', state: 'NSW' },
  { postCode: '2422', suburb: 'GIRO', state: 'NSW' },
  { postCode: '2422', suburb: 'GLEN WARD', state: 'NSW' },
  { postCode: '2422', suburb: 'GLOUCESTER', state: 'NSW' },
  { postCode: '2422', suburb: 'GLOUCESTER TOPS', state: 'NSW' },
  { postCode: '2422', suburb: 'INVERGORDON', state: 'NSW' },
  { postCode: '2422', suburb: 'KIA ORA', state: 'NSW' },
  { postCode: '2422', suburb: 'MARES RUN', state: 'NSW' },
  { postCode: '2422', suburb: 'MERNOT', state: 'NSW' },
  { postCode: '2422', suburb: 'MOGRANI', state: 'NSW' },
  { postCode: '2422', suburb: 'MOPPY', state: 'NSW' },
  { postCode: '2422', suburb: 'RAWDON VALE', state: 'NSW' },
  { postCode: '2422', suburb: 'ROOKHURST', state: 'NSW' },
  { postCode: '2422', suburb: 'STRATFORD', state: 'NSW' },
  { postCode: '2422', suburb: 'TERREEL', state: 'NSW' },
  { postCode: '2422', suburb: 'TIBBUC', state: 'NSW' },
  { postCode: '2422', suburb: 'TITAATEE CREEK', state: 'NSW' },
  { postCode: '2422', suburb: 'TUGRABAKH', state: 'NSW' },
  { postCode: '2422', suburb: 'WALLANBAH', state: 'NSW' },
  { postCode: '2422', suburb: 'WARDS RIVER', state: 'NSW' },
  { postCode: '2422', suburb: 'WAUKIVORY', state: 'NSW' },
  { postCode: '2422', suburb: 'WOKO', state: 'NSW' },
  { postCode: '2423', suburb: 'BOMBAH POINT', state: 'NSW' },
  { postCode: '2423', suburb: 'BOOLAMBAYTE', state: 'NSW' },
  { postCode: '2423', suburb: 'BULAHDELAH', state: 'NSW' },
  { postCode: '2423', suburb: 'BUNGWAHL', state: 'NSW' },
  { postCode: '2423', suburb: 'COOLONGOLOOK', state: 'NSW' },
  { postCode: '2423', suburb: 'CRAWFORD RIVER', state: 'NSW' },
  { postCode: '2423', suburb: 'MARKWELL', state: 'NSW' },
  { postCode: '2423', suburb: 'MAYERS FLAT', state: 'NSW' },
  { postCode: '2423', suburb: 'MUNGO BRUSH', state: 'NSW' },
  { postCode: '2423', suburb: 'MYALL LAKE', state: 'NSW' },
  { postCode: '2423', suburb: 'NERONG', state: 'NSW' },
  { postCode: '2423', suburb: 'SEAL ROCKS', state: 'NSW' },
  { postCode: '2423', suburb: 'TOPI TOPI', state: 'NSW' },
  { postCode: '2423', suburb: 'UPPER MYALL', state: 'NSW' },
  { postCode: '2423', suburb: 'VIOLET HILL', state: 'NSW' },
  { postCode: '2423', suburb: 'WANG WAUK', state: 'NSW' },
  { postCode: '2423', suburb: 'WARRANULLA', state: 'NSW' },
  { postCode: '2423', suburb: 'WILLINA', state: 'NSW' },
  { postCode: '2423', suburb: 'WOOTTON', state: 'NSW' },
  { postCode: '2423', suburb: 'YAGON', state: 'NSW' },
  { postCode: '2424', suburb: 'CAFFREYS FLAT', state: 'NSW' },
  { postCode: '2424', suburb: 'CELLS RIVER', state: 'NSW' },
  { postCode: '2424', suburb: 'COOPLACURRIPA', state: 'NSW' },
  { postCode: '2424', suburb: 'CUNDLE FLAT', state: 'NSW' },
  { postCode: '2424', suburb: 'KNORRIT FLAT', state: 'NSW' },
  { postCode: '2424', suburb: 'KNORRIT FOREST', state: 'NSW' },
  { postCode: '2424', suburb: 'MOUNT GEORGE', state: 'NSW' },
  { postCode: '2424', suburb: 'NUMBER ONE', state: 'NSW' },
  { postCode: '2424', suburb: 'TIRI', state: 'NSW' },
  { postCode: '2425', suburb: 'ALLWORTH', state: 'NSW' },
  { postCode: '2425', suburb: 'BOORAL', state: 'NSW' },
  { postCode: '2425', suburb: 'GIRVAN', state: 'NSW' },
  { postCode: '2425', suburb: 'STROUD', state: 'NSW' },
  { postCode: '2425', suburb: 'THE BRANCH', state: 'NSW' },
  { postCode: '2425', suburb: 'WASHPOOL', state: 'NSW' },
  { postCode: '2426', suburb: 'COOPERNOOK', state: 'NSW' },
  { postCode: '2426', suburb: 'LANGLEY VALE', state: 'NSW' },
  { postCode: '2426', suburb: 'MOTO', state: 'NSW' },
  { postCode: '2427', suburb: 'CROWDY HEAD', state: 'NSW' },
  { postCode: '2427', suburb: 'HARRINGTON', state: 'NSW' },
  { postCode: '2428', suburb: 'BLUEYS BEACH', state: 'NSW' },
  { postCode: '2428', suburb: 'BOOMERANG BEACH', state: 'NSW' },
  { postCode: '2428', suburb: 'BOOTI BOOTI', state: 'NSW' },
  { postCode: '2428', suburb: 'CHARLOTTE BAY', state: 'NSW' },
  { postCode: '2428', suburb: 'COOMBA BAY', state: 'NSW' },
  { postCode: '2428', suburb: 'COOMBA PARK', state: 'NSW' },
  { postCode: '2428', suburb: 'DARAWANK', state: 'NSW' },
  { postCode: '2428', suburb: 'ELIZABETH BEACH', state: 'NSW' },
  { postCode: '2428', suburb: 'FORSTER', state: 'NSW' },
  { postCode: '2428', suburb: 'FORSTER SHOPPING VILLAGE', state: 'NSW' },
  { postCode: '2428', suburb: 'GREEN POINT', state: 'NSW' },
  { postCode: '2428', suburb: 'PACIFIC PALMS', state: 'NSW' },
  { postCode: '2428', suburb: 'SANDBAR', state: 'NSW' },
  { postCode: '2428', suburb: 'SHALLOW BAY', state: 'NSW' },
  { postCode: '2428', suburb: 'SMITHS LAKE', state: 'NSW' },
  { postCode: '2428', suburb: 'TARBUCK BAY', state: 'NSW' },
  { postCode: '2428', suburb: 'TIONA', state: 'NSW' },
  { postCode: '2428', suburb: 'TUNCURRY', state: 'NSW' },
  { postCode: '2428', suburb: 'WALLINGAT', state: 'NSW' },
  { postCode: '2428', suburb: 'WALLIS LAKE', state: 'NSW' },
  { postCode: '2428', suburb: 'WHOOTA', state: 'NSW' },
  { postCode: '2429', suburb: 'BOBIN', state: 'NSW' },
  { postCode: '2429', suburb: 'BOORGANNA', state: 'NSW' },
  { postCode: '2429', suburb: 'BUCCA WAUKA', state: 'NSW' },
  { postCode: '2429', suburb: 'BULGA FOREST', state: 'NSW' },
  { postCode: '2429', suburb: 'BUNYAH', state: 'NSW' },
  { postCode: '2429', suburb: 'BURRELL CREEK', state: 'NSW' },
  { postCode: '2429', suburb: 'CAPARRA', state: 'NSW' },
  { postCode: '2429', suburb: 'CEDAR PARTY', state: 'NSW' },
  { postCode: '2429', suburb: 'COMBOYNE', state: 'NSW' },
  { postCode: '2429', suburb: 'DINGO FOREST', state: 'NSW' },
  { postCode: '2429', suburb: 'DOLLYS FLAT', state: 'NSW' },
  { postCode: '2429', suburb: 'DYERS CROSSING', state: 'NSW' },
  { postCode: '2429', suburb: 'ELANDS', state: 'NSW' },
  { postCode: '2429', suburb: 'FIREFLY', state: 'NSW' },
  { postCode: '2429', suburb: 'INNES VIEW', state: 'NSW' },
  { postCode: '2429', suburb: 'KARAAK FLAT', state: 'NSW' },
  { postCode: '2429', suburb: 'KHATAMBUHL', state: 'NSW' },
  { postCode: '2429', suburb: 'KILLABAKH', state: 'NSW' },
  { postCode: '2429', suburb: 'KILLAWARRA', state: 'NSW' },
  { postCode: '2429', suburb: 'KIMBRIKI', state: 'NSW' },
  { postCode: '2429', suburb: 'KIPPAXS', state: 'NSW' },
  { postCode: '2429', suburb: 'KRAMBACH', state: 'NSW' },
  { postCode: '2429', suburb: 'KUNDIBAKH', state: 'NSW' },
  { postCode: '2429', suburb: 'MARLEE', state: 'NSW' },
  { postCode: '2429', suburb: 'MOORAL CREEK', state: 'NSW' },
  { postCode: '2429', suburb: 'STRATHCEDAR', state: 'NSW' },
  { postCode: '2429', suburb: 'THE BIGHT', state: 'NSW' },
  { postCode: '2429', suburb: 'TIPPERARY', state: 'NSW' },
  { postCode: '2429', suburb: 'WARRIWILLAH', state: 'NSW' },
  { postCode: '2429', suburb: 'WHERROL FLAT', state: 'NSW' },
  { postCode: '2429', suburb: 'WINGHAM', state: 'NSW' },
  { postCode: '2429', suburb: 'YARRATT FOREST', state: 'NSW' },
  { postCode: '2430', suburb: 'BLACK HEAD', state: 'NSW' },
  { postCode: '2430', suburb: 'BOHNOCK', state: 'NSW' },
  { postCode: '2430', suburb: 'BOOTAWA', state: 'NSW' },
  { postCode: '2430', suburb: 'BRIMBIN', state: 'NSW' },
  { postCode: '2430', suburb: 'CABBAGE TREE ISLAND', state: 'NSW' },
  { postCode: '2430', suburb: 'CHATHAM', state: 'NSW' },
  { postCode: '2430', suburb: 'CROKI', state: 'NSW' },
  { postCode: '2430', suburb: 'CUNDLETOWN', state: 'NSW' },
  { postCode: '2430', suburb: 'DIAMOND BEACH', state: 'NSW' },
  { postCode: '2430', suburb: 'DUMARESQ ISLAND', state: 'NSW' },
  { postCode: '2430', suburb: 'FAILFORD', state: 'NSW' },
  { postCode: '2430', suburb: 'GHINNI GHINNI', state: 'NSW' },
  { postCode: '2430', suburb: 'GLENTHORNE', state: 'NSW' },
  { postCode: '2430', suburb: 'HALLIDAYS POINT', state: 'NSW' },
  { postCode: '2430', suburb: 'HILLVILLE', state: 'NSW' },
  { postCode: '2430', suburb: 'JONES ISLAND', state: 'NSW' },
  { postCode: '2430', suburb: 'KIWARRAK', state: 'NSW' },
  { postCode: '2430', suburb: 'KOORAINGHAT', state: 'NSW' },
  { postCode: '2430', suburb: 'KUNDLE KUNDLE', state: 'NSW' },
  { postCode: '2430', suburb: 'LANSDOWNE', state: 'NSW' },
  { postCode: '2430', suburb: 'LANSDOWNE FOREST', state: 'NSW' },
  { postCode: '2430', suburb: 'MANNING POINT', state: 'NSW' },
  { postCode: '2430', suburb: 'MELINGA', state: 'NSW' },
  { postCode: '2430', suburb: 'MITCHELLS ISLAND', state: 'NSW' },
  { postCode: '2430', suburb: 'MONDROOK', state: 'NSW' },
  { postCode: '2430', suburb: 'OLD BAR', state: 'NSW' },
  { postCode: '2430', suburb: 'OXLEY ISLAND', state: 'NSW' },
  { postCode: '2430', suburb: 'PAMPOOLAH', state: 'NSW' },
  { postCode: '2430', suburb: 'POSSUM BRUSH', state: 'NSW' },
  { postCode: '2430', suburb: 'PURFLEET', state: 'NSW' },
  { postCode: '2430', suburb: 'RAINBOW FLAT', state: 'NSW' },
  { postCode: '2430', suburb: 'RED HEAD', state: 'NSW' },
  { postCode: '2430', suburb: 'SALTWATER', state: 'NSW' },
  { postCode: '2430', suburb: 'TALLWOODS VILLAGE', state: 'NSW' },
  { postCode: '2430', suburb: 'TAREE', state: 'NSW' },
  { postCode: '2430', suburb: 'TAREE DC', state: 'NSW' },
  { postCode: '2430', suburb: 'TAREE SOUTH', state: 'NSW' },
  { postCode: '2430', suburb: 'TINONEE', state: 'NSW' },
  { postCode: '2430', suburb: 'UPPER LANSDOWNE', state: 'NSW' },
  { postCode: '2430', suburb: 'WALLABI POINT', state: 'NSW' },
  { postCode: '2431', suburb: 'ARAKOON', state: 'NSW' },
  { postCode: '2431', suburb: 'JERSEYVILLE', state: 'NSW' },
  { postCode: '2431', suburb: 'SOUTH WEST ROCKS', state: 'NSW' },
  { postCode: '2439', suburb: 'BATAR CREEK', state: 'NSW' },
  { postCode: '2439', suburb: 'BLACK CREEK', state: 'NSW' },
  { postCode: '2439', suburb: 'BOBS CREEK', state: 'NSW' },
  { postCode: '2439', suburb: 'HERONS CREEK', state: 'NSW' },
  { postCode: '2439', suburb: 'KENDALL', state: 'NSW' },
  { postCode: '2439', suburb: 'KEREWONG', state: 'NSW' },
  { postCode: '2439', suburb: 'KEW', state: 'NSW' },
  { postCode: '2439', suburb: 'LOGANS CROSSING', state: 'NSW' },
  { postCode: '2439', suburb: 'LORNE', state: 'NSW' },
  { postCode: '2439', suburb: 'ROSSGLEN', state: 'NSW' },
  { postCode: '2439', suburb: 'SWANS CROSSING', state: 'NSW' },
  { postCode: '2439', suburb: 'UPSALLS CREEK', state: 'NSW' },
  { postCode: '2440', suburb: 'ALDAVILLA', state: 'NSW' },
  { postCode: '2440', suburb: 'AUSTRAL EDEN', state: 'NSW' },
  { postCode: '2440', suburb: 'BELLBROOK', state: 'NSW' },
  { postCode: '2440', suburb: 'BELLIMBOPINNI', state: 'NSW' },
  { postCode: '2440', suburb: 'BELMORE RIVER', state: 'NSW' },
  { postCode: '2440', suburb: 'BURNT BRIDGE', state: 'NSW' },
  { postCode: '2440', suburb: 'CARRAI', state: 'NSW' },
  { postCode: '2440', suburb: 'CLYBUCCA', state: 'NSW' },
  { postCode: '2440', suburb: 'COLLOMBATTI', state: 'NSW' },
  { postCode: '2440', suburb: 'COMARA', state: 'NSW' },
  { postCode: '2440', suburb: 'CORANGULA', state: 'NSW' },
  { postCode: '2440', suburb: 'CRESCENT HEAD', state: 'NSW' },
  { postCode: '2440', suburb: 'DEEP CREEK', state: 'NSW' },
  { postCode: '2440', suburb: 'DONDINGALONG', state: 'NSW' },
  { postCode: '2440', suburb: 'EAST KEMPSEY', state: 'NSW' },
  { postCode: '2440', suburb: 'EUROKA', state: 'NSW' },
  { postCode: '2440', suburb: 'FREDERICKTON', state: 'NSW' },
  { postCode: '2440', suburb: 'GLADSTONE', state: 'NSW' },
  { postCode: '2440', suburb: 'GREENHILL', state: 'NSW' },
  { postCode: '2440', suburb: 'HAMPDEN HALL', state: 'NSW' },
  { postCode: '2440', suburb: 'HAT HEAD', state: 'NSW' },
  { postCode: '2440', suburb: 'HICKEYS CREEK', state: 'NSW' },
  { postCode: '2440', suburb: 'KEMPSEY', state: 'NSW' },
  { postCode: '2440', suburb: 'KINCHELA', state: 'NSW' },
  { postCode: '2440', suburb: 'LOWER CREEK', state: 'NSW' },
  { postCode: '2440', suburb: 'MILLBANK', state: 'NSW' },
  { postCode: '2440', suburb: 'MOONEBA', state: 'NSW' },
  { postCode: '2440', suburb: 'MOPARRABAH', state: 'NSW' },
  { postCode: '2440', suburb: 'MUNGAY CREEK', state: 'NSW' },
  { postCode: '2440', suburb: 'OLD STATION', state: 'NSW' },
  { postCode: '2440', suburb: 'POLA CREEK', state: 'NSW' },
  { postCode: '2440', suburb: 'RAINBOW REACH', state: 'NSW' },
  { postCode: '2440', suburb: 'SEVEN OAKS', state: 'NSW' },
  { postCode: '2440', suburb: 'SHERWOOD', state: 'NSW' },
  { postCode: '2440', suburb: 'SKILLION FLAT', state: 'NSW' },
  { postCode: '2440', suburb: 'SMITHTOWN', state: 'NSW' },
  { postCode: '2440', suburb: 'SOUTH KEMPSEY', state: 'NSW' },
  { postCode: '2440', suburb: 'SUMMER ISLAND', state: 'NSW' },
  { postCode: '2440', suburb: 'TEMAGOG', state: 'NSW' },
  { postCode: '2440', suburb: 'TOOROOKA', state: 'NSW' },
  { postCode: '2440', suburb: 'TURNERS FLAT', state: 'NSW' },
  { postCode: '2440', suburb: 'VERGES CREEK', state: 'NSW' },
  { postCode: '2440', suburb: 'WEST KEMPSEY', state: 'NSW' },
  { postCode: '2440', suburb: 'WILLAWARRIN', state: 'NSW' },
  { postCode: '2440', suburb: 'WILLI WILLI', state: 'NSW' },
  { postCode: '2440', suburb: 'WITTITRIN', state: 'NSW' },
  { postCode: '2440', suburb: 'YARRAVEL', state: 'NSW' },
  { postCode: '2440', suburb: 'YESSABAH', state: 'NSW' },
  { postCode: '2441', suburb: 'ALLGOMERA', state: 'NSW' },
  { postCode: '2441', suburb: 'BALLENGARRA', state: 'NSW' },
  { postCode: '2441', suburb: 'BARRAGANYATTI', state: 'NSW' },
  { postCode: '2441', suburb: 'BRIL BRIL', state: 'NSW' },
  { postCode: '2441', suburb: 'COOPERABUNG', state: 'NSW' },
  { postCode: '2441', suburb: 'EUNGAI CREEK', state: 'NSW' },
  { postCode: '2441', suburb: 'EUNGAI RAIL', state: 'NSW' },
  { postCode: '2441', suburb: 'FISHERMANS REACH', state: 'NSW' },
  { postCode: '2441', suburb: 'GEARYS FLAT', state: 'NSW' },
  { postCode: '2441', suburb: 'GRASSY HEAD', state: 'NSW' },
  { postCode: '2441', suburb: 'GUM SCRUB', state: 'NSW' },
  { postCode: '2441', suburb: 'HACKS FERRY', state: 'NSW' },
  { postCode: '2441', suburb: 'KIPPARA', state: 'NSW' },
  { postCode: '2441', suburb: 'KUNDABUNG', state: 'NSW' },
  { postCode: '2441', suburb: 'MARLO MERRICAN', state: 'NSW' },
  { postCode: '2441', suburb: 'ROLLANDS PLAINS', state: 'NSW' },
  { postCode: '2441', suburb: 'STUARTS POINT', state: 'NSW' },
  { postCode: '2441', suburb: 'TAMBAN', state: 'NSW' },
  { postCode: '2441', suburb: 'TELEGRAPH POINT', state: 'NSW' },
  { postCode: '2441', suburb: 'UPPER ROLLANDS PLAINS', state: 'NSW' },
  { postCode: '2441', suburb: 'YARRAHAPINNI', state: 'NSW' },
  { postCode: '2442', suburb: 'MID NORTH COAST MC', state: 'NSW' },
  { postCode: '2443', suburb: 'CAMDEN HEAD', state: 'NSW' },
  { postCode: '2443', suburb: 'CORALVILLE', state: 'NSW' },
  { postCode: '2443', suburb: 'CROWDY BAY', state: 'NSW' },
  { postCode: '2443', suburb: 'DEAUVILLE', state: 'NSW' },
  { postCode: '2443', suburb: 'DIAMOND HEAD', state: 'NSW' },
  { postCode: '2443', suburb: 'DUNBOGAN', state: 'NSW' },
  { postCode: '2443', suburb: 'HANNAM VALE', state: 'NSW' },
  { postCode: '2443', suburb: 'JOHNS RIVER', state: 'NSW' },
  { postCode: '2443', suburb: 'LAKEWOOD', state: 'NSW' },
  { postCode: '2443', suburb: 'LAURIETON', state: 'NSW' },
  { postCode: '2443', suburb: 'MIDDLE BROTHER', state: 'NSW' },
  { postCode: '2443', suburb: 'MOORLAND', state: 'NSW' },
  { postCode: '2443', suburb: 'NORTH BROTHER', state: 'NSW' },
  { postCode: '2443', suburb: 'NORTH HAVEN', state: 'NSW' },
  { postCode: '2443', suburb: 'STEWARTS RIVER', state: 'NSW' },
  { postCode: '2443', suburb: 'WAITUI', state: 'NSW' },
  { postCode: '2443', suburb: 'WEST HAVEN', state: 'NSW' },
  { postCode: '2444', suburb: 'BLACKMANS POINT', state: 'NSW' },
  { postCode: '2444', suburb: 'FERNBANK CREEK', state: 'NSW' },
  { postCode: '2444', suburb: 'FLYNNS BEACH', state: 'NSW' },
  { postCode: '2444', suburb: 'LIGHTHOUSE BEACH', state: 'NSW' },
  { postCode: '2444', suburb: 'LIMEBURNERS CREEK', state: 'NSW' },
  { postCode: '2444', suburb: 'NORTH SHORE', state: 'NSW' },
  { postCode: '2444', suburb: 'PORT MACQUARIE', state: 'NSW' },
  { postCode: '2444', suburb: 'PORT MACQUARIE BC', state: 'NSW' },
  { postCode: '2444', suburb: 'RIVERSIDE', state: 'NSW' },
  { postCode: '2444', suburb: 'SETTLEMENT CITY', state: 'NSW' },
  { postCode: '2444', suburb: 'THE HATCH', state: 'NSW' },
  { postCode: '2444', suburb: 'THRUMSTER', state: 'NSW' },
  { postCode: '2445', suburb: 'BONNY HILLS', state: 'NSW' },
  { postCode: '2445', suburb: 'GRANTS BEACH', state: 'NSW' },
  { postCode: '2445', suburb: 'JOLLY NOSE', state: 'NSW' },
  { postCode: '2445', suburb: 'LAKE CATHIE', state: 'NSW' },
  { postCode: '2446', suburb: 'BAGNOO', state: 'NSW' },
  { postCode: '2446', suburb: 'BAGO', state: 'NSW' },
  { postCode: '2446', suburb: 'BANDA BANDA', state: 'NSW' },
  { postCode: '2446', suburb: 'BEECHWOOD', state: 'NSW' },
  { postCode: '2446', suburb: 'BELLANGRY', state: 'NSW' },
  { postCode: '2446', suburb: 'BIRDWOOD', state: 'NSW' },
  { postCode: '2446', suburb: 'BROMBIN', state: 'NSW' },
  { postCode: '2446', suburb: 'BYABARRA', state: 'NSW' },
  { postCode: '2446', suburb: 'CAIRNCROSS', state: 'NSW' },
  { postCode: '2446', suburb: 'CROSSLANDS', state: 'NSW' },
  { postCode: '2446', suburb: 'DEBENHAM', state: 'NSW' },
  { postCode: '2446', suburb: 'DOYLES RIVER', state: 'NSW' },
  { postCode: '2446', suburb: 'ELLENBOROUGH', state: 'NSW' },
  { postCode: '2446', suburb: 'FORBES RIVER', state: 'NSW' },
  { postCode: '2446', suburb: 'FRAZERS CREEK', state: 'NSW' },
  { postCode: '2446', suburb: 'HARTYS PLAINS', state: 'NSW' },
  { postCode: '2446', suburb: 'HOLLISDALE', state: 'NSW' },
  { postCode: '2446', suburb: 'HUNTINGDON', state: 'NSW' },
  { postCode: '2446', suburb: 'HYNDMANS CREEK', state: 'NSW' },
  { postCode: '2446', suburb: 'KINDEE', state: 'NSW' },
  { postCode: '2446', suburb: 'KING CREEK', state: 'NSW' },
  { postCode: '2446', suburb: 'LAKE INNES', state: 'NSW' },
  { postCode: '2446', suburb: 'LONG FLAT', state: 'NSW' },
  { postCode: '2446', suburb: 'LOWER PAPPINBARRA', state: 'NSW' },
  { postCode: '2446', suburb: 'MORTONS CREEK', state: 'NSW' },
  { postCode: '2446', suburb: 'MOUNT SEAVIEW', state: 'NSW' },
  { postCode: '2446', suburb: 'PAPPINBARRA', state: 'NSW' },
  { postCode: '2446', suburb: 'PEMBROOKE', state: 'NSW' },
  { postCode: '2446', suburb: 'PIPECLAY', state: 'NSW' },
  { postCode: '2446', suburb: 'RAWDON ISLAND', state: 'NSW' },
  { postCode: '2446', suburb: 'REDBANK', state: 'NSW' },
  { postCode: '2446', suburb: 'ROSEWOOD', state: 'NSW' },
  { postCode: '2446', suburb: 'SANCROX', state: 'NSW' },
  { postCode: '2446', suburb: 'TOMS CREEK', state: 'NSW' },
  { postCode: '2446', suburb: 'UPPER PAPPINBARRA', state: 'NSW' },
  { postCode: '2446', suburb: 'WAUCHOPE', state: 'NSW' },
  { postCode: '2446', suburb: 'WERRIKIMBE', state: 'NSW' },
  { postCode: '2446', suburb: 'YARRAS', state: 'NSW' },
  { postCode: '2446', suburb: 'YIPPIN CREEK', state: 'NSW' },
  { postCode: '2447', suburb: 'BAKERS CREEK', state: 'NSW' },
  { postCode: '2447', suburb: 'BURRAPINE', state: 'NSW' },
  { postCode: '2447', suburb: 'CONGARINNI', state: 'NSW' },
  { postCode: '2447', suburb: 'CONGARINNI NORTH', state: 'NSW' },
  { postCode: '2447', suburb: 'DONNELLYVILLE', state: 'NSW' },
  { postCode: '2447', suburb: 'GUMMA', state: 'NSW' },
  { postCode: '2447', suburb: 'MACKSVILLE', state: 'NSW' },
  { postCode: '2447', suburb: 'NEWEE CREEK', state: 'NSW' },
  { postCode: '2447', suburb: 'NORTH MACKSVILLE', state: 'NSW' },
  { postCode: '2447', suburb: 'SCOTTS HEAD', state: 'NSW' },
  { postCode: '2447', suburb: 'TALARM', state: 'NSW' },
  { postCode: '2447', suburb: 'TAYLORS ARM', state: 'NSW' },
  { postCode: '2447', suburb: 'THUMB CREEK', state: 'NSW' },
  { postCode: '2447', suburb: 'UPPER TAYLORS ARM', state: 'NSW' },
  { postCode: '2447', suburb: 'UTUNGUN', state: 'NSW' },
  { postCode: '2447', suburb: 'WARRELL CREEK', state: 'NSW' },
  { postCode: '2447', suburb: 'WAY WAY', state: 'NSW' },
  { postCode: '2447', suburb: 'WIRRIMBI', state: 'NSW' },
  { postCode: '2447', suburb: 'YARRANBELLA', state: 'NSW' },
  { postCode: '2448', suburb: 'HYLAND PARK', state: 'NSW' },
  { postCode: '2448', suburb: 'NAMBUCCA HEADS', state: 'NSW' },
  { postCode: '2448', suburb: 'VALLA', state: 'NSW' },
  { postCode: '2448', suburb: 'VALLA BEACH', state: 'NSW' },
  { postCode: '2449', suburb: 'ARGENTS HILL', state: 'NSW' },
  { postCode: '2449', suburb: 'BOWRAVILLE', state: 'NSW' },
  { postCode: '2449', suburb: 'BUCKRA BENDINNI', state: 'NSW' },
  { postCode: '2449', suburb: 'GIRRALONG', state: 'NSW' },
  { postCode: '2449', suburb: 'KENNAICLE CREEK', state: 'NSW' },
  { postCode: '2449', suburb: 'KILLIEKRANKIE', state: 'NSW' },
  { postCode: '2449', suburb: 'MISSABOTTI', state: 'NSW' },
  { postCode: '2449', suburb: 'SOUTH ARM', state: 'NSW' },
  { postCode: '2449', suburb: 'TEWINGA', state: 'NSW' },
  { postCode: '2450', suburb: 'BOAMBEE', state: 'NSW' },
  { postCode: '2450', suburb: 'BONVILLE', state: 'NSW' },
  { postCode: '2450', suburb: 'BROOKLANA', state: 'NSW' },
  { postCode: '2450', suburb: 'BUCCA', state: 'NSW' },
  { postCode: '2450', suburb: 'COFFS HARBOUR', state: 'NSW' },
  { postCode: '2450', suburb: 'COFFS HARBOUR DC', state: 'NSW' },
  { postCode: '2450', suburb: 'COFFS HARBOUR JETTY', state: 'NSW' },
  { postCode: '2450', suburb: 'COFFS HARBOUR PLAZA', state: 'NSW' },
  { postCode: '2450', suburb: 'CORAMBA', state: 'NSW' },
  { postCode: '2450', suburb: 'GLENREAGH', state: 'NSW' },
  { postCode: '2450', suburb: 'KARANGI', state: 'NSW' },
  { postCode: '2450', suburb: 'KORORA', state: 'NSW' },
  { postCode: '2450', suburb: 'LOWANNA', state: 'NSW' },
  { postCode: '2450', suburb: 'MOONEE BEACH', state: 'NSW' },
  { postCode: '2450', suburb: 'NANA GLEN', state: 'NSW' },
  { postCode: '2450', suburb: 'NORTH BOAMBEE VALLEY', state: 'NSW' },
  { postCode: '2450', suburb: 'SAPPHIRE BEACH', state: 'NSW' },
  { postCode: '2450', suburb: 'SHERWOOD', state: 'NSW' },
  { postCode: '2450', suburb: 'ULONG', state: 'NSW' },
  { postCode: '2450', suburb: 'UPPER ORARA', state: 'NSW' },
  { postCode: '2452', suburb: 'BOAMBEE EAST', state: 'NSW' },
  { postCode: '2452', suburb: 'SAWTELL', state: 'NSW' },
  { postCode: '2452', suburb: 'TOORMINA', state: 'NSW' },
  { postCode: '2453', suburb: 'BIELSDOWN HILLS', state: 'NSW' },
  { postCode: '2453', suburb: 'BILLYS CREEK', state: 'NSW' },
  { postCode: '2453', suburb: 'BOSTOBRICK', state: 'NSW' },
  { postCode: '2453', suburb: 'CASCADE', state: 'NSW' },
  { postCode: '2453', suburb: 'CLOUDS CREEK', state: 'NSW' },
  { postCode: '2453', suburb: 'DEER VALE', state: 'NSW' },
  { postCode: '2453', suburb: 'DORRIGO', state: 'NSW' },
  { postCode: '2453', suburb: 'DORRIGO MOUNTAIN', state: 'NSW' },
  { postCode: '2453', suburb: 'DUNDURRABIN', state: 'NSW' },
  { postCode: '2453', suburb: 'EBOR', state: 'NSW' },
  { postCode: '2453', suburb: 'FERNBROOK', state: 'NSW' },
  { postCode: '2453', suburb: 'HERNANI', state: 'NSW' },
  { postCode: '2453', suburb: 'MARENGO', state: 'NSW' },
  { postCode: '2453', suburb: 'MEGAN', state: 'NSW' },
  { postCode: '2453', suburb: 'MOONPAR', state: 'NSW' },
  { postCode: '2453', suburb: 'NEVER NEVER', state: 'NSW' },
  { postCode: '2453', suburb: 'NORTH DORRIGO', state: 'NSW' },
  { postCode: '2453', suburb: 'TALLOWWOOD RIDGE', state: 'NSW' },
  { postCode: '2453', suburb: 'TYRINGHAM', state: 'NSW' },
  { postCode: '2453', suburb: 'WILD CATTLE CREEK', state: 'NSW' },
  { postCode: '2454', suburb: 'BELLINGEN', state: 'NSW' },
  { postCode: '2454', suburb: 'BRIERFIELD', state: 'NSW' },
  { postCode: '2454', suburb: 'BRINERVILLE', state: 'NSW' },
  { postCode: '2454', suburb: 'BUNDAGEN', state: 'NSW' },
  { postCode: '2454', suburb: 'DARKWOOD', state: 'NSW' },
  { postCode: '2454', suburb: 'FERNMOUNT', state: 'NSW' },
  { postCode: '2454', suburb: 'GLENIFFER', state: 'NSW' },
  { postCode: '2454', suburb: 'HYDES CREEK', state: 'NSW' },
  { postCode: '2454', suburb: 'KALANG', state: 'NSW' },
  { postCode: '2454', suburb: 'MYLESTOM', state: 'NSW' },
  { postCode: '2454', suburb: 'RALEIGH', state: 'NSW' },
  { postCode: '2454', suburb: 'REPTON', state: 'NSW' },
  { postCode: '2454', suburb: 'SPICKETTS CREEK', state: 'NSW' },
  { postCode: '2454', suburb: 'THORA', state: 'NSW' },
  { postCode: '2454', suburb: 'VALERY', state: 'NSW' },
  { postCode: '2455', suburb: 'URUNGA', state: 'NSW' },
  { postCode: '2456', suburb: 'ARRAWARRA', state: 'NSW' },
  { postCode: '2456', suburb: 'ARRAWARRA HEADLAND', state: 'NSW' },
  { postCode: '2456', suburb: 'CORINDI BEACH', state: 'NSW' },
  { postCode: '2456', suburb: 'DIRTY CREEK', state: 'NSW' },
  { postCode: '2456', suburb: 'EMERALD BEACH', state: 'NSW' },
  { postCode: '2456', suburb: 'MULLAWAY', state: 'NSW' },
  { postCode: '2456', suburb: 'RED ROCK', state: 'NSW' },
  { postCode: '2456', suburb: 'SAFETY BEACH', state: 'NSW' },
  { postCode: '2456', suburb: 'SANDY BEACH', state: 'NSW' },
  { postCode: '2456', suburb: 'UPPER CORINDI', state: 'NSW' },
  { postCode: '2456', suburb: 'WOOLGOOLGA', state: 'NSW' },
  { postCode: '2460', suburb: 'ALUMY CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'BANYABBA', state: 'NSW' },
  { postCode: '2460', suburb: 'BARCOONGERE', state: 'NSW' },
  { postCode: '2460', suburb: 'BARRETTS CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'BARYULGIL', state: 'NSW' },
  { postCode: '2460', suburb: 'BLAXLANDS CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'BOM BOM', state: 'NSW' },
  { postCode: '2460', suburb: 'BOOKRAM', state: 'NSW' },
  { postCode: '2460', suburb: 'BRAUNSTONE', state: 'NSW' },
  { postCode: '2460', suburb: 'BRUSHGROVE', state: 'NSW' },
  { postCode: '2460', suburb: 'BUCCARUMBI', state: 'NSW' },
  { postCode: '2460', suburb: 'CALAMIA', state: 'NSW' },
  { postCode: '2460', suburb: 'CANGAI', state: 'NSW' },
  { postCode: '2460', suburb: 'CARNHAM', state: 'NSW' },
  { postCode: '2460', suburb: 'CARRS CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'CARRS ISLAND', state: 'NSW' },
  { postCode: '2460', suburb: 'CARRS PENINSULAR', state: 'NSW' },
  { postCode: '2460', suburb: 'CHAELUNDI', state: 'NSW' },
  { postCode: '2460', suburb: 'CHAMBIGNE', state: 'NSW' },
  { postCode: '2460', suburb: 'CLARENZA', state: 'NSW' },
  { postCode: '2460', suburb: 'CLIFDEN', state: 'NSW' },
  { postCode: '2460', suburb: 'COALDALE', state: 'NSW' },
  { postCode: '2460', suburb: 'COLLUM COLLUM', state: 'NSW' },
  { postCode: '2460', suburb: 'COOMBADJHA', state: 'NSW' },
  { postCode: '2460', suburb: 'COPMANHURST', state: 'NSW' },
  { postCode: '2460', suburb: 'COUTTS CROSSING', state: 'NSW' },
  { postCode: '2460', suburb: 'COWPER', state: 'NSW' },
  { postCode: '2460', suburb: 'CROWTHER ISLAND', state: 'NSW' },
  { postCode: '2460', suburb: 'DALMORTON', state: 'NSW' },
  { postCode: '2460', suburb: 'DEEP CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'DILKOON', state: 'NSW' },
  { postCode: '2460', suburb: 'DUMBUDGERY', state: 'NSW' },
  { postCode: '2460', suburb: 'EATONSVILLE', state: 'NSW' },
  { postCode: '2460', suburb: 'EIGHTEEN MILE', state: 'NSW' },
  { postCode: '2460', suburb: 'ELLAND', state: 'NSW' },
  { postCode: '2460', suburb: 'FINE FLOWER', state: 'NSW' },
  { postCode: '2460', suburb: 'FORTIS CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'GLENUGIE', state: 'NSW' },
  { postCode: '2460', suburb: 'GRAFTON', state: 'NSW' },
  { postCode: '2460', suburb: 'GREAT MARLOW', state: 'NSW' },
  { postCode: '2460', suburb: 'GURRANANG', state: 'NSW' },
  { postCode: '2460', suburb: 'HALFWAY CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'HEIFER STATION', state: 'NSW' },
  { postCode: '2460', suburb: 'JACKADGERY', state: 'NSW' },
  { postCode: '2460', suburb: 'JUNCTION HILL', state: 'NSW' },
  { postCode: '2460', suburb: 'KANGAROO CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'KOOLKHAN', state: 'NSW' },
  { postCode: '2460', suburb: 'KREMNOS', state: 'NSW' },
  { postCode: '2460', suburb: 'KUNGALA', state: 'NSW' },
  { postCode: '2460', suburb: 'KYARRAN', state: 'NSW' },
  { postCode: '2460', suburb: 'LANITZA', state: 'NSW' },
  { postCode: '2460', suburb: 'LAWRENCE', state: 'NSW' },
  { postCode: '2460', suburb: 'LEVENSTRATH', state: 'NSW' },
  { postCode: '2460', suburb: 'LILYDALE', state: 'NSW' },
  { postCode: '2460', suburb: 'LIONSVILLE', state: 'NSW' },
  { postCode: '2460', suburb: 'LOWER SOUTHGATE', state: 'NSW' },
  { postCode: '2460', suburb: 'MALABUGILMAH', state: 'NSW' },
  { postCode: '2460', suburb: 'MOLEVILLE CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'MOUNTAIN VIEW', state: 'NSW' },
  { postCode: '2460', suburb: 'MYLNEFORD', state: 'NSW' },
  { postCode: '2460', suburb: 'NEWBOLD', state: 'NSW' },
  { postCode: '2460', suburb: 'NYMBOIDA', state: 'NSW' },
  { postCode: '2460', suburb: 'PULGANBAR', state: 'NSW' },
  { postCode: '2460', suburb: 'PUNCHBOWL', state: 'NSW' },
  { postCode: '2460', suburb: 'RAMORNIE', state: 'NSW' },
  { postCode: '2460', suburb: 'RUSHFORTH', state: 'NSW' },
  { postCode: '2460', suburb: 'SANDY CROSSING', state: 'NSW' },
  { postCode: '2460', suburb: 'SEELANDS', state: 'NSW' },
  { postCode: '2460', suburb: 'SHANNONDALE', state: 'NSW' },
  { postCode: '2460', suburb: 'SMITHS CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'SOUTH ARM', state: 'NSW' },
  { postCode: '2460', suburb: 'SOUTH GRAFTON', state: 'NSW' },
  { postCode: '2460', suburb: 'SOUTHAMPTON', state: 'NSW' },
  { postCode: '2460', suburb: 'SOUTHGATE', state: 'NSW' },
  { postCode: '2460', suburb: 'STOCKYARD CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'THE PINNACLES', state: 'NSW' },
  { postCode: '2460', suburb: 'THE WHITEMAN', state: 'NSW' },
  { postCode: '2460', suburb: 'TOWALLUM', state: 'NSW' },
  { postCode: '2460', suburb: 'TRENAYR', state: 'NSW' },
  { postCode: '2460', suburb: 'TYNDALE', state: 'NSW' },
  { postCode: '2460', suburb: 'UPPER COPMANHURST', state: 'NSW' },
  { postCode: '2460', suburb: 'UPPER FINE FLOWER', state: 'NSW' },
  { postCode: '2460', suburb: 'WARRAGAI CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'WASHPOOL', state: 'NSW' },
  { postCode: '2460', suburb: 'WATERVIEW', state: 'NSW' },
  { postCode: '2460', suburb: 'WATERVIEW HEIGHTS', state: 'NSW' },
  { postCode: '2460', suburb: 'WELLS CROSSING', state: 'NSW' },
  { postCode: '2460', suburb: 'WHITEMAN CREEK', state: 'NSW' },
  { postCode: '2460', suburb: 'WINEGROVE', state: 'NSW' },
  { postCode: '2460', suburb: 'WOMBAT CREEK', state: 'NSW' },
  { postCode: '2462', suburb: 'CALLIOPE', state: 'NSW' },
  { postCode: '2462', suburb: 'COLDSTREAM', state: 'NSW' },
  { postCode: '2462', suburb: 'DIGGERS CAMP', state: 'NSW' },
  { postCode: '2462', suburb: 'GILLETTS RIDGE', state: 'NSW' },
  { postCode: '2462', suburb: 'LAKE HIAWATHA', state: 'NSW' },
  { postCode: '2462', suburb: 'LAVADIA', state: 'NSW' },
  { postCode: '2462', suburb: 'MINNIE WATER', state: 'NSW' },
  { postCode: '2462', suburb: 'PILLAR VALLEY', state: 'NSW' },
  { postCode: '2462', suburb: 'SWAN CREEK', state: 'NSW' },
  { postCode: '2462', suburb: 'TUCABIA', state: 'NSW' },
  { postCode: '2462', suburb: 'ULMARRA', state: 'NSW' },
  { postCode: '2462', suburb: 'WOOLI', state: 'NSW' },
  { postCode: '2463', suburb: 'ASHBY', state: 'NSW' },
  { postCode: '2463', suburb: 'ASHBY HEIGHTS', state: 'NSW' },
  { postCode: '2463', suburb: 'ASHBY ISLAND', state: 'NSW' },
  { postCode: '2463', suburb: 'BROOMS HEAD', state: 'NSW' },
  { postCode: '2463', suburb: 'GULMARRAD', state: 'NSW' },
  { postCode: '2463', suburb: 'ILARWILL', state: 'NSW' },
  { postCode: '2463', suburb: 'JACKY BULBIN FLAT', state: 'NSW' },
  { postCode: '2463', suburb: 'JAMES CREEK', state: 'NSW' },
  { postCode: '2463', suburb: 'MACLEAN', state: 'NSW' },
  { postCode: '2463', suburb: 'PALMERS CHANNEL', state: 'NSW' },
  { postCode: '2463', suburb: 'PALMERS ISLAND', state: 'NSW' },
  { postCode: '2463', suburb: 'SANDON', state: 'NSW' },
  { postCode: '2463', suburb: 'SHARK CREEK', state: 'NSW' },
  { postCode: '2463', suburb: 'TALOUMBI', state: 'NSW' },
  { postCode: '2463', suburb: 'THE SANDON', state: 'NSW' },
  { postCode: '2463', suburb: 'TOWNSEND', state: 'NSW' },
  { postCode: '2463', suburb: 'TULLYMORGAN', state: 'NSW' },
  { postCode: '2463', suburb: 'WOODFORD ISLAND', state: 'NSW' },
  { postCode: '2464', suburb: 'ANGOURIE', state: 'NSW' },
  { postCode: '2464', suburb: 'FREEBURN ISLAND', state: 'NSW' },
  { postCode: '2464', suburb: 'MICALO ISLAND', state: 'NSW' },
  { postCode: '2464', suburb: 'WOOLOWEYAH', state: 'NSW' },
  { postCode: '2464', suburb: 'YAMBA', state: 'NSW' },
  { postCode: '2464', suburb: 'YURAYGIR', state: 'NSW' },
  { postCode: '2465', suburb: 'HARWOOD', state: 'NSW' },
  { postCode: '2466', suburb: 'ILUKA', state: 'NSW' },
  { postCode: '2466', suburb: 'THE FRESHWATER', state: 'NSW' },
  { postCode: '2466', suburb: 'WOODY HEAD', state: 'NSW' },
  { postCode: '2469', suburb: 'ALICE', state: 'NSW' },
  { postCode: '2469', suburb: 'BEAN CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'BINGEEBEEBRA CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'BONALBO', state: 'NSW' },
  { postCode: '2469', suburb: 'BOTTLE CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'BULLDOG', state: 'NSW' },
  { postCode: '2469', suburb: 'BUNGAWALBIN', state: 'NSW' },
  { postCode: '2469', suburb: 'BUSBYS FLAT', state: 'NSW' },
  { postCode: '2469', suburb: 'CAMBRIDGE PLATEAU', state: 'NSW' },
  { postCode: '2469', suburb: 'CAMIRA', state: 'NSW' },
  { postCode: '2469', suburb: 'CAPEEN CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'CHATSWORTH', state: 'NSW' },
  { postCode: '2469', suburb: 'CLEARFIELD', state: 'NSW' },
  { postCode: '2469', suburb: 'COONGBAR', state: 'NSW' },
  { postCode: '2469', suburb: 'CULMARAN CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'DEEP CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'DRAKE', state: 'NSW' },
  { postCode: '2469', suburb: 'DRAKE VILLAGE', state: 'NSW' },
  { postCode: '2469', suburb: 'DUCK CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'EWINGAR', state: 'NSW' },
  { postCode: '2469', suburb: 'GIBBERAGEE', state: 'NSW' },
  { postCode: '2469', suburb: 'GOODWOOD ISLAND', state: 'NSW' },
  { postCode: '2469', suburb: 'GORGE CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'HAYSTACK', state: 'NSW' },
  { postCode: '2469', suburb: 'HOGARTH RANGE', state: 'NSW' },
  { postCode: '2469', suburb: 'JACKSONS FLAT', state: 'NSW' },
  { postCode: '2469', suburb: 'JOES BOX', state: 'NSW' },
  { postCode: '2469', suburb: 'KEYBARBIN', state: 'NSW' },
  { postCode: '2469', suburb: 'KIPPENDUFF', state: 'NSW' },
  { postCode: '2469', suburb: 'LOUISA CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'LOWER BOTTLE CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'LOWER DUCK CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'LOWER PEACOCK', state: 'NSW' },
  { postCode: '2469', suburb: 'MALLANGANEE', state: 'NSW' },
  { postCode: '2469', suburb: 'MOOKIMA WYBRA', state: 'NSW' },
  { postCode: '2469', suburb: 'MORORO', state: 'NSW' },
  { postCode: '2469', suburb: 'MOUNT MARSH', state: 'NSW' },
  { postCode: '2469', suburb: 'MUMMULGUM', state: 'NSW' },
  { postCode: '2469', suburb: 'MYRTLE CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'OLD BONALBO', state: 'NSW' },
  { postCode: '2469', suburb: 'PADDYS FLAT', state: 'NSW' },
  { postCode: '2469', suburb: 'PAGANS FLAT', state: 'NSW' },
  { postCode: '2469', suburb: 'PEACOCK CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'PIKAPENE', state: 'NSW' },
  { postCode: '2469', suburb: 'RAPPVILLE', state: 'NSW' },
  { postCode: '2469', suburb: 'SANDILANDS', state: 'NSW' },
  { postCode: '2469', suburb: 'SIMPKINS CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'SIX MILE SWAMP', state: 'NSW' },
  { postCode: '2469', suburb: 'TABULAM', state: 'NSW' },
  { postCode: '2469', suburb: 'THERESA CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'TUNGLEBUNG', state: 'NSW' },
  { postCode: '2469', suburb: 'UPPER DUCK CREEK', state: 'NSW' },
  { postCode: '2469', suburb: 'WARREGAH ISLAND', state: 'NSW' },
  { postCode: '2469', suburb: 'WHIPORIE', state: 'NSW' },
  { postCode: '2469', suburb: 'WOOMBAH', state: 'NSW' },
  { postCode: '2469', suburb: 'WYAN', state: 'NSW' },
  { postCode: '2469', suburb: 'YABBRA', state: 'NSW' },
  { postCode: '2470', suburb: 'BABYL CREEK', state: 'NSW' },
  { postCode: '2470', suburb: 'BACKMEDE', state: 'NSW' },
  { postCode: '2470', suburb: 'CASINO', state: 'NSW' },
  { postCode: '2470', suburb: 'COOMBELL', state: 'NSW' },
  { postCode: '2470', suburb: 'DOBIES BIGHT', state: 'NSW' },
  { postCode: '2470', suburb: 'DOUBTFUL CREEK', state: 'NSW' },
  { postCode: '2470', suburb: 'DYRAABA', state: 'NSW' },
  { postCode: '2470', suburb: 'ELLANGOWAN', state: 'NSW' },
  { postCode: '2470', suburb: 'FAIRY HILL', state: 'NSW' },
  { postCode: '2470', suburb: 'IRVINGTON', state: 'NSW' },
  { postCode: '2470', suburb: 'LEEVILLE', state: 'NSW' },
  { postCode: '2470', suburb: 'LOWER DYRAABA', state: 'NSW' },
  { postCode: '2470', suburb: 'MONGOGARIE', state: 'NSW' },
  { postCode: '2470', suburb: 'NAUGHTONS GAP', state: 'NSW' },
  { postCode: '2470', suburb: 'NORTH CASINO', state: 'NSW' },
  { postCode: '2470', suburb: 'PIORA', state: 'NSW' },
  { postCode: '2470', suburb: 'SEXTONVILLE', state: 'NSW' },
  { postCode: '2470', suburb: 'SHANNON BROOK', state: 'NSW' },
  { postCode: '2470', suburb: 'SPRING GROVE', state: 'NSW' },
  { postCode: '2470', suburb: 'STRATHEDEN', state: 'NSW' },
  { postCode: '2470', suburb: 'TOMKI', state: 'NSW' },
  { postCode: '2470', suburb: 'UPPER MONGOGARIE', state: 'NSW' },
  { postCode: '2470', suburb: 'WOODVIEW', state: 'NSW' },
  { postCode: '2470', suburb: 'WOOLNERS ARM', state: 'NSW' },
  { postCode: '2470', suburb: 'YORKLEA', state: 'NSW' },
  { postCode: '2471', suburb: 'BORA RIDGE', state: 'NSW' },
  { postCode: '2471', suburb: 'CODRINGTON', state: 'NSW' },
  { postCode: '2471', suburb: 'CORAKI', state: 'NSW' },
  { postCode: '2471', suburb: 'EAST CORAKI', state: 'NSW' },
  { postCode: '2471', suburb: 'GREEN FOREST', state: 'NSW' },
  { postCode: '2471', suburb: 'GREENRIDGE', state: 'NSW' },
  { postCode: '2471', suburb: 'NORTH WOODBURN', state: 'NSW' },
  { postCode: '2471', suburb: 'SWAN BAY', state: 'NSW' },
  { postCode: '2471', suburb: 'TATHAM', state: 'NSW' },
  { postCode: '2471', suburb: 'WEST BUNGAWALBIN', state: 'NSW' },
  { postCode: '2471', suburb: 'WEST CORAKI', state: 'NSW' },
  { postCode: '2472', suburb: 'BROADWATER', state: 'NSW' },
  { postCode: '2472', suburb: 'BUCKENDOON', state: 'NSW' },
  { postCode: '2472', suburb: 'ESK', state: 'NSW' },
  { postCode: '2472', suburb: 'KILGIN', state: 'NSW' },
  { postCode: '2472', suburb: 'MOONEM', state: 'NSW' },
  { postCode: '2472', suburb: 'NEW ITALY', state: 'NSW' },
  { postCode: '2472', suburb: 'RILEYS HILL', state: 'NSW' },
  { postCode: '2472', suburb: 'TABBIMOBLE', state: 'NSW' },
  { postCode: '2472', suburb: 'THE GAP', state: 'NSW' },
  { postCode: '2472', suburb: 'TRUSTUMS HILL', state: 'NSW' },
  { postCode: '2472', suburb: 'WOODBURN', state: 'NSW' },
  { postCode: '2473', suburb: 'BUNDJALUNG', state: 'NSW' },
  { postCode: '2473', suburb: 'DOONBAH', state: 'NSW' },
  { postCode: '2473', suburb: 'EVANS HEAD', state: 'NSW' },
  { postCode: '2473', suburb: 'IRON GATES', state: 'NSW' },
  { postCode: '2473', suburb: 'SOUTH EVANS HEAD', state: 'NSW' },
  { postCode: '2474', suburb: 'AFTERLEE', state: 'NSW' },
  { postCode: '2474', suburb: 'BARKERS VALE', state: 'NSW' },
  { postCode: '2474', suburb: 'BORDER RANGES', state: 'NSW' },
  { postCode: '2474', suburb: 'CAWONGLA', state: 'NSW' },
  { postCode: '2474', suburb: 'CEDAR POINT', state: 'NSW' },
  { postCode: '2474', suburb: 'COLLINS CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'COUGAL', state: 'NSW' },
  { postCode: '2474', suburb: 'DAIRY FLAT', state: 'NSW' },
  { postCode: '2474', suburb: 'EDEN CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'EDENVILLE', state: 'NSW' },
  { postCode: '2474', suburb: 'ETTRICK', state: 'NSW' },
  { postCode: '2474', suburb: 'FAWCETTS PLAIN', state: 'NSW' },
  { postCode: '2474', suburb: 'FINDON CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'GENEVA', state: 'NSW' },
  { postCode: '2474', suburb: 'GHINNI GHI', state: 'NSW' },
  { postCode: '2474', suburb: 'GRADYS CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'GREEN PIGEON', state: 'NSW' },
  { postCode: '2474', suburb: 'GREVILLIA', state: 'NSW' },
  { postCode: '2474', suburb: 'HOMELEIGH', state: 'NSW' },
  { postCode: '2474', suburb: 'HORSE STATION CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'HORSESHOE CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'IRON POT CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'KILGRA', state: 'NSW' },
  { postCode: '2474', suburb: 'KYOGLE', state: 'NSW' },
  { postCode: '2474', suburb: 'LITTLE BACK CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'LOADSTONE', state: 'NSW' },
  { postCode: '2474', suburb: 'LYNCHS CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'NEW PARK', state: 'NSW' },
  { postCode: '2474', suburb: 'OLD GREVILLIA', state: 'NSW' },
  { postCode: '2474', suburb: 'ROSEBERRY', state: 'NSW' },
  { postCode: '2474', suburb: 'ROSEBERRY CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'RUKENVALE', state: 'NSW' },
  { postCode: '2474', suburb: 'SAWPIT CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'SHERWOOD', state: 'NSW' },
  { postCode: '2474', suburb: 'SMITHS CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'TERRACE CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'THE RISK', state: 'NSW' },
  { postCode: '2474', suburb: 'TOONUMBAR', state: 'NSW' },
  { postCode: '2474', suburb: 'UNUMGAR', state: 'NSW' },
  { postCode: '2474', suburb: 'UPPER EDEN CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'UPPER HORSESHOE CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'WADEVILLE', state: 'NSW' },
  { postCode: '2474', suburb: 'WARRAZAMBIL CREEK', state: 'NSW' },
  { postCode: '2474', suburb: 'WEST WIANGAREE', state: 'NSW' },
  { postCode: '2474', suburb: 'WIANGAREE', state: 'NSW' },
  { postCode: '2474', suburb: 'WYNEDEN', state: 'NSW' },
  { postCode: '2475', suburb: 'TOOLOOM', state: 'NSW' },
  { postCode: '2475', suburb: 'UPPER TOOLOOM', state: 'NSW' },
  { postCode: '2475', suburb: 'URBENVILLE', state: 'NSW' },
  { postCode: '2476', suburb: 'ACACIA CREEK', state: 'NSW' },
  { postCode: '2476', suburb: 'BOOMI CREEK', state: 'NSW' },
  { postCode: '2476', suburb: 'BRUMBY PLAINS', state: 'NSW' },
  { postCode: '2476', suburb: 'KOREELAH', state: 'NSW' },
  { postCode: '2476', suburb: 'LEGUME', state: 'NSW' },
  { postCode: '2476', suburb: 'LINDESAY CREEK', state: 'NSW' },
  { postCode: '2476', suburb: 'LOWER ACACIA CREEK', state: 'NSW' },
  { postCode: '2476', suburb: 'MULI MULI', state: 'NSW' },
  { postCode: '2476', suburb: 'THE GLEN', state: 'NSW' },
  { postCode: '2476', suburb: 'WOODENBONG', state: 'NSW' },
  { postCode: '2477', suburb: 'ALSTONVALE', state: 'NSW' },
  { postCode: '2477', suburb: 'ALSTONVILLE', state: 'NSW' },
  { postCode: '2477', suburb: 'BAGOTVILLE', state: 'NSW' },
  { postCode: '2477', suburb: 'CABBAGE TREE ISLAND', state: 'NSW' },
  { postCode: '2477', suburb: 'DALWOOD', state: 'NSW' },
  { postCode: '2477', suburb: 'EAST WARDELL', state: 'NSW' },
  { postCode: '2477', suburb: 'GOAT ISLAND', state: 'NSW' },
  { postCode: '2477', suburb: 'LYNWOOD', state: 'NSW' },
  { postCode: '2477', suburb: 'MEERSCHAUM VALE', state: 'NSW' },
  { postCode: '2477', suburb: 'PEARCES CREEK', state: 'NSW' },
  { postCode: '2477', suburb: 'ROUS', state: 'NSW' },
  { postCode: '2477', suburb: 'ROUS MILL', state: 'NSW' },
  { postCode: '2477', suburb: 'TUCKOMBIL', state: 'NSW' },
  { postCode: '2477', suburb: 'URALBA', state: 'NSW' },
  { postCode: '2477', suburb: 'WARDELL', state: 'NSW' },
  { postCode: '2477', suburb: 'WOLLONGBAR', state: 'NSW' },
  { postCode: '2478', suburb: 'BALLINA', state: 'NSW' },
  { postCode: '2478', suburb: 'BALLINA DC', state: 'NSW' },
  { postCode: '2478', suburb: 'COOLGARDIE', state: 'NSW' },
  { postCode: '2478', suburb: 'CUMBALUM', state: 'NSW' },
  { postCode: '2478', suburb: 'EAST BALLINA', state: 'NSW' },
  { postCode: '2478', suburb: 'EMPIRE VALE', state: 'NSW' },
  { postCode: '2478', suburb: 'KEITH HALL', state: 'NSW' },
  { postCode: '2478', suburb: 'KINVARA', state: 'NSW' },
  { postCode: '2478', suburb: 'LENNOX HEAD', state: 'NSW' },
  { postCode: '2478', suburb: 'PATCHS BEACH', state: 'NSW' },
  { postCode: '2478', suburb: 'PIMLICO', state: 'NSW' },
  { postCode: '2478', suburb: 'PIMLICO ISLAND', state: 'NSW' },
  { postCode: '2478', suburb: 'SKENNARS HEAD', state: 'NSW' },
  { postCode: '2478', suburb: 'SOUTH BALLINA', state: 'NSW' },
  { postCode: '2478', suburb: 'TEVEN', state: 'NSW' },
  { postCode: '2478', suburb: 'TINTENBAR', state: 'NSW' },
  { postCode: '2478', suburb: 'WEST BALLINA', state: 'NSW' },
  { postCode: '2479', suburb: 'BANGALOW', state: 'NSW' },
  { postCode: '2479', suburb: 'BINNA BURRA', state: 'NSW' },
  { postCode: '2479', suburb: 'BROOKLET', state: 'NSW' },
  { postCode: '2479', suburb: 'COOPERS SHOOT', state: 'NSW' },
  { postCode: '2479', suburb: 'COORABELL', state: 'NSW' },
  { postCode: '2479', suburb: 'FERNLEIGH', state: 'NSW' },
  { postCode: '2479', suburb: 'KNOCKROW', state: 'NSW' },
  { postCode: '2479', suburb: 'MCLEODS SHOOT', state: 'NSW' },
  { postCode: '2479', suburb: 'NASHUA', state: 'NSW' },
  { postCode: '2479', suburb: 'NEWRYBAR', state: 'NSW' },
  { postCode: '2479', suburb: 'POSSUM CREEK', state: 'NSW' },
  { postCode: '2480', suburb: 'BENTLEY', state: 'NSW' },
  { postCode: '2480', suburb: 'BEXHILL', state: 'NSW' },
  { postCode: '2480', suburb: 'BLAKEBROOK', state: 'NSW' },
  { postCode: '2480', suburb: 'BLUE KNOB', state: 'NSW' },
  { postCode: '2480', suburb: 'BOAT HARBOUR', state: 'NSW' },
  { postCode: '2480', suburb: 'BOOERIE CREEK', state: 'NSW' },
  { postCode: '2480', suburb: 'BOORABEE PARK', state: 'NSW' },
  { postCode: '2480', suburb: 'BOOYONG', state: 'NSW' },
  { postCode: '2480', suburb: 'BUNGABBEE', state: 'NSW' },
  { postCode: '2480', suburb: 'CANIABA', state: 'NSW' },
  { postCode: '2480', suburb: 'CHILCOTTS GRASS', state: 'NSW' },
  { postCode: '2480', suburb: 'CLOVASS', state: 'NSW' },
  { postCode: '2480', suburb: 'CLUNES', state: 'NSW' },
  { postCode: '2480', suburb: 'COFFEE CAMP', state: 'NSW' },
  { postCode: '2480', suburb: 'CORNDALE', state: 'NSW' },
  { postCode: '2480', suburb: 'DORROUGHBY', state: 'NSW' },
  { postCode: '2480', suburb: 'DUNGARUBBA', state: 'NSW' },
  { postCode: '2480', suburb: 'DUNOON', state: 'NSW' },
  { postCode: '2480', suburb: 'EAST LISMORE', state: 'NSW' },
  { postCode: '2480', suburb: 'ELTHAM', state: 'NSW' },
  { postCode: '2480', suburb: 'EUREKA', state: 'NSW' },
  { postCode: '2480', suburb: 'FEDERAL', state: 'NSW' },
  { postCode: '2480', suburb: 'FERNSIDE', state: 'NSW' },
  { postCode: '2480', suburb: 'GEORGICA', state: 'NSW' },
  { postCode: '2480', suburb: 'GIRARDS HILL', state: 'NSW' },
  { postCode: '2480', suburb: 'GOOLMANGAR', state: 'NSW' },
  { postCode: '2480', suburb: 'GOONELLABAH', state: 'NSW' },
  { postCode: '2480', suburb: 'HOWARDS GRASS', state: 'NSW' },
  { postCode: '2480', suburb: 'JIGGI', state: 'NSW' },
  { postCode: '2480', suburb: 'KEERRONG', state: 'NSW' },
  { postCode: '2480', suburb: 'KOONORIGAN', state: 'NSW' },
  { postCode: '2480', suburb: 'LAGOON GRASS', state: 'NSW' },
  { postCode: '2480', suburb: 'LARNOOK', state: 'NSW' },
  { postCode: '2480', suburb: 'LEYCESTER', state: 'NSW' },
  { postCode: '2480', suburb: 'LILLIAN ROCK', state: 'NSW' },
  { postCode: '2480', suburb: 'LINDENDALE', state: 'NSW' },
  { postCode: '2480', suburb: 'LISMORE', state: 'NSW' },
  { postCode: '2480', suburb: 'LISMORE DC', state: 'NSW' },
  { postCode: '2480', suburb: 'LISMORE HEIGHTS', state: 'NSW' },
  { postCode: '2480', suburb: 'LOFTVILLE', state: 'NSW' },
  { postCode: '2480', suburb: 'MAROM CREEK', state: 'NSW' },
  { postCode: '2480', suburb: 'MCKEES HILL', state: 'NSW' },
  { postCode: '2480', suburb: 'MCLEANS RIDGES', state: 'NSW' },
  { postCode: '2480', suburb: 'MODANVILLE', state: 'NSW' },
  { postCode: '2480', suburb: 'MONALTRIE', state: 'NSW' },
  { postCode: '2480', suburb: 'MOUNTAIN TOP', state: 'NSW' },
  { postCode: '2480', suburb: 'NIGHTCAP', state: 'NSW' },
  { postCode: '2480', suburb: 'NIMBIN', state: 'NSW' },
  { postCode: '2480', suburb: 'NORTH LISMORE', state: 'NSW' },
  { postCode: '2480', suburb: 'NUMULGI', state: 'NSW' },
  { postCode: '2480', suburb: 'REPENTANCE CREEK', state: 'NSW' },
  { postCode: '2480', suburb: 'RICHMOND HILL', state: 'NSW' },
  { postCode: '2480', suburb: 'ROCK VALLEY', state: 'NSW' },
  { postCode: '2480', suburb: 'ROSEBANK', state: 'NSW' },
  { postCode: '2480', suburb: 'RUTHVEN', state: 'NSW' },
  { postCode: '2480', suburb: 'SOUTH GUNDURIMBA', state: 'NSW' },
  { postCode: '2480', suburb: 'SOUTH LISMORE', state: 'NSW' },
  { postCode: '2480', suburb: 'STONY CHUTE', state: 'NSW' },
  { postCode: '2480', suburb: 'TERANIA CREEK', state: 'NSW' },
  { postCode: '2480', suburb: 'THE CHANNON', state: 'NSW' },
  { postCode: '2480', suburb: 'TREGEAGLE', state: 'NSW' },
  { postCode: '2480', suburb: 'TUCKI TUCKI', state: 'NSW' },
  { postCode: '2480', suburb: 'TUCKURIMBA', state: 'NSW' },
  { postCode: '2480', suburb: 'TULLERA', state: 'NSW' },
  { postCode: '2480', suburb: 'TUNCESTER', state: 'NSW' },
  { postCode: '2480', suburb: 'TUNTABLE CREEK', state: 'NSW' },
  { postCode: '2480', suburb: 'WHIAN WHIAN', state: 'NSW' },
  { postCode: '2480', suburb: 'WOODLAWN', state: 'NSW' },
  { postCode: '2480', suburb: 'WYRALLAH', state: 'NSW' },
  { postCode: '2481', suburb: 'BROKEN HEAD', state: 'NSW' },
  { postCode: '2481', suburb: 'BYRON BAY', state: 'NSW' },
  { postCode: '2481', suburb: 'EWINGSDALE', state: 'NSW' },
  { postCode: '2481', suburb: 'HAYTERS HILL', state: 'NSW' },
  { postCode: '2481', suburb: 'MYOCUM', state: 'NSW' },
  { postCode: '2481', suburb: 'SKINNERS SHOOT', state: 'NSW' },
  { postCode: '2481', suburb: 'SUFFOLK PARK', state: 'NSW' },
  { postCode: '2481', suburb: 'TALOFA', state: 'NSW' },
  { postCode: '2481', suburb: 'TYAGARAH', state: 'NSW' },
  { postCode: '2482', suburb: 'GOONENGERRY', state: 'NSW' },
  { postCode: '2482', suburb: 'HUONBROOK', state: 'NSW' },
  { postCode: '2482', suburb: 'KOONYUM RANGE', state: 'NSW' },
  { postCode: '2482', suburb: 'MAIN ARM', state: 'NSW' },
  { postCode: '2482', suburb: 'MONTECOLLUM', state: 'NSW' },
  { postCode: '2482', suburb: 'MULLUMBIMBY', state: 'NSW' },
  { postCode: '2482', suburb: 'MULLUMBIMBY CREEK', state: 'NSW' },
  { postCode: '2482', suburb: 'PALMWOODS', state: 'NSW' },
  { postCode: '2482', suburb: 'UPPER COOPERS CREEK', state: 'NSW' },
  { postCode: '2482', suburb: 'UPPER MAIN ARM', state: 'NSW' },
  { postCode: '2482', suburb: 'UPPER WILSONS CREEK', state: 'NSW' },
  { postCode: '2482', suburb: 'WANGANUI', state: 'NSW' },
  { postCode: '2482', suburb: 'WILSONS CREEK', state: 'NSW' },
  { postCode: '2483', suburb: 'BILLINUDGEL', state: 'NSW' },
  { postCode: '2483', suburb: 'BRUNSWICK HEADS', state: 'NSW' },
  { postCode: '2483', suburb: 'BURRINGBAR', state: 'NSW' },
  { postCode: '2483', suburb: 'CRABBES CREEK', state: 'NSW' },
  { postCode: '2483', suburb: 'MIDDLE POCKET', state: 'NSW' },
  { postCode: '2483', suburb: 'MOOBALL', state: 'NSW' },
  { postCode: '2483', suburb: 'NEW BRIGHTON', state: 'NSW' },
  { postCode: '2483', suburb: 'OCEAN SHORES', state: 'NSW' },
  { postCode: '2483', suburb: 'SLEEPY HOLLOW', state: 'NSW' },
  { postCode: '2483', suburb: 'SOUTH GOLDEN BEACH', state: 'NSW' },
  { postCode: '2483', suburb: 'THE POCKET', state: 'NSW' },
  { postCode: '2483', suburb: 'UPPER BURRINGBAR', state: 'NSW' },
  { postCode: '2483', suburb: 'WOOYUNG', state: 'NSW' },
  { postCode: '2483', suburb: 'YELGUN', state: 'NSW' },
  { postCode: '2484', suburb: 'BACK CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'BRAY PARK', state: 'NSW' },
  { postCode: '2484', suburb: 'BRAYS CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'BYANGUM', state: 'NSW' },
  { postCode: '2484', suburb: 'BYRRILL CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'CEDAR CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'CHILLINGHAM', state: 'NSW' },
  { postCode: '2484', suburb: 'CHOWAN CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'CLOTHIERS CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'COMMISSIONERS CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'CONDONG', state: 'NSW' },
  { postCode: '2484', suburb: 'CRYSTAL CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'CUDGERA CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'DOON DOON', state: 'NSW' },
  { postCode: '2484', suburb: 'DULGUIGAN', state: 'NSW' },
  { postCode: '2484', suburb: 'DUM DUM', state: 'NSW' },
  { postCode: '2484', suburb: 'DUNBIBLE', state: 'NSW' },
  { postCode: '2484', suburb: 'DUNGAY', state: 'NSW' },
  { postCode: '2484', suburb: 'EUNGELLA', state: 'NSW' },
  { postCode: '2484', suburb: 'EVIRON', state: 'NSW' },
  { postCode: '2484', suburb: 'FARRANTS HILL', state: 'NSW' },
  { postCode: '2484', suburb: 'FERNVALE', state: 'NSW' },
  { postCode: '2484', suburb: 'HOPKINS CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'KIELVALE', state: 'NSW' },
  { postCode: '2484', suburb: 'KUNGHUR', state: 'NSW' },
  { postCode: '2484', suburb: 'KUNGHUR CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'KYNNUMBOON', state: 'NSW' },
  { postCode: '2484', suburb: 'LIMPINWOOD', state: 'NSW' },
  { postCode: '2484', suburb: 'MEBBIN', state: 'NSW' },
  { postCode: '2484', suburb: 'MIDGINBIL', state: 'NSW' },
  { postCode: '2484', suburb: 'MOUNT BURRELL', state: 'NSW' },
  { postCode: '2484', suburb: 'MOUNT WARNING', state: 'NSW' },
  { postCode: '2484', suburb: 'MURWILLUMBAH', state: 'NSW' },
  { postCode: '2484', suburb: 'MURWILLUMBAH DC', state: 'NSW' },
  { postCode: '2484', suburb: 'MURWILLUMBAH SOUTH', state: 'NSW' },
  { postCode: '2484', suburb: 'NOBBYS CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'NORTH ARM', state: 'NSW' },
  { postCode: '2484', suburb: 'NUMINBAH', state: 'NSW' },
  { postCode: '2484', suburb: 'NUNDERI', state: 'NSW' },
  { postCode: '2484', suburb: 'PALMVALE', state: 'NSW' },
  { postCode: '2484', suburb: 'PUMPENBIL', state: 'NSW' },
  { postCode: '2484', suburb: 'RESERVE CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'ROUND MOUNTAIN', state: 'NSW' },
  { postCode: '2484', suburb: 'ROWLANDS CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'SMITHS CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'SOUTH MURWILLUMBAH', state: 'NSW' },
  { postCode: '2484', suburb: 'STOKERS SIDING', state: 'NSW' },
  { postCode: '2484', suburb: 'TERRAGON', state: 'NSW' },
  { postCode: '2484', suburb: 'TOMEWIN', state: 'NSW' },
  { postCode: '2484', suburb: 'TYALGUM', state: 'NSW' },
  { postCode: '2484', suburb: 'TYALGUM CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'TYGALGAH', state: 'NSW' },
  { postCode: '2484', suburb: 'UKI', state: 'NSW' },
  { postCode: '2484', suburb: 'UPPER CRYSTAL CREEK', state: 'NSW' },
  { postCode: '2484', suburb: 'URLIUP', state: 'NSW' },
  { postCode: '2484', suburb: 'WARDROP VALLEY', state: 'NSW' },
  { postCode: '2484', suburb: 'ZARA', state: 'NSW' },
  { postCode: '2485', suburb: 'TWEED HEADS', state: 'NSW' },
  { postCode: '2485', suburb: 'TWEED HEADS WEST', state: 'NSW' },
  { postCode: '2486', suburb: 'BANORA POINT', state: 'NSW' },
  { postCode: '2486', suburb: 'BILAMBIL', state: 'NSW' },
  { postCode: '2486', suburb: 'BILAMBIL HEIGHTS', state: 'NSW' },
  { postCode: '2486', suburb: 'BUNGALORA', state: 'NSW' },
  { postCode: '2486', suburb: 'CAROOL', state: 'NSW' },
  { postCode: '2486', suburb: 'COBAKI', state: 'NSW' },
  { postCode: '2486', suburb: 'COBAKI LAKES', state: 'NSW' },
  { postCode: '2486', suburb: 'DUROBY', state: 'NSW' },
  { postCode: '2486', suburb: 'GLENGARRIE', state: 'NSW' },
  { postCode: '2486', suburb: 'PIGGABEEN', state: 'NSW' },
  { postCode: '2486', suburb: 'TERRANORA', state: 'NSW' },
  { postCode: '2486', suburb: 'TWEED HEADS SOUTH', state: 'NSW' },
  { postCode: '2486', suburb: 'TWEED HEADS SOUTH DC', state: 'NSW' },
  { postCode: '2486', suburb: 'UPPER DUROBY', state: 'NSW' },
  { postCode: '2487', suburb: 'CASUARINA', state: 'NSW' },
  { postCode: '2487', suburb: 'CHINDERAH', state: 'NSW' },
  { postCode: '2487', suburb: 'CUDGEN', state: 'NSW' },
  { postCode: '2487', suburb: 'DURANBAH', state: 'NSW' },
  { postCode: '2487', suburb: 'FINGAL HEAD', state: 'NSW' },
  { postCode: '2487', suburb: 'KINGS FOREST', state: 'NSW' },
  { postCode: '2487', suburb: 'KINGSCLIFF', state: 'NSW' },
  { postCode: '2487', suburb: 'STOTTS CREEK', state: 'NSW' },
  { postCode: '2488', suburb: 'BOGANGAR', state: 'NSW' },
  { postCode: '2488', suburb: 'CABARITA BEACH', state: 'NSW' },
  { postCode: '2488', suburb: 'TANGLEWOOD', state: 'NSW' },
  { postCode: '2489', suburb: 'HASTINGS POINT', state: 'NSW' },
  { postCode: '2489', suburb: 'POTTSVILLE', state: 'NSW' },
  { postCode: '2489', suburb: 'POTTSVILLE BEACH', state: 'NSW' },
  { postCode: '2490', suburb: 'NORTH TUMBULGUM', state: 'NSW' },
  { postCode: '2490', suburb: 'TUMBULGUM', state: 'NSW' },
  { postCode: '2500', suburb: 'CONISTON', state: 'NSW' },
  { postCode: '2500', suburb: 'GWYNNEVILLE', state: 'NSW' },
  { postCode: '2500', suburb: 'KEIRAVILLE', state: 'NSW' },
  { postCode: '2500', suburb: 'MANGERTON', state: 'NSW' },
  { postCode: '2500', suburb: 'MOUNT KEIRA', state: 'NSW' },
  { postCode: '2500', suburb: 'MOUNT SAINT THOMAS', state: 'NSW' },
  { postCode: '2500', suburb: 'NORTH WOLLONGONG', state: 'NSW' },
  { postCode: '2500', suburb: 'SPRING HILL', state: 'NSW' },
  { postCode: '2500', suburb: 'WEST WOLLONGONG', state: 'NSW' },
  { postCode: '2500', suburb: 'WOLLONGONG', state: 'NSW' },
  { postCode: '2500', suburb: 'WOLLONGONG DC', state: 'NSW' },
  { postCode: '2500', suburb: 'WOLLONGONG WEST', state: 'NSW' },
  { postCode: '2502', suburb: 'CRINGILA', state: 'NSW' },
  { postCode: '2502', suburb: 'LAKE HEIGHTS', state: 'NSW' },
  { postCode: '2502', suburb: 'PRIMBEE', state: 'NSW' },
  { postCode: '2502', suburb: 'WARRAWONG', state: 'NSW' },
  { postCode: '2505', suburb: 'PORT KEMBLA', state: 'NSW' },
  { postCode: '2506', suburb: 'BERKELEY', state: 'NSW' },
  { postCode: '2508', suburb: 'COALCLIFF', state: 'NSW' },
  { postCode: '2508', suburb: 'DARKES FOREST', state: 'NSW' },
  { postCode: '2508', suburb: 'HELENSBURGH', state: 'NSW' },
  { postCode: '2508', suburb: 'LILYVALE', state: 'NSW' },
  { postCode: '2508', suburb: 'MADDENS PLAINS', state: 'NSW' },
  { postCode: '2508', suburb: 'OTFORD', state: 'NSW' },
  { postCode: '2508', suburb: 'STANWELL PARK', state: 'NSW' },
  { postCode: '2508', suburb: 'STANWELL TOPS', state: 'NSW' },
  { postCode: '2508', suburb: 'WORONORA DAM', state: 'NSW' },
  { postCode: '2515', suburb: 'AUSTINMER', state: 'NSW' },
  { postCode: '2515', suburb: 'CLIFTON', state: 'NSW' },
  { postCode: '2515', suburb: 'COLEDALE', state: 'NSW' },
  { postCode: '2515', suburb: 'SCARBOROUGH', state: 'NSW' },
  { postCode: '2515', suburb: 'THIRROUL', state: 'NSW' },
  { postCode: '2515', suburb: 'WOMBARRA', state: 'NSW' },
  { postCode: '2516', suburb: 'BULLI', state: 'NSW' },
  { postCode: '2517', suburb: 'RUSSELL VALE', state: 'NSW' },
  { postCode: '2517', suburb: 'WOONONA', state: 'NSW' },
  { postCode: '2517', suburb: 'WOONONA EAST', state: 'NSW' },
  { postCode: '2518', suburb: 'BELLAMBI', state: 'NSW' },
  { postCode: '2518', suburb: 'CORRIMAL', state: 'NSW' },
  { postCode: '2518', suburb: 'CORRIMAL EAST', state: 'NSW' },
  { postCode: '2518', suburb: 'EAST CORRIMAL', state: 'NSW' },
  { postCode: '2518', suburb: 'TARRAWANNA', state: 'NSW' },
  { postCode: '2518', suburb: 'TOWRADGI', state: 'NSW' },
  { postCode: '2519', suburb: 'BALGOWNIE', state: 'NSW' },
  { postCode: '2519', suburb: 'FAIRY MEADOW', state: 'NSW' },
  { postCode: '2519', suburb: 'FERNHILL', state: 'NSW' },
  { postCode: '2519', suburb: 'MOUNT OUSLEY', state: 'NSW' },
  { postCode: '2519', suburb: 'MOUNT PLEASANT', state: 'NSW' },
  { postCode: '2520', suburb: 'WOLLONGONG', state: 'NSW' },
  { postCode: '2522', suburb: 'UNIVERSITY OF WOLLONGONG', state: 'NSW' },
  { postCode: '2525', suburb: 'FIGTREE', state: 'NSW' },
  { postCode: '2526', suburb: 'CORDEAUX', state: 'NSW' },
  { postCode: '2526', suburb: 'CORDEAUX HEIGHTS', state: 'NSW' },
  { postCode: '2526', suburb: 'FARMBOROUGH HEIGHTS', state: 'NSW' },
  { postCode: '2526', suburb: 'KEMBLA GRANGE', state: 'NSW' },
  { postCode: '2526', suburb: 'KEMBLA HEIGHTS', state: 'NSW' },
  { postCode: '2526', suburb: 'MOUNT KEMBLA', state: 'NSW' },
  { postCode: '2526', suburb: 'UNANDERRA', state: 'NSW' },
  { postCode: '2527', suburb: 'ALBION PARK', state: 'NSW' },
  { postCode: '2527', suburb: 'ALBION PARK RAIL', state: 'NSW' },
  { postCode: '2527', suburb: 'CALDERWOOD', state: 'NSW' },
  { postCode: '2527', suburb: 'CROOM', state: 'NSW' },
  { postCode: '2527', suburb: 'NORTH MACQUARIE', state: 'NSW' },
  { postCode: '2527', suburb: 'TONGARRA', state: 'NSW' },
  { postCode: '2527', suburb: 'TULLIMBAR', state: 'NSW' },
  { postCode: '2527', suburb: 'YELLOW ROCK', state: 'NSW' },
  { postCode: '2528', suburb: 'BARRACK HEIGHTS', state: 'NSW' },
  { postCode: '2528', suburb: 'BARRACK POINT', state: 'NSW' },
  { postCode: '2528', suburb: 'LAKE ILLAWARRA', state: 'NSW' },
  { postCode: '2528', suburb: 'MOUNT WARRIGAL', state: 'NSW' },
  { postCode: '2528', suburb: 'WARILLA', state: 'NSW' },
  { postCode: '2528', suburb: 'WINDANG', state: 'NSW' },
  { postCode: '2529', suburb: 'BLACKBUTT', state: 'NSW' },
  { postCode: '2529', suburb: 'DUNMORE', state: 'NSW' },
  { postCode: '2529', suburb: 'FLINDERS', state: 'NSW' },
  { postCode: '2529', suburb: 'OAK FLATS', state: 'NSW' },
  { postCode: '2529', suburb: 'OAK FLATS DC', state: 'NSW' },
  { postCode: '2529', suburb: 'SHELL COVE', state: 'NSW' },
  { postCode: '2529', suburb: 'SHELLHARBOUR', state: 'NSW' },
  { postCode: '2529', suburb: 'SHELLHARBOUR CITY CENTRE', state: 'NSW' },
  { postCode: '2530', suburb: 'AVONDALE', state: 'NSW' },
  { postCode: '2530', suburb: 'BROWNSVILLE', state: 'NSW' },
  { postCode: '2530', suburb: 'CLEVELAND', state: 'NSW' },
  { postCode: '2530', suburb: 'DAPTO', state: 'NSW' },
  { postCode: '2530', suburb: 'DOMBARTON', state: 'NSW' },
  { postCode: '2530', suburb: 'HAYWARDS BAY', state: 'NSW' },
  { postCode: '2530', suburb: 'HORSLEY', state: 'NSW' },
  { postCode: '2530', suburb: 'HUNTLEY', state: 'NSW' },
  { postCode: '2530', suburb: 'KANAHOOKA', state: 'NSW' },
  { postCode: '2530', suburb: 'KOONAWARRA', state: 'NSW' },
  { postCode: '2530', suburb: 'MARSHALL MOUNT', state: 'NSW' },
  { postCode: '2530', suburb: 'WONGAWILLI', state: 'NSW' },
  { postCode: '2530', suburb: 'YALLAH', state: 'NSW' },
  { postCode: '2533', suburb: 'BOMBO', state: 'NSW' },
  { postCode: '2533', suburb: 'CURRAMORE', state: 'NSW' },
  { postCode: '2533', suburb: 'JAMBEROO', state: 'NSW' },
  { postCode: '2533', suburb: 'JERRARA', state: 'NSW' },
  { postCode: '2533', suburb: 'KIAMA', state: 'NSW' },
  { postCode: '2533', suburb: 'KIAMA DOWNS', state: 'NSW' },
  { postCode: '2533', suburb: 'KIAMA HEIGHTS', state: 'NSW' },
  { postCode: '2533', suburb: 'MINNAMURRA', state: 'NSW' },
  { postCode: '2533', suburb: 'SADDLEBACK MOUNTAIN', state: 'NSW' },
  { postCode: '2534', suburb: 'BROUGHTON VILLAGE', state: 'NSW' },
  { postCode: '2534', suburb: 'FOXGROUND', state: 'NSW' },
  { postCode: '2534', suburb: 'GERRINGONG', state: 'NSW' },
  { postCode: '2534', suburb: 'GERROA', state: 'NSW' },
  { postCode: '2534', suburb: 'ROSE VALLEY', state: 'NSW' },
  { postCode: '2534', suburb: 'TOOLIJOOA', state: 'NSW' },
  { postCode: '2534', suburb: 'WERRI BEACH', state: 'NSW' },
  { postCode: '2534', suburb: 'WILLOW VALE', state: 'NSW' },
  { postCode: '2535', suburb: 'BACK FOREST', state: 'NSW' },
  { postCode: '2535', suburb: 'BELLAWONGARAH', state: 'NSW' },
  { postCode: '2535', suburb: 'BERRY', state: 'NSW' },
  { postCode: '2535', suburb: 'BERRY MOUNTAIN', state: 'NSW' },
  { postCode: '2535', suburb: 'BROGERS CREEK', state: 'NSW' },
  { postCode: '2535', suburb: 'BROUGHTON', state: 'NSW' },
  { postCode: '2535', suburb: 'BROUGHTON VALE', state: 'NSW' },
  { postCode: '2535', suburb: 'BUDDEROO', state: 'NSW' },
  { postCode: '2535', suburb: 'BUNDEWALLAH', state: 'NSW' },
  { postCode: '2535', suburb: 'COOLANGATTA', state: 'NSW' },
  { postCode: '2535', suburb: 'FAR MEADOW', state: 'NSW' },
  { postCode: '2535', suburb: 'JASPERS BRUSH', state: 'NSW' },
  { postCode: '2535', suburb: 'SHOALHAVEN HEADS', state: 'NSW' },
  { postCode: '2535', suburb: 'WATTAMOLLA', state: 'NSW' },
  { postCode: '2535', suburb: 'WOODHILL', state: 'NSW' },
  { postCode: '2536', suburb: 'BATEHAVEN', state: 'NSW' },
  { postCode: '2536', suburb: 'BATEMANS BAY', state: 'NSW' },
  { postCode: '2536', suburb: 'BENANDARAH', state: 'NSW' },
  { postCode: '2536', suburb: 'BIMBIMBIE', state: 'NSW' },
  { postCode: '2536', suburb: 'BUCKENBOWRA', state: 'NSW' },
  { postCode: '2536', suburb: 'CATALINA', state: 'NSW' },
  { postCode: '2536', suburb: 'CURROWAN', state: 'NSW' },
  { postCode: '2536', suburb: 'DENHAMS BEACH', state: 'NSW' },
  { postCode: '2536', suburb: 'DEPOT BEACH', state: 'NSW' },
  { postCode: '2536', suburb: 'DURRAS NORTH', state: 'NSW' },
  { postCode: '2536', suburb: 'EAST LYNNE', state: 'NSW' },
  { postCode: '2536', suburb: 'GUERILLA BAY', state: 'NSW' },
  { postCode: '2536', suburb: 'JEREMADRA', state: 'NSW' },
  { postCode: '2536', suburb: 'LILLI PILLI', state: 'NSW' },
  { postCode: '2536', suburb: 'LONG BEACH', state: 'NSW' },
  { postCode: '2536', suburb: 'MALONEYS BEACH', state: 'NSW' },
  { postCode: '2536', suburb: 'MALUA BAY', state: 'NSW' },
  { postCode: '2536', suburb: 'MOGO', state: 'NSW' },
  { postCode: '2536', suburb: 'NELLIGEN', state: 'NSW' },
  { postCode: '2536', suburb: 'NORTH BATEMANS BAY', state: 'NSW' },
  { postCode: '2536', suburb: 'PEBBLY BEACH', state: 'NSW' },
  { postCode: '2536', suburb: 'ROSEDALE', state: 'NSW' },
  { postCode: '2536', suburb: 'RUNNYFORD', state: 'NSW' },
  { postCode: '2536', suburb: 'SOUTH DURRAS', state: 'NSW' },
  { postCode: '2536', suburb: 'SUNSHINE BAY', state: 'NSW' },
  { postCode: '2536', suburb: 'SURF BEACH', state: 'NSW' },
  { postCode: '2536', suburb: 'SURFSIDE', state: 'NSW' },
  { postCode: '2536', suburb: 'WOODLANDS', state: 'NSW' },
  { postCode: '2537', suburb: 'BERGALIA', state: 'NSW' },
  { postCode: '2537', suburb: 'BINGIE', state: 'NSW' },
  { postCode: '2537', suburb: 'BROULEE', state: 'NSW' },
  { postCode: '2537', suburb: 'COILA', state: 'NSW' },
  { postCode: '2537', suburb: 'CONGO', state: 'NSW' },
  { postCode: '2537', suburb: 'DEUA', state: 'NSW' },
  { postCode: '2537', suburb: 'DEUA RIVER VALLEY', state: 'NSW' },
  { postCode: '2537', suburb: 'KIORA', state: 'NSW' },
  { postCode: '2537', suburb: 'MERINGO', state: 'NSW' },
  { postCode: '2537', suburb: 'MOGENDOURA', state: 'NSW' },
  { postCode: '2537', suburb: 'MORUYA', state: 'NSW' },
  { postCode: '2537', suburb: 'MORUYA HEADS', state: 'NSW' },
  { postCode: '2537', suburb: 'MOSSY POINT', state: 'NSW' },
  { postCode: '2537', suburb: 'TOMAKIN', state: 'NSW' },
  { postCode: '2537', suburb: 'TURLINJAH', state: 'NSW' },
  { postCode: '2537', suburb: 'TUROSS HEAD', state: 'NSW' },
  { postCode: '2537', suburb: 'WAMBAN', state: 'NSW' },
  { postCode: '2538', suburb: 'BROOMAN', state: 'NSW' },
  { postCode: '2538', suburb: 'LITTLE FOREST', state: 'NSW' },
  { postCode: '2538', suburb: 'MILTON', state: 'NSW' },
  { postCode: '2538', suburb: 'MOGOOD', state: 'NSW' },
  { postCode: '2538', suburb: 'MORTON', state: 'NSW' },
  { postCode: '2538', suburb: 'PORTERS CREEK', state: 'NSW' },
  { postCode: '2538', suburb: 'WOODBURN', state: 'NSW' },
  { postCode: '2538', suburb: 'WOODSTOCK', state: 'NSW' },
  { postCode: '2539', suburb: 'BAWLEY POINT', state: 'NSW' },
  { postCode: '2539', suburb: 'BENDALONG', state: 'NSW' },
  { postCode: '2539', suburb: 'BERRINGER LAKE', state: 'NSW' },
  { postCode: '2539', suburb: 'BURRILL LAKE', state: 'NSW' },
  { postCode: '2539', suburb: 'COCKWHY', state: 'NSW' },
  { postCode: '2539', suburb: 'CONJOLA', state: 'NSW' },
  { postCode: '2539', suburb: 'CONJOLA PARK', state: 'NSW' },
  { postCode: '2539', suburb: 'CROOBYAR', state: 'NSW' },
  { postCode: '2539', suburb: 'CUNJURONG POINT', state: 'NSW' },
  { postCode: '2539', suburb: 'DOLPHIN POINT', state: 'NSW' },
  { postCode: '2539', suburb: 'FISHERMANS PARADISE', state: 'NSW' },
  { postCode: '2539', suburb: 'KINGS POINT', state: 'NSW' },
  { postCode: '2539', suburb: 'KIOLOA', state: 'NSW' },
  { postCode: '2539', suburb: 'LAKE CONJOLA', state: 'NSW' },
  { postCode: '2539', suburb: 'LAKE TABOURIE', state: 'NSW' },
  { postCode: '2539', suburb: 'MANYANA', state: 'NSW' },
  { postCode: '2539', suburb: 'MOLLYMOOK', state: 'NSW' },
  { postCode: '2539', suburb: 'MOLLYMOOK BEACH', state: 'NSW' },
  { postCode: '2539', suburb: 'MOUNT KINGIMAN', state: 'NSW' },
  { postCode: '2539', suburb: 'NARRAWALLEE', state: 'NSW' },
  { postCode: '2539', suburb: 'POINTER MOUNTAIN', state: 'NSW' },
  { postCode: '2539', suburb: 'PRETTY BEACH', state: 'NSW' },
  { postCode: '2539', suburb: 'TERMEIL', state: 'NSW' },
  { postCode: '2539', suburb: 'ULLADULLA', state: 'NSW' },
  { postCode: '2539', suburb: 'YADBORO', state: 'NSW' },
  { postCode: '2539', suburb: 'YATTE YATTAH', state: 'NSW' },
  { postCode: '2540', suburb: 'BAMARANG', state: 'NSW' },
  { postCode: '2540', suburb: 'BARRINGELLA', state: 'NSW' },
  { postCode: '2540', suburb: 'BASIN VIEW', state: 'NSW' },
  { postCode: '2540', suburb: 'BEECROFT PENINSULA', state: 'NSW' },
  { postCode: '2540', suburb: 'BERRARA', state: 'NSW' },
  { postCode: '2540', suburb: 'BEWONG', state: 'NSW' },
  { postCode: '2540', suburb: 'BOLONG', state: 'NSW' },
  { postCode: '2540', suburb: 'BOOLIJAH', state: 'NSW' },
  { postCode: '2540', suburb: 'BREAM BEACH', state: 'NSW' },
  { postCode: '2540', suburb: 'BROWNS MOUNTAIN', state: 'NSW' },
  { postCode: '2540', suburb: 'BRUNDEE', state: 'NSW' },
  { postCode: '2540', suburb: 'BUANGLA', state: 'NSW' },
  { postCode: '2540', suburb: 'BURRIER', state: 'NSW' },
  { postCode: '2540', suburb: 'CALLALA BAY', state: 'NSW' },
  { postCode: '2540', suburb: 'CALLALA BEACH', state: 'NSW' },
  { postCode: '2540', suburb: 'CAMBEWARRA', state: 'NSW' },
  { postCode: '2540', suburb: 'CAMBEWARRA VILLAGE', state: 'NSW' },
  { postCode: '2540', suburb: 'COMBERTON', state: 'NSW' },
  { postCode: '2540', suburb: 'COMERONG ISLAND', state: 'NSW' },
  { postCode: '2540', suburb: 'CUDMIRRAH', state: 'NSW' },
  { postCode: '2540', suburb: 'CULBURRA BEACH', state: 'NSW' },
  { postCode: '2540', suburb: 'CURRARONG', state: 'NSW' },
  { postCode: '2540', suburb: 'EROWAL BAY', state: 'NSW' },
  { postCode: '2540', suburb: 'ETTREMA', state: 'NSW' },
  { postCode: '2540', suburb: 'FALLS CREEK', state: 'NSW' },
  { postCode: '2540', suburb: 'GREENWELL POINT', state: 'NSW' },
  { postCode: '2540', suburb: 'HMAS ALBATROSS', state: 'NSW' },
  { postCode: '2540', suburb: 'HMAS CRESWELL', state: 'ACT' },
  { postCode: '2540', suburb: 'HUSKISSON', state: 'NSW' },
  { postCode: '2540', suburb: 'HYAMS BEACH', state: 'NSW' },
  { postCode: '2540', suburb: 'ILLAROO', state: 'NSW' },
  { postCode: '2540', suburb: 'JERRAWANGALA', state: 'NSW' },
  { postCode: '2540', suburb: 'JERVIS BAY', state: 'ACT' },
  { postCode: '2540', suburb: 'KINGHORNE', state: 'NSW' },
  { postCode: '2540', suburb: 'LONGREACH', state: 'NSW' },
  { postCode: '2540', suburb: 'MAYFIELD', state: 'NSW' },
  { postCode: '2540', suburb: 'MEROO MEADOW', state: 'NSW' },
  { postCode: '2540', suburb: 'MONDAYONG', state: 'NSW' },
  { postCode: '2540', suburb: 'MOOLLATTOO', state: 'NSW' },
  { postCode: '2540', suburb: 'MUNDAMIA', state: 'NSW' },
  { postCode: '2540', suburb: 'MYOLA', state: 'NSW' },
  { postCode: '2540', suburb: 'NOWRA HILL', state: 'NSW' },
  { postCode: '2540', suburb: 'NOWRA NAVAL PO', state: 'NSW' },
  { postCode: '2540', suburb: 'NUMBAA', state: 'NSW' },
  { postCode: '2540', suburb: 'OLD EROWAL BAY', state: 'NSW' },
  { postCode: '2540', suburb: 'ORIENT POINT', state: 'NSW' },
  { postCode: '2540', suburb: 'PARMA', state: 'NSW' },
  { postCode: '2540', suburb: 'PYREE', state: 'NSW' },
  { postCode: '2540', suburb: 'SANCTUARY POINT', state: 'NSW' },
  { postCode: '2540', suburb: 'ST GEORGES BASIN', state: 'NSW' },
  { postCode: '2540', suburb: 'SUSSEX INLET', state: 'NSW' },
  { postCode: '2540', suburb: 'SWANHAVEN', state: 'NSW' },
  { postCode: '2540', suburb: 'TALLOWAL', state: 'NSW' },
  { postCode: '2540', suburb: 'TAPITALLEE', state: 'NSW' },
  { postCode: '2540', suburb: 'TERARA', state: 'NSW' },
  { postCode: '2540', suburb: 'TOMERONG', state: 'NSW' },
  { postCode: '2540', suburb: 'TULLARWALLA', state: 'NSW' },
  { postCode: '2540', suburb: 'TWELVE MILE PEG', state: 'NSW' },
  { postCode: '2540', suburb: 'VINCENTIA', state: 'NSW' },
  { postCode: '2540', suburb: 'WANDANDIAN', state: 'NSW' },
  { postCode: '2540', suburb: 'WATERSLEIGH', state: 'NSW' },
  { postCode: '2540', suburb: 'WOLLUMBOOLA', state: 'NSW' },
  { postCode: '2540', suburb: 'WOOLLAMIA', state: 'NSW' },
  { postCode: '2540', suburb: 'WORRIGEE', state: 'NSW' },
  { postCode: '2540', suburb: 'WORROWING HEIGHTS', state: 'NSW' },
  { postCode: '2540', suburb: 'WRECK BAY', state: 'ACT' },
  { postCode: '2540', suburb: 'WRIGHTS BEACH', state: 'NSW' },
  { postCode: '2540', suburb: 'YALWAL', state: 'NSW' },
  { postCode: '2540', suburb: 'YERRIYONG', state: 'NSW' },
  { postCode: '2541', suburb: 'BANGALEE', state: 'NSW' },
  { postCode: '2541', suburb: 'BOMADERRY', state: 'NSW' },
  { postCode: '2541', suburb: 'NORTH NOWRA', state: 'NSW' },
  { postCode: '2541', suburb: 'NOWRA', state: 'NSW' },
  { postCode: '2541', suburb: 'NOWRA DC', state: 'NSW' },
  { postCode: '2541', suburb: 'NOWRA EAST', state: 'NSW' },
  { postCode: '2541', suburb: 'SOUTH NOWRA', state: 'NSW' },
  { postCode: '2541', suburb: 'WEST NOWRA', state: 'NSW' },
  { postCode: '2545', suburb: 'BELOWRA', state: 'NSW' },
  { postCode: '2545', suburb: 'BODALLA', state: 'NSW' },
  { postCode: '2545', suburb: 'CADGEE', state: 'NSW' },
  { postCode: '2545', suburb: 'EUROBODALLA', state: 'NSW' },
  { postCode: '2545', suburb: 'NERRIGUNDAH', state: 'NSW' },
  { postCode: '2545', suburb: 'POTATO POINT', state: 'NSW' },
  { postCode: '2546', suburb: 'AKOLELE', state: 'NSW' },
  { postCode: '2546', suburb: 'BARRAGGA BAY', state: 'NSW' },
  { postCode: '2546', suburb: 'BERMAGUI', state: 'NSW' },
  { postCode: '2546', suburb: 'CENTRAL TILBA', state: 'NSW' },
  { postCode: '2546', suburb: 'CORUNNA', state: 'NSW' },
  { postCode: '2546', suburb: 'CUTTAGEE', state: 'NSW' },
  { postCode: '2546', suburb: 'DALMENY', state: 'NSW' },
  { postCode: '2546', suburb: 'DIGNAMS CREEK', state: 'NSW' },
  { postCode: '2546', suburb: 'KIANGA', state: 'NSW' },
  { postCode: '2546', suburb: 'MURRAH', state: 'NSW' },
  { postCode: '2546', suburb: 'MYSTERY BAY', state: 'NSW' },
  { postCode: '2546', suburb: 'NAROOMA', state: 'NSW' },
  { postCode: '2546', suburb: 'NORTH NAROOMA', state: 'NSW' },
  { postCode: '2546', suburb: 'TILBA TILBA', state: 'NSW' },
  { postCode: '2546', suburb: 'TINPOT', state: 'NSW' },
  { postCode: '2546', suburb: 'WADBILLIGA', state: 'NSW' },
  { postCode: '2546', suburb: 'WALLAGA LAKE', state: 'NSW' },
  { postCode: '2548', suburb: 'BERRAMBOOL', state: 'NSW' },
  { postCode: '2548', suburb: 'BOURNDA', state: 'NSW' },
  { postCode: '2548', suburb: 'MERIMBULA', state: 'NSW' },
  { postCode: '2548', suburb: 'MIRADOR', state: 'NSW' },
  { postCode: '2548', suburb: 'TURA BEACH', state: 'NSW' },
  { postCode: '2548', suburb: 'YELLOW PINCH', state: 'NSW' },
  { postCode: '2549', suburb: 'BALD HILLS', state: 'NSW' },
  { postCode: '2549', suburb: 'BROADWATER', state: 'NSW' },
  { postCode: '2549', suburb: 'GREIGS FLAT', state: 'NSW' },
  { postCode: '2549', suburb: 'LOCHIEL', state: 'NSW' },
  { postCode: '2549', suburb: 'MILLINGANDI', state: 'NSW' },
  { postCode: '2549', suburb: 'NETHERCOTE', state: 'NSW' },
  { postCode: '2549', suburb: 'PAMBULA', state: 'NSW' },
  { postCode: '2549', suburb: 'PAMBULA BEACH', state: 'NSW' },
  { postCode: '2549', suburb: 'SOUTH PAMBULA', state: 'NSW' },
  { postCode: '2550', suburb: 'ANGLEDALE', state: 'NSW' },
  { postCode: '2550', suburb: 'BEGA', state: 'NSW' },
  { postCode: '2550', suburb: 'BEMBOKA', state: 'NSW' },
  { postCode: '2550', suburb: 'BLACK RANGE', state: 'NSW' },
  { postCode: '2550', suburb: 'BROGO', state: 'NSW' },
  { postCode: '2550', suburb: 'BUCKAJO', state: 'NSW' },
  { postCode: '2550', suburb: 'BURRAGATE', state: 'NSW' },
  { postCode: '2550', suburb: 'CANDELO', state: 'NSW' },
  { postCode: '2550', suburb: 'CHINNOCK', state: 'NSW' },
  { postCode: '2550', suburb: 'COBARGO', state: 'NSW' },
  { postCode: '2550', suburb: 'COOLAGOLITE', state: 'NSW' },
  { postCode: '2550', suburb: 'COOLANGUBRA', state: 'NSW' },
  { postCode: '2550', suburb: 'COOPERS GULLY', state: 'NSW' },
  { postCode: '2550', suburb: 'DEVILS HOLE', state: 'NSW' },
  { postCode: '2550', suburb: 'DOCTOR GEORGE MOUNTAIN', state: 'NSW' },
  { postCode: '2550', suburb: 'FROGS HOLLOW', state: 'NSW' },
  { postCode: '2550', suburb: 'GREENDALE', state: 'NSW' },
  { postCode: '2550', suburb: 'JELLAT JELLAT', state: 'NSW' },
  { postCode: '2550', suburb: 'KALARU', state: 'NSW' },
  { postCode: '2550', suburb: 'KAMERUKA', state: 'NSW' },
  { postCode: '2550', suburb: 'KANOONA', state: 'NSW' },
  { postCode: '2550', suburb: 'KINGSWOOD', state: 'NSW' },
  { postCode: '2550', suburb: 'MOGAREEKA', state: 'NSW' },
  { postCode: '2550', suburb: 'MOGILLA', state: 'NSW' },
  { postCode: '2550', suburb: 'MORANS CROSSING', state: 'NSW' },
  { postCode: '2550', suburb: 'MUMBULLA MOUNTAIN', state: 'NSW' },
  { postCode: '2550', suburb: 'MYRTLE MOUNTAIN', state: 'NSW' },
  { postCode: '2550', suburb: 'NELSON', state: 'NSW' },
  { postCode: '2550', suburb: 'NEW BUILDINGS', state: 'NSW' },
  { postCode: '2550', suburb: 'NUMBUGGA', state: 'NSW' },
  { postCode: '2550', suburb: 'PERICOE', state: 'NSW' },
  { postCode: '2550', suburb: 'QUAAMA', state: 'NSW' },
  { postCode: '2550', suburb: 'REEDY SWAMP', state: 'NSW' },
  { postCode: '2550', suburb: 'ROCKY HALL', state: 'NSW' },
  { postCode: '2550', suburb: 'SOUTH WOLUMLA', state: 'NSW' },
  { postCode: '2550', suburb: 'STONY CREEK', state: 'NSW' },
  { postCode: '2550', suburb: 'TANJA', state: 'NSW' },
  { postCode: '2550', suburb: 'TANTAWANGALO', state: 'NSW' },
  { postCode: '2550', suburb: 'TARRAGANDA', state: 'NSW' },
  { postCode: '2550', suburb: 'TATHRA', state: 'NSW' },
  { postCode: '2550', suburb: 'TOOTHDALE', state: 'NSW' },
  { postCode: '2550', suburb: 'TOWAMBA', state: 'NSW' },
  { postCode: '2550', suburb: 'VERONA', state: 'NSW' },
  { postCode: '2550', suburb: 'WALLAGOOT', state: 'NSW' },
  { postCode: '2550', suburb: 'WANDELLA', state: 'NSW' },
  { postCode: '2550', suburb: 'WAPENGO', state: 'NSW' },
  { postCode: '2550', suburb: 'WOG WOG', state: 'NSW' },
  { postCode: '2550', suburb: 'WOLUMLA', state: 'NSW' },
  { postCode: '2550', suburb: 'WYNDHAM', state: 'NSW' },
  { postCode: '2550', suburb: 'YAMBULLA', state: 'NSW' },
  { postCode: '2550', suburb: 'YANKEES CREEK', state: 'NSW' },
  { postCode: '2550', suburb: 'YOWRIE', state: 'NSW' },
  { postCode: '2551', suburb: 'BOYDTOWN', state: 'NSW' },
  { postCode: '2551', suburb: 'EDEN', state: 'NSW' },
  { postCode: '2551', suburb: 'EDROM', state: 'NSW' },
  { postCode: '2551', suburb: 'GREEN CAPE', state: 'NSW' },
  { postCode: '2551', suburb: 'KIAH', state: 'NSW' },
  { postCode: '2551', suburb: 'NADGEE', state: 'NSW' },
  { postCode: '2551', suburb: 'NARRABARBA', state: 'NSW' },
  { postCode: '2551', suburb: 'NULLICA', state: 'NSW' },
  { postCode: '2551', suburb: 'NUNGATTA', state: 'NSW' },
  { postCode: '2551', suburb: 'NUNGATTA SOUTH', state: 'NSW' },
  { postCode: '2551', suburb: 'TIMBILLICA', state: 'NSW' },
  { postCode: '2551', suburb: 'WONBOYN', state: 'NSW' },
  { postCode: '2551', suburb: 'WONBOYN LAKE', state: 'NSW' },
  { postCode: '2551', suburb: 'WONBOYN NORTH', state: 'NSW' },
  { postCode: '2555', suburb: 'BADGERYS CREEK', state: 'NSW' },
  { postCode: '2556', suburb: 'BRINGELLY', state: 'NSW' },
  { postCode: '2557', suburb: 'CATHERINE FIELD', state: 'NSW' },
  { postCode: '2557', suburb: 'GLEDSWOOD HILLS', state: 'NSW' },
  { postCode: '2557', suburb: 'GREGORY HILLS', state: 'NSW' },
  { postCode: '2557', suburb: 'ROSSMORE', state: 'NSW' },
  { postCode: '2558', suburb: 'EAGLE VALE', state: 'NSW' },
  { postCode: '2558', suburb: 'ESCHOL PARK', state: 'NSW' },
  { postCode: '2558', suburb: 'KEARNS', state: 'NSW' },
  { postCode: '2559', suburb: 'BLAIRMOUNT', state: 'NSW' },
  { postCode: '2559', suburb: 'CLAYMORE', state: 'NSW' },
  { postCode: '2560', suburb: 'AIRDS', state: 'NSW' },
  { postCode: '2560', suburb: 'AMBARVALE', state: 'NSW' },
  { postCode: '2560', suburb: 'APPIN', state: 'NSW' },
  { postCode: '2560', suburb: 'BLAIR ATHOL', state: 'NSW' },
  { postCode: '2560', suburb: 'BRADBURY', state: 'NSW' },
  { postCode: '2560', suburb: 'CAMPBELLTOWN', state: 'NSW' },
  { postCode: '2560', suburb: 'CAMPBELLTOWN NORTH', state: 'NSW' },
  { postCode: '2560', suburb: 'CATARACT', state: 'NSW' },
  { postCode: '2560', suburb: 'ENGLORIE PARK', state: 'NSW' },
  { postCode: '2560', suburb: 'GILEAD', state: 'NSW' },
  { postCode: '2560', suburb: 'GLEN ALPINE', state: 'NSW' },
  { postCode: '2560', suburb: 'KENTLYN', state: 'NSW' },
  { postCode: '2560', suburb: 'LEUMEAH', state: 'NSW' },
  { postCode: '2560', suburb: 'MACARTHUR SQUARE', state: 'NSW' },
  { postCode: '2560', suburb: 'ROSEMEADOW', state: 'NSW' },
  { postCode: '2560', suburb: 'RUSE', state: 'NSW' },
  { postCode: '2560', suburb: 'ST HELENS PARK', state: 'NSW' },
  { postCode: '2560', suburb: 'WEDDERBURN', state: 'NSW' },
  { postCode: '2560', suburb: 'WOODBINE', state: 'NSW' },
  { postCode: '2563', suburb: 'MENANGLE PARK', state: 'NSW' },
  { postCode: '2564', suburb: 'GLENQUARIE', state: 'NSW' },
  { postCode: '2564', suburb: 'LONG POINT', state: 'NSW' },
  { postCode: '2564', suburb: 'MACQUARIE FIELDS', state: 'NSW' },
  { postCode: '2565', suburb: 'BARDIA', state: 'NSW' },
  { postCode: '2565', suburb: 'DENHAM COURT', state: 'NSW' },
  { postCode: '2565', suburb: 'INGLEBURN', state: 'NSW' },
  { postCode: '2565', suburb: 'MACQUARIE LINKS', state: 'NSW' },
  { postCode: '2566', suburb: 'BOW BOWING', state: 'NSW' },
  { postCode: '2566', suburb: 'MINTO', state: 'NSW' },
  { postCode: '2566', suburb: 'MINTO DC', state: 'NSW' },
  { postCode: '2566', suburb: 'MINTO HEIGHTS', state: 'NSW' },
  { postCode: '2566', suburb: 'RABY', state: 'NSW' },
  { postCode: '2566', suburb: 'ST ANDREWS', state: 'NSW' },
  { postCode: '2566', suburb: 'VARROVILLE', state: 'NSW' },
  { postCode: '2567', suburb: 'CURRANS HILL', state: 'NSW' },
  { postCode: '2567', suburb: 'HARRINGTON PARK', state: 'NSW' },
  { postCode: '2567', suburb: 'MOUNT ANNAN', state: 'NSW' },
  { postCode: '2567', suburb: 'NARELLAN', state: 'NSW' },
  { postCode: '2567', suburb: 'NARELLAN DC', state: 'NSW' },
  { postCode: '2567', suburb: 'NARELLAN VALE', state: 'NSW' },
  { postCode: '2567', suburb: 'SMEATON GRANGE', state: 'NSW' },
  { postCode: '2568', suburb: 'MENANGLE', state: 'NSW' },
  { postCode: '2569', suburb: 'DOUGLAS PARK', state: 'NSW' },
  { postCode: '2570', suburb: 'BELIMBLA PARK', state: 'NSW' },
  { postCode: '2570', suburb: 'BICKLEY VALE', state: 'NSW' },
  { postCode: '2570', suburb: 'BROWNLOW HILL', state: 'NSW' },
  { postCode: '2570', suburb: 'CAMDEN', state: 'NSW' },
  { postCode: '2570', suburb: 'CAMDEN PARK', state: 'NSW' },
  { postCode: '2570', suburb: 'CAMDEN SOUTH', state: 'NSW' },
  { postCode: '2570', suburb: 'CAWDOR', state: 'NSW' },
  { postCode: '2570', suburb: 'COBBITTY', state: 'NSW' },
  { postCode: '2570', suburb: 'ELDERSLIE', state: 'NSW' },
  { postCode: '2570', suburb: 'ELLIS LANE', state: 'NSW' },
  { postCode: '2570', suburb: 'GLENMORE', state: 'NSW' },
  { postCode: '2570', suburb: 'GRASMERE', state: 'NSW' },
  { postCode: '2570', suburb: 'KIRKHAM', state: 'NSW' },
  { postCode: '2570', suburb: 'MOUNT HUNTER', state: 'NSW' },
  { postCode: '2570', suburb: 'NATTAI', state: 'NSW' },
  { postCode: '2570', suburb: 'OAKDALE', state: 'NSW' },
  { postCode: '2570', suburb: 'ORAN PARK', state: 'NSW' },
  { postCode: '2570', suburb: 'ORANGEVILLE', state: 'NSW' },
  { postCode: '2570', suburb: 'SPRING FARM', state: 'NSW' },
  { postCode: '2570', suburb: 'THE OAKS', state: 'NSW' },
  { postCode: '2570', suburb: 'THERESA PARK', state: 'NSW' },
  { postCode: '2570', suburb: 'WEROMBI', state: 'NSW' },
  { postCode: '2571', suburb: 'BALMORAL', state: 'NSW' },
  { postCode: '2571', suburb: 'BUXTON', state: 'NSW' },
  { postCode: '2571', suburb: 'COURIDJAH', state: 'NSW' },
  { postCode: '2571', suburb: 'MALDON', state: 'NSW' },
  { postCode: '2571', suburb: 'MOWBRAY PARK', state: 'NSW' },
  { postCode: '2571', suburb: 'PICTON', state: 'NSW' },
  { postCode: '2571', suburb: 'RAZORBACK', state: 'NSW' },
  { postCode: '2571', suburb: 'WILTON', state: 'NSW' },
  { postCode: '2572', suburb: 'LAKESLAND', state: 'NSW' },
  { postCode: '2572', suburb: 'THIRLMERE', state: 'NSW' },
  { postCode: '2573', suburb: 'TAHMOOR', state: 'NSW' },
  { postCode: '2574', suburb: 'AVON', state: 'NSW' },
  { postCode: '2574', suburb: 'BARGO', state: 'NSW' },
  { postCode: '2574', suburb: 'PHEASANTS NEST', state: 'NSW' },
  { postCode: '2574', suburb: 'YANDERRA', state: 'NSW' },
  { postCode: '2575', suburb: 'ALPINE', state: 'NSW' },
  { postCode: '2575', suburb: 'AYLMERTON', state: 'NSW' },
  { postCode: '2575', suburb: 'BALACLAVA', state: 'NSW' },
  { postCode: '2575', suburb: 'BRAEMAR', state: 'NSW' },
  { postCode: '2575', suburb: 'BULLIO', state: 'NSW' },
  { postCode: '2575', suburb: 'COLO VALE', state: 'NSW' },
  { postCode: '2575', suburb: 'GOODMANS FORD', state: 'NSW' },
  { postCode: '2575', suburb: 'HIGH RANGE', state: 'NSW' },
  { postCode: '2575', suburb: 'HILL TOP', state: 'NSW' },
  { postCode: '2575', suburb: 'JOADJA', state: 'NSW' },
  { postCode: '2575', suburb: 'MANDEMAR', state: 'NSW' },
  { postCode: '2575', suburb: 'MITTAGONG', state: 'NSW' },
  { postCode: '2575', suburb: 'MOUNT LINDSEY', state: 'NSW' },
  { postCode: '2575', suburb: 'RENWICK', state: 'NSW' },
  { postCode: '2575', suburb: 'WATTLE RIDGE', state: 'NSW' },
  { postCode: '2575', suburb: 'WELBY', state: 'NSW' },
  { postCode: '2575', suburb: 'WILLOW VALE', state: 'NSW' },
  { postCode: '2575', suburb: 'WOODLANDS', state: 'NSW' },
  { postCode: '2575', suburb: 'YERRINBOOL', state: 'NSW' },
  { postCode: '2576', suburb: 'BOWRAL', state: 'NSW' },
  { postCode: '2576', suburb: 'BURRADOO', state: 'NSW' },
  { postCode: '2576', suburb: 'EAST BOWRAL', state: 'NSW' },
  { postCode: '2576', suburb: 'EAST KANGALOON', state: 'NSW' },
  { postCode: '2576', suburb: 'GLENQUARRY', state: 'NSW' },
  { postCode: '2576', suburb: 'KANGALOON', state: 'NSW' },
  { postCode: '2577', suburb: 'AVOCA', state: 'NSW' },
  { postCode: '2577', suburb: 'BARREN GROUNDS', state: 'NSW' },
  { postCode: '2577', suburb: 'BARRENGARRY', state: 'NSW' },
  { postCode: '2577', suburb: 'BEAUMONT', state: 'NSW' },
  { postCode: '2577', suburb: 'BELANGLO', state: 'NSW' },
  { postCode: '2577', suburb: 'BERRIMA', state: 'NSW' },
  { postCode: '2577', suburb: 'BUDGONG', state: 'NSW' },
  { postCode: '2577', suburb: 'BURRAWANG', state: 'NSW' },
  { postCode: '2577', suburb: 'CANYONLEIGH', state: 'NSW' },
  { postCode: '2577', suburb: 'CARRINGTON FALLS', state: 'NSW' },
  { postCode: '2577', suburb: 'FITZROY FALLS', state: 'NSW' },
  { postCode: '2577', suburb: 'KANGAROO VALLEY', state: 'NSW' },
  { postCode: '2577', suburb: 'KNIGHTS HILL', state: 'NSW' },
  { postCode: '2577', suburb: 'MACQUARIE PASS', state: 'NSW' },
  { postCode: '2577', suburb: 'MANCHESTER SQUARE', state: 'NSW' },
  { postCode: '2577', suburb: 'MEDWAY', state: 'NSW' },
  { postCode: '2577', suburb: 'MERYLA', state: 'NSW' },
  { postCode: '2577', suburb: 'MOSS VALE', state: 'NSW' },
  { postCode: '2577', suburb: 'MOUNT MURRAY', state: 'NSW' },
  { postCode: '2577', suburb: 'NEW BERRIMA', state: 'NSW' },
  { postCode: '2577', suburb: 'PADDYS RIVER', state: 'NSW' },
  { postCode: '2577', suburb: 'RED ROCKS', state: 'NSW' },
  { postCode: '2577', suburb: 'ROBERTSON', state: 'NSW' },
  { postCode: '2577', suburb: 'SUTTON FOREST', state: 'NSW' },
  { postCode: '2577', suburb: 'UPPER KANGAROO RIVER', state: 'NSW' },
  { postCode: '2577', suburb: 'UPPER KANGAROO VALLEY', state: 'NSW' },
  { postCode: '2577', suburb: 'WERAI', state: 'NSW' },
  { postCode: '2577', suburb: 'WILDES MEADOW', state: 'NSW' },
  { postCode: '2578', suburb: 'BUNDANOON', state: 'NSW' },
  { postCode: '2579', suburb: 'BIG HILL', state: 'NSW' },
  { postCode: '2579', suburb: 'BRAYTON', state: 'NSW' },
  { postCode: '2579', suburb: 'EXETER', state: 'NSW' },
  { postCode: '2579', suburb: 'MARULAN', state: 'NSW' },
  { postCode: '2579', suburb: 'PENROSE', state: 'NSW' },
  { postCode: '2579', suburb: 'TALLONG', state: 'NSW' },
  { postCode: '2579', suburb: 'WINGELLO', state: 'NSW' },
  { postCode: '2580', suburb: 'BANNABY', state: 'NSW' },
  { postCode: '2580', suburb: 'BANNISTER', state: 'NSW' },
  { postCode: '2580', suburb: 'BAW BAW', state: 'NSW' },
  { postCode: '2580', suburb: 'BOXERS CREEK', state: 'NSW' },
  { postCode: '2580', suburb: 'BRISBANE GROVE', state: 'NSW' },
  { postCode: '2580', suburb: 'BUNGONIA', state: 'NSW' },
  { postCode: '2580', suburb: 'CARRICK', state: 'NSW' },
  { postCode: '2580', suburb: 'CHATSBURY', state: 'NSW' },
  { postCode: '2580', suburb: 'CURRAWANG', state: 'NSW' },
  { postCode: '2580', suburb: 'CURRAWEELA', state: 'NSW' },
  { postCode: '2580', suburb: 'GOLSPIE', state: 'NSW' },
  { postCode: '2580', suburb: 'GOULBURN', state: 'NSW' },
  { postCode: '2580', suburb: 'GOULBURN DC', state: 'NSW' },
  { postCode: '2580', suburb: 'GOULBURN NORTH', state: 'NSW' },
  { postCode: '2580', suburb: 'GREENWICH PARK', state: 'NSW' },
  { postCode: '2580', suburb: 'GUNDARY', state: 'NSW' },
  { postCode: '2580', suburb: 'JERRONG', state: 'NSW' },
  { postCode: '2580', suburb: 'KINGSDALE', state: 'NSW' },
  { postCode: '2580', suburb: 'LAKE BATHURST', state: 'NSW' },
  { postCode: '2580', suburb: 'LOWER BORO', state: 'NSW' },
  { postCode: '2580', suburb: 'MAYFIELD', state: 'NSW' },
  { postCode: '2580', suburb: 'MIDDLE ARM', state: 'NSW' },
  { postCode: '2580', suburb: 'MOUNT FAIRY', state: 'NSW' },
  { postCode: '2580', suburb: 'MUMMEL', state: 'NSW' },
  { postCode: '2580', suburb: 'MYRTLEVILLE', state: 'NSW' },
  { postCode: '2580', suburb: 'PALING YARDS', state: 'NSW' },
  { postCode: '2580', suburb: 'PARKESBOURNE', state: 'NSW' },
  { postCode: '2580', suburb: 'POMEROY', state: 'NSW' },
  { postCode: '2580', suburb: 'QUIALIGO', state: 'NSW' },
  { postCode: '2580', suburb: 'RICHLANDS', state: 'NSW' },
  { postCode: '2580', suburb: 'ROSLYN', state: 'NSW' },
  { postCode: '2580', suburb: 'RUN-O-WATERS', state: 'NSW' },
  { postCode: '2580', suburb: 'STONEQUARRY', state: 'NSW' },
  { postCode: '2580', suburb: 'TARAGO', state: 'NSW' },
  { postCode: '2580', suburb: 'TARALGA', state: 'NSW' },
  { postCode: '2580', suburb: 'TARLO', state: 'NSW' },
  { postCode: '2580', suburb: 'TIRRANNAVILLE', state: 'NSW' },
  { postCode: '2580', suburb: 'TOWRANG', state: 'NSW' },
  { postCode: '2580', suburb: 'WAYO', state: 'NSW' },
  { postCode: '2580', suburb: 'WIARBOROUGH', state: 'NSW' },
  { postCode: '2580', suburb: 'WINDELLAMA', state: 'NSW' },
  { postCode: '2580', suburb: 'WOMBEYAN CAVES', state: 'NSW' },
  { postCode: '2580', suburb: 'WOODHOUSELEE', state: 'NSW' },
  { postCode: '2580', suburb: 'YALBRAITH', state: 'NSW' },
  { postCode: '2580', suburb: 'YARRA', state: 'NSW' },
  { postCode: '2581', suburb: 'BELLMOUNT FOREST', state: 'NSW' },
  { postCode: '2581', suburb: 'BEVENDALE', state: 'NSW' },
  { postCode: '2581', suburb: 'BIALA', state: 'NSW' },
  { postCode: '2581', suburb: 'BLAKNEY CREEK', state: 'NSW' },
  { postCode: '2581', suburb: 'BREADALBANE', state: 'NSW' },
  { postCode: '2581', suburb: 'BROADWAY', state: 'NSW' },
  { postCode: '2581', suburb: 'COLLECTOR', state: 'NSW' },
  { postCode: '2581', suburb: 'CULLERIN', state: 'NSW' },
  { postCode: '2581', suburb: 'DALTON', state: 'NSW' },
  { postCode: '2581', suburb: 'GUNNING', state: 'NSW' },
  { postCode: '2581', suburb: 'GURRUNDAH', state: 'NSW' },
  { postCode: '2581', suburb: 'LADE VALE', state: 'NSW' },
  { postCode: '2581', suburb: 'LAKE GEORGE', state: 'NSW' },
  { postCode: '2581', suburb: 'LERIDA', state: 'NSW' },
  { postCode: '2581', suburb: 'MERRILL', state: 'NSW' },
  { postCode: '2581', suburb: 'OOLONG', state: 'NSW' },
  { postCode: '2581', suburb: 'WOLLOGORANG', state: 'NSW' },
  { postCode: '2582', suburb: 'BANGO', state: 'NSW' },
  { postCode: '2582', suburb: 'BERREMANGRA', state: 'NSW' },
  { postCode: '2582', suburb: 'BOAMBOLO', state: 'NSW' },
  { postCode: '2582', suburb: 'BOOKHAM', state: 'NSW' },
  { postCode: '2582', suburb: 'BOWNING', state: 'NSW' },
  { postCode: '2582', suburb: 'BURRINJUCK', state: 'NSW' },
  { postCode: '2582', suburb: 'CAVAN', state: 'NSW' },
  { postCode: '2582', suburb: 'GOOD HOPE', state: 'NSW' },
  { postCode: '2582', suburb: 'JEIR', state: 'NSW' },
  { postCode: '2582', suburb: 'JERRAWA', state: 'NSW' },
  { postCode: '2582', suburb: 'KANGIARA', state: 'NSW' },
  { postCode: '2582', suburb: 'LAVERSTOCK', state: 'NSW' },
  { postCode: '2582', suburb: 'MANTON', state: 'NSW' },
  { postCode: '2582', suburb: 'MARCHMONT', state: 'NSW' },
  { postCode: '2582', suburb: 'MULLION', state: 'NSW' },
  { postCode: '2582', suburb: 'MURRUMBATEMAN', state: 'NSW' },
  { postCode: '2582', suburb: 'NANIMA', state: 'NSW' },
  { postCode: '2582', suburb: 'NARRANGULLEN', state: 'NSW' },
  { postCode: '2582', suburb: 'WEE JASPER', state: 'NSW' },
  { postCode: '2582', suburb: 'WOOLGARLO', state: 'NSW' },
  { postCode: '2582', suburb: 'YASS', state: 'NSW' },
  { postCode: '2582', suburb: 'YASS RIVER', state: 'NSW' },
  { postCode: '2583', suburb: 'BIGGA', state: 'NSW' },
  { postCode: '2583', suburb: 'BINDA', state: 'NSW' },
  { postCode: '2583', suburb: 'CROOKED CORNER', state: 'NSW' },
  { postCode: '2583', suburb: 'CROOKWELL', state: 'NSW' },
  { postCode: '2583', suburb: 'FULLERTON', state: 'NSW' },
  { postCode: '2583', suburb: 'GRABBEN GULLEN', state: 'NSW' },
  { postCode: '2583', suburb: 'LAGGAN', state: 'NSW' },
  { postCode: '2583', suburb: 'LIMERICK', state: 'NSW' },
  { postCode: '2583', suburb: 'LOST RIVER', state: 'NSW' },
  { postCode: '2583', suburb: 'NARRAWA', state: 'NSW' },
  { postCode: '2583', suburb: 'PEELWOOD', state: 'NSW' },
  { postCode: '2583', suburb: 'PEJAR', state: 'NSW' },
  { postCode: '2583', suburb: 'RUGBY', state: 'NSW' },
  { postCode: '2583', suburb: 'TUENA', state: 'NSW' },
  { postCode: '2583', suburb: 'WHEEO', state: 'NSW' },
  { postCode: '2584', suburb: 'BINALONG', state: 'NSW' },
  { postCode: '2585', suburb: 'GALONG', state: 'NSW' },
  { postCode: '2586', suburb: 'BOOROWA', state: 'NSW' },
  { postCode: '2586', suburb: 'FROGMORE', state: 'NSW' },
  { postCode: '2586', suburb: 'GODFREYS CREEK', state: 'NSW' },
  { postCode: '2586', suburb: 'MURRINGO', state: 'NSW' },
  { postCode: '2586', suburb: 'REIDS FLAT', state: 'NSW' },
  { postCode: '2586', suburb: 'RYE PARK', state: 'NSW' },
  { postCode: '2586', suburb: 'TAYLORS FLAT', state: 'NSW' },
  { postCode: '2587', suburb: 'BEGGAN BEGGAN', state: 'NSW' },
  { postCode: '2587', suburb: 'CUNNINGAR', state: 'NSW' },
  { postCode: '2587', suburb: 'HARDEN', state: 'NSW' },
  { postCode: '2587', suburb: 'KINGSVALE', state: 'NSW' },
  { postCode: '2587', suburb: 'MCMAHONS REEF', state: 'NSW' },
  { postCode: '2587', suburb: 'MURRUMBURRAH', state: 'NSW' },
  { postCode: '2587', suburb: 'NUBBA', state: 'NSW' },
  { postCode: '2587', suburb: 'WOMBAT', state: 'NSW' },
  { postCode: '2588', suburb: 'WALLENDBEEN', state: 'NSW' },
  { postCode: '2590', suburb: 'BETHUNGRA', state: 'NSW' },
  { postCode: '2590', suburb: 'COOTAMUNDRA', state: 'NSW' },
  { postCode: '2590', suburb: 'ILLABO', state: 'NSW' },
  { postCode: '2594', suburb: 'BARWANG', state: 'NSW' },
  { postCode: '2594', suburb: 'BERTHONG', state: 'NSW' },
  { postCode: '2594', suburb: 'BRIBBAREE', state: 'NSW' },
  { postCode: '2594', suburb: 'BULLA CREEK', state: 'NSW' },
  { postCode: '2594', suburb: 'BURRANGONG', state: 'NSW' },
  { postCode: '2594', suburb: 'KIKIAMAH', state: 'NSW' },
  { postCode: '2594', suburb: 'MAIMURU', state: 'NSW' },
  { postCode: '2594', suburb: 'MEMAGONG', state: 'NSW' },
  { postCode: '2594', suburb: 'MILVALE', state: 'NSW' },
  { postCode: '2594', suburb: 'MONTEAGLE', state: 'NSW' },
  { postCode: '2594', suburb: 'THUDDUNGRA', state: 'NSW' },
  { postCode: '2594', suburb: 'TUBBUL', state: 'NSW' },
  { postCode: '2594', suburb: 'WEEDALLION', state: 'NSW' },
  { postCode: '2594', suburb: 'YOUNG', state: 'NSW' },
  { postCode: '2600', suburb: 'BARTON', state: 'ACT' },
  { postCode: '2600', suburb: 'CANBERRA', state: 'ACT' },
  { postCode: '2600', suburb: 'CAPITAL HILL', state: 'ACT' },
  { postCode: '2600', suburb: 'DEAKIN', state: 'ACT' },
  { postCode: '2600', suburb: 'DEAKIN WEST', state: 'ACT' },
  { postCode: '2600', suburb: 'HARMAN', state: 'ACT' },
  { postCode: '2600', suburb: 'HMAS HARMAN', state: 'ACT' },
  { postCode: '2600', suburb: 'PARKES', state: 'ACT' },
  { postCode: '2600', suburb: 'RUSSELL', state: 'ACT' },
  { postCode: '2600', suburb: 'YARRALUMLA', state: 'ACT' },
  { postCode: '2601', suburb: 'ACTON', state: 'ACT' },
  { postCode: '2601', suburb: 'CANBERRA', state: 'ACT' },
  { postCode: '2601', suburb: 'CITY', state: 'ACT' },
  { postCode: '2602', suburb: 'AINSLIE', state: 'ACT' },
  { postCode: '2602', suburb: 'DICKSON', state: 'ACT' },
  { postCode: '2602', suburb: 'DOWNER', state: 'ACT' },
  { postCode: '2602', suburb: 'HACKETT', state: 'ACT' },
  { postCode: '2602', suburb: 'LYNEHAM', state: 'ACT' },
  { postCode: '2602', suburb: "O'CONNOR", state: 'ACT' },
  { postCode: '2602', suburb: 'WATSON', state: 'ACT' },
  { postCode: '2603', suburb: 'FORREST', state: 'ACT' },
  { postCode: '2603', suburb: 'GRIFFITH', state: 'ACT' },
  { postCode: '2603', suburb: 'MANUKA', state: 'ACT' },
  { postCode: '2603', suburb: 'RED HILL', state: 'ACT' },
  { postCode: '2604', suburb: 'CAUSEWAY', state: 'ACT' },
  { postCode: '2604', suburb: 'KINGSTON', state: 'ACT' },
  { postCode: '2604', suburb: 'NARRABUNDAH', state: 'ACT' },
  { postCode: '2605', suburb: 'CURTIN', state: 'ACT' },
  { postCode: '2605', suburb: 'GARRAN', state: 'ACT' },
  { postCode: '2605', suburb: 'HUGHES', state: 'ACT' },
  { postCode: '2606', suburb: 'CHIFLEY', state: 'ACT' },
  { postCode: '2606', suburb: 'LYONS', state: 'ACT' },
  { postCode: '2606', suburb: "O'MALLEY", state: 'ACT' },
  { postCode: '2606', suburb: 'PHILLIP', state: 'ACT' },
  { postCode: '2606', suburb: 'WODEN', state: 'ACT' },
  { postCode: '2607', suburb: 'FARRER', state: 'ACT' },
  { postCode: '2607', suburb: 'ISAACS', state: 'ACT' },
  { postCode: '2607', suburb: 'MAWSON', state: 'ACT' },
  { postCode: '2607', suburb: 'PEARCE', state: 'ACT' },
  { postCode: '2607', suburb: 'TORRENS', state: 'ACT' },
  { postCode: '2608', suburb: 'CIVIC SQUARE', state: 'ACT' },
  { postCode: '2609', suburb: 'CANBERRA AIRPORT', state: 'ACT' },
  { postCode: '2609', suburb: 'FYSHWICK', state: 'ACT' },
  { postCode: '2609', suburb: 'MAJURA', state: 'ACT' },
  { postCode: '2609', suburb: 'PIALLIGO', state: 'ACT' },
  { postCode: '2609', suburb: 'SYMONSTON', state: 'ACT' },
  { postCode: '2610', suburb: 'CANBERRA BC', state: 'ACT' },
  { postCode: '2610', suburb: 'CANBERRA MC', state: 'ACT' },
  { postCode: '2611', suburb: 'BIMBERI', state: 'NSW' },
  { postCode: '2611', suburb: 'BRINDABELLA', state: 'NSW' },
  { postCode: '2611', suburb: 'CHAPMAN', state: 'ACT' },
  { postCode: '2611', suburb: 'COOLEMAN', state: 'NSW' },
  { postCode: '2611', suburb: 'COOMBS', state: 'ACT' },
  { postCode: '2611', suburb: 'COREE', state: 'ACT' },
  { postCode: '2611', suburb: 'DENMAN PROSPECT', state: 'ACT' },
  { postCode: '2611', suburb: 'DUFFY', state: 'ACT' },
  { postCode: '2611', suburb: 'FISHER', state: 'ACT' },
  { postCode: '2611', suburb: 'HOLDER', state: 'ACT' },
  { postCode: '2611', suburb: 'RIVETT', state: 'ACT' },
  { postCode: '2611', suburb: 'STIRLING', state: 'ACT' },
  { postCode: '2611', suburb: 'STROMLO', state: 'ACT' },
  { postCode: '2611', suburb: 'URIARRA', state: 'NSW' },
  { postCode: '2611', suburb: 'URIARRA VILLAGE', state: 'ACT' },
  { postCode: '2611', suburb: 'WARAMANGA', state: 'ACT' },
  { postCode: '2611', suburb: 'WESTON', state: 'ACT' },
  { postCode: '2611', suburb: 'WESTON CREEK', state: 'ACT' },
  { postCode: '2611', suburb: 'WRIGHT', state: 'ACT' },
  { postCode: '2612', suburb: 'BRADDON', state: 'ACT' },
  { postCode: '2612', suburb: 'CAMPBELL', state: 'ACT' },
  { postCode: '2612', suburb: 'REID', state: 'ACT' },
  { postCode: '2612', suburb: 'TURNER', state: 'ACT' },
  { postCode: '2614', suburb: 'ARANDA', state: 'ACT' },
  { postCode: '2614', suburb: 'COOK', state: 'ACT' },
  { postCode: '2614', suburb: 'HAWKER', state: 'ACT' },
  { postCode: '2614', suburb: 'JAMISON CENTRE', state: 'ACT' },
  { postCode: '2614', suburb: 'MACQUARIE', state: 'ACT' },
  { postCode: '2614', suburb: 'PAGE', state: 'ACT' },
  { postCode: '2614', suburb: 'SCULLIN', state: 'ACT' },
  { postCode: '2614', suburb: 'WEETANGERA', state: 'ACT' },
  { postCode: '2615', suburb: 'CHARNWOOD', state: 'ACT' },
  { postCode: '2615', suburb: 'DUNLOP', state: 'ACT' },
  { postCode: '2615', suburb: 'FLOREY', state: 'ACT' },
  { postCode: '2615', suburb: 'FLYNN', state: 'ACT' },
  { postCode: '2615', suburb: 'FRASER', state: 'ACT' },
  { postCode: '2615', suburb: 'HIGGINS', state: 'ACT' },
  { postCode: '2615', suburb: 'HOLT', state: 'ACT' },
  { postCode: '2615', suburb: 'KIPPAX', state: 'ACT' },
  { postCode: '2615', suburb: 'LATHAM', state: 'ACT' },
  { postCode: '2615', suburb: 'MACGREGOR', state: 'ACT' },
  { postCode: '2615', suburb: 'MACNAMARA', state: 'ACT' },
  { postCode: '2615', suburb: 'MELBA', state: 'ACT' },
  { postCode: '2615', suburb: 'SPENCE', state: 'ACT' },
  { postCode: '2615', suburb: 'STRATHNAIRN', state: 'ACT' },
  { postCode: '2615', suburb: 'WHITLAM', state: 'ACT' },
  { postCode: '2616', suburb: 'BELCONNEN', state: 'ACT' },
  { postCode: '2617', suburb: 'BELCONNEN', state: 'ACT' },
  { postCode: '2617', suburb: 'BELCONNEN DC', state: 'ACT' },
  { postCode: '2617', suburb: 'BRUCE', state: 'ACT' },
  { postCode: '2617', suburb: 'EVATT', state: 'ACT' },
  { postCode: '2617', suburb: 'GIRALANG', state: 'ACT' },
  { postCode: '2617', suburb: 'KALEEN', state: 'ACT' },
  { postCode: '2617', suburb: 'LAWSON', state: 'ACT' },
  { postCode: '2617', suburb: 'MCKELLAR', state: 'ACT' },
  { postCode: '2617', suburb: 'UNIVERSITY OF CANBERRA', state: 'ACT' },
  { postCode: '2618', suburb: 'HALL', state: 'ACT' },
  { postCode: '2618', suburb: 'SPRINGRANGE', state: 'NSW' },
  { postCode: '2618', suburb: 'WALLAROO', state: 'NSW' },
  { postCode: '2619', suburb: 'JERRABOMBERRA', state: 'NSW' },
  { postCode: '2620', suburb: 'BEARD', state: 'ACT' },
  { postCode: '2620', suburb: 'BURRA', state: 'NSW' },
  { postCode: '2620', suburb: 'CARWOOLA', state: 'NSW' },
  { postCode: '2620', suburb: 'CLEAR RANGE', state: 'NSW' },
  { postCode: '2620', suburb: 'CRESTWOOD', state: 'NSW' },
  { postCode: '2620', suburb: 'ENVIRONA', state: 'NSW' },
  { postCode: '2620', suburb: 'GOOGONG', state: 'NSW' },
  { postCode: '2620', suburb: 'GREENLEIGH', state: 'NSW' },
  { postCode: '2620', suburb: 'GUNDAROO', state: 'NSW' },
  { postCode: '2620', suburb: 'HUME', state: 'ACT' },
  { postCode: '2620', suburb: 'KARABAR', state: 'NSW' },
  { postCode: '2620', suburb: 'KOWEN', state: 'ACT' },
  { postCode: '2620', suburb: 'MICHELAGO', state: 'NSW' },
  { postCode: '2620', suburb: 'OAKS ESTATE', state: 'ACT' },
  { postCode: '2620', suburb: 'PADDYS RIVER', state: 'ACT' },
  { postCode: '2620', suburb: 'QUEANBEYAN', state: 'NSW' },
  { postCode: '2620', suburb: 'QUEANBEYAN DC', state: 'NSW' },
  { postCode: '2620', suburb: 'QUEANBEYAN EAST', state: 'NSW' },
  { postCode: '2620', suburb: 'QUEANBEYAN WEST', state: 'NSW' },
  { postCode: '2620', suburb: 'ROYALLA', state: 'NSW' },
  { postCode: '2620', suburb: 'SUTTON', state: 'NSW' },
  { postCode: '2620', suburb: 'THARWA', state: 'ACT' },
  { postCode: '2620', suburb: 'THE ANGLE', state: 'NSW' },
  { postCode: '2620', suburb: 'THE RIDGEWAY', state: 'NSW' },
  { postCode: '2620', suburb: 'TINDERRY', state: 'NSW' },
  { postCode: '2620', suburb: 'TRALEE', state: 'NSW' },
  { postCode: '2620', suburb: 'URILA', state: 'NSW' },
  { postCode: '2620', suburb: 'WAMBOIN', state: 'NSW' },
  { postCode: '2620', suburb: 'WILLIAMSDALE', state: 'ACT' },
  { postCode: '2620', suburb: 'WILLIAMSDALE', state: 'NSW' },
  { postCode: '2620', suburb: 'YARROW', state: 'NSW' },
  { postCode: '2621', suburb: 'ANEMBO', state: 'NSW' },
  { postCode: '2621', suburb: 'BUNGENDORE', state: 'NSW' },
  { postCode: '2621', suburb: 'BYWONG', state: 'NSW' },
  { postCode: '2621', suburb: 'FORBES CREEK', state: 'NSW' },
  { postCode: '2621', suburb: 'HOSKINSTOWN', state: 'NSW' },
  { postCode: '2621', suburb: 'PRIMROSE VALLEY', state: 'NSW' },
  { postCode: '2621', suburb: 'ROSSI', state: 'NSW' },
  { postCode: '2622', suburb: 'ARALUEN', state: 'NSW' },
  { postCode: '2622', suburb: 'BACK CREEK', state: 'NSW' },
  { postCode: '2622', suburb: 'BALLALABA', state: 'NSW' },
  { postCode: '2622', suburb: 'BENDOURA', state: 'NSW' },
  { postCode: '2622', suburb: 'BERLANG', state: 'NSW' },
  { postCode: '2622', suburb: 'BOMBAY', state: 'NSW' },
  { postCode: '2622', suburb: 'BORO', state: 'NSW' },
  { postCode: '2622', suburb: 'BRAIDWOOD', state: 'NSW' },
  { postCode: '2622', suburb: 'BUDAWANG', state: 'NSW' },
  { postCode: '2622', suburb: 'BULEE', state: 'NSW' },
  { postCode: '2622', suburb: 'CHARLEYS FOREST', state: 'NSW' },
  { postCode: '2622', suburb: 'COOLUMBURRA', state: 'NSW' },
  { postCode: '2622', suburb: 'CORANG', state: 'NSW' },
  { postCode: '2622', suburb: 'DURRAN DURRA', state: 'NSW' },
  { postCode: '2622', suburb: 'ENDRICK', state: 'NSW' },
  { postCode: '2622', suburb: 'FARRINGDON', state: 'NSW' },
  { postCode: '2622', suburb: 'HAROLDS CROSS', state: 'NSW' },
  { postCode: '2622', suburb: 'HEREFORD HALL', state: 'NSW' },
  { postCode: '2622', suburb: 'JEMBAICUMBENE', state: 'NSW' },
  { postCode: '2622', suburb: 'JERRABATTGULLA', state: 'NSW' },
  { postCode: '2622', suburb: 'JINDEN', state: 'NSW' },
  { postCode: '2622', suburb: 'JINGERA', state: 'NSW' },
  { postCode: '2622', suburb: 'KINDERVALE', state: 'NSW' },
  { postCode: '2622', suburb: 'KRAWARREE', state: 'NSW' },
  { postCode: '2622', suburb: 'LARBERT', state: 'NSW' },
  { postCode: '2622', suburb: 'MAJORS CREEK', state: 'NSW' },
  { postCode: '2622', suburb: 'MANAR', state: 'NSW' },
  { postCode: '2622', suburb: 'MARLOWE', state: 'NSW' },
  { postCode: '2622', suburb: 'MERRICUMBENE', state: 'NSW' },
  { postCode: '2622', suburb: 'MONGA', state: 'NSW' },
  { postCode: '2622', suburb: 'MONGARLOWE', state: 'NSW' },
  { postCode: '2622', suburb: 'MULLOON', state: 'NSW' },
  { postCode: '2622', suburb: 'MURRENGENBURG', state: 'NSW' },
  { postCode: '2622', suburb: 'NERINGLA', state: 'NSW' },
  { postCode: '2622', suburb: 'NERRIGA', state: 'NSW' },
  { postCode: '2622', suburb: 'NORTHANGERA', state: 'NSW' },
  { postCode: '2622', suburb: 'OALLEN', state: 'NSW' },
  { postCode: '2622', suburb: 'PALERANG', state: 'NSW' },
  { postCode: '2622', suburb: 'QUIERA', state: 'NSW' },
  { postCode: '2622', suburb: 'REIDSDALE', state: 'NSW' },
  { postCode: '2622', suburb: 'SASSAFRAS', state: 'NSW' },
  { postCode: '2622', suburb: 'SNOWBALL', state: 'NSW' },
  { postCode: '2622', suburb: 'ST GEORGE', state: 'NSW' },
  { postCode: '2622', suburb: 'TIANJARA', state: 'NSW' },
  { postCode: '2622', suburb: 'TOLWONG', state: 'NSW' },
  { postCode: '2622', suburb: 'TOMBOYE', state: 'NSW' },
  { postCode: '2622', suburb: 'TOUGA', state: 'NSW' },
  { postCode: '2622', suburb: 'WARRI', state: 'NSW' },
  { postCode: '2622', suburb: 'WOG WOG', state: 'NSW' },
  { postCode: '2622', suburb: 'WYANBENE', state: 'NSW' },
  { postCode: '2623', suburb: 'CAPTAINS FLAT', state: 'NSW' },
  { postCode: '2624', suburb: 'BLUE COW', state: 'NSW' },
  { postCode: '2624', suburb: 'CHARLOTTE PASS', state: 'NSW' },
  { postCode: '2624', suburb: 'GUTHEGA', state: 'NSW' },
  { postCode: '2624', suburb: 'MUNYANG', state: 'NSW' },
  { postCode: '2624', suburb: 'PERISHER VALLEY', state: 'NSW' },
  { postCode: '2624', suburb: 'SMIGGIN HOLES', state: 'NSW' },
  { postCode: '2624', suburb: 'WILSONS VALLEY', state: 'NSW' },
  { postCode: '2625', suburb: 'THREDBO', state: 'NSW' },
  { postCode: '2626', suburb: 'BREDBO', state: 'NSW' },
  { postCode: '2626', suburb: 'BUMBALONG', state: 'NSW' },
  { postCode: '2626', suburb: 'COLINTON', state: 'NSW' },
  { postCode: '2627', suburb: 'BULLOCKS FLAT', state: 'NSW' },
  { postCode: '2627', suburb: 'BURRUNGUBUGGE', state: 'NSW' },
  { postCode: '2627', suburb: 'CRACKENBACK', state: 'NSW' },
  { postCode: '2627', suburb: 'CREEL BAY', state: 'NSW' },
  { postCode: '2627', suburb: 'EAST JINDABYNE', state: 'NSW' },
  { postCode: '2627', suburb: 'GROSSES PLAIN', state: 'NSW' },
  { postCode: '2627', suburb: 'INGEBIRAH', state: 'NSW' },
  { postCode: '2627', suburb: 'INGEEGOODBEE', state: 'NSW' },
  { postCode: '2627', suburb: 'JACOBS RIVER', state: 'NSW' },
  { postCode: '2627', suburb: 'JINDABYNE', state: 'NSW' },
  { postCode: '2627', suburb: 'KALKITE', state: 'NSW' },
  { postCode: '2627', suburb: 'KOSCIUSZKO', state: 'NSW' },
  { postCode: '2627', suburb: 'KOSCIUSZKO NATIONAL PARK', state: 'NSW' },
  { postCode: '2627', suburb: 'MOONBAH', state: 'NSW' },
  { postCode: '2627', suburb: 'NGARIGO', state: 'NSW' },
  { postCode: '2627', suburb: 'PILOT WILDERNESS', state: 'NSW' },
  { postCode: '2628', suburb: 'AVONSIDE', state: 'NSW' },
  { postCode: '2628', suburb: 'BELOKA', state: 'NSW' },
  { postCode: '2628', suburb: 'BERRIDALE', state: 'NSW' },
  { postCode: '2628', suburb: 'BRAEMAR BAY', state: 'NSW' },
  { postCode: '2628', suburb: 'BYADBO WILDERNESS', state: 'NSW' },
  { postCode: '2628', suburb: 'COOTRALANTRA', state: 'NSW' },
  { postCode: '2628', suburb: 'DALGETY', state: 'NSW' },
  { postCode: '2628', suburb: 'EUCUMBENE', state: 'NSW' },
  { postCode: '2628', suburb: 'HILL TOP', state: 'NSW' },
  { postCode: '2628', suburb: 'JIMENBUEN', state: 'NSW' },
  { postCode: '2628', suburb: 'NIMMO', state: 'NSW' },
  { postCode: '2628', suburb: 'NUMBLA VALE', state: 'NSW' },
  { postCode: '2628', suburb: 'PAUPONG', state: 'NSW' },
  { postCode: '2628', suburb: 'ROCKY PLAIN', state: 'NSW' },
  { postCode: '2628', suburb: 'SNOWY PLAIN', state: 'NSW' },
  { postCode: '2629', suburb: 'ADAMINABY', state: 'NSW' },
  { postCode: '2629', suburb: 'ANGLERS REACH', state: 'NSW' },
  { postCode: '2629', suburb: 'BOLARO', state: 'NSW' },
  { postCode: '2629', suburb: 'BROKEN DAM', state: 'NSW' },
  { postCode: '2629', suburb: 'CABRAMURRA', state: 'NSW' },
  { postCode: '2629', suburb: 'GOOANDRA', state: 'NSW' },
  { postCode: '2629', suburb: 'KIANDRA', state: 'NSW' },
  { postCode: '2629', suburb: 'LONG PLAIN', state: 'NSW' },
  { postCode: '2629', suburb: 'NUNGAR', state: 'NSW' },
  { postCode: '2629', suburb: 'OLD ADAMINABY', state: 'NSW' },
  { postCode: '2629', suburb: 'PROVIDENCE PORTAL', state: 'NSW' },
  { postCode: '2629', suburb: 'TANTANGARA', state: 'NSW' },
  { postCode: '2629', suburb: 'TOLBAR', state: 'NSW' },
  { postCode: '2629', suburb: 'YAOUK', state: 'NSW' },
  { postCode: '2630', suburb: 'ARABLE', state: 'NSW' },
  { postCode: '2630', suburb: 'BADJA', state: 'NSW' },
  { postCode: '2630', suburb: 'BILLILINGRA', state: 'NSW' },
  { postCode: '2630', suburb: 'BINJURA', state: 'NSW' },
  { postCode: '2630', suburb: 'BOBUNDARA', state: 'NSW' },
  { postCode: '2630', suburb: 'BUCKENDERRA', state: 'NSW' },
  { postCode: '2630', suburb: 'BUNGARBY', state: 'NSW' },
  { postCode: '2630', suburb: 'BUNYAN', state: 'NSW' },
  { postCode: '2630', suburb: 'CARLAMINDA', state: 'NSW' },
  { postCode: '2630', suburb: 'CHAKOLA', state: 'NSW' },
  { postCode: '2630', suburb: 'COOLRINGDON', state: 'NSW' },
  { postCode: '2630', suburb: 'COOMA', state: 'NSW' },
  { postCode: '2630', suburb: 'COUNTEGANY', state: 'NSW' },
  { postCode: '2630', suburb: 'DAIRYMANS PLAINS', state: 'NSW' },
  { postCode: '2630', suburb: 'DANGELONG', state: 'NSW' },
  { postCode: '2630', suburb: 'DRY PLAIN', state: 'NSW' },
  { postCode: '2630', suburb: 'FRYING PAN', state: 'NSW' },
  { postCode: '2630', suburb: 'GLEN FERGUS', state: 'NSW' },
  { postCode: '2630', suburb: 'IRONMUNGY', state: 'NSW' },
  { postCode: '2630', suburb: 'JERANGLE', state: 'NSW' },
  { postCode: '2630', suburb: 'MAFFRA', state: 'NSW' },
  { postCode: '2630', suburb: 'MIDDLE FLAT', state: 'NSW' },
  { postCode: '2630', suburb: 'MIDDLINGBANK', state: 'NSW' },
  { postCode: '2630', suburb: 'MURRUMBUCCA', state: 'NSW' },
  { postCode: '2630', suburb: 'MYALLA', state: 'NSW' },
  { postCode: '2630', suburb: 'NUMERALLA', state: 'NSW' },
  { postCode: '2630', suburb: 'PEAK VIEW', state: 'NSW' },
  { postCode: '2630', suburb: 'PINE VALLEY', state: 'NSW' },
  { postCode: '2630', suburb: 'POLO FLAT', state: 'NSW' },
  { postCode: '2630', suburb: 'RHINE FALLS', state: 'NSW' },
  { postCode: '2630', suburb: 'ROCK FLAT', state: 'NSW' },
  { postCode: '2630', suburb: 'ROSE VALLEY', state: 'NSW' },
  { postCode: '2630', suburb: 'SHANNONS FLAT', state: 'NSW' },
  { postCode: '2630', suburb: 'SPRINGFIELD', state: 'NSW' },
  { postCode: '2630', suburb: 'THE BROTHERS', state: 'NSW' },
  { postCode: '2630', suburb: 'TUROSS', state: 'NSW' },
  { postCode: '2630', suburb: 'WAMBROOK', state: 'NSW' },
  { postCode: '2631', suburb: 'ANDO', state: 'NSW' },
  { postCode: '2631', suburb: 'BOCO', state: 'NSW' },
  { postCode: '2631', suburb: 'CREEWAH', state: 'NSW' },
  { postCode: '2631', suburb: 'GLEN ALLEN', state: 'NSW' },
  { postCode: '2631', suburb: 'GREENLANDS', state: 'NSW' },
  { postCode: '2631', suburb: 'HOLTS FLAT', state: 'NSW' },
  { postCode: '2631', suburb: 'JINCUMBILLY', state: 'NSW' },
  { postCode: '2631', suburb: 'KYBEYAN', state: 'NSW' },
  { postCode: '2631', suburb: 'MOUNT COOPER', state: 'NSW' },
  { postCode: '2631', suburb: 'NIMMITABEL', state: 'NSW' },
  { postCode: '2631', suburb: 'STEEPLE FLAT', state: 'NSW' },
  { postCode: '2631', suburb: 'WINIFRED', state: 'NSW' },
  { postCode: '2632', suburb: 'BIBBENLUKE', state: 'NSW' },
  { postCode: '2632', suburb: 'BOMBALA', state: 'NSW' },
  { postCode: '2632', suburb: 'BONDI FOREST', state: 'NSW' },
  { postCode: '2632', suburb: 'BUKALONG', state: 'NSW' },
  { postCode: '2632', suburb: 'CAMBALONG', state: 'NSW' },
  { postCode: '2632', suburb: 'CATHCART', state: 'NSW' },
  { postCode: '2632', suburb: 'COOLUMBOOKA', state: 'NSW' },
  { postCode: '2632', suburb: 'CRAIGIE', state: 'NSW' },
  { postCode: '2632', suburb: 'GUNNINGRAH', state: 'NSW' },
  { postCode: '2632', suburb: 'LORDS HILL', state: 'NSW' },
  { postCode: '2632', suburb: 'MERRIANGAAH', state: 'NSW' },
  { postCode: '2632', suburb: 'MILA', state: 'NSW' },
  { postCode: '2632', suburb: 'MOUNT DARRAGH', state: 'NSW' },
  { postCode: '2632', suburb: 'PADDYS FLAT', state: 'NSW' },
  { postCode: '2632', suburb: 'PALARANG', state: 'NSW' },
  { postCode: '2632', suburb: 'QUIDONG', state: 'NSW' },
  { postCode: '2632', suburb: 'ROCKTON', state: 'NSW' },
  { postCode: '2632', suburb: 'ROSEMEATH', state: 'NSW' },
  { postCode: '2633', suburb: 'CORROWONG', state: 'NSW' },
  { postCode: '2633', suburb: 'DELEGATE', state: 'NSW' },
  { postCode: '2633', suburb: 'TOMBONG', state: 'NSW' },
  { postCode: '2640', suburb: 'ALBURY', state: 'NSW' },
  { postCode: '2640', suburb: 'BUNGOWANNAH', state: 'NSW' },
  { postCode: '2640', suburb: 'EAST ALBURY', state: 'NSW' },
  { postCode: '2640', suburb: 'ETTAMOGAH', state: 'NSW' },
  { postCode: '2640', suburb: 'GLENROY', state: 'NSW' },
  { postCode: '2640', suburb: 'LAVINGTON DC', state: 'NSW' },
  { postCode: '2640', suburb: 'MOORWATHA', state: 'NSW' },
  { postCode: '2640', suburb: 'NORTH ALBURY', state: 'NSW' },
  { postCode: '2640', suburb: 'OURNIE', state: 'NSW' },
  { postCode: '2640', suburb: 'SOUTH ALBURY', state: 'NSW' },
  { postCode: '2640', suburb: 'SPLITTERS CREEK', state: 'NSW' },
  { postCode: '2640', suburb: 'TABLE TOP', state: 'NSW' },
  { postCode: '2640', suburb: 'TALMALMO', state: 'NSW' },
  { postCode: '2640', suburb: 'THURGOONA', state: 'NSW' },
  { postCode: '2640', suburb: 'WEST ALBURY', state: 'NSW' },
  { postCode: '2640', suburb: 'WIRLINGA', state: 'NSW' },
  { postCode: '2640', suburb: 'WYMAH', state: 'NSW' },
  { postCode: '2641', suburb: 'HAMILTON VALLEY', state: 'NSW' },
  { postCode: '2641', suburb: 'LAVINGTON', state: 'NSW' },
  { postCode: '2641', suburb: 'SPRINGDALE HEIGHTS', state: 'NSW' },
  { postCode: '2642', suburb: 'BIDGEEMIA', state: 'NSW' },
  { postCode: '2642', suburb: 'BROCKLESBY', state: 'NSW' },
  { postCode: '2642', suburb: 'BURRUMBUTTOCK', state: 'NSW' },
  { postCode: '2642', suburb: 'GEEHI', state: 'NSW' },
  { postCode: '2642', suburb: 'GEROGERY', state: 'NSW' },
  { postCode: '2642', suburb: 'GLENELLEN', state: 'NSW' },
  { postCode: '2642', suburb: 'GREG GREG', state: 'NSW' },
  { postCode: '2642', suburb: 'INDI', state: 'NSW' },
  { postCode: '2642', suburb: 'JAGUMBA', state: 'NSW' },
  { postCode: '2642', suburb: 'JAGUNGAL WILDERNESS', state: 'NSW' },
  { postCode: '2642', suburb: 'JINDERA', state: 'NSW' },
  { postCode: '2642', suburb: 'JINGELLIC', state: 'NSW' },
  { postCode: '2642', suburb: 'KHANCOBAN', state: 'NSW' },
  { postCode: '2642', suburb: 'MURRAY GORGE', state: 'NSW' },
  { postCode: '2642', suburb: 'RAND', state: 'NSW' },
  { postCode: '2642', suburb: 'TOOMA', state: 'NSW' },
  { postCode: '2642', suburb: 'WALBUNDRIE', state: 'NSW' },
  { postCode: '2642', suburb: 'WELAREGANG', state: 'NSW' },
  { postCode: '2642', suburb: 'WRATHALL', state: 'NSW' },
  { postCode: '2642', suburb: 'YERONG CREEK', state: 'NSW' },
  { postCode: '2643', suburb: 'HOWLONG', state: 'NSW' },
  { postCode: '2644', suburb: 'BOWNA', state: 'NSW' },
  { postCode: '2644', suburb: 'COPPABELLA', state: 'NSW' },
  { postCode: '2644', suburb: 'HOLBROOK', state: 'NSW' },
  { postCode: '2644', suburb: 'LANKEYS CREEK', state: 'NSW' },
  { postCode: '2644', suburb: 'LITTLE BILLABONG', state: 'NSW' },
  { postCode: '2644', suburb: 'MOUNTAIN CREEK', state: 'NSW' },
  { postCode: '2644', suburb: 'MULLENGANDRA', state: 'NSW' },
  { postCode: '2644', suburb: 'WANTAGONG', state: 'NSW' },
  { postCode: '2644', suburb: 'WOOMARGAMA', state: 'NSW' },
  { postCode: '2644', suburb: 'YARARA', state: 'NSW' },
  { postCode: '2645', suburb: 'CULLIVEL', state: 'NSW' },
  { postCode: '2645', suburb: 'URANA', state: 'NSW' },
  { postCode: '2646', suburb: 'BALLDALE', state: 'NSW' },
  { postCode: '2646', suburb: 'COLLENDINA', state: 'NSW' },
  { postCode: '2646', suburb: 'COREEN', state: 'NSW' },
  { postCode: '2646', suburb: 'COROWA', state: 'NSW' },
  { postCode: '2646', suburb: 'DAYSDALE', state: 'NSW' },
  { postCode: '2646', suburb: 'GOOMBARGANA', state: 'NSW' },
  { postCode: '2646', suburb: 'HOPEFIELD', state: 'NSW' },
  { postCode: '2646', suburb: 'LOWESDALE', state: 'NSW' },
  { postCode: '2646', suburb: 'NYORA', state: 'NSW' },
  { postCode: '2646', suburb: 'OAKLANDS', state: 'NSW' },
  { postCode: '2646', suburb: 'REDLANDS', state: 'NSW' },
  { postCode: '2646', suburb: 'RENNIE', state: 'NSW' },
  { postCode: '2646', suburb: 'RINGWOOD', state: 'NSW' },
  { postCode: '2646', suburb: 'SANGER', state: 'NSW' },
  { postCode: '2646', suburb: 'SAVERNAKE', state: 'NSW' },
  { postCode: '2647', suburb: 'MULWALA', state: 'NSW' },
  { postCode: '2648', suburb: 'ANABRANCH NORTH', state: 'NSW' },
  { postCode: '2648', suburb: 'ANABRANCH SOUTH', state: 'NSW' },
  { postCode: '2648', suburb: 'CURLWAA', state: 'NSW' },
  { postCode: '2648', suburb: 'ELLERSLIE', state: 'NSW' },
  { postCode: '2648', suburb: 'MOORARA', state: 'NSW' },
  { postCode: '2648', suburb: 'PAN BAN', state: 'NSW' },
  { postCode: '2648', suburb: 'PARA', state: 'NSW' },
  { postCode: '2648', suburb: 'PINE CAMP', state: 'NSW' },
  { postCode: '2648', suburb: 'POMONA', state: 'NSW' },
  { postCode: '2648', suburb: 'POONCARIE', state: 'NSW' },
  { postCode: '2648', suburb: 'RUFUS', state: 'NSW' },
  { postCode: '2648', suburb: 'SCOTIA', state: 'NSW' },
  { postCode: '2648', suburb: 'WENTWORTH', state: 'NSW' },
  { postCode: '2649', suburb: 'LAUREL HILL', state: 'NSW' },
  { postCode: '2649', suburb: 'NURENMERENMONG', state: 'NSW' },
  { postCode: '2650', suburb: 'ALFREDTOWN', state: 'NSW' },
  { postCode: '2650', suburb: 'ASHMONT', state: 'NSW' },
  { postCode: '2650', suburb: 'BELFRAYDEN', state: 'NSW' },
  { postCode: '2650', suburb: 'BIG SPRINGS', state: 'NSW' },
  { postCode: '2650', suburb: 'BOMEN', state: 'NSW' },
  { postCode: '2650', suburb: 'BOOK BOOK', state: 'NSW' },
  { postCode: '2650', suburb: 'BOOROOMA', state: 'NSW' },
  { postCode: '2650', suburb: 'BORAMBOLA', state: 'NSW' },
  { postCode: '2650', suburb: 'BOURKELANDS', state: 'NSW' },
  { postCode: '2650', suburb: 'BRUCEDALE', state: 'NSW' },
  { postCode: '2650', suburb: 'BULGARY', state: 'NSW' },
  { postCode: '2650', suburb: 'BURRANDANA', state: 'NSW' },
  { postCode: '2650', suburb: 'CARABOST', state: 'NSW' },
  { postCode: '2650', suburb: 'CARTWRIGHTS HILL', state: 'NSW' },
  { postCode: '2650', suburb: 'COLLINGULLIE', state: 'NSW' },
  { postCode: '2650', suburb: 'COOKARDINIA', state: 'NSW' },
  { postCode: '2650', suburb: 'CURRAWARNA', state: 'NSW' },
  { postCode: '2650', suburb: 'DHULURA', state: 'NSW' },
  { postCode: '2650', suburb: 'DOWNSIDE', state: 'NSW' },
  { postCode: '2650', suburb: 'EAST WAGGA WAGGA', state: 'NSW' },
  { postCode: '2650', suburb: 'ESTELLA', state: 'NSW' },
  { postCode: '2650', suburb: 'EUBERTA', state: 'NSW' },
  { postCode: '2650', suburb: 'EUNANOREENYA', state: 'NSW' },
  { postCode: '2650', suburb: 'GALORE', state: 'NSW' },
  { postCode: '2650', suburb: 'GELSTON PARK', state: 'NSW' },
  { postCode: '2650', suburb: 'GLENFIELD PARK', state: 'NSW' },
  { postCode: '2650', suburb: 'GOBBAGOMBALIN', state: 'NSW' },
  { postCode: '2650', suburb: 'GREGADOO', state: 'NSW' },
  { postCode: '2650', suburb: 'HAREFIELD', state: 'NSW' },
  { postCode: '2650', suburb: 'HILLGROVE', state: 'NSW' },
  { postCode: '2650', suburb: 'KOORINGAL', state: 'NSW' },
  { postCode: '2650', suburb: 'KYEAMBA', state: 'NSW' },
  { postCode: '2650', suburb: 'LAKE ALBERT', state: 'NSW' },
  { postCode: '2650', suburb: 'LLOYD', state: 'NSW' },
  { postCode: '2650', suburb: 'MAXWELL', state: 'NSW' },
  { postCode: '2650', suburb: 'MOORONG', state: 'NSW' },
  { postCode: '2650', suburb: 'MOUNT AUSTIN', state: 'NSW' },
  { postCode: '2650', suburb: 'NORTH WAGGA WAGGA', state: 'NSW' },
  { postCode: '2650', suburb: 'OBERNE CREEK', state: 'NSW' },
  { postCode: '2650', suburb: 'OURA', state: 'NSW' },
  { postCode: '2650', suburb: 'PULLETOP', state: 'NSW' },
  { postCode: '2650', suburb: 'ROWAN', state: 'NSW' },
  { postCode: '2650', suburb: 'SAN ISIDORE', state: 'NSW' },
  { postCode: '2650', suburb: 'SPRINGVALE', state: 'NSW' },
  { postCode: '2650', suburb: 'TATTON', state: 'NSW' },
  { postCode: '2650', suburb: 'THE GAP', state: 'NSW' },
  { postCode: '2650', suburb: 'TOLLAND', state: 'NSW' },
  { postCode: '2650', suburb: 'TURVEY PARK', state: 'NSW' },
  { postCode: '2650', suburb: 'WAGGA WAGGA', state: 'NSW' },
  { postCode: '2650', suburb: 'WAGGA WAGGA BC', state: 'NSW' },
  { postCode: '2650', suburb: 'WALLACETOWN', state: 'NSW' },
  { postCode: '2650', suburb: 'WANTABADGERY', state: 'NSW' },
  { postCode: '2650', suburb: 'YARRAGUNDRY', state: 'NSW' },
  { postCode: '2650', suburb: 'YATHELLA', state: 'NSW' },
  { postCode: '2651', suburb: 'FOREST HILL', state: 'NSW' },
  { postCode: '2651', suburb: 'WAGGA WAGGA RAAF', state: 'NSW' },
  { postCode: '2652', suburb: 'BOORGA', state: 'NSW' },
  { postCode: '2652', suburb: 'BOREE CREEK', state: 'NSW' },
  { postCode: '2652', suburb: 'COWABBIE', state: 'NSW' },
  { postCode: '2652', suburb: 'GOOLGOWI', state: 'NSW' },
  { postCode: '2652', suburb: 'GRONG GRONG', state: 'NSW' },
  { postCode: '2652', suburb: 'GUMLY GUMLY', state: 'NSW' },
  { postCode: '2652', suburb: 'HUMULA', state: 'NSW' },
  { postCode: '2652', suburb: 'LADYSMITH', state: 'NSW' },
  { postCode: '2652', suburb: 'LANDERVALE', state: 'NSW' },
  { postCode: '2652', suburb: 'MANGOPLAH', state: 'NSW' },
  { postCode: '2652', suburb: 'MARRAR', state: 'NSW' },
  { postCode: '2652', suburb: 'MATONG', state: 'NSW' },
  { postCode: '2652', suburb: 'MERRIWAGGA', state: 'NSW' },
  { postCode: '2652', suburb: 'MURRULEBALE', state: 'NSW' },
  { postCode: '2652', suburb: 'OLD JUNEE', state: 'NSW' },
  { postCode: '2652', suburb: 'ROSEWOOD', state: 'NSW' },
  { postCode: '2652', suburb: 'TABBITA', state: 'NSW' },
  { postCode: '2652', suburb: 'TARCUTTA', state: 'NSW' },
  { postCode: '2652', suburb: 'URANQUINTY', state: 'NSW' },
  { postCode: '2653', suburb: 'BURRA', state: 'NSW' },
  { postCode: '2653', suburb: 'COURABYRA', state: 'NSW' },
  { postCode: '2653', suburb: 'GLENROY', state: 'NSW' },
  { postCode: '2653', suburb: 'MANNUS', state: 'NSW' },
  { postCode: '2653', suburb: 'MARAGLE', state: 'NSW' },
  { postCode: '2653', suburb: 'MUNDEROO', state: 'NSW' },
  { postCode: '2653', suburb: 'PADDYS RIVER', state: 'NSW' },
  { postCode: '2653', suburb: 'TARADALE', state: 'NSW' },
  { postCode: '2653', suburb: 'TUMBARUMBA', state: 'NSW' },
  { postCode: '2653', suburb: 'WESTDALE', state: 'NSW' },
  { postCode: '2653', suburb: 'WILLIGOBUNG', state: 'NSW' },
  { postCode: '2655', suburb: 'FRENCH PARK', state: 'NSW' },
  { postCode: '2655', suburb: 'THE ROCK', state: 'NSW' },
  { postCode: '2655', suburb: 'TOOTOOL', state: 'NSW' },
  { postCode: '2656', suburb: 'BROOKDALE', state: 'NSW' },
  { postCode: '2656', suburb: 'BROOKONG', state: 'NSW' },
  { postCode: '2656', suburb: 'FARGUNYAH', state: 'NSW' },
  { postCode: '2656', suburb: 'LOCKHART', state: 'NSW' },
  { postCode: '2656', suburb: 'MILBRULONG', state: 'NSW' },
  { postCode: '2656', suburb: 'OSBORNE', state: 'NSW' },
  { postCode: '2656', suburb: 'URANGELINE', state: 'NSW' },
  { postCode: '2656', suburb: 'URANGELINE EAST', state: 'NSW' },
  { postCode: '2658', suburb: 'HENTY', state: 'NSW' },
  { postCode: '2658', suburb: 'MUNYABLA', state: 'NSW' },
  { postCode: '2658', suburb: 'PLEASANT HILLS', state: 'NSW' },
  { postCode: '2658', suburb: 'RYAN', state: 'NSW' },
  { postCode: '2659', suburb: 'ALMA PARK', state: 'NSW' },
  { postCode: '2659', suburb: 'WALLA WALLA', state: 'NSW' },
  { postCode: '2660', suburb: 'CULCAIRN', state: 'NSW' },
  { postCode: '2660', suburb: 'MORVEN', state: 'NSW' },
  { postCode: '2661', suburb: 'KAPOOKA', state: 'NSW' },
  { postCode: '2663', suburb: 'ERIN VALE', state: 'NSW' },
  { postCode: '2663', suburb: 'EURONGILLY', state: 'NSW' },
  { postCode: '2663', suburb: 'JUNEE', state: 'NSW' },
  { postCode: '2663', suburb: 'MARINNA', state: 'NSW' },
  { postCode: '2663', suburb: 'WANTIOOL', state: 'NSW' },
  { postCode: '2665', suburb: 'ARDLETHAN', state: 'NSW' },
  { postCode: '2665', suburb: 'ARIAH PARK', state: 'NSW' },
  { postCode: '2665', suburb: 'BARELLAN', state: 'NSW' },
  { postCode: '2665', suburb: 'BECKOM', state: 'NSW' },
  { postCode: '2665', suburb: 'BECTRIC', state: 'NSW' },
  { postCode: '2665', suburb: 'BINYA', state: 'NSW' },
  { postCode: '2665', suburb: 'KAMARAH', state: 'NSW' },
  { postCode: '2665', suburb: 'MIRROOL', state: 'NSW' },
  { postCode: '2665', suburb: 'MOOMBOOLDOOL', state: 'NSW' },
  { postCode: '2665', suburb: 'QUANDARY', state: 'NSW' },
  { postCode: '2665', suburb: 'TARA', state: 'NSW' },
  { postCode: '2665', suburb: 'WALLEROOBIE', state: 'NSW' },
  { postCode: '2666', suburb: 'COMBANING', state: 'NSW' },
  { postCode: '2666', suburb: 'DIRNASEER', state: 'NSW' },
  { postCode: '2666', suburb: 'GIDGINBUNG', state: 'NSW' },
  { postCode: '2666', suburb: 'GROGAN', state: 'NSW' },
  { postCode: '2666', suburb: 'JUNEE REEFS', state: 'NSW' },
  { postCode: '2666', suburb: 'MIMOSA', state: 'NSW' },
  { postCode: '2666', suburb: 'MORANGARELL', state: 'NSW' },
  { postCode: '2666', suburb: 'NARRABURRA', state: 'NSW' },
  { postCode: '2666', suburb: 'PUCAWAN', state: 'NSW' },
  { postCode: '2666', suburb: 'REEFTON', state: 'NSW' },
  { postCode: '2666', suburb: 'SEBASTOPOL', state: 'NSW' },
  { postCode: '2666', suburb: 'SPRINGDALE', state: 'NSW' },
  { postCode: '2666', suburb: 'TEMORA', state: 'NSW' },
  { postCode: '2666', suburb: 'TRUNGLEY HALL', state: 'NSW' },
  { postCode: '2668', suburb: 'BARMEDMAN', state: 'NSW' },
  { postCode: '2669', suburb: 'ERIGOLIA', state: 'NSW' },
  { postCode: '2669', suburb: 'GIRRAL', state: 'NSW' },
  { postCode: '2669', suburb: 'KIKOIRA', state: 'NSW' },
  { postCode: '2669', suburb: 'MELBERGEN', state: 'NSW' },
  { postCode: '2669', suburb: 'NARADHAN', state: 'NSW' },
  { postCode: '2669', suburb: 'RANKINS SPRINGS', state: 'NSW' },
  { postCode: '2669', suburb: 'TALLIMBA', state: 'NSW' },
  { postCode: '2669', suburb: 'TULLIBIGEAL', state: 'NSW' },
  { postCode: '2669', suburb: 'UNGARIE', state: 'NSW' },
  { postCode: '2669', suburb: 'WEETHALLE', state: 'NSW' },
  { postCode: '2671', suburb: 'ALLEENA', state: 'NSW' },
  { postCode: '2671', suburb: 'BACK CREEK', state: 'NSW' },
  { postCode: '2671', suburb: 'BURCHER', state: 'NSW' },
  { postCode: '2671', suburb: 'LAKE COWAL', state: 'NSW' },
  { postCode: '2671', suburb: 'NORTH YALGOGRIN', state: 'NSW' },
  { postCode: '2671', suburb: 'WEST WYALONG', state: 'NSW' },
  { postCode: '2671', suburb: 'WYALONG', state: 'NSW' },
  { postCode: '2672', suburb: 'CURLEW WATERS', state: 'NSW' },
  { postCode: '2672', suburb: 'LAKE CARGELLIGO', state: 'NSW' },
  { postCode: '2672', suburb: 'MURRIN BRIDGE', state: 'NSW' },
  { postCode: '2675', suburb: 'HILLSTON', state: 'NSW' },
  { postCode: '2675', suburb: 'LAKE BREWSTER', state: 'NSW' },
  { postCode: '2675', suburb: 'MONIA GAP', state: 'NSW' },
  { postCode: '2675', suburb: 'ROTO', state: 'NSW' },
  { postCode: '2675', suburb: 'WALLANTHERY', state: 'NSW' },
  { postCode: '2678', suburb: 'CHARLES STURT UNIVERSITY', state: 'NSW' },
  { postCode: '2678', suburb: 'RIVERINA MC', state: 'NSW' },
  { postCode: '2680', suburb: 'BEELBANGERA', state: 'NSW' },
  { postCode: '2680', suburb: 'BENEREMBAH', state: 'NSW' },
  { postCode: '2680', suburb: 'BILBUL', state: 'NSW' },
  { postCode: '2680', suburb: 'GRIFFITH', state: 'NSW' },
  { postCode: '2680', suburb: 'GRIFFITH DC', state: 'NSW' },
  { postCode: '2680', suburb: 'GRIFFITH EAST', state: 'NSW' },
  { postCode: '2680', suburb: 'HANWOOD', state: 'NSW' },
  { postCode: '2680', suburb: 'KOOBA', state: 'NSW' },
  { postCode: '2680', suburb: 'LAKE WYANGAN', state: 'NSW' },
  { postCode: '2680', suburb: 'NERICON', state: 'NSW' },
  { postCode: '2680', suburb: 'THARBOGANG', state: 'NSW' },
  { postCode: '2680', suburb: 'WARBURN', state: 'NSW' },
  { postCode: '2680', suburb: 'WARRAWIDGEE', state: 'NSW' },
  { postCode: '2680', suburb: 'WIDGELLI', state: 'NSW' },
  { postCode: '2680', suburb: 'WILLBRIGGIE', state: 'NSW' },
  { postCode: '2680', suburb: 'YOOGALI', state: 'NSW' },
  { postCode: '2681', suburb: 'MYALL PARK', state: 'NSW' },
  { postCode: '2681', suburb: 'YENDA', state: 'NSW' },
  { postCode: '2700', suburb: 'BUNDURE', state: 'NSW' },
  { postCode: '2700', suburb: 'COLINROOBIE', state: 'NSW' },
  { postCode: '2700', suburb: 'COROBIMILLA', state: 'NSW' },
  { postCode: '2700', suburb: 'CUDGEL', state: 'NSW' },
  { postCode: '2700', suburb: 'EUROLEY', state: 'NSW' },
  { postCode: '2700', suburb: 'GILLENBAH', state: 'NSW' },
  { postCode: '2700', suburb: 'MORUNDAH', state: 'NSW' },
  { postCode: '2700', suburb: 'NARRANDERA', state: 'NSW' },
  { postCode: '2700', suburb: 'SANDIGO', state: 'NSW' },
  { postCode: '2701', suburb: 'BERRY JERRY', state: 'NSW' },
  { postCode: '2701', suburb: 'COOLAMON', state: 'NSW' },
  { postCode: '2701', suburb: 'METHUL', state: 'NSW' },
  { postCode: '2701', suburb: 'RANNOCK', state: 'NSW' },
  { postCode: '2702', suburb: 'GANMAIN', state: 'NSW' },
  { postCode: '2703', suburb: 'YANCO', state: 'NSW' },
  { postCode: '2705', suburb: 'BROBENAH', state: 'NSW' },
  { postCode: '2705', suburb: 'CORBIE HILL', state: 'NSW' },
  { postCode: '2705', suburb: 'GOGELDRIE', state: 'NSW' },
  { postCode: '2705', suburb: 'LEETON', state: 'NSW' },
  { postCode: '2705', suburb: 'MERUNGLE HILL', state: 'NSW' },
  { postCode: '2705', suburb: 'MURRAMI', state: 'NSW' },
  { postCode: '2705', suburb: 'STANBRIDGE', state: 'NSW' },
  { postCode: '2705', suburb: 'WHITTON', state: 'NSW' },
  { postCode: '2706', suburb: 'DARLINGTON POINT', state: 'NSW' },
  { postCode: '2707', suburb: 'ARGOON', state: 'NSW' },
  { postCode: '2707', suburb: 'COLEAMBALLY', state: 'NSW' },
  { postCode: '2708', suburb: 'MURRAY REGION MC', state: 'NSW' },
  { postCode: '2710', suburb: 'BARRATTA', state: 'NSW' },
  { postCode: '2710', suburb: 'BIRGANBIGIL', state: 'NSW' },
  { postCode: '2710', suburb: 'BOOROORBAN', state: 'NSW' },
  { postCode: '2710', suburb: 'BULLATALE', state: 'NSW' },
  { postCode: '2710', suburb: 'CALDWELL', state: 'NSW' },
  { postCode: '2710', suburb: 'CALIMO', state: 'NSW' },
  { postCode: '2710', suburb: 'CONARGO', state: 'NSW' },
  { postCode: '2710', suburb: 'COREE', state: 'NSW' },
  { postCode: '2710', suburb: 'DENILIQUIN', state: 'NSW' },
  { postCode: '2710', suburb: 'DENILIQUIN NORTH', state: 'NSW' },
  { postCode: '2710', suburb: 'HARTWOOD', state: 'NSW' },
  { postCode: '2710', suburb: 'LINDIFFERON', state: 'NSW' },
  { postCode: '2710', suburb: 'MATHOURA', state: 'NSW' },
  { postCode: '2710', suburb: 'MAYRUNG', state: 'NSW' },
  { postCode: '2710', suburb: 'MOONBRIA', state: 'NSW' },
  { postCode: '2710', suburb: 'MORAGO', state: 'NSW' },
  { postCode: '2710', suburb: 'PRETTY PINE', state: 'NSW' },
  { postCode: '2710', suburb: 'STEAM PLAINS', state: 'NSW' },
  { postCode: '2710', suburb: 'STUD PARK', state: 'NSW' },
  { postCode: '2710', suburb: 'WAKOOL', state: 'NSW' },
  { postCode: '2710', suburb: 'WANDOOK', state: 'NSW' },
  { postCode: '2710', suburb: 'WANGANELLA', state: 'NSW' },
  { postCode: '2710', suburb: 'WARRAGOON', state: 'NSW' },
  { postCode: '2710', suburb: 'WILLURAH', state: 'NSW' },
  { postCode: '2711', suburb: 'BOOLIGAL', state: 'NSW' },
  { postCode: '2711', suburb: 'CARRATHOOL', state: 'NSW' },
  { postCode: '2711', suburb: 'CLARE', state: 'NSW' },
  { postCode: '2711', suburb: 'CORRONG', state: 'NSW' },
  { postCode: '2711', suburb: 'GUNBAR', state: 'NSW' },
  { postCode: '2711', suburb: 'HAY', state: 'NSW' },
  { postCode: '2711', suburb: 'HAY SOUTH', state: 'NSW' },
  { postCode: '2711', suburb: 'KERI KERI', state: 'NSW' },
  { postCode: '2711', suburb: 'MAUDE', state: 'NSW' },
  { postCode: '2711', suburb: 'ONE TREE', state: 'NSW' },
  { postCode: '2711', suburb: 'OXLEY', state: 'NSW' },
  { postCode: '2711', suburb: 'WAUGORAH', state: 'NSW' },
  { postCode: '2711', suburb: 'YANGA', state: 'NSW' },
  { postCode: '2712', suburb: 'BERRIGAN', state: 'NSW' },
  { postCode: '2712', suburb: 'BOOMANOOMANA', state: 'NSW' },
  { postCode: '2713', suburb: 'BLIGHTY', state: 'NSW' },
  { postCode: '2713', suburb: 'FINLEY', state: 'NSW' },
  { postCode: '2713', suburb: 'LOGIE BRAE', state: 'NSW' },
  { postCode: '2713', suburb: 'MYRTLE PARK', state: 'NSW' },
  { postCode: '2714', suburb: 'ARATULA', state: 'NSW' },
  { postCode: '2714', suburb: 'PINE LODGE', state: 'NSW' },
  { postCode: '2714', suburb: 'TOCUMWAL', state: 'NSW' },
  { postCode: '2714', suburb: 'TUPPAL', state: 'NSW' },
  { postCode: '2715', suburb: 'ARUMPO', state: 'NSW' },
  { postCode: '2715', suburb: 'BALRANALD', state: 'NSW' },
  { postCode: '2715', suburb: 'HATFIELD', state: 'NSW' },
  { postCode: '2715', suburb: 'KYALITE', state: 'NSW' },
  { postCode: '2715', suburb: 'MUNGO', state: 'NSW' },
  { postCode: '2716', suburb: 'FOUR CORNERS', state: 'NSW' },
  { postCode: '2716', suburb: 'GALA VALE', state: 'NSW' },
  { postCode: '2716', suburb: 'JERILDERIE', state: 'NSW' },
  { postCode: '2716', suburb: 'MABINS WELL', state: 'NSW' },
  { postCode: '2716', suburb: 'MAIRJIMMY', state: 'NSW' },
  { postCode: '2717', suburb: 'COOMEALLA', state: 'NSW' },
  { postCode: '2717', suburb: 'DARETON', state: 'NSW' },
  { postCode: '2720', suburb: 'ARGALONG', state: 'NSW' },
  { postCode: '2720', suburb: 'BLOWERING', state: 'NSW' },
  { postCode: '2720', suburb: 'BOGONG PEAKS WILDERNESS', state: 'NSW' },
  { postCode: '2720', suburb: 'BOMBOWLEE', state: 'NSW' },
  { postCode: '2720', suburb: 'BOMBOWLEE CREEK', state: 'NSW' },
  { postCode: '2720', suburb: 'BUDDONG', state: 'NSW' },
  { postCode: '2720', suburb: 'COURAGAGO', state: 'NSW' },
  { postCode: '2720', suburb: 'GADARA', state: 'NSW' },
  { postCode: '2720', suburb: 'GILMORE', state: 'NSW' },
  { postCode: '2720', suburb: 'GOCUP', state: 'NSW' },
  { postCode: '2720', suburb: 'GOOBARRAGANDRA', state: 'NSW' },
  { postCode: '2720', suburb: 'JONES BRIDGE', state: 'NSW' },
  { postCode: '2720', suburb: 'KILLIMICAT', state: 'NSW' },
  { postCode: '2720', suburb: 'LACMALAC', state: 'NSW' },
  { postCode: '2720', suburb: 'LITTLE RIVER', state: 'NSW' },
  { postCode: '2720', suburb: 'MINJARY', state: 'NSW' },
  { postCode: '2720', suburb: 'MUNDONGO', state: 'NSW' },
  { postCode: '2720', suburb: 'PINBEYAN', state: 'NSW' },
  { postCode: '2720', suburb: 'RED HILL', state: 'NSW' },
  { postCode: '2720', suburb: 'TALBINGO', state: 'NSW' },
  { postCode: '2720', suburb: 'TUMORRAMA', state: 'NSW' },
  { postCode: '2720', suburb: 'TUMUT', state: 'NSW' },
  { postCode: '2720', suburb: 'TUMUT PLAINS', state: 'NSW' },
  { postCode: '2720', suburb: 'WEREBOLDERA', state: 'NSW' },
  { postCode: '2720', suburb: 'WERMATONG', state: 'NSW' },
  { postCode: '2720', suburb: 'WINDOWIE', state: 'NSW' },
  { postCode: '2720', suburb: 'WYANGLE', state: 'NSW' },
  { postCode: '2720', suburb: 'YARRANGOBILLY', state: 'NSW' },
  { postCode: '2721', suburb: 'BLAND', state: 'NSW' },
  { postCode: '2721', suburb: 'QUANDIALLA', state: 'NSW' },
  { postCode: '2722', suburb: 'BRUNGLE', state: 'NSW' },
  { postCode: '2722', suburb: 'BRUNGLE CREEK', state: 'NSW' },
  { postCode: '2722', suburb: 'BURRA CREEK', state: 'NSW' },
  { postCode: '2722', suburb: 'DARBALARA', state: 'NSW' },
  { postCode: '2722', suburb: 'GUNDAGAI', state: 'NSW' },
  { postCode: '2722', suburb: 'MUTTAMA', state: 'NSW' },
  { postCode: '2722', suburb: 'NANGUS', state: 'NSW' },
  { postCode: '2722', suburb: 'RENO', state: 'NSW' },
  { postCode: '2722', suburb: 'SOUTH GUNDAGAI', state: 'NSW' },
  { postCode: '2725', suburb: 'STOCKINBINGAL', state: 'NSW' },
  { postCode: '2726', suburb: 'COONEYS CREEK', state: 'NSW' },
  { postCode: '2726', suburb: 'JUGIONG', state: 'NSW' },
  { postCode: '2727', suburb: 'ADJUNGBILLY', state: 'NSW' },
  { postCode: '2727', suburb: 'COOLAC', state: 'NSW' },
  { postCode: '2727', suburb: 'GOBARRALONG', state: 'NSW' },
  { postCode: '2729', suburb: 'ADELONG', state: 'NSW' },
  { postCode: '2729', suburb: 'BANGADANG', state: 'NSW' },
  { postCode: '2729', suburb: 'BLACK CREEK', state: 'NSW' },
  { postCode: '2729', suburb: 'CALIFAT', state: 'NSW' },
  { postCode: '2729', suburb: 'COOLEYS CREEK', state: 'NSW' },
  { postCode: '2729', suburb: 'DARLOW', state: 'NSW' },
  { postCode: '2729', suburb: 'ELLERSLIE', state: 'NSW' },
  { postCode: '2729', suburb: 'GRAHAMSTOWN', state: 'NSW' },
  { postCode: '2729', suburb: 'MOUNT ADRAH', state: 'NSW' },
  { postCode: '2729', suburb: 'MOUNT HOREB', state: 'NSW' },
  { postCode: '2729', suburb: 'MUNDARLO', state: 'NSW' },
  { postCode: '2729', suburb: 'SANDY GULLY', state: 'NSW' },
  { postCode: '2729', suburb: 'SHARPS CREEK', state: 'NSW' },
  { postCode: '2729', suburb: 'TUMBLONG', state: 'NSW' },
  { postCode: '2729', suburb: 'WESTWOOD', state: 'NSW' },
  { postCode: '2729', suburb: 'WONDALGA', state: 'NSW' },
  { postCode: '2729', suburb: 'YAVEN CREEK', state: 'NSW' },
  { postCode: '2730', suburb: 'BATLOW', state: 'NSW' },
  { postCode: '2730', suburb: 'GREEN HILLS', state: 'NSW' },
  { postCode: '2730', suburb: 'KUNAMA', state: 'NSW' },
  { postCode: '2730', suburb: 'LOWER BAGO', state: 'NSW' },
  { postCode: '2731', suburb: 'BUNNALOO', state: 'NSW' },
  { postCode: '2731', suburb: 'MOAMA', state: 'NSW' },
  { postCode: '2731', suburb: 'TANTONAN', state: 'NSW' },
  { postCode: '2731', suburb: 'THYRA', state: 'NSW' },
  { postCode: '2731', suburb: 'WOMBOOTA', state: 'NSW' },
  { postCode: '2732', suburb: 'BARHAM', state: 'NSW' },
  { postCode: '2732', suburb: 'BURRABOI', state: 'NSW' },
  { postCode: '2732', suburb: 'COBRAMUNGA', state: 'NSW' },
  { postCode: '2732', suburb: 'GONN', state: 'NSW' },
  { postCode: '2732', suburb: 'NOORONG', state: 'NSW' },
  { postCode: '2732', suburb: 'THULE', state: 'NSW' },
  { postCode: '2732', suburb: 'TULLAKOOL', state: 'NSW' },
  { postCode: '2733', suburb: 'DHURAGOON', state: 'NSW' },
  { postCode: '2733', suburb: 'MOULAMEIN', state: 'NSW' },
  { postCode: '2733', suburb: 'NIEMUR', state: 'NSW' },
  { postCode: '2734', suburb: 'CUNNINYEUK', state: 'NSW' },
  { postCode: '2734', suburb: 'DILPURRA', state: 'NSW' },
  { postCode: '2734', suburb: 'MALLAN', state: 'NSW' },
  { postCode: '2734', suburb: 'MELLOOL', state: 'NSW' },
  { postCode: '2734', suburb: 'MOOLPA', state: 'NSW' },
  { postCode: '2734', suburb: 'MURRAY DOWNS', state: 'NSW' },
  { postCode: '2734', suburb: 'STONY CROSSING', state: 'NSW' },
  { postCode: '2734', suburb: 'TOORANIE', state: 'NSW' },
  { postCode: '2734', suburb: 'WETUPPA', state: 'NSW' },
  { postCode: '2735', suburb: 'KORALEIGH', state: 'NSW' },
  { postCode: '2735', suburb: 'SPEEWA', state: 'NSW' },
  { postCode: '2736', suburb: 'GOODNIGHT', state: 'NSW' },
  { postCode: '2736', suburb: 'TOOLEYBUC', state: 'NSW' },
  { postCode: '2737', suburb: 'EUSTON', state: 'NSW' },
  { postCode: '2738', suburb: 'GOL GOL', state: 'NSW' },
  { postCode: '2738', suburb: 'MALLEE', state: 'NSW' },
  { postCode: '2738', suburb: 'MONAK', state: 'NSW' },
  { postCode: '2738', suburb: 'PARINGI', state: 'NSW' },
  { postCode: '2738', suburb: 'TRENTHAM CLIFFS', state: 'NSW' },
  { postCode: '2739', suburb: 'BOEILL CREEK', state: 'NSW' },
  { postCode: '2739', suburb: 'BURONGA', state: 'NSW' },
  { postCode: '2739', suburb: 'MOURQUONG', state: 'NSW' },
  { postCode: '2745', suburb: 'GLENMORE PARK', state: 'NSW' },
  { postCode: '2745', suburb: 'GREENDALE', state: 'NSW' },
  { postCode: '2745', suburb: 'LUDDENHAM', state: 'NSW' },
  { postCode: '2745', suburb: 'MULGOA', state: 'NSW' },
  { postCode: '2745', suburb: 'REGENTVILLE', state: 'NSW' },
  { postCode: '2745', suburb: 'WALLACIA', state: 'NSW' },
  { postCode: '2747', suburb: 'CADDENS', state: 'NSW' },
  { postCode: '2747', suburb: 'CAMBRIDGE GARDENS', state: 'NSW' },
  { postCode: '2747', suburb: 'CAMBRIDGE PARK', state: 'NSW' },
  { postCode: '2747', suburb: 'CLAREMONT MEADOWS', state: 'NSW' },
  { postCode: '2747', suburb: 'JORDAN SPRINGS', state: 'NSW' },
  { postCode: '2747', suburb: 'KINGSWOOD', state: 'NSW' },
  { postCode: '2747', suburb: 'LLANDILO', state: 'NSW' },
  { postCode: '2747', suburb: 'SHANES PARK', state: 'NSW' },
  { postCode: '2747', suburb: 'WERRINGTON', state: 'NSW' },
  { postCode: '2747', suburb: 'WERRINGTON COUNTY', state: 'NSW' },
  { postCode: '2747', suburb: 'WERRINGTON DOWNS', state: 'NSW' },
  { postCode: '2748', suburb: 'ORCHARD HILLS', state: 'NSW' },
  { postCode: '2749', suburb: 'CASTLEREAGH', state: 'NSW' },
  { postCode: '2749', suburb: 'CRANEBROOK', state: 'NSW' },
  { postCode: '2750', suburb: 'EMU HEIGHTS', state: 'NSW' },
  { postCode: '2750', suburb: 'EMU PLAINS', state: 'NSW' },
  { postCode: '2750', suburb: 'JAMISONTOWN', state: 'NSW' },
  { postCode: '2750', suburb: 'LEONAY', state: 'NSW' },
  { postCode: '2750', suburb: 'PENRITH', state: 'NSW' },
  { postCode: '2750', suburb: 'PENRITH PLAZA', state: 'NSW' },
  { postCode: '2750', suburb: 'PENRITH SOUTH', state: 'NSW' },
  { postCode: '2750', suburb: 'SOUTH PENRITH', state: 'NSW' },
  { postCode: '2751', suburb: 'PENRITH', state: 'NSW' },
  { postCode: '2752', suburb: 'SILVERDALE', state: 'NSW' },
  { postCode: '2752', suburb: 'WARRAGAMBA', state: 'NSW' },
  { postCode: '2753', suburb: 'AGNES BANKS', state: 'NSW' },
  { postCode: '2753', suburb: 'BOWEN MOUNTAIN', state: 'NSW' },
  { postCode: '2753', suburb: 'GROSE VALE', state: 'NSW' },
  { postCode: '2753', suburb: 'GROSE WOLD', state: 'NSW' },
  { postCode: '2753', suburb: 'HOBARTVILLE', state: 'NSW' },
  { postCode: '2753', suburb: 'LONDONDERRY', state: 'NSW' },
  { postCode: '2753', suburb: 'RICHMOND', state: 'NSW' },
  { postCode: '2753', suburb: 'RICHMOND LOWLANDS', state: 'NSW' },
  { postCode: '2753', suburb: 'YARRAMUNDI', state: 'NSW' },
  { postCode: '2754', suburb: 'NORTH RICHMOND', state: 'NSW' },
  { postCode: '2754', suburb: 'TENNYSON', state: 'NSW' },
  { postCode: '2754', suburb: 'THE SLOPES', state: 'NSW' },
  { postCode: '2756', suburb: 'BLIGH PARK', state: 'NSW' },
  { postCode: '2756', suburb: 'CATTAI', state: 'NSW' },
  { postCode: '2756', suburb: 'CENTRAL COLO', state: 'NSW' },
  { postCode: '2756', suburb: 'CLARENDON', state: 'NSW' },
  { postCode: '2756', suburb: 'COLO', state: 'NSW' },
  { postCode: '2756', suburb: 'COLO HEIGHTS', state: 'NSW' },
  { postCode: '2756', suburb: 'CORNWALLIS', state: 'NSW' },
  { postCode: '2756', suburb: 'CUMBERLAND REACH', state: 'NSW' },
  { postCode: '2756', suburb: 'EBENEZER', state: 'NSW' },
  { postCode: '2756', suburb: 'FREEMANS REACH', state: 'NSW' },
  { postCode: '2756', suburb: 'GLOSSODIA', state: 'NSW' },
  { postCode: '2756', suburb: 'LOWER PORTLAND', state: 'NSW' },
  { postCode: '2756', suburb: 'MAROOTA', state: 'NSW' },
  { postCode: '2756', suburb: 'MCGRATHS HILL', state: 'NSW' },
  { postCode: '2756', suburb: 'MELLONG', state: 'NSW' },
  { postCode: '2756', suburb: 'MULGRAVE', state: 'NSW' },
  { postCode: '2756', suburb: 'PITT TOWN', state: 'NSW' },
  { postCode: '2756', suburb: 'PITT TOWN BOTTOMS', state: 'NSW' },
  { postCode: '2756', suburb: 'SACKVILLE', state: 'NSW' },
  { postCode: '2756', suburb: 'SACKVILLE NORTH', state: 'NSW' },
  { postCode: '2756', suburb: 'SCHEYVILLE', state: 'NSW' },
  { postCode: '2756', suburb: 'SOUTH MAROOTA', state: 'NSW' },
  { postCode: '2756', suburb: 'SOUTH WINDSOR', state: 'NSW' },
  { postCode: '2756', suburb: 'UPPER COLO', state: 'NSW' },
  { postCode: '2756', suburb: 'WILBERFORCE', state: 'NSW' },
  { postCode: '2756', suburb: 'WINDSOR', state: 'NSW' },
  { postCode: '2756', suburb: 'WINDSOR DOWNS', state: 'NSW' },
  { postCode: '2756', suburb: 'WOMERAH', state: 'NSW' },
  { postCode: '2757', suburb: 'KURMOND', state: 'NSW' },
  { postCode: '2758', suburb: 'BERAMBING', state: 'NSW' },
  { postCode: '2758', suburb: 'BILPIN', state: 'NSW' },
  { postCode: '2758', suburb: 'BLAXLANDS RIDGE', state: 'NSW' },
  { postCode: '2758', suburb: 'EAST KURRAJONG', state: 'NSW' },
  { postCode: '2758', suburb: 'KURRAJONG', state: 'NSW' },
  { postCode: '2758', suburb: 'KURRAJONG HEIGHTS', state: 'NSW' },
  { postCode: '2758', suburb: 'KURRAJONG HILLS', state: 'NSW' },
  { postCode: '2758', suburb: 'MOUNT TOMAH', state: 'NSW' },
  { postCode: '2758', suburb: 'MOUNTAIN LAGOON', state: 'NSW' },
  { postCode: '2758', suburb: 'THE DEVILS WILDERNESS', state: 'NSW' },
  { postCode: '2758', suburb: 'WHEENY CREEK', state: 'NSW' },
  { postCode: '2759', suburb: 'ERSKINE PARK', state: 'NSW' },
  { postCode: '2759', suburb: 'ST CLAIR', state: 'NSW' },
  { postCode: '2760', suburb: 'COLYTON', state: 'NSW' },
  { postCode: '2760', suburb: 'NORTH ST MARYS', state: 'NSW' },
  { postCode: '2760', suburb: 'OXLEY PARK', state: 'NSW' },
  { postCode: '2760', suburb: 'ROPES CROSSING', state: 'NSW' },
  { postCode: '2760', suburb: 'ST MARYS', state: 'NSW' },
  { postCode: '2760', suburb: 'ST MARYS EAST', state: 'NSW' },
  { postCode: '2760', suburb: 'ST MARYS SOUTH', state: 'NSW' },
  { postCode: '2761', suburb: 'COLEBEE', state: 'NSW' },
  { postCode: '2761', suburb: 'DEAN PARK', state: 'NSW' },
  { postCode: '2761', suburb: 'GLENDENNING', state: 'NSW' },
  { postCode: '2761', suburb: 'HASSALL GROVE', state: 'NSW' },
  { postCode: '2761', suburb: 'OAKHURST', state: 'NSW' },
  { postCode: '2761', suburb: 'PLUMPTON', state: 'NSW' },
  { postCode: '2762', suburb: 'SCHOFIELDS', state: 'NSW' },
  { postCode: '2763', suburb: 'ACACIA GARDENS', state: 'NSW' },
  { postCode: '2763', suburb: 'QUAKERS HILL', state: 'NSW' },
  { postCode: '2765', suburb: 'BERKSHIRE PARK', state: 'NSW' },
  { postCode: '2765', suburb: 'BOX HILL', state: 'NSW' },
  { postCode: '2765', suburb: 'MARAYLYA', state: 'NSW' },
  { postCode: '2765', suburb: 'MARSDEN PARK', state: 'NSW' },
  { postCode: '2765', suburb: 'NELSON', state: 'NSW' },
  { postCode: '2765', suburb: 'OAKVILLE', state: 'NSW' },
  { postCode: '2765', suburb: 'RIVERSTONE', state: 'NSW' },
  { postCode: '2765', suburb: 'VINEYARD', state: 'NSW' },
  { postCode: '2766', suburb: 'EASTERN CREEK', state: 'NSW' },
  { postCode: '2766', suburb: 'ROOTY HILL', state: 'NSW' },
  { postCode: '2767', suburb: 'BUNGARRIBEE', state: 'NSW' },
  { postCode: '2767', suburb: 'DOONSIDE', state: 'NSW' },
  { postCode: '2767', suburb: 'WOODCROFT', state: 'NSW' },
  { postCode: '2768', suburb: 'GLENWOOD', state: 'NSW' },
  { postCode: '2768', suburb: 'PARKLEA', state: 'NSW' },
  { postCode: '2768', suburb: 'STANHOPE GARDENS', state: 'NSW' },
  { postCode: '2769', suburb: 'THE PONDS', state: 'NSW' },
  { postCode: '2770', suburb: 'BIDWILL', state: 'NSW' },
  { postCode: '2770', suburb: 'BLACKETT', state: 'NSW' },
  { postCode: '2770', suburb: 'DHARRUK', state: 'NSW' },
  { postCode: '2770', suburb: 'EMERTON', state: 'NSW' },
  { postCode: '2770', suburb: 'HEBERSHAM', state: 'NSW' },
  { postCode: '2770', suburb: 'LETHBRIDGE PARK', state: 'NSW' },
  { postCode: '2770', suburb: 'MINCHINBURY', state: 'NSW' },
  { postCode: '2770', suburb: 'MOUNT DRUITT', state: 'NSW' },
  { postCode: '2770', suburb: 'MOUNT DRUITT VILLAGE', state: 'NSW' },
  { postCode: '2770', suburb: 'SHALVEY', state: 'NSW' },
  { postCode: '2770', suburb: 'TREGEAR', state: 'NSW' },
  { postCode: '2770', suburb: 'WHALAN', state: 'NSW' },
  { postCode: '2770', suburb: 'WILLMOT', state: 'NSW' },
  { postCode: '2773', suburb: 'GLENBROOK', state: 'NSW' },
  { postCode: '2773', suburb: 'LAPSTONE', state: 'NSW' },
  { postCode: '2774', suburb: 'BLAXLAND', state: 'NSW' },
  { postCode: '2774', suburb: 'BLAXLAND EAST', state: 'NSW' },
  { postCode: '2774', suburb: 'MOUNT RIVERVIEW', state: 'NSW' },
  { postCode: '2774', suburb: 'WARRIMOO', state: 'NSW' },
  { postCode: '2775', suburb: 'CENTRAL MACDONALD', state: 'NSW' },
  { postCode: '2775', suburb: 'FERNANCES', state: 'NSW' },
  { postCode: '2775', suburb: 'GUNDERMAN', state: 'NSW' },
  { postCode: '2775', suburb: 'HIGHER MACDONALD', state: 'NSW' },
  { postCode: '2775', suburb: 'LAUGHTONDALE', state: 'NSW' },
  { postCode: '2775', suburb: 'LEETS VALE', state: 'NSW' },
  { postCode: '2775', suburb: 'LOWER MACDONALD', state: 'NSW' },
  { postCode: '2775', suburb: 'MARLOW', state: 'NSW' },
  { postCode: '2775', suburb: 'MOGO CREEK', state: 'NSW' },
  { postCode: '2775', suburb: 'PERRYS CROSSING', state: 'NSW' },
  { postCode: '2775', suburb: 'SINGLETONS MILL', state: 'NSW' },
  { postCode: '2775', suburb: 'SPENCER', state: 'NSW' },
  { postCode: '2775', suburb: 'ST ALBANS', state: 'NSW' },
  { postCode: '2775', suburb: 'UPPER MACDONALD', state: 'NSW' },
  { postCode: '2775', suburb: 'WEBBS CREEK', state: 'NSW' },
  { postCode: '2775', suburb: 'WISEMANS FERRY', state: 'NSW' },
  { postCode: '2775', suburb: 'WRIGHTS CREEK', state: 'NSW' },
  { postCode: '2776', suburb: 'FAULCONBRIDGE', state: 'NSW' },
  { postCode: '2777', suburb: 'HAWKESBURY HEIGHTS', state: 'NSW' },
  { postCode: '2777', suburb: 'SPRINGWOOD', state: 'NSW' },
  { postCode: '2777', suburb: 'SUN VALLEY', state: 'NSW' },
  { postCode: '2777', suburb: 'VALLEY HEIGHTS', state: 'NSW' },
  { postCode: '2777', suburb: 'WINMALEE', state: 'NSW' },
  { postCode: '2777', suburb: 'YELLOW ROCK', state: 'NSW' },
  { postCode: '2778', suburb: 'LINDEN', state: 'NSW' },
  { postCode: '2778', suburb: 'WOODFORD', state: 'NSW' },
  { postCode: '2779', suburb: 'HAZELBROOK', state: 'NSW' },
  { postCode: '2780', suburb: 'KATOOMBA', state: 'NSW' },
  { postCode: '2780', suburb: 'KATOOMBA DC', state: 'NSW' },
  { postCode: '2780', suburb: 'LEURA', state: 'NSW' },
  { postCode: '2780', suburb: 'MEDLOW BATH', state: 'NSW' },
  { postCode: '2782', suburb: 'WENTWORTH FALLS', state: 'NSW' },
  { postCode: '2783', suburb: 'LAWSON', state: 'NSW' },
  { postCode: '2784', suburb: 'BULLABURRA', state: 'NSW' },
  { postCode: '2785', suburb: 'BLACKHEATH', state: 'NSW' },
  { postCode: '2785', suburb: 'MEGALONG VALLEY', state: 'NSW' },
  { postCode: '2786', suburb: 'BELL', state: 'NSW' },
  { postCode: '2786', suburb: 'DARGAN', state: 'NSW' },
  { postCode: '2786', suburb: 'MOUNT IRVINE', state: 'NSW' },
  { postCode: '2786', suburb: 'MOUNT VICTORIA', state: 'NSW' },
  { postCode: '2786', suburb: 'MOUNT WILSON', state: 'NSW' },
  { postCode: '2787', suburb: 'BLACK SPRINGS', state: 'NSW' },
  { postCode: '2787', suburb: 'CHATHAM VALLEY', state: 'NSW' },
  { postCode: '2787', suburb: 'DUCKMALOI', state: 'NSW' },
  { postCode: '2787', suburb: 'EDITH', state: 'NSW' },
  { postCode: '2787', suburb: 'ESSINGTON', state: 'NSW' },
  { postCode: '2787', suburb: 'GINGKIN', state: 'NSW' },
  { postCode: '2787', suburb: 'GURNANG', state: 'NSW' },
  { postCode: '2787', suburb: 'HAZELGROVE', state: 'NSW' },
  { postCode: '2787', suburb: 'JAUNTER', state: 'NSW' },
  { postCode: '2787', suburb: 'KANANGRA', state: 'NSW' },
  { postCode: '2787', suburb: 'MAYFIELD', state: 'NSW' },
  { postCode: '2787', suburb: 'MOUNT OLIVE', state: 'NSW' },
  { postCode: '2787', suburb: 'MOUNT WERONG', state: 'NSW' },
  { postCode: '2787', suburb: 'MOZART', state: 'NSW' },
  { postCode: '2787', suburb: 'NORWAY', state: 'NSW' },
  { postCode: '2787', suburb: 'OBERON', state: 'NSW' },
  { postCode: '2787', suburb: 'PORTERS RETREAT', state: 'NSW' },
  { postCode: '2787', suburb: 'SHOOTERS HILL', state: 'NSW' },
  { postCode: '2787', suburb: 'TARANA', state: 'NSW' },
  { postCode: '2787', suburb: 'THE MEADOWS', state: 'NSW' },
  { postCode: '2787', suburb: 'YERRANDERIE', state: 'NSW' },
  { postCode: '2790', suburb: 'BEN BULLEN', state: 'NSW' },
  { postCode: '2790', suburb: 'BLACKMANS FLAT', state: 'NSW' },
  { postCode: '2790', suburb: 'BOWENFELS', state: 'NSW' },
  { postCode: '2790', suburb: 'CLARENCE', state: 'NSW' },
  { postCode: '2790', suburb: 'COBAR PARK', state: 'NSW' },
  { postCode: '2790', suburb: 'CORNEY TOWN', state: 'NSW' },
  { postCode: '2790', suburb: 'CULLEN BULLEN', state: 'NSW' },
  { postCode: '2790', suburb: 'DOCTORS GAP', state: 'NSW' },
  { postCode: '2790', suburb: 'GANBENANG', state: 'NSW' },
  { postCode: '2790', suburb: 'GOOD FOREST', state: 'NSW' },
  { postCode: '2790', suburb: 'HAMPTON', state: 'NSW' },
  { postCode: '2790', suburb: 'HARTLEY', state: 'NSW' },
  { postCode: '2790', suburb: 'HARTLEY VALE', state: 'NSW' },
  { postCode: '2790', suburb: 'HASSANS WALLS', state: 'NSW' },
  { postCode: '2790', suburb: 'HERMITAGE FLAT', state: 'NSW' },
  { postCode: '2790', suburb: 'JENOLAN', state: 'NSW' },
  { postCode: '2790', suburb: 'KANIMBLA', state: 'NSW' },
  { postCode: '2790', suburb: 'LIDSDALE', state: 'NSW' },
  { postCode: '2790', suburb: 'LITHGOW', state: 'NSW' },
  { postCode: '2790', suburb: 'LITTLE HARTLEY', state: 'NSW' },
  { postCode: '2790', suburb: 'LITTLETON', state: 'NSW' },
  { postCode: '2790', suburb: 'LOWTHER', state: 'NSW' },
  { postCode: '2790', suburb: 'MARRANGAROO', state: 'NSW' },
  { postCode: '2790', suburb: 'MCKELLARS PARK', state: 'NSW' },
  { postCode: '2790', suburb: 'MORTS ESTATE', state: 'NSW' },
  { postCode: '2790', suburb: 'MOUNT LAMBIE', state: 'NSW' },
  { postCode: '2790', suburb: 'NEWNES', state: 'NSW' },
  { postCode: '2790', suburb: 'NEWNES PLATEAU', state: 'NSW' },
  { postCode: '2790', suburb: 'OAKY PARK', state: 'NSW' },
  { postCode: '2790', suburb: 'POTTERY ESTATE', state: 'NSW' },
  { postCode: '2790', suburb: 'RYDAL', state: 'NSW' },
  { postCode: '2790', suburb: 'SHEEDYS GULLY', state: 'NSW' },
  { postCode: '2790', suburb: 'SODWALLS', state: 'NSW' },
  { postCode: '2790', suburb: 'SOUTH BOWENFELS', state: 'NSW' },
  { postCode: '2790', suburb: 'SOUTH LITTLETON', state: 'NSW' },
  { postCode: '2790', suburb: 'SPRINGVALE', state: 'NSW' },
  { postCode: '2790', suburb: 'STATE MINE GULLY', state: 'NSW' },
  { postCode: '2790', suburb: 'VALE OF CLWYDD', state: 'NSW' },
  { postCode: '2790', suburb: 'WOLGAN VALLEY', state: 'NSW' },
  { postCode: '2790', suburb: 'WOLLANGAMBE', state: 'NSW' },
  { postCode: '2791', suburb: 'CARCOAR', state: 'NSW' },
  { postCode: '2791', suburb: 'ERROWANBANG', state: 'NSW' },
  { postCode: '2792', suburb: 'BURNT YARDS', state: 'NSW' },
  { postCode: '2792', suburb: 'MANDURAMA', state: 'NSW' },
  { postCode: '2793', suburb: 'DARBYS FALLS', state: 'NSW' },
  { postCode: '2793', suburb: 'ROSEBERG', state: 'NSW' },
  { postCode: '2793', suburb: 'WOODSTOCK', state: 'NSW' },
  { postCode: '2794', suburb: 'BUMBALDRY', state: 'NSW' },
  { postCode: '2794', suburb: 'COWRA', state: 'NSW' },
  { postCode: '2794', suburb: 'HOVELLS CREEK', state: 'NSW' },
  { postCode: '2794', suburb: 'MOUNT COLLINS', state: 'NSW' },
  { postCode: '2794', suburb: 'WATTAMONDARA', state: 'NSW' },
  { postCode: '2795', suburb: 'ABERCROMBIE', state: 'NSW' },
  { postCode: '2795', suburb: 'ABERCROMBIE RIVER', state: 'NSW' },
  { postCode: '2795', suburb: 'ARKELL', state: 'NSW' },
  { postCode: '2795', suburb: 'ARKSTONE', state: 'NSW' },
  { postCode: '2795', suburb: 'BALD RIDGE', state: 'NSW' },
  { postCode: '2795', suburb: 'BALLYROE', state: 'NSW' },
  { postCode: '2795', suburb: 'BATHAMPTON', state: 'NSW' },
  { postCode: '2795', suburb: 'BATHURST', state: 'NSW' },
  { postCode: '2795', suburb: 'BATHURST WEST', state: 'NSW' },
  { postCode: '2795', suburb: 'BILLYWILLINGA', state: 'NSW' },
  { postCode: '2795', suburb: 'BREWONGLE', state: 'NSW' },
  { postCode: '2795', suburb: 'BRUINBUN', state: 'NSW' },
  { postCode: '2795', suburb: 'BURRAGA', state: 'NSW' },
  { postCode: '2795', suburb: 'CALOOLA', state: 'NSW' },
  { postCode: '2795', suburb: 'CHARLES STURT UNIVERSITY', state: 'NSW' },
  { postCode: '2795', suburb: 'CHARLTON', state: 'NSW' },
  { postCode: '2795', suburb: 'CLEAR CREEK', state: 'NSW' },
  { postCode: '2795', suburb: 'COLO', state: 'NSW' },
  { postCode: '2795', suburb: 'COPPERHANNIA', state: 'NSW' },
  { postCode: '2795', suburb: 'COW FLAT', state: 'NSW' },
  { postCode: '2795', suburb: 'CRUDINE', state: 'NSW' },
  { postCode: '2795', suburb: 'CURRAGH', state: 'NSW' },
  { postCode: '2795', suburb: 'DARK CORNER', state: 'NSW' },
  { postCode: '2795', suburb: 'DOG ROCKS', state: 'NSW' },
  { postCode: '2795', suburb: 'DUNKELD', state: 'NSW' },
  { postCode: '2795', suburb: 'DURAMANA', state: 'NSW' },
  { postCode: '2795', suburb: 'EGLINTON', state: 'NSW' },
  { postCode: '2795', suburb: 'EVANS PLAINS', state: 'NSW' },
  { postCode: '2795', suburb: 'FITZGERALDS VALLEY', state: 'NSW' },
  { postCode: '2795', suburb: 'FOREST GROVE', state: 'NSW' },
  { postCode: '2795', suburb: 'FOSTERS VALLEY', state: 'NSW' },
  { postCode: '2795', suburb: 'FREEMANTLE', state: 'NSW' },
  { postCode: '2795', suburb: 'GEMALLA', state: 'NSW' },
  { postCode: '2795', suburb: 'GEORGES PLAINS', state: 'NSW' },
  { postCode: '2795', suburb: 'GILMANDYKE', state: 'NSW' },
  { postCode: '2795', suburb: 'GLANMIRE', state: 'NSW' },
  { postCode: '2795', suburb: 'GORMANS HILL', state: 'NSW' },
  { postCode: '2795', suburb: 'GOWAN', state: 'NSW' },
  { postCode: '2795', suburb: 'HOBBYS YARDS', state: 'NSW' },
  { postCode: '2795', suburb: 'ISABELLA', state: 'NSW' },
  { postCode: '2795', suburb: 'JEREMY', state: 'NSW' },
  { postCode: '2795', suburb: 'JUDDS CREEK', state: 'NSW' },
  { postCode: '2795', suburb: 'KELSO', state: 'NSW' },
  { postCode: '2795', suburb: 'KILLONGBUTTA', state: 'NSW' },
  { postCode: '2795', suburb: 'KIRKCONNELL', state: 'NSW' },
  { postCode: '2795', suburb: 'LAFFING WATERS', state: 'NSW' },
  { postCode: '2795', suburb: 'LIMEKILNS', state: 'NSW' },
  { postCode: '2795', suburb: 'LLANARTH', state: 'NSW' },
  { postCode: '2795', suburb: 'LOCKSLEY', state: 'NSW' },
  { postCode: '2795', suburb: 'MEADOW FLAT', state: 'NSW' },
  { postCode: '2795', suburb: 'MILKERS FLAT', state: 'NSW' },
  { postCode: '2795', suburb: 'MILLAH MURRAH', state: 'NSW' },
  { postCode: '2795', suburb: 'MITCHELL', state: 'NSW' },
  { postCode: '2795', suburb: 'MOORILDA', state: 'NSW' },
  { postCode: '2795', suburb: 'MOUNT DAVID', state: 'NSW' },
  { postCode: '2795', suburb: 'MOUNT PANORAMA', state: 'NSW' },
  { postCode: '2795', suburb: 'MOUNT RANKIN', state: 'NSW' },
  { postCode: '2795', suburb: 'NAPOLEON REEF', state: 'NSW' },
  { postCode: '2795', suburb: 'NEWBRIDGE', state: 'NSW' },
  { postCode: '2795', suburb: "O'CONNELL", state: 'NSW' },
  { postCode: '2795', suburb: 'ORTON PARK', state: 'NSW' },
  { postCode: '2795', suburb: 'PALING YARDS', state: 'NSW' },
  { postCode: '2795', suburb: 'PALMERS OAKY', state: 'NSW' },
  { postCode: '2795', suburb: 'PEEL', state: 'NSW' },
  { postCode: '2795', suburb: 'PERTHVILLE', state: 'NSW' },
  { postCode: '2795', suburb: 'RAGLAN', state: 'NSW' },
  { postCode: '2795', suburb: 'ROBIN HILL', state: 'NSW' },
  { postCode: '2795', suburb: 'ROCK FOREST', state: 'NSW' },
  { postCode: '2795', suburb: 'ROCKLEY', state: 'NSW' },
  { postCode: '2795', suburb: 'ROCKLEY MOUNT', state: 'NSW' },
  { postCode: '2795', suburb: 'SOFALA', state: 'NSW' },
  { postCode: '2795', suburb: 'SOUTH BATHURST', state: 'NSW' },
  { postCode: '2795', suburb: 'STEWARTS MOUNT', state: 'NSW' },
  { postCode: '2795', suburb: 'SUNNY CORNER', state: 'NSW' },
  { postCode: '2795', suburb: 'TANNAS MOUNT', state: 'NSW' },
  { postCode: '2795', suburb: 'THE LAGOON', state: 'NSW' },
  { postCode: '2795', suburb: 'THE ROCKS', state: 'NSW' },
  { postCode: '2795', suburb: 'TRIANGLE FLAT', state: 'NSW' },
  { postCode: '2795', suburb: 'TRUNKEY CREEK', state: 'NSW' },
  { postCode: '2795', suburb: 'TURONDALE', state: 'NSW' },
  { postCode: '2795', suburb: 'TWENTY FORESTS', state: 'NSW' },
  { postCode: '2795', suburb: 'UPPER TURON', state: 'NSW' },
  { postCode: '2795', suburb: 'WALANG', state: 'NSW' },
  { postCode: '2795', suburb: 'WAMBOOL', state: 'NSW' },
  { postCode: '2795', suburb: 'WATTLE FLAT', state: 'NSW' },
  { postCode: '2795', suburb: 'WATTON', state: 'NSW' },
  { postCode: '2795', suburb: 'WEST BATHURST', state: 'NSW' },
  { postCode: '2795', suburb: 'WHITE ROCK', state: 'NSW' },
  { postCode: '2795', suburb: 'WIAGDON', state: 'NSW' },
  { postCode: '2795', suburb: 'WIMBLEDON', state: 'NSW' },
  { postCode: '2795', suburb: 'WINBURNDALE', state: 'NSW' },
  { postCode: '2795', suburb: 'WINDRADYNE', state: 'NSW' },
  { postCode: '2795', suburb: 'WISEMANS CREEK', state: 'NSW' },
  { postCode: '2795', suburb: 'YARRAS', state: 'NSW' },
  { postCode: '2795', suburb: 'YETHOLME', state: 'NSW' },
  { postCode: '2797', suburb: 'GARLAND', state: 'NSW' },
  { postCode: '2797', suburb: 'LYNDHURST', state: 'NSW' },
  { postCode: '2798', suburb: 'FOREST REEFS', state: 'NSW' },
  { postCode: '2798', suburb: 'GUYONG', state: 'NSW' },
  { postCode: '2798', suburb: 'MILLTHORPE', state: 'NSW' },
  { postCode: '2798', suburb: 'SPRING TERRACE', state: 'NSW' },
  { postCode: '2798', suburb: 'TALLWOOD', state: 'NSW' },
  { postCode: '2799', suburb: 'BARRY', state: 'NSW' },
  { postCode: '2799', suburb: 'BLAYNEY', state: 'NSW' },
  { postCode: '2799', suburb: 'BROWNS CREEK', state: 'NSW' },
  { postCode: '2799', suburb: 'FITZGERALDS MOUNT', state: 'NSW' },
  { postCode: '2799', suburb: 'KINGS PLAINS', state: 'NSW' },
  { postCode: '2799', suburb: 'NEVILLE', state: 'NSW' },
  { postCode: '2799', suburb: 'VITTORIA', state: 'NSW' },
  { postCode: '2800', suburb: 'BELGRAVIA', state: 'NSW' },
  { postCode: '2800', suburb: 'BOREE', state: 'NSW' },
  { postCode: '2800', suburb: 'BORENORE', state: 'NSW' },
  { postCode: '2800', suburb: 'BYNG', state: 'NSW' },
  { postCode: '2800', suburb: 'CADIA', state: 'NSW' },
  { postCode: '2800', suburb: 'CANOBOLAS', state: 'NSW' },
  { postCode: '2800', suburb: 'CARGO', state: 'NSW' },
  { postCode: '2800', suburb: 'CLERGATE', state: 'NSW' },
  { postCode: '2800', suburb: 'CLIFTON GROVE', state: 'NSW' },
  { postCode: '2800', suburb: 'EMU SWAMP', state: 'NSW' },
  { postCode: '2800', suburb: 'FOUR MILE CREEK', state: 'NSW' },
  { postCode: '2800', suburb: 'HUNTLEY', state: 'NSW' },
  { postCode: '2800', suburb: 'KANGAROOBIE', state: 'NSW' },
  { postCode: '2800', suburb: 'KERRS CREEK', state: 'NSW' },
  { postCode: '2800', suburb: 'LEWIS PONDS', state: 'NSW' },
  { postCode: '2800', suburb: 'LIDSTER', state: 'NSW' },
  { postCode: '2800', suburb: 'LOWER LEWIS PONDS', state: 'NSW' },
  { postCode: '2800', suburb: 'LUCKNOW', state: 'NSW' },
  { postCode: '2800', suburb: 'MARCH', state: 'NSW' },
  { postCode: '2800', suburb: 'MULLION CREEK', state: 'NSW' },
  { postCode: '2800', suburb: 'NASHDALE', state: 'NSW' },
  { postCode: '2800', suburb: 'OPHIR', state: 'NSW' },
  { postCode: '2800', suburb: 'ORANGE', state: 'NSW' },
  { postCode: '2800', suburb: 'ORANGE DC', state: 'NSW' },
  { postCode: '2800', suburb: 'ORANGE EAST', state: 'NSW' },
  { postCode: '2800', suburb: 'ORANGE MOULDER STREET', state: 'NSW' },
  { postCode: '2800', suburb: 'PANUARA', state: 'NSW' },
  { postCode: '2800', suburb: 'SHADFORTH', state: 'NSW' },
  { postCode: '2800', suburb: 'SPRING CREEK', state: 'NSW' },
  { postCode: '2800', suburb: 'SPRING HILL', state: 'NSW' },
  { postCode: '2800', suburb: 'SPRINGSIDE', state: 'NSW' },
  { postCode: '2800', suburb: 'SUMMER HILL CREEK', state: 'NSW' },
  { postCode: '2800', suburb: 'WALDEGRAVE', state: 'NSW' },
  { postCode: '2800', suburb: 'WINDERA', state: 'NSW' },
  { postCode: '2803', suburb: 'BENDICK MURRELL', state: 'NSW' },
  { postCode: '2803', suburb: 'CROWTHER', state: 'NSW' },
  { postCode: '2803', suburb: 'WIRRIMAH', state: 'NSW' },
  { postCode: '2804', suburb: 'BILLIMARI', state: 'NSW' },
  { postCode: '2804', suburb: 'CANOWINDRA', state: 'NSW' },
  { postCode: '2804', suburb: 'MOORBEL', state: 'NSW' },
  { postCode: '2804', suburb: 'NYRANG CREEK', state: 'NSW' },
  { postCode: '2805', suburb: 'GOOLOOGONG', state: 'NSW' },
  { postCode: '2806', suburb: 'EUGOWRA', state: 'NSW' },
  { postCode: '2807', suburb: 'KOORAWATHA', state: 'NSW' },
  { postCode: '2808', suburb: 'WYANGALA', state: 'NSW' },
  { postCode: '2809', suburb: 'GREENETHORPE', state: 'NSW' },
  { postCode: '2810', suburb: 'BIMBI', state: 'NSW' },
  { postCode: '2810', suburb: 'CARAGABAL', state: 'NSW' },
  { postCode: '2810', suburb: 'GLENELG', state: 'NSW' },
  { postCode: '2810', suburb: 'GRENFELL', state: 'NSW' },
  { postCode: '2810', suburb: 'PINEY RANGE', state: 'NSW' },
  { postCode: '2810', suburb: 'PINNACLE', state: 'NSW' },
  { postCode: '2810', suburb: 'PULLABOOKA', state: 'NSW' },
  { postCode: '2810', suburb: 'WARRADERRY', state: 'NSW' },
  { postCode: '2817', suburb: 'TONDERBURINE', state: 'NSW' },
  { postCode: '2817', suburb: 'TOORAWEENAH', state: 'NSW' },
  { postCode: '2818', suburb: 'BENOLONG', state: 'NSW' },
  { postCode: '2818', suburb: 'GEURIE', state: 'NSW' },
  { postCode: '2818', suburb: 'PONTO', state: 'NSW' },
  { postCode: '2818', suburb: 'TERRABELLA', state: 'NSW' },
  { postCode: '2820', suburb: 'APSLEY', state: 'NSW' },
  { postCode: '2820', suburb: 'ARTHURVILLE', state: 'NSW' },
  { postCode: '2820', suburb: 'BAKERS SWAMP', state: 'NSW' },
  { postCode: '2820', suburb: 'BODANGORA', state: 'NSW' },
  { postCode: '2820', suburb: 'COMOBELLA', state: 'NSW' },
  { postCode: '2820', suburb: 'CURRA CREEK', state: 'NSW' },
  { postCode: '2820', suburb: 'DRIPSTONE', state: 'NSW' },
  { postCode: '2820', suburb: 'FARNHAM', state: 'NSW' },
  { postCode: '2820', suburb: 'GOLLAN', state: 'NSW' },
  { postCode: '2820', suburb: 'LAKE BURRENDONG', state: 'NSW' },
  { postCode: '2820', suburb: 'MARYVALE', state: 'NSW' },
  { postCode: '2820', suburb: 'MEDWAY', state: 'NSW' },
  { postCode: '2820', suburb: 'MONTEFIORES', state: 'NSW' },
  { postCode: '2820', suburb: 'MOOKERAWA', state: 'NSW' },
  { postCode: '2820', suburb: 'MOUNT AQUILA', state: 'NSW' },
  { postCode: '2820', suburb: 'MOUNT ARTHUR', state: 'NSW' },
  { postCode: '2820', suburb: 'MUMBIL', state: 'NSW' },
  { postCode: '2820', suburb: 'NEUREA', state: 'NSW' },
  { postCode: '2820', suburb: 'SPICERS CREEK', state: 'NSW' },
  { postCode: '2820', suburb: 'STUART TOWN', state: 'NSW' },
  { postCode: '2820', suburb: 'SUNTOP', state: 'NSW' },
  { postCode: '2820', suburb: 'WALMER', state: 'NSW' },
  { postCode: '2820', suburb: 'WELLINGTON', state: 'NSW' },
  { postCode: '2820', suburb: 'WUULUMAN', state: 'NSW' },
  { postCode: '2820', suburb: 'YARRAGAL', state: 'NSW' },
  { postCode: '2821', suburb: 'BURROWAY', state: 'NSW' },
  { postCode: '2821', suburb: 'NARROMINE', state: 'NSW' },
  { postCode: '2822', suburb: 'BALLADORAN', state: 'NSW' },
  { postCode: '2822', suburb: 'EUMUNGERIE', state: 'NSW' },
  { postCode: '2823', suburb: 'BUNDEMAR', state: 'NSW' },
  { postCode: '2823', suburb: 'CATHUNDRAL', state: 'NSW' },
  { postCode: '2823', suburb: 'DANDALOO', state: 'NSW' },
  { postCode: '2823', suburb: 'GIN GIN', state: 'NSW' },
  { postCode: '2823', suburb: 'TRANGIE', state: 'NSW' },
  { postCode: '2824', suburb: 'BEEMUNNEL', state: 'NSW' },
  { postCode: '2824', suburb: 'BULLAGREEN', state: 'NSW' },
  { postCode: '2824', suburb: 'EENAWEENA', state: 'NSW' },
  { postCode: '2824', suburb: 'MARTHAGUY', state: 'NSW' },
  { postCode: '2824', suburb: 'MOUNT FOSTER', state: 'NSW' },
  { postCode: '2824', suburb: 'MOUNT HARRIS', state: 'NSW' },
  { postCode: '2824', suburb: 'MUMBLEBONE PLAIN', state: 'NSW' },
  { postCode: '2824', suburb: 'OXLEY', state: 'NSW' },
  { postCode: '2824', suburb: 'PIGEONBAH', state: 'NSW' },
  { postCode: '2824', suburb: 'PINE CLUMP', state: 'NSW' },
  { postCode: '2824', suburb: 'RAVENSWOOD', state: 'NSW' },
  { postCode: '2824', suburb: 'RED HILL', state: 'NSW' },
  { postCode: '2824', suburb: 'SNAKES PLAIN', state: 'NSW' },
  { postCode: '2824', suburb: 'TENANDRA', state: 'NSW' },
  { postCode: '2824', suburb: 'WARREN', state: 'NSW' },
  { postCode: '2825', suburb: 'BABINDA', state: 'NSW' },
  { postCode: '2825', suburb: 'BUDDABADAH', state: 'NSW' },
  { postCode: '2825', suburb: 'CANONBA', state: 'NSW' },
  { postCode: '2825', suburb: 'HONEYBUGLE', state: 'NSW' },
  { postCode: '2825', suburb: 'MIANDETTA', state: 'NSW' },
  { postCode: '2825', suburb: 'MULLA', state: 'NSW' },
  { postCode: '2825', suburb: 'MULLENGUDGERY', state: 'NSW' },
  { postCode: '2825', suburb: 'MURRAWOMBIE', state: 'NSW' },
  { postCode: '2825', suburb: 'NYNGAN', state: 'NSW' },
  { postCode: '2825', suburb: 'PANGEE', state: 'NSW' },
  { postCode: '2826', suburb: 'BOGAN', state: 'NSW' },
  { postCode: '2826', suburb: 'NEVERTIRE', state: 'NSW' },
  { postCode: '2827', suburb: 'BEARBONG', state: 'NSW' },
  { postCode: '2827', suburb: 'BIDDON', state: 'NSW' },
  { postCode: '2827', suburb: 'BREELONG', state: 'NSW' },
  { postCode: '2827', suburb: 'COLLIE', state: 'NSW' },
  { postCode: '2827', suburb: 'CURBAN', state: 'NSW' },
  { postCode: '2827', suburb: 'GILGANDRA', state: 'NSW' },
  { postCode: '2827', suburb: 'MERRIGAL', state: 'NSW' },
  { postCode: '2828', suburb: 'ARMATREE', state: 'NSW' },
  { postCode: '2828', suburb: 'BLACK HOLLOW', state: 'NSW' },
  { postCode: '2828', suburb: 'BOURBAH', state: 'NSW' },
  { postCode: '2828', suburb: 'GULARGAMBONE', state: 'NSW' },
  { postCode: '2828', suburb: 'MOUNT TENANDRA', state: 'NSW' },
  { postCode: '2828', suburb: 'QUANDA', state: 'NSW' },
  { postCode: '2828', suburb: 'WARRUMBUNGLE', state: 'NSW' },
  { postCode: '2829', suburb: 'BILLEROY', state: 'NSW' },
  { postCode: '2829', suburb: 'COMBARA', state: 'NSW' },
  { postCode: '2829', suburb: 'CONIMBIA', state: 'NSW' },
  { postCode: '2829', suburb: 'COONAMBLE', state: 'NSW' },
  { postCode: '2829', suburb: 'GILGOOMA', state: 'NSW' },
  { postCode: '2829', suburb: 'GUNGALMAN', state: 'NSW' },
  { postCode: '2829', suburb: 'MAGOMETON', state: 'NSW' },
  { postCode: '2829', suburb: 'NEBEA', state: 'NSW' },
  { postCode: '2829', suburb: 'PINE GROVE', state: 'NSW' },
  { postCode: '2829', suburb: 'TERIDGERIE', state: 'NSW' },
  { postCode: '2829', suburb: 'TOOLOON', state: 'NSW' },
  { postCode: '2829', suburb: 'URAWILKIE', state: 'NSW' },
  { postCode: '2829', suburb: 'WINGADEE', state: 'NSW' },
  { postCode: '2830', suburb: 'BALLIMORE', state: 'NSW' },
  { postCode: '2830', suburb: 'BROCKLEHURST', state: 'NSW' },
  { postCode: '2830', suburb: 'DUBBO', state: 'NSW' },
  { postCode: '2830', suburb: 'DUBBO DC', state: 'NSW' },
  { postCode: '2830', suburb: 'DUBBO EAST', state: 'NSW' },
  { postCode: '2830', suburb: 'DUBBO GROVE', state: 'NSW' },
  { postCode: '2830', suburb: 'DUBBO WEST', state: 'NSW' },
  { postCode: '2830', suburb: 'GOONOO FOREST', state: 'NSW' },
  { postCode: '2830', suburb: 'KICKABIL', state: 'NSW' },
  { postCode: '2830', suburb: 'MINORE', state: 'NSW' },
  { postCode: '2830', suburb: 'MOGRIGUY', state: 'NSW' },
  { postCode: '2830', suburb: 'RAWSONVILLE', state: 'NSW' },
  { postCode: '2830', suburb: 'TERRAMUNGAMINE', state: 'NSW' },
  { postCode: '2830', suburb: 'TOONGI', state: 'NSW' },
  { postCode: '2830', suburb: 'WAMBANGALANG', state: 'NSW' },
  { postCode: '2831', suburb: 'BYROCK', state: 'NSW' },
  { postCode: '2831', suburb: 'CARINDA', state: 'NSW' },
  { postCode: '2831', suburb: 'COOLABAH', state: 'NSW' },
  { postCode: '2831', suburb: 'ELONG ELONG', state: 'NSW' },
  { postCode: '2831', suburb: 'GIRILAMBONE', state: 'NSW' },
  { postCode: '2831', suburb: 'HERMIDALE', state: 'NSW' },
  { postCode: '2831', suburb: 'MACQUARIE MARSHES', state: 'NSW' },
  { postCode: '2831', suburb: 'MERRYGOEN', state: 'NSW' },
  { postCode: '2831', suburb: 'NEILREX', state: 'NSW' },
  { postCode: '2831', suburb: 'NYMAGEE', state: 'NSW' },
  { postCode: '2831', suburb: 'QUAMBONE', state: 'NSW' },
  { postCode: '2831', suburb: 'THE MARRA', state: 'NSW' },
  { postCode: '2831', suburb: 'WONGARBON', state: 'NSW' },
  { postCode: '2832', suburb: 'COME BY CHANCE', state: 'NSW' },
  { postCode: '2832', suburb: 'CRYON', state: 'NSW' },
  { postCode: '2832', suburb: 'CUMBORAH', state: 'NSW' },
  { postCode: '2832', suburb: 'GRAWIN OPAL FIELDS', state: 'NSW' },
  { postCode: '2832', suburb: 'WALGETT', state: 'NSW' },
  { postCode: '2833', suburb: 'COLLARENEBRI', state: 'NSW' },
  { postCode: '2834', suburb: 'ANGLEDOOL', state: 'NSW' },
  { postCode: '2834', suburb: 'LIGHTNING RIDGE', state: 'NSW' },
  { postCode: '2835', suburb: 'BULLA', state: 'NSW' },
  { postCode: '2835', suburb: 'CANBELEGO', state: 'NSW' },
  { postCode: '2835', suburb: 'COBAR', state: 'NSW' },
  { postCode: '2835', suburb: 'CUBBA', state: 'NSW' },
  { postCode: '2835', suburb: 'IRYMPLE', state: 'NSW' },
  { postCode: '2835', suburb: 'KERRIGUNDI', state: 'NSW' },
  { postCode: '2835', suburb: 'KULWIN', state: 'NSW' },
  { postCode: '2835', suburb: 'NOONA', state: 'NSW' },
  { postCode: '2835', suburb: 'SANDY CREEK', state: 'NSW' },
  { postCode: '2835', suburb: 'TINDAREY', state: 'NSW' },
  { postCode: '2836', suburb: 'WHITE CLIFFS', state: 'NSW' },
  { postCode: '2836', suburb: 'WILCANNIA', state: 'NSW' },
  { postCode: '2838', suburb: 'GOODOOGA', state: 'NSW' },
  { postCode: '2839', suburb: 'BREWARRINA', state: 'NSW' },
  { postCode: '2839', suburb: 'COLLERINA', state: 'NSW' },
  { postCode: '2839', suburb: 'GONGOLGON', state: 'NSW' },
  { postCode: '2839', suburb: 'NARRAN LAKE', state: 'NSW' },
  { postCode: '2839', suburb: 'TALAWANTA', state: 'NSW' },
  { postCode: '2839', suburb: 'WEILMORINGLE', state: 'NSW' },
  { postCode: '2840', suburb: 'BARRINGUN', state: 'NSW' },
  { postCode: '2840', suburb: 'BOURKE', state: 'NSW' },
  { postCode: '2840', suburb: 'ENNGONIA', state: 'NSW' },
  { postCode: '2840', suburb: 'FORDS BRIDGE', state: 'NSW' },
  { postCode: '2840', suburb: 'GUMBALIE', state: 'NSW' },
  { postCode: '2840', suburb: 'GUNDERBOOKA', state: 'NSW' },
  { postCode: '2840', suburb: 'HUNGERFORD', state: 'NSW' },
  { postCode: '2840', suburb: 'LOUTH', state: 'NSW' },
  { postCode: '2840', suburb: 'NORTH BOURKE', state: 'NSW' },
  { postCode: '2840', suburb: 'TILPA', state: 'NSW' },
  { postCode: '2840', suburb: 'WANAARING', state: 'NSW' },
  { postCode: '2840', suburb: 'YANTABULLA', state: 'NSW' },
  { postCode: '2842', suburb: 'MENDOORAN', state: 'NSW' },
  { postCode: '2842', suburb: 'MOLLYAN', state: 'NSW' },
  { postCode: '2842', suburb: 'YARRAGRIN', state: 'NSW' },
  { postCode: '2843', suburb: 'COOLAH', state: 'NSW' },
  { postCode: '2844', suburb: 'BIRRIWA', state: 'NSW' },
  { postCode: '2844', suburb: 'DUNEDOO', state: 'NSW' },
  { postCode: '2844', suburb: 'LEADVILLE', state: 'NSW' },
  { postCode: '2845', suburb: 'WALLERAWANG', state: 'NSW' },
  { postCode: '2846', suburb: 'CAPERTEE', state: 'NSW' },
  { postCode: '2846', suburb: 'GLEN DAVIS', state: 'NSW' },
  { postCode: '2846', suburb: 'ROUND SWAMP', state: 'NSW' },
  { postCode: '2847', suburb: 'PORTLAND', state: 'NSW' },
  { postCode: '2848', suburb: 'BROGANS CREEK', state: 'NSW' },
  { postCode: '2848', suburb: 'CHARBON', state: 'NSW' },
  { postCode: '2848', suburb: 'CLANDULLA', state: 'NSW' },
  { postCode: '2848', suburb: 'KANDOS', state: 'NSW' },
  { postCode: '2849', suburb: 'BOGEE', state: 'NSW' },
  { postCode: '2849', suburb: 'BREAKFAST CREEK', state: 'NSW' },
  { postCode: '2849', suburb: 'BUDDEN', state: 'NSW' },
  { postCode: '2849', suburb: 'BYLONG', state: 'NSW' },
  { postCode: '2849', suburb: 'CAMBOON', state: 'NSW' },
  { postCode: '2849', suburb: 'CARWELL', state: 'NSW' },
  { postCode: '2849', suburb: 'COGGAN', state: 'NSW' },
  { postCode: '2849', suburb: 'COXS CREEK', state: 'NSW' },
  { postCode: '2849', suburb: 'COXS CROWN', state: 'NSW' },
  { postCode: '2849', suburb: 'DABEE', state: 'NSW' },
  { postCode: '2849', suburb: 'DUNGEREE', state: 'NSW' },
  { postCode: '2849', suburb: 'DUNVILLE LOOP', state: 'NSW' },
  { postCode: '2849', suburb: 'GINGHI', state: 'NSW' },
  { postCode: '2849', suburb: 'GLEN ALICE', state: 'NSW' },
  { postCode: '2849', suburb: 'GROWEE', state: 'NSW' },
  { postCode: '2849', suburb: 'KELGOOLA', state: 'NSW' },
  { postCode: '2849', suburb: 'LEE CREEK', state: 'NSW' },
  { postCode: '2849', suburb: 'MOUNT MARSDEN', state: 'NSW' },
  { postCode: '2849', suburb: 'MURRUMBO', state: 'NSW' },
  { postCode: '2849', suburb: 'NULLO MOUNTAIN', state: 'NSW' },
  { postCode: '2849', suburb: 'OLINDA', state: 'NSW' },
  { postCode: '2849', suburb: 'PINNACLE SWAMP', state: 'NSW' },
  { postCode: '2849', suburb: 'PYANGLE', state: 'NSW' },
  { postCode: '2849', suburb: 'REEDY CREEK', state: 'NSW' },
  { postCode: '2849', suburb: 'RYLSTONE', state: 'NSW' },
  { postCode: '2849', suburb: 'UPPER BYLONG', state: 'NSW' },
  { postCode: '2849', suburb: 'UPPER GROWEE', state: 'NSW' },
  { postCode: '2849', suburb: 'UPPER NILE', state: 'NSW' },
  { postCode: '2849', suburb: 'WIRRABA', state: 'NSW' },
  { postCode: '2850', suburb: 'AARONS PASS', state: 'NSW' },
  { postCode: '2850', suburb: 'APPLE TREE FLAT', state: 'NSW' },
  { postCode: '2850', suburb: 'AVISFORD', state: 'NSW' },
  { postCode: '2850', suburb: 'BARA', state: 'NSW' },
  { postCode: '2850', suburb: 'BARIGAN', state: 'NSW' },
  { postCode: '2850', suburb: 'BOCOBLE', state: 'NSW' },
  { postCode: '2850', suburb: 'BOMBIRA', state: 'NSW' },
  { postCode: '2850', suburb: 'BOTOBOLAR', state: 'NSW' },
  { postCode: '2850', suburb: 'BUCKAROO', state: 'NSW' },
  { postCode: '2850', suburb: 'BUDGEE BUDGEE', state: 'NSW' },
  { postCode: '2850', suburb: 'BURRUNDULLA', state: 'NSW' },
  { postCode: '2850', suburb: 'CAERLEON', state: 'NSW' },
  { postCode: '2850', suburb: 'CANADIAN LEAD', state: 'NSW' },
  { postCode: '2850', suburb: 'CARCALGONG', state: 'NSW' },
  { postCode: '2850', suburb: 'COLLINGWOOD', state: 'NSW' },
  { postCode: '2850', suburb: 'COOKS GAP', state: 'NSW' },
  { postCode: '2850', suburb: 'COOYAL', state: 'NSW' },
  { postCode: '2850', suburb: 'CROSS ROADS', state: 'NSW' },
  { postCode: '2850', suburb: 'CUDGEGONG', state: 'NSW' },
  { postCode: '2850', suburb: 'CULLENBONE', state: 'NSW' },
  { postCode: '2850', suburb: 'CUMBO', state: 'NSW' },
  { postCode: '2850', suburb: 'ERUDGERE', state: 'NSW' },
  { postCode: '2850', suburb: 'EURUNDEREE', state: 'NSW' },
  { postCode: '2850', suburb: 'FROG ROCK', state: 'NSW' },
  { postCode: '2850', suburb: 'GALAMBINE', state: 'NSW' },
  { postCode: '2850', suburb: 'GRATTAI', state: 'NSW' },
  { postCode: '2850', suburb: 'GREEN GULLY', state: 'NSW' },
  { postCode: '2850', suburb: 'HARGRAVES', state: 'NSW' },
  { postCode: '2850', suburb: 'HAVILAH', state: 'NSW' },
  { postCode: '2850', suburb: 'HAYES GAP', state: 'NSW' },
  { postCode: '2850', suburb: 'HILL END', state: 'NSW' },
  { postCode: '2850', suburb: 'HOME RULE', state: 'NSW' },
  { postCode: '2850', suburb: 'ILFORD', state: 'NSW' },
  { postCode: '2850', suburb: 'KAINS FLAT', state: 'NSW' },
  { postCode: '2850', suburb: 'LINBURN', state: 'NSW' },
  { postCode: '2850', suburb: 'LUE', state: 'NSW' },
  { postCode: '2850', suburb: 'MAITLAND BAR', state: 'NSW' },
  { postCode: '2850', suburb: 'MENAH', state: 'NSW' },
  { postCode: '2850', suburb: 'MEROO', state: 'NSW' },
  { postCode: '2850', suburb: 'MILROY', state: 'NSW' },
  { postCode: '2850', suburb: 'MOGO', state: 'NSW' },
  { postCode: '2850', suburb: 'MONIVAE', state: 'NSW' },
  { postCode: '2850', suburb: 'MOOLARBEN', state: 'NSW' },
  { postCode: '2850', suburb: 'MOUNT FROME', state: 'NSW' },
  { postCode: '2850', suburb: 'MOUNT KNOWLES', state: 'NSW' },
  { postCode: '2850', suburb: 'MUDGEE', state: 'NSW' },
  { postCode: '2850', suburb: 'MULLAMUDDY', state: 'NSW' },
  { postCode: '2850', suburb: 'MUNGHORN', state: 'NSW' },
  { postCode: '2850', suburb: 'PIAMBONG', state: 'NSW' },
  { postCode: '2850', suburb: 'PUTTA BUCCA', state: 'NSW' },
  { postCode: '2850', suburb: 'PYRAMUL', state: 'NSW' },
  { postCode: '2850', suburb: 'QUEENS PINCH', state: 'NSW' },
  { postCode: '2850', suburb: 'RIVERLEA', state: 'NSW' },
  { postCode: '2850', suburb: 'RUNNING STREAM', state: 'NSW' },
  { postCode: '2850', suburb: 'SALLYS FLAT', state: 'NSW' },
  { postCode: '2850', suburb: 'SPRING FLAT', state: 'NSW' },
  { postCode: '2850', suburb: 'ST FILLANS', state: 'NSW' },
  { postCode: '2850', suburb: 'STONY CREEK', state: 'NSW' },
  { postCode: '2850', suburb: 'TAMBAROORA', state: 'NSW' },
  { postCode: '2850', suburb: 'TICHULAR', state: 'NSW' },
  { postCode: '2850', suburb: 'TOTNES VALLEY', state: 'NSW' },
  { postCode: '2850', suburb: 'TRIAMBLE', state: 'NSW' },
  { postCode: '2850', suburb: 'TURILL', state: 'NSW' },
  { postCode: '2850', suburb: 'TWELVE MILE', state: 'NSW' },
  { postCode: '2850', suburb: 'ULAN', state: 'NSW' },
  { postCode: '2850', suburb: 'ULLAMALLA', state: 'NSW' },
  { postCode: '2850', suburb: 'WILBETREE', state: 'NSW' },
  { postCode: '2850', suburb: 'WILPINJONG', state: 'NSW' },
  { postCode: '2850', suburb: 'WINDEYER', state: 'NSW' },
  { postCode: '2850', suburb: 'WOLLAR', state: 'NSW' },
  { postCode: '2850', suburb: 'WORLDS END', state: 'NSW' },
  { postCode: '2850', suburb: 'YARRABIN', state: 'NSW' },
  { postCode: '2850', suburb: 'YARRAWONGA', state: 'NSW' },
  { postCode: '2852', suburb: 'BARNEYS REEF', state: 'NSW' },
  { postCode: '2852', suburb: 'BERYL', state: 'NSW' },
  { postCode: '2852', suburb: 'BUNGABA', state: 'NSW' },
  { postCode: '2852', suburb: 'COPE', state: 'NSW' },
  { postCode: '2852', suburb: 'CUMBANDRY', state: 'NSW' },
  { postCode: '2852', suburb: 'GOOLMA', state: 'NSW' },
  { postCode: '2852', suburb: 'GULGONG', state: 'NSW' },
  { postCode: '2852', suburb: 'GUNTAWANG', state: 'NSW' },
  { postCode: '2852', suburb: 'MEBUL', state: 'NSW' },
  { postCode: '2852', suburb: 'MEROTHERIE', state: 'NSW' },
  { postCode: '2852', suburb: 'STUBBO', state: 'NSW' },
  { postCode: '2852', suburb: 'TALLAWANG', state: 'NSW' },
  { postCode: '2852', suburb: 'TWO MILE FLAT', state: 'NSW' },
  { postCode: '2864', suburb: 'BOWAN PARK', state: 'NSW' },
  { postCode: '2864', suburb: 'CUDAL', state: 'NSW' },
  { postCode: '2864', suburb: 'MURGA', state: 'NSW' },
  { postCode: '2864', suburb: 'TOOGONG', state: 'NSW' },
  { postCode: '2865', suburb: 'BOCOBRA', state: 'NSW' },
  { postCode: '2865', suburb: 'GUMBLE', state: 'NSW' },
  { postCode: '2865', suburb: 'MANILDRA', state: 'NSW' },
  { postCode: '2866', suburb: 'AMAROO', state: 'NSW' },
  { postCode: '2866', suburb: 'BOOMEY', state: 'NSW' },
  { postCode: '2866', suburb: 'CUNDUMBUL', state: 'NSW' },
  { postCode: '2866', suburb: 'EUCHAREENA', state: 'NSW' },
  { postCode: '2866', suburb: 'GARRA', state: 'NSW' },
  { postCode: '2866', suburb: 'LARRAS LEE', state: 'NSW' },
  { postCode: '2866', suburb: 'MOLONG', state: 'NSW' },
  { postCode: '2867', suburb: 'BALDRY', state: 'NSW' },
  { postCode: '2867', suburb: 'CUMNOCK', state: 'NSW' },
  { postCode: '2867', suburb: 'EURIMBLA', state: 'NSW' },
  { postCode: '2867', suburb: 'LOOMBAH', state: 'NSW' },
  { postCode: '2867', suburb: 'YULLUNDRY', state: 'NSW' },
  { postCode: '2868', suburb: 'BOURNEWOOD', state: 'NSW' },
  { postCode: '2868', suburb: 'NORTH YEOVAL', state: 'NSW' },
  { postCode: '2868', suburb: 'OBLEY', state: 'NSW' },
  { postCode: '2868', suburb: 'YEOVAL', state: 'NSW' },
  { postCode: '2869', suburb: 'PEAK HILL', state: 'NSW' },
  { postCode: '2869', suburb: 'TOMINGLEY', state: 'NSW' },
  { postCode: '2869', suburb: 'TREWILGA', state: 'NSW' },
  { postCode: '2870', suburb: 'ALECTOWN', state: 'NSW' },
  { postCode: '2870', suburb: 'BUMBERRY', state: 'NSW' },
  { postCode: '2870', suburb: 'COOKAMIDGERA', state: 'NSW' },
  { postCode: '2870', suburb: 'COOKS MYALLS', state: 'NSW' },
  { postCode: '2870', suburb: 'DAROOBALGIE', state: 'NSW' },
  { postCode: '2870', suburb: 'GOONUMBLA', state: 'NSW' },
  { postCode: '2870', suburb: 'MANDAGERY', state: 'NSW' },
  { postCode: '2870', suburb: 'PARKES', state: 'NSW' },
  { postCode: '2870', suburb: 'TICHBORNE', state: 'NSW' },
  { postCode: '2871', suburb: 'BEDGERABONG', state: 'NSW' },
  { postCode: '2871', suburb: 'CORINELLA', state: 'NSW' },
  { postCode: '2871', suburb: 'FAIRHOLME', state: 'NSW' },
  { postCode: '2871', suburb: 'FORBES', state: 'NSW' },
  { postCode: '2871', suburb: 'GAREMA', state: 'NSW' },
  { postCode: '2871', suburb: 'JEMALONG', state: 'NSW' },
  { postCode: '2871', suburb: 'MULYANDRY', state: 'NSW' },
  { postCode: '2871', suburb: 'OOMA', state: 'NSW' },
  { postCode: '2871', suburb: 'PAYTENS BRIDGE', state: 'NSW' },
  { postCode: '2871', suburb: 'WARROO', state: 'NSW' },
  { postCode: '2871', suburb: 'WIRRINYA', state: 'NSW' },
  { postCode: '2873', suburb: 'ALBERT', state: 'NSW' },
  { postCode: '2873', suburb: 'FIVE WAYS', state: 'NSW' },
  { postCode: '2873', suburb: 'MIAMLEY', state: 'NSW' },
  { postCode: '2873', suburb: 'TOTTENHAM', state: 'NSW' },
  { postCode: '2874', suburb: 'TULLAMORE', state: 'NSW' },
  { postCode: '2875', suburb: 'BRUIE PLAINS', state: 'NSW' },
  { postCode: '2875', suburb: 'FIFIELD', state: 'NSW' },
  { postCode: '2875', suburb: 'OOTHA', state: 'NSW' },
  { postCode: '2875', suburb: 'TRUNDLE', state: 'NSW' },
  { postCode: '2875', suburb: 'YARRABANDAI', state: 'NSW' },
  { postCode: '2876', suburb: 'BOGAN GATE', state: 'NSW' },
  { postCode: '2876', suburb: 'GUNNING GAP', state: 'NSW' },
  { postCode: '2876', suburb: 'GUNNINGBLAND', state: 'NSW' },
  { postCode: '2876', suburb: 'NELUNGALOO', state: 'NSW' },
  { postCode: '2877', suburb: 'BOBADAH', state: 'NSW' },
  { postCode: '2877', suburb: 'BOONA MOUNT', state: 'NSW' },
  { postCode: '2877', suburb: 'CONDOBOLIN', state: 'NSW' },
  { postCode: '2877', suburb: 'DERRIWONG', state: 'NSW' },
  { postCode: '2877', suburb: 'EREMERANG', state: 'NSW' },
  { postCode: '2877', suburb: 'EUABALONG', state: 'NSW' },
  { postCode: '2877', suburb: 'EUABALONG WEST', state: 'NSW' },
  { postCode: '2877', suburb: 'GILGUNNIA', state: 'NSW' },
  { postCode: '2877', suburb: 'KIACATOO', state: 'NSW' },
  { postCode: '2877', suburb: 'MOUNT HOPE', state: 'NSW' },
  { postCode: '2877', suburb: 'MULGUTHRIE', state: 'NSW' },
  { postCode: '2878', suburb: 'IVANHOE', state: 'NSW' },
  { postCode: '2878', suburb: 'MOSSGIEL', state: 'NSW' },
  { postCode: '2879', suburb: 'MENINDEE', state: 'NSW' },
  { postCode: '2879', suburb: 'SUNSET STRIP', state: 'NSW' },
  { postCode: '2880', suburb: 'BROKEN HILL', state: 'NSW' },
  { postCode: '2880', suburb: 'BROKEN HILL NORTH', state: 'NSW' },
  { postCode: '2880', suburb: 'BROKEN HILL WEST', state: 'NSW' },
  { postCode: '2880', suburb: 'BROUGHAMS GATE', state: 'NSW' },
  { postCode: '2880', suburb: 'FOWLERS GAP', state: 'NSW' },
  { postCode: '2880', suburb: 'LITTLE TOPAR', state: 'NSW' },
  { postCode: '2880', suburb: 'MILPARINKA', state: 'NSW' },
  { postCode: '2880', suburb: 'MUTAWINTJI', state: 'NSW' },
  { postCode: '2880', suburb: 'PACKSADDLE', state: 'NSW' },
  { postCode: '2880', suburb: 'SILVERTON', state: 'NSW' },
  { postCode: '2880', suburb: 'SOUTH BROKEN HILL', state: 'NSW' },
  { postCode: '2880', suburb: 'TIBOOBURRA', state: 'NSW' },
  { postCode: '2890', suburb: 'AUSTRALIAN DEFENCE FORCES', state: 'NSW' },
  { postCode: '2898', suburb: 'LORD HOWE ISLAND', state: 'NSW' },
  { postCode: '2899', suburb: 'NORFOLK ISLAND', state: 'NSW' },
  { postCode: '2900', suburb: 'GREENWAY', state: 'ACT' },
  { postCode: '2901', suburb: 'TUGGERANONG DC', state: 'ACT' },
  { postCode: '2902', suburb: 'KAMBAH', state: 'ACT' },
  { postCode: '2902', suburb: 'KAMBAH VILLAGE', state: 'ACT' },
  { postCode: '2903', suburb: 'ERINDALE CENTRE', state: 'ACT' },
  { postCode: '2903', suburb: 'OXLEY', state: 'ACT' },
  { postCode: '2903', suburb: 'WANNIASSA', state: 'ACT' },
  { postCode: '2904', suburb: 'FADDEN', state: 'ACT' },
  { postCode: '2904', suburb: 'GOWRIE', state: 'ACT' },
  { postCode: '2904', suburb: 'MACARTHUR', state: 'ACT' },
  { postCode: '2904', suburb: 'MONASH', state: 'ACT' },
  { postCode: '2905', suburb: 'BONYTHON', state: 'ACT' },
  { postCode: '2905', suburb: 'CALWELL', state: 'ACT' },
  { postCode: '2905', suburb: 'CHISHOLM', state: 'ACT' },
  { postCode: '2905', suburb: 'GILMORE', state: 'ACT' },
  { postCode: '2905', suburb: 'ISABELLA PLAINS', state: 'ACT' },
  { postCode: '2905', suburb: 'RICHARDSON', state: 'ACT' },
  { postCode: '2905', suburb: 'THEODORE', state: 'ACT' },
  { postCode: '2906', suburb: 'BANKS', state: 'ACT' },
  { postCode: '2906', suburb: 'CONDER', state: 'ACT' },
  { postCode: '2906', suburb: 'GORDON', state: 'ACT' },
  { postCode: '2911', suburb: 'CRACE', state: 'ACT' },
  { postCode: '2911', suburb: 'MITCHELL', state: 'ACT' },
  { postCode: '2912', suburb: 'GUNGAHLIN', state: 'ACT' },
  { postCode: '2913', suburb: 'CASEY', state: 'ACT' },
  { postCode: '2913', suburb: 'FRANKLIN', state: 'ACT' },
  { postCode: '2913', suburb: 'NGUNNAWAL', state: 'ACT' },
  { postCode: '2913', suburb: 'NICHOLLS', state: 'ACT' },
  { postCode: '2913', suburb: 'PALMERSTON', state: 'ACT' },
  { postCode: '2913', suburb: 'TAYLOR', state: 'ACT' },
  { postCode: '2914', suburb: 'AMAROO', state: 'ACT' },
  { postCode: '2914', suburb: 'BONNER', state: 'ACT' },
  { postCode: '2914', suburb: 'FORDE', state: 'ACT' },
  { postCode: '2914', suburb: 'HARRISON', state: 'ACT' },
  { postCode: '2914', suburb: 'JACKA', state: 'ACT' },
  { postCode: '2914', suburb: 'MONCRIEFF', state: 'ACT' },
  { postCode: '2914', suburb: 'THROSBY', state: 'ACT' },
  { postCode: '3000', suburb: 'MELBOURNE', state: 'VIC' },
  { postCode: '3001', suburb: 'MELBOURNE', state: 'VIC' },
  { postCode: '3002', suburb: 'EAST MELBOURNE', state: 'VIC' },
  { postCode: '3003', suburb: 'WEST MELBOURNE', state: 'VIC' },
  { postCode: '3004', suburb: 'MELBOURNE', state: 'VIC' },
  { postCode: '3004', suburb: 'ST KILDA ROAD CENTRAL', state: 'VIC' },
  { postCode: '3004', suburb: 'ST KILDA ROAD MELBOURNE', state: 'VIC' },
  { postCode: '3006', suburb: 'SOUTH WHARF', state: 'VIC' },
  { postCode: '3006', suburb: 'SOUTHBANK', state: 'VIC' },
  { postCode: '3008', suburb: 'DOCKLANDS', state: 'VIC' },
  { postCode: '3010', suburb: 'UNIVERSITY OF MELBOURNE', state: 'VIC' },
  { postCode: '3011', suburb: 'FOOTSCRAY', state: 'VIC' },
  { postCode: '3011', suburb: 'SEDDON', state: 'VIC' },
  { postCode: '3011', suburb: 'SEDDON WEST', state: 'VIC' },
  { postCode: '3012', suburb: 'BROOKLYN', state: 'VIC' },
  { postCode: '3012', suburb: 'KINGSVILLE', state: 'VIC' },
  { postCode: '3012', suburb: 'MAIDSTONE', state: 'VIC' },
  { postCode: '3012', suburb: 'TOTTENHAM', state: 'VIC' },
  { postCode: '3012', suburb: 'WEST FOOTSCRAY', state: 'VIC' },
  { postCode: '3013', suburb: 'YARRAVILLE', state: 'VIC' },
  { postCode: '3013', suburb: 'YARRAVILLE WEST', state: 'VIC' },
  { postCode: '3015', suburb: 'NEWPORT', state: 'VIC' },
  { postCode: '3015', suburb: 'SOUTH KINGSVILLE', state: 'VIC' },
  { postCode: '3015', suburb: 'SPOTSWOOD', state: 'VIC' },
  { postCode: '3016', suburb: 'WILLIAMSTOWN', state: 'VIC' },
  { postCode: '3016', suburb: 'WILLIAMSTOWN NORTH', state: 'VIC' },
  { postCode: '3018', suburb: 'ALTONA', state: 'VIC' },
  { postCode: '3018', suburb: 'SEAHOLME', state: 'VIC' },
  { postCode: '3019', suburb: 'BRAYBROOK', state: 'VIC' },
  { postCode: '3019', suburb: 'ROBINSON', state: 'VIC' },
  { postCode: '3020', suburb: 'ALBION', state: 'VIC' },
  { postCode: '3020', suburb: 'GLENGALA', state: 'VIC' },
  { postCode: '3020', suburb: 'SUNSHINE', state: 'VIC' },
  { postCode: '3020', suburb: 'SUNSHINE NORTH', state: 'VIC' },
  { postCode: '3020', suburb: 'SUNSHINE WEST', state: 'VIC' },
  { postCode: '3021', suburb: 'ALBANVALE', state: 'VIC' },
  { postCode: '3021', suburb: 'KEALBA', state: 'VIC' },
  { postCode: '3021', suburb: 'KINGS PARK', state: 'VIC' },
  { postCode: '3021', suburb: 'ST ALBANS', state: 'VIC' },
  { postCode: '3022', suburb: 'ARDEER', state: 'VIC' },
  { postCode: '3022', suburb: 'DEER PARK EAST', state: 'VIC' },
  { postCode: '3023', suburb: 'BURNSIDE', state: 'VIC' },
  { postCode: '3023', suburb: 'BURNSIDE HEIGHTS', state: 'VIC' },
  { postCode: '3023', suburb: 'CAIRNLEA', state: 'VIC' },
  { postCode: '3023', suburb: 'CAROLINE SPRINGS', state: 'VIC' },
  { postCode: '3023', suburb: 'DEER PARK', state: 'VIC' },
  { postCode: '3023', suburb: 'DEER PARK NORTH', state: 'VIC' },
  { postCode: '3023', suburb: 'RAVENHALL', state: 'VIC' },
  { postCode: '3024', suburb: 'FIELDSTONE', state: 'VIC' },
  { postCode: '3024', suburb: 'MAMBOURIN', state: 'VIC' },
  { postCode: '3024', suburb: 'MANOR LAKES', state: 'VIC' },
  { postCode: '3024', suburb: 'MOUNT COTTRELL', state: 'VIC' },
  { postCode: '3024', suburb: 'WYNDHAM VALE', state: 'VIC' },
  { postCode: '3025', suburb: 'ALTONA EAST', state: 'VIC' },
  { postCode: '3025', suburb: 'ALTONA GATE', state: 'VIC' },
  { postCode: '3025', suburb: 'ALTONA NORTH', state: 'VIC' },
  { postCode: '3026', suburb: 'DERRIMUT', state: 'VIC' },
  { postCode: '3026', suburb: 'LAVERTON NORTH', state: 'VIC' },
  { postCode: '3027', suburb: 'WILLIAMS LANDING', state: 'VIC' },
  { postCode: '3028', suburb: 'ALTONA MEADOWS', state: 'VIC' },
  { postCode: '3028', suburb: 'LAVERTON', state: 'VIC' },
  { postCode: '3028', suburb: 'SEABROOK', state: 'VIC' },
  { postCode: '3029', suburb: 'HOPPERS CROSSING', state: 'VIC' },
  { postCode: '3029', suburb: 'TARNEIT', state: 'VIC' },
  { postCode: '3029', suburb: 'TRUGANINA', state: 'VIC' },
  { postCode: '3030', suburb: 'COCOROC', state: 'VIC' },
  { postCode: '3030', suburb: 'POINT COOK', state: 'VIC' },
  { postCode: '3030', suburb: 'QUANDONG', state: 'VIC' },
  { postCode: '3030', suburb: 'WERRIBEE', state: 'VIC' },
  { postCode: '3030', suburb: 'WERRIBEE SOUTH', state: 'VIC' },
  { postCode: '3031', suburb: 'FLEMINGTON', state: 'VIC' },
  { postCode: '3031', suburb: 'KENSINGTON', state: 'VIC' },
  { postCode: '3032', suburb: 'ASCOT VALE', state: 'VIC' },
  { postCode: '3032', suburb: 'HIGHPOINT CITY', state: 'VIC' },
  { postCode: '3032', suburb: 'MARIBYRNONG', state: 'VIC' },
  { postCode: '3032', suburb: 'TRAVANCORE', state: 'VIC' },
  { postCode: '3033', suburb: 'KEILOR EAST', state: 'VIC' },
  { postCode: '3034', suburb: 'AVONDALE HEIGHTS', state: 'VIC' },
  { postCode: '3036', suburb: 'KEILOR', state: 'VIC' },
  { postCode: '3036', suburb: 'KEILOR NORTH', state: 'VIC' },
  { postCode: '3037', suburb: 'CALDER PARK', state: 'VIC' },
  { postCode: '3037', suburb: 'DELAHEY', state: 'VIC' },
  { postCode: '3037', suburb: 'HILLSIDE', state: 'VIC' },
  { postCode: '3037', suburb: 'SYDENHAM', state: 'VIC' },
  { postCode: '3037', suburb: 'TAYLORS HILL', state: 'VIC' },
  { postCode: '3038', suburb: 'KEILOR DOWNS', state: 'VIC' },
  { postCode: '3038', suburb: 'KEILOR LODGE', state: 'VIC' },
  { postCode: '3038', suburb: 'TAYLORS LAKES', state: 'VIC' },
  { postCode: '3038', suburb: 'WATERGARDENS', state: 'VIC' },
  { postCode: '3039', suburb: 'MOONEE PONDS', state: 'VIC' },
  { postCode: '3040', suburb: 'ABERFELDIE', state: 'VIC' },
  { postCode: '3040', suburb: 'ESSENDON', state: 'VIC' },
  { postCode: '3040', suburb: 'ESSENDON WEST', state: 'VIC' },
  { postCode: '3041', suburb: 'CROSS KEYS', state: 'VIC' },
  { postCode: '3041', suburb: 'ESSENDON FIELDS', state: 'VIC' },
  { postCode: '3041', suburb: 'ESSENDON NORTH', state: 'VIC' },
  { postCode: '3041', suburb: 'STRATHMORE', state: 'VIC' },
  { postCode: '3041', suburb: 'STRATHMORE HEIGHTS', state: 'VIC' },
  { postCode: '3042', suburb: 'AIRPORT WEST', state: 'VIC' },
  { postCode: '3042', suburb: 'KEILOR PARK', state: 'VIC' },
  { postCode: '3042', suburb: 'NIDDRIE', state: 'VIC' },
  { postCode: '3042', suburb: 'NIDDRIE NORTH', state: 'VIC' },
  { postCode: '3043', suburb: 'GLADSTONE PARK', state: 'VIC' },
  { postCode: '3043', suburb: 'GOWANBRAE', state: 'VIC' },
  { postCode: '3043', suburb: 'TULLAMARINE', state: 'VIC' },
  { postCode: '3044', suburb: 'PASCOE VALE', state: 'VIC' },
  { postCode: '3044', suburb: 'PASCOE VALE SOUTH', state: 'VIC' },
  { postCode: '3045', suburb: 'MELBOURNE AIRPORT', state: 'VIC' },
  { postCode: '3046', suburb: 'GLENROY', state: 'VIC' },
  { postCode: '3046', suburb: 'HADFIELD', state: 'VIC' },
  { postCode: '3046', suburb: 'OAK PARK', state: 'VIC' },
  { postCode: '3047', suburb: 'BROADMEADOWS', state: 'VIC' },
  { postCode: '3047', suburb: 'DALLAS', state: 'VIC' },
  { postCode: '3047', suburb: 'JACANA', state: 'VIC' },
  { postCode: '3048', suburb: 'COOLAROO', state: 'VIC' },
  { postCode: '3048', suburb: 'MEADOW HEIGHTS', state: 'VIC' },
  { postCode: '3049', suburb: 'ATTWOOD', state: 'VIC' },
  { postCode: '3049', suburb: 'WESTMEADOWS', state: 'VIC' },
  { postCode: '3050', suburb: 'ROYAL MELBOURNE HOSPITAL', state: 'VIC' },
  { postCode: '3051', suburb: 'HOTHAM HILL', state: 'VIC' },
  { postCode: '3051', suburb: 'NORTH MELBOURNE', state: 'VIC' },
  { postCode: '3052', suburb: 'MELBOURNE UNIVERSITY', state: 'VIC' },
  { postCode: '3052', suburb: 'PARKVILLE', state: 'VIC' },
  { postCode: '3053', suburb: 'CARLTON', state: 'VIC' },
  { postCode: '3053', suburb: 'CARLTON SOUTH', state: 'VIC' },
  { postCode: '3054', suburb: 'CARLTON NORTH', state: 'VIC' },
  { postCode: '3054', suburb: 'PRINCES HILL', state: 'VIC' },
  { postCode: '3055', suburb: 'BRUNSWICK SOUTH', state: 'VIC' },
  { postCode: '3055', suburb: 'BRUNSWICK WEST', state: 'VIC' },
  { postCode: '3055', suburb: 'MOONEE VALE', state: 'VIC' },
  { postCode: '3055', suburb: 'MORELAND WEST', state: 'VIC' },
  { postCode: '3056', suburb: 'BRUNSWICK', state: 'VIC' },
  { postCode: '3056', suburb: 'BRUNSWICK LOWER', state: 'VIC' },
  { postCode: '3056', suburb: 'BRUNSWICK NORTH', state: 'VIC' },
  { postCode: '3057', suburb: 'BRUNSWICK EAST', state: 'VIC' },
  { postCode: '3057', suburb: 'SUMNER', state: 'VIC' },
  { postCode: '3058', suburb: 'BATMAN', state: 'VIC' },
  { postCode: '3058', suburb: 'COBURG', state: 'VIC' },
  { postCode: '3058', suburb: 'COBURG NORTH', state: 'VIC' },
  { postCode: '3058', suburb: 'MERLYNSTON', state: 'VIC' },
  { postCode: '3058', suburb: 'MORELAND', state: 'VIC' },
  { postCode: '3059', suburb: 'GREENVALE', state: 'VIC' },
  { postCode: '3060', suburb: 'FAWKNER', state: 'VIC' },
  { postCode: '3061', suburb: 'CAMPBELLFIELD', state: 'VIC' },
  { postCode: '3062', suburb: 'SOMERTON', state: 'VIC' },
  { postCode: '3063', suburb: 'OAKLANDS JUNCTION', state: 'VIC' },
  { postCode: '3063', suburb: 'YUROKE', state: 'VIC' },
  { postCode: '3064', suburb: 'CRAIGIEBURN', state: 'VIC' },
  { postCode: '3064', suburb: 'DONNYBROOK', state: 'VIC' },
  { postCode: '3064', suburb: 'KALKALLO', state: 'VIC' },
  { postCode: '3064', suburb: 'MICKLEHAM', state: 'VIC' },
  { postCode: '3064', suburb: 'ROXBURGH PARK', state: 'VIC' },
  { postCode: '3065', suburb: 'FITZROY', state: 'VIC' },
  { postCode: '3066', suburb: 'COLLINGWOOD', state: 'VIC' },
  { postCode: '3066', suburb: 'COLLINGWOOD NORTH', state: 'VIC' },
  { postCode: '3067', suburb: 'ABBOTSFORD', state: 'VIC' },
  { postCode: '3068', suburb: 'CLIFTON HILL', state: 'VIC' },
  { postCode: '3068', suburb: 'FITZROY NORTH', state: 'VIC' },
  { postCode: '3070', suburb: 'NORTHCOTE', state: 'VIC' },
  { postCode: '3070', suburb: 'NORTHCOTE SOUTH', state: 'VIC' },
  { postCode: '3071', suburb: 'THORNBURY', state: 'VIC' },
  { postCode: '3072', suburb: 'GILBERTON', state: 'VIC' },
  { postCode: '3072', suburb: 'NORTHLAND CENTRE', state: 'VIC' },
  { postCode: '3072', suburb: 'PRESTON', state: 'VIC' },
  { postCode: '3072', suburb: 'PRESTON LOWER', state: 'VIC' },
  { postCode: '3072', suburb: 'PRESTON SOUTH', state: 'VIC' },
  { postCode: '3072', suburb: 'PRESTON WEST', state: 'VIC' },
  { postCode: '3072', suburb: 'REGENT WEST', state: 'VIC' },
  { postCode: '3073', suburb: 'RESERVOIR', state: 'VIC' },
  { postCode: '3074', suburb: 'THOMASTOWN', state: 'VIC' },
  { postCode: '3075', suburb: 'LALOR', state: 'VIC' },
  { postCode: '3076', suburb: 'EPPING', state: 'VIC' },
  { postCode: '3078', suburb: 'ALPHINGTON', state: 'VIC' },
  { postCode: '3078', suburb: 'FAIRFIELD', state: 'VIC' },
  { postCode: '3079', suburb: 'IVANHOE', state: 'VIC' },
  { postCode: '3079', suburb: 'IVANHOE EAST', state: 'VIC' },
  { postCode: '3079', suburb: 'IVANHOE NORTH', state: 'VIC' },
  { postCode: '3081', suburb: 'BELLFIELD', state: 'VIC' },
  { postCode: '3081', suburb: 'HEIDELBERG HEIGHTS', state: 'VIC' },
  { postCode: '3081', suburb: 'HEIDELBERG RGH', state: 'VIC' },
  { postCode: '3081', suburb: 'HEIDELBERG WEST', state: 'VIC' },
  { postCode: '3082', suburb: 'MILL PARK', state: 'VIC' },
  { postCode: '3083', suburb: 'BUNDOORA', state: 'VIC' },
  { postCode: '3083', suburb: 'KINGSBURY', state: 'VIC' },
  { postCode: '3083', suburb: 'LA TROBE UNIVERSITY', state: 'VIC' },
  { postCode: '3084', suburb: 'BANYULE', state: 'VIC' },
  { postCode: '3084', suburb: 'EAGLEMONT', state: 'VIC' },
  { postCode: '3084', suburb: 'HEIDELBERG', state: 'VIC' },
  { postCode: '3084', suburb: 'ROSANNA', state: 'VIC' },
  { postCode: '3084', suburb: 'VIEWBANK', state: 'VIC' },
  { postCode: '3085', suburb: 'MACLEOD', state: 'VIC' },
  { postCode: '3085', suburb: 'MACLEOD WEST', state: 'VIC' },
  { postCode: '3085', suburb: 'YALLAMBIE', state: 'VIC' },
  { postCode: '3086', suburb: 'LA TROBE UNIVERSITY', state: 'VIC' },
  { postCode: '3087', suburb: 'WATSONIA', state: 'VIC' },
  { postCode: '3087', suburb: 'WATSONIA NORTH', state: 'VIC' },
  { postCode: '3088', suburb: 'BRIAR HILL', state: 'VIC' },
  { postCode: '3088', suburb: 'GREENSBOROUGH', state: 'VIC' },
  { postCode: '3088', suburb: 'ST HELENA', state: 'VIC' },
  { postCode: '3089', suburb: 'DIAMOND CREEK', state: 'VIC' },
  { postCode: '3090', suburb: 'PLENTY', state: 'VIC' },
  { postCode: '3091', suburb: 'YARRAMBAT', state: 'VIC' },
  { postCode: '3093', suburb: 'LOWER PLENTY', state: 'VIC' },
  { postCode: '3094', suburb: 'MONTMORENCY', state: 'VIC' },
  { postCode: '3095', suburb: 'ELTHAM', state: 'VIC' },
  { postCode: '3095', suburb: 'ELTHAM NORTH', state: 'VIC' },
  { postCode: '3095', suburb: 'RESEARCH', state: 'VIC' },
  { postCode: '3096', suburb: 'WATTLE GLEN', state: 'VIC' },
  { postCode: '3097', suburb: 'BEND OF ISLANDS', state: 'VIC' },
  { postCode: '3097', suburb: 'KANGAROO GROUND', state: 'VIC' },
  { postCode: '3097', suburb: 'WATSONS CREEK', state: 'VIC' },
  { postCode: '3099', suburb: 'ARTHURS CREEK', state: 'VIC' },
  { postCode: '3099', suburb: 'COTTLES BRIDGE', state: 'VIC' },
  { postCode: '3099', suburb: 'HURSTBRIDGE', state: 'VIC' },
  { postCode: '3099', suburb: 'NUTFIELD', state: 'VIC' },
  { postCode: '3099', suburb: 'STRATHEWEN', state: 'VIC' },
  { postCode: '3101', suburb: 'COTHAM', state: 'VIC' },
  { postCode: '3101', suburb: 'KEW', state: 'VIC' },
  { postCode: '3102', suburb: 'KEW EAST', state: 'VIC' },
  { postCode: '3103', suburb: 'BALWYN', state: 'VIC' },
  { postCode: '3103', suburb: 'BALWYN EAST', state: 'VIC' },
  { postCode: '3103', suburb: 'DEEPDENE', state: 'VIC' },
  { postCode: '3103', suburb: 'STRADBROKE PARK', state: 'VIC' },
  { postCode: '3104', suburb: 'BALWYN NORTH', state: 'VIC' },
  { postCode: '3104', suburb: 'GREYTHORN', state: 'VIC' },
  { postCode: '3105', suburb: 'BULLEEN', state: 'VIC' },
  { postCode: '3106', suburb: 'TEMPLESTOWE', state: 'VIC' },
  { postCode: '3107', suburb: 'TEMPLESTOWE LOWER', state: 'VIC' },
  { postCode: '3108', suburb: 'DONCASTER', state: 'VIC' },
  { postCode: '3109', suburb: 'DONCASTER EAST', state: 'VIC' },
  { postCode: '3109', suburb: 'DONCASTER HEIGHTS', state: 'VIC' },
  { postCode: '3111', suburb: 'DONVALE', state: 'VIC' },
  { postCode: '3113', suburb: 'NORTH WARRANDYTE', state: 'VIC' },
  { postCode: '3113', suburb: 'WARRANDYTE', state: 'VIC' },
  { postCode: '3114', suburb: 'PARK ORCHARDS', state: 'VIC' },
  { postCode: '3115', suburb: 'WONGA PARK', state: 'VIC' },
  { postCode: '3116', suburb: 'CHIRNSIDE PARK', state: 'VIC' },
  { postCode: '3121', suburb: 'BURNLEY', state: 'VIC' },
  { postCode: '3121', suburb: 'BURNLEY NORTH', state: 'VIC' },
  { postCode: '3121', suburb: 'CREMORNE', state: 'VIC' },
  { postCode: '3121', suburb: 'RICHMOND', state: 'VIC' },
  { postCode: '3121', suburb: 'RICHMOND EAST', state: 'VIC' },
  { postCode: '3121', suburb: 'RICHMOND NORTH', state: 'VIC' },
  { postCode: '3121', suburb: 'RICHMOND SOUTH', state: 'VIC' },
  { postCode: '3122', suburb: 'AUBURN SOUTH', state: 'VIC' },
  { postCode: '3122', suburb: 'GLENFERRIE SOUTH', state: 'VIC' },
  { postCode: '3122', suburb: 'HAWTHORN', state: 'VIC' },
  { postCode: '3122', suburb: 'HAWTHORN NORTH', state: 'VIC' },
  { postCode: '3122', suburb: 'HAWTHORN WEST', state: 'VIC' },
  { postCode: '3123', suburb: 'AUBURN', state: 'VIC' },
  { postCode: '3123', suburb: 'HAWTHORN EAST', state: 'VIC' },
  { postCode: '3124', suburb: 'CAMBERWELL', state: 'VIC' },
  { postCode: '3124', suburb: 'CAMBERWELL NORTH', state: 'VIC' },
  { postCode: '3124', suburb: 'CAMBERWELL SOUTH', state: 'VIC' },
  { postCode: '3124', suburb: 'CAMBERWELL WEST', state: 'VIC' },
  { postCode: '3124', suburb: 'HARTWELL', state: 'VIC' },
  { postCode: '3124', suburb: 'MIDDLE CAMBERWELL', state: 'VIC' },
  { postCode: '3125', suburb: 'BENNETTSWOOD', state: 'VIC' },
  { postCode: '3125', suburb: 'BURWOOD', state: 'VIC' },
  { postCode: '3125', suburb: 'SURREY HILLS SOUTH', state: 'VIC' },
  { postCode: '3126', suburb: 'CAMBERWELL EAST', state: 'VIC' },
  { postCode: '3126', suburb: 'CANTERBURY', state: 'VIC' },
  { postCode: '3127', suburb: 'MONT ALBERT', state: 'VIC' },
  { postCode: '3127', suburb: 'SURREY HILLS', state: 'VIC' },
  { postCode: '3127', suburb: 'SURREY HILLS NORTH', state: 'VIC' },
  { postCode: '3128', suburb: 'BOX HILL', state: 'VIC' },
  { postCode: '3128', suburb: 'BOX HILL CENTRAL', state: 'VIC' },
  { postCode: '3128', suburb: 'BOX HILL SOUTH', state: 'VIC' },
  { postCode: '3128', suburb: 'HOUSTON', state: 'VIC' },
  { postCode: '3128', suburb: 'WATTLE PARK', state: 'VIC' },
  { postCode: '3129', suburb: 'BOX HILL NORTH', state: 'VIC' },
  { postCode: '3129', suburb: 'KERRIMUIR', state: 'VIC' },
  { postCode: '3129', suburb: 'MONT ALBERT NORTH', state: 'VIC' },
  { postCode: '3130', suburb: 'BLACKBURN', state: 'VIC' },
  { postCode: '3130', suburb: 'BLACKBURN NORTH', state: 'VIC' },
  { postCode: '3130', suburb: 'BLACKBURN SOUTH', state: 'VIC' },
  { postCode: '3130', suburb: 'LABURNUM', state: 'VIC' },
  { postCode: '3131', suburb: 'BRENTFORD SQUARE', state: 'VIC' },
  { postCode: '3131', suburb: 'FOREST HILL', state: 'VIC' },
  { postCode: '3131', suburb: 'NUNAWADING', state: 'VIC' },
  { postCode: '3132', suburb: 'MITCHAM', state: 'VIC' },
  { postCode: '3132', suburb: 'MITCHAM NORTH', state: 'VIC' },
  { postCode: '3132', suburb: 'RANGEVIEW', state: 'VIC' },
  { postCode: '3133', suburb: 'VERMONT', state: 'VIC' },
  { postCode: '3133', suburb: 'VERMONT SOUTH', state: 'VIC' },
  { postCode: '3134', suburb: 'HEATHWOOD', state: 'VIC' },
  { postCode: '3134', suburb: 'RINGWOOD', state: 'VIC' },
  { postCode: '3134', suburb: 'RINGWOOD NORTH', state: 'VIC' },
  { postCode: '3134', suburb: 'WARRANDYTE SOUTH', state: 'VIC' },
  { postCode: '3134', suburb: 'WARRANWOOD', state: 'VIC' },
  { postCode: '3135', suburb: 'BEDFORD ROAD', state: 'VIC' },
  { postCode: '3135', suburb: 'HEATHMONT', state: 'VIC' },
  { postCode: '3135', suburb: 'RINGWOOD EAST', state: 'VIC' },
  { postCode: '3136', suburb: 'CROYDON', state: 'VIC' },
  { postCode: '3136', suburb: 'CROYDON HILLS', state: 'VIC' },
  { postCode: '3136', suburb: 'CROYDON NORTH', state: 'VIC' },
  { postCode: '3136', suburb: 'CROYDON SOUTH', state: 'VIC' },
  { postCode: '3137', suburb: 'KILSYTH', state: 'VIC' },
  { postCode: '3137', suburb: 'KILSYTH SOUTH', state: 'VIC' },
  { postCode: '3138', suburb: 'MOOROOLBARK', state: 'VIC' },
  { postCode: '3139', suburb: 'BEENAK', state: 'VIC' },
  { postCode: '3139', suburb: 'DON VALLEY', state: 'VIC' },
  { postCode: '3139', suburb: 'HODDLES CREEK', state: 'VIC' },
  { postCode: '3139', suburb: 'LAUNCHING PLACE', state: 'VIC' },
  { postCode: '3139', suburb: 'SEVILLE', state: 'VIC' },
  { postCode: '3139', suburb: 'SEVILLE EAST', state: 'VIC' },
  { postCode: '3139', suburb: 'WANDIN EAST', state: 'VIC' },
  { postCode: '3139', suburb: 'WANDIN NORTH', state: 'VIC' },
  { postCode: '3139', suburb: 'WOORI YALLOCK', state: 'VIC' },
  { postCode: '3139', suburb: 'YELLINGBO', state: 'VIC' },
  { postCode: '3140', suburb: 'LILYDALE', state: 'VIC' },
  { postCode: '3141', suburb: 'SOUTH YARRA', state: 'VIC' },
  { postCode: '3142', suburb: 'HAWKSBURN', state: 'VIC' },
  { postCode: '3142', suburb: 'TOORAK', state: 'VIC' },
  { postCode: '3143', suburb: 'ARMADALE', state: 'VIC' },
  { postCode: '3143', suburb: 'ARMADALE NORTH', state: 'VIC' },
  { postCode: '3144', suburb: 'KOOYONG', state: 'VIC' },
  { postCode: '3144', suburb: 'MALVERN', state: 'VIC' },
  { postCode: '3144', suburb: 'MALVERN NORTH', state: 'VIC' },
  { postCode: '3145', suburb: 'CAULFIELD EAST', state: 'VIC' },
  { postCode: '3145', suburb: 'CENTRAL PARK', state: 'VIC' },
  { postCode: '3145', suburb: 'DARLING', state: 'VIC' },
  { postCode: '3145', suburb: 'DARLING SOUTH', state: 'VIC' },
  { postCode: '3145', suburb: 'MALVERN EAST', state: 'VIC' },
  { postCode: '3145', suburb: 'WATTLETREE ROAD PO', state: 'VIC' },
  { postCode: '3146', suburb: 'GLEN IRIS', state: 'VIC' },
  { postCode: '3146', suburb: 'TOORONGA', state: 'VIC' },
  { postCode: '3147', suburb: 'ASHBURTON', state: 'VIC' },
  { postCode: '3147', suburb: 'ASHWOOD', state: 'VIC' },
  { postCode: '3148', suburb: 'CHADSTONE', state: 'VIC' },
  { postCode: '3148', suburb: 'CHADSTONE CENTRE', state: 'VIC' },
  { postCode: '3148', suburb: 'HOLMESGLEN', state: 'VIC' },
  { postCode: '3148', suburb: 'JORDANVILLE', state: 'VIC' },
  { postCode: '3149', suburb: 'MOUNT WAVERLEY', state: 'VIC' },
  { postCode: '3149', suburb: 'PINEWOOD', state: 'VIC' },
  { postCode: '3149', suburb: 'SYNDAL', state: 'VIC' },
  { postCode: '3150', suburb: 'BRANDON PARK', state: 'VIC' },
  { postCode: '3150', suburb: 'GLEN WAVERLEY', state: 'VIC' },
  { postCode: '3150', suburb: 'WHEELERS HILL', state: 'VIC' },
  { postCode: '3151', suburb: 'BURWOOD EAST', state: 'VIC' },
  { postCode: '3151', suburb: 'BURWOOD HEIGHTS', state: 'VIC' },
  { postCode: '3152', suburb: 'KNOX CITY CENTRE', state: 'VIC' },
  { postCode: '3152', suburb: 'STUDFIELD', state: 'VIC' },
  { postCode: '3152', suburb: 'WANTIRNA', state: 'VIC' },
  { postCode: '3152', suburb: 'WANTIRNA SOUTH', state: 'VIC' },
  { postCode: '3153', suburb: 'BAYSWATER', state: 'VIC' },
  { postCode: '3153', suburb: 'BAYSWATER NORTH', state: 'VIC' },
  { postCode: '3154', suburb: 'THE BASIN', state: 'VIC' },
  { postCode: '3155', suburb: 'BORONIA', state: 'VIC' },
  { postCode: '3156', suburb: 'FERNTREE GULLY', state: 'VIC' },
  { postCode: '3156', suburb: 'LYSTERFIELD', state: 'VIC' },
  { postCode: '3156', suburb: 'LYSTERFIELD SOUTH', state: 'VIC' },
  { postCode: '3156', suburb: 'MOUNTAIN GATE', state: 'VIC' },
  { postCode: '3156', suburb: 'UPPER FERNTREE GULLY', state: 'VIC' },
  { postCode: '3158', suburb: 'UPWEY', state: 'VIC' },
  { postCode: '3159', suburb: 'MENZIES CREEK', state: 'VIC' },
  { postCode: '3159', suburb: 'SELBY', state: 'VIC' },
  { postCode: '3160', suburb: 'BELGRAVE', state: 'VIC' },
  { postCode: '3160', suburb: 'BELGRAVE HEIGHTS', state: 'VIC' },
  { postCode: '3160', suburb: 'BELGRAVE SOUTH', state: 'VIC' },
  { postCode: '3160', suburb: 'TECOMA', state: 'VIC' },
  { postCode: '3161', suburb: 'CAULFIELD JUNCTION', state: 'VIC' },
  { postCode: '3161', suburb: 'CAULFIELD NORTH', state: 'VIC' },
  { postCode: '3162', suburb: 'CAULFIELD', state: 'VIC' },
  { postCode: '3162', suburb: 'CAULFIELD SOUTH', state: 'VIC' },
  { postCode: '3162', suburb: 'HOPETOUN GARDENS', state: 'VIC' },
  { postCode: '3163', suburb: 'BOORAN ROAD PO', state: 'VIC' },
  { postCode: '3163', suburb: 'CARNEGIE', state: 'VIC' },
  { postCode: '3163', suburb: 'GLEN HUNTLY', state: 'VIC' },
  { postCode: '3163', suburb: 'MURRUMBEENA', state: 'VIC' },
  { postCode: '3164', suburb: 'DANDENONG SOUTH', state: 'VIC' },
  { postCode: '3165', suburb: 'BENTLEIGH EAST', state: 'VIC' },
  { postCode: '3166', suburb: 'HUGHESDALE', state: 'VIC' },
  { postCode: '3166', suburb: 'HUNTINGDALE', state: 'VIC' },
  { postCode: '3166', suburb: 'OAKLEIGH', state: 'VIC' },
  { postCode: '3166', suburb: 'OAKLEIGH EAST', state: 'VIC' },
  { postCode: '3167', suburb: 'OAKLEIGH SOUTH', state: 'VIC' },
  { postCode: '3168', suburb: 'CLAYTON', state: 'VIC' },
  { postCode: '3168', suburb: 'NOTTING HILL', state: 'VIC' },
  { postCode: '3169', suburb: 'CLARINDA', state: 'VIC' },
  { postCode: '3169', suburb: 'CLAYTON SOUTH', state: 'VIC' },
  { postCode: '3170', suburb: 'MULGRAVE', state: 'VIC' },
  { postCode: '3170', suburb: 'WAVERLEY GARDENS', state: 'VIC' },
  { postCode: '3171', suburb: 'SANDOWN VILLAGE', state: 'VIC' },
  { postCode: '3171', suburb: 'SPRINGVALE', state: 'VIC' },
  { postCode: '3172', suburb: 'DINGLEY VILLAGE', state: 'VIC' },
  { postCode: '3172', suburb: 'SPRINGVALE SOUTH', state: 'VIC' },
  { postCode: '3173', suburb: 'KEYSBOROUGH', state: 'VIC' },
  { postCode: '3174', suburb: 'NOBLE PARK', state: 'VIC' },
  { postCode: '3174', suburb: 'NOBLE PARK NORTH', state: 'VIC' },
  { postCode: '3175', suburb: 'BANGHOLME', state: 'VIC' },
  { postCode: '3175', suburb: 'DANDENONG', state: 'VIC' },
  { postCode: '3175', suburb: 'DANDENONG EAST', state: 'VIC' },
  { postCode: '3175', suburb: 'DANDENONG NORTH', state: 'VIC' },
  { postCode: '3175', suburb: 'DANDENONG SOUTH', state: 'VIC' },
  { postCode: '3175', suburb: 'DUNEARN', state: 'VIC' },
  { postCode: '3176', suburb: 'SCORESBY BC', state: 'VIC' },
  { postCode: '3177', suburb: 'DOVETON', state: 'VIC' },
  { postCode: '3177', suburb: 'EUMEMMERRING', state: 'VIC' },
  { postCode: '3178', suburb: 'ROWVILLE', state: 'VIC' },
  { postCode: '3179', suburb: 'SCORESBY', state: 'VIC' },
  { postCode: '3180', suburb: 'KNOXFIELD', state: 'VIC' },
  { postCode: '3181', suburb: 'PRAHRAN', state: 'VIC' },
  { postCode: '3181', suburb: 'PRAHRAN EAST', state: 'VIC' },
  { postCode: '3181', suburb: 'WINDSOR', state: 'VIC' },
  { postCode: '3182', suburb: 'ST KILDA', state: 'VIC' },
  { postCode: '3182', suburb: 'ST KILDA SOUTH', state: 'VIC' },
  { postCode: '3182', suburb: 'ST KILDA WEST', state: 'VIC' },
  { postCode: '3183', suburb: 'BALACLAVA', state: 'VIC' },
  { postCode: '3183', suburb: 'ST KILDA EAST', state: 'VIC' },
  { postCode: '3184', suburb: 'BRIGHTON ROAD', state: 'VIC' },
  { postCode: '3184', suburb: 'ELWOOD', state: 'VIC' },
  { postCode: '3185', suburb: 'ELSTERNWICK', state: 'VIC' },
  { postCode: '3185', suburb: 'GARDENVALE', state: 'VIC' },
  { postCode: '3185', suburb: 'RIPPONLEA', state: 'VIC' },
  { postCode: '3186', suburb: 'BRIGHTON', state: 'VIC' },
  { postCode: '3186', suburb: 'BRIGHTON NORTH', state: 'VIC' },
  { postCode: '3186', suburb: 'DENDY', state: 'VIC' },
  { postCode: '3186', suburb: 'WERE STREET PO', state: 'VIC' },
  { postCode: '3187', suburb: 'BRIGHTON EAST', state: 'VIC' },
  { postCode: '3187', suburb: 'NORTH ROAD', state: 'VIC' },
  { postCode: '3188', suburb: 'HAMPTON', state: 'VIC' },
  { postCode: '3188', suburb: 'HAMPTON EAST', state: 'VIC' },
  { postCode: '3188', suburb: 'HAMPTON NORTH', state: 'VIC' },
  { postCode: '3189', suburb: 'MOORABBIN', state: 'VIC' },
  { postCode: '3189', suburb: 'MOORABBIN EAST', state: 'VIC' },
  { postCode: '3189', suburb: 'WISHART', state: 'VIC' },
  { postCode: '3190', suburb: 'HIGHETT', state: 'VIC' },
  { postCode: '3191', suburb: 'SANDRINGHAM', state: 'VIC' },
  { postCode: '3192', suburb: 'CHELTENHAM', state: 'VIC' },
  { postCode: '3192', suburb: 'CHELTENHAM EAST', state: 'VIC' },
  { postCode: '3192', suburb: 'SOUTHLAND CENTRE', state: 'VIC' },
  { postCode: '3193', suburb: 'BEAUMARIS', state: 'VIC' },
  { postCode: '3193', suburb: 'BLACK ROCK', state: 'VIC' },
  { postCode: '3193', suburb: 'BLACK ROCK NORTH', state: 'VIC' },
  { postCode: '3193', suburb: 'CROMER', state: 'VIC' },
  { postCode: '3194', suburb: 'MENTONE', state: 'VIC' },
  { postCode: '3194', suburb: 'MENTONE EAST', state: 'VIC' },
  { postCode: '3194', suburb: 'MOORABBIN AIRPORT', state: 'VIC' },
  { postCode: '3195', suburb: 'ASPENDALE', state: 'VIC' },
  { postCode: '3195', suburb: 'ASPENDALE GARDENS', state: 'VIC' },
  { postCode: '3195', suburb: 'BRAESIDE', state: 'VIC' },
  { postCode: '3195', suburb: 'MORDIALLOC', state: 'VIC' },
  { postCode: '3195', suburb: 'PARKDALE', state: 'VIC' },
  { postCode: '3195', suburb: 'WATERWAYS', state: 'VIC' },
  { postCode: '3196', suburb: 'BONBEACH', state: 'VIC' },
  { postCode: '3196', suburb: 'CHELSEA', state: 'VIC' },
  { postCode: '3196', suburb: 'CHELSEA HEIGHTS', state: 'VIC' },
  { postCode: '3196', suburb: 'EDITHVALE', state: 'VIC' },
  { postCode: '3197', suburb: 'CARRUM', state: 'VIC' },
  { postCode: '3197', suburb: 'PATTERSON LAKES', state: 'VIC' },
  { postCode: '3198', suburb: 'SEAFORD', state: 'VIC' },
  { postCode: '3199', suburb: 'FRANKSTON', state: 'VIC' },
  { postCode: '3199', suburb: 'FRANKSTON EAST', state: 'VIC' },
  { postCode: '3199', suburb: 'FRANKSTON HEIGHTS', state: 'VIC' },
  { postCode: '3199', suburb: 'FRANKSTON SOUTH', state: 'VIC' },
  { postCode: '3199', suburb: 'KARINGAL', state: 'VIC' },
  { postCode: '3199', suburb: 'KARINGAL CENTRE', state: 'VIC' },
  { postCode: '3200', suburb: 'FRANKSTON NORTH', state: 'VIC' },
  { postCode: '3200', suburb: 'PINES FOREST', state: 'VIC' },
  { postCode: '3201', suburb: 'CARRUM DOWNS', state: 'VIC' },
  { postCode: '3202', suburb: 'HEATHERTON', state: 'VIC' },
  { postCode: '3204', suburb: 'BENTLEIGH', state: 'VIC' },
  { postCode: '3204', suburb: 'MCKINNON', state: 'VIC' },
  { postCode: '3204', suburb: 'ORMOND', state: 'VIC' },
  { postCode: '3204', suburb: 'PATTERSON', state: 'VIC' },
  { postCode: '3205', suburb: 'SOUTH MELBOURNE', state: 'VIC' },
  { postCode: '3206', suburb: 'ALBERT PARK', state: 'VIC' },
  { postCode: '3206', suburb: 'MIDDLE PARK', state: 'VIC' },
  { postCode: '3207', suburb: 'GARDEN CITY', state: 'VIC' },
  { postCode: '3207', suburb: 'PORT MELBOURNE', state: 'VIC' },
  { postCode: '3211', suburb: 'LITTLE RIVER', state: 'VIC' },
  { postCode: '3212', suburb: 'AVALON', state: 'VIC' },
  { postCode: '3212', suburb: 'LARA', state: 'VIC' },
  { postCode: '3212', suburb: 'POINT WILSON', state: 'VIC' },
  { postCode: '3213', suburb: 'ANAKIE', state: 'VIC' },
  { postCode: '3213', suburb: 'BATESFORD', state: 'VIC' },
  { postCode: '3213', suburb: 'LOVELY BANKS', state: 'VIC' },
  { postCode: '3213', suburb: 'MOORABOOL', state: 'VIC' },
  { postCode: '3214', suburb: 'CORIO', state: 'VIC' },
  { postCode: '3214', suburb: 'NORLANE', state: 'VIC' },
  { postCode: '3214', suburb: 'NORTH SHORE', state: 'VIC' },
  { postCode: '3215', suburb: 'BELL PARK', state: 'VIC' },
  { postCode: '3215', suburb: 'BELL POST HILL', state: 'VIC' },
  { postCode: '3215', suburb: 'DRUMCONDRA', state: 'VIC' },
  { postCode: '3215', suburb: 'GEELONG NORTH', state: 'VIC' },
  { postCode: '3215', suburb: 'HAMLYN HEIGHTS', state: 'VIC' },
  { postCode: '3215', suburb: 'NORTH GEELONG', state: 'VIC' },
  { postCode: '3215', suburb: 'RIPPLESIDE', state: 'VIC' },
  { postCode: '3216', suburb: 'BELMONT', state: 'VIC' },
  { postCode: '3216', suburb: 'GROVEDALE', state: 'VIC' },
  { postCode: '3216', suburb: 'GROVEDALE EAST', state: 'VIC' },
  { postCode: '3216', suburb: 'HIGHTON', state: 'VIC' },
  { postCode: '3216', suburb: 'MARSHALL', state: 'VIC' },
  { postCode: '3216', suburb: 'WANDANA HEIGHTS', state: 'VIC' },
  { postCode: '3216', suburb: 'WAURN PONDS', state: 'VIC' },
  { postCode: '3217', suburb: 'ARMSTRONG CREEK', state: 'VIC' },
  { postCode: '3217', suburb: 'CHARLEMONT', state: 'VIC' },
  { postCode: '3217', suburb: 'FRESHWATER CREEK', state: 'VIC' },
  { postCode: '3217', suburb: 'MOUNT DUNEED', state: 'VIC' },
  { postCode: '3218', suburb: 'FYANSFORD', state: 'VIC' },
  { postCode: '3218', suburb: 'GEELONG WEST', state: 'VIC' },
  { postCode: '3218', suburb: 'HERNE HILL', state: 'VIC' },
  { postCode: '3218', suburb: 'MANIFOLD HEIGHTS', state: 'VIC' },
  { postCode: '3218', suburb: 'MURGHEBOLUC', state: 'VIC' },
  { postCode: '3218', suburb: 'STONEHAVEN', state: 'VIC' },
  { postCode: '3219', suburb: 'BREAKWATER', state: 'VIC' },
  { postCode: '3219', suburb: 'EAST GEELONG', state: 'VIC' },
  { postCode: '3219', suburb: 'NEWCOMB', state: 'VIC' },
  { postCode: '3219', suburb: 'ST ALBANS PARK', state: 'VIC' },
  { postCode: '3219', suburb: 'THOMSON', state: 'VIC' },
  { postCode: '3219', suburb: 'WHITTINGTON', state: 'VIC' },
  { postCode: '3220', suburb: 'BAREENA', state: 'VIC' },
  { postCode: '3220', suburb: 'GEELONG', state: 'VIC' },
  { postCode: '3220', suburb: 'NEWTOWN', state: 'VIC' },
  { postCode: '3220', suburb: 'SOUTH GEELONG', state: 'VIC' },
  { postCode: '3221', suburb: 'BARRABOOL', state: 'VIC' },
  { postCode: '3221', suburb: 'CERES', state: 'VIC' },
  { postCode: '3221', suburb: 'GEELONG MC', state: 'VIC' },
  { postCode: '3221', suburb: 'GNARWARRE', state: 'VIC' },
  { postCode: '3222', suburb: 'CLIFTON SPRINGS', state: 'VIC' },
  { postCode: '3222', suburb: 'CURLEWIS', state: 'VIC' },
  { postCode: '3222', suburb: 'DRYSDALE', state: 'VIC' },
  { postCode: '3222', suburb: 'MANNERIM', state: 'VIC' },
  { postCode: '3222', suburb: 'MARCUS HILL', state: 'VIC' },
  { postCode: '3222', suburb: 'WALLINGTON', state: 'VIC' },
  { postCode: '3223', suburb: 'BELLARINE', state: 'VIC' },
  { postCode: '3223', suburb: 'INDENTED HEAD', state: 'VIC' },
  { postCode: '3223', suburb: 'PORTARLINGTON', state: 'VIC' },
  { postCode: '3223', suburb: 'ST LEONARDS', state: 'VIC' },
  { postCode: '3224', suburb: 'LEOPOLD', state: 'VIC' },
  { postCode: '3224', suburb: 'MOOLAP', state: 'VIC' },
  { postCode: '3225', suburb: 'POINT LONSDALE', state: 'VIC' },
  { postCode: '3225', suburb: 'QUEENSCLIFF', state: 'VIC' },
  { postCode: '3225', suburb: 'SWAN BAY', state: 'VIC' },
  { postCode: '3225', suburb: 'SWAN ISLAND', state: 'VIC' },
  { postCode: '3226', suburb: 'OCEAN GROVE', state: 'VIC' },
  { postCode: '3227', suburb: 'BARWON HEADS', state: 'VIC' },
  { postCode: '3227', suburb: 'BREAMLEA', state: 'VIC' },
  { postCode: '3227', suburb: 'CONNEWARRE', state: 'VIC' },
  { postCode: '3228', suburb: 'BELLBRAE', state: 'VIC' },
  { postCode: '3228', suburb: 'BELLS BEACH', state: 'VIC' },
  { postCode: '3228', suburb: 'JAN JUC', state: 'VIC' },
  { postCode: '3228', suburb: 'TORQUAY', state: 'VIC' },
  { postCode: '3230', suburb: 'ANGLESEA', state: 'VIC' },
  { postCode: '3231', suburb: 'AIREYS INLET', state: 'VIC' },
  { postCode: '3231', suburb: 'BIG HILL', state: 'VIC' },
  { postCode: '3231', suburb: 'EASTERN VIEW', state: 'VIC' },
  { postCode: '3231', suburb: 'FAIRHAVEN', state: 'VIC' },
  { postCode: '3231', suburb: 'MOGGS CREEK', state: 'VIC' },
  { postCode: '3232', suburb: 'LORNE', state: 'VIC' },
  { postCode: '3233', suburb: 'APOLLO BAY', state: 'VIC' },
  { postCode: '3233', suburb: 'CAPE OTWAY', state: 'VIC' },
  { postCode: '3233', suburb: 'MARENGO', state: 'VIC' },
  { postCode: '3233', suburb: 'PETTICOAT CREEK', state: 'VIC' },
  { postCode: '3233', suburb: 'SKENES CREEK', state: 'VIC' },
  { postCode: '3233', suburb: 'SKENES CREEK NORTH', state: 'VIC' },
  { postCode: '3234', suburb: 'GREY RIVER', state: 'VIC' },
  { postCode: '3234', suburb: 'KENNETT RIVER', state: 'VIC' },
  { postCode: '3234', suburb: 'SEPARATION CREEK', state: 'VIC' },
  { postCode: '3234', suburb: 'SUGARLOAF', state: 'VIC' },
  { postCode: '3234', suburb: 'WONGARRA', state: 'VIC' },
  { postCode: '3234', suburb: 'WYE RIVER', state: 'VIC' },
  { postCode: '3235', suburb: 'BENWERRIN', state: 'VIC' },
  { postCode: '3235', suburb: 'BOONAH', state: 'VIC' },
  { postCode: '3235', suburb: 'DEANS MARSH', state: 'VIC' },
  { postCode: '3235', suburb: 'PENNYROYAL', state: 'VIC' },
  { postCode: '3236', suburb: 'FORREST', state: 'VIC' },
  { postCode: '3236', suburb: 'MOUNT SABINE', state: 'VIC' },
  { postCode: '3237', suburb: 'AIRE VALLEY', state: 'VIC' },
  { postCode: '3237', suburb: 'BEECH FOREST', state: 'VIC' },
  { postCode: '3237', suburb: 'FERGUSON', state: 'VIC' },
  { postCode: '3237', suburb: 'GELLIBRAND LOWER', state: 'VIC' },
  { postCode: '3237', suburb: 'WATTLE HILL', state: 'VIC' },
  { postCode: '3237', suburb: 'WEEAPROINAH', state: 'VIC' },
  { postCode: '3237', suburb: 'WYELANGTA', state: 'VIC' },
  { postCode: '3237', suburb: 'YUULONG', state: 'VIC' },
  { postCode: '3238', suburb: 'GLENAIRE', state: 'VIC' },
  { postCode: '3238', suburb: 'HORDERN VALE', state: 'VIC' },
  { postCode: '3238', suburb: 'JOHANNA', state: 'VIC' },
  { postCode: '3238', suburb: 'LAVERS HILL', state: 'VIC' },
  { postCode: '3239', suburb: 'CARLISLE RIVER', state: 'VIC' },
  { postCode: '3239', suburb: 'CHAPPLE VALE', state: 'VIC' },
  { postCode: '3239', suburb: 'GELLIBRAND', state: 'VIC' },
  { postCode: '3239', suburb: 'KENNEDYS CREEK', state: 'VIC' },
  { postCode: '3240', suburb: 'BUCKLEY', state: 'VIC' },
  { postCode: '3240', suburb: 'GHERANG', state: 'VIC' },
  { postCode: '3240', suburb: 'MODEWARRE', state: 'VIC' },
  { postCode: '3240', suburb: 'MORIAC', state: 'VIC' },
  { postCode: '3240', suburb: 'MOUNT MORIAC', state: 'VIC' },
  { postCode: '3240', suburb: 'PARAPARAP', state: 'VIC' },
  { postCode: '3241', suburb: 'BAMBRA', state: 'VIC' },
  { postCode: '3241', suburb: 'OMBERSLEY', state: 'VIC' },
  { postCode: '3241', suburb: 'WENSLEYDALE', state: 'VIC' },
  { postCode: '3241', suburb: 'WINCHELSEA', state: 'VIC' },
  { postCode: '3241', suburb: 'WINCHELSEA SOUTH', state: 'VIC' },
  { postCode: '3241', suburb: 'WURDIBOLUC', state: 'VIC' },
  { postCode: '3242', suburb: 'BIRREGURRA', state: 'VIC' },
  { postCode: '3243', suburb: 'BARWON DOWNS', state: 'VIC' },
  { postCode: '3243', suburb: 'MURROON', state: 'VIC' },
  { postCode: '3243', suburb: 'WARNCOORT', state: 'VIC' },
  { postCode: '3243', suburb: 'WHOOREL', state: 'VIC' },
  { postCode: '3249', suburb: 'ALVIE', state: 'VIC' },
  { postCode: '3249', suburb: 'BALINTORE', state: 'VIC' },
  { postCode: '3249', suburb: 'BARONGAROOK', state: 'VIC' },
  { postCode: '3249', suburb: 'BARONGAROOK WEST', state: 'VIC' },
  { postCode: '3249', suburb: 'BARRAMUNGA', state: 'VIC' },
  { postCode: '3249', suburb: 'CORAGULAC', state: 'VIC' },
  { postCode: '3249', suburb: 'CORUNNUN', state: 'VIC' },
  { postCode: '3249', suburb: 'DREEITE', state: 'VIC' },
  { postCode: '3249', suburb: 'DREEITE SOUTH', state: 'VIC' },
  { postCode: '3249', suburb: 'GERANGAMETE', state: 'VIC' },
  { postCode: '3249', suburb: 'IRREWARRA', state: 'VIC' },
  { postCode: '3249', suburb: 'IRREWILLIPE', state: 'VIC' },
  { postCode: '3249', suburb: 'IRREWILLIPE EAST', state: 'VIC' },
  { postCode: '3249', suburb: 'KAWARREN', state: 'VIC' },
  { postCode: '3249', suburb: 'LARPENT', state: 'VIC' },
  { postCode: '3249', suburb: 'NALANGIL', state: 'VIC' },
  { postCode: '3249', suburb: 'ONDIT', state: 'VIC' },
  { postCode: '3249', suburb: 'PIRRON YALLOCK', state: 'VIC' },
  { postCode: '3249', suburb: 'POMBORNEIT EAST', state: 'VIC' },
  { postCode: '3249', suburb: 'SWAN MARSH', state: 'VIC' },
  { postCode: '3249', suburb: 'TANYBRYN', state: 'VIC' },
  { postCode: '3249', suburb: 'WARRION', state: 'VIC' },
  { postCode: '3249', suburb: 'WOOL WOOL', state: 'VIC' },
  { postCode: '3249', suburb: 'YEO', state: 'VIC' },
  { postCode: '3249', suburb: 'YEODENE', state: 'VIC' },
  { postCode: '3250', suburb: 'COLAC', state: 'VIC' },
  { postCode: '3250', suburb: 'COLAC EAST', state: 'VIC' },
  { postCode: '3250', suburb: 'COLAC WEST', state: 'VIC' },
  { postCode: '3250', suburb: 'ELLIMINYT', state: 'VIC' },
  { postCode: '3251', suburb: 'BEEAC', state: 'VIC' },
  { postCode: '3251', suburb: 'CUNDARE', state: 'VIC' },
  { postCode: '3251', suburb: 'CUNDARE NORTH', state: 'VIC' },
  { postCode: '3251', suburb: 'EURACK', state: 'VIC' },
  { postCode: '3251', suburb: 'WEERING', state: 'VIC' },
  { postCode: '3254', suburb: 'COROROOKE', state: 'VIC' },
  { postCode: '3260', suburb: 'BOOKAAR', state: 'VIC' },
  { postCode: '3260', suburb: 'BOSTOCKS CREEK', state: 'VIC' },
  { postCode: '3260', suburb: 'BUNGADOR', state: 'VIC' },
  { postCode: '3260', suburb: 'CAMPERDOWN', state: 'VIC' },
  { postCode: '3260', suburb: 'CARPENDEIT', state: 'VIC' },
  { postCode: '3260', suburb: 'CHOCOLYN', state: 'VIC' },
  { postCode: '3260', suburb: 'GNOTUK', state: 'VIC' },
  { postCode: '3260', suburb: 'KARIAH', state: 'VIC' },
  { postCode: '3260', suburb: 'KOALLAH', state: 'VIC' },
  { postCode: '3260', suburb: 'LESLIE MANOR', state: 'VIC' },
  { postCode: '3260', suburb: 'POMBORNEIT', state: 'VIC' },
  { postCode: '3260', suburb: 'POMBORNEIT NORTH', state: 'VIC' },
  { postCode: '3260', suburb: 'SKIBO', state: 'VIC' },
  { postCode: '3260', suburb: 'SOUTH PURRUMBETE', state: 'VIC' },
  { postCode: '3260', suburb: 'STONYFORD', state: 'VIC' },
  { postCode: '3260', suburb: 'TANDAROOK', state: 'VIC' },
  { postCode: '3260', suburb: 'TESBURY', state: 'VIC' },
  { postCode: '3260', suburb: 'WEERITE', state: 'VIC' },
  { postCode: '3264', suburb: 'TERANG', state: 'VIC' },
  { postCode: '3265', suburb: 'BOORCAN', state: 'VIC' },
  { postCode: '3265', suburb: 'CUDGEE', state: 'VIC' },
  { postCode: '3265', suburb: 'DIXIE', state: 'VIC' },
  { postCode: '3265', suburb: 'ECKLIN SOUTH', state: 'VIC' },
  { postCode: '3265', suburb: 'ELLERSLIE', state: 'VIC' },
  { postCode: '3265', suburb: 'FRAMLINGHAM', state: 'VIC' },
  { postCode: '3265', suburb: 'FRAMLINGHAM EAST', state: 'VIC' },
  { postCode: '3265', suburb: 'GARVOC', state: 'VIC' },
  { postCode: '3265', suburb: 'GLENORMISTON', state: 'VIC' },
  { postCode: '3265', suburb: 'GLENORMISTON NORTH', state: 'VIC' },
  { postCode: '3265', suburb: 'GLENORMISTON SOUTH', state: 'VIC' },
  { postCode: '3265', suburb: 'KOLORA', state: 'VIC' },
  { postCode: '3265', suburb: 'LAANG', state: 'VIC' },
  { postCode: '3265', suburb: 'NOORAT', state: 'VIC' },
  { postCode: '3265', suburb: 'NOORAT EAST', state: 'VIC' },
  { postCode: '3265', suburb: 'PANMURE', state: 'VIC' },
  { postCode: '3265', suburb: 'TAROON', state: 'VIC' },
  { postCode: '3265', suburb: 'THE SISTERS', state: 'VIC' },
  { postCode: '3266', suburb: 'BULLAHARRE', state: 'VIC' },
  { postCode: '3266', suburb: 'COBDEN', state: 'VIC' },
  { postCode: '3266', suburb: 'COBRICO', state: 'VIC' },
  { postCode: '3266', suburb: 'ELINGAMITE', state: 'VIC' },
  { postCode: '3266', suburb: 'ELINGAMITE NORTH', state: 'VIC' },
  { postCode: '3266', suburb: 'GLENFYNE', state: 'VIC' },
  { postCode: '3266', suburb: 'JANCOURT', state: 'VIC' },
  { postCode: '3266', suburb: 'JANCOURT EAST', state: 'VIC' },
  { postCode: '3266', suburb: 'NAROGHID', state: 'VIC' },
  { postCode: '3266', suburb: 'SIMPSON', state: 'VIC' },
  { postCode: '3267', suburb: 'SCOTTS CREEK', state: 'VIC' },
  { postCode: '3268', suburb: 'AYRFORD', state: 'VIC' },
  { postCode: '3268', suburb: 'BRUCKNELL', state: 'VIC' },
  { postCode: '3268', suburb: 'COORIEMUNGLE', state: 'VIC' },
  { postCode: '3268', suburb: 'COWLEYS CREEK', state: 'VIC' },
  { postCode: '3268', suburb: 'CURDIES RIVER', state: 'VIC' },
  { postCode: '3268', suburb: 'CURDIEVALE', state: 'VIC' },
  { postCode: '3268', suburb: 'HEYTESBURY LOWER', state: 'VIC' },
  { postCode: '3268', suburb: 'NEWFIELD', state: 'VIC' },
  { postCode: '3268', suburb: 'NIRRANDA', state: 'VIC' },
  { postCode: '3268', suburb: 'NIRRANDA EAST', state: 'VIC' },
  { postCode: '3268', suburb: 'NIRRANDA SOUTH', state: 'VIC' },
  { postCode: '3268', suburb: 'NULLAWARRE', state: 'VIC' },
  { postCode: '3268', suburb: 'NULLAWARRE NORTH', state: 'VIC' },
  { postCode: '3268', suburb: 'PAARATTE', state: 'VIC' },
  { postCode: '3268', suburb: 'THE COVE', state: 'VIC' },
  { postCode: '3268', suburb: 'TIMBOON', state: 'VIC' },
  { postCode: '3268', suburb: 'TIMBOON WEST', state: 'VIC' },
  { postCode: '3269', suburb: 'PORT CAMPBELL', state: 'VIC' },
  { postCode: '3269', suburb: 'PRINCETOWN', state: 'VIC' },
  { postCode: '3269', suburb: 'WAARRE', state: 'VIC' },
  { postCode: '3270', suburb: 'PETERBOROUGH', state: 'VIC' },
  { postCode: '3271', suburb: 'DARLINGTON', state: 'VIC' },
  { postCode: '3271', suburb: 'DUNDONNELL', state: 'VIC' },
  { postCode: '3271', suburb: 'PURA PURA', state: 'VIC' },
  { postCode: '3272', suburb: 'MORTLAKE', state: 'VIC' },
  { postCode: '3272', suburb: 'WOORNDOO', state: 'VIC' },
  { postCode: '3273', suburb: 'HEXHAM', state: 'VIC' },
  { postCode: '3274', suburb: 'CARAMUT', state: 'VIC' },
  { postCode: '3275', suburb: 'MAILORS FLAT', state: 'VIC' },
  { postCode: '3276', suburb: 'MINJAH', state: 'VIC' },
  { postCode: '3276', suburb: 'WOOLSTHORPE', state: 'VIC' },
  { postCode: '3277', suburb: 'ALLANSFORD', state: 'VIC' },
  { postCode: '3277', suburb: 'MEPUNGA', state: 'VIC' },
  { postCode: '3277', suburb: 'MEPUNGA EAST', state: 'VIC' },
  { postCode: '3277', suburb: 'MEPUNGA WEST', state: 'VIC' },
  { postCode: '3277', suburb: 'NARINGAL', state: 'VIC' },
  { postCode: '3277', suburb: 'NARINGAL EAST', state: 'VIC' },
  { postCode: '3278', suburb: 'PURNIM', state: 'VIC' },
  { postCode: '3278', suburb: 'PURNIM WEST', state: 'VIC' },
  { postCode: '3279', suburb: 'BALLANGEICH', state: 'VIC' },
  { postCode: '3279', suburb: 'WANGOOM', state: 'VIC' },
  { postCode: '3280', suburb: 'DENNINGTON', state: 'VIC' },
  { postCode: '3280', suburb: 'WARRNAMBOOL', state: 'VIC' },
  { postCode: '3281', suburb: 'BUSHFIELD', state: 'VIC' },
  { postCode: '3281', suburb: 'GRASSMERE', state: 'VIC' },
  { postCode: '3281', suburb: 'WINSLOW', state: 'VIC' },
  { postCode: '3281', suburb: 'WOODFORD', state: 'VIC' },
  { postCode: '3282', suburb: 'ILLOWA', state: 'VIC' },
  { postCode: '3282', suburb: 'KOROIT', state: 'VIC' },
  { postCode: '3283', suburb: 'CROSSLEY', state: 'VIC' },
  { postCode: '3283', suburb: 'KILLARNEY', state: 'VIC' },
  { postCode: '3283', suburb: 'KIRKSTALL', state: 'VIC' },
  { postCode: '3283', suburb: 'SOUTHERN CROSS', state: 'VIC' },
  { postCode: '3283', suburb: 'TARRONE', state: 'VIC' },
  { postCode: '3283', suburb: 'TOWER HILL', state: 'VIC' },
  { postCode: '3283', suburb: 'WARRONG', state: 'VIC' },
  { postCode: '3283', suburb: 'WILLATOOK', state: 'VIC' },
  { postCode: '3283', suburb: 'YANGERY', state: 'VIC' },
  { postCode: '3283', suburb: 'YARPTURK', state: 'VIC' },
  { postCode: '3284', suburb: 'ORFORD', state: 'VIC' },
  { postCode: '3284', suburb: 'PORT FAIRY', state: 'VIC' },
  { postCode: '3285', suburb: 'CODRINGTON', state: 'VIC' },
  { postCode: '3285', suburb: 'NARRAWONG', state: 'VIC' },
  { postCode: '3285', suburb: 'ROSEBROOK', state: 'VIC' },
  { postCode: '3285', suburb: 'ST HELENS', state: 'VIC' },
  { postCode: '3285', suburb: 'TOOLONG', state: 'VIC' },
  { postCode: '3285', suburb: 'TYRENDARRA', state: 'VIC' },
  { postCode: '3285', suburb: 'TYRENDARRA EAST', state: 'VIC' },
  { postCode: '3285', suburb: 'YAMBUK', state: 'VIC' },
  { postCode: '3286', suburb: 'CONDAH SWAMP', state: 'VIC' },
  { postCode: '3286', suburb: 'KNEBSWORTH', state: 'VIC' },
  { postCode: '3286', suburb: 'MACARTHUR', state: 'VIC' },
  { postCode: '3286', suburb: 'WARRABKOOK', state: 'VIC' },
  { postCode: '3287', suburb: 'HAWKESDALE', state: 'VIC' },
  { postCode: '3287', suburb: 'MINHAMITE', state: 'VIC' },
  { postCode: '3289', suburb: 'GAZETTE', state: 'VIC' },
  { postCode: '3289', suburb: 'GERRIGERRUP', state: 'VIC' },
  { postCode: '3289', suburb: 'PENSHURST', state: 'VIC' },
  { postCode: '3289', suburb: 'PURDEET', state: 'VIC' },
  { postCode: '3289', suburb: 'TABOR', state: 'VIC' },
  { postCode: '3292', suburb: 'NELSON', state: 'VIC' },
  { postCode: '3293', suburb: 'GLENTHOMPSON', state: 'VIC' },
  { postCode: '3293', suburb: 'NAREEB', state: 'VIC' },
  { postCode: '3293', suburb: 'NARRAPUMELAP SOUTH', state: 'VIC' },
  { postCode: '3294', suburb: 'DUNKELD', state: 'VIC' },
  { postCode: '3294', suburb: 'KARABEAL', state: 'VIC' },
  { postCode: '3294', suburb: 'MIRRANATWA', state: 'VIC' },
  { postCode: '3294', suburb: 'MOUTAJUP', state: 'VIC' },
  { postCode: '3294', suburb: 'VICTORIA POINT', state: 'VIC' },
  { postCode: '3294', suburb: 'VICTORIA VALLEY', state: 'VIC' },
  { postCode: '3294', suburb: 'WOODHOUSE', state: 'VIC' },
  { postCode: '3300', suburb: 'BYADUK NORTH', state: 'VIC' },
  { postCode: '3300', suburb: 'HAMILTON', state: 'VIC' },
  { postCode: '3301', suburb: 'BOCHARA', state: 'VIC' },
  { postCode: '3301', suburb: 'BROADWATER', state: 'VIC' },
  { postCode: '3301', suburb: 'BUCKLEY SWAMP', state: 'VIC' },
  { postCode: '3301', suburb: 'BYADUK', state: 'VIC' },
  { postCode: '3301', suburb: 'CROXTON EAST', state: 'VIC' },
  { postCode: '3301', suburb: 'HENSLEY PARK', state: 'VIC' },
  { postCode: '3301', suburb: 'MORGIANA', state: 'VIC' },
  { postCode: '3301', suburb: 'MOUNT NAPIER', state: 'VIC' },
  { postCode: '3301', suburb: 'STRATHKELLAR', state: 'VIC' },
  { postCode: '3301', suburb: 'TAHARA', state: 'VIC' },
  { postCode: '3301', suburb: 'TARRINGTON', state: 'VIC' },
  { postCode: '3301', suburb: 'WANNON', state: 'VIC' },
  { postCode: '3301', suburb: 'WARRAYURE', state: 'VIC' },
  { postCode: '3301', suburb: 'YATCHAW', state: 'VIC' },
  { postCode: '3301', suburb: 'YULECART', state: 'VIC' },
  { postCode: '3302', suburb: 'BRANXHOLME', state: 'VIC' },
  { postCode: '3302', suburb: 'GRASSDALE', state: 'VIC' },
  { postCode: '3303', suburb: 'BREAKAWAY CREEK', state: 'VIC' },
  { postCode: '3303', suburb: 'CONDAH', state: 'VIC' },
  { postCode: '3303', suburb: 'HOTSPUR', state: 'VIC' },
  { postCode: '3303', suburb: 'LAKE CONDAH', state: 'VIC' },
  { postCode: '3303', suburb: 'WALLACEDALE', state: 'VIC' },
  { postCode: '3304', suburb: 'BESSIEBELLE', state: 'VIC' },
  { postCode: '3304', suburb: 'DARTMOOR', state: 'VIC' },
  { postCode: '3304', suburb: 'DRIK DRIK', state: 'VIC' },
  { postCode: '3304', suburb: 'DRUMBORG', state: 'VIC' },
  { postCode: '3304', suburb: 'GREENWALD', state: 'VIC' },
  { postCode: '3304', suburb: 'HEYWOOD', state: 'VIC' },
  { postCode: '3304', suburb: 'HOMERTON', state: 'VIC' },
  { postCode: '3304', suburb: 'LYONS', state: 'VIC' },
  { postCode: '3304', suburb: 'MILLTOWN', state: 'VIC' },
  { postCode: '3304', suburb: 'MUMBANNAR', state: 'VIC' },
  { postCode: '3304', suburb: 'MYAMYN', state: 'VIC' },
  { postCode: '3304', suburb: 'WINNAP', state: 'VIC' },
  { postCode: '3305', suburb: 'ALLESTREE', state: 'VIC' },
  { postCode: '3305', suburb: 'BOLWARRA', state: 'VIC' },
  { postCode: '3305', suburb: 'CAPE BRIDGEWATER', state: 'VIC' },
  { postCode: '3305', suburb: 'CASHMORE', state: 'VIC' },
  { postCode: '3305', suburb: 'DUTTON WAY', state: 'VIC' },
  { postCode: '3305', suburb: 'GORAE', state: 'VIC' },
  { postCode: '3305', suburb: 'GORAE WEST', state: 'VIC' },
  { postCode: '3305', suburb: 'HEATHMERE', state: 'VIC' },
  { postCode: '3305', suburb: 'MOUNT RICHMOND', state: 'VIC' },
  { postCode: '3305', suburb: 'PORTLAND', state: 'VIC' },
  { postCode: '3305', suburb: 'PORTLAND NORTH', state: 'VIC' },
  { postCode: '3305', suburb: 'PORTLAND WEST', state: 'VIC' },
  { postCode: '3309', suburb: 'DIGBY', state: 'VIC' },
  { postCode: '3310', suburb: 'MERINO', state: 'VIC' },
  { postCode: '3310', suburb: 'TAHARA WEST', state: 'VIC' },
  { postCode: '3311', suburb: 'CASTERTON', state: 'VIC' },
  { postCode: '3311', suburb: 'CORNDALE', state: 'VIC' },
  { postCode: '3312', suburb: 'BAHGALLAH', state: 'VIC' },
  { postCode: '3312', suburb: 'BRIMBOAL', state: 'VIC' },
  { postCode: '3312', suburb: 'CARAPOOK', state: 'VIC' },
  { postCode: '3312', suburb: 'CHETWYND', state: 'VIC' },
  { postCode: '3312', suburb: 'DERGHOLM', state: 'VIC' },
  { postCode: '3312', suburb: 'DORODONG', state: 'VIC' },
  { postCode: '3312', suburb: 'DUNROBIN', state: 'VIC' },
  { postCode: '3312', suburb: 'HENTY', state: 'VIC' },
  { postCode: '3312', suburb: 'KILLARA', state: 'VIC' },
  { postCode: '3312', suburb: 'LAKE MUNDI', state: 'VIC' },
  { postCode: '3312', suburb: 'LINDSAY', state: 'VIC' },
  { postCode: '3312', suburb: 'NANGEELA', state: 'VIC' },
  { postCode: '3312', suburb: 'POOLAIJELO', state: 'VIC' },
  { postCode: '3312', suburb: 'POWERS CREEK', state: 'VIC' },
  { postCode: '3312', suburb: 'SANDFORD', state: 'VIC' },
  { postCode: '3312', suburb: 'STRATHDOWNIE', state: 'VIC' },
  { postCode: '3312', suburb: 'WANDO BRIDGE', state: 'VIC' },
  { postCode: '3312', suburb: 'WANDO VALE', state: 'VIC' },
  { postCode: '3312', suburb: 'WARROCK', state: 'VIC' },
  { postCode: '3314', suburb: 'BULART', state: 'VIC' },
  { postCode: '3314', suburb: 'CAVENDISH', state: 'VIC' },
  { postCode: '3314', suburb: 'GLENISLA', state: 'VIC' },
  { postCode: '3314', suburb: 'GRAMPIANS', state: 'VIC' },
  { postCode: '3314', suburb: 'MOORALLA', state: 'VIC' },
  { postCode: '3315', suburb: 'BRIT BRIT', state: 'VIC' },
  { postCode: '3315', suburb: 'CLOVER FLAT', state: 'VIC' },
  { postCode: '3315', suburb: 'COLERAINE', state: 'VIC' },
  { postCode: '3315', suburb: 'COOJAR', state: 'VIC' },
  { postCode: '3315', suburb: 'CULLA', state: 'VIC' },
  { postCode: '3315', suburb: 'GRINGEGALGONA', state: 'VIC' },
  { postCode: '3315', suburb: 'GRITJURK', state: 'VIC' },
  { postCode: '3315', suburb: 'HILGAY', state: 'VIC' },
  { postCode: '3315', suburb: 'KONONGWOOTONG', state: 'VIC' },
  { postCode: '3315', suburb: 'MELVILLE FOREST', state: 'VIC' },
  { postCode: '3315', suburb: 'MUNTHAM', state: 'VIC' },
  { postCode: '3315', suburb: 'NAREEN', state: 'VIC' },
  { postCode: '3315', suburb: 'PASCHENDALE', state: 'VIC' },
  { postCode: '3315', suburb: 'TAHARA BRIDGE', state: 'VIC' },
  { postCode: '3315', suburb: 'TARRAYOUKYAN', state: 'VIC' },
  { postCode: '3315', suburb: 'TARRENLEA', state: 'VIC' },
  { postCode: '3315', suburb: 'WOOTONG VALE', state: 'VIC' },
  { postCode: '3317', suburb: 'HARROW', state: 'VIC' },
  { postCode: '3318', suburb: 'CHARAM', state: 'VIC' },
  { postCode: '3318', suburb: 'CONNEWIRRICOO', state: 'VIC' },
  { postCode: '3318', suburb: 'EDENHOPE', state: 'VIC' },
  { postCode: '3318', suburb: 'KADNOOK', state: 'VIC' },
  { postCode: '3318', suburb: 'LANGKOOP', state: 'VIC' },
  { postCode: '3318', suburb: 'PATYAH', state: 'VIC' },
  { postCode: '3318', suburb: 'ULLSWATER', state: 'VIC' },
  { postCode: '3319', suburb: 'APSLEY', state: 'VIC' },
  { postCode: '3319', suburb: 'BENAYEO', state: 'VIC' },
  { postCode: '3319', suburb: 'BRINGALBERT', state: 'VIC' },
  { postCode: '3321', suburb: 'HESSE', state: 'VIC' },
  { postCode: '3321', suburb: 'INVERLEIGH', state: 'VIC' },
  { postCode: '3321', suburb: 'WINGEEL', state: 'VIC' },
  { postCode: '3322', suburb: 'CRESSY', state: 'VIC' },
  { postCode: '3323', suburb: 'BERRYBANK', state: 'VIC' },
  { postCode: '3323', suburb: 'DUVERNEY', state: 'VIC' },
  { postCode: '3323', suburb: 'FOXHOW', state: 'VIC' },
  { postCode: '3324', suburb: 'LISMORE', state: 'VIC' },
  { postCode: '3324', suburb: 'MINGAY', state: 'VIC' },
  { postCode: '3324', suburb: 'MOUNT BUTE', state: 'VIC' },
  { postCode: '3325', suburb: 'DERRINALLUM', state: 'VIC' },
  { postCode: '3325', suburb: 'LARRALEA', state: 'VIC' },
  { postCode: '3325', suburb: 'VITE VITE', state: 'VIC' },
  { postCode: '3325', suburb: 'VITE VITE NORTH', state: 'VIC' },
  { postCode: '3328', suburb: 'TEESDALE', state: 'VIC' },
  { postCode: '3329', suburb: 'BARUNAH PARK', state: 'VIC' },
  { postCode: '3329', suburb: 'BARUNAH PLAINS', state: 'VIC' },
  { postCode: '3329', suburb: 'SHELFORD', state: 'VIC' },
  { postCode: '3330', suburb: 'ROKEWOOD', state: 'VIC' },
  { postCode: '3331', suburb: 'BANNOCKBURN', state: 'VIC' },
  { postCode: '3331', suburb: 'GHERINGHAP', state: 'VIC' },
  { postCode: '3331', suburb: 'MAUDE', state: 'VIC' },
  { postCode: '3331', suburb: 'RUSSELLS BRIDGE', state: 'VIC' },
  { postCode: '3331', suburb: 'SHE OAKS', state: 'VIC' },
  { postCode: '3331', suburb: 'STEIGLITZ', state: 'VIC' },
  { postCode: '3331', suburb: 'SUTHERLANDS CREEK', state: 'VIC' },
  { postCode: '3332', suburb: 'LETHBRIDGE', state: 'VIC' },
  { postCode: '3333', suburb: 'BAMGANIE', state: 'VIC' },
  { postCode: '3333', suburb: 'MEREDITH', state: 'VIC' },
  { postCode: '3334', suburb: 'BUNGAL', state: 'VIC' },
  { postCode: '3334', suburb: 'CARGERIE', state: 'VIC' },
  { postCode: '3334', suburb: 'ELAINE', state: 'VIC' },
  { postCode: '3334', suburb: 'MORRISONS', state: 'VIC' },
  { postCode: '3334', suburb: 'MOUNT DORAN', state: 'VIC' },
  { postCode: '3335', suburb: 'BONNIE BROOK', state: 'VIC' },
  { postCode: '3335', suburb: 'GRANGEFIELDS', state: 'VIC' },
  { postCode: '3335', suburb: 'PLUMPTON', state: 'VIC' },
  { postCode: '3335', suburb: 'ROCKBANK', state: 'VIC' },
  { postCode: '3335', suburb: 'THORNHILL PARK', state: 'VIC' },
  { postCode: '3336', suburb: 'AINTREE', state: 'VIC' },
  { postCode: '3336', suburb: 'DEANSIDE', state: 'VIC' },
  { postCode: '3336', suburb: 'FRASER RISE', state: 'VIC' },
  { postCode: '3337', suburb: 'HARKNESS', state: 'VIC' },
  { postCode: '3337', suburb: 'KURUNJANG', state: 'VIC' },
  { postCode: '3337', suburb: 'MELTON', state: 'VIC' },
  { postCode: '3337', suburb: 'MELTON WEST', state: 'VIC' },
  { postCode: '3337', suburb: 'TOOLERN VALE', state: 'VIC' },
  { postCode: '3338', suburb: 'BROOKFIELD', state: 'VIC' },
  { postCode: '3338', suburb: 'COBBLEBANK', state: 'VIC' },
  { postCode: '3338', suburb: 'EXFORD', state: 'VIC' },
  { postCode: '3338', suburb: 'EYNESBURY', state: 'VIC' },
  { postCode: '3338', suburb: 'MELTON SOUTH', state: 'VIC' },
  { postCode: '3338', suburb: 'STRATHTULLOH', state: 'VIC' },
  { postCode: '3338', suburb: 'WEIR VIEWS', state: 'VIC' },
  { postCode: '3340', suburb: 'BACCHUS MARSH', state: 'VIC' },
  { postCode: '3340', suburb: 'BALLIANG', state: 'VIC' },
  { postCode: '3340', suburb: 'BALLIANG EAST', state: 'VIC' },
  { postCode: '3340', suburb: 'COIMADAI', state: 'VIC' },
  { postCode: '3340', suburb: 'DARLEY', state: 'VIC' },
  { postCode: '3340', suburb: 'GLENMORE', state: 'VIC' },
  { postCode: '3340', suburb: 'HOPETOUN PARK', state: 'VIC' },
  { postCode: '3340', suburb: 'LONG FOREST', state: 'VIC' },
  { postCode: '3340', suburb: 'MADDINGLEY', state: 'VIC' },
  { postCode: '3340', suburb: 'MERRIMU', state: 'VIC' },
  { postCode: '3340', suburb: 'PARWAN', state: 'VIC' },
  { postCode: '3340', suburb: 'ROWSLEY', state: 'VIC' },
  { postCode: '3340', suburb: 'STAUGHTON VALE', state: 'VIC' },
  { postCode: '3341', suburb: 'DALES CREEK', state: 'VIC' },
  { postCode: '3341', suburb: 'GREENDALE', state: 'VIC' },
  { postCode: '3341', suburb: 'KOROBEIT', state: 'VIC' },
  { postCode: '3341', suburb: 'MYRNIONG', state: 'VIC' },
  { postCode: '3341', suburb: 'PENTLAND HILLS', state: 'VIC' },
  { postCode: '3342', suburb: 'BALLAN', state: 'VIC' },
  { postCode: '3342', suburb: 'BEREMBOKE', state: 'VIC' },
  { postCode: '3342', suburb: 'BLAKEVILLE', state: 'VIC' },
  { postCode: '3342', suburb: 'BUNDING', state: 'VIC' },
  { postCode: '3342', suburb: 'COLBROOK', state: 'VIC' },
  { postCode: '3342', suburb: 'DURDIDWARRAH', state: 'VIC' },
  { postCode: '3342', suburb: 'FISKVILLE', state: 'VIC' },
  { postCode: '3342', suburb: 'INGLISTON', state: 'VIC' },
  { postCode: '3342', suburb: 'MOUNT WALLACE', state: 'VIC' },
  { postCode: '3345', suburb: 'GORDON', state: 'VIC' },
  { postCode: '3350', suburb: 'ALFREDTON', state: 'VIC' },
  { postCode: '3350', suburb: 'BAKERY HILL', state: 'VIC' },
  { postCode: '3350', suburb: 'BALLARAT', state: 'VIC' },
  { postCode: '3350', suburb: 'BALLARAT CENTRAL', state: 'VIC' },
  { postCode: '3350', suburb: 'BALLARAT EAST', state: 'VIC' },
  { postCode: '3350', suburb: 'BALLARAT NORTH', state: 'VIC' },
  { postCode: '3350', suburb: 'BALLARAT WEST', state: 'VIC' },
  { postCode: '3350', suburb: 'BLACK HILL', state: 'VIC' },
  { postCode: '3350', suburb: 'BROWN HILL', state: 'VIC' },
  { postCode: '3350', suburb: 'CANADIAN', state: 'VIC' },
  { postCode: '3350', suburb: 'EUREKA', state: 'VIC' },
  { postCode: '3350', suburb: 'GOLDEN POINT', state: 'VIC' },
  { postCode: '3350', suburb: 'INVERMAY PARK', state: 'VIC' },
  { postCode: '3350', suburb: 'LAKE WENDOUREE', state: 'VIC' },
  { postCode: '3350', suburb: 'LUCAS', state: 'VIC' },
  { postCode: '3350', suburb: 'MOUNT CLEAR', state: 'VIC' },
  { postCode: '3350', suburb: 'MOUNT HELEN', state: 'VIC' },
  { postCode: '3350', suburb: 'MOUNT PLEASANT', state: 'VIC' },
  { postCode: '3350', suburb: 'NERRINA', state: 'VIC' },
  { postCode: '3350', suburb: 'NEWINGTON', state: 'VIC' },
  { postCode: '3350', suburb: 'REDAN', state: 'VIC' },
  { postCode: '3350', suburb: 'SOLDIERS HILL', state: 'VIC' },
  { postCode: '3351', suburb: 'BERRINGA', state: 'VIC' },
  { postCode: '3351', suburb: 'BO PEEP', state: 'VIC' },
  { postCode: '3351', suburb: 'CAPE CLEAR', state: 'VIC' },
  { postCode: '3351', suburb: 'CARNGHAM', state: 'VIC' },
  { postCode: '3351', suburb: 'CHEPSTOWE', state: 'VIC' },
  { postCode: '3351', suburb: 'HADDON', state: 'VIC' },
  { postCode: '3351', suburb: 'HILLCREST', state: 'VIC' },
  { postCode: '3351', suburb: 'ILLABAROOK', state: 'VIC' },
  { postCode: '3351', suburb: 'LAKE BOLAC', state: 'VIC' },
  { postCode: '3351', suburb: 'MININERA', state: 'VIC' },
  { postCode: '3351', suburb: 'MOUNT EMU', state: 'VIC' },
  { postCode: '3351', suburb: 'NERRIN NERRIN', state: 'VIC' },
  { postCode: '3351', suburb: 'NEWTOWN', state: 'VIC' },
  { postCode: '3351', suburb: 'NINTINGBOOL', state: 'VIC' },
  { postCode: '3351', suburb: 'PIGGOREET', state: 'VIC' },
  { postCode: '3351', suburb: 'PITFIELD', state: 'VIC' },
  { postCode: '3351', suburb: 'ROKEWOOD JUNCTION', state: 'VIC' },
  { postCode: '3351', suburb: 'ROSS CREEK', state: 'VIC' },
  { postCode: '3351', suburb: 'SCARSDALE', state: 'VIC' },
  { postCode: '3351', suburb: 'SMYTHES CREEK', state: 'VIC' },
  { postCode: '3351', suburb: 'SMYTHESDALE', state: 'VIC' },
  { postCode: '3351', suburb: 'SNAKE VALLEY', state: 'VIC' },
  { postCode: '3351', suburb: 'SPRINGDALLAH', state: 'VIC' },
  { postCode: '3351', suburb: 'STAFFORDSHIRE REEF', state: 'VIC' },
  { postCode: '3351', suburb: 'STREATHAM', state: 'VIC' },
  { postCode: '3351', suburb: 'WALLINDUC', state: 'VIC' },
  { postCode: '3351', suburb: 'WESTMERE', state: 'VIC' },
  { postCode: '3352', suburb: 'ADDINGTON', state: 'VIC' },
  { postCode: '3352', suburb: 'BLOWHARD', state: 'VIC' },
  { postCode: '3352', suburb: 'BOLWARRAH', state: 'VIC' },
  { postCode: '3352', suburb: 'BONSHAW', state: 'VIC' },
  { postCode: '3352', suburb: 'BREWSTER', state: 'VIC' },
  { postCode: '3352', suburb: 'BULLAROOK', state: 'VIC' },
  { postCode: '3352', suburb: 'BUNGAREE', state: 'VIC' },
  { postCode: '3352', suburb: 'BUNKERS HILL', state: 'VIC' },
  { postCode: '3352', suburb: 'BURRUMBEET', state: 'VIC' },
  { postCode: '3352', suburb: 'CAMBRIAN HILL', state: 'VIC' },
  { postCode: '3352', suburb: 'CARDIGAN', state: 'VIC' },
  { postCode: '3352', suburb: 'CARDIGAN VILLAGE', state: 'VIC' },
  { postCode: '3352', suburb: 'CHAPEL FLAT', state: 'VIC' },
  { postCode: '3352', suburb: 'CLARENDON', state: 'VIC' },
  { postCode: '3352', suburb: 'CLARETOWN', state: 'VIC' },
  { postCode: '3352', suburb: 'CLARKES HILL', state: 'VIC' },
  { postCode: '3352', suburb: 'CORINDHAP', state: 'VIC' },
  { postCode: '3352', suburb: 'DEREEL', state: 'VIC' },
  { postCode: '3352', suburb: 'DUNNSTOWN', state: 'VIC' },
  { postCode: '3352', suburb: 'DURHAM LEAD', state: 'VIC' },
  { postCode: '3352', suburb: 'ENFIELD', state: 'VIC' },
  { postCode: '3352', suburb: 'ERCILDOUNE', state: 'VIC' },
  { postCode: '3352', suburb: 'GARIBALDI', state: 'VIC' },
  { postCode: '3352', suburb: 'GLEN PARK', state: 'VIC' },
  { postCode: '3352', suburb: 'GLENBRAE', state: 'VIC' },
  { postCode: '3352', suburb: 'GONG GONG', state: 'VIC' },
  { postCode: '3352', suburb: 'GRENVILLE', state: 'VIC' },
  { postCode: '3352', suburb: 'INVERMAY', state: 'VIC' },
  { postCode: '3352', suburb: 'LAL LAL', state: 'VIC' },
  { postCode: '3352', suburb: 'LAMPLOUGH', state: 'VIC' },
  { postCode: '3352', suburb: 'LANGI KAL KAL', state: 'VIC' },
  { postCode: '3352', suburb: 'LEARMONTH', state: 'VIC' },
  { postCode: '3352', suburb: 'LEIGH CREEK', state: 'VIC' },
  { postCode: '3352', suburb: 'LEXTON', state: 'VIC' },
  { postCode: '3352', suburb: 'MAGPIE', state: 'VIC' },
  { postCode: '3352', suburb: 'MILLBROOK', state: 'VIC' },
  { postCode: '3352', suburb: 'MINERS REST', state: 'VIC' },
  { postCode: '3352', suburb: 'MOLLONGGHIP', state: 'VIC' },
  { postCode: '3352', suburb: 'MOUNT BOLTON', state: 'VIC' },
  { postCode: '3352', suburb: 'MOUNT EGERTON', state: 'VIC' },
  { postCode: '3352', suburb: 'MOUNT MERCER', state: 'VIC' },
  { postCode: '3352', suburb: 'MOUNT ROWAN', state: 'VIC' },
  { postCode: '3352', suburb: 'NAPOLEONS', state: 'VIC' },
  { postCode: '3352', suburb: 'NAVIGATORS', state: 'VIC' },
  { postCode: '3352', suburb: 'POOTILLA', state: 'VIC' },
  { postCode: '3352', suburb: 'SCOTCHMANS LEAD', state: 'VIC' },
  { postCode: '3352', suburb: 'SCOTSBURN', state: 'VIC' },
  { postCode: '3352', suburb: 'SPRINGBANK', state: 'VIC' },
  { postCode: '3352', suburb: 'SULKY', state: 'VIC' },
  { postCode: '3352', suburb: 'WALLACE', state: 'VIC' },
  { postCode: '3352', suburb: 'WARRENHEIP', state: 'VIC' },
  { postCode: '3352', suburb: 'WATTLE FLAT', state: 'VIC' },
  { postCode: '3352', suburb: 'WAUBRA', state: 'VIC' },
  { postCode: '3352', suburb: 'WEATHERBOARD', state: 'VIC' },
  { postCode: '3352', suburb: 'WERNETH', state: 'VIC' },
  { postCode: '3352', suburb: 'WINDERMERE', state: 'VIC' },
  { postCode: '3352', suburb: 'YENDON', state: 'VIC' },
  { postCode: '3353', suburb: 'BALLARAT', state: 'VIC' },
  { postCode: '3354', suburb: 'BAKERY HILL', state: 'VIC' },
  { postCode: '3354', suburb: 'BALLARAT MC', state: 'VIC' },
  { postCode: '3355', suburb: 'LAKE GARDENS', state: 'VIC' },
  { postCode: '3355', suburb: 'MITCHELL PARK', state: 'VIC' },
  { postCode: '3355', suburb: 'WENDOUREE', state: 'VIC' },
  { postCode: '3355', suburb: 'WENDOUREE VILLAGE', state: 'VIC' },
  { postCode: '3356', suburb: 'DELACOMBE', state: 'VIC' },
  { postCode: '3356', suburb: 'SEBASTOPOL', state: 'VIC' },
  { postCode: '3357', suburb: 'BUNINYONG', state: 'VIC' },
  { postCode: '3358', suburb: 'WINTER VALLEY', state: 'VIC' },
  { postCode: '3360', suburb: 'HAPPY VALLEY', state: 'VIC' },
  { postCode: '3360', suburb: 'LINTON', state: 'VIC' },
  { postCode: '3360', suburb: 'MANNIBADAR', state: 'VIC' },
  { postCode: '3360', suburb: 'PITTONG', state: 'VIC' },
  { postCode: '3360', suburb: 'WILLOWVALE', state: 'VIC' },
  { postCode: '3361', suburb: 'BRADVALE', state: 'VIC' },
  { postCode: '3361', suburb: 'CARRANBALLAC', state: 'VIC' },
  { postCode: '3361', suburb: 'SKIPTON', state: 'VIC' },
  { postCode: '3363', suburb: 'CRESWICK', state: 'VIC' },
  { postCode: '3363', suburb: 'CRESWICK NORTH', state: 'VIC' },
  { postCode: '3363', suburb: 'DEAN', state: 'VIC' },
  { postCode: '3363', suburb: 'GLENDARUEL', state: 'VIC' },
  { postCode: '3363', suburb: 'LANGDONS HILL', state: 'VIC' },
  { postCode: '3363', suburb: 'MOUNT BECKWORTH', state: 'VIC' },
  { postCode: '3363', suburb: 'TOURELLO', state: 'VIC' },
  { postCode: '3364', suburb: 'ALLENDALE', state: 'VIC' },
  { postCode: '3364', suburb: 'ASCOT', state: 'VIC' },
  { postCode: '3364', suburb: 'BALD HILLS', state: 'VIC' },
  { postCode: '3364', suburb: 'BARKSTEAD', state: 'VIC' },
  { postCode: '3364', suburb: 'BLAMPIED', state: 'VIC' },
  { postCode: '3364', suburb: 'BROOMFIELD', state: 'VIC' },
  { postCode: '3364', suburb: 'CABBAGE TREE', state: 'VIC' },
  { postCode: '3364', suburb: 'CAMPBELLTOWN', state: 'VIC' },
  { postCode: '3364', suburb: 'COGHILLS CREEK', state: 'VIC' },
  { postCode: '3364', suburb: 'GLENDONALD', state: 'VIC' },
  { postCode: '3364', suburb: 'JOYCES CREEK', state: 'VIC' },
  { postCode: '3364', suburb: 'KINGSTON', state: 'VIC' },
  { postCode: '3364', suburb: 'KOOROOCHEANG', state: 'VIC' },
  { postCode: '3364', suburb: 'LAWRENCE', state: 'VIC' },
  { postCode: '3364', suburb: 'MOUNT PROSPECT', state: 'VIC' },
  { postCode: '3364', suburb: 'NEWLYN', state: 'VIC' },
  { postCode: '3364', suburb: 'NEWLYN NORTH', state: 'VIC' },
  { postCode: '3364', suburb: 'ROCKLYN', state: 'VIC' },
  { postCode: '3364', suburb: 'SMEATON', state: 'VIC' },
  { postCode: '3364', suburb: 'SMOKEYTOWN', state: 'VIC' },
  { postCode: '3364', suburb: 'SPRINGMOUNT', state: 'VIC' },
  { postCode: '3364', suburb: 'STRATHLEA', state: 'VIC' },
  { postCode: '3364', suburb: 'WERONA', state: 'VIC' },
  { postCode: '3370', suburb: 'CLUNES', state: 'VIC' },
  { postCode: '3370', suburb: 'GLENGOWER', state: 'VIC' },
  { postCode: '3370', suburb: 'MOUNT CAMERON', state: 'VIC' },
  { postCode: '3370', suburb: 'ULLINA', state: 'VIC' },
  { postCode: '3371', suburb: 'AMHERST', state: 'VIC' },
  { postCode: '3371', suburb: 'BURNBANK', state: 'VIC' },
  { postCode: '3371', suburb: 'CARALULUP', state: 'VIC' },
  { postCode: '3371', suburb: 'DUNACH', state: 'VIC' },
  { postCode: '3371', suburb: 'EVANSFORD', state: 'VIC' },
  { postCode: '3371', suburb: 'LILLICUR', state: 'VIC' },
  { postCode: '3371', suburb: 'MOUNT GLASGOW', state: 'VIC' },
  { postCode: '3371', suburb: 'RED LION', state: 'VIC' },
  { postCode: '3371', suburb: 'STONY CREEK', state: 'VIC' },
  { postCode: '3371', suburb: 'TALBOT', state: 'VIC' },
  { postCode: '3373', suburb: 'BEAUFORT', state: 'VIC' },
  { postCode: '3373', suburb: 'CHUTE', state: 'VIC' },
  { postCode: '3373', suburb: 'CROSS ROADS', state: 'VIC' },
  { postCode: '3373', suburb: 'LAKE GOLDSMITH', state: 'VIC' },
  { postCode: '3373', suburb: 'LAKE WONGAN', state: 'VIC' },
  { postCode: '3373', suburb: 'MAIN LEAD', state: 'VIC' },
  { postCode: '3373', suburb: 'MENA PARK', state: 'VIC' },
  { postCode: '3373', suburb: 'NERRING', state: 'VIC' },
  { postCode: '3373', suburb: 'RAGLAN', state: 'VIC' },
  { postCode: '3373', suburb: 'STOCKYARD HILL', state: 'VIC' },
  { postCode: '3373', suburb: 'STONELEIGH', state: 'VIC' },
  { postCode: '3373', suburb: 'TRAWALLA', state: 'VIC' },
  { postCode: '3373', suburb: 'WATERLOO', state: 'VIC' },
  { postCode: '3374', suburb: 'GREAT WESTERN', state: 'VIC' },
  { postCode: '3375', suburb: 'BALLYROGAN', state: 'VIC' },
  { postCode: '3375', suburb: 'BAYINDEEN', state: 'VIC' },
  { postCode: '3375', suburb: 'BUANGOR', state: 'VIC' },
  { postCode: '3375', suburb: 'MIDDLE CREEK', state: 'VIC' },
  { postCode: '3377', suburb: 'ARARAT', state: 'VIC' },
  { postCode: '3377', suburb: 'ARMSTRONG', state: 'VIC' },
  { postCode: '3377', suburb: 'BULGANA', state: 'VIC' },
  { postCode: '3377', suburb: 'CATHCART', state: 'VIC' },
  { postCode: '3377', suburb: 'CROWLANDS', state: 'VIC' },
  { postCode: '3377', suburb: 'DENICULL CREEK', state: 'VIC' },
  { postCode: '3377', suburb: 'DOBIE', state: 'VIC' },
  { postCode: '3377', suburb: 'DUNNEWORTHY', state: 'VIC' },
  { postCode: '3377', suburb: 'EVERSLEY', state: 'VIC' },
  { postCode: '3377', suburb: 'LANGI LOGAN', state: 'VIC' },
  { postCode: '3377', suburb: 'MAROONA', state: 'VIC' },
  { postCode: '3377', suburb: 'MOUNT COLE', state: 'VIC' },
  { postCode: '3377', suburb: 'MOUNT COLE CREEK', state: 'VIC' },
  { postCode: '3377', suburb: 'MOYSTON', state: 'VIC' },
  { postCode: '3377', suburb: 'NORVAL', state: 'VIC' },
  { postCode: '3377', suburb: 'RHYMNEY', state: 'VIC' },
  { postCode: '3377', suburb: 'ROCKY POINT', state: 'VIC' },
  { postCode: '3377', suburb: 'ROSSBRIDGE', state: 'VIC' },
  { postCode: '3377', suburb: 'SHAYS FLAT', state: 'VIC' },
  { postCode: '3377', suburb: 'WARRAK', state: 'VIC' },
  { postCode: '3378', suburb: 'TATYOON', state: 'VIC' },
  { postCode: '3378', suburb: 'YALLA-Y-POORA', state: 'VIC' },
  { postCode: '3379', suburb: 'BORNES HILL', state: 'VIC' },
  { postCode: '3379', suburb: 'CHATSWORTH', state: 'VIC' },
  { postCode: '3379', suburb: 'MAFEKING', state: 'VIC' },
  { postCode: '3379', suburb: 'STAVELY', state: 'VIC' },
  { postCode: '3379', suburb: 'WICKLIFFE', state: 'VIC' },
  { postCode: '3379', suburb: 'WILLAURA', state: 'VIC' },
  { postCode: '3379', suburb: 'WILLAURA NORTH', state: 'VIC' },
  { postCode: '3380', suburb: 'STAWELL', state: 'VIC' },
  { postCode: '3380', suburb: 'STAWELL WEST', state: 'VIC' },
  { postCode: '3381', suburb: 'BELLELLEN', state: 'VIC' },
  { postCode: '3381', suburb: 'BELLFIELD', state: 'VIC' },
  { postCode: '3381', suburb: 'BLACK RANGE', state: 'VIC' },
  { postCode: '3381', suburb: 'FYANS CREEK', state: 'VIC' },
  { postCode: '3381', suburb: 'HALLS GAP', state: 'VIC' },
  { postCode: '3381', suburb: 'ILLAWARRA', state: 'VIC' },
  { postCode: '3381', suburb: 'LAKE FYANS', state: 'VIC' },
  { postCode: '3381', suburb: 'LAKE LONSDALE', state: 'VIC' },
  { postCode: '3381', suburb: 'MOKEPILLY', state: 'VIC' },
  { postCode: '3381', suburb: 'MOUNT DRYDEN', state: 'VIC' },
  { postCode: '3381', suburb: 'POMONAL', state: 'VIC' },
  { postCode: '3384', suburb: 'BARKLY', state: 'VIC' },
  { postCode: '3384', suburb: 'CONCONGELLA', state: 'VIC' },
  { postCode: '3384', suburb: 'FRENCHMANS', state: 'VIC' },
  { postCode: '3384', suburb: 'JOEL JOEL', state: 'VIC' },
  { postCode: '3384', suburb: 'JOEL SOUTH', state: 'VIC' },
  { postCode: '3384', suburb: 'LANDSBOROUGH', state: 'VIC' },
  { postCode: '3384', suburb: 'LANDSBOROUGH WEST', state: 'VIC' },
  { postCode: '3384', suburb: 'NAVARRE', state: 'VIC' },
  { postCode: '3384', suburb: 'TULKARA', state: 'VIC' },
  { postCode: '3384', suburb: 'WATTLE CREEK', state: 'VIC' },
  { postCode: '3385', suburb: 'DADSWELLS BRIDGE', state: 'VIC' },
  { postCode: '3385', suburb: 'DEEP LEAD', state: 'VIC' },
  { postCode: '3385', suburb: 'GLENORCHY', state: 'VIC' },
  { postCode: '3385', suburb: 'LEDCOURT', state: 'VIC' },
  { postCode: '3385', suburb: 'LUBECK', state: 'VIC' },
  { postCode: '3385', suburb: 'RIACHELLA', state: 'VIC' },
  { postCode: '3385', suburb: 'ROSES GAP', state: 'VIC' },
  { postCode: '3385', suburb: 'WAL WAL', state: 'VIC' },
  { postCode: '3387', suburb: 'BOLANGUM', state: 'VIC' },
  { postCode: '3387', suburb: 'CALLAWADDA', state: 'VIC' },
  { postCode: '3387', suburb: 'CAMPBELLS BRIDGE', state: 'VIC' },
  { postCode: '3387', suburb: 'GERMANIA', state: 'VIC' },
  { postCode: '3387', suburb: 'GREENS CREEK', state: 'VIC' },
  { postCode: '3387', suburb: 'KANYA', state: 'VIC' },
  { postCode: '3387', suburb: 'MARNOO', state: 'VIC' },
  { postCode: '3387', suburb: 'MARNOO WEST', state: 'VIC' },
  { postCode: '3387', suburb: 'MORRL MORRL', state: 'VIC' },
  { postCode: '3387', suburb: 'WALLALOO', state: 'VIC' },
  { postCode: '3387', suburb: 'WALLALOO EAST', state: 'VIC' },
  { postCode: '3388', suburb: 'BANYENA', state: 'VIC' },
  { postCode: '3388', suburb: 'RUPANYUP', state: 'VIC' },
  { postCode: '3390', suburb: 'KEWELL', state: 'VIC' },
  { postCode: '3390', suburb: 'MURTOA', state: 'VIC' },
  { postCode: '3391', suburb: 'BRIM', state: 'VIC' },
  { postCode: '3392', suburb: 'BOOLITE', state: 'VIC' },
  { postCode: '3392', suburb: 'MINYIP', state: 'VIC' },
  { postCode: '3392', suburb: 'SHEEP HILLS', state: 'VIC' },
  { postCode: '3393', suburb: 'AUBREY', state: 'VIC' },
  { postCode: '3393', suburb: 'BANGERANG', state: 'VIC' },
  { postCode: '3393', suburb: 'CANNUM', state: 'VIC' },
  { postCode: '3393', suburb: 'CRYMELON', state: 'VIC' },
  { postCode: '3393', suburb: 'KELLALAC', state: 'VIC' },
  { postCode: '3393', suburb: 'LAH', state: 'VIC' },
  { postCode: '3393', suburb: 'WARRACKNABEAL', state: 'VIC' },
  { postCode: '3393', suburb: 'WILKUR', state: 'VIC' },
  { postCode: '3393', suburb: 'WILLENABRINA', state: 'VIC' },
  { postCode: '3395', suburb: 'BEULAH', state: 'VIC' },
  { postCode: '3395', suburb: 'KENMARE', state: 'VIC' },
  { postCode: '3395', suburb: 'REEDY DAM', state: 'VIC' },
  { postCode: '3395', suburb: 'ROSEBERY', state: 'VIC' },
  { postCode: '3396', suburb: 'HOPETOUN', state: 'VIC' },
  { postCode: '3400', suburb: 'HORSHAM', state: 'VIC' },
  { postCode: '3401', suburb: 'BLACKHEATH', state: 'VIC' },
  { postCode: '3401', suburb: 'BRIMPAEN', state: 'VIC' },
  { postCode: '3401', suburb: 'BUNGALALLY', state: 'VIC' },
  { postCode: '3401', suburb: 'CHERRYPOOL', state: 'VIC' },
  { postCode: '3401', suburb: 'DOOEN', state: 'VIC' },
  { postCode: '3401', suburb: 'DRUNG', state: 'VIC' },
  { postCode: '3401', suburb: 'GYMBOWEN', state: 'VIC' },
  { postCode: '3401', suburb: 'HAVEN', state: 'VIC' },
  { postCode: '3401', suburb: 'JUNG', state: 'VIC' },
  { postCode: '3401', suburb: 'KALKEE', state: 'VIC' },
  { postCode: '3401', suburb: 'KANAGULK', state: 'VIC' },
  { postCode: '3401', suburb: 'KARNAK', state: 'VIC' },
  { postCode: '3401', suburb: 'LAHARUM', state: 'VIC' },
  { postCode: '3401', suburb: 'LONGERENONG', state: 'VIC' },
  { postCode: '3401', suburb: 'LOWER NORTON', state: 'VIC' },
  { postCode: '3401', suburb: 'MCKENZIE CREEK', state: 'VIC' },
  { postCode: '3401', suburb: 'MOCKINYA', state: 'VIC' },
  { postCode: '3401', suburb: 'MURRA WARRA', state: 'VIC' },
  { postCode: '3401', suburb: 'NURCOUNG', state: 'VIC' },
  { postCode: '3401', suburb: 'NURRABIEL', state: 'VIC' },
  { postCode: '3401', suburb: 'PIMPINIO', state: 'VIC' },
  { postCode: '3401', suburb: 'QUANTONG', state: 'VIC' },
  { postCode: '3401', suburb: 'RIVERSIDE', state: 'VIC' },
  { postCode: '3401', suburb: 'ROCKLANDS', state: 'VIC' },
  { postCode: '3401', suburb: 'ST HELENS PLAINS', state: 'VIC' },
  { postCode: '3401', suburb: 'TELANGATUK EAST', state: 'VIC' },
  { postCode: '3401', suburb: 'TOOLONDO', state: 'VIC' },
  { postCode: '3401', suburb: 'VECTIS', state: 'VIC' },
  { postCode: '3401', suburb: 'WAIL', state: 'VIC' },
  { postCode: '3401', suburb: 'WALLUP', state: 'VIC' },
  { postCode: '3401', suburb: 'WARTOOK', state: 'VIC' },
  { postCode: '3401', suburb: 'WONWONDAH', state: 'VIC' },
  { postCode: '3401', suburb: 'ZUMSTEINS', state: 'VIC' },
  { postCode: '3402', suburb: 'HORSHAM', state: 'VIC' },
  { postCode: '3407', suburb: 'BALMORAL', state: 'VIC' },
  { postCode: '3407', suburb: 'ENGLEFIELD', state: 'VIC' },
  { postCode: '3407', suburb: 'GATUM', state: 'VIC' },
  { postCode: '3407', suburb: 'PIGEON PONDS', state: 'VIC' },
  { postCode: '3407', suburb: 'VASEY', state: 'VIC' },
  { postCode: '3409', suburb: 'ARAPILES', state: 'VIC' },
  { postCode: '3409', suburb: 'CLEAR LAKE', state: 'VIC' },
  { postCode: '3409', suburb: 'DOUGLAS', state: 'VIC' },
  { postCode: '3409', suburb: 'DUCHEMBEGARRA', state: 'VIC' },
  { postCode: '3409', suburb: 'GRASS FLAT', state: 'VIC' },
  { postCode: '3409', suburb: 'JILPANGER', state: 'VIC' },
  { postCode: '3409', suburb: 'MIGA LAKE', state: 'VIC' },
  { postCode: '3409', suburb: 'MITRE', state: 'VIC' },
  { postCode: '3409', suburb: 'NATIMUK', state: 'VIC' },
  { postCode: '3409', suburb: 'NORADJUHA', state: 'VIC' },
  { postCode: '3409', suburb: 'TOOAN', state: 'VIC' },
  { postCode: '3409', suburb: 'WOMBELANO', state: 'VIC' },
  { postCode: '3412', suburb: 'GOROKE', state: 'VIC' },
  { postCode: '3413', suburb: 'MINIMAY', state: 'VIC' },
  { postCode: '3413', suburb: 'NEUARPURR', state: 'VIC' },
  { postCode: '3413', suburb: 'OZENKADNOOK', state: 'VIC' },
  { postCode: '3413', suburb: 'PERONNE', state: 'VIC' },
  { postCode: '3414', suburb: 'ANTWERP', state: 'VIC' },
  { postCode: '3414', suburb: 'DIMBOOLA', state: 'VIC' },
  { postCode: '3414', suburb: 'TARRANYURK', state: 'VIC' },
  { postCode: '3415', suburb: 'MIRAM', state: 'VIC' },
  { postCode: '3418', suburb: 'BROUGHTON', state: 'VIC' },
  { postCode: '3418', suburb: 'GERANG GERUNG', state: 'VIC' },
  { postCode: '3418', suburb: 'GLENLEE', state: 'VIC' },
  { postCode: '3418', suburb: 'KIATA', state: 'VIC' },
  { postCode: '3418', suburb: 'LAWLOIT', state: 'VIC' },
  { postCode: '3418', suburb: 'LITTLE DESERT', state: 'VIC' },
  { postCode: '3418', suburb: 'LORQUON', state: 'VIC' },
  { postCode: '3418', suburb: 'NETHERBY', state: 'VIC' },
  { postCode: '3418', suburb: 'NHILL', state: 'VIC' },
  { postCode: '3418', suburb: 'YANAC', state: 'VIC' },
  { postCode: '3419', suburb: 'KANIVA', state: 'VIC' },
  { postCode: '3420', suburb: 'LILLIMUR', state: 'VIC' },
  { postCode: '3420', suburb: 'SERVICETON', state: 'VIC' },
  { postCode: '3420', suburb: 'TELOPEA DOWNS', state: 'VIC' },
  { postCode: '3423', suburb: 'JEPARIT', state: 'VIC' },
  { postCode: '3424', suburb: 'ALBACUTYA', state: 'VIC' },
  { postCode: '3424', suburb: 'RAINBOW', state: 'VIC' },
  { postCode: '3424', suburb: 'YAAPEET', state: 'VIC' },
  { postCode: '3427', suburb: 'DIGGERS REST', state: 'VIC' },
  { postCode: '3428', suburb: 'BULLA', state: 'VIC' },
  { postCode: '3429', suburb: 'SUNBURY', state: 'VIC' },
  { postCode: '3429', suburb: 'WILDWOOD', state: 'VIC' },
  { postCode: '3430', suburb: 'CLARKEFIELD', state: 'VIC' },
  { postCode: '3431', suburb: 'RIDDELLS CREEK', state: 'VIC' },
  { postCode: '3432', suburb: 'BOLINDA', state: 'VIC' },
  { postCode: '3433', suburb: 'MONEGEETTA', state: 'VIC' },
  { postCode: '3434', suburb: 'CHEROKEE', state: 'VIC' },
  { postCode: '3434', suburb: 'KERRIE', state: 'VIC' },
  { postCode: '3434', suburb: 'ROMSEY', state: 'VIC' },
  { postCode: '3434', suburb: 'SPRINGFIELD', state: 'VIC' },
  { postCode: '3435', suburb: 'BENLOCH', state: 'VIC' },
  { postCode: '3435', suburb: 'GOLDIE', state: 'VIC' },
  { postCode: '3435', suburb: 'LANCEFIELD', state: 'VIC' },
  { postCode: '3435', suburb: 'NULLA VALE', state: 'VIC' },
  { postCode: '3437', suburb: 'BULLENGAROOK', state: 'VIC' },
  { postCode: '3437', suburb: 'GISBORNE', state: 'VIC' },
  { postCode: '3437', suburb: 'GISBORNE SOUTH', state: 'VIC' },
  { postCode: '3438', suburb: 'NEW GISBORNE', state: 'VIC' },
  { postCode: '3440', suburb: 'MACEDON', state: 'VIC' },
  { postCode: '3441', suburb: 'MOUNT MACEDON', state: 'VIC' },
  { postCode: '3442', suburb: 'ASHBOURNE', state: 'VIC' },
  { postCode: '3442', suburb: 'CADELLO', state: 'VIC' },
  { postCode: '3442', suburb: 'CARLSRUHE', state: 'VIC' },
  { postCode: '3442', suburb: 'COBAW', state: 'VIC' },
  { postCode: '3442', suburb: 'HESKET', state: 'VIC' },
  { postCode: '3442', suburb: 'NEWHAM', state: 'VIC' },
  { postCode: '3442', suburb: 'ROCHFORD', state: 'VIC' },
  { postCode: '3442', suburb: 'WOODEND', state: 'VIC' },
  { postCode: '3442', suburb: 'WOODEND NORTH', state: 'VIC' },
  { postCode: '3444', suburb: 'BARFOLD', state: 'VIC' },
  { postCode: '3444', suburb: 'BAYNTON', state: 'VIC' },
  { postCode: '3444', suburb: 'BAYNTON EAST', state: 'VIC' },
  { postCode: '3444', suburb: 'EDGECOMBE', state: 'VIC' },
  { postCode: '3444', suburb: 'GLENHOPE', state: 'VIC' },
  { postCode: '3444', suburb: 'GREENHILL', state: 'VIC' },
  { postCode: '3444', suburb: 'KYNETON', state: 'VIC' },
  { postCode: '3444', suburb: 'KYNETON SOUTH', state: 'VIC' },
  { postCode: '3444', suburb: 'LANGLEY', state: 'VIC' },
  { postCode: '3444', suburb: 'LAURISTON', state: 'VIC' },
  { postCode: '3444', suburb: 'LYAL', state: 'VIC' },
  { postCode: '3444', suburb: 'METCALFE EAST', state: 'VIC' },
  { postCode: '3444', suburb: 'MIA MIA', state: 'VIC' },
  { postCode: '3444', suburb: 'PASTORIA', state: 'VIC' },
  { postCode: '3444', suburb: 'PASTORIA EAST', state: 'VIC' },
  { postCode: '3444', suburb: 'PIPERS CREEK', state: 'VIC' },
  { postCode: '3444', suburb: 'REDESDALE', state: 'VIC' },
  { postCode: '3444', suburb: 'SIDONIA', state: 'VIC' },
  { postCode: '3444', suburb: 'SPRING HILL', state: 'VIC' },
  { postCode: '3444', suburb: 'TYLDEN', state: 'VIC' },
  { postCode: '3444', suburb: 'TYLDEN SOUTH', state: 'VIC' },
  { postCode: '3446', suburb: 'DRUMMOND NORTH', state: 'VIC' },
  { postCode: '3446', suburb: 'MALMSBURY', state: 'VIC' },
  { postCode: '3447', suburb: 'TARADALE', state: 'VIC' },
  { postCode: '3448', suburb: 'ELPHINSTONE', state: 'VIC' },
  { postCode: '3448', suburb: 'METCALFE', state: 'VIC' },
  { postCode: '3448', suburb: 'SUTTON GRANGE', state: 'VIC' },
  { postCode: '3450', suburb: 'CASTLEMAINE', state: 'VIC' },
  { postCode: '3450', suburb: 'MOONLIGHT FLAT', state: 'VIC' },
  { postCode: '3451', suburb: 'BARKERS CREEK', state: 'VIC' },
  { postCode: '3451', suburb: 'CAMPBELLS CREEK', state: 'VIC' },
  { postCode: '3451', suburb: 'CHEWTON', state: 'VIC' },
  { postCode: '3451', suburb: 'CHEWTON BUSHLANDS', state: 'VIC' },
  { postCode: '3451', suburb: 'FARADAY', state: 'VIC' },
  { postCode: '3451', suburb: 'FRYERSTOWN', state: 'VIC' },
  { postCode: '3451', suburb: 'GLENLUCE', state: 'VIC' },
  { postCode: '3451', suburb: 'GOLDEN POINT', state: 'VIC' },
  { postCode: '3451', suburb: 'GUILDFORD', state: 'VIC' },
  { postCode: '3451', suburb: 'IRISHTOWN', state: 'VIC' },
  { postCode: '3451', suburb: 'MCKENZIE HILL', state: 'VIC' },
  { postCode: '3451', suburb: 'MUCKLEFORD', state: 'VIC' },
  { postCode: '3451', suburb: 'TARILTA', state: 'VIC' },
  { postCode: '3451', suburb: 'VAUGHAN', state: 'VIC' },
  { postCode: '3451', suburb: 'YAPEEN', state: 'VIC' },
  { postCode: '3453', suburb: 'HARCOURT', state: 'VIC' },
  { postCode: '3453', suburb: 'HARCOURT NORTH', state: 'VIC' },
  { postCode: '3453', suburb: 'RAVENSWOOD', state: 'VIC' },
  { postCode: '3453', suburb: 'RAVENSWOOD SOUTH', state: 'VIC' },
  { postCode: '3458', suburb: 'BARRYS REEF', state: 'VIC' },
  { postCode: '3458', suburb: 'BLACKWOOD', state: 'VIC' },
  { postCode: '3458', suburb: 'FERN HILL', state: 'VIC' },
  { postCode: '3458', suburb: 'LERDERDERG', state: 'VIC' },
  { postCode: '3458', suburb: 'LITTLE HAMPTON', state: 'VIC' },
  { postCode: '3458', suburb: 'NEWBURY', state: 'VIC' },
  { postCode: '3458', suburb: 'NORTH BLACKWOOD', state: 'VIC' },
  { postCode: '3458', suburb: 'TRENTHAM', state: 'VIC' },
  { postCode: '3458', suburb: 'TRENTHAM EAST', state: 'VIC' },
  { postCode: '3460', suburb: 'BASALT', state: 'VIC' },
  { postCode: '3460', suburb: 'DAYLESFORD', state: 'VIC' },
  { postCode: '3461', suburb: 'BULLARTO', state: 'VIC' },
  { postCode: '3461', suburb: 'BULLARTO SOUTH', state: 'VIC' },
  { postCode: '3461', suburb: 'CLYDESDALE', state: 'VIC' },
  { postCode: '3461', suburb: 'COOMOORA', state: 'VIC' },
  { postCode: '3461', suburb: 'DENVER', state: 'VIC' },
  { postCode: '3461', suburb: 'DRUMMOND', state: 'VIC' },
  { postCode: '3461', suburb: 'DRY DIGGINGS', state: 'VIC' },
  { postCode: '3461', suburb: 'EGANSTOWN', state: 'VIC' },
  { postCode: '3461', suburb: 'ELEVATED PLAINS', state: 'VIC' },
  { postCode: '3461', suburb: 'FRANKLINFORD', state: 'VIC' },
  { postCode: '3461', suburb: 'GLENLYON', state: 'VIC' },
  { postCode: '3461', suburb: 'HEPBURN', state: 'VIC' },
  { postCode: '3461', suburb: 'HEPBURN SPRINGS', state: 'VIC' },
  { postCode: '3461', suburb: 'KORWEINGUBOORA', state: 'VIC' },
  { postCode: '3461', suburb: 'LEONARDS HILL', state: 'VIC' },
  { postCode: '3461', suburb: 'LYONVILLE', state: 'VIC' },
  { postCode: '3461', suburb: 'MOUNT FRANKLIN', state: 'VIC' },
  { postCode: '3461', suburb: 'MUSK', state: 'VIC' },
  { postCode: '3461', suburb: 'MUSK VALE', state: 'VIC' },
  { postCode: '3461', suburb: 'PORCUPINE RIDGE', state: 'VIC' },
  { postCode: '3461', suburb: 'SAILORS FALLS', state: 'VIC' },
  { postCode: '3461', suburb: 'SAILORS HILL', state: 'VIC' },
  { postCode: '3461', suburb: 'SHEPHERDS FLAT', state: 'VIC' },
  { postCode: '3461', suburb: 'SPARGO CREEK', state: 'VIC' },
  { postCode: '3461', suburb: 'STRANGWAYS', state: 'VIC' },
  { postCode: '3461', suburb: 'WHEATSHEAF', state: 'VIC' },
  { postCode: '3461', suburb: 'YANDOIT', state: 'VIC' },
  { postCode: '3461', suburb: 'YANDOIT HILLS', state: 'VIC' },
  { postCode: '3462', suburb: 'GREEN GULLY', state: 'VIC' },
  { postCode: '3462', suburb: 'MUCKLEFORD SOUTH', state: 'VIC' },
  { postCode: '3462', suburb: 'NEWSTEAD', state: 'VIC' },
  { postCode: '3462', suburb: 'SANDON', state: 'VIC' },
  { postCode: '3462', suburb: 'WELSHMANS REEF', state: 'VIC' },
  { postCode: '3463', suburb: 'BARINGHUP', state: 'VIC' },
  { postCode: '3463', suburb: 'BARINGHUP WEST', state: 'VIC' },
  { postCode: '3463', suburb: 'BRADFORD', state: 'VIC' },
  { postCode: '3463', suburb: 'EASTVILLE', state: 'VIC' },
  { postCode: '3463', suburb: 'GOWER', state: 'VIC' },
  { postCode: '3463', suburb: 'LAANECOORIE', state: 'VIC' },
  { postCode: '3463', suburb: 'MALDON', state: 'VIC' },
  { postCode: '3463', suburb: 'NEEREMAN', state: 'VIC' },
  { postCode: '3463', suburb: 'NUGGETTY', state: 'VIC' },
  { postCode: '3463', suburb: 'TARRENGOWER', state: 'VIC' },
  { postCode: '3463', suburb: 'WALMER', state: 'VIC' },
  { postCode: '3463', suburb: 'WOODSTOCK WEST', state: 'VIC' },
  { postCode: '3464', suburb: 'CARISBROOK', state: 'VIC' },
  { postCode: '3465', suburb: 'ADELAIDE LEAD', state: 'VIC' },
  { postCode: '3465', suburb: 'ALMA', state: 'VIC' },
  { postCode: '3465', suburb: 'BOWENVALE', state: 'VIC' },
  { postCode: '3465', suburb: 'BUNG BONG', state: 'VIC' },
  { postCode: '3465', suburb: 'COTSWOLD', state: 'VIC' },
  { postCode: '3465', suburb: 'CRAIGIE', state: 'VIC' },
  { postCode: '3465', suburb: 'DAISY HILL', state: 'VIC' },
  { postCode: '3465', suburb: 'FLAGSTAFF', state: 'VIC' },
  { postCode: '3465', suburb: 'GOLDEN POINT', state: 'VIC' },
  { postCode: '3465', suburb: 'HAVELOCK', state: 'VIC' },
  { postCode: '3465', suburb: 'HOMEBUSH', state: 'VIC' },
  { postCode: '3465', suburb: 'MAJORCA', state: 'VIC' },
  { postCode: '3465', suburb: 'MARYBOROUGH', state: 'VIC' },
  { postCode: '3465', suburb: 'MOOLORT', state: 'VIC' },
  { postCode: '3465', suburb: 'MOONLIGHT FLAT', state: 'VIC' },
  { postCode: '3465', suburb: 'NATTE YALLOCK', state: 'VIC' },
  { postCode: '3465', suburb: 'RATHSCAR', state: 'VIC' },
  { postCode: '3465', suburb: 'RATHSCAR WEST', state: 'VIC' },
  { postCode: '3465', suburb: 'SIMSON', state: 'VIC' },
  { postCode: '3465', suburb: 'TIMOR', state: 'VIC' },
  { postCode: '3465', suburb: 'TIMOR WEST', state: 'VIC' },
  { postCode: '3465', suburb: 'WAREEK', state: 'VIC' },
  { postCode: '3467', suburb: 'AVOCA', state: 'VIC' },
  { postCode: '3468', suburb: 'AMPHITHEATRE', state: 'VIC' },
  { postCode: '3468', suburb: 'MOUNT LONARCH', state: 'VIC' },
  { postCode: '3469', suburb: 'ELMHURST', state: 'VIC' },
  { postCode: '3469', suburb: 'GLENLOFTY', state: 'VIC' },
  { postCode: '3469', suburb: 'GLENLOGIE', state: 'VIC' },
  { postCode: '3469', suburb: 'GLENPATRICK', state: 'VIC' },
  { postCode: '3469', suburb: 'NOWHERE CREEK', state: 'VIC' },
  { postCode: '3472', suburb: 'BET BET', state: 'VIC' },
  { postCode: '3472', suburb: 'BETLEY', state: 'VIC' },
  { postCode: '3472', suburb: 'BROMLEY', state: 'VIC' },
  { postCode: '3472', suburb: 'DUNLUCE', state: 'VIC' },
  { postCode: '3472', suburb: 'DUNOLLY', state: 'VIC' },
  { postCode: '3472', suburb: 'EDDINGTON', state: 'VIC' },
  { postCode: '3472', suburb: 'GOLDSBOROUGH', state: 'VIC' },
  { postCode: '3472', suburb: 'INKERMAN', state: 'VIC' },
  { postCode: '3472', suburb: 'MCINTYRE', state: 'VIC' },
  { postCode: '3472', suburb: 'MOLIAGUL', state: 'VIC' },
  { postCode: '3472', suburb: 'MOUNT HOOGHLY', state: 'VIC' },
  { postCode: '3475', suburb: 'ARCHDALE', state: 'VIC' },
  { postCode: '3475', suburb: 'ARCHDALE JUNCTION', state: 'VIC' },
  { postCode: '3475', suburb: 'BEALIBA', state: 'VIC' },
  { postCode: '3475', suburb: 'BURKES FLAT', state: 'VIC' },
  { postCode: '3475', suburb: 'COCHRANES CREEK', state: 'VIC' },
  { postCode: '3475', suburb: 'EMU', state: 'VIC' },
  { postCode: '3475', suburb: 'LOGAN', state: 'VIC' },
  { postCode: '3477', suburb: 'AVON PLAINS', state: 'VIC' },
  { postCode: '3477', suburb: 'BEAZLEYS BRIDGE', state: 'VIC' },
  { postCode: '3477', suburb: 'CARAPOOEE', state: 'VIC' },
  { postCode: '3477', suburb: 'CARAPOOEE WEST', state: 'VIC' },
  { postCode: '3477', suburb: 'COONOOER BRIDGE', state: 'VIC' },
  { postCode: '3477', suburb: 'COONOOER WEST', state: 'VIC' },
  { postCode: '3477', suburb: 'DALYENONG', state: 'VIC' },
  { postCode: '3477', suburb: 'GOOROC', state: 'VIC' },
  { postCode: '3477', suburb: 'GOWAR EAST', state: 'VIC' },
  { postCode: '3477', suburb: 'GRAYS BRIDGE', state: 'VIC' },
  { postCode: '3477', suburb: 'GRE GRE', state: 'VIC' },
  { postCode: '3477', suburb: 'GRE GRE NORTH', state: 'VIC' },
  { postCode: '3477', suburb: 'GRE GRE SOUTH', state: 'VIC' },
  { postCode: '3477', suburb: 'KOOREH', state: 'VIC' },
  { postCode: '3477', suburb: 'MARNOO EAST', state: 'VIC' },
  { postCode: '3477', suburb: 'MOOLERR', state: 'VIC' },
  { postCode: '3477', suburb: 'MOYREISK', state: 'VIC' },
  { postCode: '3477', suburb: 'PARADISE', state: 'VIC' },
  { postCode: '3477', suburb: 'REDBANK', state: 'VIC' },
  { postCode: '3477', suburb: 'ROSTRON', state: 'VIC' },
  { postCode: '3477', suburb: 'SLATY CREEK', state: 'VIC' },
  { postCode: '3477', suburb: 'ST ARNAUD EAST', state: 'VIC' },
  { postCode: '3477', suburb: 'ST ARNAUD NORTH', state: 'VIC' },
  { postCode: '3477', suburb: 'STUART MILL', state: 'VIC' },
  { postCode: '3477', suburb: 'SUTHERLAND', state: 'VIC' },
  { postCode: '3477', suburb: 'SWANWATER', state: 'VIC' },
  { postCode: '3477', suburb: 'TOTTINGTON', state: 'VIC' },
  { postCode: '3477', suburb: 'TRAYNORS LAGOON', state: 'VIC' },
  { postCode: '3477', suburb: 'WINJALLOK', state: 'VIC' },
  { postCode: '3477', suburb: 'YORK PLAINS', state: 'VIC' },
  { postCode: '3478', suburb: 'DOOBOOBETIC', state: 'VIC' },
  { postCode: '3478', suburb: 'MEDLYN', state: 'VIC' },
  { postCode: '3478', suburb: 'MOONAMBEL', state: 'VIC' },
  { postCode: '3478', suburb: 'PERCYDALE', state: 'VIC' },
  { postCode: '3478', suburb: 'ST ARNAUD', state: 'VIC' },
  { postCode: '3478', suburb: 'TANWOOD', state: 'VIC' },
  { postCode: '3478', suburb: 'WARRENMANG', state: 'VIC' },
  { postCode: '3478', suburb: 'YAWONG HILLS', state: 'VIC' },
  { postCode: '3480', suburb: 'AREEGRA', state: 'VIC' },
  { postCode: '3480', suburb: 'CARRON', state: 'VIC' },
  { postCode: '3480', suburb: 'COPE COPE', state: 'VIC' },
  { postCode: '3480', suburb: 'CORACK', state: 'VIC' },
  { postCode: '3480', suburb: 'CORACK EAST', state: 'VIC' },
  { postCode: '3480', suburb: 'DONALD', state: 'VIC' },
  { postCode: '3480', suburb: 'GIL GIL', state: 'VIC' },
  { postCode: '3480', suburb: 'JEFFCOTT', state: 'VIC' },
  { postCode: '3480', suburb: 'JEFFCOTT NORTH', state: 'VIC' },
  { postCode: '3480', suburb: 'LAEN', state: 'VIC' },
  { postCode: '3480', suburb: 'LAEN EAST', state: 'VIC' },
  { postCode: '3480', suburb: 'LAEN NORTH', state: 'VIC' },
  { postCode: '3480', suburb: 'LAWLER', state: 'VIC' },
  { postCode: '3480', suburb: 'LITCHFIELD', state: 'VIC' },
  { postCode: '3480', suburb: 'RICH AVON', state: 'VIC' },
  { postCode: '3480', suburb: 'RICH AVON EAST', state: 'VIC' },
  { postCode: '3480', suburb: 'RICH AVON WEST', state: 'VIC' },
  { postCode: '3480', suburb: 'SWANWATER WEST', state: 'VIC' },
  { postCode: '3482', suburb: 'MASSEY', state: 'VIC' },
  { postCode: '3482', suburb: 'MORTON PLAINS', state: 'VIC' },
  { postCode: '3482', suburb: 'WARMUR', state: 'VIC' },
  { postCode: '3482', suburb: 'WATCHEM', state: 'VIC' },
  { postCode: '3482', suburb: 'WATCHEM WEST', state: 'VIC' },
  { postCode: '3483', suburb: 'BALLAPUR', state: 'VIC' },
  { postCode: '3483', suburb: 'BIRCHIP', state: 'VIC' },
  { postCode: '3483', suburb: 'BIRCHIP WEST', state: 'VIC' },
  { postCode: '3483', suburb: 'CURYO', state: 'VIC' },
  { postCode: '3483', suburb: 'JIL JIL', state: 'VIC' },
  { postCode: '3483', suburb: 'KARYRIE', state: 'VIC' },
  { postCode: '3483', suburb: 'KINNABULLA', state: 'VIC' },
  { postCode: '3483', suburb: 'MARLBED', state: 'VIC' },
  { postCode: '3483', suburb: 'NARRAPORT', state: 'VIC' },
  { postCode: '3483', suburb: 'WHIRILY', state: 'VIC' },
  { postCode: '3485', suburb: 'BANYAN', state: 'VIC' },
  { postCode: '3485', suburb: 'WATCHUPGA', state: 'VIC' },
  { postCode: '3485', suburb: 'WILLANGIE', state: 'VIC' },
  { postCode: '3485', suburb: 'WOOMELANG', state: 'VIC' },
  { postCode: '3487', suburb: 'LASCELLES', state: 'VIC' },
  { postCode: '3488', suburb: 'SPEED', state: 'VIC' },
  { postCode: '3488', suburb: 'TURRIFF', state: 'VIC' },
  { postCode: '3488', suburb: 'TURRIFF EAST', state: 'VIC' },
  { postCode: '3489', suburb: 'TEMPY', state: 'VIC' },
  { postCode: '3490', suburb: 'BIG DESERT', state: 'VIC' },
  { postCode: '3490', suburb: 'BOINKA', state: 'VIC' },
  { postCode: '3490', suburb: 'KULWIN', state: 'VIC' },
  { postCode: '3490', suburb: 'MITTYACK', state: 'VIC' },
  { postCode: '3490', suburb: 'MURRAY-SUNSET', state: 'VIC' },
  { postCode: '3490', suburb: 'OUYEN', state: 'VIC' },
  { postCode: '3490', suburb: 'TORRITA', state: 'VIC' },
  { postCode: '3490', suburb: 'TUTYE', state: 'VIC' },
  { postCode: '3491', suburb: 'PATCHEWOLLOCK', state: 'VIC' },
  { postCode: '3494', suburb: 'CARWARP', state: 'VIC' },
  { postCode: '3494', suburb: 'COLIGNAN', state: 'VIC' },
  { postCode: '3494', suburb: 'IRAAK', state: 'VIC' },
  { postCode: '3494', suburb: 'NANGILOC', state: 'VIC' },
  { postCode: '3496', suburb: 'CARDROSS', state: 'VIC' },
  { postCode: '3496', suburb: 'CULLULLERAINE', state: 'VIC' },
  { postCode: '3496', suburb: 'LINDSAY POINT', state: 'VIC' },
  { postCode: '3496', suburb: 'MERINGUR', state: 'VIC' },
  { postCode: '3496', suburb: 'MERRINEE', state: 'VIC' },
  { postCode: '3496', suburb: 'NEDS CORNER', state: 'VIC' },
  { postCode: '3496', suburb: 'RED CLIFFS', state: 'VIC' },
  { postCode: '3496', suburb: 'SUNNYCLIFFS', state: 'VIC' },
  { postCode: '3496', suburb: 'WERRIMULL', state: 'VIC' },
  { postCode: '3498', suburb: 'IRYMPLE', state: 'VIC' },
  { postCode: '3500', suburb: 'MILDURA', state: 'VIC' },
  { postCode: '3500', suburb: 'MILDURA WEST', state: 'VIC' },
  { postCode: '3501', suburb: 'HATTAH', state: 'VIC' },
  { postCode: '3501', suburb: 'KOORLONG', state: 'VIC' },
  { postCode: '3501', suburb: 'MILDURA CENTRE PLAZA', state: 'VIC' },
  { postCode: '3501', suburb: 'MILDURA SOUTH', state: 'VIC' },
  { postCode: '3501', suburb: 'NICHOLS POINT', state: 'VIC' },
  { postCode: '3502', suburb: 'MILDURA', state: 'VIC' },
  { postCode: '3505', suburb: 'BIRDWOODTON', state: 'VIC' },
  { postCode: '3505', suburb: 'CABARITA', state: 'VIC' },
  { postCode: '3505', suburb: 'MERBEIN', state: 'VIC' },
  { postCode: '3505', suburb: 'MERBEIN SOUTH', state: 'VIC' },
  { postCode: '3505', suburb: 'MERBEIN WEST', state: 'VIC' },
  { postCode: '3505', suburb: 'WARGAN', state: 'VIC' },
  { postCode: '3505', suburb: 'YELTA', state: 'VIC' },
  { postCode: '3506', suburb: 'COWANGIE', state: 'VIC' },
  { postCode: '3507', suburb: 'WALPEUP', state: 'VIC' },
  { postCode: '3509', suburb: 'LINGA', state: 'VIC' },
  { postCode: '3509', suburb: 'UNDERBOOL', state: 'VIC' },
  { postCode: '3512', suburb: 'CARINA', state: 'VIC' },
  { postCode: '3512', suburb: 'MURRAYVILLE', state: 'VIC' },
  { postCode: '3512', suburb: 'PANITYA', state: 'VIC' },
  { postCode: '3515', suburb: 'MARONG', state: 'VIC' },
  { postCode: '3515', suburb: 'SHELBOURNE', state: 'VIC' },
  { postCode: '3515', suburb: 'WILSONS HILL', state: 'VIC' },
  { postCode: '3516', suburb: 'BRIDGEWATER', state: 'VIC' },
  { postCode: '3516', suburb: 'BRIDGEWATER NORTH', state: 'VIC' },
  { postCode: '3516', suburb: 'BRIDGEWATER ON LODDON', state: 'VIC' },
  { postCode: '3516', suburb: 'DERBY', state: 'VIC' },
  { postCode: '3516', suburb: 'LEICHARDT', state: 'VIC' },
  { postCode: '3516', suburb: 'YARRABERB', state: 'VIC' },
  { postCode: '3517', suburb: 'BEARS LAGOON', state: 'VIC' },
  { postCode: '3517', suburb: 'BRENANAH', state: 'VIC' },
  { postCode: '3517', suburb: 'GLENALBYN', state: 'VIC' },
  { postCode: '3517', suburb: 'INGLEWOOD', state: 'VIC' },
  { postCode: '3517', suburb: 'JARKLIN', state: 'VIC' },
  { postCode: '3517', suburb: 'KINGOWER', state: 'VIC' },
  { postCode: '3517', suburb: 'KURTING', state: 'VIC' },
  { postCode: '3517', suburb: 'POWLETT PLAINS', state: 'VIC' },
  { postCode: '3517', suburb: 'RHEOLA', state: 'VIC' },
  { postCode: '3517', suburb: 'SALISBURY WEST', state: 'VIC' },
  { postCode: '3517', suburb: 'SERPENTINE', state: 'VIC' },
  { postCode: '3518', suburb: 'BERRIMAL', state: 'VIC' },
  { postCode: '3518', suburb: 'BORUNG', state: 'VIC' },
  { postCode: '3518', suburb: 'FENTONS CREEK', state: 'VIC' },
  { postCode: '3518', suburb: 'FERNIHURST', state: 'VIC' },
  { postCode: '3518', suburb: 'FIERY FLAT', state: 'VIC' },
  { postCode: '3518', suburb: 'KURRACA', state: 'VIC' },
  { postCode: '3518', suburb: 'KURRACA WEST', state: 'VIC' },
  { postCode: '3518', suburb: 'MYSIA', state: 'VIC' },
  { postCode: '3518', suburb: 'NINE MILE', state: 'VIC' },
  { postCode: '3518', suburb: 'RICHMOND PLAINS', state: 'VIC' },
  { postCode: '3518', suburb: 'SKINNERS FLAT', state: 'VIC' },
  { postCode: '3518', suburb: 'WEDDERBURN', state: 'VIC' },
  { postCode: '3518', suburb: 'WEDDERBURN JUNCTION', state: 'VIC' },
  { postCode: '3518', suburb: 'WEHLA', state: 'VIC' },
  { postCode: '3518', suburb: 'WOOLSHED FLAT', state: 'VIC' },
  { postCode: '3518', suburb: 'WOOSANG', state: 'VIC' },
  { postCode: '3520', suburb: 'KINYPANIAL', state: 'VIC' },
  { postCode: '3520', suburb: 'KORONG VALE', state: 'VIC' },
  { postCode: '3521', suburb: 'PYALONG', state: 'VIC' },
  { postCode: '3522', suburb: 'GLENHOPE EAST', state: 'VIC' },
  { postCode: '3522', suburb: 'TOOBORAC', state: 'VIC' },
  { postCode: '3523', suburb: 'ARGYLE', state: 'VIC' },
  { postCode: '3523', suburb: 'COSTERFIELD', state: 'VIC' },
  { postCode: '3523', suburb: 'DERRINAL', state: 'VIC' },
  { postCode: '3523', suburb: 'HEATHCOTE', state: 'VIC' },
  { postCode: '3523', suburb: 'HEATHCOTE SOUTH', state: 'VIC' },
  { postCode: '3523', suburb: 'KNOWSLEY', state: 'VIC' },
  { postCode: '3523', suburb: 'LADYS PASS', state: 'VIC' },
  { postCode: '3523', suburb: 'MOORMBOOL WEST', state: 'VIC' },
  { postCode: '3523', suburb: 'MOUNT CAMEL', state: 'VIC' },
  { postCode: '3523', suburb: 'REDCASTLE', state: 'VIC' },
  { postCode: '3525', suburb: 'BARRAKEE', state: 'VIC' },
  { postCode: '3525', suburb: 'BUCKRABANYULE', state: 'VIC' },
  { postCode: '3525', suburb: 'CHARLTON', state: 'VIC' },
  { postCode: '3525', suburb: 'CHIRRIP', state: 'VIC' },
  { postCode: '3525', suburb: 'GRANITE FLAT', state: 'VIC' },
  { postCode: '3525', suburb: 'LAKE MARMAL', state: 'VIC' },
  { postCode: '3525', suburb: 'NAREEWILLOCK', state: 'VIC' },
  { postCode: '3525', suburb: 'TERRAPPEE', state: 'VIC' },
  { postCode: '3525', suburb: 'WOOROONOOK', state: 'VIC' },
  { postCode: '3525', suburb: 'WYCHITELLA', state: 'VIC' },
  { postCode: '3525', suburb: 'WYCHITELLA NORTH', state: 'VIC' },
  { postCode: '3525', suburb: 'YEUNGROON', state: 'VIC' },
  { postCode: '3525', suburb: 'YEUNGROON EAST', state: 'VIC' },
  { postCode: '3527', suburb: 'BUNGULUKE', state: 'VIC' },
  { postCode: '3527', suburb: 'DUMOSA', state: 'VIC' },
  { postCode: '3527', suburb: 'GLENLOTH', state: 'VIC' },
  { postCode: '3527', suburb: 'GLENLOTH EAST', state: 'VIC' },
  { postCode: '3527', suburb: 'JERUK', state: 'VIC' },
  { postCode: '3527', suburb: 'NINYEUNOOK', state: 'VIC' },
  { postCode: '3527', suburb: 'TEDDYWADDY', state: 'VIC' },
  { postCode: '3527', suburb: 'TEDDYWADDY WEST', state: 'VIC' },
  { postCode: '3527', suburb: 'THALIA', state: 'VIC' },
  { postCode: '3527', suburb: 'TOWANINNY', state: 'VIC' },
  { postCode: '3527', suburb: 'TOWANINNY SOUTH', state: 'VIC' },
  { postCode: '3527', suburb: 'WYCHEPROOF', state: 'VIC' },
  { postCode: '3527', suburb: 'WYCHEPROOF SOUTH', state: 'VIC' },
  { postCode: '3529', suburb: 'KALPIENUNG', state: 'VIC' },
  { postCode: '3529', suburb: 'NULLAWIL', state: 'VIC' },
  { postCode: '3530', suburb: 'CULGOA', state: 'VIC' },
  { postCode: '3530', suburb: 'SUTTON', state: 'VIC' },
  { postCode: '3530', suburb: 'WANGIE', state: 'VIC' },
  { postCode: '3530', suburb: 'WARNE', state: 'VIC' },
  { postCode: '3531', suburb: 'BERRIWILLOCK', state: 'VIC' },
  { postCode: '3531', suburb: 'BOIGBEAT', state: 'VIC' },
  { postCode: '3533', suburb: 'BIMBOURIE', state: 'VIC' },
  { postCode: '3533', suburb: 'LAKE TYRRELL', state: 'VIC' },
  { postCode: '3533', suburb: 'MYALL', state: 'VIC' },
  { postCode: '3533', suburb: 'NANDALY', state: 'VIC' },
  { postCode: '3533', suburb: 'NINDA', state: 'VIC' },
  { postCode: '3533', suburb: 'NYARRIN', state: 'VIC' },
  { postCode: '3533', suburb: 'PIER MILAN', state: 'VIC' },
  { postCode: '3533', suburb: 'SEA LAKE', state: 'VIC' },
  { postCode: '3533', suburb: 'STRATEN', state: 'VIC' },
  { postCode: '3533', suburb: 'TYENNA', state: 'VIC' },
  { postCode: '3533', suburb: 'TYRRELL', state: 'VIC' },
  { postCode: '3533', suburb: 'TYRRELL DOWNS', state: 'VIC' },
  { postCode: '3537', suburb: 'BARRAPORT', state: 'VIC' },
  { postCode: '3537', suburb: 'BARRAPORT WEST', state: 'VIC' },
  { postCode: '3537', suburb: 'BOORT', state: 'VIC' },
  { postCode: '3537', suburb: 'CANARY ISLAND', state: 'VIC' },
  { postCode: '3537', suburb: 'CATUMNAL', state: 'VIC' },
  { postCode: '3537', suburb: 'GREDGWIN', state: 'VIC' },
  { postCode: '3537', suburb: 'LEAGHUR', state: 'VIC' },
  { postCode: '3537', suburb: 'MINMINDIE', state: 'VIC' },
  { postCode: '3537', suburb: 'YANDO', state: 'VIC' },
  { postCode: '3540', suburb: 'CANNIE', state: 'VIC' },
  { postCode: '3540', suburb: 'OAKVALE', state: 'VIC' },
  { postCode: '3540', suburb: 'QUAMBATOOK', state: 'VIC' },
  { postCode: '3542', suburb: 'COKUM', state: 'VIC' },
  { postCode: '3542', suburb: 'LALBERT', state: 'VIC' },
  { postCode: '3542', suburb: 'TITTYBONG', state: 'VIC' },
  { postCode: '3544', suburb: 'CHINANGIN', state: 'VIC' },
  { postCode: '3544', suburb: 'GOWANFORD', state: 'VIC' },
  { postCode: '3544', suburb: 'MURNUNGIN', state: 'VIC' },
  { postCode: '3544', suburb: 'SPRINGFIELD', state: 'VIC' },
  { postCode: '3544', suburb: 'ULTIMA', state: 'VIC' },
  { postCode: '3544', suburb: 'ULTIMA EAST', state: 'VIC' },
  { postCode: '3544', suburb: 'WAITCHIE', state: 'VIC' },
  { postCode: '3546', suburb: 'BOLTON', state: 'VIC' },
  { postCode: '3546', suburb: 'CHINKAPOOK', state: 'VIC' },
  { postCode: '3546', suburb: 'COCAMBA', state: 'VIC' },
  { postCode: '3546', suburb: 'GERAHMIN', state: 'VIC' },
  { postCode: '3546', suburb: 'MANANGATANG', state: 'VIC' },
  { postCode: '3546', suburb: 'TUROAR', state: 'VIC' },
  { postCode: '3546', suburb: 'WINNAMBOOL', state: 'VIC' },
  { postCode: '3549', suburb: 'ANNUELLO', state: 'VIC' },
  { postCode: '3549', suburb: 'BANNERTON', state: 'VIC' },
  { postCode: '3549', suburb: 'HAPPY VALLEY', state: 'VIC' },
  { postCode: '3549', suburb: 'LIPAROO', state: 'VIC' },
  { postCode: '3549', suburb: 'ROBINVALE', state: 'VIC' },
  {
    postCode: '3549',
    suburb: 'ROBINVALE IRRIGATION DISTRICT SECTION B',
    state: 'VIC',
  },
  {
    postCode: '3549',
    suburb: 'ROBINVALE IRRIGATION DISTRICT SECTION C',
    state: 'VIC',
  },
  {
    postCode: '3549',
    suburb: 'ROBINVALE IRRIGATION DISTRICT SECTION D',
    state: 'VIC',
  },
  {
    postCode: '3549',
    suburb: 'ROBINVALE IRRIGATION DISTRICT SECTION E',
    state: 'VIC',
  },
  { postCode: '3549', suburb: 'TOL TOL', state: 'VIC' },
  { postCode: '3549', suburb: 'WANDOWN', state: 'VIC' },
  { postCode: '3549', suburb: 'WEMEN', state: 'VIC' },
  { postCode: '3550', suburb: 'BENDIGO', state: 'VIC' },
  { postCode: '3550', suburb: 'BENDIGO SOUTH', state: 'VIC' },
  { postCode: '3550', suburb: 'EAST BENDIGO', state: 'VIC' },
  { postCode: '3550', suburb: 'FLORA HILL', state: 'VIC' },
  { postCode: '3550', suburb: 'IRONBARK', state: 'VIC' },
  { postCode: '3550', suburb: 'KENNINGTON', state: 'VIC' },
  { postCode: '3550', suburb: 'LONG GULLY', state: 'VIC' },
  { postCode: '3550', suburb: 'NORTH BENDIGO', state: 'VIC' },
  { postCode: '3550', suburb: 'QUARRY HILL', state: 'VIC' },
  { postCode: '3550', suburb: 'SANDHURST EAST', state: 'VIC' },
  { postCode: '3550', suburb: 'SPRING GULLY', state: 'VIC' },
  { postCode: '3550', suburb: 'STRATHDALE', state: 'VIC' },
  { postCode: '3550', suburb: 'WEST BENDIGO', state: 'VIC' },
  { postCode: '3550', suburb: 'WHITE HILLS', state: 'VIC' },
  { postCode: '3551', suburb: 'ARNOLD', state: 'VIC' },
  { postCode: '3551', suburb: 'ARNOLD WEST', state: 'VIC' },
  { postCode: '3551', suburb: 'ASCOT', state: 'VIC' },
  { postCode: '3551', suburb: 'AXE CREEK', state: 'VIC' },
  { postCode: '3551', suburb: 'AXEDALE', state: 'VIC' },
  { postCode: '3551', suburb: 'BAGSHOT', state: 'VIC' },
  { postCode: '3551', suburb: 'BAGSHOT NORTH', state: 'VIC' },
  { postCode: '3551', suburb: 'BENDIGO FORWARD', state: 'VIC' },
  { postCode: '3551', suburb: 'CORNELLA', state: 'VIC' },
  { postCode: '3551', suburb: 'CREEK VIEW', state: 'VIC' },
  { postCode: '3551', suburb: 'EMU CREEK', state: 'VIC' },
  { postCode: '3551', suburb: 'EPPALOCK', state: 'VIC' },
  { postCode: '3551', suburb: 'EPSOM', state: 'VIC' },
  { postCode: '3551', suburb: 'HUNTLY', state: 'VIC' },
  { postCode: '3551', suburb: 'HUNTLY NORTH', state: 'VIC' },
  { postCode: '3551', suburb: 'JUNORTOUN', state: 'VIC' },
  { postCode: '3551', suburb: 'KIMBOLTON', state: 'VIC' },
  { postCode: '3551', suburb: 'LAKE EPPALOCK', state: 'VIC' },
  { postCode: '3551', suburb: 'LLANELLY', state: 'VIC' },
  { postCode: '3551', suburb: 'LOCKWOOD', state: 'VIC' },
  { postCode: '3551', suburb: 'LOCKWOOD SOUTH', state: 'VIC' },
  { postCode: '3551', suburb: 'LONGLEA', state: 'VIC' },
  { postCode: '3551', suburb: 'MAIDEN GULLY', state: 'VIC' },
  { postCode: '3551', suburb: 'MANDURANG', state: 'VIC' },
  { postCode: '3551', suburb: 'MANDURANG SOUTH', state: 'VIC' },
  { postCode: '3551', suburb: 'MURPHYS CREEK', state: 'VIC' },
  { postCode: '3551', suburb: 'MYOLA', state: 'VIC' },
  { postCode: '3551', suburb: 'MYRTLE CREEK', state: 'VIC' },
  { postCode: '3551', suburb: 'NEWBRIDGE', state: 'VIC' },
  { postCode: '3551', suburb: 'PAINSWICK', state: 'VIC' },
  { postCode: '3551', suburb: 'SEDGWICK', state: 'VIC' },
  { postCode: '3551', suburb: 'STRATHFIELDSAYE', state: 'VIC' },
  { postCode: '3551', suburb: 'TARNAGULLA', state: 'VIC' },
  { postCode: '3551', suburb: 'TOOLLEEN', state: 'VIC' },
  { postCode: '3551', suburb: 'WAANYARRA', state: 'VIC' },
  { postCode: '3551', suburb: 'WELLSFORD', state: 'VIC' },
  { postCode: '3551', suburb: 'WOODSTOCK ON LODDON', state: 'VIC' },
  { postCode: '3552', suburb: 'BENDIGO', state: 'VIC' },
  { postCode: '3554', suburb: 'BENDIGO DC', state: 'VIC' },
  { postCode: '3555', suburb: 'BIG HILL', state: 'VIC' },
  { postCode: '3555', suburb: 'GOLDEN GULLY', state: 'VIC' },
  { postCode: '3555', suburb: 'GOLDEN SQUARE', state: 'VIC' },
  { postCode: '3555', suburb: 'KANGAROO FLAT', state: 'VIC' },
  { postCode: '3555', suburb: 'LANSELL PLAZA', state: 'VIC' },
  { postCode: '3556', suburb: 'CALIFORNIA GULLY', state: 'VIC' },
  { postCode: '3556', suburb: 'CAMPBELLS FOREST', state: 'VIC' },
  { postCode: '3556', suburb: 'EAGLEHAWK', state: 'VIC' },
  { postCode: '3556', suburb: 'EAGLEHAWK NORTH', state: 'VIC' },
  { postCode: '3556', suburb: 'JACKASS FLAT', state: 'VIC' },
  { postCode: '3556', suburb: 'MYERS FLAT', state: 'VIC' },
  { postCode: '3556', suburb: 'SAILORS GULLY', state: 'VIC' },
  { postCode: '3556', suburb: 'SEBASTIAN', state: 'VIC' },
  { postCode: '3556', suburb: 'WHIPSTICK', state: 'VIC' },
  { postCode: '3556', suburb: 'WOODVALE', state: 'VIC' },
  { postCode: '3557', suburb: 'BARNADOWN', state: 'VIC' },
  { postCode: '3557', suburb: 'FOSTERVILLE', state: 'VIC' },
  { postCode: '3557', suburb: 'GOORNONG', state: 'VIC' },
  { postCode: '3557', suburb: 'MUSKERRY', state: 'VIC' },
  { postCode: '3558', suburb: 'BURNEWANG', state: 'VIC' },
  { postCode: '3558', suburb: 'COROP WEST', state: 'VIC' },
  { postCode: '3558', suburb: 'ELMORE', state: 'VIC' },
  { postCode: '3558', suburb: 'HUNTER', state: 'VIC' },
  { postCode: '3558', suburb: 'RUNNYMEDE', state: 'VIC' },
  { postCode: '3559', suburb: 'AVONMORE', state: 'VIC' },
  { postCode: '3559', suburb: 'BURRAMBOOT', state: 'VIC' },
  { postCode: '3559', suburb: 'COLBINABBIN', state: 'VIC' },
  { postCode: '3559', suburb: 'COROP', state: 'VIC' },
  { postCode: '3559', suburb: 'GOBARUP', state: 'VIC' },
  { postCode: '3561', suburb: 'BALLENDELLA', state: 'VIC' },
  { postCode: '3561', suburb: 'BAMAWM', state: 'VIC' },
  { postCode: '3561', suburb: 'BONN', state: 'VIC' },
  { postCode: '3561', suburb: 'DIGGORA', state: 'VIC' },
  { postCode: '3561', suburb: 'FAIRY DELL', state: 'VIC' },
  { postCode: '3561', suburb: 'NANNEELLA', state: 'VIC' },
  { postCode: '3561', suburb: 'ROCHESTER', state: 'VIC' },
  { postCode: '3561', suburb: 'TIMMERING', state: 'VIC' },
  { postCode: '3562', suburb: 'TORRUMBARRY', state: 'VIC' },
  { postCode: '3563', suburb: 'LOCKINGTON', state: 'VIC' },
  { postCode: '3564', suburb: 'BAMAWM EXTENSION', state: 'VIC' },
  { postCode: '3564', suburb: 'ECHUCA', state: 'VIC' },
  { postCode: '3564', suburb: 'ECHUCA SOUTH', state: 'VIC' },
  { postCode: '3564', suburb: 'ECHUCA VILLAGE', state: 'VIC' },
  { postCode: '3564', suburb: 'ECHUCA WEST', state: 'VIC' },
  { postCode: '3564', suburb: 'KANYAPELLA', state: 'VIC' },
  { postCode: '3564', suburb: 'PATHO', state: 'VIC' },
  { postCode: '3564', suburb: 'ROSLYNMEAD', state: 'VIC' },
  { postCode: '3564', suburb: 'WHARPARILLA', state: 'VIC' },
  { postCode: '3565', suburb: 'KOTTA', state: 'VIC' },
  { postCode: '3566', suburb: 'GUNBOWER', state: 'VIC' },
  { postCode: '3567', suburb: 'HORFIELD', state: 'VIC' },
  { postCode: '3567', suburb: 'LEITCHVILLE', state: 'VIC' },
  { postCode: '3568', suburb: 'BURKES BRIDGE', state: 'VIC' },
  { postCode: '3568', suburb: 'COHUNA', state: 'VIC' },
  { postCode: '3568', suburb: 'CULLEN', state: 'VIC' },
  { postCode: '3568', suburb: 'DALTONS BRIDGE', state: 'VIC' },
  { postCode: '3568', suburb: 'GANNAWARRA', state: 'VIC' },
  { postCode: '3568', suburb: 'KEELY', state: 'VIC' },
  { postCode: '3568', suburb: 'MACORNA NORTH', state: 'VIC' },
  { postCode: '3568', suburb: 'MCMILLANS', state: 'VIC' },
  { postCode: '3568', suburb: 'MEAD', state: 'VIC' },
  { postCode: '3568', suburb: 'MINCHA WEST', state: 'VIC' },
  { postCode: '3568', suburb: 'WEE WEE RUP', state: 'VIC' },
  { postCode: '3570', suburb: 'AUCHMORE', state: 'VIC' },
  { postCode: '3570', suburb: 'DRUMMARTIN', state: 'VIC' },
  { postCode: '3570', suburb: 'KAMAROOKA', state: 'VIC' },
  { postCode: '3570', suburb: 'NEILBOROUGH', state: 'VIC' },
  { postCode: '3570', suburb: 'RAYWOOD', state: 'VIC' },
  { postCode: '3571', suburb: 'DINGEE', state: 'VIC' },
  { postCode: '3571', suburb: 'KAMAROOKA NORTH', state: 'VIC' },
  { postCode: '3571', suburb: 'POMPAPIEL', state: 'VIC' },
  { postCode: '3571', suburb: 'TANDARRA', state: 'VIC' },
  { postCode: '3572', suburb: 'MILLOO', state: 'VIC' },
  { postCode: '3572', suburb: 'PIAVELLA', state: 'VIC' },
  { postCode: '3572', suburb: 'PRAIRIE', state: 'VIC' },
  { postCode: '3572', suburb: 'TENNYSON', state: 'VIC' },
  { postCode: '3573', suburb: 'CALIVIL', state: 'VIC' },
  { postCode: '3573', suburb: 'MITIAMO', state: 'VIC' },
  { postCode: '3573', suburb: 'PINE GROVE', state: 'VIC' },
  { postCode: '3573', suburb: 'TERRICK TERRICK EAST', state: 'VIC' },
  { postCode: '3575', suburb: 'GLADFIELD', state: 'VIC' },
  { postCode: '3575', suburb: 'JUNGABURRA', state: 'VIC' },
  { postCode: '3575', suburb: 'LODDON VALE', state: 'VIC' },
  { postCode: '3575', suburb: 'MINCHA', state: 'VIC' },
  { postCode: '3575', suburb: 'MOLOGA', state: 'VIC' },
  { postCode: '3575', suburb: 'PYRAMID HILL', state: 'VIC' },
  { postCode: '3575', suburb: 'SYLVATERRE', state: 'VIC' },
  { postCode: '3575', suburb: 'TERRICK TERRICK', state: 'VIC' },
  { postCode: '3575', suburb: 'YARRAWALLA', state: 'VIC' },
  { postCode: '3576', suburb: 'DURHAM OX', state: 'VIC' },
  { postCode: '3579', suburb: 'APPIN', state: 'VIC' },
  { postCode: '3579', suburb: 'APPIN SOUTH', state: 'VIC' },
  { postCode: '3579', suburb: 'BAEL BAEL', state: 'VIC' },
  { postCode: '3579', suburb: 'BEAUCHAMP', state: 'VIC' },
  { postCode: '3579', suburb: 'BENJEROOP', state: 'VIC' },
  { postCode: '3579', suburb: 'BUDGERUM EAST', state: 'VIC' },
  { postCode: '3579', suburb: 'CAPELS CROSSING', state: 'VIC' },
  { postCode: '3579', suburb: 'DINGWALL', state: 'VIC' },
  { postCode: '3579', suburb: 'FAIRLEY', state: 'VIC' },
  { postCode: '3579', suburb: 'GONN CROSSING', state: 'VIC' },
  { postCode: '3579', suburb: 'KERANG', state: 'VIC' },
  { postCode: '3579', suburb: 'KERANG EAST', state: 'VIC' },
  { postCode: '3579', suburb: 'KOROOP', state: 'VIC' },
  { postCode: '3579', suburb: 'LAKE MERAN', state: 'VIC' },
  { postCode: '3579', suburb: 'MACORNA', state: 'VIC' },
  { postCode: '3579', suburb: 'MEERING WEST', state: 'VIC' },
  { postCode: '3579', suburb: 'MILNES BRIDGE', state: 'VIC' },
  { postCode: '3579', suburb: 'MURRABIT', state: 'VIC' },
  { postCode: '3579', suburb: 'MURRABIT WEST', state: 'VIC' },
  { postCode: '3579', suburb: 'MYALL', state: 'VIC' },
  { postCode: '3579', suburb: 'MYSTIC PARK', state: 'VIC' },
  { postCode: '3579', suburb: 'NORMANVILLE', state: 'VIC' },
  { postCode: '3579', suburb: 'PINE VIEW', state: 'VIC' },
  { postCode: '3579', suburb: 'REEDY LAKE', state: 'VIC' },
  { postCode: '3579', suburb: 'SANDHILL LAKE', state: 'VIC' },
  { postCode: '3579', suburb: 'TEAL POINT', state: 'VIC' },
  { postCode: '3579', suburb: 'TRAGOWEL', state: 'VIC' },
  { postCode: '3579', suburb: 'WANDELLA', state: 'VIC' },
  { postCode: '3579', suburb: 'WESTBY', state: 'VIC' },
  { postCode: '3580', suburb: 'KOONDROOK', state: 'VIC' },
  { postCode: '3581', suburb: 'LAKE CHARM', state: 'VIC' },
  { postCode: '3583', suburb: 'TRESCO', state: 'VIC' },
  { postCode: '3584', suburb: 'LAKE BOGA', state: 'VIC' },
  { postCode: '3584', suburb: 'TRESCO WEST', state: 'VIC' },
  { postCode: '3585', suburb: 'CASTLE DONNINGTON', state: 'VIC' },
  { postCode: '3585', suburb: 'CHILLINGOLLAH', state: 'VIC' },
  { postCode: '3585', suburb: 'FISH POINT', state: 'VIC' },
  { postCode: '3585', suburb: 'GOSCHEN', state: 'VIC' },
  { postCode: '3585', suburb: 'KUNAT', state: 'VIC' },
  { postCode: '3585', suburb: 'MEATIAN', state: 'VIC' },
  { postCode: '3585', suburb: 'NOWIE', state: 'VIC' },
  { postCode: '3585', suburb: 'NYRRABY', state: 'VIC' },
  { postCode: '3585', suburb: 'PIRA', state: 'VIC' },
  { postCode: '3585', suburb: 'POLISBET', state: 'VIC' },
  { postCode: '3585', suburb: 'SPEEWA', state: 'VIC' },
  { postCode: '3585', suburb: 'SWAN HILL', state: 'VIC' },
  { postCode: '3585', suburb: 'SWAN HILL WEST', state: 'VIC' },
  { postCode: '3585', suburb: 'WINLATON', state: 'VIC' },
  { postCode: '3586', suburb: 'BULGA', state: 'VIC' },
  { postCode: '3586', suburb: 'MURRAWEE', state: 'VIC' },
  { postCode: '3586', suburb: 'MURRAYDALE', state: 'VIC' },
  { postCode: '3586', suburb: 'PENTAL ISLAND', state: 'VIC' },
  { postCode: '3586', suburb: 'TYNTYNDER', state: 'VIC' },
  { postCode: '3586', suburb: 'TYNTYNDER SOUTH', state: 'VIC' },
  { postCode: '3588', suburb: 'WOORINEN SOUTH', state: 'VIC' },
  { postCode: '3589', suburb: 'WOORINEN', state: 'VIC' },
  { postCode: '3589', suburb: 'WOORINEN NORTH', state: 'VIC' },
  { postCode: '3590', suburb: 'BEVERFORD', state: 'VIC' },
  { postCode: '3591', suburb: 'VINIFERA', state: 'VIC' },
  { postCode: '3594', suburb: 'NYAH', state: 'VIC' },
  { postCode: '3595', suburb: 'NYAH WEST', state: 'VIC' },
  { postCode: '3596', suburb: 'MIRALIE', state: 'VIC' },
  { postCode: '3596', suburb: 'TOWAN', state: 'VIC' },
  { postCode: '3596', suburb: 'WOOD WOOD', state: 'VIC' },
  { postCode: '3597', suburb: 'KENLEY', state: 'VIC' },
  { postCode: '3597', suburb: 'KOOLOONONG', state: 'VIC' },
  { postCode: '3597', suburb: 'LAKE POWELL', state: 'VIC' },
  { postCode: '3597', suburb: 'NARRUNG', state: 'VIC' },
  { postCode: '3597', suburb: 'NATYA', state: 'VIC' },
  { postCode: '3597', suburb: 'PIANGIL', state: 'VIC' },
  { postCode: '3599', suburb: 'BOUNDARY BEND', state: 'VIC' },
  { postCode: '3607', suburb: 'TABILK', state: 'VIC' },
  { postCode: '3608', suburb: 'BAILIESTON', state: 'VIC' },
  { postCode: '3608', suburb: 'GOULBURN WEIR', state: 'VIC' },
  { postCode: '3608', suburb: 'GRAYTOWN', state: 'VIC' },
  { postCode: '3608', suburb: 'KIRWANS BRIDGE', state: 'VIC' },
  { postCode: '3608', suburb: 'MITCHELLSTOWN', state: 'VIC' },
  { postCode: '3608', suburb: 'NAGAMBIE', state: 'VIC' },
  { postCode: '3608', suburb: 'WAHRING', state: 'VIC' },
  { postCode: '3608', suburb: 'WIRRATE', state: 'VIC' },
  { postCode: '3610', suburb: 'DHURRINGILE', state: 'VIC' },
  { postCode: '3610', suburb: 'MOORILIM', state: 'VIC' },
  { postCode: '3610', suburb: 'MURCHISON', state: 'VIC' },
  { postCode: '3610', suburb: 'MURCHISON EAST', state: 'VIC' },
  { postCode: '3610', suburb: 'MURCHISON NORTH', state: 'VIC' },
  { postCode: '3612', suburb: 'MOORA', state: 'VIC' },
  { postCode: '3612', suburb: 'RUSHWORTH', state: 'VIC' },
  { postCode: '3612', suburb: 'WANALTA', state: 'VIC' },
  { postCode: '3612', suburb: 'WARANGA SHORES', state: 'VIC' },
  { postCode: '3612', suburb: 'WHROO', state: 'VIC' },
  { postCode: '3614', suburb: 'TOOLAMBA', state: 'VIC' },
  { postCode: '3614', suburb: 'TOOLAMBA WEST', state: 'VIC' },
  { postCode: '3616', suburb: 'COOMA', state: 'VIC' },
  { postCode: '3616', suburb: 'GILLIESTON', state: 'VIC' },
  { postCode: '3616', suburb: 'GIRGARRE EAST', state: 'VIC' },
  { postCode: '3616', suburb: 'HARSTON', state: 'VIC' },
  { postCode: '3616', suburb: 'MOOROOPNA NORTH WEST', state: 'VIC' },
  { postCode: '3616', suburb: 'TATURA', state: 'VIC' },
  { postCode: '3616', suburb: 'TATURA EAST', state: 'VIC' },
  { postCode: '3616', suburb: 'WARANGA', state: 'VIC' },
  { postCode: '3617', suburb: 'BYRNESIDE', state: 'VIC' },
  { postCode: '3618', suburb: 'MERRIGUM', state: 'VIC' },
  { postCode: '3619', suburb: 'KYABRAM', state: 'VIC' },
  { postCode: '3620', suburb: 'KYABRAM', state: 'VIC' },
  { postCode: '3620', suburb: 'KYABRAM SOUTH', state: 'VIC' },
  { postCode: '3620', suburb: 'LANCASTER', state: 'VIC' },
  { postCode: '3620', suburb: 'ST GERMAINS', state: 'VIC' },
  { postCode: '3620', suburb: 'WYUNA', state: 'VIC' },
  { postCode: '3620', suburb: 'WYUNA EAST', state: 'VIC' },
  { postCode: '3621', suburb: 'KYVALLEY', state: 'VIC' },
  { postCode: '3621', suburb: 'TONGALA', state: 'VIC' },
  { postCode: '3621', suburb: 'YAMBUNA', state: 'VIC' },
  { postCode: '3622', suburb: 'KOYUGA', state: 'VIC' },
  { postCode: '3622', suburb: 'STRATHALLAN', state: 'VIC' },
  { postCode: '3623', suburb: 'CARAG CARAG', state: 'VIC' },
  { postCode: '3623', suburb: 'STANHOPE', state: 'VIC' },
  { postCode: '3623', suburb: 'STANHOPE SOUTH', state: 'VIC' },
  { postCode: '3624', suburb: 'GIRGARRE', state: 'VIC' },
  { postCode: '3629', suburb: 'ARDMONA', state: 'VIC' },
  { postCode: '3629', suburb: 'COOMBOONA', state: 'VIC' },
  { postCode: '3629', suburb: 'MOOROOPNA', state: 'VIC' },
  { postCode: '3629', suburb: 'MOOROOPNA NORTH', state: 'VIC' },
  { postCode: '3629', suburb: 'UNDERA', state: 'VIC' },
  { postCode: '3630', suburb: 'BRANDITT', state: 'VIC' },
  { postCode: '3630', suburb: 'CANIAMBO', state: 'VIC' },
  { postCode: '3630', suburb: 'COLLIVER', state: 'VIC' },
  { postCode: '3630', suburb: 'DUNKIRK', state: 'VIC' },
  { postCode: '3630', suburb: 'SHEPPARTON', state: 'VIC' },
  { postCode: '3630', suburb: 'SHEPPARTON SOUTH', state: 'VIC' },
  { postCode: '3631', suburb: 'ARCADIA', state: 'VIC' },
  { postCode: '3631', suburb: 'ARCADIA SOUTH', state: 'VIC' },
  { postCode: '3631', suburb: 'COSGROVE', state: 'VIC' },
  { postCode: '3631', suburb: 'COSGROVE SOUTH', state: 'VIC' },
  { postCode: '3631', suburb: 'GRAHAMVALE', state: 'VIC' },
  { postCode: '3631', suburb: 'KARRAMOMUS', state: 'VIC' },
  { postCode: '3631', suburb: 'KIALLA', state: 'VIC' },
  { postCode: '3631', suburb: 'KIALLA EAST', state: 'VIC' },
  { postCode: '3631', suburb: 'KIALLA WEST', state: 'VIC' },
  { postCode: '3631', suburb: 'LEMNOS', state: 'VIC' },
  { postCode: '3631', suburb: 'ORRVALE', state: 'VIC' },
  { postCode: '3631', suburb: 'PINE LODGE', state: 'VIC' },
  { postCode: '3631', suburb: 'SHEPPARTON EAST', state: 'VIC' },
  { postCode: '3631', suburb: 'SHEPPARTON NORTH', state: 'VIC' },
  { postCode: '3632', suburb: 'SHEPPARTON', state: 'VIC' },
  { postCode: '3633', suburb: 'CONGUPNA', state: 'VIC' },
  { postCode: '3634', suburb: 'BUNBARTHA', state: 'VIC' },
  { postCode: '3634', suburb: 'KATANDRA', state: 'VIC' },
  { postCode: '3634', suburb: 'KATANDRA WEST', state: 'VIC' },
  { postCode: '3634', suburb: 'MARIONVALE', state: 'VIC' },
  { postCode: '3634', suburb: 'MARUNGI', state: 'VIC' },
  { postCode: '3634', suburb: 'TALLYGAROOPNA', state: 'VIC' },
  { postCode: '3634', suburb: 'ZEERUST', state: 'VIC' },
  { postCode: '3635', suburb: 'KAARIMBA', state: 'VIC' },
  { postCode: '3635', suburb: 'MUNDOONA', state: 'VIC' },
  { postCode: '3635', suburb: 'WUNGHNU', state: 'VIC' },
  { postCode: '3636', suburb: 'DRUMANURE', state: 'VIC' },
  { postCode: '3636', suburb: 'INVERGORDON', state: 'VIC' },
  { postCode: '3636', suburb: 'NARING', state: 'VIC' },
  { postCode: '3636', suburb: 'NUMURKAH', state: 'VIC' },
  { postCode: '3637', suburb: 'WAAIA', state: 'VIC' },
  { postCode: '3637', suburb: 'YALCA', state: 'VIC' },
  { postCode: '3638', suburb: 'KOTUPNA', state: 'VIC' },
  { postCode: '3638', suburb: 'NATHALIA', state: 'VIC' },
  { postCode: '3638', suburb: 'YIELIMA', state: 'VIC' },
  { postCode: '3639', suburb: 'BARMAH', state: 'VIC' },
  { postCode: '3639', suburb: 'LOWER MOIRA', state: 'VIC' },
  { postCode: '3639', suburb: 'PICOLA', state: 'VIC' },
  { postCode: '3639', suburb: 'PICOLA WEST', state: 'VIC' },
  { postCode: '3640', suburb: 'KATUNGA', state: 'VIC' },
  { postCode: '3641', suburb: 'BEARII', state: 'VIC' },
  { postCode: '3641', suburb: 'MYWEE', state: 'VIC' },
  { postCode: '3641', suburb: 'STRATHMERTON', state: 'VIC' },
  { postCode: '3641', suburb: 'ULUPNA', state: 'VIC' },
  { postCode: '3643', suburb: 'COBRAM', state: 'VIC' },
  { postCode: '3644', suburb: 'BAROOGA', state: 'NSW' },
  { postCode: '3644', suburb: 'COBRAM', state: 'VIC' },
  { postCode: '3644', suburb: 'COBRAM EAST', state: 'VIC' },
  { postCode: '3644', suburb: 'KOONOOMOO', state: 'VIC' },
  { postCode: '3644', suburb: 'LALALTY', state: 'NSW' },
  { postCode: '3644', suburb: 'MUCKATAH', state: 'VIC' },
  { postCode: '3644', suburb: 'YARROWEYAH', state: 'VIC' },
  { postCode: '3646', suburb: 'DOOKIE', state: 'VIC' },
  { postCode: '3646', suburb: 'MOUNT MAJOR', state: 'VIC' },
  { postCode: '3646', suburb: 'NALINGA', state: 'VIC' },
  { postCode: '3646', suburb: 'WAGGARANDALL', state: 'VIC' },
  { postCode: '3646', suburb: 'YABBA NORTH', state: 'VIC' },
  { postCode: '3646', suburb: 'YABBA SOUTH', state: 'VIC' },
  { postCode: '3646', suburb: 'YOUANMITE', state: 'VIC' },
  { postCode: '3647', suburb: 'DOOKIE COLLEGE', state: 'VIC' },
  { postCode: '3649', suburb: 'KATAMATITE', state: 'VIC' },
  { postCode: '3649', suburb: 'KATAMATITE EAST', state: 'VIC' },
  { postCode: '3658', suburb: 'BROADFORD', state: 'VIC' },
  { postCode: '3658', suburb: 'CLONBINANE', state: 'VIC' },
  { postCode: '3658', suburb: 'HAZELDENE', state: 'VIC' },
  { postCode: '3658', suburb: 'REEDY CREEK', state: 'VIC' },
  { postCode: '3658', suburb: 'STRATH CREEK', state: 'VIC' },
  { postCode: '3658', suburb: 'SUGARLOAF CREEK', state: 'VIC' },
  { postCode: '3658', suburb: 'SUNDAY CREEK', state: 'VIC' },
  { postCode: '3658', suburb: 'TYAAK', state: 'VIC' },
  { postCode: '3658', suburb: 'WATERFORD PARK', state: 'VIC' },
  { postCode: '3659', suburb: 'TALLAROOK', state: 'VIC' },
  { postCode: '3660', suburb: 'CAVEAT', state: 'VIC' },
  { postCode: '3660', suburb: 'DROPMORE', state: 'VIC' },
  { postCode: '3660', suburb: 'HIGHLANDS', state: 'VIC' },
  { postCode: '3660', suburb: 'HILLDENE', state: 'VIC' },
  { postCode: '3660', suburb: 'KERRISDALE', state: 'VIC' },
  { postCode: '3660', suburb: 'NORTHWOOD', state: 'VIC' },
  { postCode: '3660', suburb: 'SEYMOUR', state: 'VIC' },
  { postCode: '3660', suburb: 'SEYMOUR SOUTH', state: 'VIC' },
  { postCode: '3660', suburb: 'TRAWOOL', state: 'VIC' },
  { postCode: '3660', suburb: 'WHITEHEADS CREEK', state: 'VIC' },
  { postCode: '3661', suburb: 'SEYMOUR', state: 'VIC' },
  { postCode: '3662', suburb: 'PUCKAPUNYAL', state: 'VIC' },
  { postCode: '3663', suburb: 'MANGALORE', state: 'VIC' },
  { postCode: '3664', suburb: 'AVENEL', state: 'VIC' },
  { postCode: '3664', suburb: 'UPTON HILL', state: 'VIC' },
  { postCode: '3665', suburb: 'LOCKSLEY', state: 'VIC' },
  { postCode: '3665', suburb: 'LONGWOOD', state: 'VIC' },
  { postCode: '3666', suburb: 'BALMATTUM', state: 'VIC' },
  { postCode: '3666', suburb: 'CREIGHTONS CREEK', state: 'VIC' },
  { postCode: '3666', suburb: 'EUROA', state: 'VIC' },
  { postCode: '3666', suburb: 'GOORAM', state: 'VIC' },
  { postCode: '3666', suburb: 'KELVIN VIEW', state: 'VIC' },
  { postCode: '3666', suburb: 'KITHBROOK', state: 'VIC' },
  { postCode: '3666', suburb: 'LONGWOOD EAST', state: 'VIC' },
  { postCode: '3666', suburb: 'MIEPOLL', state: 'VIC' },
  { postCode: '3666', suburb: 'MOGLONEMBY', state: 'VIC' },
  { postCode: '3666', suburb: 'MOLKA', state: 'VIC' },
  { postCode: '3666', suburb: 'PRANJIP', state: 'VIC' },
  { postCode: '3666', suburb: 'RIGGS CREEK', state: 'VIC' },
  { postCode: '3666', suburb: 'RUFFY', state: 'VIC' },
  { postCode: '3666', suburb: 'SHEANS CREEK', state: 'VIC' },
  { postCode: '3666', suburb: 'STRATHBOGIE', state: 'VIC' },
  { postCode: '3666', suburb: 'TARCOMBE', state: 'VIC' },
  { postCode: '3669', suburb: 'BOHO', state: 'VIC' },
  { postCode: '3669', suburb: 'BOHO SOUTH', state: 'VIC' },
  { postCode: '3669', suburb: 'CREEK JUNCTION', state: 'VIC' },
  { postCode: '3669', suburb: 'EARLSTON', state: 'VIC' },
  { postCode: '3669', suburb: 'GOWANGARDIE', state: 'VIC' },
  { postCode: '3669', suburb: 'KOONDA', state: 'VIC' },
  { postCode: '3669', suburb: 'MARRAWEENEY', state: 'VIC' },
  { postCode: '3669', suburb: 'TAMLEUGH', state: 'VIC' },
  { postCode: '3669', suburb: 'TAMLEUGH NORTH', state: 'VIC' },
  { postCode: '3669', suburb: 'UPOTIPOTPON', state: 'VIC' },
  { postCode: '3669', suburb: 'VIOLET TOWN', state: 'VIC' },
  { postCode: '3670', suburb: 'BADDAGINNIE', state: 'VIC' },
  { postCode: '3670', suburb: 'TARNOOK', state: 'VIC' },
  { postCode: '3670', suburb: 'WARRENBAYNE', state: 'VIC' },
  { postCode: '3671', suburb: 'BENALLA', state: 'VIC' },
  { postCode: '3672', suburb: 'BENALLA', state: 'VIC' },
  { postCode: '3673', suburb: 'BROKEN CREEK', state: 'VIC' },
  { postCode: '3673', suburb: 'GOOMALIBEE', state: 'VIC' },
  { postCode: '3673', suburb: 'LIMA', state: 'VIC' },
  { postCode: '3673', suburb: 'LIMA EAST', state: 'VIC' },
  { postCode: '3673', suburb: 'LIMA SOUTH', state: 'VIC' },
  { postCode: '3673', suburb: 'LURG', state: 'VIC' },
  { postCode: '3673', suburb: 'MOLYULLAH', state: 'VIC' },
  { postCode: '3673', suburb: 'MOORNGAG', state: 'VIC' },
  { postCode: '3673', suburb: 'SAMARIA', state: 'VIC' },
  { postCode: '3673', suburb: 'SWANPOOL', state: 'VIC' },
  { postCode: '3673', suburb: 'TATONG', state: 'VIC' },
  { postCode: '3673', suburb: 'UPPER LURG', state: 'VIC' },
  { postCode: '3673', suburb: 'UPPER RYANS CREEK', state: 'VIC' },
  { postCode: '3673', suburb: 'WINTON', state: 'VIC' },
  { postCode: '3673', suburb: 'WINTON NORTH', state: 'VIC' },
  { postCode: '3675', suburb: 'BOWEYA', state: 'VIC' },
  { postCode: '3675', suburb: 'BOWEYA NORTH', state: 'VIC' },
  { postCode: '3675', suburb: 'GLENROWAN', state: 'VIC' },
  { postCode: '3675', suburb: 'GLENROWAN WEST', state: 'VIC' },
  { postCode: '3675', suburb: 'GRETA', state: 'VIC' },
  { postCode: '3675', suburb: 'GRETA SOUTH', state: 'VIC' },
  { postCode: '3675', suburb: 'GRETA WEST', state: 'VIC' },
  { postCode: '3675', suburb: 'HANSONVILLE', state: 'VIC' },
  { postCode: '3675', suburb: 'MOUNT BRUNO', state: 'VIC' },
  { postCode: '3675', suburb: 'TAMINICK', state: 'VIC' },
  { postCode: '3676', suburb: 'WANGARATTA', state: 'VIC' },
  { postCode: '3677', suburb: 'WANGARATTA', state: 'VIC' },
  { postCode: '3677', suburb: 'YARRUNGA', state: 'VIC' },
  { postCode: '3678', suburb: 'BOBINAWARRAH', state: 'VIC' },
  { postCode: '3678', suburb: 'BOORHAMAN', state: 'VIC' },
  { postCode: '3678', suburb: 'BOORHAMAN EAST', state: 'VIC' },
  { postCode: '3678', suburb: 'BOWSER', state: 'VIC' },
  { postCode: '3678', suburb: 'BYAWATHA', state: 'VIC' },
  { postCode: '3678', suburb: 'CARBOOR', state: 'VIC' },
  { postCode: '3678', suburb: 'CHESHUNT', state: 'VIC' },
  { postCode: '3678', suburb: 'CHESHUNT SOUTH', state: 'VIC' },
  { postCode: '3678', suburb: 'DOCKER', state: 'VIC' },
  { postCode: '3678', suburb: 'DOCKERS PLAINS', state: 'VIC' },
  { postCode: '3678', suburb: 'EAST WANGARATTA', state: 'VIC' },
  { postCode: '3678', suburb: 'EDI', state: 'VIC' },
  { postCode: '3678', suburb: 'EDI UPPER', state: 'VIC' },
  { postCode: '3678', suburb: 'EVERTON', state: 'VIC' },
  { postCode: '3678', suburb: 'EVERTON UPPER', state: 'VIC' },
  { postCode: '3678', suburb: 'KILLAWARRA', state: 'VIC' },
  { postCode: '3678', suburb: 'KING VALLEY', state: 'VIC' },
  { postCode: '3678', suburb: 'LACEBY', state: 'VIC' },
  { postCode: '3678', suburb: 'LONDRIGAN', state: 'VIC' },
  { postCode: '3678', suburb: 'MARKWOOD', state: 'VIC' },
  { postCode: '3678', suburb: 'MEADOW CREEK', state: 'VIC' },
  { postCode: '3678', suburb: 'MILAWA', state: 'VIC' },
  { postCode: '3678', suburb: 'NORTH WANGARATTA', state: 'VIC' },
  { postCode: '3678', suburb: 'OXLEY', state: 'VIC' },
  { postCode: '3678', suburb: 'OXLEY FLATS', state: 'VIC' },
  { postCode: '3678', suburb: 'PEECHELBA', state: 'VIC' },
  { postCode: '3678', suburb: 'PEECHELBA EAST', state: 'VIC' },
  { postCode: '3678', suburb: 'ROSE RIVER', state: 'VIC' },
  { postCode: '3678', suburb: 'TARRAWINGEE', state: 'VIC' },
  { postCode: '3678', suburb: 'WABONGA', state: 'VIC' },
  { postCode: '3678', suburb: 'WALDARA', state: 'VIC' },
  { postCode: '3678', suburb: 'WANGANDARY', state: 'VIC' },
  { postCode: '3678', suburb: 'WANGARATTA FORWARD', state: 'VIC' },
  { postCode: '3678', suburb: 'WANGARATTA SOUTH', state: 'VIC' },
  { postCode: '3678', suburb: 'WHITLANDS', state: 'VIC' },
  { postCode: '3682', suburb: 'BORALMA', state: 'VIC' },
  { postCode: '3682', suburb: 'LILLIPUT', state: 'VIC' },
  { postCode: '3682', suburb: 'NORONG', state: 'VIC' },
  { postCode: '3682', suburb: 'SPRINGHURST', state: 'VIC' },
  { postCode: '3683', suburb: 'CHILTERN', state: 'VIC' },
  { postCode: '3683', suburb: 'CHILTERN VALLEY', state: 'VIC' },
  { postCode: '3683', suburb: 'CORNISHTOWN', state: 'VIC' },
  { postCode: '3685', suburb: 'BOORHAMAN NORTH', state: 'VIC' },
  { postCode: '3685', suburb: 'BRIMIN', state: 'VIC' },
  { postCode: '3685', suburb: 'BROWNS PLAINS', state: 'VIC' },
  { postCode: '3685', suburb: 'CARLYLE', state: 'VIC' },
  { postCode: '3685', suburb: 'GOORAMADDA', state: 'VIC' },
  { postCode: '3685', suburb: 'GREAT SOUTHERN', state: 'VIC' },
  { postCode: '3685', suburb: 'PRENTICE NORTH', state: 'VIC' },
  { postCode: '3685', suburb: 'RUTHERGLEN', state: 'VIC' },
  { postCode: '3687', suburb: 'WAHGUNYAH', state: 'VIC' },
  { postCode: '3688', suburb: 'BARNAWARTHA', state: 'VIC' },
  { postCode: '3688', suburb: 'INDIGO VALLEY', state: 'VIC' },
  { postCode: '3689', suburb: 'WODONGA', state: 'VIC' },
  { postCode: '3690', suburb: 'WEST WODONGA', state: 'VIC' },
  { postCode: '3690', suburb: 'WODONGA', state: 'VIC' },
  { postCode: '3690', suburb: 'WODONGA PLAZA', state: 'VIC' },
  { postCode: '3691', suburb: 'ALLANS FLAT', state: 'VIC' },
  { postCode: '3691', suburb: 'BANDIANA', state: 'VIC' },
  { postCode: '3691', suburb: 'BARANDUDA', state: 'VIC' },
  { postCode: '3691', suburb: 'BARNAWARTHA NORTH', state: 'VIC' },
  { postCode: '3691', suburb: 'BELLBRIDGE', state: 'VIC' },
  { postCode: '3691', suburb: 'BERRINGAMA', state: 'VIC' },
  { postCode: '3691', suburb: 'BETHANGA', state: 'VIC' },
  { postCode: '3691', suburb: 'BONEGILLA', state: 'VIC' },
  { postCode: '3691', suburb: 'BUNGIL', state: 'VIC' },
  { postCode: '3691', suburb: 'CASTLE CREEK', state: 'VIC' },
  { postCode: '3691', suburb: 'CORAL BANK', state: 'VIC' },
  { postCode: '3691', suburb: 'DEDERANG', state: 'VIC' },
  { postCode: '3691', suburb: 'EBDEN', state: 'VIC' },
  { postCode: '3691', suburb: 'GATEWAY ISLAND', state: 'VIC' },
  { postCode: '3691', suburb: 'GLEN CREEK', state: 'VIC' },
  { postCode: '3691', suburb: 'GUNDOWRING', state: 'VIC' },
  { postCode: '3691', suburb: 'HUON CREEK', state: 'VIC' },
  { postCode: '3691', suburb: 'KANCOONA', state: 'VIC' },
  { postCode: '3691', suburb: 'KERGUNYAH', state: 'VIC' },
  { postCode: '3691', suburb: 'KERGUNYAH SOUTH', state: 'VIC' },
  { postCode: '3691', suburb: 'KIEWA', state: 'VIC' },
  { postCode: '3691', suburb: 'KILLARA', state: 'VIC' },
  { postCode: '3691', suburb: 'LAKE HUME VILLAGE', state: 'NSW' },
  { postCode: '3691', suburb: 'LENEVA', state: 'VIC' },
  { postCode: '3691', suburb: 'LUCYVALE', state: 'VIC' },
  { postCode: '3691', suburb: 'MONGANS BRIDGE', state: 'VIC' },
  { postCode: '3691', suburb: 'OSBORNES FLAT', state: 'VIC' },
  { postCode: '3691', suburb: 'RUNNING CREEK', state: 'VIC' },
  { postCode: '3691', suburb: 'STAGHORN FLAT', state: 'VIC' },
  { postCode: '3691', suburb: 'TALGARNO', state: 'VIC' },
  { postCode: '3691', suburb: 'TANGAMBALANGA', state: 'VIC' },
  { postCode: '3691', suburb: 'THOLOGOLONG', state: 'VIC' },
  { postCode: '3691', suburb: 'UPPER GUNDOWRING', state: 'VIC' },
  { postCode: '3691', suburb: 'WODONGA FORWARD', state: 'VIC' },
  { postCode: '3694', suburb: 'BANDIANA MILPO', state: 'VIC' },
  { postCode: '3695', suburb: 'CHARLEROI', state: 'VIC' },
  { postCode: '3695', suburb: 'HUON', state: 'VIC' },
  { postCode: '3695', suburb: 'SANDY CREEK', state: 'VIC' },
  { postCode: '3697', suburb: 'TAWONGA', state: 'VIC' },
  { postCode: '3698', suburb: 'TAWONGA SOUTH', state: 'VIC' },
  { postCode: '3699', suburb: 'BOGONG', state: 'VIC' },
  { postCode: '3699', suburb: 'FALLS CREEK', state: 'VIC' },
  { postCode: '3699', suburb: 'MOUNT BEAUTY', state: 'VIC' },
  { postCode: '3699', suburb: 'NELSE', state: 'VIC' },
  { postCode: '3700', suburb: 'BULLIOH', state: 'VIC' },
  { postCode: '3700', suburb: 'GEORGES CREEK', state: 'VIC' },
  { postCode: '3700', suburb: 'JARVIS CREEK', state: 'VIC' },
  { postCode: '3700', suburb: 'TALLANGATTA', state: 'VIC' },
  { postCode: '3700', suburb: 'TALLANGATTA EAST', state: 'VIC' },
  { postCode: '3701', suburb: 'DARTMOUTH', state: 'VIC' },
  { postCode: '3701', suburb: 'ESKDALE', state: 'VIC' },
  { postCode: '3701', suburb: 'GRANYA', state: 'VIC' },
  { postCode: '3701', suburb: 'MITTA MITTA', state: 'VIC' },
  { postCode: '3701', suburb: 'OLD TALLANGATTA', state: 'VIC' },
  { postCode: '3701', suburb: 'SHELLEY', state: 'VIC' },
  { postCode: '3701', suburb: 'TALLANDOON', state: 'VIC' },
  { postCode: '3701', suburb: 'TALLANGATTA SOUTH', state: 'VIC' },
  { postCode: '3701', suburb: 'TALLANGATTA VALLEY', state: 'VIC' },
  { postCode: '3704', suburb: 'KOETONG', state: 'VIC' },
  { postCode: '3705', suburb: 'CUDGEWA', state: 'VIC' },
  { postCode: '3707', suburb: 'BIGGARA', state: 'VIC' },
  { postCode: '3707', suburb: 'BRINGENBRONG', state: 'NSW' },
  { postCode: '3707', suburb: 'COLAC COLAC', state: 'VIC' },
  { postCode: '3707', suburb: 'CORRYONG', state: 'VIC' },
  { postCode: '3707', suburb: 'NARIEL VALLEY', state: 'VIC' },
  { postCode: '3707', suburb: 'THOWGLA VALLEY', state: 'VIC' },
  { postCode: '3707', suburb: 'TOM GROGGIN', state: 'VIC' },
  { postCode: '3707', suburb: 'TOWONG', state: 'VIC' },
  { postCode: '3707', suburb: 'TOWONG UPPER', state: 'VIC' },
  { postCode: '3708', suburb: 'TINTALDRA', state: 'VIC' },
  { postCode: '3709', suburb: 'BURROWYE', state: 'VIC' },
  { postCode: '3709', suburb: 'GUYS FOREST', state: 'VIC' },
  { postCode: '3709', suburb: 'MOUNT ALFRED', state: 'VIC' },
  { postCode: '3709', suburb: 'PINE MOUNTAIN', state: 'VIC' },
  { postCode: '3709', suburb: 'WALWA', state: 'VIC' },
  { postCode: '3711', suburb: 'BUXTON', state: 'VIC' },
  { postCode: '3712', suburb: 'RUBICON', state: 'VIC' },
  { postCode: '3712', suburb: 'THORNTON', state: 'VIC' },
  { postCode: '3713', suburb: 'EILDON', state: 'VIC' },
  { postCode: '3713', suburb: 'LAKE EILDON', state: 'VIC' },
  { postCode: '3713', suburb: 'TAYLOR BAY', state: 'VIC' },
  { postCode: '3714', suburb: 'ACHERON', state: 'VIC' },
  { postCode: '3714', suburb: 'ALEXANDRA', state: 'VIC' },
  { postCode: '3714', suburb: 'CATHKIN', state: 'VIC' },
  { postCode: '3714', suburb: 'CRYSTAL CREEK', state: 'VIC' },
  { postCode: '3714', suburb: 'DEVILS RIVER', state: 'VIC' },
  { postCode: '3714', suburb: 'FAWCETT', state: 'VIC' },
  { postCode: '3714', suburb: 'KORIELLA', state: 'VIC' },
  { postCode: '3714', suburb: 'MAINTONGOON', state: 'VIC' },
  { postCode: '3714', suburb: 'TAGGERTY', state: 'VIC' },
  { postCode: '3714', suburb: 'WHANREGARWEN', state: 'VIC' },
  { postCode: '3715', suburb: 'ANCONA', state: 'VIC' },
  { postCode: '3715', suburb: 'MERTON', state: 'VIC' },
  { postCode: '3715', suburb: 'WOODFIELD', state: 'VIC' },
  { postCode: '3717', suburb: 'FLOWERDALE', state: 'VIC' },
  { postCode: '3717', suburb: 'GHIN GHIN', state: 'VIC' },
  { postCode: '3717', suburb: 'GLENBURN', state: 'VIC' },
  { postCode: '3717', suburb: 'HOMEWOOD', state: 'VIC' },
  { postCode: '3717', suburb: 'KILLINGWORTH', state: 'VIC' },
  { postCode: '3717', suburb: 'LIMESTONE', state: 'VIC' },
  { postCode: '3717', suburb: 'MURRINDINDI', state: 'VIC' },
  { postCode: '3717', suburb: 'YEA', state: 'VIC' },
  { postCode: '3718', suburb: 'MOLESWORTH', state: 'VIC' },
  { postCode: '3719', suburb: 'GOBUR', state: 'VIC' },
  { postCode: '3719', suburb: 'KANUMBRA', state: 'VIC' },
  { postCode: '3719', suburb: 'TERIP TERIP', state: 'VIC' },
  { postCode: '3719', suburb: 'YARCK', state: 'VIC' },
  { postCode: '3720', suburb: 'BONNIE DOON', state: 'VIC' },
  { postCode: '3722', suburb: 'BARWITE', state: 'VIC' },
  { postCode: '3722', suburb: 'MANSFIELD', state: 'VIC' },
  { postCode: '3722', suburb: 'MIRIMBAH', state: 'VIC' },
  { postCode: '3723', suburb: 'ARCHERTON', state: 'VIC' },
  { postCode: '3723', suburb: 'BARJARG', state: 'VIC' },
  { postCode: '3723', suburb: 'BOOROLITE', state: 'VIC' },
  { postCode: '3723', suburb: 'BRIDGE CREEK', state: 'VIC' },
  { postCode: '3723', suburb: 'DELATITE', state: 'VIC' },
  { postCode: '3723', suburb: 'ENOCHS POINT', state: 'VIC' },
  { postCode: '3723', suburb: 'GAFFNEYS CREEK', state: 'VIC' },
  { postCode: '3723', suburb: 'GOUGHS BAY', state: 'VIC' },
  { postCode: '3723', suburb: 'HOWES CREEK', state: 'VIC' },
  { postCode: '3723', suburb: 'HOWQUA', state: 'VIC' },
  { postCode: '3723', suburb: 'HOWQUA HILLS', state: 'VIC' },
  { postCode: '3723', suburb: 'HOWQUA INLET', state: 'VIC' },
  { postCode: '3723', suburb: 'JAMIESON', state: 'VIC' },
  { postCode: '3723', suburb: 'KEVINGTON', state: 'VIC' },
  { postCode: '3723', suburb: 'KNOCKWOOD', state: 'VIC' },
  { postCode: '3723', suburb: 'MACS COVE', state: 'VIC' },
  { postCode: '3723', suburb: 'MAINDAMPLE', state: 'VIC' },
  { postCode: '3723', suburb: 'MATLOCK', state: 'VIC' },
  { postCode: '3723', suburb: 'MERRIJIG', state: 'VIC' },
  { postCode: '3723', suburb: 'MOUNT BULLER', state: 'VIC' },
  { postCode: '3723', suburb: 'MOUNTAIN BAY', state: 'VIC' },
  { postCode: '3723', suburb: 'PIRIES', state: 'VIC' },
  { postCode: '3723', suburb: 'SAWMILL SETTLEMENT', state: 'VIC' },
  { postCode: '3723', suburb: 'TOLMIE', state: 'VIC' },
  { postCode: '3723', suburb: 'WOODS POINT', state: 'VIC' },
  { postCode: '3724', suburb: 'MANSFIELD', state: 'VIC' },
  { postCode: '3725', suburb: 'BOXWOOD', state: 'VIC' },
  { postCode: '3725', suburb: 'CHESNEY VALE', state: 'VIC' },
  { postCode: '3725', suburb: 'GOORAMBAT', state: 'VIC' },
  { postCode: '3725', suburb: 'MAJOR PLAINS', state: 'VIC' },
  { postCode: '3725', suburb: 'STEWARTON', state: 'VIC' },
  { postCode: '3726', suburb: 'BUNGEET', state: 'VIC' },
  { postCode: '3726', suburb: 'BUNGEET WEST', state: 'VIC' },
  { postCode: '3726', suburb: 'DEVENISH', state: 'VIC' },
  { postCode: '3726', suburb: 'THOONA', state: 'VIC' },
  { postCode: '3727', suburb: 'ALMONDS', state: 'VIC' },
  { postCode: '3727', suburb: 'LAKE ROWAN', state: 'VIC' },
  { postCode: '3727', suburb: 'PELLUEBLA', state: 'VIC' },
  { postCode: '3727', suburb: 'ST JAMES', state: 'VIC' },
  { postCode: '3727', suburb: 'YUNDOOL', state: 'VIC' },
  { postCode: '3728', suburb: 'BOOMAHNOOMOONAH', state: 'VIC' },
  { postCode: '3728', suburb: 'TUNGAMAH', state: 'VIC' },
  { postCode: '3728', suburb: 'WILBY', state: 'VIC' },
  { postCode: '3728', suburb: 'YOUARANG', state: 'VIC' },
  { postCode: '3730', suburb: 'BATHUMI', state: 'VIC' },
  { postCode: '3730', suburb: 'BOOSEY', state: 'VIC' },
  { postCode: '3730', suburb: 'BUNDALONG', state: 'VIC' },
  { postCode: '3730', suburb: 'BUNDALONG SOUTH', state: 'VIC' },
  { postCode: '3730', suburb: 'BURRAMINE', state: 'VIC' },
  { postCode: '3730', suburb: 'BURRAMINE SOUTH', state: 'VIC' },
  { postCode: '3730', suburb: 'ESMOND', state: 'VIC' },
  { postCode: '3730', suburb: 'TELFORD', state: 'VIC' },
  { postCode: '3730', suburb: 'YARRAWONGA', state: 'VIC' },
  { postCode: '3730', suburb: 'YARRAWONGA SOUTH', state: 'VIC' },
  { postCode: '3732', suburb: 'MOYHU', state: 'VIC' },
  { postCode: '3732', suburb: 'MYRRHEE', state: 'VIC' },
  { postCode: '3733', suburb: 'WHITFIELD', state: 'VIC' },
  { postCode: '3735', suburb: 'BOWMANS FOREST', state: 'VIC' },
  { postCode: '3735', suburb: 'WHOROULY', state: 'VIC' },
  { postCode: '3735', suburb: 'WHOROULY EAST', state: 'VIC' },
  { postCode: '3735', suburb: 'WHOROULY SOUTH', state: 'VIC' },
  { postCode: '3736', suburb: 'MYRTLEFORD', state: 'VIC' },
  { postCode: '3737', suburb: 'ABBEYARD', state: 'VIC' },
  { postCode: '3737', suburb: 'BARWIDGEE', state: 'VIC' },
  { postCode: '3737', suburb: 'BUFFALO RIVER', state: 'VIC' },
  { postCode: '3737', suburb: 'DANDONGADALE', state: 'VIC' },
  { postCode: '3737', suburb: 'GAPSTED', state: 'VIC' },
  { postCode: '3737', suburb: 'HAVILAH', state: 'VIC' },
  { postCode: '3737', suburb: 'MERRIANG', state: 'VIC' },
  { postCode: '3737', suburb: 'MERRIANG SOUTH', state: 'VIC' },
  { postCode: '3737', suburb: 'MUDGEGONGA', state: 'VIC' },
  { postCode: '3737', suburb: 'MYRTLEFORD', state: 'VIC' },
  { postCode: '3737', suburb: 'NUG NUG', state: 'VIC' },
  { postCode: '3737', suburb: 'ROSEWHITE', state: 'VIC' },
  { postCode: '3737', suburb: 'SELWYN', state: 'VIC' },
  { postCode: '3737', suburb: 'WONNANGATTA', state: 'VIC' },
  { postCode: '3738', suburb: 'OVENS', state: 'VIC' },
  { postCode: '3739', suburb: 'EUROBIN', state: 'VIC' },
  { postCode: '3740', suburb: 'BUCKLAND', state: 'VIC' },
  { postCode: '3740', suburb: 'MOUNT BUFFALO', state: 'VIC' },
  { postCode: '3740', suburb: 'POREPUNKAH', state: 'VIC' },
  { postCode: '3741', suburb: 'BRIGHT', state: 'VIC' },
  { postCode: '3741', suburb: 'FREEBURGH', state: 'VIC' },
  { postCode: '3741', suburb: 'GERMANTOWN', state: 'VIC' },
  { postCode: '3741', suburb: 'HARRIETVILLE', state: 'VIC' },
  { postCode: '3741', suburb: 'HOTHAM HEIGHTS', state: 'VIC' },
  { postCode: '3741', suburb: 'MOUNT HOTHAM', state: 'VIC' },
  { postCode: '3741', suburb: 'SMOKO', state: 'VIC' },
  { postCode: '3744', suburb: 'WANDILIGONG', state: 'VIC' },
  { postCode: '3746', suburb: 'ELDORADO', state: 'VIC' },
  { postCode: '3747', suburb: 'BEECHWORTH', state: 'VIC' },
  { postCode: '3747', suburb: 'MURMUNGEE', state: 'VIC' },
  { postCode: '3747', suburb: 'STANLEY', state: 'VIC' },
  { postCode: '3747', suburb: 'WOORAGEE', state: 'VIC' },
  { postCode: '3749', suburb: 'BRUARONG', state: 'VIC' },
  { postCode: '3749', suburb: 'YACKANDANDAH', state: 'VIC' },
  { postCode: '3750', suburb: 'WOLLERT', state: 'VIC' },
  { postCode: '3751', suburb: 'WOODSTOCK', state: 'VIC' },
  { postCode: '3752', suburb: 'SOUTH MORANG', state: 'VIC' },
  { postCode: '3753', suburb: 'BEVERIDGE', state: 'VIC' },
  { postCode: '3754', suburb: 'DOREEN', state: 'VIC' },
  { postCode: '3754', suburb: 'MERNDA', state: 'VIC' },
  { postCode: '3755', suburb: 'YAN YEAN', state: 'VIC' },
  { postCode: '3756', suburb: 'CHINTIN', state: 'VIC' },
  { postCode: '3756', suburb: 'DARRAWEIT GUIM', state: 'VIC' },
  { postCode: '3756', suburb: 'UPPER PLENTY', state: 'VIC' },
  { postCode: '3756', suburb: 'WALLAN', state: 'VIC' },
  { postCode: '3757', suburb: 'EDEN PARK', state: 'VIC' },
  { postCode: '3757', suburb: 'HUMEVALE', state: 'VIC' },
  { postCode: '3757', suburb: 'KINGLAKE CENTRAL', state: 'VIC' },
  { postCode: '3757', suburb: 'KINGLAKE WEST', state: 'VIC' },
  { postCode: '3757', suburb: 'PHEASANT CREEK', state: 'VIC' },
  { postCode: '3757', suburb: 'WHITTLESEA', state: 'VIC' },
  { postCode: '3758', suburb: 'HEATHCOTE JUNCTION', state: 'VIC' },
  { postCode: '3758', suburb: 'WANDONG', state: 'VIC' },
  { postCode: '3759', suburb: 'PANTON HILL', state: 'VIC' },
  { postCode: '3760', suburb: 'SMITHS GULLY', state: 'VIC' },
  { postCode: '3761', suburb: 'ST ANDREWS', state: 'VIC' },
  { postCode: '3762', suburb: 'BYLANDS', state: 'VIC' },
  { postCode: '3763', suburb: 'KINGLAKE', state: 'VIC' },
  { postCode: '3764', suburb: 'FORBES', state: 'VIC' },
  { postCode: '3764', suburb: 'GLENAROUA', state: 'VIC' },
  { postCode: '3764', suburb: 'HIGH CAMP', state: 'VIC' },
  { postCode: '3764', suburb: 'KILMORE', state: 'VIC' },
  { postCode: '3764', suburb: 'KILMORE EAST', state: 'VIC' },
  { postCode: '3764', suburb: 'MORANDING', state: 'VIC' },
  { postCode: '3764', suburb: 'TANTARABOO', state: 'VIC' },
  { postCode: '3764', suburb: 'WILLOWMAVIN', state: 'VIC' },
  { postCode: '3765', suburb: 'MONTROSE', state: 'VIC' },
  { postCode: '3766', suburb: 'KALORAMA', state: 'VIC' },
  { postCode: '3767', suburb: 'MOUNT DANDENONG', state: 'VIC' },
  { postCode: '3770', suburb: 'COLDSTREAM', state: 'VIC' },
  { postCode: '3770', suburb: 'GRUYERE', state: 'VIC' },
  { postCode: '3770', suburb: 'YERING', state: 'VIC' },
  { postCode: '3775', suburb: 'CHRISTMAS HILLS', state: 'VIC' },
  { postCode: '3775', suburb: 'DIXONS CREEK', state: 'VIC' },
  { postCode: '3775', suburb: 'STEELS CREEK', state: 'VIC' },
  { postCode: '3775', suburb: 'TARRAWARRA', state: 'VIC' },
  { postCode: '3775', suburb: 'YARRA GLEN', state: 'VIC' },
  { postCode: '3777', suburb: 'BADGER CREEK', state: 'VIC' },
  { postCode: '3777', suburb: 'CASTELLA', state: 'VIC' },
  { postCode: '3777', suburb: 'CHUM CREEK', state: 'VIC' },
  { postCode: '3777', suburb: 'HEALESVILLE', state: 'VIC' },
  { postCode: '3777', suburb: 'HEALESVILLE MAIN STREET', state: 'VIC' },
  { postCode: '3777', suburb: 'MOUNT TOOLEBEWONG', state: 'VIC' },
  { postCode: '3777', suburb: 'TOOLANGI', state: 'VIC' },
  { postCode: '3778', suburb: 'FERNSHAW', state: 'VIC' },
  { postCode: '3778', suburb: 'NARBETHONG', state: 'VIC' },
  { postCode: '3779', suburb: 'CAMBARVILLE', state: 'VIC' },
  { postCode: '3779', suburb: 'MARYSVILLE', state: 'VIC' },
  { postCode: '3781', suburb: 'COCKATOO', state: 'VIC' },
  { postCode: '3781', suburb: 'MOUNT BURNETT', state: 'VIC' },
  { postCode: '3781', suburb: 'NANGANA', state: 'VIC' },
  { postCode: '3782', suburb: 'AVONSLEIGH', state: 'VIC' },
  { postCode: '3782', suburb: 'CLEMATIS', state: 'VIC' },
  { postCode: '3782', suburb: 'EMERALD', state: 'VIC' },
  { postCode: '3782', suburb: 'MACCLESFIELD', state: 'VIC' },
  { postCode: '3783', suburb: 'GEMBROOK', state: 'VIC' },
  { postCode: '3785', suburb: 'TREMONT', state: 'VIC' },
  { postCode: '3786', suburb: 'FERNY CREEK', state: 'VIC' },
  { postCode: '3787', suburb: 'SASSAFRAS', state: 'VIC' },
  { postCode: '3787', suburb: 'SASSAFRAS GULLY', state: 'VIC' },
  { postCode: '3788', suburb: 'OLINDA', state: 'VIC' },
  { postCode: '3789', suburb: 'SHERBROOKE', state: 'VIC' },
  { postCode: '3791', suburb: 'KALLISTA', state: 'VIC' },
  { postCode: '3792', suburb: 'THE PATCH', state: 'VIC' },
  { postCode: '3793', suburb: 'MONBULK', state: 'VIC' },
  { postCode: '3795', suburb: 'SILVAN', state: 'VIC' },
  { postCode: '3796', suburb: 'MOUNT EVELYN', state: 'VIC' },
  { postCode: '3797', suburb: 'GILDEROY', state: 'VIC' },
  { postCode: '3797', suburb: 'GLADYSDALE', state: 'VIC' },
  { postCode: '3797', suburb: 'POWELLTOWN', state: 'VIC' },
  { postCode: '3797', suburb: 'THREE BRIDGES', state: 'VIC' },
  { postCode: '3797', suburb: 'YARRA JUNCTION', state: 'VIC' },
  { postCode: '3799', suburb: 'BIG PATS CREEK', state: 'VIC' },
  { postCode: '3799', suburb: 'EAST WARBURTON', state: 'VIC' },
  { postCode: '3799', suburb: 'MCMAHONS CREEK', state: 'VIC' },
  { postCode: '3799', suburb: 'MILLGROVE', state: 'VIC' },
  { postCode: '3799', suburb: 'REEFTON', state: 'VIC' },
  { postCode: '3799', suburb: 'WARBURTON', state: 'VIC' },
  { postCode: '3799', suburb: 'WESBURN', state: 'VIC' },
  { postCode: '3800', suburb: 'MONASH UNIVERSITY', state: 'VIC' },
  { postCode: '3802', suburb: 'ENDEAVOUR HILLS', state: 'VIC' },
  { postCode: '3803', suburb: 'HALLAM', state: 'VIC' },
  { postCode: '3804', suburb: 'NARRE WARREN EAST', state: 'VIC' },
  { postCode: '3804', suburb: 'NARRE WARREN NORTH', state: 'VIC' },
  { postCode: '3805', suburb: 'FOUNTAIN GATE', state: 'VIC' },
  { postCode: '3805', suburb: 'NARRE WARREN', state: 'VIC' },
  { postCode: '3805', suburb: 'NARRE WARREN SOUTH', state: 'VIC' },
  { postCode: '3806', suburb: 'BERWICK', state: 'VIC' },
  { postCode: '3806', suburb: 'HARKAWAY', state: 'VIC' },
  { postCode: '3807', suburb: 'BEACONSFIELD', state: 'VIC' },
  { postCode: '3807', suburb: 'GUYS HILL', state: 'VIC' },
  { postCode: '3808', suburb: 'BEACONSFIELD UPPER', state: 'VIC' },
  { postCode: '3808', suburb: 'DEWHURST', state: 'VIC' },
  { postCode: '3809', suburb: 'OFFICER', state: 'VIC' },
  { postCode: '3809', suburb: 'OFFICER SOUTH', state: 'VIC' },
  { postCode: '3810', suburb: 'PAKENHAM', state: 'VIC' },
  { postCode: '3810', suburb: 'PAKENHAM SOUTH', state: 'VIC' },
  { postCode: '3810', suburb: 'PAKENHAM UPPER', state: 'VIC' },
  { postCode: '3810', suburb: 'RYTHDALE', state: 'VIC' },
  { postCode: '3812', suburb: 'MARYKNOLL', state: 'VIC' },
  { postCode: '3812', suburb: 'NAR NAR GOON', state: 'VIC' },
  { postCode: '3812', suburb: 'NAR NAR GOON NORTH', state: 'VIC' },
  { postCode: '3813', suburb: 'TYNONG', state: 'VIC' },
  { postCode: '3813', suburb: 'TYNONG NORTH', state: 'VIC' },
  { postCode: '3814', suburb: 'CORA LYNN', state: 'VIC' },
  { postCode: '3814', suburb: 'GARFIELD', state: 'VIC' },
  { postCode: '3814', suburb: 'GARFIELD NORTH', state: 'VIC' },
  { postCode: '3814', suburb: 'VERVALE', state: 'VIC' },
  { postCode: '3815', suburb: 'BUNYIP', state: 'VIC' },
  { postCode: '3815', suburb: 'BUNYIP NORTH', state: 'VIC' },
  { postCode: '3815', suburb: 'IONA', state: 'VIC' },
  { postCode: '3815', suburb: 'TONIMBUK', state: 'VIC' },
  { postCode: '3816', suburb: 'LABERTOUCHE', state: 'VIC' },
  { postCode: '3816', suburb: 'LONGWARRY', state: 'VIC' },
  { postCode: '3816', suburb: 'LONGWARRY NORTH', state: 'VIC' },
  { postCode: '3816', suburb: 'MODELLA', state: 'VIC' },
  { postCode: '3818', suburb: 'ATHLONE', state: 'VIC' },
  { postCode: '3818', suburb: 'DROUIN', state: 'VIC' },
  { postCode: '3818', suburb: 'DROUIN EAST', state: 'VIC' },
  { postCode: '3818', suburb: 'DROUIN SOUTH', state: 'VIC' },
  { postCode: '3818', suburb: 'DROUIN WEST', state: 'VIC' },
  { postCode: '3818', suburb: 'HALLORA', state: 'VIC' },
  { postCode: '3818', suburb: 'JINDIVICK', state: 'VIC' },
  { postCode: '3818', suburb: 'RIPPLEBROOK', state: 'VIC' },
  { postCode: '3820', suburb: 'BONA VISTA', state: 'VIC' },
  { postCode: '3820', suburb: 'LILLICO', state: 'VIC' },
  { postCode: '3820', suburb: 'WARRAGUL', state: 'VIC' },
  { postCode: '3821', suburb: 'BRANDY CREEK', state: 'VIC' },
  { postCode: '3821', suburb: 'BRAVINGTON', state: 'VIC' },
  { postCode: '3821', suburb: 'BULN BULN', state: 'VIC' },
  { postCode: '3821', suburb: 'BULN BULN EAST', state: 'VIC' },
  { postCode: '3821', suburb: 'CROSSOVER', state: 'VIC' },
  { postCode: '3821', suburb: 'ELLINBANK', state: 'VIC' },
  { postCode: '3821', suburb: 'FERNDALE', state: 'VIC' },
  { postCode: '3821', suburb: 'LARDNER', state: 'VIC' },
  { postCode: '3821', suburb: 'NILMA', state: 'VIC' },
  { postCode: '3821', suburb: 'NILMA NORTH', state: 'VIC' },
  { postCode: '3821', suburb: 'ROKEBY', state: 'VIC' },
  { postCode: '3821', suburb: 'SEAVIEW', state: 'VIC' },
  { postCode: '3821', suburb: 'SHADY CREEK', state: 'VIC' },
  { postCode: '3821', suburb: 'TETOORA ROAD', state: 'VIC' },
  { postCode: '3821', suburb: 'TORWOOD', state: 'VIC' },
  { postCode: '3821', suburb: 'WARRAGUL SOUTH', state: 'VIC' },
  { postCode: '3821', suburb: 'WARRAGUL WEST', state: 'VIC' },
  { postCode: '3822', suburb: 'CLOVERLEA', state: 'VIC' },
  { postCode: '3822', suburb: 'DARNUM', state: 'VIC' },
  { postCode: '3822', suburb: 'GAINSBOROUGH', state: 'VIC' },
  { postCode: '3823', suburb: 'ALLAMBEE', state: 'VIC' },
  { postCode: '3823', suburb: 'YARRAGON', state: 'VIC' },
  { postCode: '3823', suburb: 'YARRAGON SOUTH', state: 'VIC' },
  { postCode: '3824', suburb: 'CHILDERS', state: 'VIC' },
  { postCode: '3824', suburb: 'NARRACAN', state: 'VIC' },
  { postCode: '3824', suburb: 'THORPDALE SOUTH', state: 'VIC' },
  { postCode: '3824', suburb: 'TRAFALGAR', state: 'VIC' },
  { postCode: '3824', suburb: 'TRAFALGAR EAST', state: 'VIC' },
  { postCode: '3824', suburb: 'TRAFALGAR SOUTH', state: 'VIC' },
  { postCode: '3825', suburb: 'ABERFELDY', state: 'VIC' },
  { postCode: '3825', suburb: 'AMOR', state: 'VIC' },
  { postCode: '3825', suburb: 'BOOLA', state: 'VIC' },
  { postCode: '3825', suburb: 'CARINGAL', state: 'VIC' },
  { postCode: '3825', suburb: 'COALVILLE', state: 'VIC' },
  { postCode: '3825', suburb: 'COOPERS CREEK', state: 'VIC' },
  { postCode: '3825', suburb: 'ERICA', state: 'VIC' },
  { postCode: '3825', suburb: 'FUMINA', state: 'VIC' },
  { postCode: '3825', suburb: 'FUMINA SOUTH', state: 'VIC' },
  { postCode: '3825', suburb: 'HERNES OAK', state: 'VIC' },
  { postCode: '3825', suburb: 'HILL END', state: 'VIC' },
  { postCode: '3825', suburb: 'JACOB CREEK', state: 'VIC' },
  { postCode: '3825', suburb: 'JERICHO', state: 'VIC' },
  { postCode: '3825', suburb: 'MOE', state: 'VIC' },
  { postCode: '3825', suburb: 'MOE SOUTH', state: 'VIC' },
  { postCode: '3825', suburb: 'MOONDARRA', state: 'VIC' },
  { postCode: '3825', suburb: 'NEWBOROUGH', state: 'VIC' },
  { postCode: '3825', suburb: 'RAWSON', state: 'VIC' },
  { postCode: '3825', suburb: 'TANJIL', state: 'VIC' },
  { postCode: '3825', suburb: 'TANJIL SOUTH', state: 'VIC' },
  { postCode: '3825', suburb: 'THALLOO', state: 'VIC' },
  { postCode: '3825', suburb: 'THOMSON', state: 'VIC' },
  { postCode: '3825', suburb: 'TOOMBON', state: 'VIC' },
  { postCode: '3825', suburb: 'WALHALLA', state: 'VIC' },
  { postCode: '3825', suburb: 'WALHALLA EAST', state: 'VIC' },
  { postCode: '3825', suburb: 'WESTBURY', state: 'VIC' },
  { postCode: '3825', suburb: 'WILLOW GROVE', state: 'VIC' },
  { postCode: '3825', suburb: 'YALLOURN', state: 'VIC' },
  { postCode: '3825', suburb: 'YALLOURN NORTH', state: 'VIC' },
  { postCode: '3831', suburb: 'NEERIM', state: 'VIC' },
  { postCode: '3831', suburb: 'NEERIM EAST', state: 'VIC' },
  { postCode: '3831', suburb: 'NEERIM SOUTH', state: 'VIC' },
  { postCode: '3832', suburb: 'NAYOOK', state: 'VIC' },
  { postCode: '3832', suburb: 'NEERIM JUNCTION', state: 'VIC' },
  { postCode: '3832', suburb: 'NEERIM NORTH', state: 'VIC' },
  { postCode: '3833', suburb: 'ADA', state: 'VIC' },
  { postCode: '3833', suburb: 'BAW BAW', state: 'VIC' },
  { postCode: '3833', suburb: 'BAW BAW VILLAGE', state: 'VIC' },
  { postCode: '3833', suburb: 'GENTLE ANNIE', state: 'VIC' },
  { postCode: '3833', suburb: 'ICY CREEK', state: 'VIC' },
  { postCode: '3833', suburb: 'LOCH VALLEY', state: 'VIC' },
  { postCode: '3833', suburb: 'NOOJEE', state: 'VIC' },
  { postCode: '3833', suburb: 'PIEDMONT', state: 'VIC' },
  { postCode: '3833', suburb: 'TANJIL BREN', state: 'VIC' },
  { postCode: '3833', suburb: 'TOORONGO', state: 'VIC' },
  { postCode: '3833', suburb: 'VESPER', state: 'VIC' },
  { postCode: '3835', suburb: 'THORPDALE', state: 'VIC' },
  { postCode: '3840', suburb: 'DRIFFIELD', state: 'VIC' },
  { postCode: '3840', suburb: 'HAZELWOOD', state: 'VIC' },
  { postCode: '3840', suburb: 'HAZELWOOD NORTH', state: 'VIC' },
  { postCode: '3840', suburb: 'HAZELWOOD SOUTH', state: 'VIC' },
  { postCode: '3840', suburb: 'JEERALANG', state: 'VIC' },
  { postCode: '3840', suburb: 'JEERALANG JUNCTION', state: 'VIC' },
  { postCode: '3840', suburb: 'MARYVALE', state: 'VIC' },
  { postCode: '3840', suburb: 'MORWELL', state: 'VIC' },
  { postCode: '3841', suburb: 'GIPPSLAND MC', state: 'VIC' },
  { postCode: '3842', suburb: 'CHURCHILL', state: 'VIC' },
  { postCode: '3844', suburb: 'BLACKWARRY', state: 'VIC' },
  { postCode: '3844', suburb: 'CALLIGNEE', state: 'VIC' },
  { postCode: '3844', suburb: 'CALLIGNEE NORTH', state: 'VIC' },
  { postCode: '3844', suburb: 'CALLIGNEE SOUTH', state: 'VIC' },
  { postCode: '3844', suburb: 'CARRAJUNG', state: 'VIC' },
  { postCode: '3844', suburb: 'CARRAJUNG LOWER', state: 'VIC' },
  { postCode: '3844', suburb: 'CARRAJUNG SOUTH', state: 'VIC' },
  { postCode: '3844', suburb: 'FLYNN', state: 'VIC' },
  { postCode: '3844', suburb: 'FLYNNS CREEK', state: 'VIC' },
  { postCode: '3844', suburb: 'KOORNALLA', state: 'VIC' },
  { postCode: '3844', suburb: 'LOY YANG', state: 'VIC' },
  { postCode: '3844', suburb: 'MOUNT TASSIE', state: 'VIC' },
  { postCode: '3844', suburb: 'TRARALGON', state: 'VIC' },
  { postCode: '3844', suburb: 'TRARALGON EAST', state: 'VIC' },
  { postCode: '3844', suburb: 'TRARALGON SOUTH', state: 'VIC' },
  { postCode: '3844', suburb: 'TYERS', state: 'VIC' },
  { postCode: '3847', suburb: 'HIAMDALE', state: 'VIC' },
  { postCode: '3847', suburb: 'NAMBROK', state: 'VIC' },
  { postCode: '3847', suburb: 'ROSEDALE', state: 'VIC' },
  { postCode: '3847', suburb: 'WILLUNG', state: 'VIC' },
  { postCode: '3847', suburb: 'WILLUNG SOUTH', state: 'VIC' },
  { postCode: '3850', suburb: 'SALE', state: 'VIC' },
  { postCode: '3850', suburb: 'WURRUK', state: 'VIC' },
  { postCode: '3851', suburb: 'AIRLY', state: 'VIC' },
  { postCode: '3851', suburb: 'BUNDALAGUAH', state: 'VIC' },
  { postCode: '3851', suburb: 'CLYDEBANK', state: 'VIC' },
  { postCode: '3851', suburb: 'COBAINS', state: 'VIC' },
  { postCode: '3851', suburb: 'DARRIMAN', state: 'VIC' },
  { postCode: '3851', suburb: 'DUTSON', state: 'VIC' },
  { postCode: '3851', suburb: 'DUTSON DOWNS', state: 'VIC' },
  { postCode: '3851', suburb: 'FLAMINGO BEACH', state: 'VIC' },
  { postCode: '3851', suburb: 'FULHAM', state: 'VIC' },
  { postCode: '3851', suburb: 'GIFFARD', state: 'VIC' },
  { postCode: '3851', suburb: 'GIFFARD WEST', state: 'VIC' },
  { postCode: '3851', suburb: 'GLOMAR BEACH', state: 'VIC' },
  { postCode: '3851', suburb: 'GOLDEN BEACH', state: 'VIC' },
  { postCode: '3851', suburb: 'KILMANY', state: 'VIC' },
  { postCode: '3851', suburb: 'LAKE WELLINGTON', state: 'VIC' },
  { postCode: '3851', suburb: 'LOCH SPORT', state: 'VIC' },
  { postCode: '3851', suburb: 'LONGFORD', state: 'VIC' },
  { postCode: '3851', suburb: 'MONTGOMERY', state: 'VIC' },
  { postCode: '3851', suburb: 'MYRTLEBANK', state: 'VIC' },
  { postCode: '3851', suburb: 'PARADISE BEACH', state: 'VIC' },
  { postCode: '3851', suburb: 'PEARSONDALE', state: 'VIC' },
  { postCode: '3851', suburb: 'SEACOMBE', state: 'VIC' },
  { postCode: '3851', suburb: 'SEASPRAY', state: 'VIC' },
  { postCode: '3851', suburb: 'SOMERTON PARK', state: 'VIC' },
  { postCode: '3851', suburb: 'STRADBROKE', state: 'VIC' },
  { postCode: '3851', suburb: 'THE HEART', state: 'VIC' },
  { postCode: '3851', suburb: 'THE HONEYSUCKLES', state: 'VIC' },
  { postCode: '3852', suburb: 'EAST SALE', state: 'VIC' },
  { postCode: '3852', suburb: 'SALE EAST RAAF', state: 'VIC' },
  { postCode: '3853', suburb: 'SALE', state: 'VIC' },
  { postCode: '3854', suburb: 'GLENGARRY', state: 'VIC' },
  { postCode: '3854', suburb: 'GLENGARRY NORTH', state: 'VIC' },
  { postCode: '3854', suburb: 'GLENGARRY WEST', state: 'VIC' },
  { postCode: '3856', suburb: 'TOONGABBIE', state: 'VIC' },
  { postCode: '3857', suburb: 'COWWARR', state: 'VIC' },
  { postCode: '3858', suburb: 'ARBUCKLE', state: 'VIC' },
  { postCode: '3858', suburb: 'BILLABONG', state: 'VIC' },
  { postCode: '3858', suburb: 'BURAGWONDUC', state: 'VIC' },
  { postCode: '3858', suburb: 'CROOKAYAN', state: 'VIC' },
  { postCode: '3858', suburb: 'DAWSON', state: 'VIC' },
  { postCode: '3858', suburb: 'DENISON', state: 'VIC' },
  { postCode: '3858', suburb: 'GILLUM', state: 'VIC' },
  { postCode: '3858', suburb: 'GLENFALLOCH', state: 'VIC' },
  { postCode: '3858', suburb: 'GLENMAGGIE', state: 'VIC' },
  { postCode: '3858', suburb: 'HEYFIELD', state: 'VIC' },
  { postCode: '3858', suburb: 'HOWITT PLAINS', state: 'VIC' },
  { postCode: '3858', suburb: 'LICOLA', state: 'VIC' },
  { postCode: '3858', suburb: 'LICOLA NORTH', state: 'VIC' },
  { postCode: '3858', suburb: 'REYNARD', state: 'VIC' },
  { postCode: '3858', suburb: 'SARGOOD', state: 'VIC' },
  { postCode: '3858', suburb: 'SEATON', state: 'VIC' },
  { postCode: '3858', suburb: 'TAMBORITHA', state: 'VIC' },
  { postCode: '3858', suburb: 'WINNINDOO', state: 'VIC' },
  { postCode: '3858', suburb: 'WORROWING', state: 'VIC' },
  { postCode: '3858', suburb: 'YANGOURA', state: 'VIC' },
  { postCode: '3859', suburb: 'MAFFRA WEST UPPER', state: 'VIC' },
  { postCode: '3859', suburb: 'NEWRY', state: 'VIC' },
  { postCode: '3859', suburb: 'TINAMBA', state: 'VIC' },
  { postCode: '3859', suburb: 'TINAMBA WEST', state: 'VIC' },
  { postCode: '3860', suburb: 'BOISDALE', state: 'VIC' },
  { postCode: '3860', suburb: 'BRIAGOLONG', state: 'VIC' },
  { postCode: '3860', suburb: 'BUSHY PARK', state: 'VIC' },
  { postCode: '3860', suburb: 'COONGULLA', state: 'VIC' },
  { postCode: '3860', suburb: 'KOOROOL', state: 'VIC' },
  { postCode: '3860', suburb: 'MAFFRA', state: 'VIC' },
  { postCode: '3860', suburb: 'MONOMAK', state: 'VIC' },
  { postCode: '3860', suburb: 'MOROKA', state: 'VIC' },
  { postCode: '3860', suburb: 'NAP NAP MARRA', state: 'VIC' },
  { postCode: '3860', suburb: 'RIVERSLEA', state: 'VIC' },
  { postCode: '3860', suburb: 'TOOLOME', state: 'VIC' },
  { postCode: '3860', suburb: 'VALENCIA CREEK', state: 'VIC' },
  { postCode: '3860', suburb: 'WOOLENOOK', state: 'VIC' },
  { postCode: '3860', suburb: 'WRATHUNG', state: 'VIC' },
  { postCode: '3860', suburb: 'WRIXON', state: 'VIC' },
  { postCode: '3862', suburb: 'BUDGEE BUDGEE', state: 'VIC' },
  { postCode: '3862', suburb: 'COBBANNAH', state: 'VIC' },
  { postCode: '3862', suburb: 'COWA', state: 'VIC' },
  { postCode: '3862', suburb: 'CROOKED RIVER', state: 'VIC' },
  { postCode: '3862', suburb: 'DARGO', state: 'VIC' },
  { postCode: '3862', suburb: 'HAWKHURST', state: 'VIC' },
  { postCode: '3862', suburb: 'HOLLANDS LANDING', state: 'VIC' },
  { postCode: '3862', suburb: 'LLOWALONG', state: 'VIC' },
  { postCode: '3862', suburb: 'MEERLIEU', state: 'VIC' },
  { postCode: '3862', suburb: 'MIOWERA', state: 'VIC' },
  { postCode: '3862', suburb: 'MOORNAPA', state: 'VIC' },
  { postCode: '3862', suburb: 'MUNRO', state: 'VIC' },
  { postCode: '3862', suburb: 'PERRY BRIDGE', state: 'VIC' },
  { postCode: '3862', suburb: 'STOCKDALE', state: 'VIC' },
  { postCode: '3862', suburb: 'STRATFORD', state: 'VIC' },
  { postCode: '3862', suburb: 'WATERFORD', state: 'VIC' },
  { postCode: '3862', suburb: 'WONGUNGARRA', state: 'VIC' },
  { postCode: '3864', suburb: 'FERNBANK', state: 'VIC' },
  { postCode: '3864', suburb: 'GLENALADALE', state: 'VIC' },
  { postCode: '3865', suburb: 'LINDENOW', state: 'VIC' },
  { postCode: '3869', suburb: 'JUMBUK', state: 'VIC' },
  { postCode: '3869', suburb: 'YINNAR', state: 'VIC' },
  { postCode: '3869', suburb: 'YINNAR SOUTH', state: 'VIC' },
  { postCode: '3870', suburb: 'BOOLARRA', state: 'VIC' },
  { postCode: '3870', suburb: 'BOOLARRA SOUTH', state: 'VIC' },
  { postCode: '3870', suburb: 'BUDGEREE', state: 'VIC' },
  { postCode: '3870', suburb: 'GRAND RIDGE', state: 'VIC' },
  { postCode: '3870', suburb: 'JOHNSTONES HILL', state: 'VIC' },
  { postCode: '3871', suburb: 'ALLAMBEE RESERVE', state: 'VIC' },
  { postCode: '3871', suburb: 'ALLAMBEE SOUTH', state: 'VIC' },
  { postCode: '3871', suburb: 'BAROMI', state: 'VIC' },
  { postCode: '3871', suburb: 'DARLIMURLA', state: 'VIC' },
  { postCode: '3871', suburb: 'DELBURN', state: 'VIC' },
  { postCode: '3871', suburb: 'DOLLAR', state: 'VIC' },
  { postCode: '3871', suburb: 'MIRBOO', state: 'VIC' },
  { postCode: '3871', suburb: 'MIRBOO NORTH', state: 'VIC' },
  { postCode: '3873', suburb: 'GORMANDALE', state: 'VIC' },
  { postCode: '3874', suburb: 'MCLOUGHLINS BEACH', state: 'VIC' },
  { postCode: '3874', suburb: 'WOODSIDE', state: 'VIC' },
  { postCode: '3874', suburb: 'WOODSIDE BEACH', state: 'VIC' },
  { postCode: '3874', suburb: 'WOODSIDE NORTH', state: 'VIC' },
  { postCode: '3875', suburb: 'BAIRNSDALE', state: 'VIC' },
  { postCode: '3875', suburb: 'BANKSIA PENINSULA', state: 'VIC' },
  { postCode: '3875', suburb: 'BENGWORDEN', state: 'VIC' },
  { postCode: '3875', suburb: 'BROADLANDS', state: 'VIC' },
  { postCode: '3875', suburb: 'BULLUMWAAL', state: 'VIC' },
  { postCode: '3875', suburb: 'CALULU', state: 'VIC' },
  { postCode: '3875', suburb: 'CLIFTON CREEK', state: 'VIC' },
  { postCode: '3875', suburb: 'DEPTFORD', state: 'VIC' },
  { postCode: '3875', suburb: 'EAST BAIRNSDALE', state: 'VIC' },
  { postCode: '3875', suburb: 'EASTWOOD', state: 'VIC' },
  { postCode: '3875', suburb: 'ELLASWOOD', state: 'VIC' },
  { postCode: '3875', suburb: 'FAIRY DELL', state: 'VIC' },
  { postCode: '3875', suburb: 'FLAGGY CREEK', state: 'VIC' },
  { postCode: '3875', suburb: 'FORGE CREEK', state: 'VIC' },
  { postCode: '3875', suburb: 'GOON NURE', state: 'VIC' },
  { postCode: '3875', suburb: 'GRANITE ROCK', state: 'VIC' },
  { postCode: '3875', suburb: 'HILLSIDE', state: 'VIC' },
  { postCode: '3875', suburb: 'IGUANA CREEK', state: 'VIC' },
  { postCode: '3875', suburb: 'LINDENOW SOUTH', state: 'VIC' },
  { postCode: '3875', suburb: 'LUCKNOW', state: 'VIC' },
  { postCode: '3875', suburb: 'MARTHAVALE', state: 'VIC' },
  { postCode: '3875', suburb: 'MELWOOD', state: 'VIC' },
  { postCode: '3875', suburb: 'MERRIJIG', state: 'VIC' },
  { postCode: '3875', suburb: 'MOUNT TAYLOR', state: 'VIC' },
  { postCode: '3875', suburb: 'NEWLANDS ARM', state: 'VIC' },
  { postCode: '3875', suburb: 'RYANS', state: 'VIC' },
  { postCode: '3875', suburb: 'SARSFIELD', state: 'VIC' },
  { postCode: '3875', suburb: 'TABBERABBERA', state: 'VIC' },
  { postCode: '3875', suburb: 'WALPA', state: 'VIC' },
  { postCode: '3875', suburb: 'WATERHOLES', state: 'VIC' },
  { postCode: '3875', suburb: 'WENTWORTH', state: 'VIC' },
  { postCode: '3875', suburb: 'WOODGLEN', state: 'VIC' },
  { postCode: '3875', suburb: 'WUK WUK', state: 'VIC' },
  { postCode: '3875', suburb: 'WY YUNG', state: 'VIC' },
  { postCode: '3878', suburb: 'EAGLE POINT', state: 'VIC' },
  { postCode: '3880', suburb: 'BOOLE POOLE', state: 'VIC' },
  { postCode: '3880', suburb: 'OCEAN GRANGE', state: 'VIC' },
  { postCode: '3880', suburb: 'PAYNESVILLE', state: 'VIC' },
  { postCode: '3880', suburb: 'RAYMOND ISLAND', state: 'VIC' },
  { postCode: '3882', suburb: 'NICHOLSON', state: 'VIC' },
  { postCode: '3885', suburb: 'BRUMBY', state: 'VIC' },
  { postCode: '3885', suburb: 'BRUTHEN', state: 'VIC' },
  { postCode: '3885', suburb: 'BUCHAN', state: 'VIC' },
  { postCode: '3885', suburb: 'BUCHAN SOUTH', state: 'VIC' },
  { postCode: '3885', suburb: 'BUTCHERS RIDGE', state: 'VIC' },
  { postCode: '3885', suburb: 'GELANTIPY', state: 'VIC' },
  { postCode: '3885', suburb: 'MOSSIFACE', state: 'VIC' },
  { postCode: '3885', suburb: 'MURRINDAL', state: 'VIC' },
  { postCode: '3885', suburb: 'SUGGAN BUGGAN', state: 'VIC' },
  { postCode: '3885', suburb: 'TAMBO UPPER', state: 'VIC' },
  { postCode: '3885', suburb: 'TIMBARRA', state: 'VIC' },
  { postCode: '3885', suburb: 'W TREE', state: 'VIC' },
  { postCode: '3885', suburb: 'WISELEIGH', state: 'VIC' },
  { postCode: '3885', suburb: 'WULGULMERANG', state: 'VIC' },
  { postCode: '3885', suburb: 'WULGULMERANG EAST', state: 'VIC' },
  { postCode: '3885', suburb: 'WULGULMERANG WEST', state: 'VIC' },
  { postCode: '3885', suburb: 'YALMY', state: 'VIC' },
  { postCode: '3886', suburb: 'NEWMERELLA', state: 'VIC' },
  { postCode: '3887', suburb: 'LAKE TYERS', state: 'VIC' },
  { postCode: '3887', suburb: 'NOWA NOWA', state: 'VIC' },
  { postCode: '3887', suburb: 'WAIREWA', state: 'VIC' },
  { postCode: '3888', suburb: 'BENDOC', state: 'VIC' },
  { postCode: '3888', suburb: 'BETE BOLONG', state: 'VIC' },
  { postCode: '3888', suburb: 'BETE BOLONG NORTH', state: 'VIC' },
  { postCode: '3888', suburb: 'BONANG', state: 'VIC' },
  { postCode: '3888', suburb: 'BRODRIBB RIVER', state: 'VIC' },
  { postCode: '3888', suburb: 'CAPE CONRAN', state: 'VIC' },
  { postCode: '3888', suburb: 'CORRINGLE', state: 'VIC' },
  { postCode: '3888', suburb: 'DEDDICK VALLEY', state: 'VIC' },
  { postCode: '3888', suburb: 'DELEGATE RIVER', state: 'VIC' },
  { postCode: '3888', suburb: 'GOONGERAH', state: 'VIC' },
  { postCode: '3888', suburb: 'HAYDENS BOG', state: 'VIC' },
  { postCode: '3888', suburb: 'JARRAHMOND', state: 'VIC' },
  { postCode: '3888', suburb: 'MARLO', state: 'VIC' },
  { postCode: '3888', suburb: 'NURRAN', state: 'VIC' },
  { postCode: '3888', suburb: 'ORBOST', state: 'VIC' },
  { postCode: '3888', suburb: 'SIMPSONS CREEK', state: 'VIC' },
  { postCode: '3888', suburb: 'TOSTAREE', state: 'VIC' },
  { postCode: '3888', suburb: 'TUBBUT', state: 'VIC' },
  { postCode: '3888', suburb: 'WAYGARA', state: 'VIC' },
  { postCode: '3888', suburb: 'WOMBAT CREEK', state: 'VIC' },
  { postCode: '3889', suburb: 'BELLBIRD CREEK', state: 'VIC' },
  { postCode: '3889', suburb: 'BEMM RIVER', state: 'VIC' },
  { postCode: '3889', suburb: 'CABBAGE TREE CREEK', state: 'VIC' },
  { postCode: '3889', suburb: 'CLUB TERRACE', state: 'VIC' },
  { postCode: '3889', suburb: 'COMBIENBAR', state: 'VIC' },
  { postCode: '3889', suburb: 'ERRINUNDRA', state: 'VIC' },
  { postCode: '3889', suburb: 'MANORINA', state: 'VIC' },
  { postCode: '3890', suburb: 'BULDAH', state: 'VIC' },
  { postCode: '3890', suburb: 'CANN RIVER', state: 'VIC' },
  { postCode: '3890', suburb: 'CHANDLERS CREEK', state: 'VIC' },
  { postCode: '3890', suburb: 'NOORINBEE', state: 'VIC' },
  { postCode: '3890', suburb: 'NOORINBEE NORTH', state: 'VIC' },
  { postCode: '3890', suburb: 'TAMBOON', state: 'VIC' },
  { postCode: '3890', suburb: 'TONGHI CREEK', state: 'VIC' },
  { postCode: '3891', suburb: 'GENOA', state: 'VIC' },
  { postCode: '3891', suburb: 'GIPSY POINT', state: 'VIC' },
  { postCode: '3891', suburb: 'MARAMINGO CREEK', state: 'VIC' },
  { postCode: '3891', suburb: 'WALLAGARAUGH', state: 'VIC' },
  { postCode: '3891', suburb: 'WANGARABELL', state: 'VIC' },
  { postCode: '3891', suburb: 'WINGAN RIVER', state: 'VIC' },
  { postCode: '3891', suburb: 'WROXHAM', state: 'VIC' },
  { postCode: '3892', suburb: 'MALLACOOTA', state: 'VIC' },
  { postCode: '3893', suburb: 'DOUBLE BRIDGES', state: 'VIC' },
  { postCode: '3893', suburb: 'STIRLING', state: 'VIC' },
  { postCode: '3893', suburb: 'TAMBO CROSSING', state: 'VIC' },
  { postCode: '3895', suburb: 'DOCTORS FLAT', state: 'VIC' },
  { postCode: '3895', suburb: 'ENSAY', state: 'VIC' },
  { postCode: '3895', suburb: 'ENSAY NORTH', state: 'VIC' },
  { postCode: '3895', suburb: 'REEDY FLAT', state: 'VIC' },
  { postCode: '3896', suburb: 'BINDI', state: 'VIC' },
  { postCode: '3896', suburb: 'BROOKVILLE', state: 'VIC' },
  { postCode: '3896', suburb: 'NUNNIONG', state: 'VIC' },
  { postCode: '3896', suburb: 'SWIFTS CREEK', state: 'VIC' },
  { postCode: '3896', suburb: 'TONGIO', state: 'VIC' },
  { postCode: '3898', suburb: 'ANGLERS REST', state: 'VIC' },
  { postCode: '3898', suburb: 'BINGO MUNJIE', state: 'VIC' },
  { postCode: '3898', suburb: 'BUNDARA', state: 'VIC' },
  { postCode: '3898', suburb: 'CASSILIS', state: 'VIC' },
  { postCode: '3898', suburb: 'COBUNGRA', state: 'VIC' },
  { postCode: '3898', suburb: 'DINNER PLAIN', state: 'VIC' },
  { postCode: '3898', suburb: 'GLEN VALLEY', state: 'VIC' },
  { postCode: '3898', suburb: 'GLEN WILLS', state: 'VIC' },
  { postCode: '3898', suburb: 'HINNOMUNJIE', state: 'VIC' },
  { postCode: '3898', suburb: 'OMEO', state: 'VIC' },
  { postCode: '3898', suburb: 'OMEO VALLEY', state: 'VIC' },
  { postCode: '3898', suburb: 'SHANNONVALE', state: 'VIC' },
  { postCode: '3900', suburb: 'BENAMBRA', state: 'VIC' },
  { postCode: '3900', suburb: 'COBBERAS', state: 'VIC' },
  { postCode: '3902', suburb: 'BUMBERRAH', state: 'VIC' },
  { postCode: '3902', suburb: 'JOHNSONVILLE', state: 'VIC' },
  { postCode: '3903', suburb: 'SWAN REACH', state: 'VIC' },
  { postCode: '3904', suburb: 'METUNG', state: 'VIC' },
  { postCode: '3909', suburb: 'KALIMNA', state: 'VIC' },
  { postCode: '3909', suburb: 'KALIMNA WEST', state: 'VIC' },
  { postCode: '3909', suburb: 'LAKE BUNGA', state: 'VIC' },
  { postCode: '3909', suburb: 'LAKE TYERS BEACH', state: 'VIC' },
  { postCode: '3909', suburb: 'LAKES ENTRANCE', state: 'VIC' },
  { postCode: '3909', suburb: 'NUNGURNER', state: 'VIC' },
  { postCode: '3909', suburb: 'NYERIMILANG', state: 'VIC' },
  { postCode: '3909', suburb: 'TOORLOO ARM', state: 'VIC' },
  { postCode: '3910', suburb: 'LANGWARRIN', state: 'VIC' },
  { postCode: '3911', suburb: 'BAXTER', state: 'VIC' },
  { postCode: '3911', suburb: 'LANGWARRIN SOUTH', state: 'VIC' },
  { postCode: '3912', suburb: 'PEARCEDALE', state: 'VIC' },
  { postCode: '3912', suburb: 'SOMERVILLE', state: 'VIC' },
  { postCode: '3913', suburb: 'TYABB', state: 'VIC' },
  { postCode: '3915', suburb: 'HASTINGS', state: 'VIC' },
  { postCode: '3915', suburb: 'TUERONG', state: 'VIC' },
  { postCode: '3916', suburb: 'MERRICKS', state: 'VIC' },
  { postCode: '3916', suburb: 'POINT LEO', state: 'VIC' },
  { postCode: '3916', suburb: 'SHOREHAM', state: 'VIC' },
  { postCode: '3918', suburb: 'BITTERN', state: 'VIC' },
  { postCode: '3919', suburb: 'CRIB POINT', state: 'VIC' },
  { postCode: '3920', suburb: 'HMAS CERBERUS', state: 'VIC' },
  { postCode: '3921', suburb: 'ELIZABETH ISLAND', state: 'VIC' },
  { postCode: '3921', suburb: 'FRENCH ISLAND', state: 'VIC' },
  { postCode: '3922', suburb: 'COWES', state: 'VIC' },
  { postCode: '3922', suburb: 'SILVERLEAVES', state: 'VIC' },
  { postCode: '3922', suburb: 'SMITHS BEACH', state: 'VIC' },
  { postCode: '3922', suburb: 'SUMMERLANDS', state: 'VIC' },
  { postCode: '3922', suburb: 'SUNDERLAND BAY', state: 'VIC' },
  { postCode: '3922', suburb: 'SUNSET STRIP', state: 'VIC' },
  { postCode: '3922', suburb: 'SURF BEACH', state: 'VIC' },
  { postCode: '3922', suburb: 'VENTNOR', state: 'VIC' },
  { postCode: '3922', suburb: 'WIMBLEDON HEIGHTS', state: 'VIC' },
  { postCode: '3923', suburb: 'RHYLL', state: 'VIC' },
  { postCode: '3925', suburb: 'CAPE WOOLAMAI', state: 'VIC' },
  { postCode: '3925', suburb: 'CHURCHILL ISLAND', state: 'VIC' },
  { postCode: '3925', suburb: 'NEWHAVEN', state: 'VIC' },
  { postCode: '3925', suburb: 'SAN REMO', state: 'VIC' },
  { postCode: '3926', suburb: 'BALNARRING', state: 'VIC' },
  { postCode: '3926', suburb: 'BALNARRING BEACH', state: 'VIC' },
  { postCode: '3926', suburb: 'MERRICKS BEACH', state: 'VIC' },
  { postCode: '3926', suburb: 'MERRICKS NORTH', state: 'VIC' },
  { postCode: '3927', suburb: 'SOMERS', state: 'VIC' },
  { postCode: '3928', suburb: 'MAIN RIDGE', state: 'VIC' },
  { postCode: '3929', suburb: 'FLINDERS', state: 'VIC' },
  { postCode: '3930', suburb: 'KUNYUNG', state: 'VIC' },
  { postCode: '3930', suburb: 'MOUNT ELIZA', state: 'VIC' },
  { postCode: '3931', suburb: 'MORNINGTON', state: 'VIC' },
  { postCode: '3933', suburb: 'MOOROODUC', state: 'VIC' },
  { postCode: '3934', suburb: 'MOUNT MARTHA', state: 'VIC' },
  { postCode: '3936', suburb: 'ARTHURS SEAT', state: 'VIC' },
  { postCode: '3936', suburb: 'DROMANA', state: 'VIC' },
  { postCode: '3936', suburb: 'SAFETY BEACH', state: 'VIC' },
  { postCode: '3937', suburb: 'RED HILL', state: 'VIC' },
  { postCode: '3937', suburb: 'RED HILL SOUTH', state: 'VIC' },
  { postCode: '3938', suburb: 'MCCRAE', state: 'VIC' },
  { postCode: '3939', suburb: 'BONEO', state: 'VIC' },
  { postCode: '3939', suburb: 'CAPE SCHANCK', state: 'VIC' },
  { postCode: '3939', suburb: 'FINGAL', state: 'VIC' },
  { postCode: '3939', suburb: 'ROSEBUD', state: 'VIC' },
  { postCode: '3939', suburb: 'ROSEBUD PLAZA', state: 'VIC' },
  { postCode: '3940', suburb: 'CAPEL SOUND', state: 'VIC' },
  { postCode: '3941', suburb: 'RYE', state: 'VIC' },
  { postCode: '3941', suburb: 'ST ANDREWS BEACH', state: 'VIC' },
  { postCode: '3941', suburb: 'TOOTGAROOK', state: 'VIC' },
  { postCode: '3942', suburb: 'BLAIRGOWRIE', state: 'VIC' },
  { postCode: '3943', suburb: 'SORRENTO', state: 'VIC' },
  { postCode: '3944', suburb: 'PORTSEA', state: 'VIC' },
  { postCode: '3945', suburb: 'JEETHO', state: 'VIC' },
  { postCode: '3945', suburb: 'KROWERA', state: 'VIC' },
  { postCode: '3945', suburb: 'LOCH', state: 'VIC' },
  { postCode: '3945', suburb: 'WOODLEIGH', state: 'VIC' },
  { postCode: '3946', suburb: 'BENA', state: 'VIC' },
  { postCode: '3950', suburb: 'KARDELLA SOUTH', state: 'VIC' },
  { postCode: '3950', suburb: 'KORUMBURRA', state: 'VIC' },
  { postCode: '3950', suburb: 'KORUMBURRA SOUTH', state: 'VIC' },
  { postCode: '3950', suburb: 'STRZELECKI', state: 'VIC' },
  { postCode: '3950', suburb: 'WHITELAW', state: 'VIC' },
  { postCode: '3951', suburb: 'ARAWATA', state: 'VIC' },
  { postCode: '3951', suburb: 'FAIRBANK', state: 'VIC' },
  { postCode: '3951', suburb: 'JUMBUNNA', state: 'VIC' },
  { postCode: '3951', suburb: 'KARDELLA', state: 'VIC' },
  { postCode: '3951', suburb: 'KONGWAK', state: 'VIC' },
  { postCode: '3951', suburb: 'MOYARRA', state: 'VIC' },
  { postCode: '3951', suburb: 'OUTTRIM', state: 'VIC' },
  { postCode: '3951', suburb: 'RANCEBY', state: 'VIC' },
  { postCode: '3953', suburb: 'BERRYS CREEK', state: 'VIC' },
  { postCode: '3953', suburb: 'BOOROOL', state: 'VIC' },
  { postCode: '3953', suburb: 'HALLSTON', state: 'VIC' },
  { postCode: '3953', suburb: 'KOOROOMAN', state: 'VIC' },
  { postCode: '3953', suburb: 'LEONGATHA', state: 'VIC' },
  { postCode: '3953', suburb: 'LEONGATHA NORTH', state: 'VIC' },
  { postCode: '3953', suburb: 'LEONGATHA SOUTH', state: 'VIC' },
  { postCode: '3953', suburb: 'MARDAN', state: 'VIC' },
  { postCode: '3953', suburb: 'MOUNT ECCLES', state: 'VIC' },
  { postCode: '3953', suburb: 'MOUNT ECCLES SOUTH', state: 'VIC' },
  { postCode: '3953', suburb: 'NERRENA', state: 'VIC' },
  { postCode: '3953', suburb: 'RUBY', state: 'VIC' },
  { postCode: '3953', suburb: 'TRIDA', state: 'VIC' },
  { postCode: '3953', suburb: 'WILD DOG VALLEY', state: 'VIC' },
  { postCode: '3953', suburb: 'WOOREEN', state: 'VIC' },
  { postCode: '3954', suburb: 'KOONWARRA', state: 'VIC' },
  { postCode: '3956', suburb: 'DUMBALK', state: 'VIC' },
  { postCode: '3956', suburb: 'DUMBALK NORTH', state: 'VIC' },
  { postCode: '3956', suburb: 'MEENIYAN', state: 'VIC' },
  { postCode: '3956', suburb: 'MIDDLE TARWIN', state: 'VIC' },
  { postCode: '3956', suburb: 'TARWIN', state: 'VIC' },
  { postCode: '3956', suburb: 'TARWIN LOWER', state: 'VIC' },
  { postCode: '3956', suburb: 'VENUS BAY', state: 'VIC' },
  { postCode: '3956', suburb: 'WALKERVILLE', state: 'VIC' },
  { postCode: '3956', suburb: 'WALKERVILLE NORTH', state: 'VIC' },
  { postCode: '3956', suburb: 'WALKERVILLE SOUTH', state: 'VIC' },
  { postCode: '3957', suburb: 'STONY CREEK', state: 'VIC' },
  { postCode: '3958', suburb: 'BUFFALO', state: 'VIC' },
  { postCode: '3959', suburb: 'FISH CREEK', state: 'VIC' },
  { postCode: '3959', suburb: 'SANDY POINT', state: 'VIC' },
  { postCode: '3959', suburb: 'WARATAH BAY', state: 'VIC' },
  { postCode: '3960', suburb: 'BENNISON', state: 'VIC' },
  { postCode: '3960', suburb: 'BOOLARONG', state: 'VIC' },
  { postCode: '3960', suburb: 'FOSTER', state: 'VIC' },
  { postCode: '3960', suburb: 'FOSTER NORTH', state: 'VIC' },
  { postCode: '3960', suburb: 'GUNYAH', state: 'VIC' },
  { postCode: '3960', suburb: 'MOUNT BEST', state: 'VIC' },
  { postCode: '3960', suburb: 'SHALLOW INLET', state: 'VIC' },
  { postCode: '3960', suburb: 'TIDAL RIVER', state: 'VIC' },
  { postCode: '3960', suburb: 'TURTONS CREEK', state: 'VIC' },
  { postCode: '3960', suburb: 'WILSONS PROMONTORY', state: 'VIC' },
  { postCode: '3960', suburb: 'WONGA', state: 'VIC' },
  { postCode: '3960', suburb: 'WOORARRA WEST', state: 'VIC' },
  { postCode: '3960', suburb: 'YANAKIE', state: 'VIC' },
  { postCode: '3962', suburb: 'AGNES', state: 'VIC' },
  { postCode: '3962', suburb: 'TOORA', state: 'VIC' },
  { postCode: '3962', suburb: 'TOORA NORTH', state: 'VIC' },
  { postCode: '3962', suburb: 'WONYIP', state: 'VIC' },
  { postCode: '3962', suburb: 'WOORARRA EAST', state: 'VIC' },
  { postCode: '3964', suburb: 'PORT FRANKLIN', state: 'VIC' },
  { postCode: '3965', suburb: 'PORT WELSHPOOL', state: 'VIC' },
  { postCode: '3966', suburb: 'BINGINWARRI', state: 'VIC' },
  { postCode: '3966', suburb: 'HAZEL PARK', state: 'VIC' },
  { postCode: '3966', suburb: 'WELSHPOOL', state: 'VIC' },
  { postCode: '3967', suburb: 'HEDLEY', state: 'VIC' },
  { postCode: '3971', suburb: 'ALBERTON', state: 'VIC' },
  { postCode: '3971', suburb: 'ALBERTON WEST', state: 'VIC' },
  { postCode: '3971', suburb: 'BALOOK', state: 'VIC' },
  { postCode: '3971', suburb: 'CALROSSIE', state: 'VIC' },
  { postCode: '3971', suburb: 'DEVON NORTH', state: 'VIC' },
  { postCode: '3971', suburb: 'GELLIONDALE', state: 'VIC' },
  { postCode: '3971', suburb: 'HIAWATHA', state: 'VIC' },
  { postCode: '3971', suburb: 'HUNTERSTON', state: 'VIC' },
  { postCode: '3971', suburb: 'JACK RIVER', state: 'VIC' },
  { postCode: '3971', suburb: 'LANGSBOROUGH', state: 'VIC' },
  { postCode: '3971', suburb: 'MACKS CREEK', state: 'VIC' },
  { postCode: '3971', suburb: 'MADALYA', state: 'VIC' },
  { postCode: '3971', suburb: 'MANNS BEACH', state: 'VIC' },
  { postCode: '3971', suburb: 'PORT ALBERT', state: 'VIC' },
  { postCode: '3971', suburb: 'ROBERTSONS BEACH', state: 'VIC' },
  { postCode: '3971', suburb: 'SNAKE ISLAND', state: 'VIC' },
  { postCode: '3971', suburb: 'STACEYS BRIDGE', state: 'VIC' },
  { postCode: '3971', suburb: 'TARRA VALLEY', state: 'VIC' },
  { postCode: '3971', suburb: 'TARRAVILLE', state: 'VIC' },
  { postCode: '3971', suburb: 'WON WRON', state: 'VIC' },
  { postCode: '3971', suburb: 'YARRAM', state: 'VIC' },
  { postCode: '3975', suburb: 'LYNBROOK', state: 'VIC' },
  { postCode: '3975', suburb: 'LYNDHURST', state: 'VIC' },
  { postCode: '3976', suburb: 'HAMPTON PARK', state: 'VIC' },
  { postCode: '3977', suburb: 'BOTANIC RIDGE', state: 'VIC' },
  { postCode: '3977', suburb: 'CANNONS CREEK', state: 'VIC' },
  { postCode: '3977', suburb: 'CRANBOURNE', state: 'VIC' },
  { postCode: '3977', suburb: 'CRANBOURNE EAST', state: 'VIC' },
  { postCode: '3977', suburb: 'CRANBOURNE NORTH', state: 'VIC' },
  { postCode: '3977', suburb: 'CRANBOURNE SOUTH', state: 'VIC' },
  { postCode: '3977', suburb: 'CRANBOURNE WEST', state: 'VIC' },
  { postCode: '3977', suburb: 'DEVON MEADOWS', state: 'VIC' },
  { postCode: '3977', suburb: 'JUNCTION VILLAGE', state: 'VIC' },
  { postCode: '3977', suburb: 'SANDHURST', state: 'VIC' },
  { postCode: '3977', suburb: 'SKYE', state: 'VIC' },
  { postCode: '3978', suburb: 'CARDINIA', state: 'VIC' },
  { postCode: '3978', suburb: 'CLYDE', state: 'VIC' },
  { postCode: '3978', suburb: 'CLYDE NORTH', state: 'VIC' },
  { postCode: '3979', suburb: 'ALMURTA', state: 'VIC' },
  { postCode: '3979', suburb: 'GLEN ALVIE', state: 'VIC' },
  { postCode: '3979', suburb: 'KERNOT', state: 'VIC' },
  { postCode: '3980', suburb: 'BLIND BIGHT', state: 'VIC' },
  { postCode: '3980', suburb: 'TOORADIN', state: 'VIC' },
  { postCode: '3980', suburb: 'WARNEET', state: 'VIC' },
  { postCode: '3981', suburb: 'BAYLES', state: 'VIC' },
  { postCode: '3981', suburb: 'CATANI', state: 'VIC' },
  { postCode: '3981', suburb: 'DALMORE', state: 'VIC' },
  { postCode: '3981', suburb: 'HEATH HILL', state: 'VIC' },
  { postCode: '3981', suburb: 'KOO WEE RUP', state: 'VIC' },
  { postCode: '3981', suburb: 'KOO WEE RUP NORTH', state: 'VIC' },
  { postCode: '3981', suburb: 'YANNATHAN', state: 'VIC' },
  { postCode: '3984', suburb: 'ADAMS ESTATE', state: 'VIC' },
  { postCode: '3984', suburb: 'CALDERMEADE', state: 'VIC' },
  { postCode: '3984', suburb: 'CORINELLA', state: 'VIC' },
  { postCode: '3984', suburb: 'CORONET BAY', state: 'VIC' },
  { postCode: '3984', suburb: 'GRANTVILLE', state: 'VIC' },
  { postCode: '3984', suburb: 'JAM JERRUP', state: 'VIC' },
  { postCode: '3984', suburb: 'LANG LANG', state: 'VIC' },
  { postCode: '3984', suburb: 'LANG LANG EAST', state: 'VIC' },
  { postCode: '3984', suburb: 'MONOMEITH', state: 'VIC' },
  { postCode: '3984', suburb: 'PIONEER BAY', state: 'VIC' },
  { postCode: '3984', suburb: 'QUEENSFERRY', state: 'VIC' },
  { postCode: '3984', suburb: 'TENBY POINT', state: 'VIC' },
  { postCode: '3984', suburb: 'THE GURDIES', state: 'VIC' },
  { postCode: '3987', suburb: 'NYORA', state: 'VIC' },
  { postCode: '3988', suburb: 'MOUNTAIN VIEW', state: 'VIC' },
  { postCode: '3988', suburb: 'POOWONG', state: 'VIC' },
  { postCode: '3988', suburb: 'POOWONG EAST', state: 'VIC' },
  { postCode: '3988', suburb: 'POOWONG NORTH', state: 'VIC' },
  { postCode: '3990', suburb: 'GLEN FORBES', state: 'VIC' },
  { postCode: '3991', suburb: 'BASS', state: 'VIC' },
  { postCode: '3992', suburb: 'BLACKWOOD FOREST', state: 'VIC' },
  { postCode: '3992', suburb: 'DALYSTON', state: 'VIC' },
  { postCode: '3992', suburb: 'RYANSTON', state: 'VIC' },
  { postCode: '3992', suburb: 'WEST CREEK', state: 'VIC' },
  { postCode: '3995', suburb: 'ANDERSON', state: 'VIC' },
  { postCode: '3995', suburb: 'ARCHIES CREEK', state: 'VIC' },
  { postCode: '3995', suburb: 'CAPE PATERSON', state: 'VIC' },
  { postCode: '3995', suburb: 'HARMERS HAVEN', state: 'VIC' },
  { postCode: '3995', suburb: 'KILCUNDA', state: 'VIC' },
  { postCode: '3995', suburb: 'LANCE CREEK', state: 'VIC' },
  { postCode: '3995', suburb: 'NORTH WONTHAGGI', state: 'VIC' },
  { postCode: '3995', suburb: 'SOUTH DUDLEY', state: 'VIC' },
  { postCode: '3995', suburb: 'ST CLAIR', state: 'VIC' },
  { postCode: '3995', suburb: 'WATTLE BANK', state: 'VIC' },
  { postCode: '3995', suburb: 'WONTHAGGI', state: 'VIC' },
  { postCode: '3995', suburb: 'WOOLAMAI', state: 'VIC' },
  { postCode: '3996', suburb: 'INVERLOCH', state: 'VIC' },
  { postCode: '3996', suburb: 'POUND CREEK', state: 'VIC' },
  { postCode: '4000', suburb: 'BRISBANE ADELAIDE STREET', state: 'QLD' },
  { postCode: '4000', suburb: 'BRISBANE CITY', state: 'QLD' },
  { postCode: '4000', suburb: 'BRISBANE GPO', state: 'QLD' },
  { postCode: '4000', suburb: 'PETRIE TERRACE', state: 'QLD' },
  { postCode: '4000', suburb: 'SPRING HILL', state: 'QLD' },
  { postCode: '4001', suburb: 'BRISBANE', state: 'QLD' },
  { postCode: '4002', suburb: 'CITY EAST', state: 'QLD' },
  { postCode: '4003', suburb: 'GEORGE STREET', state: 'QLD' },
  { postCode: '4004', suburb: 'SPRING HILL', state: 'QLD' },
  { postCode: '4005', suburb: 'NEW FARM', state: 'QLD' },
  { postCode: '4005', suburb: 'TENERIFFE', state: 'QLD' },
  { postCode: '4006', suburb: 'BOWEN HILLS', state: 'QLD' },
  { postCode: '4006', suburb: 'FORTITUDE VALLEY', state: 'QLD' },
  { postCode: '4006', suburb: 'FORTITUDE VALLEY BC', state: 'QLD' },
  { postCode: '4006', suburb: 'HERSTON', state: 'QLD' },
  { postCode: '4006', suburb: 'NEWSTEAD', state: 'QLD' },
  { postCode: '4007', suburb: 'ASCOT', state: 'QLD' },
  { postCode: '4007', suburb: 'HAMILTON', state: 'QLD' },
  { postCode: '4007', suburb: 'HAMILTON CENTRAL', state: 'QLD' },
  { postCode: '4008', suburb: 'BRISBANE AIRPORT', state: 'QLD' },
  { postCode: '4008', suburb: 'PINKENBA', state: 'QLD' },
  { postCode: '4009', suburb: 'EAGLE FARM', state: 'QLD' },
  { postCode: '4009', suburb: 'EAGLE FARM BC', state: 'QLD' },
  { postCode: '4010', suburb: 'ALBION', state: 'QLD' },
  { postCode: '4010', suburb: 'ALBION BC', state: 'QLD' },
  { postCode: '4010', suburb: 'ALBION DC', state: 'QLD' },
  { postCode: '4011', suburb: 'CLAYFIELD', state: 'QLD' },
  { postCode: '4011', suburb: 'HENDRA', state: 'QLD' },
  { postCode: '4012', suburb: 'NUNDAH', state: 'QLD' },
  { postCode: '4012', suburb: 'TOOMBUL', state: 'QLD' },
  { postCode: '4012', suburb: 'WAVELL HEIGHTS', state: 'QLD' },
  { postCode: '4012', suburb: 'WAVELL HEIGHTS NORTH', state: 'QLD' },
  { postCode: '4013', suburb: 'NORTHGATE', state: 'QLD' },
  { postCode: '4014', suburb: 'BANYO', state: 'QLD' },
  { postCode: '4014', suburb: 'NUDGEE', state: 'QLD' },
  { postCode: '4014', suburb: 'NUDGEE BEACH', state: 'QLD' },
  { postCode: '4014', suburb: 'VIRGINIA', state: 'QLD' },
  { postCode: '4014', suburb: 'VIRGINIA BC', state: 'QLD' },
  { postCode: '4014', suburb: 'VIRGINIA DC', state: 'QLD' },
  { postCode: '4017', suburb: 'BRACKEN RIDGE', state: 'QLD' },
  { postCode: '4017', suburb: 'BRIGHTON', state: 'QLD' },
  { postCode: '4017', suburb: 'BRIGHTON EVENTIDE', state: 'QLD' },
  { postCode: '4017', suburb: 'BRIGHTON NATHAN STREET', state: 'QLD' },
  { postCode: '4017', suburb: 'DEAGON', state: 'QLD' },
  { postCode: '4017', suburb: 'SANDGATE', state: 'QLD' },
  { postCode: '4017', suburb: 'SANDGATE DC', state: 'QLD' },
  { postCode: '4017', suburb: 'SHORNCLIFFE', state: 'QLD' },
  { postCode: '4018', suburb: 'FITZGIBBON', state: 'QLD' },
  { postCode: '4018', suburb: 'TAIGUM', state: 'QLD' },
  { postCode: '4019', suburb: 'CLONTARF', state: 'QLD' },
  { postCode: '4019', suburb: 'CLONTARF BEACH', state: 'QLD' },
  { postCode: '4019', suburb: 'CLONTARF DC', state: 'QLD' },
  { postCode: '4019', suburb: 'MARGATE', state: 'QLD' },
  { postCode: '4019', suburb: 'MARGATE BEACH', state: 'QLD' },
  { postCode: '4019', suburb: 'WOODY POINT', state: 'QLD' },
  { postCode: '4020', suburb: 'NEWPORT', state: 'QLD' },
  { postCode: '4020', suburb: 'REDCLIFFE', state: 'QLD' },
  { postCode: '4020', suburb: 'REDCLIFFE NORTH', state: 'QLD' },
  { postCode: '4020', suburb: 'SCARBOROUGH', state: 'QLD' },
  { postCode: '4021', suburb: 'KIPPA-RING', state: 'QLD' },
  { postCode: '4022', suburb: 'ROTHWELL', state: 'QLD' },
  { postCode: '4025', suburb: 'BULWER', state: 'QLD' },
  { postCode: '4025', suburb: 'COWAN COWAN', state: 'QLD' },
  { postCode: '4025', suburb: 'KOORINGAL', state: 'QLD' },
  { postCode: '4025', suburb: 'MORETON ISLAND', state: 'QLD' },
  { postCode: '4025', suburb: 'TANGALOOMA', state: 'QLD' },
  { postCode: '4029', suburb: 'ROYAL BRISBANE HOSPITAL', state: 'QLD' },
  { postCode: '4030', suburb: 'KALINGA', state: 'QLD' },
  { postCode: '4030', suburb: 'LUTWYCHE', state: 'QLD' },
  { postCode: '4030', suburb: 'WINDSOR', state: 'QLD' },
  { postCode: '4030', suburb: 'WOOLOOWIN', state: 'QLD' },
  { postCode: '4031', suburb: 'GORDON PARK', state: 'QLD' },
  { postCode: '4031', suburb: 'KEDRON', state: 'QLD' },
  { postCode: '4032', suburb: 'CHERMSIDE', state: 'QLD' },
  { postCode: '4032', suburb: 'CHERMSIDE CENTRE', state: 'QLD' },
  { postCode: '4032', suburb: 'CHERMSIDE SOUTH', state: 'QLD' },
  { postCode: '4032', suburb: 'CHERMSIDE WEST', state: 'QLD' },
  { postCode: '4034', suburb: 'ASPLEY', state: 'QLD' },
  { postCode: '4034', suburb: 'BOONDALL', state: 'QLD' },
  { postCode: '4034', suburb: 'CARSELDINE', state: 'QLD' },
  { postCode: '4034', suburb: 'GEEBUNG', state: 'QLD' },
  { postCode: '4034', suburb: 'ZILLMERE', state: 'QLD' },
  { postCode: '4035', suburb: 'ALBANY CREEK', state: 'QLD' },
  { postCode: '4035', suburb: 'BRIDGEMAN DOWNS', state: 'QLD' },
  { postCode: '4036', suburb: 'BALD HILLS', state: 'QLD' },
  { postCode: '4037', suburb: 'EATONS HILL', state: 'QLD' },
  { postCode: '4051', suburb: 'ALDERLEY', state: 'QLD' },
  { postCode: '4051', suburb: 'ENOGGERA', state: 'QLD' },
  { postCode: '4051', suburb: 'GAYTHORNE', state: 'QLD' },
  { postCode: '4051', suburb: 'GRANGE', state: 'QLD' },
  { postCode: '4051', suburb: 'NEWMARKET', state: 'QLD' },
  { postCode: '4051', suburb: 'WILSTON', state: 'QLD' },
  { postCode: '4053', suburb: 'BROOKSIDE CENTRE', state: 'QLD' },
  { postCode: '4053', suburb: 'EVERTON HILLS', state: 'QLD' },
  { postCode: '4053', suburb: 'EVERTON PARK', state: 'QLD' },
  { postCode: '4053', suburb: 'MCDOWALL', state: 'QLD' },
  { postCode: '4053', suburb: 'MITCHELTON', state: 'QLD' },
  { postCode: '4053', suburb: 'STAFFORD', state: 'QLD' },
  { postCode: '4053', suburb: 'STAFFORD DC', state: 'QLD' },
  { postCode: '4053', suburb: 'STAFFORD HEIGHTS', state: 'QLD' },
  { postCode: '4054', suburb: 'ARANA HILLS', state: 'QLD' },
  { postCode: '4054', suburb: 'KEPERRA', state: 'QLD' },
  { postCode: '4055', suburb: 'BUNYA', state: 'QLD' },
  { postCode: '4055', suburb: 'FERNY GROVE', state: 'QLD' },
  { postCode: '4055', suburb: 'FERNY HILLS', state: 'QLD' },
  { postCode: '4055', suburb: 'FERNY HILLS DC', state: 'QLD' },
  { postCode: '4055', suburb: 'UPPER KEDRON', state: 'QLD' },
  { postCode: '4059', suburb: 'KELVIN GROVE', state: 'QLD' },
  { postCode: '4059', suburb: 'KELVIN GROVE DC', state: 'QLD' },
  { postCode: '4059', suburb: 'RED HILL', state: 'QLD' },
  { postCode: '4060', suburb: 'ASHGROVE', state: 'QLD' },
  { postCode: '4060', suburb: 'ASHGROVE EAST', state: 'QLD' },
  { postCode: '4061', suburb: 'THE GAP', state: 'QLD' },
  { postCode: '4064', suburb: 'MILTON', state: 'QLD' },
  { postCode: '4064', suburb: 'MILTON BC', state: 'QLD' },
  { postCode: '4064', suburb: 'PADDINGTON', state: 'QLD' },
  { postCode: '4065', suburb: 'BARDON', state: 'QLD' },
  { postCode: '4066', suburb: 'AUCHENFLOWER', state: 'QLD' },
  { postCode: '4066', suburb: 'MOUNT COOT-THA', state: 'QLD' },
  { postCode: '4066', suburb: 'TOOWONG', state: 'QLD' },
  { postCode: '4066', suburb: 'TOOWONG BC', state: 'QLD' },
  { postCode: '4066', suburb: 'TOOWONG DC', state: 'QLD' },
  { postCode: '4067', suburb: 'ST LUCIA', state: 'QLD' },
  { postCode: '4067', suburb: 'ST LUCIA SOUTH', state: 'QLD' },
  { postCode: '4068', suburb: 'CHELMER', state: 'QLD' },
  { postCode: '4068', suburb: 'INDOOROOPILLY', state: 'QLD' },
  { postCode: '4068', suburb: 'INDOOROOPILLY CENTRE', state: 'QLD' },
  { postCode: '4068', suburb: 'TARINGA', state: 'QLD' },
  { postCode: '4069', suburb: 'BROOKFIELD', state: 'QLD' },
  { postCode: '4069', suburb: 'CHAPEL HILL', state: 'QLD' },
  { postCode: '4069', suburb: 'FIG TREE POCKET', state: 'QLD' },
  { postCode: '4069', suburb: 'KENMORE', state: 'QLD' },
  { postCode: '4069', suburb: 'KENMORE DC', state: 'QLD' },
  { postCode: '4069', suburb: 'KENMORE EAST', state: 'QLD' },
  { postCode: '4069', suburb: 'KENMORE HILLS', state: 'QLD' },
  { postCode: '4069', suburb: 'PINJARRA HILLS', state: 'QLD' },
  { postCode: '4069', suburb: 'PULLENVALE', state: 'QLD' },
  { postCode: '4069', suburb: 'UPPER BROOKFIELD', state: 'QLD' },
  { postCode: '4070', suburb: 'ANSTEAD', state: 'QLD' },
  { postCode: '4070', suburb: 'BELLBOWRIE', state: 'QLD' },
  { postCode: '4070', suburb: 'MOGGILL', state: 'QLD' },
  { postCode: '4072', suburb: 'UNIVERSITY OF QUEENSLAND', state: 'QLD' },
  { postCode: '4073', suburb: 'SEVENTEEN MILE ROCKS', state: 'QLD' },
  { postCode: '4073', suburb: 'SINNAMON PARK', state: 'QLD' },
  { postCode: '4074', suburb: 'JAMBOREE HEIGHTS', state: 'QLD' },
  { postCode: '4074', suburb: 'JINDALEE', state: 'QLD' },
  { postCode: '4074', suburb: 'MIDDLE PARK', state: 'QLD' },
  { postCode: '4074', suburb: 'MOUNT OMMANEY', state: 'QLD' },
  { postCode: '4074', suburb: 'RIVERHILLS', state: 'QLD' },
  { postCode: '4074', suburb: 'SUMNER', state: 'QLD' },
  { postCode: '4074', suburb: 'SUMNER PARK BC', state: 'QLD' },
  { postCode: '4074', suburb: 'WESTLAKE', state: 'QLD' },
  { postCode: '4075', suburb: 'CORINDA', state: 'QLD' },
  { postCode: '4075', suburb: 'GRACEVILLE', state: 'QLD' },
  { postCode: '4075', suburb: 'GRACEVILLE EAST', state: 'QLD' },
  { postCode: '4075', suburb: 'OXLEY', state: 'QLD' },
  { postCode: '4075', suburb: 'SHERWOOD', state: 'QLD' },
  { postCode: '4076', suburb: 'DARRA', state: 'QLD' },
  { postCode: '4076', suburb: 'WACOL', state: 'QLD' },
  { postCode: '4077', suburb: 'DOOLANDELLA', state: 'QLD' },
  { postCode: '4077', suburb: 'DURACK', state: 'QLD' },
  { postCode: '4077', suburb: 'INALA', state: 'QLD' },
  { postCode: '4077', suburb: 'INALA HEIGHTS', state: 'QLD' },
  { postCode: '4077', suburb: 'RICHLANDS', state: 'QLD' },
  { postCode: '4078', suburb: 'ELLEN GROVE', state: 'QLD' },
  { postCode: '4078', suburb: 'FOREST LAKE', state: 'QLD' },
  { postCode: '4101', suburb: 'HIGHGATE HILL', state: 'QLD' },
  { postCode: '4101', suburb: 'SOUTH BRISBANE', state: 'QLD' },
  { postCode: '4101', suburb: 'SOUTH BRISBANE BC', state: 'QLD' },
  { postCode: '4101', suburb: 'WEST END', state: 'QLD' },
  { postCode: '4102', suburb: 'DUTTON PARK', state: 'QLD' },
  { postCode: '4102', suburb: 'WOOLLOONGABBA', state: 'QLD' },
  { postCode: '4103', suburb: 'ANNERLEY', state: 'QLD' },
  { postCode: '4103', suburb: 'FAIRFIELD', state: 'QLD' },
  { postCode: '4103', suburb: 'FAIRFIELD GARDENS', state: 'QLD' },
  { postCode: '4104', suburb: 'YERONGA', state: 'QLD' },
  { postCode: '4105', suburb: 'MOOROOKA', state: 'QLD' },
  { postCode: '4105', suburb: 'TENNYSON', state: 'QLD' },
  { postCode: '4105', suburb: 'YEERONGPILLY', state: 'QLD' },
  { postCode: '4106', suburb: 'BRISBANE MARKET', state: 'QLD' },
  { postCode: '4106', suburb: 'ROCKLEA', state: 'QLD' },
  { postCode: '4106', suburb: 'ROCKLEA DC', state: 'QLD' },
  { postCode: '4107', suburb: 'SALISBURY', state: 'QLD' },
  { postCode: '4107', suburb: 'SALISBURY EAST', state: 'QLD' },
  { postCode: '4108', suburb: 'ARCHERFIELD', state: 'QLD' },
  { postCode: '4108', suburb: 'ARCHERFIELD BC', state: 'QLD' },
  { postCode: '4108', suburb: 'COOPERS PLAINS', state: 'QLD' },
  { postCode: '4109', suburb: 'MACGREGOR', state: 'QLD' },
  { postCode: '4109', suburb: 'ROBERTSON', state: 'QLD' },
  { postCode: '4109', suburb: 'SUNNYBANK', state: 'QLD' },
  { postCode: '4109', suburb: 'SUNNYBANK HILLS', state: 'QLD' },
  { postCode: '4109', suburb: 'SUNNYBANK SOUTH', state: 'QLD' },
  { postCode: '4110', suburb: 'ACACIA RIDGE', state: 'QLD' },
  { postCode: '4110', suburb: 'HEATHWOOD', state: 'QLD' },
  { postCode: '4110', suburb: 'HEATHWOOD DF', state: 'QLD' },
  { postCode: '4110', suburb: 'LARAPINTA', state: 'QLD' },
  { postCode: '4110', suburb: 'PALLARA', state: 'QLD' },
  { postCode: '4110', suburb: 'WILLAWONG', state: 'QLD' },
  { postCode: '4111', suburb: 'NATHAN', state: 'QLD' },
  { postCode: '4112', suburb: 'KURABY', state: 'QLD' },
  { postCode: '4113', suburb: 'EIGHT MILE PLAINS', state: 'QLD' },
  { postCode: '4113', suburb: 'RUNCORN', state: 'QLD' },
  { postCode: '4114', suburb: 'KINGSTON', state: 'QLD' },
  { postCode: '4114', suburb: 'LOGAN CENTRAL', state: 'QLD' },
  { postCode: '4114', suburb: 'LOGAN CITY DC', state: 'QLD' },
  { postCode: '4114', suburb: 'WOODRIDGE', state: 'QLD' },
  { postCode: '4115', suburb: 'ALGESTER', state: 'QLD' },
  { postCode: '4115', suburb: 'PARKINSON', state: 'QLD' },
  { postCode: '4116', suburb: 'CALAMVALE', state: 'QLD' },
  { postCode: '4116', suburb: 'DREWVALE', state: 'QLD' },
  { postCode: '4116', suburb: 'STRETTON', state: 'QLD' },
  { postCode: '4117', suburb: 'BERRINBA', state: 'QLD' },
  { postCode: '4117', suburb: 'KARAWATHA', state: 'QLD' },
  { postCode: '4118', suburb: 'BROWNS PLAINS', state: 'QLD' },
  { postCode: '4118', suburb: 'FORESTDALE', state: 'QLD' },
  { postCode: '4118', suburb: 'HERITAGE PARK', state: 'QLD' },
  { postCode: '4118', suburb: 'HILLCREST', state: 'QLD' },
  { postCode: '4118', suburb: 'REGENTS PARK', state: 'QLD' },
  { postCode: '4119', suburb: 'UNDERWOOD', state: 'QLD' },
  { postCode: '4120', suburb: 'GREENSLOPES', state: 'QLD' },
  { postCode: '4120', suburb: 'STONES CORNER', state: 'QLD' },
  { postCode: '4121', suburb: 'HOLLAND PARK', state: 'QLD' },
  { postCode: '4121', suburb: 'HOLLAND PARK EAST', state: 'QLD' },
  { postCode: '4121', suburb: 'HOLLAND PARK WEST', state: 'QLD' },
  { postCode: '4121', suburb: 'TARRAGINDI', state: 'QLD' },
  { postCode: '4121', suburb: 'WELLERS HILL', state: 'QLD' },
  { postCode: '4122', suburb: 'MANSFIELD', state: 'QLD' },
  { postCode: '4122', suburb: 'MANSFIELD BC', state: 'QLD' },
  { postCode: '4122', suburb: 'MANSFIELD DC', state: 'QLD' },
  { postCode: '4122', suburb: 'MOUNT GRAVATT', state: 'QLD' },
  { postCode: '4122', suburb: 'MOUNT GRAVATT EAST', state: 'QLD' },
  { postCode: '4122', suburb: 'UPPER MOUNT GRAVATT', state: 'QLD' },
  { postCode: '4122', suburb: 'UPPER MOUNT GRAVATT BC', state: 'QLD' },
  { postCode: '4122', suburb: 'WISHART', state: 'QLD' },
  { postCode: '4123', suburb: 'ROCHEDALE', state: 'QLD' },
  { postCode: '4123', suburb: 'ROCHEDALE SOUTH', state: 'QLD' },
  { postCode: '4124', suburb: 'BORONIA HEIGHTS', state: 'QLD' },
  { postCode: '4124', suburb: 'GREENBANK', state: 'QLD' },
  { postCode: '4124', suburb: 'LYONS', state: 'QLD' },
  { postCode: '4124', suburb: 'NEW BEITH', state: 'QLD' },
  { postCode: '4124', suburb: 'SILVERBARK RIDGE', state: 'QLD' },
  { postCode: '4125', suburb: 'MUNRUBEN', state: 'QLD' },
  { postCode: '4125', suburb: 'PARK RIDGE', state: 'QLD' },
  { postCode: '4125', suburb: 'PARK RIDGE SOUTH', state: 'QLD' },
  { postCode: '4127', suburb: 'DAISY HILL', state: 'QLD' },
  { postCode: '4127', suburb: 'PRIESTDALE', state: 'QLD' },
  { postCode: '4127', suburb: 'SLACKS CREEK', state: 'QLD' },
  { postCode: '4127', suburb: 'SPRINGWOOD', state: 'QLD' },
  { postCode: '4128', suburb: 'SHAILER PARK', state: 'QLD' },
  { postCode: '4128', suburb: 'TANAH MERAH', state: 'QLD' },
  { postCode: '4129', suburb: 'LOGANHOLME', state: 'QLD' },
  { postCode: '4129', suburb: 'LOGANHOLME BC', state: 'QLD' },
  { postCode: '4129', suburb: 'LOGANHOLME DC', state: 'QLD' },
  { postCode: '4130', suburb: 'CARBROOK', state: 'QLD' },
  { postCode: '4130', suburb: 'CORNUBIA', state: 'QLD' },
  { postCode: '4131', suburb: 'LOGANLEA', state: 'QLD' },
  { postCode: '4131', suburb: 'MEADOWBROOK', state: 'QLD' },
  { postCode: '4132', suburb: 'CRESTMEAD', state: 'QLD' },
  { postCode: '4132', suburb: 'MARSDEN', state: 'QLD' },
  { postCode: '4133', suburb: 'CHAMBERS FLAT', state: 'QLD' },
  { postCode: '4133', suburb: 'LOGAN RESERVE', state: 'QLD' },
  { postCode: '4133', suburb: 'WATERFORD', state: 'QLD' },
  { postCode: '4133', suburb: 'WATERFORD WEST', state: 'QLD' },
  { postCode: '4151', suburb: 'COORPAROO', state: 'QLD' },
  { postCode: '4151', suburb: 'COORPAROO DC', state: 'QLD' },
  { postCode: '4152', suburb: 'CAMP HILL', state: 'QLD' },
  { postCode: '4152', suburb: 'CARINA', state: 'QLD' },
  { postCode: '4152', suburb: 'CARINA HEIGHTS', state: 'QLD' },
  { postCode: '4152', suburb: 'CARINDALE', state: 'QLD' },
  { postCode: '4153', suburb: 'BELMONT', state: 'QLD' },
  { postCode: '4154', suburb: 'GUMDALE', state: 'QLD' },
  { postCode: '4154', suburb: 'RANSOME', state: 'QLD' },
  { postCode: '4154', suburb: 'WAKERLEY', state: 'QLD' },
  { postCode: '4155', suburb: 'CHANDLER', state: 'QLD' },
  { postCode: '4156', suburb: 'BURBANK', state: 'QLD' },
  { postCode: '4156', suburb: 'MACKENZIE', state: 'QLD' },
  { postCode: '4157', suburb: 'CAPALABA', state: 'QLD' },
  { postCode: '4157', suburb: 'CAPALABA BC', state: 'QLD' },
  { postCode: '4157', suburb: 'CAPALABA DC', state: 'QLD' },
  { postCode: '4157', suburb: 'SHELDON', state: 'QLD' },
  { postCode: '4158', suburb: 'THORNESIDE', state: 'QLD' },
  { postCode: '4159', suburb: 'BIRKDALE', state: 'QLD' },
  { postCode: '4160', suburb: 'ORMISTON', state: 'QLD' },
  { postCode: '4160', suburb: 'WELLINGTON POINT', state: 'QLD' },
  { postCode: '4161', suburb: 'ALEXANDRA HILLS', state: 'QLD' },
  { postCode: '4163', suburb: 'CLEVELAND', state: 'QLD' },
  { postCode: '4163', suburb: 'CLEVELAND DC', state: 'QLD' },
  { postCode: '4164', suburb: 'THORNLANDS', state: 'QLD' },
  { postCode: '4165', suburb: 'MOUNT COTTON', state: 'QLD' },
  { postCode: '4165', suburb: 'REDLAND BAY', state: 'QLD' },
  { postCode: '4165', suburb: 'VICTORIA POINT', state: 'QLD' },
  { postCode: '4165', suburb: 'VICTORIA POINT WEST', state: 'QLD' },
  { postCode: '4169', suburb: 'EAST BRISBANE', state: 'QLD' },
  { postCode: '4169', suburb: 'KANGAROO POINT', state: 'QLD' },
  { postCode: '4170', suburb: 'CANNON HILL', state: 'QLD' },
  { postCode: '4170', suburb: 'MORNINGSIDE', state: 'QLD' },
  { postCode: '4170', suburb: 'NORMAN PARK', state: 'QLD' },
  { postCode: '4170', suburb: 'SEVEN HILLS', state: 'QLD' },
  { postCode: '4171', suburb: 'BALMORAL', state: 'QLD' },
  { postCode: '4171', suburb: 'BULIMBA', state: 'QLD' },
  { postCode: '4171', suburb: 'HAWTHORNE', state: 'QLD' },
  { postCode: '4172', suburb: 'MURARRIE', state: 'QLD' },
  { postCode: '4173', suburb: 'TINGALPA', state: 'QLD' },
  { postCode: '4173', suburb: 'TINGALPA DC', state: 'QLD' },
  { postCode: '4174', suburb: 'HEMMANT', state: 'QLD' },
  { postCode: '4178', suburb: 'LYTTON', state: 'QLD' },
  { postCode: '4178', suburb: 'PORT OF BRISBANE', state: 'QLD' },
  { postCode: '4178', suburb: 'WYNNUM', state: 'QLD' },
  { postCode: '4178', suburb: 'WYNNUM NORTH', state: 'QLD' },
  { postCode: '4178', suburb: 'WYNNUM PLAZA', state: 'QLD' },
  { postCode: '4178', suburb: 'WYNNUM WEST', state: 'QLD' },
  { postCode: '4179', suburb: 'LOTA', state: 'QLD' },
  { postCode: '4179', suburb: 'MANLY', state: 'QLD' },
  { postCode: '4179', suburb: 'MANLY WEST', state: 'QLD' },
  { postCode: '4183', suburb: 'AMITY', state: 'QLD' },
  { postCode: '4183', suburb: 'AMITY POINT', state: 'QLD' },
  { postCode: '4183', suburb: 'DUNWICH', state: 'QLD' },
  { postCode: '4183', suburb: 'NORTH STRADBROKE ISLAND', state: 'QLD' },
  { postCode: '4183', suburb: 'POINT LOOKOUT', state: 'QLD' },
  { postCode: '4184', suburb: 'COOCHIEMUDLO ISLAND', state: 'QLD' },
  { postCode: '4184', suburb: 'KARRAGARRA ISLAND', state: 'QLD' },
  { postCode: '4184', suburb: 'LAMB ISLAND', state: 'QLD' },
  { postCode: '4184', suburb: 'MACLEAY ISLAND', state: 'QLD' },
  { postCode: '4184', suburb: 'PEEL ISLAND', state: 'QLD' },
  { postCode: '4184', suburb: 'RUSSELL ISLAND', state: 'QLD' },
  { postCode: '4205', suburb: 'BETHANIA', state: 'QLD' },
  { postCode: '4207', suburb: 'ALBERTON', state: 'QLD' },
  { postCode: '4207', suburb: 'BAHRS SCRUB', state: 'QLD' },
  { postCode: '4207', suburb: 'BANNOCKBURN', state: 'QLD' },
  { postCode: '4207', suburb: 'BEENLEIGH', state: 'QLD' },
  { postCode: '4207', suburb: 'BELIVAH', state: 'QLD' },
  { postCode: '4207', suburb: 'BUCCAN', state: 'QLD' },
  { postCode: '4207', suburb: 'CEDAR CREEK', state: 'QLD' },
  { postCode: '4207', suburb: 'EAGLEBY', state: 'QLD' },
  { postCode: '4207', suburb: 'EDENS LANDING', state: 'QLD' },
  { postCode: '4207', suburb: 'HOLMVIEW', state: 'QLD' },
  { postCode: '4207', suburb: 'KAIRABAH', state: 'QLD' },
  { postCode: '4207', suburb: 'LOGAN VILLAGE', state: 'QLD' },
  { postCode: '4207', suburb: 'LUSCOMBE', state: 'QLD' },
  { postCode: '4207', suburb: 'MOUNT WARREN PARK', state: 'QLD' },
  { postCode: '4207', suburb: 'STAPYLTON', state: 'QLD' },
  { postCode: '4207', suburb: 'STEIGLITZ', state: 'QLD' },
  { postCode: '4207', suburb: 'WINDAROO', state: 'QLD' },
  { postCode: '4207', suburb: 'WOLFFDENE', state: 'QLD' },
  { postCode: '4207', suburb: 'WOONGOOLBA', state: 'QLD' },
  { postCode: '4207', suburb: 'YARRABILBA', state: 'QLD' },
  { postCode: '4207', suburb: 'YATALA', state: 'QLD' },
  { postCode: '4207', suburb: 'YATALA DC', state: 'QLD' },
  { postCode: '4208', suburb: 'GILBERTON', state: 'QLD' },
  { postCode: '4208', suburb: 'JACOBS WELL', state: 'QLD' },
  { postCode: '4208', suburb: 'KINGSHOLME', state: 'QLD' },
  { postCode: '4208', suburb: 'NORWELL', state: 'QLD' },
  { postCode: '4208', suburb: 'ORMEAU', state: 'QLD' },
  { postCode: '4208', suburb: 'ORMEAU HILLS', state: 'QLD' },
  { postCode: '4209', suburb: 'COOMERA', state: 'QLD' },
  { postCode: '4209', suburb: 'PIMPAMA', state: 'QLD' },
  { postCode: '4209', suburb: 'UPPER COOMERA', state: 'QLD' },
  { postCode: '4209', suburb: 'WILLOW VALE', state: 'QLD' },
  { postCode: '4210', suburb: 'GUANABA', state: 'QLD' },
  { postCode: '4210', suburb: 'MAUDSLAND', state: 'QLD' },
  { postCode: '4210', suburb: 'OXENFORD', state: 'QLD' },
  { postCode: '4210', suburb: 'STUDIO VILLAGE', state: 'QLD' },
  { postCode: '4210', suburb: 'WONGAWALLAN', state: 'QLD' },
  { postCode: '4211', suburb: 'ADVANCETOWN', state: 'QLD' },
  { postCode: '4211', suburb: 'BEECHMONT', state: 'QLD' },
  { postCode: '4211', suburb: 'BINNA BURRA', state: 'QLD' },
  { postCode: '4211', suburb: 'CARRARA', state: 'QLD' },
  { postCode: '4211', suburb: 'CLAGIRABA', state: 'QLD' },
  { postCode: '4211', suburb: 'GAVEN', state: 'QLD' },
  { postCode: '4211', suburb: 'GILSTON', state: 'QLD' },
  { postCode: '4211', suburb: 'HIGHLAND PARK', state: 'QLD' },
  { postCode: '4211', suburb: 'LOWER BEECHMONT', state: 'QLD' },
  { postCode: '4211', suburb: 'MOUNT NATHAN', state: 'QLD' },
  { postCode: '4211', suburb: 'NATURAL BRIDGE', state: 'QLD' },
  { postCode: '4211', suburb: 'NERANG', state: 'QLD' },
  { postCode: '4211', suburb: 'NERANG BC', state: 'QLD' },
  { postCode: '4211', suburb: 'NERANG DC', state: 'QLD' },
  { postCode: '4211', suburb: 'NUMINBAH VALLEY', state: 'QLD' },
  { postCode: '4211', suburb: 'PACIFIC PINES', state: 'QLD' },
  { postCode: '4211', suburb: 'SOUTHERN LAMINGTON', state: 'QLD' },
  { postCode: '4212', suburb: 'HELENSVALE', state: 'QLD' },
  { postCode: '4212', suburb: 'HELENSVALE TOWN CENTRE', state: 'QLD' },
  { postCode: '4212', suburb: 'HOPE ISLAND', state: 'QLD' },
  { postCode: '4212', suburb: 'SANCTUARY COVE', state: 'QLD' },
  { postCode: '4213', suburb: 'AUSTINVILLE', state: 'QLD' },
  { postCode: '4213', suburb: 'BONOGIN', state: 'QLD' },
  { postCode: '4213', suburb: 'MUDGEERABA', state: 'QLD' },
  { postCode: '4213', suburb: 'NERANWOOD', state: 'QLD' },
  { postCode: '4213', suburb: 'SPRINGBROOK', state: 'QLD' },
  { postCode: '4213', suburb: 'TALLAI', state: 'QLD' },
  { postCode: '4213', suburb: 'WORONGARY', state: 'QLD' },
  { postCode: '4214', suburb: 'ARUNDEL', state: 'QLD' },
  { postCode: '4214', suburb: 'ARUNDEL DC', state: 'QLD' },
  { postCode: '4214', suburb: 'ASHMORE', state: 'QLD' },
  { postCode: '4214', suburb: 'ASHMORE CITY', state: 'QLD' },
  { postCode: '4214', suburb: 'MOLENDINAR', state: 'QLD' },
  { postCode: '4214', suburb: 'PARKWOOD', state: 'QLD' },
  { postCode: '4215', suburb: 'AUSTRALIA FAIR', state: 'QLD' },
  { postCode: '4215', suburb: 'CHIRN PARK', state: 'QLD' },
  { postCode: '4215', suburb: 'LABRADOR', state: 'QLD' },
  { postCode: '4215', suburb: 'SOUTHPORT', state: 'QLD' },
  { postCode: '4215', suburb: 'SOUTHPORT BC', state: 'QLD' },
  { postCode: '4215', suburb: 'SOUTHPORT PARK', state: 'QLD' },
  { postCode: '4216', suburb: 'BIGGERA WATERS', state: 'QLD' },
  { postCode: '4216', suburb: 'COOMBABAH', state: 'QLD' },
  { postCode: '4216', suburb: 'HOLLYWELL', state: 'QLD' },
  { postCode: '4216', suburb: 'PARADISE POINT', state: 'QLD' },
  { postCode: '4216', suburb: 'RUNAWAY BAY', state: 'QLD' },
  { postCode: '4216', suburb: 'SOUTH STRADBROKE', state: 'QLD' },
  { postCode: '4217', suburb: 'BENOWA', state: 'QLD' },
  { postCode: '4217', suburb: 'BUNDALL', state: 'QLD' },
  { postCode: '4217', suburb: 'BUNDALL BC', state: 'QLD' },
  { postCode: '4217', suburb: 'BUNDALL DC', state: 'QLD' },
  { postCode: '4217', suburb: 'CHEVRON ISLAND', state: 'QLD' },
  { postCode: '4217', suburb: 'GOLD COAST MC', state: 'QLD' },
  { postCode: '4217', suburb: 'ISLE OF CAPRI', state: 'QLD' },
  { postCode: '4217', suburb: 'MAIN BEACH', state: 'QLD' },
  { postCode: '4217', suburb: 'SURFERS PARADISE', state: 'QLD' },
  { postCode: '4218', suburb: 'BROADBEACH', state: 'QLD' },
  { postCode: '4218', suburb: 'BROADBEACH WATERS', state: 'QLD' },
  { postCode: '4218', suburb: 'MERMAID BEACH', state: 'QLD' },
  { postCode: '4218', suburb: 'MERMAID WATERS', state: 'QLD' },
  { postCode: '4218', suburb: 'NOBBY BEACH', state: 'QLD' },
  { postCode: '4218', suburb: 'PACIFIC FAIR', state: 'QLD' },
  { postCode: '4218', suburb: 'Q SUPERCENTRE', state: 'QLD' },
  { postCode: '4219', suburb: 'WEST BURLEIGH', state: 'QLD' },
  { postCode: '4220', suburb: 'BURLEIGH DC', state: 'QLD' },
  { postCode: '4220', suburb: 'BURLEIGH HEADS', state: 'QLD' },
  { postCode: '4220', suburb: 'BURLEIGH TOWN', state: 'QLD' },
  { postCode: '4220', suburb: 'BURLEIGH WATERS', state: 'QLD' },
  { postCode: '4220', suburb: 'MIAMI', state: 'QLD' },
  { postCode: '4221', suburb: 'ELANORA', state: 'QLD' },
  { postCode: '4221', suburb: 'PALM BEACH', state: 'QLD' },
  { postCode: '4222', suburb: 'GRIFFITH UNIVERSITY', state: 'QLD' },
  { postCode: '4223', suburb: 'CURRUMBIN', state: 'QLD' },
  { postCode: '4223', suburb: 'CURRUMBIN VALLEY', state: 'QLD' },
  { postCode: '4223', suburb: 'CURRUMBIN WATERS', state: 'QLD' },
  { postCode: '4224', suburb: 'TUGUN', state: 'QLD' },
  { postCode: '4225', suburb: 'BILINGA', state: 'QLD' },
  { postCode: '4225', suburb: 'COOLANGATTA', state: 'QLD' },
  { postCode: '4226', suburb: 'CLEAR ISLAND WATERS', state: 'QLD' },
  { postCode: '4226', suburb: 'MERRIMAC', state: 'QLD' },
  { postCode: '4226', suburb: 'ROBINA', state: 'QLD' },
  { postCode: '4226', suburb: 'ROBINA DC', state: 'QLD' },
  { postCode: '4227', suburb: 'REEDY CREEK', state: 'QLD' },
  { postCode: '4227', suburb: 'VARSITY LAKES', state: 'QLD' },
  { postCode: '4228', suburb: 'TALLEBUDGERA', state: 'QLD' },
  { postCode: '4228', suburb: 'TALLEBUDGERA VALLEY', state: 'QLD' },
  { postCode: '4230', suburb: 'ROBINA TOWN CENTRE', state: 'QLD' },
  { postCode: '4270', suburb: 'TAMBORINE', state: 'QLD' },
  { postCode: '4271', suburb: 'EAGLE HEIGHTS', state: 'QLD' },
  { postCode: '4272', suburb: 'NORTH TAMBORINE', state: 'QLD' },
  { postCode: '4272', suburb: 'TAMBORINE MOUNTAIN', state: 'QLD' },
  { postCode: '4275', suburb: 'BENOBBLE', state: 'QLD' },
  { postCode: '4275', suburb: 'BIDDADDABA', state: 'QLD' },
  { postCode: '4275', suburb: 'BOYLAND', state: 'QLD' },
  { postCode: '4275', suburb: 'CANUNGRA', state: 'QLD' },
  { postCode: '4275', suburb: 'FERNY GLEN', state: 'QLD' },
  { postCode: '4275', suburb: 'FLYING FOX', state: 'QLD' },
  { postCode: '4275', suburb: 'ILLINBAH', state: 'QLD' },
  { postCode: '4275', suburb: "O'REILLY", state: 'QLD' },
  { postCode: '4275', suburb: 'SARABAH', state: 'QLD' },
  { postCode: '4275', suburb: 'WITHEREN', state: 'QLD' },
  { postCode: '4275', suburb: 'WONGLEPONG', state: 'QLD' },
  { postCode: '4280', suburb: 'FLAGSTONE', state: 'QLD' },
  { postCode: '4280', suburb: 'GLENLOGAN', state: 'QLD' },
  { postCode: '4280', suburb: 'JIMBOOMBA', state: 'QLD' },
  { postCode: '4280', suburb: 'NORTH MACLEAN', state: 'QLD' },
  { postCode: '4280', suburb: 'RIVERBEND', state: 'QLD' },
  { postCode: '4280', suburb: 'SOUTH MACLEAN', state: 'QLD' },
  { postCode: '4280', suburb: 'STOCKLEIGH', state: 'QLD' },
  { postCode: '4285', suburb: 'ALLENVIEW', state: 'QLD' },
  { postCode: '4285', suburb: 'BEAUDESERT', state: 'QLD' },
  { postCode: '4285', suburb: 'BIRNAM', state: 'QLD' },
  { postCode: '4285', suburb: 'BROMELTON', state: 'QLD' },
  { postCode: '4285', suburb: 'CAINBABLE', state: 'QLD' },
  { postCode: '4285', suburb: 'CEDAR GROVE', state: 'QLD' },
  { postCode: '4285', suburb: 'CEDAR VALE', state: 'QLD' },
  { postCode: '4285', suburb: 'CHINGHEE CREEK', state: 'QLD' },
  { postCode: '4285', suburb: 'CHRISTMAS CREEK', state: 'QLD' },
  { postCode: '4285', suburb: 'CRYNA', state: 'QLD' },
  { postCode: '4285', suburb: 'DARLINGTON', state: 'QLD' },
  { postCode: '4285', suburb: 'FLINDERS LAKES', state: 'QLD' },
  { postCode: '4285', suburb: 'GLENEAGLE', state: 'QLD' },
  { postCode: '4285', suburb: 'HILLVIEW', state: 'QLD' },
  { postCode: '4285', suburb: 'INNISPLAIN', state: 'QLD' },
  { postCode: '4285', suburb: 'JOSEPHVILLE', state: 'QLD' },
  { postCode: '4285', suburb: 'KAGARU', state: 'QLD' },
  { postCode: '4285', suburb: 'KERRY', state: 'QLD' },
  { postCode: '4285', suburb: 'KNAPP CREEK', state: 'QLD' },
  { postCode: '4285', suburb: 'KOORALBYN', state: 'QLD' },
  { postCode: '4285', suburb: 'LAMINGTON', state: 'QLD' },
  { postCode: '4285', suburb: 'LARAVALE', state: 'QLD' },
  { postCode: '4285', suburb: 'MONARCH GLEN', state: 'QLD' },
  { postCode: '4285', suburb: 'MOUNT GIPPS', state: 'QLD' },
  { postCode: '4285', suburb: 'MUNDOOLUN', state: 'QLD' },
  { postCode: '4285', suburb: 'NINDOOINBAH', state: 'QLD' },
  { postCode: '4285', suburb: 'OAKY CREEK', state: 'QLD' },
  { postCode: '4285', suburb: 'TABOOBA', state: 'QLD' },
  { postCode: '4285', suburb: 'TABRAGALBA', state: 'QLD' },
  { postCode: '4285', suburb: 'TAMROOKUM', state: 'QLD' },
  { postCode: '4285', suburb: 'TAMROOKUM CREEK', state: 'QLD' },
  { postCode: '4285', suburb: 'UNDULLAH', state: 'QLD' },
  { postCode: '4285', suburb: 'VERESDALE', state: 'QLD' },
  { postCode: '4285', suburb: 'VERESDALE SCRUB', state: 'QLD' },
  { postCode: '4285', suburb: 'WOODHILL', state: 'QLD' },
  { postCode: '4287', suburb: 'BARNEY VIEW', state: 'QLD' },
  { postCode: '4287', suburb: 'MOUNT BARNEY', state: 'QLD' },
  { postCode: '4287', suburb: 'MOUNT LINDESAY', state: 'QLD' },
  { postCode: '4287', suburb: 'PALEN CREEK', state: 'QLD' },
  { postCode: '4287', suburb: 'RATHDOWNEY', state: 'QLD' },
  { postCode: '4287', suburb: 'RUNNING CREEK', state: 'QLD' },
  { postCode: '4300', suburb: 'AUGUSTINE HEIGHTS', state: 'QLD' },
  { postCode: '4300', suburb: 'BELLBIRD PARK', state: 'QLD' },
  { postCode: '4300', suburb: 'BROOKWATER', state: 'QLD' },
  { postCode: '4300', suburb: 'CAMIRA', state: 'QLD' },
  { postCode: '4300', suburb: 'CAROLE PARK', state: 'QLD' },
  { postCode: '4300', suburb: 'GAILES', state: 'QLD' },
  { postCode: '4300', suburb: 'GOODNA', state: 'QLD' },
  { postCode: '4300', suburb: 'SPRING MOUNTAIN', state: 'QLD' },
  { postCode: '4300', suburb: 'SPRINGFIELD', state: 'QLD' },
  { postCode: '4300', suburb: 'SPRINGFIELD CENTRAL', state: 'QLD' },
  { postCode: '4300', suburb: 'SPRINGFIELD LAKES', state: 'QLD' },
  { postCode: '4301', suburb: 'COLLINGWOOD PARK', state: 'QLD' },
  { postCode: '4301', suburb: 'REDBANK', state: 'QLD' },
  { postCode: '4301', suburb: 'REDBANK PLAINS', state: 'QLD' },
  { postCode: '4303', suburb: 'DINMORE', state: 'QLD' },
  { postCode: '4303', suburb: 'NEW CHUM', state: 'QLD' },
  { postCode: '4303', suburb: 'RIVERVIEW', state: 'QLD' },
  { postCode: '4304', suburb: 'BLACKSTONE', state: 'QLD' },
  { postCode: '4304', suburb: 'BOOVAL', state: 'QLD' },
  { postCode: '4304', suburb: 'BOOVAL FAIR', state: 'QLD' },
  { postCode: '4304', suburb: 'BUNDAMBA', state: 'QLD' },
  { postCode: '4304', suburb: 'EBBW VALE', state: 'QLD' },
  { postCode: '4304', suburb: 'NORTH BOOVAL', state: 'QLD' },
  { postCode: '4304', suburb: 'SILKSTONE', state: 'QLD' },
  { postCode: '4305', suburb: 'BASIN POCKET', state: 'QLD' },
  { postCode: '4305', suburb: 'BRASSALL', state: 'QLD' },
  { postCode: '4305', suburb: 'BREMER', state: 'QLD' },
  { postCode: '4305', suburb: 'CHURCHILL', state: 'QLD' },
  { postCode: '4305', suburb: 'COALFALLS', state: 'QLD' },
  { postCode: '4305', suburb: 'EAST IPSWICH', state: 'QLD' },
  { postCode: '4305', suburb: 'EASTERN HEIGHTS', state: 'QLD' },
  { postCode: '4305', suburb: 'FLINDERS VIEW', state: 'QLD' },
  { postCode: '4305', suburb: 'IPSWICH', state: 'QLD' },
  { postCode: '4305', suburb: 'LEICHHARDT', state: 'QLD' },
  { postCode: '4305', suburb: 'LIMESTONE RIDGES', state: 'QLD' },
  { postCode: '4305', suburb: 'MOORES POCKET', state: 'QLD' },
  { postCode: '4305', suburb: 'NEWTOWN', state: 'QLD' },
  { postCode: '4305', suburb: 'NORTH IPSWICH', state: 'QLD' },
  { postCode: '4305', suburb: 'NORTH TIVOLI', state: 'QLD' },
  { postCode: '4305', suburb: 'ONE MILE', state: 'QLD' },
  { postCode: '4305', suburb: 'RACEVIEW', state: 'QLD' },
  { postCode: '4305', suburb: 'SADLIERS CROSSING', state: 'QLD' },
  { postCode: '4305', suburb: 'TIVOLI', state: 'QLD' },
  { postCode: '4305', suburb: 'WEST IPSWICH', state: 'QLD' },
  { postCode: '4305', suburb: 'WOODEND', state: 'QLD' },
  { postCode: '4305', suburb: 'WULKURAKA', state: 'QLD' },
  { postCode: '4305', suburb: 'YAMANTO', state: 'QLD' },
  { postCode: '4306', suburb: 'AMBERLEY', state: 'QLD' },
  { postCode: '4306', suburb: 'BANKS CREEK', state: 'QLD' },
  { postCode: '4306', suburb: 'BARELLAN POINT', state: 'QLD' },
  { postCode: '4306', suburb: 'BLACKSOIL', state: 'QLD' },
  { postCode: '4306', suburb: 'BORALLON', state: 'QLD' },
  { postCode: '4306', suburb: 'CHUWAR', state: 'QLD' },
  { postCode: '4306', suburb: 'DEEBING HEIGHTS', state: 'QLD' },
  { postCode: '4306', suburb: 'DUNDAS', state: 'QLD' },
  { postCode: '4306', suburb: 'ENGLAND CREEK', state: 'QLD' },
  { postCode: '4306', suburb: 'FAIRNEY VIEW', state: 'QLD' },
  { postCode: '4306', suburb: 'FERNVALE', state: 'QLD' },
  { postCode: '4306', suburb: 'GLAMORGAN VALE', state: 'QLD' },
  { postCode: '4306', suburb: 'GOOLMAN', state: 'QLD' },
  { postCode: '4306', suburb: 'HAIGSLEA', state: 'QLD' },
  { postCode: '4306', suburb: 'IRONBARK', state: 'QLD' },
  { postCode: '4306', suburb: 'KARALEE', state: 'QLD' },
  { postCode: '4306', suburb: 'KARANA DOWNS', state: 'QLD' },
  { postCode: '4306', suburb: 'KARRABIN', state: 'QLD' },
  { postCode: '4306', suburb: 'KHOLO', state: 'QLD' },
  { postCode: '4306', suburb: 'LAKE MANCHESTER', state: 'QLD' },
  { postCode: '4306', suburb: 'LARK HILL', state: 'QLD' },
  { postCode: '4306', suburb: 'MOUNT CROSBY', state: 'QLD' },
  { postCode: '4306', suburb: 'MOUNT MARROW', state: 'QLD' },
  { postCode: '4306', suburb: 'MUIRLEA', state: 'QLD' },
  { postCode: '4306', suburb: 'PEAK CROSSING', state: 'QLD' },
  { postCode: '4306', suburb: 'PINE MOUNTAIN', state: 'QLD' },
  { postCode: '4306', suburb: 'PURGA', state: 'QLD' },
  { postCode: '4306', suburb: 'RIPLEY', state: 'QLD' },
  { postCode: '4306', suburb: 'SOUTH RIPLEY', state: 'QLD' },
  { postCode: '4306', suburb: 'SPLIT YARD CREEK', state: 'QLD' },
  { postCode: '4306', suburb: 'SWANBANK', state: 'QLD' },
  { postCode: '4306', suburb: 'THAGOONA', state: 'QLD' },
  { postCode: '4306', suburb: 'VERNOR', state: 'QLD' },
  { postCode: '4306', suburb: 'WALLOON', state: 'QLD' },
  { postCode: '4306', suburb: 'WANORA', state: 'QLD' },
  { postCode: '4306', suburb: 'WASHPOOL', state: 'QLD' },
  { postCode: '4306', suburb: 'WHITE ROCK', state: 'QLD' },
  { postCode: '4306', suburb: 'WILLOWBANK', state: 'QLD' },
  { postCode: '4306', suburb: 'WIVENHOE POCKET', state: 'QLD' },
  { postCode: '4307', suburb: 'COLEYVILLE', state: 'QLD' },
  { postCode: '4307', suburb: 'HARRISVILLE', state: 'QLD' },
  { postCode: '4307', suburb: 'MUTDAPILLY', state: 'QLD' },
  { postCode: '4307', suburb: 'RADFORD', state: 'QLD' },
  { postCode: '4307', suburb: 'SILVERDALE', state: 'QLD' },
  { postCode: '4307', suburb: 'WARRILL VIEW', state: 'QLD' },
  { postCode: '4307', suburb: 'WILSONS PLAINS', state: 'QLD' },
  { postCode: '4309', suburb: 'ARATULA', state: 'QLD' },
  { postCode: '4309', suburb: 'CHARLWOOD', state: 'QLD' },
  { postCode: '4309', suburb: 'CLUMBER', state: 'QLD' },
  { postCode: '4309', suburb: 'FASSIFERN', state: 'QLD' },
  { postCode: '4309', suburb: 'FASSIFERN VALLEY', state: 'QLD' },
  { postCode: '4309', suburb: 'FRAZERVIEW', state: 'QLD' },
  { postCode: '4309', suburb: 'KALBAR', state: 'QLD' },
  { postCode: '4309', suburb: 'KENTS LAGOON', state: 'QLD' },
  { postCode: '4309', suburb: 'KULGUN', state: 'QLD' },
  { postCode: '4309', suburb: 'MILORA', state: 'QLD' },
  { postCode: '4309', suburb: 'MOOGERAH', state: 'QLD' },
  { postCode: '4309', suburb: 'MORWINCHA', state: 'QLD' },
  { postCode: '4309', suburb: 'MOUNT EDWARDS', state: 'QLD' },
  { postCode: '4309', suburb: 'MUNBILLA', state: 'QLD' },
  { postCode: '4309', suburb: 'OBUM OBUM', state: 'QLD' },
  { postCode: '4309', suburb: 'TAROME', state: 'QLD' },
  { postCode: '4309', suburb: 'TEVIOTVILLE', state: 'QLD' },
  { postCode: '4310', suburb: 'ALLANDALE', state: 'QLD' },
  { postCode: '4310', suburb: 'ANTHONY', state: 'QLD' },
  { postCode: '4310', suburb: 'BLANTYRE', state: 'QLD' },
  { postCode: '4310', suburb: 'BOONAH', state: 'QLD' },
  { postCode: '4310', suburb: 'BUNBURRA', state: 'QLD' },
  { postCode: '4310', suburb: 'BUNJURGEN', state: 'QLD' },
  { postCode: '4310', suburb: 'BURNETT CREEK', state: 'QLD' },
  { postCode: '4310', suburb: 'CANNON CREEK', state: 'QLD' },
  { postCode: '4310', suburb: 'CARNEYS CREEK', state: 'QLD' },
  { postCode: '4310', suburb: 'COOCHIN', state: 'QLD' },
  { postCode: '4310', suburb: 'COULSON', state: 'QLD' },
  { postCode: '4310', suburb: 'CROFTBY', state: 'QLD' },
  { postCode: '4310', suburb: 'DUGANDAN', state: 'QLD' },
  { postCode: '4310', suburb: 'FRENCHES CREEK', state: 'QLD' },
  { postCode: '4310', suburb: 'HOYA', state: 'QLD' },
  { postCode: '4310', suburb: 'KENTS POCKET', state: 'QLD' },
  { postCode: '4310', suburb: 'MAROON', state: 'QLD' },
  { postCode: '4310', suburb: 'MILBONG', state: 'QLD' },
  { postCode: '4310', suburb: 'MILFORD', state: 'QLD' },
  { postCode: '4310', suburb: 'MOUNT ALFORD', state: 'QLD' },
  { postCode: '4310', suburb: 'MOUNT FRENCH', state: 'QLD' },
  { postCode: '4310', suburb: 'ROADVALE', state: 'QLD' },
  { postCode: '4310', suburb: 'TEMPLIN', state: 'QLD' },
  { postCode: '4310', suburb: 'WALLACES CREEK', state: 'QLD' },
  { postCode: '4310', suburb: 'WOOLOOMAN', state: 'QLD' },
  { postCode: '4310', suburb: 'WYARALONG', state: 'QLD' },
  { postCode: '4311', suburb: 'ATKINSONS DAM', state: 'QLD' },
  { postCode: '4311', suburb: 'BRIGHTVIEW', state: 'QLD' },
  { postCode: '4311', suburb: 'BUARABA', state: 'QLD' },
  { postCode: '4311', suburb: 'BUARABA SOUTH', state: 'QLD' },
  { postCode: '4311', suburb: 'CHURCHABLE', state: 'QLD' },
  { postCode: '4311', suburb: 'CLARENDON', state: 'QLD' },
  { postCode: '4311', suburb: 'COOLANA', state: 'QLD' },
  { postCode: '4311', suburb: 'COOMINYA', state: 'QLD' },
  { postCode: '4311', suburb: 'LAKE WIVENHOE', state: 'QLD' },
  { postCode: '4311', suburb: 'LOCKYER WATERS', state: 'QLD' },
  { postCode: '4311', suburb: 'LOWOOD', state: 'QLD' },
  { postCode: '4311', suburb: 'MINDEN', state: 'QLD' },
  { postCode: '4311', suburb: 'MOUNT TARAMPA', state: 'QLD' },
  { postCode: '4311', suburb: 'PATRICK ESTATE', state: 'QLD' },
  { postCode: '4311', suburb: 'PRENZLAU', state: 'QLD' },
  { postCode: '4311', suburb: 'RIFLE RANGE', state: 'QLD' },
  { postCode: '4311', suburb: 'TARAMPA', state: 'QLD' },
  { postCode: '4311', suburb: 'WIVENHOE HILL', state: 'QLD' },
  { postCode: '4312', suburb: 'BRYDEN', state: 'QLD' },
  { postCode: '4312', suburb: 'CABOONBAH', state: 'QLD' },
  { postCode: '4312', suburb: 'COAL CREEK', state: 'QLD' },
  { postCode: '4312', suburb: 'CROSSDALE', state: 'QLD' },
  { postCode: '4312', suburb: 'ESK', state: 'QLD' },
  { postCode: '4312', suburb: 'ESKDALE', state: 'QLD' },
  { postCode: '4312', suburb: 'GLEN ESK', state: 'QLD' },
  { postCode: '4312', suburb: 'MOOMBRA', state: 'QLD' },
  { postCode: '4312', suburb: 'MOUNT BYRON', state: 'QLD' },
  { postCode: '4312', suburb: 'MOUNT HALLEN', state: 'QLD' },
  { postCode: '4312', suburb: 'MURRUMBA', state: 'QLD' },
  { postCode: '4312', suburb: 'REDBANK CREEK', state: 'QLD' },
  { postCode: '4312', suburb: 'SOMERSET DAM', state: 'QLD' },
  { postCode: '4313', suburb: 'BIARRA', state: 'QLD' },
  { postCode: '4313', suburb: 'BRAEMORE', state: 'QLD' },
  { postCode: '4313', suburb: 'COOEEIMBARDI', state: 'QLD' },
  { postCode: '4313', suburb: 'CRESSBROOK', state: 'QLD' },
  { postCode: '4313', suburb: 'FULHAM', state: 'QLD' },
  { postCode: '4313', suburb: 'GREGORS CREEK', state: 'QLD' },
  { postCode: '4313', suburb: 'IVORY CREEK', state: 'QLD' },
  { postCode: '4313', suburb: 'LOWER CRESSBROOK', state: 'QLD' },
  { postCode: '4313', suburb: 'MOUNT BEPPO', state: 'QLD' },
  { postCode: '4313', suburb: 'OTTABA', state: 'QLD' },
  { postCode: '4313', suburb: 'SCRUB CREEK', state: 'QLD' },
  { postCode: '4313', suburb: 'TOOGOOLAWAH', state: 'QLD' },
  { postCode: '4313', suburb: 'YIMBUN', state: 'QLD' },
  { postCode: '4314', suburb: 'AVOCA VALE', state: 'QLD' },
  { postCode: '4314', suburb: 'BENARKIN', state: 'QLD' },
  { postCode: '4314', suburb: 'BENARKIN NORTH', state: 'QLD' },
  { postCode: '4314', suburb: 'BLACKBUTT', state: 'QLD' },
  { postCode: '4314', suburb: 'BLACKBUTT NORTH', state: 'QLD' },
  { postCode: '4314', suburb: 'BLACKBUTT SOUTH', state: 'QLD' },
  { postCode: '4314', suburb: 'CHERRY CREEK', state: 'QLD' },
  { postCode: '4314', suburb: 'COLINTON', state: 'QLD' },
  { postCode: '4314', suburb: 'GILLA', state: 'QLD' },
  { postCode: '4314', suburb: 'GOOGA CREEK', state: 'QLD' },
  { postCode: '4314', suburb: 'HARLIN', state: 'QLD' },
  { postCode: '4314', suburb: 'LINVILLE', state: 'QLD' },
  { postCode: '4314', suburb: 'MOORE', state: 'QLD' },
  { postCode: '4314', suburb: 'MOUNT BINGA', state: 'QLD' },
  { postCode: '4314', suburb: 'MOUNT STANLEY', state: 'QLD' },
  { postCode: '4314', suburb: 'NUKKU', state: 'QLD' },
  { postCode: '4314', suburb: 'TAROMEO', state: 'QLD' },
  { postCode: '4314', suburb: 'TEELAH', state: 'QLD' },
  { postCode: '4340', suburb: 'ASHWELL', state: 'QLD' },
  { postCode: '4340', suburb: 'CALVERT', state: 'QLD' },
  { postCode: '4340', suburb: 'EBENEZER', state: 'QLD' },
  { postCode: '4340', suburb: 'GRANDCHESTER', state: 'QLD' },
  { postCode: '4340', suburb: 'JEEBROPILLY', state: 'QLD' },
  { postCode: '4340', suburb: 'LANEFIELD', state: 'QLD' },
  { postCode: '4340', suburb: 'LOWER MOUNT WALKER', state: 'QLD' },
  { postCode: '4340', suburb: 'MERRYVALE', state: 'QLD' },
  { postCode: '4340', suburb: 'MOORANG', state: 'QLD' },
  { postCode: '4340', suburb: 'MOUNT FORBES', state: 'QLD' },
  { postCode: '4340', suburb: 'MOUNT MORT', state: 'QLD' },
  { postCode: '4340', suburb: 'MOUNT WALKER', state: 'QLD' },
  { postCode: '4340', suburb: 'MOUNT WALKER WEST', state: 'QLD' },
  { postCode: '4340', suburb: 'ROSEVALE', state: 'QLD' },
  { postCode: '4340', suburb: 'ROSEWOOD', state: 'QLD' },
  { postCode: '4340', suburb: 'TALLEGALLA', state: 'QLD' },
  { postCode: '4340', suburb: 'THE BLUFF', state: 'QLD' },
  { postCode: '4340', suburb: 'WOOLSHED', state: 'QLD' },
  { postCode: '4341', suburb: 'BLENHEIM', state: 'QLD' },
  { postCode: '4341', suburb: 'HATTON VALE', state: 'QLD' },
  { postCode: '4341', suburb: 'KENSINGTON GROVE', state: 'QLD' },
  { postCode: '4341', suburb: 'KENTVILLE', state: 'QLD' },
  { postCode: '4341', suburb: 'LAIDLEY', state: 'QLD' },
  { postCode: '4341', suburb: 'LAIDLEY CREEK WEST', state: 'QLD' },
  { postCode: '4341', suburb: 'LAIDLEY HEIGHTS', state: 'QLD' },
  { postCode: '4341', suburb: 'LAIDLEY NORTH', state: 'QLD' },
  { postCode: '4341', suburb: 'LAIDLEY SOUTH', state: 'QLD' },
  { postCode: '4341', suburb: 'MOUNT BERRYMAN', state: 'QLD' },
  { postCode: '4341', suburb: 'MULGOWIE', state: 'QLD' },
  { postCode: '4341', suburb: 'PLAINLAND', state: 'QLD' },
  { postCode: '4341', suburb: 'REGENCY DOWNS', state: 'QLD' },
  { postCode: '4341', suburb: 'SUMMERHOLM', state: 'QLD' },
  { postCode: '4341', suburb: 'THORNTON', state: 'QLD' },
  { postCode: '4341', suburb: 'TOWNSON', state: 'QLD' },
  { postCode: '4342', suburb: 'CROWLEY VALE', state: 'QLD' },
  { postCode: '4342', suburb: 'FOREST HILL', state: 'QLD' },
  { postCode: '4342', suburb: 'GLEN CAIRN', state: 'QLD' },
  { postCode: '4342', suburb: 'GLENORE GROVE', state: 'QLD' },
  { postCode: '4342', suburb: 'LOCKROSE', state: 'QLD' },
  { postCode: '4342', suburb: 'LYNFORD', state: 'QLD' },
  { postCode: '4343', suburb: 'ADARE', state: 'QLD' },
  { postCode: '4343', suburb: 'BLACK DUCK CREEK', state: 'QLD' },
  { postCode: '4343', suburb: 'CAFFEY', state: 'QLD' },
  { postCode: '4343', suburb: 'COLLEGE VIEW', state: 'QLD' },
  { postCode: '4343', suburb: 'EAST HALDON', state: 'QLD' },
  { postCode: '4343', suburb: 'FORDSDALE', state: 'QLD' },
  { postCode: '4343', suburb: 'GATTON', state: 'QLD' },
  { postCode: '4343', suburb: 'INGOLDSBY', state: 'QLD' },
  { postCode: '4343', suburb: 'JUNCTION VIEW', state: 'QLD' },
  { postCode: '4343', suburb: 'LAKE CLARENDON', state: 'QLD' },
  { postCode: '4343', suburb: 'LAWES', state: 'QLD' },
  { postCode: '4343', suburb: 'LEFTHAND BRANCH', state: 'QLD' },
  { postCode: '4343', suburb: 'LOWER TENTHILL', state: 'QLD' },
  { postCode: '4343', suburb: 'MORTON VALE', state: 'QLD' },
  { postCode: '4343', suburb: 'MOUNT SYLVIA', state: 'QLD' },
  { postCode: '4343', suburb: 'PLACID HILLS', state: 'QLD' },
  { postCode: '4343', suburb: 'RINGWOOD', state: 'QLD' },
  { postCode: '4343', suburb: 'ROCKSIDE', state: 'QLD' },
  { postCode: '4343', suburb: 'ROPELEY', state: 'QLD' },
  { postCode: '4343', suburb: 'SPRING CREEK', state: 'QLD' },
  { postCode: '4343', suburb: 'UPPER TENTHILL', state: 'QLD' },
  { postCode: '4343', suburb: 'VINEGAR HILL', state: 'QLD' },
  { postCode: '4343', suburb: 'WOODBINE', state: 'QLD' },
  { postCode: '4343', suburb: 'WOODLANDS', state: 'QLD' },
  { postCode: '4344', suburb: 'CARPENDALE', state: 'QLD' },
  { postCode: '4344', suburb: 'EGYPT', state: 'QLD' },
  { postCode: '4344', suburb: 'FLAGSTONE CREEK', state: 'QLD' },
  { postCode: '4344', suburb: 'HELIDON', state: 'QLD' },
  { postCode: '4344', suburb: 'HELIDON SPA', state: 'QLD' },
  { postCode: '4344', suburb: 'IREDALE', state: 'QLD' },
  { postCode: '4344', suburb: 'LILYDALE', state: 'QLD' },
  { postCode: '4344', suburb: 'LOCKYER', state: 'QLD' },
  { postCode: '4344', suburb: 'ROCKMOUNT', state: 'QLD' },
  { postCode: '4344', suburb: 'SEVENTEEN MILE', state: 'QLD' },
  { postCode: '4344', suburb: 'STOCKYARD', state: 'QLD' },
  { postCode: '4344', suburb: 'UPPER FLAGSTONE', state: 'QLD' },
  { postCode: '4345', suburb: 'GATTON COLLEGE', state: 'QLD' },
  { postCode: '4346', suburb: 'MARBURG', state: 'QLD' },
  { postCode: '4347', suburb: 'GRANTHAM', state: 'QLD' },
  { postCode: '4347', suburb: 'MA MA CREEK', state: 'QLD' },
  { postCode: '4347', suburb: 'MOUNT WHITESTONE', state: 'QLD' },
  { postCode: '4347', suburb: 'VERADILLA', state: 'QLD' },
  { postCode: '4347', suburb: 'WINWILL', state: 'QLD' },
  { postCode: '4350', suburb: 'ATHOL', state: 'QLD' },
  { postCode: '4350', suburb: 'BLUE MOUNTAIN HEIGHTS', state: 'QLD' },
  { postCode: '4350', suburb: 'CENTENARY HEIGHTS', state: 'QLD' },
  { postCode: '4350', suburb: 'CHARLTON', state: 'QLD' },
  { postCode: '4350', suburb: 'CLIFFORD GARDENS', state: 'QLD' },
  { postCode: '4350', suburb: 'COTSWOLD HILLS', state: 'QLD' },
  { postCode: '4350', suburb: 'CRANLEY', state: 'QLD' },
  { postCode: '4350', suburb: 'DARLING HEIGHTS', state: 'QLD' },
  { postCode: '4350', suburb: 'DRAYTON', state: 'QLD' },
  { postCode: '4350', suburb: 'DRAYTON NORTH', state: 'QLD' },
  { postCode: '4350', suburb: 'EAST TOOWOOMBA', state: 'QLD' },
  { postCode: '4350', suburb: 'FINNIE', state: 'QLD' },
  { postCode: '4350', suburb: 'GLENVALE', state: 'QLD' },
  { postCode: '4350', suburb: 'GOWRIE MOUNTAIN', state: 'QLD' },
  { postCode: '4350', suburb: 'HARLAXTON', state: 'QLD' },
  { postCode: '4350', suburb: 'HARRISTOWN', state: 'QLD' },
  { postCode: '4350', suburb: 'KEARNEYS SPRING', state: 'QLD' },
  { postCode: '4350', suburb: 'MIDDLE RIDGE', state: 'QLD' },
  { postCode: '4350', suburb: 'MOUNT KYNOCH', state: 'QLD' },
  { postCode: '4350', suburb: 'MOUNT LOFTY', state: 'QLD' },
  { postCode: '4350', suburb: 'MOUNT RASCAL', state: 'QLD' },
  { postCode: '4350', suburb: 'NEWTOWN', state: 'QLD' },
  { postCode: '4350', suburb: 'NORTH TOOWOOMBA', state: 'QLD' },
  { postCode: '4350', suburb: 'NORTHLANDS', state: 'QLD' },
  { postCode: '4350', suburb: 'NORTHPOINT', state: 'QLD' },
  { postCode: '4350', suburb: 'PRINCE HENRY HEIGHTS', state: 'QLD' },
  { postCode: '4350', suburb: 'RANGEVILLE', state: 'QLD' },
  { postCode: '4350', suburb: 'REDWOOD', state: 'QLD' },
  { postCode: '4350', suburb: 'ROCKVILLE', state: 'QLD' },
  { postCode: '4350', suburb: 'SOUTH TOOWOOMBA', state: 'QLD' },
  { postCode: '4350', suburb: 'TOOWOOMBA', state: 'QLD' },
  { postCode: '4350', suburb: 'TOOWOOMBA CITY', state: 'QLD' },
  { postCode: '4350', suburb: 'TOOWOOMBA DC', state: 'QLD' },
  { postCode: '4350', suburb: 'TOOWOOMBA EAST', state: 'QLD' },
  { postCode: '4350', suburb: 'TOOWOOMBA SOUTH', state: 'QLD' },
  { postCode: '4350', suburb: 'TOOWOOMBA VILLAGE FAIR', state: 'QLD' },
  { postCode: '4350', suburb: 'TOOWOOMBA WEST', state: 'QLD' },
  { postCode: '4350', suburb: 'TOP CAMP', state: 'QLD' },
  { postCode: '4350', suburb: 'TORRINGTON', state: 'QLD' },
  { postCode: '4350', suburb: 'WELLCAMP', state: 'QLD' },
  { postCode: '4350', suburb: 'WESTBROOK', state: 'QLD' },
  { postCode: '4350', suburb: 'WILSONTON', state: 'QLD' },
  { postCode: '4350', suburb: 'WILSONTON HEIGHTS', state: 'QLD' },
  { postCode: '4350', suburb: 'WYALLA PLAZA', state: 'QLD' },
  { postCode: '4352', suburb: 'BALLARD', state: 'QLD' },
  { postCode: '4352', suburb: 'BAPAUME', state: 'QLD' },
  { postCode: '4352', suburb: 'BIRNAM', state: 'QLD' },
  { postCode: '4352', suburb: 'BLANCHVIEW', state: 'QLD' },
  { postCode: '4352', suburb: 'BRANCHVIEW', state: 'QLD' },
  { postCode: '4352', suburb: 'CABARLAH', state: 'QLD' },
  { postCode: '4352', suburb: 'CAWDOR', state: 'QLD' },
  { postCode: '4352', suburb: 'CEMENT MILLS', state: 'QLD' },
  { postCode: '4352', suburb: 'COALBANK', state: 'QLD' },
  { postCode: '4352', suburb: 'CONDAMINE PLAINS', state: 'QLD' },
  { postCode: '4352', suburb: 'CUTELLA', state: 'QLD' },
  { postCode: '4352', suburb: 'DERRYMORE', state: 'QLD' },
  { postCode: '4352', suburb: 'DJUAN', state: 'QLD' },
  { postCode: '4352', suburb: 'DOCTOR CREEK', state: 'QLD' },
  { postCode: '4352', suburb: 'EVERGREEN', state: 'QLD' },
  { postCode: '4352', suburb: 'FIFTEEN MILE', state: 'QLD' },
  { postCode: '4352', suburb: 'GEHAM', state: 'QLD' },
  { postCode: '4352', suburb: 'GLENCOE', state: 'QLD' },
  { postCode: '4352', suburb: 'GORE', state: 'QLD' },
  { postCode: '4352', suburb: 'GOWRIE JUNCTION', state: 'QLD' },
  { postCode: '4352', suburb: 'GOWRIE LITTLE PLAIN', state: 'QLD' },
  { postCode: '4352', suburb: 'GRAPETREE', state: 'QLD' },
  { postCode: '4352', suburb: 'GROOMSVILLE', state: 'QLD' },
  { postCode: '4352', suburb: 'HAMPTON', state: 'QLD' },
  { postCode: '4352', suburb: 'HIGHFIELDS', state: 'QLD' },
  { postCode: '4352', suburb: 'HIGHGROVE', state: 'QLD' },
  { postCode: '4352', suburb: 'HODGSON VALE', state: 'QLD' },
  { postCode: '4352', suburb: 'KARARA', state: 'QLD' },
  { postCode: '4352', suburb: 'KLEINTON', state: 'QLD' },
  { postCode: '4352', suburb: 'KULPI', state: 'QLD' },
  { postCode: '4352', suburb: 'KURROWAH', state: 'QLD' },
  { postCode: '4352', suburb: 'LILYVALE', state: 'QLD' },
  { postCode: '4352', suburb: 'MACLAGAN', state: 'QLD' },
  { postCode: '4352', suburb: 'MALLING', state: 'QLD' },
  { postCode: '4352', suburb: 'MERINGANDAN', state: 'QLD' },
  { postCode: '4352', suburb: 'MERINGANDAN WEST', state: 'QLD' },
  { postCode: '4352', suburb: 'MERRITTS CREEK', state: 'QLD' },
  { postCode: '4352', suburb: 'MOUNT LUKE', state: 'QLD' },
  { postCode: '4352', suburb: 'MUNIGANEEN', state: 'QLD' },
  { postCode: '4352', suburb: 'MURPHYS CREEK', state: 'QLD' },
  { postCode: '4352', suburb: 'NARKO', state: 'QLD' },
  { postCode: '4352', suburb: 'NORTH MACLAGAN', state: 'QLD' },
  { postCode: '4352', suburb: 'NUTGROVE', state: 'QLD' },
  { postCode: '4352', suburb: 'OMAN AMA', state: 'QLD' },
  { postCode: '4352', suburb: 'PALMTREE', state: 'QLD' },
  { postCode: '4352', suburb: 'PAMPAS', state: 'QLD' },
  { postCode: '4352', suburb: 'PECHEY', state: 'QLD' },
  { postCode: '4352', suburb: 'PERANGA', state: 'QLD' },
  { postCode: '4352', suburb: 'PERSEVERANCE', state: 'QLD' },
  { postCode: '4352', suburb: 'POSTMANS RIDGE', state: 'QLD' },
  { postCode: '4352', suburb: 'POZIERES', state: 'QLD' },
  { postCode: '4352', suburb: 'PRESTON', state: 'QLD' },
  { postCode: '4352', suburb: 'RANGEMORE', state: 'QLD' },
  { postCode: '4352', suburb: 'RAVENSBOURNE', state: 'QLD' },
  { postCode: '4352', suburb: 'SILVER RIDGE', state: 'QLD' },
  { postCode: '4352', suburb: 'SPRING BLUFF', state: 'QLD' },
  { postCode: '4352', suburb: 'ST AUBYN', state: 'QLD' },
  { postCode: '4352', suburb: 'THORNVILLE', state: 'QLD' },
  { postCode: '4352', suburb: 'TOOWOOMBA MC', state: 'QLD' },
  { postCode: '4352', suburb: 'TUMMAVILLE', state: 'QLD' },
  { postCode: '4352', suburb: 'UMBIRAM', state: 'QLD' },
  { postCode: '4352', suburb: 'UPPER LOCKYER', state: 'QLD' },
  { postCode: '4352', suburb: 'VALE VIEW', state: 'QLD' },
  { postCode: '4352', suburb: 'WHICHELLO', state: 'QLD' },
  { postCode: '4352', suburb: 'WHITE MOUNTAIN', state: 'QLD' },
  { postCode: '4352', suburb: 'WITHCOTT', state: 'QLD' },
  { postCode: '4352', suburb: 'WOODLEIGH', state: 'QLD' },
  { postCode: '4352', suburb: 'WOOLMER', state: 'QLD' },
  { postCode: '4352', suburb: 'WUTUL', state: 'QLD' },
  { postCode: '4352', suburb: 'WYREEMA', state: 'QLD' },
  { postCode: '4352', suburb: 'YALANGUR', state: 'QLD' },
  { postCode: '4352', suburb: 'YANDILLA', state: 'QLD' },
  { postCode: '4353', suburb: 'BERGEN', state: 'QLD' },
  { postCode: '4353', suburb: 'EAST COOYAR', state: 'QLD' },
  { postCode: '4353', suburb: 'HADEN', state: 'QLD' },
  { postCode: '4354', suburb: 'DOUGLAS', state: 'QLD' },
  { postCode: '4354', suburb: 'GOOMBUNGEE', state: 'QLD' },
  { postCode: '4354', suburb: 'KILBIRNIE', state: 'QLD' },
  { postCode: '4355', suburb: 'ANDURAMBA', state: 'QLD' },
  { postCode: '4355', suburb: 'CRESSBROOK CREEK', state: 'QLD' },
  { postCode: '4355', suburb: 'CROWS NEST', state: 'QLD' },
  { postCode: '4355', suburb: 'EMU CREEK', state: 'QLD' },
  { postCode: '4355', suburb: 'GLENAVEN', state: 'QLD' },
  { postCode: '4355', suburb: 'JONES GULLY', state: 'QLD' },
  { postCode: '4355', suburb: 'MOUNTAIN CAMP', state: 'QLD' },
  { postCode: '4355', suburb: 'PIERCES CREEK', state: 'QLD' },
  { postCode: '4355', suburb: 'PINELANDS', state: 'QLD' },
  { postCode: '4355', suburb: 'PLAINBY', state: 'QLD' },
  { postCode: '4355', suburb: 'THE BLUFF', state: 'QLD' },
  { postCode: '4355', suburb: 'UPPER PINELANDS', state: 'QLD' },
  { postCode: '4356', suburb: 'BONGEEN', state: 'QLD' },
  { postCode: '4356', suburb: 'BROXBURN', state: 'QLD' },
  { postCode: '4356', suburb: 'EVANSLEA', state: 'QLD' },
  { postCode: '4356', suburb: 'IRONGATE', state: 'QLD' },
  { postCode: '4356', suburb: 'KINCORA', state: 'QLD' },
  { postCode: '4356', suburb: 'LINTHORPE', state: 'QLD' },
  { postCode: '4356', suburb: 'MOTLEY', state: 'QLD' },
  { postCode: '4356', suburb: 'MOUNT TYSON', state: 'QLD' },
  { postCode: '4356', suburb: 'NORTH BRANCH', state: 'QLD' },
  { postCode: '4356', suburb: 'NORWIN', state: 'QLD' },
  { postCode: '4356', suburb: 'PITTSWORTH', state: 'QLD' },
  { postCode: '4356', suburb: 'PURRAWUNDA', state: 'QLD' },
  { postCode: '4356', suburb: 'ROSSVALE', state: 'QLD' },
  { postCode: '4356', suburb: 'SCRUBBY MOUNTAIN', state: 'QLD' },
  { postCode: '4356', suburb: 'SPRINGSIDE', state: 'QLD' },
  { postCode: '4356', suburb: 'ST HELENS', state: 'QLD' },
  { postCode: '4356', suburb: 'STONELEIGH', state: 'QLD' },
  { postCode: '4356', suburb: 'YARRANLEA', state: 'QLD' },
  { postCode: '4357', suburb: 'BRINGALILY', state: 'QLD' },
  { postCode: '4357', suburb: 'BULLI CREEK', state: 'QLD' },
  { postCode: '4357', suburb: 'CANNING CREEK', state: 'QLD' },
  { postCode: '4357', suburb: 'CAPTAINS MOUNTAIN', state: 'QLD' },
  { postCode: '4357', suburb: 'CLONTARF', state: 'QLD' },
  { postCode: '4357', suburb: 'CONDAMINE FARMS', state: 'QLD' },
  { postCode: '4357', suburb: 'CYPRESS GARDENS', state: 'QLD' },
  { postCode: '4357', suburb: 'DOMVILLE', state: 'QLD' },
  { postCode: '4357', suburb: 'FOREST RIDGE', state: 'QLD' },
  { postCode: '4357', suburb: 'GRAYS GATE', state: 'QLD' },
  { postCode: '4357', suburb: 'KOOROONGARRA', state: 'QLD' },
  { postCode: '4357', suburb: 'LAVELLE', state: 'QLD' },
  { postCode: '4357', suburb: 'LEMONTREE', state: 'QLD' },
  { postCode: '4357', suburb: 'MILLMERRAN', state: 'QLD' },
  { postCode: '4357', suburb: 'MILLMERRAN DOWNS', state: 'QLD' },
  { postCode: '4357', suburb: 'MILLMERRAN WOODS', state: 'QLD' },
  { postCode: '4357', suburb: 'MILLWOOD', state: 'QLD' },
  { postCode: '4357', suburb: 'MOUNT EMLYN', state: 'QLD' },
  { postCode: '4357', suburb: 'PUNCHS CREEK', state: 'QLD' },
  { postCode: '4357', suburb: 'ROCKY CREEK', state: 'QLD' },
  { postCode: '4357', suburb: 'STONEHENGE', state: 'QLD' },
  { postCode: '4357', suburb: 'THE PINES', state: 'QLD' },
  { postCode: '4357', suburb: 'TURALLIN', state: 'QLD' },
  { postCode: '4357', suburb: 'WATTLE RIDGE', state: 'QLD' },
  { postCode: '4357', suburb: 'WESTERN CREEK', state: 'QLD' },
  { postCode: '4357', suburb: 'WOONDUL', state: 'QLD' },
  { postCode: '4358', suburb: 'CAMBOOYA', state: 'QLD' },
  { postCode: '4358', suburb: 'FELTON', state: 'QLD' },
  { postCode: '4358', suburb: 'FELTON SOUTH', state: 'QLD' },
  { postCode: '4358', suburb: 'RAMSAY', state: 'QLD' },
  { postCode: '4359', suburb: 'ASCOT', state: 'QLD' },
  { postCode: '4359', suburb: 'BUDGEE', state: 'QLD' },
  { postCode: '4359', suburb: 'EAST GREENMOUNT', state: 'QLD' },
  { postCode: '4359', suburb: 'GREENMOUNT', state: 'QLD' },
  { postCode: '4359', suburb: 'HIRSTGLEN', state: 'QLD' },
  { postCode: '4359', suburb: 'WEST HALDON', state: 'QLD' },
  { postCode: '4360', suburb: 'NOBBY', state: 'QLD' },
  { postCode: '4361', suburb: 'BACK PLAINS', state: 'QLD' },
  { postCode: '4361', suburb: 'CLIFTON', state: 'QLD' },
  { postCode: '4361', suburb: 'ELLANGOWAN', state: 'QLD' },
  { postCode: '4361', suburb: 'ELPHINSTONE', state: 'QLD' },
  { postCode: '4361', suburb: 'HEADINGTON HILL', state: 'QLD' },
  { postCode: '4361', suburb: 'KINGS CREEK', state: 'QLD' },
  { postCode: '4361', suburb: 'MANAPOURI', state: 'QLD' },
  { postCode: '4361', suburb: 'MISSEN FLAT', state: 'QLD' },
  { postCode: '4361', suburb: 'MOUNT MOLAR', state: 'QLD' },
  { postCode: '4361', suburb: 'NEVILTON', state: 'QLD' },
  { postCode: '4361', suburb: 'PILTON', state: 'QLD' },
  { postCode: '4361', suburb: 'RYEFORD', state: 'QLD' },
  { postCode: '4361', suburb: 'SANDY CAMP', state: 'QLD' },
  { postCode: '4361', suburb: 'SPRING CREEK', state: 'QLD' },
  { postCode: '4361', suburb: 'UPPER PILTON', state: 'QLD' },
  { postCode: '4361', suburb: 'VICTORIA HILL', state: 'QLD' },
  { postCode: '4362', suburb: 'ALLORA', state: 'QLD' },
  { postCode: '4362', suburb: 'BERAT', state: 'QLD' },
  { postCode: '4362', suburb: 'DEUCHAR', state: 'QLD' },
  { postCode: '4362', suburb: 'ELLINTHORP', state: 'QLD' },
  { postCode: '4362', suburb: 'GOOMBURRA', state: 'QLD' },
  { postCode: '4362', suburb: 'HENDON', state: 'QLD' },
  { postCode: '4362', suburb: 'MOUNT MARSHALL', state: 'QLD' },
  { postCode: '4362', suburb: 'TALGAI', state: 'QLD' },
  { postCode: '4363', suburb: 'SOUTHBROOK', state: 'QLD' },
  { postCode: '4364', suburb: 'BROOKSTEAD', state: 'QLD' },
  { postCode: '4365', suburb: 'LEYBURN', state: 'QLD' },
  { postCode: '4370', suburb: 'ALLAN', state: 'QLD' },
  { postCode: '4370', suburb: 'BONY MOUNTAIN', state: 'QLD' },
  { postCode: '4370', suburb: 'CANNINGVALE', state: 'QLD' },
  { postCode: '4370', suburb: 'CHERRY GULLY', state: 'QLD' },
  { postCode: '4370', suburb: 'CLINTONVALE', state: 'QLD' },
  { postCode: '4370', suburb: 'CUNNINGHAM', state: 'QLD' },
  { postCode: '4370', suburb: 'DANDEROO', state: 'QLD' },
  { postCode: '4370', suburb: 'ELBOW VALLEY', state: 'QLD' },
  { postCode: '4370', suburb: 'FREESTONE', state: 'QLD' },
  { postCode: '4370', suburb: 'GLADFIELD', state: 'QLD' },
  { postCode: '4370', suburb: 'GLENGALLAN', state: 'QLD' },
  { postCode: '4370', suburb: 'GREYMARE', state: 'QLD' },
  { postCode: '4370', suburb: 'JUNABEE', state: 'QLD' },
  { postCode: '4370', suburb: 'LESLIE', state: 'QLD' },
  { postCode: '4370', suburb: 'LESLIE DAM', state: 'QLD' },
  { postCode: '4370', suburb: 'LOCH LOMOND', state: 'QLD' },
  { postCode: '4370', suburb: 'MARYVALE', state: 'QLD' },
  { postCode: '4370', suburb: 'MASSIE', state: 'QLD' },
  { postCode: '4370', suburb: 'MONTROSE', state: 'QLD' },
  { postCode: '4370', suburb: 'MORGAN PARK', state: 'QLD' },
  { postCode: '4370', suburb: 'MOUNT COLLIERY', state: 'QLD' },
  { postCode: '4370', suburb: 'MOUNT STURT', state: 'QLD' },
  { postCode: '4370', suburb: 'MOUNT TABOR', state: 'QLD' },
  { postCode: '4370', suburb: 'MURRAYS BRIDGE', state: 'QLD' },
  { postCode: '4370', suburb: 'NORTH BRANCH', state: 'QLD' },
  { postCode: '4370', suburb: 'PRATTEN', state: 'QLD' },
  { postCode: '4370', suburb: 'RODGERS CREEK', state: 'QLD' },
  { postCode: '4370', suburb: 'ROSEHILL', state: 'QLD' },
  { postCode: '4370', suburb: 'ROSENTHAL HEIGHTS', state: 'QLD' },
  { postCode: '4370', suburb: 'SILVERWOOD', state: 'QLD' },
  { postCode: '4370', suburb: 'SLADEVALE', state: 'QLD' },
  { postCode: '4370', suburb: 'SWAN CREEK', state: 'QLD' },
  { postCode: '4370', suburb: 'THANE', state: 'QLD' },
  { postCode: '4370', suburb: 'THANES CREEK', state: 'QLD' },
  { postCode: '4370', suburb: 'THE GLEN', state: 'QLD' },
  { postCode: '4370', suburb: 'THE HERMITAGE', state: 'QLD' },
  { postCode: '4370', suburb: 'TOOLBURRA', state: 'QLD' },
  { postCode: '4370', suburb: 'TREGONY', state: 'QLD' },
  { postCode: '4370', suburb: 'UPPER FREESTONE', state: 'QLD' },
  { postCode: '4370', suburb: 'UPPER WHEATVALE', state: 'QLD' },
  { postCode: '4370', suburb: 'WARWICK', state: 'QLD' },
  { postCode: '4370', suburb: 'WARWICK DC', state: 'QLD' },
  { postCode: '4370', suburb: 'WHEATVALE', state: 'QLD' },
  { postCode: '4370', suburb: 'WILDASH', state: 'QLD' },
  { postCode: '4370', suburb: 'WILLOWVALE', state: 'QLD' },
  { postCode: '4370', suburb: 'WIYARRA', state: 'QLD' },
  { postCode: '4370', suburb: 'WOMINA', state: 'QLD' },
  { postCode: '4371', suburb: 'EMU VALE', state: 'QLD' },
  { postCode: '4371', suburb: 'SWANFELS', state: 'QLD' },
  { postCode: '4371', suburb: 'YANGAN', state: 'QLD' },
  { postCode: '4372', suburb: 'TANNYMOREL', state: 'QLD' },
  { postCode: '4373', suburb: 'KILLARNEY', state: 'QLD' },
  { postCode: '4373', suburb: 'THE FALLS', state: 'QLD' },
  { postCode: '4373', suburb: 'THE HEAD', state: 'QLD' },
  { postCode: '4374', suburb: 'DALVEEN', state: 'QLD' },
  { postCode: '4375', suburb: 'COTTONVALE', state: 'NSW' },
  { postCode: '4375', suburb: 'COTTONVALE', state: 'QLD' },
  { postCode: '4375', suburb: 'FLEURBAIX', state: 'QLD' },
  { postCode: '4376', suburb: 'THULIMBAH', state: 'QLD' },
  { postCode: '4377', suburb: 'GLEN NIVEN', state: 'QLD' },
  { postCode: '4377', suburb: 'MARYLAND', state: 'NSW' },
  { postCode: '4377', suburb: 'THE SUMMIT', state: 'QLD' },
  { postCode: '4378', suburb: 'APPLETHORPE', state: 'QLD' },
  { postCode: '4380', suburb: 'AMIENS', state: 'QLD' },
  { postCode: '4380', suburb: 'AMOSFIELD', state: 'NSW' },
  { postCode: '4380', suburb: 'BROADWATER', state: 'QLD' },
  { postCode: '4380', suburb: 'CANNON CREEK', state: 'QLD' },
  { postCode: '4380', suburb: 'DALCOUTH', state: 'QLD' },
  { postCode: '4380', suburb: 'DIAMONDVALE', state: 'QLD' },
  { postCode: '4380', suburb: 'EUKEY', state: 'QLD' },
  { postCode: '4380', suburb: 'GLENLYON', state: 'QLD' },
  { postCode: '4380', suburb: 'GREENLANDS', state: 'QLD' },
  { postCode: '4380', suburb: 'KYOOMBA', state: 'QLD' },
  { postCode: '4380', suburb: 'MINGOOLA', state: 'NSW' },
  { postCode: '4380', suburb: 'MINGOOLA', state: 'QLD' },
  { postCode: '4380', suburb: 'MOUNT TULLY', state: 'QLD' },
  { postCode: '4380', suburb: 'NUNDUBBERMERE', state: 'QLD' },
  { postCode: '4380', suburb: 'PIKEDALE', state: 'QLD' },
  { postCode: '4380', suburb: 'PIKES CREEK', state: 'QLD' },
  { postCode: '4380', suburb: 'RUBY CREEK', state: 'NSW' },
  { postCode: '4380', suburb: 'SEVERNLEA', state: 'QLD' },
  { postCode: '4380', suburb: 'SPRINGDALE', state: 'QLD' },
  { postCode: '4380', suburb: 'STANTHORPE', state: 'QLD' },
  { postCode: '4380', suburb: 'STORM KING', state: 'QLD' },
  { postCode: '4380', suburb: 'SUGARLOAF', state: 'QLD' },
  { postCode: '4380', suburb: 'THORNDALE', state: 'QLD' },
  { postCode: '4380', suburb: 'UNDERCLIFFE', state: 'NSW' },
  { postCode: '4381', suburb: 'FLETCHER', state: 'QLD' },
  { postCode: '4381', suburb: 'GLEN APLIN', state: 'QLD' },
  { postCode: '4382', suburb: 'BALLANDEAN', state: 'QLD' },
  { postCode: '4382', suburb: 'GIRRAWEEN', state: 'QLD' },
  { postCode: '4382', suburb: 'LYRA', state: 'QLD' },
  { postCode: '4382', suburb: 'SOMME', state: 'QLD' },
  { postCode: '4382', suburb: 'WYBERBA', state: 'QLD' },
  { postCode: '4383', suburb: 'JENNINGS', state: 'NSW' },
  { postCode: '4383', suburb: 'WALLANGARRA', state: 'QLD' },
  { postCode: '4384', suburb: 'LIMEVALE', state: 'QLD' },
  { postCode: '4385', suburb: 'BEEBO', state: 'QLD' },
  { postCode: '4385', suburb: 'BONSHAW', state: 'QLD' },
  { postCode: '4385', suburb: 'CAMP CREEK', state: 'NSW' },
  { postCode: '4385', suburb: 'GLENARBON', state: 'QLD' },
  { postCode: '4385', suburb: 'MAIDENHEAD', state: 'QLD' },
  { postCode: '4385', suburb: 'RIVERTON', state: 'QLD' },
  { postCode: '4385', suburb: 'SILVER SPUR', state: 'QLD' },
  { postCode: '4385', suburb: 'SMITHLEA', state: 'QLD' },
  { postCode: '4385', suburb: 'TEXAS', state: 'NSW' },
  { postCode: '4385', suburb: 'TEXAS', state: 'QLD' },
  { postCode: '4385', suburb: 'WATSONS CROSSING', state: 'QLD' },
  { postCode: '4387', suburb: 'BRUSH CREEK', state: 'QLD' },
  { postCode: '4387', suburb: 'BYBERA', state: 'QLD' },
  { postCode: '4387', suburb: 'COOLMUNDA', state: 'QLD' },
  { postCode: '4387', suburb: 'GREENUP', state: 'QLD' },
  { postCode: '4387', suburb: 'INGLEWOOD', state: 'QLD' },
  { postCode: '4387', suburb: 'MOSQUITO CREEK', state: 'QLD' },
  { postCode: '4387', suburb: 'TERRICA', state: 'QLD' },
  { postCode: '4387', suburb: 'WARROO', state: 'QLD' },
  { postCode: '4387', suburb: 'WHETSTONE', state: 'QLD' },
  { postCode: '4388', suburb: 'KURUMBUL', state: 'QLD' },
  { postCode: '4388', suburb: 'YELARBON', state: 'QLD' },
  { postCode: '4390', suburb: 'BILLA BILLA', state: 'QLD' },
  { postCode: '4390', suburb: 'CALINGUNEE', state: 'QLD' },
  { postCode: '4390', suburb: 'CALLANDOON', state: 'QLD' },
  { postCode: '4390', suburb: 'GOODAR', state: 'QLD' },
  { postCode: '4390', suburb: 'GOONDIWINDI', state: 'QLD' },
  { postCode: '4390', suburb: 'KINDON', state: 'QLD' },
  { postCode: '4390', suburb: 'LUNDAVRA', state: 'QLD' },
  { postCode: '4390', suburb: 'WONDALLI', state: 'QLD' },
  { postCode: '4390', suburb: 'WYAGA', state: 'QLD' },
  { postCode: '4390', suburb: 'YAGABURNE', state: 'QLD' },
  { postCode: '4400', suburb: 'KINGSTHORPE', state: 'QLD' },
  { postCode: '4401', suburb: 'ACLAND', state: 'QLD' },
  { postCode: '4401', suburb: 'AUBIGNY', state: 'QLD' },
  { postCode: '4401', suburb: 'BALGOWAN', state: 'QLD' },
  { postCode: '4401', suburb: 'BIDDESTON', state: 'QLD' },
  { postCode: '4401', suburb: 'BOODUA', state: 'QLD' },
  { postCode: '4401', suburb: 'DEVON PARK', state: 'QLD' },
  { postCode: '4401', suburb: 'GREENWOOD', state: 'QLD' },
  { postCode: '4401', suburb: 'HIGHLAND PLAINS', state: 'QLD' },
  { postCode: '4401', suburb: 'KELVINHAUGH', state: 'QLD' },
  { postCode: '4401', suburb: 'KINGS SIDING', state: 'QLD' },
  { postCode: '4401', suburb: 'MOUNT IRVING', state: 'QLD' },
  { postCode: '4401', suburb: 'MULDU', state: 'QLD' },
  { postCode: '4401', suburb: 'OAKEY', state: 'QLD' },
  { postCode: '4401', suburb: 'ROSALIE PLAINS', state: 'QLD' },
  { postCode: '4401', suburb: 'SABINE', state: 'QLD' },
  { postCode: '4401', suburb: 'SILVERLEIGH', state: 'QLD' },
  { postCode: '4401', suburb: 'YARGULLEN', state: 'QLD' },
  { postCode: '4402', suburb: 'COOYAR', state: 'QLD' },
  { postCode: '4402', suburb: 'KOORALGIN', state: 'QLD' },
  { postCode: '4402', suburb: 'UPPER COOYAR CREEK', state: 'QLD' },
  { postCode: '4403', suburb: 'BRYMAROO', state: 'QLD' },
  { postCode: '4403', suburb: 'JONDARYAN', state: 'QLD' },
  { postCode: '4403', suburb: 'MALU', state: 'QLD' },
  { postCode: '4403', suburb: 'MOUNT MORIAH', state: 'QLD' },
  { postCode: '4403', suburb: 'QUINALOW', state: 'QLD' },
  { postCode: '4403', suburb: 'WEST PRAIRIE', state: 'QLD' },
  { postCode: '4404', suburb: 'BOWENVILLE', state: 'QLD' },
  { postCode: '4404', suburb: 'FORMARTIN', state: 'QLD' },
  { postCode: '4404', suburb: 'IRVINGDALE', state: 'QLD' },
  { postCode: '4404', suburb: 'WAINUI', state: 'QLD' },
  { postCode: '4405', suburb: 'BLAXLAND', state: 'QLD' },
  { postCode: '4405', suburb: 'BUNYA MOUNTAINS', state: 'QLD' },
  { postCode: '4405', suburb: 'DALBY', state: 'QLD' },
  { postCode: '4405', suburb: 'DUCKLO', state: 'QLD' },
  { postCode: '4405', suburb: 'GRASSDALE', state: 'QLD' },
  { postCode: '4405', suburb: 'KUMBARILLA', state: 'QLD' },
  { postCode: '4405', suburb: 'MARMADUA', state: 'QLD' },
  { postCode: '4405', suburb: 'MOWBULLAN', state: 'QLD' },
  { postCode: '4405', suburb: 'PIRRINUAN', state: 'QLD' },
  { postCode: '4405', suburb: 'RANGES BRIDGE', state: 'QLD' },
  { postCode: '4405', suburb: 'ST RUTH', state: 'QLD' },
  { postCode: '4405', suburb: 'TIPTON', state: 'QLD' },
  { postCode: '4405', suburb: 'WERANGA', state: 'QLD' },
  { postCode: '4406', suburb: 'BOONDANDILLA', state: 'QLD' },
  { postCode: '4406', suburb: 'HANNAFORD', state: 'QLD' },
  { postCode: '4406', suburb: 'JIMBOUR', state: 'QLD' },
  { postCode: '4406', suburb: 'KAIMKILLENBUN', state: 'QLD' },
  { postCode: '4406', suburb: 'KOGAN', state: 'QLD' },
  { postCode: '4406', suburb: 'MACALISTER', state: 'QLD' },
  { postCode: '4406', suburb: 'MOOLA', state: 'QLD' },
  { postCode: '4406', suburb: 'MOONIE', state: 'QLD' },
  { postCode: '4406', suburb: 'SOUTHWOOD', state: 'QLD' },
  { postCode: '4406', suburb: 'THE GUMS', state: 'QLD' },
  { postCode: '4406', suburb: 'WEIR RIVER', state: 'QLD' },
  { postCode: '4407', suburb: 'CATTLE CREEK', state: 'QLD' },
  { postCode: '4407', suburb: 'CECIL PLAINS', state: 'QLD' },
  { postCode: '4407', suburb: 'DUNMORE', state: 'QLD' },
  { postCode: '4407', suburb: 'NANGWEE', state: 'QLD' },
  { postCode: '4408', suburb: 'BELL', state: 'QLD' },
  { postCode: '4410', suburb: 'JANDOWAE', state: 'QLD' },
  { postCode: '4411', suburb: 'WARRA', state: 'QLD' },
  { postCode: '4412', suburb: 'BRIGALOW', state: 'QLD' },
  { postCode: '4413', suburb: 'BAKING BOARD', state: 'QLD' },
  { postCode: '4413', suburb: 'BOONARGA', state: 'QLD' },
  { postCode: '4413', suburb: 'BURNCLUITH', state: 'QLD' },
  { postCode: '4413', suburb: 'CAMEBY', state: 'QLD' },
  { postCode: '4413', suburb: 'CANAGA', state: 'QLD' },
  { postCode: '4413', suburb: 'CHANCES PLAIN', state: 'QLD' },
  { postCode: '4413', suburb: 'CHINCHILLA', state: 'QLD' },
  { postCode: '4413', suburb: 'CROSSROADS', state: 'QLD' },
  { postCode: '4413', suburb: 'DURAH', state: 'QLD' },
  { postCode: '4413', suburb: 'HOPELAND', state: 'QLD' },
  { postCode: '4413', suburb: 'MONTROSE', state: 'QLD' },
  { postCode: '4413', suburb: 'WIEAMBILLA', state: 'QLD' },
  { postCode: '4415', suburb: 'COLUMBOOLA', state: 'QLD' },
  { postCode: '4415', suburb: 'DALWOGON', state: 'QLD' },
  { postCode: '4415', suburb: 'GURULMUNDI', state: 'QLD' },
  { postCode: '4415', suburb: 'HOOKSWOOD', state: 'QLD' },
  { postCode: '4415', suburb: 'KOWGURAN', state: 'QLD' },
  { postCode: '4415', suburb: 'MILES', state: 'QLD' },
  { postCode: '4415', suburb: 'MYALL PARK', state: 'QLD' },
  { postCode: '4415', suburb: 'PELHAM', state: 'QLD' },
  { postCode: '4416', suburb: 'BARRAMORNIE', state: 'QLD' },
  { postCode: '4416', suburb: 'CONDAMINE', state: 'QLD' },
  { postCode: '4416', suburb: 'MORABY', state: 'QLD' },
  { postCode: '4416', suburb: 'NANGRAM', state: 'QLD' },
  { postCode: '4416', suburb: 'PINE HILLS', state: 'QLD' },
  { postCode: '4416', suburb: 'SUNNYSIDE', state: 'QLD' },
  { postCode: '4416', suburb: 'YULABILLA', state: 'QLD' },
  { postCode: '4417', suburb: 'NOORINDOO', state: 'QLD' },
  { postCode: '4417', suburb: 'OBERINA', state: 'QLD' },
  { postCode: '4417', suburb: 'PARKNOOK', state: 'QLD' },
  { postCode: '4417', suburb: 'SURAT', state: 'QLD' },
  { postCode: '4417', suburb: 'WARKON', state: 'QLD' },
  { postCode: '4417', suburb: 'WELLESLEY', state: 'QLD' },
  { postCode: '4417', suburb: 'WERIBONE', state: 'QLD' },
  { postCode: '4418', suburb: 'GULUGUBA', state: 'QLD' },
  { postCode: '4419', suburb: 'COCKATOO', state: 'QLD' },
  { postCode: '4419', suburb: 'GROSMONT', state: 'QLD' },
  { postCode: '4419', suburb: 'WANDOAN', state: 'QLD' },
  { postCode: '4420', suburb: 'BROADMERE', state: 'QLD' },
  { postCode: '4420', suburb: 'COORADA', state: 'QLD' },
  { postCode: '4420', suburb: 'GHINGHINDA', state: 'QLD' },
  { postCode: '4420', suburb: 'GLENHAUGHTON', state: 'QLD' },
  { postCode: '4420', suburb: 'GWAMBEGWINE', state: 'QLD' },
  { postCode: '4420', suburb: 'HORNET BANK', state: 'QLD' },
  { postCode: '4420', suburb: 'SPRING CREEK', state: 'QLD' },
  { postCode: '4420', suburb: 'TAROOM', state: 'QLD' },
  { postCode: '4421', suburb: 'GORANBA', state: 'QLD' },
  { postCode: '4421', suburb: 'TARA', state: 'QLD' },
  { postCode: '4422', suburb: 'COOMRITH', state: 'QLD' },
  { postCode: '4422', suburb: 'FLINTON', state: 'QLD' },
  { postCode: '4422', suburb: 'INGLESTONE', state: 'QLD' },
  { postCode: '4422', suburb: 'MEANDARRA', state: 'QLD' },
  { postCode: '4422', suburb: 'WESTMAR', state: 'QLD' },
  { postCode: '4423', suburb: 'GLENMORGAN', state: 'QLD' },
  { postCode: '4423', suburb: 'TEELBA', state: 'QLD' },
  { postCode: '4424', suburb: 'DRILLHAM', state: 'QLD' },
  { postCode: '4424', suburb: 'DRILLHAM SOUTH', state: 'QLD' },
  { postCode: '4424', suburb: 'GLENAUBYN', state: 'QLD' },
  { postCode: '4425', suburb: 'BOGANDILLA', state: 'QLD' },
  { postCode: '4425', suburb: 'DULACCA', state: 'QLD' },
  { postCode: '4426', suburb: 'JACKSON', state: 'QLD' },
  { postCode: '4426', suburb: 'JACKSON NORTH', state: 'QLD' },
  { postCode: '4426', suburb: 'JACKSON SOUTH', state: 'QLD' },
  { postCode: '4427', suburb: 'CLIFFORD', state: 'QLD' },
  { postCode: '4427', suburb: 'YULEBA', state: 'QLD' },
  { postCode: '4427', suburb: 'YULEBA NORTH', state: 'QLD' },
  { postCode: '4427', suburb: 'YULEBA SOUTH', state: 'QLD' },
  { postCode: '4428', suburb: 'PICKANJINNIE', state: 'QLD' },
  { postCode: '4428', suburb: 'WALLUMBILLA', state: 'QLD' },
  { postCode: '4428', suburb: 'WALLUMBILLA NORTH', state: 'QLD' },
  { postCode: '4428', suburb: 'WALLUMBILLA SOUTH', state: 'QLD' },
  { postCode: '4454', suburb: 'BAFFLE WEST', state: 'QLD' },
  { postCode: '4454', suburb: 'BEILBA', state: 'QLD' },
  { postCode: '4454', suburb: 'DURHAM DOWNS', state: 'QLD' },
  { postCode: '4454', suburb: 'HIGHLAND PLAINS', state: 'QLD' },
  { postCode: '4454', suburb: 'HUTTON CREEK', state: 'QLD' },
  { postCode: '4454', suburb: 'INJUNE', state: 'QLD' },
  { postCode: '4454', suburb: 'MOUNT HOWE', state: 'QLD' },
  { postCode: '4454', suburb: 'MOUNT HUTTON', state: 'QLD' },
  { postCode: '4454', suburb: 'PONY HILLS', state: 'QLD' },
  { postCode: '4454', suburb: 'SIMMIE', state: 'QLD' },
  { postCode: '4454', suburb: 'UPPER DAWSON', state: 'QLD' },
  { postCode: '4454', suburb: 'WESTGROVE', state: 'QLD' },
  { postCode: '4455', suburb: 'BALLAROO', state: 'QLD' },
  { postCode: '4455', suburb: 'BLYTHDALE', state: 'QLD' },
  { postCode: '4455', suburb: 'BUNGEWORGORAI', state: 'QLD' },
  { postCode: '4455', suburb: 'BUNGIL', state: 'QLD' },
  { postCode: '4455', suburb: 'BYMOUNT', state: 'QLD' },
  { postCode: '4455', suburb: 'CORNWALL', state: 'QLD' },
  { postCode: '4455', suburb: 'DARGAL ROAD', state: 'QLD' },
  { postCode: '4455', suburb: 'EUMAMURRIN', state: 'QLD' },
  { postCode: '4455', suburb: 'EUTHULLA', state: 'QLD' },
  { postCode: '4455', suburb: 'GUNNEWIN', state: 'QLD' },
  { postCode: '4455', suburb: 'HODGSON', state: 'QLD' },
  { postCode: '4455', suburb: 'MOOGA', state: 'QLD' },
  { postCode: '4455', suburb: 'MOUNT ABUNDANCE', state: 'QLD' },
  { postCode: '4455', suburb: 'MOUNT BINDANGO', state: 'QLD' },
  { postCode: '4455', suburb: 'ORALLO', state: 'QLD' },
  { postCode: '4455', suburb: 'ORANGE HILL', state: 'QLD' },
  { postCode: '4455', suburb: 'ROMA', state: 'QLD' },
  { postCode: '4455', suburb: 'TINGUN', state: 'QLD' },
  { postCode: '4455', suburb: 'WYCOMBE', state: 'QLD' },
  { postCode: '4461', suburb: 'MUCKADILLA', state: 'QLD' },
  { postCode: '4462', suburb: 'AMBY', state: 'QLD' },
  { postCode: '4465', suburb: 'DUNKELD', state: 'QLD' },
  { postCode: '4465', suburb: 'FORESTVALE', state: 'QLD' },
  { postCode: '4465', suburb: 'MITCHELL', state: 'QLD' },
  { postCode: '4465', suburb: 'V GATE', state: 'QLD' },
  { postCode: '4465', suburb: 'WOMALILLA', state: 'QLD' },
  { postCode: '4467', suburb: 'MUNGALLALA', state: 'QLD' },
  { postCode: '4467', suburb: 'REDFORD', state: 'QLD' },
  { postCode: '4467', suburb: 'TYRCONNEL', state: 'QLD' },
  { postCode: '4468', suburb: 'CLARA CREEK', state: 'QLD' },
  { postCode: '4468', suburb: 'MORVEN', state: 'QLD' },
  { postCode: '4470', suburb: 'BAKERS BEND', state: 'QLD' },
  { postCode: '4470', suburb: 'CHARLEVILLE', state: 'QLD' },
  { postCode: '4470', suburb: 'GOWRIE STATION', state: 'QLD' },
  { postCode: '4470', suburb: 'LANGLO', state: 'QLD' },
  { postCode: '4470', suburb: 'MURWEH', state: 'QLD' },
  { postCode: '4470', suburb: 'RIVERSLEIGH', state: 'QLD' },
  { postCode: '4470', suburb: 'SOMMARIVA', state: 'QLD' },
  { postCode: '4470', suburb: 'WARD', state: 'QLD' },
  { postCode: '4471', suburb: 'CLAVERTON', state: 'QLD' },
  { postCode: '4472', suburb: 'BLACKALL', state: 'QLD' },
  { postCode: '4472', suburb: 'MOUNT ENNISKILLEN', state: 'QLD' },
  { postCode: '4474', suburb: 'ADAVALE', state: 'QLD' },
  { postCode: '4475', suburb: 'CHEEPIE', state: 'QLD' },
  { postCode: '4477', suburb: 'AUGATHELLA', state: 'QLD' },
  { postCode: '4477', suburb: 'UPPER WARREGO', state: 'QLD' },
  { postCode: '4478', suburb: 'BAYRICK', state: 'QLD' },
  { postCode: '4478', suburb: 'CALDERVALE', state: 'QLD' },
  { postCode: '4478', suburb: 'LANSDOWNE', state: 'QLD' },
  { postCode: '4478', suburb: 'LUMEAH', state: 'QLD' },
  { postCode: '4478', suburb: 'MACFARLANE', state: 'QLD' },
  { postCode: '4478', suburb: 'MINNIE DOWNS', state: 'QLD' },
  { postCode: '4478', suburb: 'TAMBO', state: 'QLD' },
  { postCode: '4478', suburb: 'WINDEYER', state: 'QLD' },
  { postCode: '4478', suburb: 'YANDARLO', state: 'QLD' },
  { postCode: '4479', suburb: 'COOLADDI', state: 'QLD' },
  { postCode: '4480', suburb: 'EROMANGA', state: 'QLD' },
  { postCode: '4480', suburb: 'QUILPIE', state: 'QLD' },
  { postCode: '4481', suburb: 'FARRARS CREEK', state: 'QLD' },
  { postCode: '4481', suburb: 'TANBAR', state: 'QLD' },
  { postCode: '4481', suburb: 'WINDORAH', state: 'QLD' },
  { postCode: '4482', suburb: 'BIRDSVILLE', state: 'QLD' },
  { postCode: '4486', suburb: 'DIRRANBANDI', state: 'QLD' },
  { postCode: '4486', suburb: 'HEBEL', state: 'QLD' },
  { postCode: '4487', suburb: 'BEGONIA', state: 'QLD' },
  { postCode: '4487', suburb: 'ST GEORGE', state: 'QLD' },
  { postCode: '4488', suburb: 'BOLLON', state: 'QLD' },
  { postCode: '4488', suburb: 'NEBINE', state: 'QLD' },
  { postCode: '4489', suburb: 'WYANDRA', state: 'QLD' },
  { postCode: '4490', suburb: 'BARRINGUN', state: 'QLD' },
  { postCode: '4490', suburb: 'COONGOOLA', state: 'QLD' },
  { postCode: '4490', suburb: 'CUNNAMULLA', state: 'QLD' },
  { postCode: '4490', suburb: 'CUTTABURRA', state: 'QLD' },
  { postCode: '4490', suburb: 'HUMEBURN', state: 'QLD' },
  { postCode: '4490', suburb: 'JOBS GATE', state: 'QLD' },
  { postCode: '4490', suburb: 'LINDEN', state: 'QLD' },
  { postCode: '4490', suburb: 'NOORAMA', state: 'QLD' },
  { postCode: '4490', suburb: 'TUEN', state: 'QLD' },
  { postCode: '4490', suburb: 'WIDGEEGOARA', state: 'QLD' },
  { postCode: '4490', suburb: 'YOWAH', state: 'QLD' },
  { postCode: '4491', suburb: 'EULO', state: 'QLD' },
  { postCode: '4492', suburb: 'BULLAWARRA', state: 'QLD' },
  { postCode: '4492', suburb: 'BULLOO DOWNS', state: 'QLD' },
  { postCode: '4492', suburb: 'DYNEVOR', state: 'QLD' },
  { postCode: '4492', suburb: 'NOCKATUNGA', state: 'QLD' },
  { postCode: '4492', suburb: 'NORLEY', state: 'QLD' },
  { postCode: '4492', suburb: 'THARGOMINDAH', state: 'QLD' },
  { postCode: '4493', suburb: 'HUNGERFORD', state: 'QLD' },
  { postCode: '4494', suburb: 'BUNGUNYA', state: 'QLD' },
  { postCode: '4494', suburb: 'NORTH BUNGUNYA', state: 'QLD' },
  { postCode: '4494', suburb: 'TARAWERA', state: 'QLD' },
  { postCode: '4496', suburb: 'NORTH TALWOOD', state: 'QLD' },
  { postCode: '4496', suburb: 'SOUTH TALWOOD', state: 'QLD' },
  { postCode: '4496', suburb: 'TALWOOD', state: 'QLD' },
  { postCode: '4497', suburb: 'DAYMAR', state: 'QLD' },
  { postCode: '4497', suburb: 'THALLON', state: 'QLD' },
  { postCode: '4497', suburb: 'WEENGALLON', state: 'QLD' },
  { postCode: '4498', suburb: 'KIOMA', state: 'QLD' },
  { postCode: '4498', suburb: 'TOOBEAH', state: 'QLD' },
  { postCode: '4500', suburb: 'BRAY PARK', state: 'QLD' },
  { postCode: '4500', suburb: 'BRENDALE', state: 'QLD' },
  { postCode: '4500', suburb: 'BRENDALE BC', state: 'QLD' },
  { postCode: '4500', suburb: 'BRENDALE DC', state: 'QLD' },
  { postCode: '4500', suburb: 'CASHMERE', state: 'QLD' },
  { postCode: '4500', suburb: 'CLEAR MOUNTAIN', state: 'QLD' },
  { postCode: '4500', suburb: 'JOYNER', state: 'QLD' },
  { postCode: '4500', suburb: 'STRATHPINE', state: 'QLD' },
  { postCode: '4500', suburb: 'STRATHPINE CENTRE', state: 'QLD' },
  { postCode: '4500', suburb: 'WARNER', state: 'QLD' },
  { postCode: '4501', suburb: 'LAWNTON', state: 'QLD' },
  { postCode: '4502', suburb: 'PETRIE', state: 'QLD' },
  { postCode: '4503', suburb: 'DAKABIN', state: 'QLD' },
  { postCode: '4503', suburb: 'GRIFFIN', state: 'QLD' },
  { postCode: '4503', suburb: 'KALLANGUR', state: 'QLD' },
  { postCode: '4503', suburb: 'KURWONGBAH', state: 'QLD' },
  { postCode: '4503', suburb: 'MURRUMBA DOWNS', state: 'QLD' },
  { postCode: '4503', suburb: 'WHITESIDE', state: 'QLD' },
  { postCode: '4504', suburb: 'NARANGBA', state: 'QLD' },
  { postCode: '4505', suburb: 'BURPENGARY', state: 'QLD' },
  { postCode: '4505', suburb: 'BURPENGARY DC', state: 'QLD' },
  { postCode: '4505', suburb: 'BURPENGARY EAST', state: 'QLD' },
  { postCode: '4506', suburb: 'MOORINA', state: 'QLD' },
  { postCode: '4506', suburb: 'MORAYFIELD', state: 'QLD' },
  { postCode: '4507', suburb: 'BANKSIA BEACH', state: 'QLD' },
  { postCode: '4507', suburb: 'BELLARA', state: 'QLD' },
  { postCode: '4507', suburb: 'BONGAREE', state: 'QLD' },
  { postCode: '4507', suburb: 'BRIBIE ISLAND', state: 'QLD' },
  { postCode: '4507', suburb: 'BRIBIE ISLAND NORTH', state: 'QLD' },
  { postCode: '4507', suburb: 'WELSBY', state: 'QLD' },
  { postCode: '4507', suburb: 'WHITE PATCH', state: 'QLD' },
  { postCode: '4507', suburb: 'WOORIM', state: 'QLD' },
  { postCode: '4508', suburb: 'DECEPTION BAY', state: 'QLD' },
  { postCode: '4509', suburb: 'MANGO HILL', state: 'QLD' },
  { postCode: '4509', suburb: 'NORTH LAKES', state: 'QLD' },
  { postCode: '4510', suburb: 'BEACHMERE', state: 'QLD' },
  { postCode: '4510', suburb: 'BELLMERE', state: 'QLD' },
  { postCode: '4510', suburb: 'CABOOLTURE', state: 'QLD' },
  { postCode: '4510', suburb: 'CABOOLTURE BC', state: 'QLD' },
  { postCode: '4510', suburb: 'CABOOLTURE SOUTH', state: 'QLD' },
  { postCode: '4510', suburb: 'DONNYBROOK', state: 'QLD' },
  { postCode: '4510', suburb: 'MELDALE', state: 'QLD' },
  { postCode: '4510', suburb: 'MOODLU', state: 'QLD' },
  { postCode: '4510', suburb: 'ROCKSBERG', state: 'QLD' },
  { postCode: '4510', suburb: 'TOORBUL', state: 'QLD' },
  { postCode: '4510', suburb: 'UPPER CABOOLTURE', state: 'QLD' },
  { postCode: '4511', suburb: 'GODWIN BEACH', state: 'QLD' },
  { postCode: '4511', suburb: 'NINGI', state: 'QLD' },
  { postCode: '4511', suburb: 'SANDSTONE POINT', state: 'QLD' },
  { postCode: '4512', suburb: 'BRACALBA', state: 'QLD' },
  { postCode: '4512', suburb: 'WAMURAN', state: 'QLD' },
  { postCode: '4512', suburb: 'WAMURAN BASIN', state: 'QLD' },
  { postCode: '4514', suburb: 'BELLTHORPE', state: 'QLD' },
  { postCode: '4514', suburb: 'CEDARTON', state: 'QLD' },
  { postCode: '4514', suburb: 'COMMISSIONERS FLAT', state: 'QLD' },
  { postCode: '4514', suburb: "D'AGUILAR", state: 'QLD' },
  { postCode: '4514', suburb: 'DELANEYS CREEK', state: 'QLD' },
  { postCode: '4514', suburb: 'MOUNT ARCHER', state: 'QLD' },
  { postCode: '4514', suburb: 'MOUNT DELANEY', state: 'QLD' },
  { postCode: '4514', suburb: 'NEURUM', state: 'QLD' },
  { postCode: '4514', suburb: 'STANMORE', state: 'QLD' },
  { postCode: '4514', suburb: 'STONY CREEK', state: 'QLD' },
  { postCode: '4514', suburb: 'VILLENEUVE', state: 'QLD' },
  { postCode: '4514', suburb: 'WOODFORD', state: 'QLD' },
  { postCode: '4515', suburb: 'GLENFERN', state: 'QLD' },
  { postCode: '4515', suburb: 'HAZELDEAN', state: 'QLD' },
  { postCode: '4515', suburb: 'JIMNA', state: 'QLD' },
  { postCode: '4515', suburb: 'KILCOY', state: 'QLD' },
  { postCode: '4515', suburb: 'KINGAHAM', state: 'QLD' },
  { postCode: '4515', suburb: 'MONSILDALE', state: 'QLD' },
  { postCode: '4515', suburb: 'MOUNT KILCOY', state: 'QLD' },
  { postCode: '4515', suburb: 'ROYSTON', state: 'QLD' },
  { postCode: '4515', suburb: 'SANDY CREEK', state: 'QLD' },
  { postCode: '4515', suburb: 'SHEEP STATION CREEK', state: 'QLD' },
  { postCode: '4515', suburb: 'WINYA', state: 'QLD' },
  { postCode: '4515', suburb: 'WOOLMAR', state: 'QLD' },
  { postCode: '4516', suburb: 'ELIMBAH', state: 'QLD' },
  { postCode: '4517', suburb: 'BEERBURRUM', state: 'QLD' },
  { postCode: '4518', suburb: 'GLASS HOUSE MOUNTAINS', state: 'QLD' },
  { postCode: '4519', suburb: 'BEERWAH', state: 'QLD' },
  { postCode: '4519', suburb: 'COOCHIN CREEK', state: 'QLD' },
  { postCode: '4519', suburb: 'CROHAMHURST', state: 'QLD' },
  { postCode: '4519', suburb: 'PEACHESTER', state: 'QLD' },
  { postCode: '4520', suburb: 'ARMSTRONG CREEK', state: 'QLD' },
  { postCode: '4520', suburb: 'CAMP MOUNTAIN', state: 'QLD' },
  { postCode: '4520', suburb: 'CEDAR CREEK', state: 'QLD' },
  { postCode: '4520', suburb: 'CLOSEBURN', state: 'QLD' },
  { postCode: '4520', suburb: 'DRAPER', state: 'QLD' },
  { postCode: '4520', suburb: 'ENOGGERA RESERVOIR', state: 'QLD' },
  { postCode: '4520', suburb: 'HIGHVALE', state: 'QLD' },
  { postCode: '4520', suburb: 'JOLLYS LOOKOUT', state: 'QLD' },
  { postCode: '4520', suburb: 'KOBBLE CREEK', state: 'QLD' },
  { postCode: '4520', suburb: 'MOUNT GLORIOUS', state: 'QLD' },
  { postCode: '4520', suburb: 'MOUNT NEBO', state: 'QLD' },
  { postCode: '4520', suburb: 'MOUNT SAMSON', state: 'QLD' },
  { postCode: '4520', suburb: 'SAMFORD', state: 'QLD' },
  { postCode: '4520', suburb: 'SAMFORD VALLEY', state: 'QLD' },
  { postCode: '4520', suburb: 'SAMFORD VILLAGE', state: 'QLD' },
  { postCode: '4520', suburb: 'SAMSONVALE', state: 'QLD' },
  { postCode: '4520', suburb: 'WIGHTS MOUNTAIN', state: 'QLD' },
  { postCode: '4520', suburb: 'YUGAR', state: 'QLD' },
  { postCode: '4521', suburb: 'CAMPBELLS POCKET', state: 'QLD' },
  { postCode: '4521', suburb: 'DAYBORO', state: 'QLD' },
  { postCode: '4521', suburb: 'KING SCRUB', state: 'QLD' },
  { postCode: '4521', suburb: 'LACEYS CREEK', state: 'QLD' },
  { postCode: '4521', suburb: 'MOUNT MEE', state: 'QLD' },
  { postCode: '4521', suburb: 'MOUNT PLEASANT', state: 'QLD' },
  { postCode: '4521', suburb: 'OCEAN VIEW', state: 'QLD' },
  { postCode: '4521', suburb: 'RUSH CREEK', state: 'QLD' },
  { postCode: '4550', suburb: 'LANDSBOROUGH', state: 'QLD' },
  { postCode: '4550', suburb: 'MOUNT MELLUM', state: 'QLD' },
  { postCode: '4551', suburb: 'AROONA', state: 'QLD' },
  { postCode: '4551', suburb: 'BANYA', state: 'QLD' },
  { postCode: '4551', suburb: 'BARINGA', state: 'QLD' },
  { postCode: '4551', suburb: 'BATTERY HILL', state: 'QLD' },
  { postCode: '4551', suburb: 'BELLS CREEK', state: 'QLD' },
  { postCode: '4551', suburb: 'CALOUNDRA', state: 'QLD' },
  { postCode: '4551', suburb: 'CALOUNDRA DC', state: 'QLD' },
  { postCode: '4551', suburb: 'CALOUNDRA WEST', state: 'QLD' },
  { postCode: '4551', suburb: 'CORBOULD PARK', state: 'QLD' },
  { postCode: '4551', suburb: 'CURRIMUNDI', state: 'QLD' },
  { postCode: '4551', suburb: 'DICKY BEACH', state: 'QLD' },
  { postCode: '4551', suburb: 'GAGALBA', state: 'QLD' },
  { postCode: '4551', suburb: 'GOLDEN BEACH', state: 'QLD' },
  { postCode: '4551', suburb: 'KINGS BEACH', state: 'QLD' },
  { postCode: '4551', suburb: 'LITTLE MOUNTAIN', state: 'QLD' },
  { postCode: '4551', suburb: 'MERIDAN PLAINS', state: 'QLD' },
  { postCode: '4551', suburb: 'MOFFAT BEACH', state: 'QLD' },
  { postCode: '4551', suburb: 'NIRIMBA', state: 'QLD' },
  { postCode: '4551', suburb: 'PELICAN WATERS', state: 'QLD' },
  { postCode: '4551', suburb: 'SHELLY BEACH', state: 'QLD' },
  { postCode: '4552', suburb: 'BALD KNOB', state: 'QLD' },
  { postCode: '4552', suburb: 'BALMORAL RIDGE', state: 'QLD' },
  { postCode: '4552', suburb: 'BOOROOBIN', state: 'QLD' },
  { postCode: '4552', suburb: 'CAMBROON', state: 'QLD' },
  { postCode: '4552', suburb: 'CONONDALE', state: 'QLD' },
  { postCode: '4552', suburb: 'CRYSTAL WATERS', state: 'QLD' },
  { postCode: '4552', suburb: 'CURRAMORE', state: 'QLD' },
  { postCode: '4552', suburb: 'ELAMAN CREEK', state: 'QLD' },
  { postCode: '4552', suburb: 'HARPER CREEK', state: 'QLD' },
  { postCode: '4552', suburb: 'MALENY', state: 'QLD' },
  { postCode: '4552', suburb: 'NORTH MALENY', state: 'QLD' },
  { postCode: '4552', suburb: 'REESVILLE', state: 'QLD' },
  { postCode: '4552', suburb: 'WITTA', state: 'QLD' },
  { postCode: '4552', suburb: 'WOOTHA', state: 'QLD' },
  { postCode: '4553', suburb: 'DIAMOND VALLEY', state: 'QLD' },
  { postCode: '4553', suburb: 'GLENVIEW', state: 'QLD' },
  { postCode: '4553', suburb: 'MOOLOOLAH', state: 'QLD' },
  { postCode: '4553', suburb: 'MOOLOOLAH VALLEY', state: 'QLD' },
  { postCode: '4553', suburb: 'PALMVIEW', state: 'QLD' },
  { postCode: '4554', suburb: 'EUDLO', state: 'QLD' },
  { postCode: '4554', suburb: 'ILKLEY', state: 'QLD' },
  { postCode: '4555', suburb: 'CHEVALLUM', state: 'QLD' },
  { postCode: '4555', suburb: 'HUNCHY', state: 'QLD' },
  { postCode: '4555', suburb: 'LANDERS SHOOT', state: 'QLD' },
  { postCode: '4555', suburb: 'PALMWOODS', state: 'QLD' },
  { postCode: '4556', suburb: 'BUDERIM', state: 'QLD' },
  { postCode: '4556', suburb: 'FOREST GLEN', state: 'QLD' },
  { postCode: '4556', suburb: 'KUNDA PARK', state: 'QLD' },
  { postCode: '4556', suburb: 'MONS', state: 'QLD' },
  { postCode: '4556', suburb: 'SIPPY DOWNS', state: 'QLD' },
  { postCode: '4556', suburb: 'TANAWHA', state: 'QLD' },
  { postCode: '4557', suburb: 'MOOLOOLABA', state: 'QLD' },
  { postCode: '4557', suburb: 'MOUNTAIN CREEK', state: 'QLD' },
  { postCode: '4558', suburb: 'COTTON TREE', state: 'QLD' },
  { postCode: '4558', suburb: 'KULUIN', state: 'QLD' },
  { postCode: '4558', suburb: 'MAROOCHYDORE', state: 'QLD' },
  { postCode: '4558', suburb: 'MAROOCHYDORE BC', state: 'QLD' },
  { postCode: '4558', suburb: 'MAROOCHYDORE DC', state: 'QLD' },
  { postCode: '4558', suburb: 'SUNSHINE PLAZA', state: 'QLD' },
  { postCode: '4559', suburb: 'DIDDILLIBAH', state: 'QLD' },
  { postCode: '4559', suburb: 'KIELS MOUNTAIN', state: 'QLD' },
  { postCode: '4559', suburb: 'WEST WOOMBYE', state: 'QLD' },
  { postCode: '4559', suburb: 'WOOMBYE', state: 'QLD' },
  { postCode: '4560', suburb: 'BLI BLI', state: 'QLD' },
  { postCode: '4560', suburb: 'BURNSIDE', state: 'QLD' },
  { postCode: '4560', suburb: 'COES CREEK', state: 'QLD' },
  { postCode: '4560', suburb: 'COOLOOLABIN', state: 'QLD' },
  { postCode: '4560', suburb: 'DULONG', state: 'QLD' },
  { postCode: '4560', suburb: 'FLAXTON', state: 'QLD' },
  { postCode: '4560', suburb: 'HIGHWORTH', state: 'QLD' },
  { postCode: '4560', suburb: 'IMAGE FLAT', state: 'QLD' },
  { postCode: '4560', suburb: 'KIAMBA', state: 'QLD' },
  { postCode: '4560', suburb: 'KULANGOOR', state: 'QLD' },
  { postCode: '4560', suburb: 'KUREELPA', state: 'QLD' },
  { postCode: '4560', suburb: 'MAPLETON', state: 'QLD' },
  { postCode: '4560', suburb: 'MONTVILLE', state: 'QLD' },
  { postCode: '4560', suburb: 'NAMBOUR', state: 'QLD' },
  { postCode: '4560', suburb: 'NAMBOUR BC', state: 'QLD' },
  { postCode: '4560', suburb: 'NAMBOUR DC', state: 'QLD' },
  { postCode: '4560', suburb: 'NAMBOUR WEST', state: 'QLD' },
  { postCode: '4560', suburb: 'PARKLANDS', state: 'QLD' },
  { postCode: '4560', suburb: 'PERWILLOWEN', state: 'QLD' },
  { postCode: '4560', suburb: 'ROSEMOUNT', state: 'QLD' },
  { postCode: '4560', suburb: 'SUNSHINE COAST MC', state: 'QLD' },
  { postCode: '4560', suburb: 'TOWEN MOUNTAIN', state: 'QLD' },
  { postCode: '4561', suburb: 'BRIDGES', state: 'QLD' },
  { postCode: '4561', suburb: 'MAROOCHY RIVER', state: 'QLD' },
  { postCode: '4561', suburb: 'NINDERRY', state: 'QLD' },
  { postCode: '4561', suburb: 'NORTH ARM', state: 'QLD' },
  { postCode: '4561', suburb: 'VALDORA', state: 'QLD' },
  { postCode: '4561', suburb: 'YANDINA', state: 'QLD' },
  { postCode: '4561', suburb: 'YANDINA CREEK', state: 'QLD' },
  { postCode: '4562', suburb: 'BELLI PARK', state: 'QLD' },
  { postCode: '4562', suburb: 'DOONAN', state: 'QLD' },
  { postCode: '4562', suburb: 'EERWAH VALE', state: 'QLD' },
  { postCode: '4562', suburb: 'EUMUNDI', state: 'QLD' },
  { postCode: '4562', suburb: 'VERRIERDALE', state: 'QLD' },
  { postCode: '4562', suburb: 'WEYBA DOWNS', state: 'QLD' },
  { postCode: '4563', suburb: 'BLACK MOUNTAIN', state: 'QLD' },
  { postCode: '4563', suburb: 'CARTERS RIDGE', state: 'QLD' },
  { postCode: '4563', suburb: 'COOROY', state: 'QLD' },
  { postCode: '4563', suburb: 'COOROY MOUNTAIN', state: 'QLD' },
  { postCode: '4563', suburb: 'LAKE MACDONALD', state: 'QLD' },
  { postCode: '4563', suburb: 'RIDGEWOOD', state: 'QLD' },
  { postCode: '4563', suburb: 'TINBEERWAH', state: 'QLD' },
  { postCode: '4564', suburb: 'MARCOOLA', state: 'QLD' },
  { postCode: '4564', suburb: 'MUDJIMBA', state: 'QLD' },
  { postCode: '4564', suburb: 'PACIFIC PARADISE', state: 'QLD' },
  { postCode: '4564', suburb: 'TWIN WATERS', state: 'QLD' },
  { postCode: '4565', suburb: 'BOREEN POINT', state: 'QLD' },
  { postCode: '4565', suburb: 'COOROIBAH', state: 'QLD' },
  { postCode: '4565', suburb: 'COOTHARABA', state: 'QLD' },
  { postCode: '4565', suburb: 'NOOSA NORTH SHORE', state: 'QLD' },
  { postCode: '4565', suburb: 'RINGTAIL CREEK', state: 'QLD' },
  { postCode: '4565', suburb: 'TEWANTIN', state: 'QLD' },
  { postCode: '4566', suburb: 'NOOSAVILLE', state: 'QLD' },
  { postCode: '4566', suburb: 'NOOSAVILLE DC', state: 'QLD' },
  { postCode: '4567', suburb: 'CASTAWAYS BEACH', state: 'QLD' },
  { postCode: '4567', suburb: 'NOOSA HEADS', state: 'QLD' },
  { postCode: '4567', suburb: 'SUNRISE BEACH', state: 'QLD' },
  { postCode: '4567', suburb: 'SUNSHINE BEACH', state: 'QLD' },
  { postCode: '4568', suburb: 'FEDERAL', state: 'QLD' },
  { postCode: '4568', suburb: 'PINBARREN', state: 'QLD' },
  { postCode: '4568', suburb: 'POMONA', state: 'QLD' },
  { postCode: '4569', suburb: 'COORAN', state: 'QLD' },
  { postCode: '4570', suburb: 'AMAMOOR', state: 'QLD' },
  { postCode: '4570', suburb: 'AMAMOOR CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'ANDERLEIGH', state: 'QLD' },
  { postCode: '4570', suburb: 'ARALUEN', state: 'QLD' },
  { postCode: '4570', suburb: 'BANKS POCKET', state: 'QLD' },
  { postCode: '4570', suburb: 'BEENAAM VALLEY', state: 'QLD' },
  { postCode: '4570', suburb: 'BELLA CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'BELLS BRIDGE', state: 'QLD' },
  { postCode: '4570', suburb: 'BOLLIER', state: 'QLD' },
  { postCode: '4570', suburb: 'BROOLOO', state: 'QLD' },
  { postCode: '4570', suburb: 'CALGOA', state: 'QLD' },
  { postCode: '4570', suburb: 'CALICO CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'CANINA', state: 'QLD' },
  { postCode: '4570', suburb: 'CEDAR POCKET', state: 'QLD' },
  { postCode: '4570', suburb: 'CHATSWORTH', state: 'QLD' },
  { postCode: '4570', suburb: 'COLES CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'COONDOO', state: 'QLD' },
  { postCode: '4570', suburb: 'CORELLA', state: 'QLD' },
  { postCode: '4570', suburb: 'CURRA', state: 'QLD' },
  { postCode: '4570', suburb: 'DAGUN', state: 'QLD' },
  { postCode: '4570', suburb: 'DOWNSFIELD', state: 'QLD' },
  { postCode: '4570', suburb: 'EAST DEEP CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'FISHERMANS POCKET', state: 'QLD' },
  { postCode: '4570', suburb: 'GILLDORA', state: 'QLD' },
  { postCode: '4570', suburb: 'GLANMIRE', state: 'QLD' },
  { postCode: '4570', suburb: 'GLASTONBURY', state: 'QLD' },
  { postCode: '4570', suburb: 'GLEN ECHO', state: 'QLD' },
  { postCode: '4570', suburb: 'GLENWOOD', state: 'QLD' },
  { postCode: '4570', suburb: 'GOOMBOORIAN', state: 'QLD' },
  { postCode: '4570', suburb: 'GREENS CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'GUNALDA', state: 'QLD' },
  { postCode: '4570', suburb: 'GYMPIE', state: 'QLD' },
  { postCode: '4570', suburb: 'GYMPIE DC', state: 'QLD' },
  { postCode: '4570', suburb: 'IMBIL', state: 'QLD' },
  { postCode: '4570', suburb: 'JONES HILL', state: 'QLD' },
  { postCode: '4570', suburb: 'KANDANGA', state: 'QLD' },
  { postCode: '4570', suburb: 'KANDANGA CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'KANIGAN', state: 'QLD' },
  { postCode: '4570', suburb: 'KIA ORA', state: 'QLD' },
  { postCode: '4570', suburb: 'KYBONG', state: 'QLD' },
  { postCode: '4570', suburb: 'LAGOON POCKET', state: 'QLD' },
  { postCode: '4570', suburb: 'LAKE BORUMBA', state: 'QLD' },
  { postCode: '4570', suburb: 'LANGSHAW', state: 'QLD' },
  { postCode: '4570', suburb: 'LONG FLAT', state: 'QLD' },
  { postCode: '4570', suburb: 'LOWER WONGA', state: 'QLD' },
  { postCode: '4570', suburb: 'MARODIAN', state: 'QLD' },
  { postCode: '4570', suburb: 'MARYS CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'MCINTOSH CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'MELAWONDI', state: 'QLD' },
  { postCode: '4570', suburb: 'MIVA', state: 'QLD' },
  { postCode: '4570', suburb: 'MONKLAND', state: 'QLD' },
  { postCode: '4570', suburb: 'MOOLOO', state: 'QLD' },
  { postCode: '4570', suburb: 'MOTHAR MOUNTAIN', state: 'QLD' },
  { postCode: '4570', suburb: 'MUNNA CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'NAHRUNDA', state: 'QLD' },
  { postCode: '4570', suburb: 'NEERDIE', state: 'QLD' },
  { postCode: '4570', suburb: 'NEUSA VALE', state: 'QLD' },
  { postCode: '4570', suburb: 'NORTH DEEP CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'PATERSON', state: 'QLD' },
  { postCode: '4570', suburb: 'PIE CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'ROSS CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'SCOTCHY POCKET', state: 'QLD' },
  { postCode: '4570', suburb: 'SCRUBBY CREEK', state: 'QLD' },
  { postCode: '4570', suburb: 'SEXTON', state: 'QLD' },
  { postCode: '4570', suburb: 'SOUTHSIDE', state: 'QLD' },
  { postCode: '4570', suburb: 'TAMAREE', state: 'QLD' },
  { postCode: '4570', suburb: 'TANDUR', state: 'QLD' },
  { postCode: '4570', suburb: 'THE DAWN', state: 'QLD' },
  { postCode: '4570', suburb: 'THE PALMS', state: 'QLD' },
  { postCode: '4570', suburb: 'THEEBINE', state: 'QLD' },
  { postCode: '4570', suburb: 'TOOLARA FOREST', state: 'QLD' },
  { postCode: '4570', suburb: 'TRAVESTON', state: 'QLD' },
  { postCode: '4570', suburb: 'TUCHEKOI', state: 'QLD' },
  { postCode: '4570', suburb: 'TWO MILE', state: 'QLD' },
  { postCode: '4570', suburb: 'UPPER GLASTONBURY', state: 'QLD' },
  { postCode: '4570', suburb: 'UPPER KANDANGA', state: 'QLD' },
  { postCode: '4570', suburb: 'VETERAN', state: 'QLD' },
  { postCode: '4570', suburb: 'VICTORY HEIGHTS', state: 'QLD' },
  { postCode: '4570', suburb: 'WALLU', state: 'QLD' },
  { postCode: '4570', suburb: 'WIDGEE', state: 'QLD' },
  { postCode: '4570', suburb: 'WIDGEE CROSSING NORTH', state: 'QLD' },
  { postCode: '4570', suburb: 'WIDGEE CROSSING SOUTH', state: 'QLD' },
  { postCode: '4570', suburb: 'WILSONS POCKET', state: 'QLD' },
  { postCode: '4570', suburb: 'WOLVI', state: 'QLD' },
  { postCode: '4570', suburb: 'WOOLOOGA', state: 'QLD' },
  { postCode: '4570', suburb: 'WOONDUM', state: 'QLD' },
  { postCode: '4571', suburb: 'COMO', state: 'QLD' },
  { postCode: '4571', suburb: 'KIN KIN', state: 'QLD' },
  { postCode: '4572', suburb: 'ALEXANDRA HEADLAND', state: 'QLD' },
  { postCode: '4573', suburb: 'COOLUM BEACH', state: 'QLD' },
  { postCode: '4573', suburb: 'MARCUS BEACH', state: 'QLD' },
  { postCode: '4573', suburb: 'MOUNT COOLUM', state: 'QLD' },
  { postCode: '4573', suburb: 'PEREGIAN BEACH', state: 'QLD' },
  { postCode: '4573', suburb: 'PEREGIAN SPRINGS', state: 'QLD' },
  { postCode: '4573', suburb: 'POINT ARKWRIGHT', state: 'QLD' },
  { postCode: '4573', suburb: 'YAROOMBA', state: 'QLD' },
  { postCode: '4574', suburb: 'COOLABINE', state: 'QLD' },
  { postCode: '4574', suburb: 'GHEERULLA', state: 'QLD' },
  { postCode: '4574', suburb: 'KENILWORTH', state: 'QLD' },
  { postCode: '4574', suburb: 'KIDAMAN CREEK', state: 'QLD' },
  { postCode: '4574', suburb: 'MOY POCKET', state: 'QLD' },
  { postCode: '4574', suburb: 'OBI OBI', state: 'QLD' },
  { postCode: '4575', suburb: 'BIRTINYA', state: 'QLD' },
  { postCode: '4575', suburb: 'BOKARINA', state: 'QLD' },
  { postCode: '4575', suburb: 'BUDDINA', state: 'QLD' },
  { postCode: '4575', suburb: 'MINYAMA', state: 'QLD' },
  { postCode: '4575', suburb: 'PARREARRA', state: 'QLD' },
  { postCode: '4575', suburb: 'WARANA', state: 'QLD' },
  { postCode: '4575', suburb: 'WURTULLA', state: 'QLD' },
  { postCode: '4580', suburb: 'COOLOOLA', state: 'QLD' },
  { postCode: '4580', suburb: 'COOLOOLA COVE', state: 'QLD' },
  { postCode: '4580', suburb: 'TIN CAN BAY', state: 'QLD' },
  { postCode: '4581', suburb: 'EURONG', state: 'QLD' },
  { postCode: '4581', suburb: 'FRASER ISLAND', state: 'QLD' },
  { postCode: '4581', suburb: 'INSKIP', state: 'QLD' },
  { postCode: '4581', suburb: 'ORCHID BEACH', state: 'QLD' },
  { postCode: '4581', suburb: 'RAINBOW BEACH', state: 'QLD' },
  { postCode: '4600', suburb: 'BLACK SNAKE', state: 'QLD' },
  { postCode: '4600', suburb: 'CINNABAR', state: 'QLD' },
  { postCode: '4600', suburb: 'KILKIVAN', state: 'QLD' },
  { postCode: '4600', suburb: 'MUDLO', state: 'QLD' },
  { postCode: '4600', suburb: 'OAKVIEW', state: 'QLD' },
  { postCode: '4601', suburb: 'BARAMBAH', state: 'QLD' },
  { postCode: '4601', suburb: 'BOONARA', state: 'QLD' },
  { postCode: '4601', suburb: 'BOOUBYJAN', state: 'QLD' },
  { postCode: '4601', suburb: 'GOOMERI', state: 'QLD' },
  { postCode: '4601', suburb: 'GOOMERIBONG', state: 'QLD' },
  { postCode: '4601', suburb: 'KINBOMBI', state: 'QLD' },
  { postCode: '4601', suburb: 'MANUMBAR', state: 'QLD' },
  { postCode: '4601', suburb: 'TANSEY', state: 'QLD' },
  { postCode: '4601', suburb: 'WRATTENS FOREST', state: 'QLD' },
  { postCode: '4605', suburb: 'BARLIL', state: 'QLD' },
  { postCode: '4605', suburb: 'BYEE', state: 'QLD' },
  { postCode: '4605', suburb: 'CHERBOURG', state: 'QLD' },
  { postCode: '4605', suburb: 'CLOYNA', state: 'QLD' },
  { postCode: '4605', suburb: 'COBBS HILL', state: 'QLD' },
  { postCode: '4605', suburb: 'CROWNTHORPE', state: 'QLD' },
  { postCode: '4605', suburb: 'GLENROCK', state: 'QLD' },
  { postCode: '4605', suburb: 'KITOBA', state: 'QLD' },
  { postCode: '4605', suburb: 'MANYUNG', state: 'QLD' },
  { postCode: '4605', suburb: 'MERLWOOD', state: 'QLD' },
  { postCode: '4605', suburb: 'MOFFATDALE', state: 'QLD' },
  { postCode: '4605', suburb: 'MOONDOONER', state: 'QLD' },
  { postCode: '4605', suburb: 'MURGON', state: 'QLD' },
  { postCode: '4605', suburb: 'OAKDALE', state: 'QLD' },
  { postCode: '4605', suburb: 'REDGATE', state: 'QLD' },
  { postCode: '4605', suburb: 'SILVERLEAF', state: 'QLD' },
  { postCode: '4605', suburb: 'SUNNY NOOK', state: 'QLD' },
  { postCode: '4605', suburb: 'TABLELANDS', state: 'QLD' },
  { postCode: '4605', suburb: 'WARNUNG', state: 'QLD' },
  { postCode: '4605', suburb: 'WINDERA', state: 'QLD' },
  { postCode: '4605', suburb: 'WOOROONDEN', state: 'QLD' },
  { postCode: '4606', suburb: 'CHELMSFORD', state: 'QLD' },
  { postCode: '4606', suburb: 'FAIRDALE', state: 'QLD' },
  { postCode: '4606', suburb: 'FICKS CROSSING', state: 'QLD' },
  { postCode: '4606', suburb: 'GREENVIEW', state: 'QLD' },
  { postCode: '4606', suburb: 'LEAFDALE', state: 'QLD' },
  { postCode: '4606', suburb: 'MOUNT MCEUEN', state: 'QLD' },
  { postCode: '4606', suburb: 'MP CREEK', state: 'QLD' },
  { postCode: '4606', suburb: 'WHEATLANDS', state: 'QLD' },
  { postCode: '4606', suburb: 'WONDAI', state: 'QLD' },
  { postCode: '4608', suburb: 'CHARLESTOWN', state: 'QLD' },
  { postCode: '4608', suburb: 'CUSHNIE', state: 'QLD' },
  { postCode: '4608', suburb: 'TINGOORA', state: 'QLD' },
  { postCode: '4608', suburb: 'WILKESDALE', state: 'QLD' },
  { postCode: '4608', suburb: 'WOOROOLIN', state: 'QLD' },
  { postCode: '4610', suburb: 'ALICE CREEK', state: 'QLD' },
  { postCode: '4610', suburb: 'BALLOGIE', state: 'QLD' },
  { postCode: '4610', suburb: 'BENAIR', state: 'QLD' },
  { postCode: '4610', suburb: 'BOOIE', state: 'QLD' },
  { postCode: '4610', suburb: 'BOYNESIDE', state: 'QLD' },
  { postCode: '4610', suburb: 'CHAHPINGAH', state: 'QLD' },
  { postCode: '4610', suburb: 'COOLABUNIA', state: 'QLD' },
  { postCode: '4610', suburb: 'CORNDALE', state: 'QLD' },
  { postCode: '4610', suburb: 'CRAWFORD', state: 'QLD' },
  { postCode: '4610', suburb: 'DANGORE', state: 'QLD' },
  { postCode: '4610', suburb: 'DURONG', state: 'QLD' },
  { postCode: '4610', suburb: 'ELLESMERE', state: 'QLD' },
  { postCode: '4610', suburb: 'GOODGER', state: 'QLD' },
  { postCode: '4610', suburb: 'GORDONBROOK', state: 'QLD' },
  { postCode: '4610', suburb: 'HALY CREEK', state: 'QLD' },
  { postCode: '4610', suburb: 'HODGLEIGH', state: 'QLD' },
  { postCode: '4610', suburb: 'INVERLAW', state: 'QLD' },
  { postCode: '4610', suburb: 'IRONPOT', state: 'QLD' },
  { postCode: '4610', suburb: 'KINGAROY', state: 'QLD' },
  { postCode: '4610', suburb: 'KINGAROY DC', state: 'QLD' },
  { postCode: '4610', suburb: 'KUMBIA', state: 'QLD' },
  { postCode: '4610', suburb: 'MANNUEM', state: 'QLD' },
  { postCode: '4610', suburb: 'MEMERAMBI', state: 'QLD' },
  { postCode: '4610', suburb: 'TAABINGA', state: 'QLD' },
  { postCode: '4610', suburb: 'WATTLE GROVE', state: 'QLD' },
  { postCode: '4611', suburb: 'MARSHLANDS', state: 'QLD' },
  { postCode: '4611', suburb: 'MONDURE', state: 'QLD' },
  { postCode: '4612', suburb: 'HIVESVILLE', state: 'QLD' },
  { postCode: '4612', suburb: 'KAWL KAWL', state: 'QLD' },
  { postCode: '4612', suburb: 'KEYSLAND', state: 'QLD' },
  { postCode: '4612', suburb: 'STONELANDS', state: 'QLD' },
  { postCode: '4612', suburb: 'WIGTON', state: 'QLD' },
  { postCode: '4613', suburb: 'ABBEYWOOD', state: 'QLD' },
  { postCode: '4613', suburb: 'BOONDOOMA', state: 'QLD' },
  { postCode: '4613', suburb: 'BRIGOODA', state: 'QLD' },
  { postCode: '4613', suburb: 'COVERTY', state: 'QLD' },
  { postCode: '4613', suburb: 'KINLEYMORE', state: 'QLD' },
  { postCode: '4613', suburb: 'MELROSE', state: 'QLD' },
  { postCode: '4613', suburb: 'OKEDEN', state: 'QLD' },
  { postCode: '4613', suburb: 'PROSTON', state: 'QLD' },
  { postCode: '4613', suburb: 'SPEEDWELL', state: 'QLD' },
  { postCode: '4613', suburb: 'STALWORTH', state: 'QLD' },
  { postCode: '4614', suburb: 'NEUMGNA', state: 'QLD' },
  { postCode: '4614', suburb: 'UPPER YARRAMAN', state: 'QLD' },
  { postCode: '4614', suburb: 'YARRAMAN', state: 'QLD' },
  { postCode: '4615', suburb: 'BARKER CREEK FLAT', state: 'QLD' },
  { postCode: '4615', suburb: 'BROOKLANDS', state: 'QLD' },
  { postCode: '4615', suburb: 'BULLCAMP', state: 'QLD' },
  { postCode: '4615', suburb: 'EAST NANANGO', state: 'QLD' },
  { postCode: '4615', suburb: 'ELGIN VALE', state: 'QLD' },
  { postCode: '4615', suburb: 'GLAN DEVON', state: 'QLD' },
  { postCode: '4615', suburb: 'JOHNSTOWN', state: 'QLD' },
  { postCode: '4615', suburb: 'KUNIOON', state: 'QLD' },
  { postCode: '4615', suburb: 'MAIDENWELL', state: 'QLD' },
  { postCode: '4615', suburb: 'NANANGO', state: 'QLD' },
  { postCode: '4615', suburb: 'PIMPIMBUDGEE', state: 'QLD' },
  { postCode: '4615', suburb: 'RUNNYMEDE', state: 'QLD' },
  { postCode: '4615', suburb: 'SANDY RIDGES', state: 'QLD' },
  { postCode: '4615', suburb: 'SOUTH EAST NANANGO', state: 'QLD' },
  { postCode: '4615', suburb: 'SOUTH NANANGO', state: 'QLD' },
  { postCode: '4615', suburb: 'TARONG', state: 'QLD' },
  { postCode: '4615', suburb: 'WATTLE CAMP', state: 'QLD' },
  { postCode: '4615', suburb: 'WENGENVILLE', state: 'QLD' },
  { postCode: '4615', suburb: 'WYALLA', state: 'QLD' },
  { postCode: '4620', suburb: 'ARAMARA', state: 'QLD' },
  { postCode: '4620', suburb: 'BROOWEENA', state: 'QLD' },
  { postCode: '4620', suburb: 'DOONGUL', state: 'QLD' },
  { postCode: '4620', suburb: 'GIGOOMGAN', state: 'QLD' },
  { postCode: '4620', suburb: 'GLENBAR', state: 'QLD' },
  { postCode: '4620', suburb: 'GUNGALOON', state: 'QLD' },
  { postCode: '4620', suburb: 'MALARGA', state: 'QLD' },
  { postCode: '4620', suburb: 'NORTH ARAMARA', state: 'QLD' },
  { postCode: '4620', suburb: 'TEEBAR', state: 'QLD' },
  { postCode: '4620', suburb: 'WOOCOO', state: 'QLD' },
  { postCode: '4621', suburb: 'BIGGENDEN', state: 'QLD' },
  { postCode: '4621', suburb: 'BOOMPA', state: 'QLD' },
  { postCode: '4621', suburb: 'COALSTOUN LAKES', state: 'QLD' },
  { postCode: '4621', suburb: 'CORINGA', state: 'QLD' },
  { postCode: '4621', suburb: 'DALLARNIL', state: 'QLD' },
  { postCode: '4621', suburb: 'DEGILBO', state: 'QLD' },
  { postCode: '4621', suburb: 'DIDCOT', state: 'QLD' },
  { postCode: '4621', suburb: 'GOLDEN FLEECE', state: 'QLD' },
  { postCode: '4621', suburb: 'LAKESIDE', state: 'QLD' },
  { postCode: '4621', suburb: 'WATERANGA', state: 'QLD' },
  { postCode: '4621', suburb: 'WOOWOONGA', state: 'QLD' },
  { postCode: '4625', suburb: 'ARANBANGA', state: 'QLD' },
  { postCode: '4625', suburb: 'BAN BAN', state: 'QLD' },
  { postCode: '4625', suburb: 'BAN BAN SPRINGS', state: 'QLD' },
  { postCode: '4625', suburb: 'BARLYNE', state: 'QLD' },
  { postCode: '4625', suburb: 'BINJOUR', state: 'QLD' },
  { postCode: '4625', suburb: 'BLAIRMORE', state: 'QLD' },
  { postCode: '4625', suburb: 'BON ACCORD', state: 'QLD' },
  { postCode: '4625', suburb: 'BRANCH CREEK', state: 'QLD' },
  { postCode: '4625', suburb: 'BYRNESTOWN', state: 'QLD' },
  { postCode: '4625', suburb: 'CAMPBELL CREEK', state: 'QLD' },
  { postCode: '4625', suburb: 'DEEP CREEK', state: 'QLD' },
  { postCode: '4625', suburb: 'DIRNBIR', state: 'QLD' },
  { postCode: '4625', suburb: 'DUNDARRAH', state: 'QLD' },
  { postCode: '4625', suburb: 'GAYNDAH', state: 'QLD' },
  { postCode: '4625', suburb: 'GINOONDAN', state: 'QLD' },
  { postCode: '4625', suburb: 'GOOROOLBA', state: 'QLD' },
  { postCode: '4625', suburb: 'HARRIET', state: 'QLD' },
  { postCode: '4625', suburb: 'HUMPHERY', state: 'QLD' },
  { postCode: '4625', suburb: 'IDERAWAY', state: 'QLD' },
  { postCode: '4625', suburb: 'MINGO', state: 'QLD' },
  { postCode: '4625', suburb: 'MOUNT DEBATEABLE', state: 'QLD' },
  { postCode: '4625', suburb: 'MOUNT LAWLESS', state: 'QLD' },
  { postCode: '4625', suburb: 'MOUNT STEADMAN', state: 'QLD' },
  { postCode: '4625', suburb: 'PENWHAUPELL', state: 'QLD' },
  { postCode: '4625', suburb: 'PILE GULLY', state: 'QLD' },
  { postCode: '4625', suburb: 'REIDS CREEK', state: 'QLD' },
  { postCode: '4625', suburb: 'STOCKHAVEN', state: 'QLD' },
  { postCode: '4625', suburb: 'THE LIMITS', state: 'QLD' },
  { postCode: '4625', suburb: 'TOONDAHRA', state: 'QLD' },
  { postCode: '4625', suburb: 'WAHOON', state: 'QLD' },
  { postCode: '4625', suburb: 'WETHERON', state: 'QLD' },
  { postCode: '4625', suburb: 'WILSON VALLEY', state: 'QLD' },
  { postCode: '4625', suburb: 'WOODMILLAR', state: 'QLD' },
  { postCode: '4625', suburb: 'YENDA', state: 'QLD' },
  { postCode: '4626', suburb: 'BEERON', state: 'QLD' },
  { postCode: '4626', suburb: 'BOYNEWOOD', state: 'QLD' },
  { postCode: '4626', suburb: 'BROVINIA', state: 'QLD' },
  { postCode: '4626', suburb: 'CATTLE CREEK', state: 'QLD' },
  { postCode: '4626', suburb: 'COONAMBULA', state: 'QLD' },
  { postCode: '4626', suburb: 'DERRI DERRA', state: 'QLD' },
  { postCode: '4626', suburb: 'DYKEHEAD', state: 'QLD' },
  { postCode: '4626', suburb: 'GLENRAE', state: 'QLD' },
  { postCode: '4626', suburb: 'GURGEENA', state: 'QLD' },
  { postCode: '4626', suburb: 'HAWKWOOD', state: 'QLD' },
  { postCode: '4626', suburb: 'MONOGORILBY', state: 'QLD' },
  { postCode: '4626', suburb: 'MUNDOWRAN', state: 'QLD' },
  { postCode: '4626', suburb: 'MUNDUBBERA', state: 'QLD' },
  { postCode: '4626', suburb: "O'BIL BIL", state: 'QLD' },
  { postCode: '4626', suburb: 'OLD COORANGA', state: 'QLD' },
  { postCode: '4626', suburb: 'PHILPOTT', state: 'QLD' },
  { postCode: '4626', suburb: 'RIVERLEIGH', state: 'QLD' },
  { postCode: '4627', suburb: 'ABERCORN', state: 'QLD' },
  { postCode: '4627', suburb: 'CERATODUS', state: 'QLD' },
  { postCode: '4627', suburb: 'CHELTENHAM', state: 'QLD' },
  { postCode: '4627', suburb: 'CYNTHIA', state: 'QLD' },
  { postCode: '4627', suburb: 'EIDSVOLD', state: 'QLD' },
  { postCode: '4627', suburb: 'EIDSVOLD EAST', state: 'QLD' },
  { postCode: '4627', suburb: 'EIDSVOLD WEST', state: 'QLD' },
  { postCode: '4627', suburb: 'GROSVENOR', state: 'QLD' },
  { postCode: '4627', suburb: 'MALMOE', state: 'QLD' },
  { postCode: '4627', suburb: 'WURUMA DAM', state: 'QLD' },
  { postCode: '4630', suburb: 'BANCROFT', state: 'QLD' },
  { postCode: '4630', suburb: 'BUKALI', state: 'QLD' },
  { postCode: '4630', suburb: 'CANIA', state: 'QLD' },
  { postCode: '4630', suburb: 'CANNINDAH', state: 'QLD' },
  { postCode: '4630', suburb: 'COOMINGLAH', state: 'QLD' },
  { postCode: '4630', suburb: 'COOMINGLAH FOREST', state: 'QLD' },
  { postCode: '4630', suburb: 'DALGA', state: 'QLD' },
  { postCode: '4630', suburb: 'GLENLEIGH', state: 'QLD' },
  { postCode: '4630', suburb: 'HARRAMI', state: 'QLD' },
  { postCode: '4630', suburb: 'KALPOWAR', state: 'QLD' },
  { postCode: '4630', suburb: 'KAPALDO', state: 'QLD' },
  { postCode: '4630', suburb: 'LANGLEY', state: 'QLD' },
  { postCode: '4630', suburb: 'MONAL', state: 'QLD' },
  { postCode: '4630', suburb: 'MONTO', state: 'QLD' },
  { postCode: '4630', suburb: 'MOONFORD', state: 'QLD' },
  { postCode: '4630', suburb: 'MULGILDIE', state: 'QLD' },
  { postCode: '4630', suburb: 'MUNGUNGO', state: 'QLD' },
  { postCode: '4630', suburb: 'RAWBELLE', state: 'QLD' },
  { postCode: '4630', suburb: 'SELENE', state: 'QLD' },
  { postCode: '4630', suburb: 'SPLINTER CREEK', state: 'QLD' },
  { postCode: '4630', suburb: 'TELLEBANG', state: 'QLD' },
  { postCode: '4630', suburb: 'THREE MOON', state: 'QLD' },
  { postCode: '4630', suburb: 'VENTNOR', state: 'QLD' },
  { postCode: '4630', suburb: 'YARROL', state: 'QLD' },
  { postCode: '4650', suburb: 'ALDERSHOT', state: 'QLD' },
  { postCode: '4650', suburb: 'ANTIGUA', state: 'QLD' },
  { postCode: '4650', suburb: 'BAUPLE', state: 'QLD' },
  { postCode: '4650', suburb: 'BAUPLE FOREST', state: 'QLD' },
  { postCode: '4650', suburb: 'BEAVER ROCK', state: 'QLD' },
  { postCode: '4650', suburb: 'BIDWILL', state: 'QLD' },
  { postCode: '4650', suburb: 'BOONOOROO', state: 'QLD' },
  { postCode: '4650', suburb: 'BOONOOROO PLAINS', state: 'QLD' },
  { postCode: '4650', suburb: 'DUCKINWILLA', state: 'QLD' },
  { postCode: '4650', suburb: 'DUNDATHU', state: 'QLD' },
  { postCode: '4650', suburb: 'DUNMORA', state: 'QLD' },
  { postCode: '4650', suburb: 'FERNEY', state: 'QLD' },
  { postCode: '4650', suburb: 'GLENORCHY', state: 'QLD' },
  { postCode: '4650', suburb: 'GOOTCHIE', state: 'QLD' },
  { postCode: '4650', suburb: 'GRAHAMS CREEK', state: 'QLD' },
  { postCode: '4650', suburb: 'GRANVILLE', state: 'QLD' },
  { postCode: '4650', suburb: 'GUNDIAH', state: 'QLD' },
  { postCode: '4650', suburb: 'ISLAND PLANTATION', state: 'QLD' },
  { postCode: '4650', suburb: 'MAAROOM', state: 'QLD' },
  { postCode: '4650', suburb: 'MAGNOLIA', state: 'QLD' },
  { postCode: '4650', suburb: 'MARYBOROUGH', state: 'QLD' },
  { postCode: '4650', suburb: 'MARYBOROUGH DC', state: 'QLD' },
  { postCode: '4650', suburb: 'MARYBOROUGH WEST', state: 'QLD' },
  { postCode: '4650', suburb: 'MOUNT URAH', state: 'QLD' },
  { postCode: '4650', suburb: 'MUNGAR', state: 'QLD' },
  { postCode: '4650', suburb: 'NETHERBY', state: 'QLD' },
  { postCode: '4650', suburb: 'OAKHURST', state: 'QLD' },
  { postCode: '4650', suburb: 'OWANYILLA', state: 'QLD' },
  { postCode: '4650', suburb: 'PALLAS STREET MARYBOROUGH', state: 'QLD' },
  { postCode: '4650', suburb: 'PILERWA', state: 'QLD' },
  { postCode: '4650', suburb: 'PIONEERS REST', state: 'QLD' },
  { postCode: '4650', suburb: 'POONA', state: 'QLD' },
  { postCode: '4650', suburb: 'PRAWLE', state: 'QLD' },
  { postCode: '4650', suburb: 'ST HELENS', state: 'QLD' },
  { postCode: '4650', suburb: 'ST MARY', state: 'QLD' },
  { postCode: '4650', suburb: 'TALEGALLA WEIR', state: 'QLD' },
  { postCode: '4650', suburb: 'TANDORA', state: 'QLD' },
  { postCode: '4650', suburb: 'TEDDINGTON', state: 'QLD' },
  { postCode: '4650', suburb: 'THE DIMONDS', state: 'QLD' },
  { postCode: '4650', suburb: 'THINOOMBA', state: 'QLD' },
  { postCode: '4650', suburb: 'TIARO', state: 'QLD' },
  { postCode: '4650', suburb: 'TINANA', state: 'QLD' },
  { postCode: '4650', suburb: 'TINANA SOUTH', state: 'QLD' },
  { postCode: '4650', suburb: 'TINNANBAR', state: 'QLD' },
  { postCode: '4650', suburb: 'TUAN', state: 'QLD' },
  { postCode: '4650', suburb: 'TUAN FOREST', state: 'QLD' },
  { postCode: '4650', suburb: 'WALKERS POINT', state: 'QLD' },
  { postCode: '4650', suburb: 'YENGARIE', state: 'QLD' },
  { postCode: '4650', suburb: 'YERRA', state: 'QLD' },
  { postCode: '4655', suburb: 'BOORAL', state: 'QLD' },
  { postCode: '4655', suburb: 'BUNYA CREEK', state: 'QLD' },
  { postCode: '4655', suburb: 'CRAIGNISH', state: 'QLD' },
  { postCode: '4655', suburb: 'DUNDOWRAN', state: 'QLD' },
  { postCode: '4655', suburb: 'DUNDOWRAN BEACH', state: 'QLD' },
  { postCode: '4655', suburb: 'ELI WATERS', state: 'QLD' },
  { postCode: '4655', suburb: 'GREAT SANDY STRAIT', state: 'QLD' },
  { postCode: '4655', suburb: 'HERVEY BAY', state: 'QLD' },
  { postCode: '4655', suburb: 'HERVEY BAY DC', state: 'QLD' },
  { postCode: '4655', suburb: 'KAWUNGAN', state: 'QLD' },
  { postCode: '4655', suburb: 'KINGFISHER BAY RESORT', state: 'QLD' },
  { postCode: '4655', suburb: 'NIKENBAH', state: 'QLD' },
  { postCode: '4655', suburb: 'PIALBA', state: 'QLD' },
  { postCode: '4655', suburb: 'POINT VERNON', state: 'QLD' },
  { postCode: '4655', suburb: 'RIVER HEADS', state: 'QLD' },
  { postCode: '4655', suburb: 'SCARNESS', state: 'QLD' },
  { postCode: '4655', suburb: 'SUNSHINE ACRES', state: 'QLD' },
  { postCode: '4655', suburb: 'SUSAN RIVER', state: 'QLD' },
  { postCode: '4655', suburb: 'TAKURA', state: 'QLD' },
  { postCode: '4655', suburb: 'TOOGOOM', state: 'QLD' },
  { postCode: '4655', suburb: 'TORQUAY', state: 'QLD' },
  { postCode: '4655', suburb: 'URANGAN', state: 'QLD' },
  { postCode: '4655', suburb: 'URRAWEEN', state: 'QLD' },
  { postCode: '4655', suburb: 'WALLIEBUM', state: 'QLD' },
  { postCode: '4655', suburb: 'WALLIGAN', state: 'QLD' },
  { postCode: '4655', suburb: 'WONDUNNA', state: 'QLD' },
  { postCode: '4659', suburb: 'BEELBI CREEK', state: 'QLD' },
  { postCode: '4659', suburb: 'BURGOWAN', state: 'QLD' },
  { postCode: '4659', suburb: 'BURRUM HEADS', state: 'QLD' },
  { postCode: '4659', suburb: 'BURRUM RIVER', state: 'QLD' },
  { postCode: '4659', suburb: 'BURRUM TOWN', state: 'QLD' },
  { postCode: '4659', suburb: 'HOWARD', state: 'QLD' },
  { postCode: '4659', suburb: 'PACIFIC HAVEN', state: 'QLD' },
  { postCode: '4660', suburb: 'ABINGTON', state: 'QLD' },
  { postCode: '4660', suburb: 'APPLE TREE CREEK', state: 'QLD' },
  { postCode: '4660', suburb: 'BUXTON', state: 'QLD' },
  { postCode: '4660', suburb: 'CHERWELL', state: 'QLD' },
  { postCode: '4660', suburb: 'CHILDERS', state: 'QLD' },
  { postCode: '4660', suburb: 'CORDALBA', state: 'QLD' },
  { postCode: '4660', suburb: 'DOOLBI', state: 'QLD' },
  { postCode: '4660', suburb: 'EUREKA', state: 'QLD' },
  { postCode: '4660', suburb: 'FARNSFIELD', state: 'QLD' },
  { postCode: '4660', suburb: 'GOODWOOD', state: 'QLD' },
  { postCode: '4660', suburb: 'GREGORY RIVER', state: 'QLD' },
  { postCode: '4660', suburb: 'HORTON', state: 'QLD' },
  { postCode: '4660', suburb: 'ISIS CENTRAL', state: 'QLD' },
  { postCode: '4660', suburb: 'ISIS RIVER', state: 'QLD' },
  { postCode: '4660', suburb: 'KULLOGUM', state: 'QLD' },
  { postCode: '4660', suburb: 'NORTH GREGORY', state: 'QLD' },
  { postCode: '4660', suburb: 'NORTH ISIS', state: 'QLD' },
  { postCode: '4660', suburb: 'PROMISEDLAND', state: 'QLD' },
  { postCode: '4660', suburb: 'REDRIDGE', state: 'QLD' },
  { postCode: '4660', suburb: 'SOUTH ISIS', state: 'QLD' },
  { postCode: '4660', suburb: 'WOODGATE', state: 'QLD' },
  { postCode: '4662', suburb: 'TORBANLEA', state: 'QLD' },
  { postCode: '4670', suburb: 'ABBOTSFORD', state: 'QLD' },
  { postCode: '4670', suburb: 'ALLOWAY', state: 'QLD' },
  { postCode: '4670', suburb: 'ASHFIELD', state: 'QLD' },
  { postCode: '4670', suburb: 'AVENELL HEIGHTS', state: 'QLD' },
  { postCode: '4670', suburb: 'AVOCA', state: 'QLD' },
  { postCode: '4670', suburb: 'AVONDALE', state: 'QLD' },
  { postCode: '4670', suburb: 'BARGARA', state: 'QLD' },
  { postCode: '4670', suburb: 'BRANYAN', state: 'QLD' },
  { postCode: '4670', suburb: 'BUCCA', state: 'QLD' },
  { postCode: '4670', suburb: 'BUNDABERG', state: 'QLD' },
  { postCode: '4670', suburb: 'BUNDABERG CENTRAL', state: 'QLD' },
  { postCode: '4670', suburb: 'BUNDABERG DC', state: 'QLD' },
  { postCode: '4670', suburb: 'BUNDABERG EAST', state: 'QLD' },
  { postCode: '4670', suburb: 'BUNDABERG NORTH', state: 'QLD' },
  { postCode: '4670', suburb: 'BUNDABERG SOUTH', state: 'QLD' },
  { postCode: '4670', suburb: 'BUNDABERG WEST', state: 'QLD' },
  { postCode: '4670', suburb: 'BURNETT HEADS', state: 'QLD' },
  { postCode: '4670', suburb: 'CALAVOS', state: 'QLD' },
  { postCode: '4670', suburb: 'COONARR', state: 'QLD' },
  { postCode: '4670', suburb: 'CORAL COVE', state: 'QLD' },
  { postCode: '4670', suburb: 'ELECTRA', state: 'QLD' },
  { postCode: '4670', suburb: 'ELLIOTT', state: 'QLD' },
  { postCode: '4670', suburb: 'ELLIOTT HEADS', state: 'QLD' },
  { postCode: '4670', suburb: 'FAIRYMEAD', state: 'QLD' },
  { postCode: '4670', suburb: 'GIVELDA', state: 'QLD' },
  { postCode: '4670', suburb: 'GOOBURRUM', state: 'QLD' },
  { postCode: '4670', suburb: 'INNES PARK', state: 'QLD' },
  { postCode: '4670', suburb: 'KALKIE', state: 'QLD' },
  { postCode: '4670', suburb: 'KENSINGTON', state: 'QLD' },
  { postCode: '4670', suburb: 'KEPNOCK', state: 'QLD' },
  { postCode: '4670', suburb: 'KINKUNA', state: 'QLD' },
  { postCode: '4670', suburb: 'MEADOWVALE', state: 'QLD' },
  { postCode: '4670', suburb: 'MILLBANK', state: 'QLD' },
  { postCode: '4670', suburb: 'MON REPOS', state: 'QLD' },
  { postCode: '4670', suburb: 'MOORE PARK BEACH', state: 'QLD' },
  { postCode: '4670', suburb: 'MOORLAND', state: 'QLD' },
  { postCode: '4670', suburb: 'MULLETT CREEK', state: 'QLD' },
  { postCode: '4670', suburb: 'NORVILLE', state: 'QLD' },
  { postCode: '4670', suburb: 'OAKWOOD', state: 'QLD' },
  { postCode: '4670', suburb: 'PINE CREEK', state: 'QLD' },
  { postCode: '4670', suburb: 'QUNABA', state: 'QLD' },
  { postCode: '4670', suburb: 'RUBYANNA', state: 'QLD' },
  { postCode: '4670', suburb: 'SHARON', state: 'QLD' },
  { postCode: '4670', suburb: 'SOUTH BINGERA', state: 'QLD' },
  { postCode: '4670', suburb: 'SOUTH KOLAN', state: 'QLD' },
  { postCode: '4670', suburb: 'SVENSSON HEIGHTS', state: 'QLD' },
  { postCode: '4670', suburb: 'THABEBAN', state: 'QLD' },
  { postCode: '4670', suburb: 'WALKERVALE', state: 'QLD' },
  { postCode: '4670', suburb: 'WATALGAN', state: 'QLD' },
  { postCode: '4670', suburb: 'WELCOME CREEK', state: 'QLD' },
  { postCode: '4670', suburb: 'WINDERMERE', state: 'QLD' },
  { postCode: '4670', suburb: 'WINFIELD', state: 'QLD' },
  { postCode: '4670', suburb: 'WOONGARRA', state: 'QLD' },
  { postCode: '4671', suburb: 'BOOLBOONDA', state: 'QLD' },
  { postCode: '4671', suburb: 'BOOYAL', state: 'QLD' },
  { postCode: '4671', suburb: 'BULLYARD', state: 'QLD' },
  { postCode: '4671', suburb: 'BUNGADOO', state: 'QLD' },
  { postCode: '4671', suburb: 'DALYSFORD', state: 'QLD' },
  { postCode: '4671', suburb: 'DAMASCUS', state: 'QLD' },
  { postCode: '4671', suburb: 'DELAN', state: 'QLD' },
  { postCode: '4671', suburb: 'DOUGHBOY', state: 'QLD' },
  { postCode: '4671', suburb: 'DRINAN', state: 'QLD' },
  { postCode: '4671', suburb: 'DUINGAL', state: 'QLD' },
  { postCode: '4671', suburb: 'GAETA', state: 'QLD' },
  { postCode: '4671', suburb: 'GIN GIN', state: 'QLD' },
  { postCode: '4671', suburb: 'GOOD NIGHT', state: 'QLD' },
  { postCode: '4671', suburb: 'HORSE CAMP', state: 'QLD' },
  { postCode: '4671', suburb: 'KOLONGA', state: 'QLD' },
  { postCode: '4671', suburb: 'LAKE MONDURAN', state: 'QLD' },
  { postCode: '4671', suburb: 'MAROONDAN', state: 'QLD' },
  { postCode: '4671', suburb: 'MCILWRAITH', state: 'QLD' },
  { postCode: '4671', suburb: 'MOLANGUL', state: 'QLD' },
  { postCode: '4671', suburb: 'MONDURAN', state: 'QLD' },
  { postCode: '4671', suburb: 'MOOLBOOLAMAN', state: 'QLD' },
  { postCode: '4671', suburb: 'MORGANVILLE', state: 'QLD' },
  { postCode: '4671', suburb: 'MOUNT PERRY', state: 'QLD' },
  { postCode: '4671', suburb: 'MUNGY', state: 'QLD' },
  { postCode: '4671', suburb: 'NEARUM', state: 'QLD' },
  { postCode: '4671', suburb: 'NEW MOONTA', state: 'QLD' },
  { postCode: '4671', suburb: 'REDHILL FARMS', state: 'QLD' },
  { postCode: '4671', suburb: 'SKYRING RESERVE', state: 'QLD' },
  { postCode: '4671', suburb: 'ST AGNES', state: 'QLD' },
  { postCode: '4671', suburb: 'ST KILDA', state: 'QLD' },
  { postCode: '4671', suburb: 'TAKILBERAN', state: 'QLD' },
  { postCode: '4671', suburb: 'TIRROAN', state: 'QLD' },
  { postCode: '4671', suburb: 'WALLAVILLE', state: 'QLD' },
  { postCode: '4671', suburb: 'WONBAH', state: 'QLD' },
  { postCode: '4671', suburb: 'WONBAH FOREST', state: 'QLD' },
  { postCode: '4673', suburb: 'MIARA', state: 'QLD' },
  { postCode: '4673', suburb: 'WATERLOO', state: 'QLD' },
  { postCode: '4673', suburb: 'YANDARAN', state: 'QLD' },
  { postCode: '4674', suburb: 'BAFFLE CREEK', state: 'QLD' },
  { postCode: '4674', suburb: 'BERAJONDO', state: 'QLD' },
  { postCode: '4674', suburb: 'DEEPWATER', state: 'QLD' },
  { postCode: '4674', suburb: 'EULEILAH', state: 'QLD' },
  { postCode: '4674', suburb: 'MOUNT MARIA', state: 'QLD' },
  { postCode: '4674', suburb: 'OYSTER CREEK', state: 'QLD' },
  { postCode: '4674', suburb: 'ROSEDALE', state: 'QLD' },
  { postCode: '4674', suburb: 'RULES BEACH', state: 'QLD' },
  { postCode: '4674', suburb: 'TAUNTON', state: 'QLD' },
  { postCode: '4676', suburb: 'GINDORAN', state: 'QLD' },
  { postCode: '4676', suburb: 'LOWMEAD', state: 'QLD' },
  { postCode: '4677', suburb: 'AGNES WATER', state: 'QLD' },
  { postCode: '4677', suburb: 'CAPTAIN CREEK', state: 'QLD' },
  { postCode: '4677', suburb: 'COLOSSEUM', state: 'QLD' },
  { postCode: '4677', suburb: 'EURIMBULA', state: 'QLD' },
  { postCode: '4677', suburb: 'MIRIAM VALE', state: 'QLD' },
  { postCode: '4677', suburb: 'MOUNT TOM', state: 'QLD' },
  { postCode: '4677', suburb: 'ROUND HILL', state: 'QLD' },
  { postCode: '4677', suburb: 'SEVENTEEN SEVENTY', state: 'QLD' },
  { postCode: '4678', suburb: 'BOROREN', state: 'QLD' },
  { postCode: '4678', suburb: 'FORESHORES', state: 'QLD' },
  { postCode: '4678', suburb: 'RODDS BAY', state: 'QLD' },
  { postCode: '4678', suburb: 'TURKEY BEACH', state: 'QLD' },
  { postCode: '4680', suburb: 'BARNEY POINT', state: 'QLD' },
  { postCode: '4680', suburb: 'BEECHER', state: 'QLD' },
  { postCode: '4680', suburb: 'BENARABY', state: 'QLD' },
  { postCode: '4680', suburb: 'BOYNE ISLAND', state: 'QLD' },
  { postCode: '4680', suburb: 'BOYNE VALLEY', state: 'QLD' },
  { postCode: '4680', suburb: 'BOYNEDALE', state: 'QLD' },
  { postCode: '4680', suburb: 'BUILYAN', state: 'QLD' },
  { postCode: '4680', suburb: 'BURUA', state: 'QLD' },
  { postCode: '4680', suburb: 'BYELLEE', state: 'QLD' },
  { postCode: '4680', suburb: 'CALLEMONDAH', state: 'QLD' },
  { postCode: '4680', suburb: 'CALLIOPE', state: 'QLD' },
  { postCode: '4680', suburb: 'CLINTON', state: 'QLD' },
  { postCode: '4680', suburb: 'CURTIS ISLAND', state: 'QLD' },
  { postCode: '4680', suburb: 'DIGLUM', state: 'QLD' },
  { postCode: '4680', suburb: 'GLADSTONE', state: 'QLD' },
  { postCode: '4680', suburb: 'GLADSTONE BC', state: 'QLD' },
  { postCode: '4680', suburb: 'GLADSTONE CENTRAL', state: 'QLD' },
  { postCode: '4680', suburb: 'GLADSTONE DC', state: 'QLD' },
  { postCode: '4680', suburb: 'GLADSTONE HARBOUR', state: 'QLD' },
  { postCode: '4680', suburb: 'GLEN EDEN', state: 'QLD' },
  { postCode: '4680', suburb: 'HERON ISLAND', state: 'QLD' },
  { postCode: '4680', suburb: 'IVERAGH', state: 'QLD' },
  { postCode: '4680', suburb: 'KIN KORA', state: 'QLD' },
  { postCode: '4680', suburb: 'KIRKWOOD', state: 'QLD' },
  { postCode: '4680', suburb: 'MOUNT ALMA', state: 'QLD' },
  { postCode: '4680', suburb: 'NEW AUCKLAND', state: 'QLD' },
  { postCode: '4680', suburb: "O'CONNELL", state: 'QLD' },
  { postCode: '4680', suburb: 'RIVER RANCH', state: 'QLD' },
  { postCode: '4680', suburb: 'SOUTH END', state: 'QLD' },
  { postCode: '4680', suburb: 'SOUTH GLADSTONE', state: 'QLD' },
  { postCode: '4680', suburb: 'SOUTH TREES', state: 'QLD' },
  { postCode: '4680', suburb: 'SUN VALLEY', state: 'QLD' },
  { postCode: '4680', suburb: 'TABLELANDS', state: 'QLD' },
  { postCode: '4680', suburb: 'TANNUM SANDS', state: 'QLD' },
  { postCode: '4680', suburb: 'TARAGOOLA', state: 'QLD' },
  { postCode: '4680', suburb: 'TELINA', state: 'QLD' },
  { postCode: '4680', suburb: 'TOOLOOA', state: 'QLD' },
  { postCode: '4680', suburb: 'UBOBO', state: 'QLD' },
  { postCode: '4680', suburb: 'WEST GLADSTONE', state: 'QLD' },
  { postCode: '4680', suburb: 'WEST STOWE', state: 'QLD' },
  { postCode: '4680', suburb: 'WOODERSON', state: 'QLD' },
  { postCode: '4680', suburb: 'WURDONG HEIGHTS', state: 'QLD' },
  { postCode: '4694', suburb: 'ALDOGA', state: 'QLD' },
  { postCode: '4694', suburb: 'TARGINNIE', state: 'QLD' },
  { postCode: '4694', suburb: 'YARWUN', state: 'QLD' },
  { postCode: '4695', suburb: 'AMBROSE', state: 'QLD' },
  { postCode: '4695', suburb: 'BRACEWELL', state: 'QLD' },
  { postCode: '4695', suburb: 'DARTS CREEK', state: 'QLD' },
  { postCode: '4695', suburb: 'EAST END', state: 'QLD' },
  { postCode: '4695', suburb: 'MACHINE CREEK', state: 'QLD' },
  { postCode: '4695', suburb: 'MOUNT LARCOM', state: 'QLD' },
  { postCode: '4695', suburb: 'THE NARROWS', state: 'QLD' },
  { postCode: '4697', suburb: 'RAGLAN', state: 'QLD' },
  { postCode: '4699', suburb: 'BAJOOL', state: 'QLD' },
  { postCode: '4699', suburb: 'PORT ALMA', state: 'QLD' },
  { postCode: '4700', suburb: 'ALLENSTOWN', state: 'QLD' },
  { postCode: '4700', suburb: 'DEPOT HILL', state: 'QLD' },
  { postCode: '4700', suburb: 'FAIRY BOWER', state: 'QLD' },
  { postCode: '4700', suburb: 'GREAT KEPPEL ISLAND', state: 'QLD' },
  { postCode: '4700', suburb: 'PORT CURTIS', state: 'QLD' },
  { postCode: '4700', suburb: 'ROCKHAMPTON', state: 'QLD' },
  { postCode: '4700', suburb: 'ROCKHAMPTON CITY', state: 'QLD' },
  { postCode: '4700', suburb: 'ROCKHAMPTON HOSPITAL', state: 'QLD' },
  { postCode: '4700', suburb: 'THE KEPPELS', state: 'QLD' },
  { postCode: '4700', suburb: 'THE RANGE', state: 'QLD' },
  { postCode: '4700', suburb: 'WANDAL', state: 'QLD' },
  { postCode: '4700', suburb: 'WEST ROCKHAMPTON', state: 'QLD' },
  { postCode: '4701', suburb: 'BERSERKER', state: 'QLD' },
  {
    postCode: '4701',
    suburb: 'CENTRAL QUEENSLAND UNIVERSITY',
    state: 'QLD',
  },
  { postCode: '4701', suburb: 'FRENCHVILLE', state: 'QLD' },
  { postCode: '4701', suburb: 'GREENLAKE', state: 'QLD' },
  { postCode: '4701', suburb: 'IRONPOT', state: 'QLD' },
  { postCode: '4701', suburb: 'KAWANA', state: 'QLD' },
  { postCode: '4701', suburb: 'KOONGAL', state: 'QLD' },
  { postCode: '4701', suburb: 'LAKES CREEK', state: 'QLD' },
  { postCode: '4701', suburb: 'LIMESTONE CREEK', state: 'QLD' },
  { postCode: '4701', suburb: 'MOUNT ARCHER', state: 'QLD' },
  { postCode: '4701', suburb: 'NANKIN', state: 'QLD' },
  { postCode: '4701', suburb: 'NERIMBERA', state: 'QLD' },
  { postCode: '4701', suburb: 'NORMAN GARDENS', state: 'QLD' },
  { postCode: '4701', suburb: 'PARK AVENUE', state: 'QLD' },
  { postCode: '4701', suburb: 'RED HILL ROCKHAMPTON', state: 'QLD' },
  { postCode: '4701', suburb: 'ROCKHAMPTON DC', state: 'QLD' },
  { postCode: '4701', suburb: 'ROCKYVIEW', state: 'QLD' },
  { postCode: '4701', suburb: 'SANDRINGHAM', state: 'QLD' },
  { postCode: '4701', suburb: 'THE COMMON', state: 'QLD' },
  { postCode: '4702', suburb: 'ALBERTA', state: 'QLD' },
  { postCode: '4702', suburb: 'ALSACE', state: 'QLD' },
  { postCode: '4702', suburb: 'ALTON DOWNS', state: 'QLD' },
  { postCode: '4702', suburb: 'ANAKIE', state: 'QLD' },
  { postCode: '4702', suburb: 'ARGOON', state: 'QLD' },
  { postCode: '4702', suburb: 'BALCOMBA', state: 'QLD' },
  { postCode: '4702', suburb: 'BANANA', state: 'QLD' },
  { postCode: '4702', suburb: 'BARALABA', state: 'QLD' },
  { postCode: '4702', suburb: 'BARNARD', state: 'QLD' },
  { postCode: '4702', suburb: 'BINGEGANG', state: 'QLD' },
  { postCode: '4702', suburb: 'BLACKDOWN', state: 'QLD' },
  { postCode: '4702', suburb: 'BLUFF', state: 'QLD' },
  { postCode: '4702', suburb: 'BOOLBURRA', state: 'QLD' },
  { postCode: '4702', suburb: 'BOULDERCOMBE', state: 'QLD' },
  { postCode: '4702', suburb: 'BUSHLEY', state: 'QLD' },
  { postCode: '4702', suburb: 'CANAL CREEK', state: 'QLD' },
  { postCode: '4702', suburb: 'CANOONA', state: 'QLD' },
  { postCode: '4702', suburb: 'CAWARRAL', state: 'QLD' },
  { postCode: '4702', suburb: 'CENTRAL QUEENSLAND MC', state: 'QLD' },
  { postCode: '4702', suburb: 'COMET', state: 'QLD' },
  { postCode: '4702', suburb: 'CONSUELO', state: 'QLD' },
  { postCode: '4702', suburb: 'COOMOO', state: 'QLD' },
  { postCode: '4702', suburb: 'COOROOMAN', state: 'QLD' },
  { postCode: '4702', suburb: 'COORUMBENE', state: 'QLD' },
  { postCode: '4702', suburb: 'COOWONGA', state: 'QLD' },
  { postCode: '4702', suburb: 'DALMA', state: 'QLD' },
  { postCode: '4702', suburb: 'DINGO', state: 'QLD' },
  { postCode: '4702', suburb: 'DIXALEA', state: 'QLD' },
  { postCode: '4702', suburb: 'DULULU', state: 'QLD' },
  { postCode: '4702', suburb: 'DUMPY CREEK', state: 'QLD' },
  { postCode: '4702', suburb: 'ETNA CREEK', state: 'QLD' },
  { postCode: '4702', suburb: 'GAINSFORD', state: 'QLD' },
  { postCode: '4702', suburb: 'GARNANT', state: 'QLD' },
  { postCode: '4702', suburb: 'GINDIE', state: 'QLD' },
  { postCode: '4702', suburb: 'GLENROY', state: 'QLD' },
  { postCode: '4702', suburb: 'GOGANGO', state: 'QLD' },
  { postCode: '4702', suburb: 'GOOMALLY', state: 'QLD' },
  { postCode: '4702', suburb: 'GOOVIGEN', state: 'QLD' },
  { postCode: '4702', suburb: 'GOOWARRA', state: 'QLD' },
  { postCode: '4702', suburb: 'GRACEMERE', state: 'QLD' },
  { postCode: '4702', suburb: 'JAMBIN', state: 'QLD' },
  { postCode: '4702', suburb: 'JARDINE', state: 'QLD' },
  { postCode: '4702', suburb: 'JELLINBAH', state: 'QLD' },
  { postCode: '4702', suburb: 'JOSKELEIGH', state: 'QLD' },
  { postCode: '4702', suburb: 'KABRA', state: 'QLD' },
  { postCode: '4702', suburb: 'KALAPA', state: 'QLD' },
  { postCode: '4702', suburb: 'KEPPEL SANDS', state: 'QLD' },
  { postCode: '4702', suburb: 'KOKOTUNGO', state: 'QLD' },
  { postCode: '4702', suburb: 'KUNWARARA', state: 'QLD' },
  { postCode: '4702', suburb: 'LOWESBY', state: 'QLD' },
  { postCode: '4702', suburb: 'MACKENZIE', state: 'QLD' },
  { postCode: '4702', suburb: 'MARMOR', state: 'QLD' },
  { postCode: '4702', suburb: 'MIDGEE', state: 'QLD' },
  { postCode: '4702', suburb: 'MILMAN', state: 'QLD' },
  { postCode: '4702', suburb: 'MIMOSA', state: 'QLD' },
  { postCode: '4702', suburb: 'MORINISH', state: 'QLD' },
  { postCode: '4702', suburb: 'MORINISH SOUTH', state: 'QLD' },
  { postCode: '4702', suburb: 'MOUNT CHALMERS', state: 'QLD' },
  { postCode: '4702', suburb: 'NINE MILE', state: 'QLD' },
  { postCode: '4702', suburb: 'PARKHURST', state: 'QLD' },
  { postCode: '4702', suburb: 'PHEASANT CREEK', state: 'QLD' },
  { postCode: '4702', suburb: 'PINK LILY', state: 'QLD' },
  { postCode: '4702', suburb: 'PLUM TREE', state: 'QLD' },
  { postCode: '4702', suburb: 'RIDGELANDS', state: 'QLD' },
  { postCode: '4702', suburb: 'ROLLESTON', state: 'QLD' },
  { postCode: '4702', suburb: 'ROSSMOYA', state: 'QLD' },
  { postCode: '4702', suburb: 'RUBYVALE', state: 'QLD' },
  { postCode: '4702', suburb: 'SAPPHIRE', state: 'QLD' },
  { postCode: '4702', suburb: 'SHOALWATER', state: 'QLD' },
  { postCode: '4702', suburb: 'SMOKY CREEK', state: 'QLD' },
  { postCode: '4702', suburb: 'SOUTH YAAMBA', state: 'QLD' },
  { postCode: '4702', suburb: 'STANAGE', state: 'QLD' },
  { postCode: '4702', suburb: 'STANWELL', state: 'QLD' },
  { postCode: '4702', suburb: 'STEWARTON', state: 'QLD' },
  { postCode: '4702', suburb: 'TARRAMBA', state: 'QLD' },
  { postCode: '4702', suburb: 'THE CAVES', state: 'QLD' },
  { postCode: '4702', suburb: 'THE GEMFIELDS', state: 'QLD' },
  { postCode: '4702', suburb: 'THOMPSON POINT', state: 'QLD' },
  { postCode: '4702', suburb: 'TUNGAMULL', state: 'QLD' },
  { postCode: '4702', suburb: 'ULOGIE', state: 'QLD' },
  { postCode: '4702', suburb: 'WALLAROO', state: 'QLD' },
  { postCode: '4702', suburb: 'WESTWOOD', state: 'QLD' },
  { postCode: '4702', suburb: 'WILLOWS', state: 'QLD' },
  { postCode: '4702', suburb: 'WILLOWS GEMFIELDS', state: 'QLD' },
  { postCode: '4702', suburb: 'WOOLEIN', state: 'QLD' },
  { postCode: '4702', suburb: 'WOOROONA', state: 'QLD' },
  { postCode: '4702', suburb: 'WOWAN', state: 'QLD' },
  { postCode: '4702', suburb: 'WYCARBAH', state: 'QLD' },
  { postCode: '4703', suburb: 'ADELAIDE PARK', state: 'QLD' },
  { postCode: '4703', suburb: 'BANGALEE', state: 'QLD' },
  { postCode: '4703', suburb: 'BARLOWS HILL', state: 'QLD' },
  { postCode: '4703', suburb: 'BARMARYEE', state: 'QLD' },
  { postCode: '4703', suburb: 'BARMOYA', state: 'QLD' },
  { postCode: '4703', suburb: 'BONDOOLA', state: 'QLD' },
  { postCode: '4703', suburb: 'BUNGUNDARRA', state: 'QLD' },
  { postCode: '4703', suburb: 'BYFIELD', state: 'QLD' },
  { postCode: '4703', suburb: 'CAUSEWAY LAKE', state: 'QLD' },
  { postCode: '4703', suburb: 'COBRABALL', state: 'QLD' },
  { postCode: '4703', suburb: 'COOEE BAY', state: 'QLD' },
  { postCode: '4703', suburb: 'FARNBOROUGH', state: 'QLD' },
  { postCode: '4703', suburb: 'HIDDEN VALLEY', state: 'QLD' },
  { postCode: '4703', suburb: 'INVERNESS', state: 'QLD' },
  { postCode: '4703', suburb: 'KINKA BEACH', state: 'QLD' },
  { postCode: '4703', suburb: 'LAKE MARY', state: 'QLD' },
  { postCode: '4703', suburb: 'LAMMERMOOR', state: 'QLD' },
  { postCode: '4703', suburb: 'MARYVALE', state: 'QLD' },
  { postCode: '4703', suburb: 'MEIKLEVILLE HILL', state: 'QLD' },
  { postCode: '4703', suburb: 'MULAMBIN', state: 'QLD' },
  { postCode: '4703', suburb: 'MULARA', state: 'QLD' },
  { postCode: '4703', suburb: 'PACIFIC HEIGHTS', state: 'QLD' },
  { postCode: '4703', suburb: 'ROSSLYN', state: 'QLD' },
  { postCode: '4703', suburb: 'STOCKYARD', state: 'QLD' },
  { postCode: '4703', suburb: 'TANBY', state: 'QLD' },
  { postCode: '4703', suburb: 'TARANGANBA', state: 'QLD' },
  { postCode: '4703', suburb: 'TAROOMBALL', state: 'QLD' },
  { postCode: '4703', suburb: 'WEERRIBA', state: 'QLD' },
  { postCode: '4703', suburb: 'WOODBURY', state: 'QLD' },
  { postCode: '4703', suburb: 'YEPPOON', state: 'QLD' },
  { postCode: '4704', suburb: 'WATTLEBANK', state: 'QLD' },
  { postCode: '4704', suburb: 'YAAMBA', state: 'QLD' },
  { postCode: '4705', suburb: 'CLARKE CREEK', state: 'QLD' },
  { postCode: '4705', suburb: 'LOTUS CREEK', state: 'QLD' },
  { postCode: '4705', suburb: 'MACKENZIE RIVER', state: 'QLD' },
  { postCode: '4705', suburb: 'MARLBOROUGH', state: 'QLD' },
  { postCode: '4705', suburb: 'MOUNT GARDINER', state: 'QLD' },
  { postCode: '4706', suburb: 'OGMORE', state: 'QLD' },
  { postCode: '4707', suburb: 'COLLAROY', state: 'QLD' },
  { postCode: '4707', suburb: 'ST LAWRENCE', state: 'QLD' },
  { postCode: '4707', suburb: 'THE PERCY GROUP', state: 'QLD' },
  { postCode: '4709', suburb: 'TIERI', state: 'QLD' },
  { postCode: '4710', suburb: 'EMU PARK', state: 'QLD' },
  { postCode: '4710', suburb: 'ZILZIE', state: 'QLD' },
  { postCode: '4711', suburb: 'GLENDALE', state: 'QLD' },
  { postCode: '4711', suburb: 'GLENLEE', state: 'QLD' },
  { postCode: '4712', suburb: 'DUARINGA', state: 'QLD' },
  { postCode: '4713', suburb: 'WOORABINDA', state: 'QLD' },
  { postCode: '4714', suburb: 'BAREE', state: 'QLD' },
  { postCode: '4714', suburb: 'BOULDER CREEK', state: 'QLD' },
  { postCode: '4714', suburb: 'FLETCHER CREEK', state: 'QLD' },
  { postCode: '4714', suburb: 'HAMILTON CREEK', state: 'QLD' },
  { postCode: '4714', suburb: 'HORSE CREEK', state: 'QLD' },
  { postCode: '4714', suburb: 'JOHNSONS HILL', state: 'QLD' },
  { postCode: '4714', suburb: 'LEYDENS HILL', state: 'QLD' },
  { postCode: '4714', suburb: 'LIMESTONE', state: 'QLD' },
  { postCode: '4714', suburb: 'MOONGAN', state: 'QLD' },
  { postCode: '4714', suburb: 'MOUNT MORGAN', state: 'QLD' },
  { postCode: '4714', suburb: 'NINE MILE CREEK', state: 'QLD' },
  { postCode: '4714', suburb: 'OAKEY CREEK', state: 'QLD' },
  { postCode: '4714', suburb: 'STRUCK OIL', state: 'QLD' },
  { postCode: '4714', suburb: 'THE MINE', state: 'QLD' },
  { postCode: '4714', suburb: 'TROTTER CREEK', state: 'QLD' },
  { postCode: '4714', suburb: 'WALMUL', state: 'QLD' },
  { postCode: '4714', suburb: 'WALTERHALL', state: 'QLD' },
  { postCode: '4714', suburb: 'WURA', state: 'QLD' },
  { postCode: '4715', suburb: 'BILOELA', state: 'QLD' },
  { postCode: '4715', suburb: 'CALLIDE', state: 'QLD' },
  { postCode: '4715', suburb: 'CASTLE CREEK', state: 'QLD' },
  { postCode: '4715', suburb: 'DAKENBA', state: 'QLD' },
  { postCode: '4715', suburb: 'DUMGREE', state: 'QLD' },
  { postCode: '4715', suburb: 'GREYCLIFFE', state: 'QLD' },
  { postCode: '4715', suburb: 'MOUNT MURCHISON', state: 'QLD' },
  { postCode: '4715', suburb: 'ORANGE CREEK', state: 'QLD' },
  { postCode: '4715', suburb: 'PROSPECT', state: 'QLD' },
  { postCode: '4715', suburb: 'VALENTINE PLAINS', state: 'QLD' },
  { postCode: '4716', suburb: 'LAWGI DAWES', state: 'QLD' },
  { postCode: '4716', suburb: 'THANGOOL', state: 'QLD' },
  { postCode: '4717', suburb: 'BLACKWATER', state: 'QLD' },
  { postCode: '4718', suburb: 'BAUHINIA', state: 'QLD' },
  { postCode: '4718', suburb: 'DROMEDARY', state: 'QLD' },
  { postCode: '4718', suburb: 'KIANGA', state: 'QLD' },
  { postCode: '4718', suburb: 'MOURA', state: 'QLD' },
  { postCode: '4718', suburb: 'MUNGABUNDA', state: 'QLD' },
  { postCode: '4718', suburb: 'OOMBABEER', state: 'QLD' },
  { postCode: '4718', suburb: 'RHYDDING', state: 'QLD' },
  { postCode: '4718', suburb: 'ROUNDSTONE', state: 'QLD' },
  { postCode: '4718', suburb: 'WARNOAH', state: 'QLD' },
  { postCode: '4719', suburb: 'CAMBOON', state: 'QLD' },
  { postCode: '4719', suburb: 'CRACOW', state: 'QLD' },
  { postCode: '4719', suburb: 'GLENMORAL', state: 'QLD' },
  { postCode: '4719', suburb: 'ISLA', state: 'QLD' },
  { postCode: '4719', suburb: 'LONESOME CREEK', state: 'QLD' },
  { postCode: '4719', suburb: 'THEODORE', state: 'QLD' },
  { postCode: '4720', suburb: 'EMERALD', state: 'QLD' },
  { postCode: '4720', suburb: 'YAMALA', state: 'QLD' },
  { postCode: '4721', suburb: 'ARGYLL', state: 'QLD' },
  { postCode: '4721', suburb: 'CLERMONT', state: 'QLD' },
  { postCode: '4721', suburb: 'ELGIN', state: 'QLD' },
  { postCode: '4721', suburb: 'FRANKFIELD', state: 'QLD' },
  { postCode: '4721', suburb: 'GEMINI MOUNTAINS', state: 'QLD' },
  { postCode: '4721', suburb: 'KILCUMMIN', state: 'QLD' },
  { postCode: '4721', suburb: 'LAGLAN', state: 'QLD' },
  { postCode: '4721', suburb: 'PASHA', state: 'QLD' },
  { postCode: '4721', suburb: 'THERESA CREEK', state: 'QLD' },
  { postCode: '4721', suburb: 'WINCHESTER', state: 'QLD' },
  { postCode: '4721', suburb: 'WOLFANG', state: 'QLD' },
  { postCode: '4722', suburb: 'BUCKLAND', state: 'QLD' },
  { postCode: '4722', suburb: 'CAIRDBEIGN', state: 'QLD' },
  { postCode: '4722', suburb: 'CONA CREEK', state: 'QLD' },
  { postCode: '4722', suburb: 'NANDOWRIE', state: 'QLD' },
  { postCode: '4722', suburb: 'ORION', state: 'QLD' },
  { postCode: '4722', suburb: 'SPRINGSURE', state: 'QLD' },
  { postCode: '4722', suburb: 'WEALWANDANGIE', state: 'QLD' },
  { postCode: '4723', suburb: 'BELCONG', state: 'QLD' },
  { postCode: '4723', suburb: 'CAPELLA', state: 'QLD' },
  { postCode: '4723', suburb: 'CARBINE CREEK', state: 'QLD' },
  { postCode: '4723', suburb: 'CHIRNSIDE', state: 'QLD' },
  { postCode: '4723', suburb: 'CRINUM', state: 'QLD' },
  { postCode: '4723', suburb: 'HIBERNIA', state: 'QLD' },
  { postCode: '4723', suburb: 'KHOSH BULDUK', state: 'QLD' },
  { postCode: '4723', suburb: 'LILYVALE', state: 'QLD' },
  { postCode: '4723', suburb: 'LOWESTOFF', state: 'QLD' },
  { postCode: '4723', suburb: 'MOUNT MACARTHUR', state: 'QLD' },
  { postCode: '4723', suburb: 'RETRO', state: 'QLD' },
  { postCode: '4724', suburb: 'ALPHA', state: 'QLD' },
  { postCode: '4724', suburb: 'BEAUFORT', state: 'QLD' },
  { postCode: '4724', suburb: 'DRUMMONDSLOPE', state: 'QLD' },
  { postCode: '4724', suburb: 'HOBARTVILLE', state: 'QLD' },
  { postCode: '4724', suburb: 'PINE HILL', state: 'QLD' },
  { postCode: '4724', suburb: 'PORT WINE', state: 'QLD' },
  { postCode: '4724', suburb: 'QUETTA', state: 'QLD' },
  { postCode: '4724', suburb: 'SEDGEFORD', state: 'QLD' },
  { postCode: '4724', suburb: 'SURBITON', state: 'QLD' },
  { postCode: '4725', suburb: 'BARCALDINE', state: 'QLD' },
  { postCode: '4725', suburb: 'BARCALDINE DOWNS', state: 'QLD' },
  { postCode: '4725', suburb: 'PATRICK', state: 'QLD' },
  { postCode: '4725', suburb: 'TARA STATION', state: 'QLD' },
  { postCode: '4726', suburb: 'ARAMAC', state: 'QLD' },
  { postCode: '4726', suburb: 'GALILEE', state: 'QLD' },
  { postCode: '4726', suburb: 'PELICAN CREEK', state: 'QLD' },
  { postCode: '4727', suburb: 'ILFRACOMBE', state: 'QLD' },
  { postCode: '4728', suburb: 'DUNROBIN', state: 'QLD' },
  { postCode: '4728', suburb: 'GARFIELD', state: 'QLD' },
  { postCode: '4728', suburb: 'JERICHO', state: 'QLD' },
  { postCode: '4728', suburb: 'MEXICO', state: 'QLD' },
  { postCode: '4730', suburb: 'CAMOOLA', state: 'QLD' },
  { postCode: '4730', suburb: 'CHORREGON', state: 'QLD' },
  { postCode: '4730', suburb: 'ERNESTINA', state: 'QLD' },
  { postCode: '4730', suburb: 'LONGREACH', state: 'QLD' },
  { postCode: '4730', suburb: 'MANEROO', state: 'QLD' },
  { postCode: '4730', suburb: 'MORELLA', state: 'QLD' },
  { postCode: '4730', suburb: 'STONEHENGE', state: 'QLD' },
  { postCode: '4730', suburb: 'TOCAL', state: 'QLD' },
  { postCode: '4730', suburb: 'VERGEMONT', state: 'QLD' },
  { postCode: '4731', suburb: 'ISISFORD', state: 'QLD' },
  { postCode: '4731', suburb: 'YARAKA', state: 'QLD' },
  { postCode: '4732', suburb: 'MUTTABURRA', state: 'QLD' },
  { postCode: '4732', suburb: 'TABLEDERRY', state: 'QLD' },
  { postCode: '4733', suburb: 'CORFIELD', state: 'QLD' },
  { postCode: '4735', suburb: 'DIAMANTINA LAKES', state: 'QLD' },
  { postCode: '4735', suburb: 'MIDDLETON', state: 'QLD' },
  { postCode: '4735', suburb: 'OPALTON', state: 'QLD' },
  { postCode: '4735', suburb: 'WINTON', state: 'QLD' },
  { postCode: '4736', suburb: 'JUNDAH', state: 'QLD' },
  { postCode: '4737', suburb: 'ARMSTRONG BEACH', state: 'QLD' },
  { postCode: '4737', suburb: 'BLUE MOUNTAIN', state: 'QLD' },
  { postCode: '4737', suburb: 'CAMPWIN BEACH', state: 'QLD' },
  { postCode: '4737', suburb: 'FRESHWATER POINT', state: 'QLD' },
  { postCode: '4737', suburb: 'SARINA', state: 'QLD' },
  { postCode: '4737', suburb: 'SARINA BEACH', state: 'QLD' },
  { postCode: '4737', suburb: 'SARINA RANGE', state: 'QLD' },
  { postCode: '4737', suburb: 'SUNNYSIDE', state: 'QLD' },
  { postCode: '4738', suburb: 'ILBILBIE', state: 'QLD' },
  { postCode: '4738', suburb: 'KOUMALA', state: 'QLD' },
  { postCode: '4739', suburb: 'CARMILA', state: 'QLD' },
  { postCode: '4740', suburb: 'ALEXANDRA', state: 'QLD' },
  { postCode: '4740', suburb: 'ALLIGATOR CREEK', state: 'QLD' },
  { postCode: '4740', suburb: 'ANDERGROVE', state: 'QLD' },
  { postCode: '4740', suburb: 'BAKERS CREEK', state: 'QLD' },
  { postCode: '4740', suburb: 'BALBERRA', state: 'QLD' },
  { postCode: '4740', suburb: 'BALNAGOWAN', state: 'QLD' },
  { postCode: '4740', suburb: 'BEACONSFIELD', state: 'QLD' },
  { postCode: '4740', suburb: 'BELMUNDA', state: 'QLD' },
  { postCode: '4740', suburb: 'BLACKS BEACH', state: 'QLD' },
  { postCode: '4740', suburb: 'CAPE HILLSBOROUGH', state: 'QLD' },
  { postCode: '4740', suburb: 'CHELONA', state: 'QLD' },
  { postCode: '4740', suburb: 'CREMORNE', state: 'QLD' },
  { postCode: '4740', suburb: 'DOLPHIN HEADS', state: 'QLD' },
  { postCode: '4740', suburb: 'DUMBLETON', state: 'QLD' },
  { postCode: '4740', suburb: 'DUNDULA', state: 'QLD' },
  { postCode: '4740', suburb: 'DUNNROCK', state: 'QLD' },
  { postCode: '4740', suburb: 'EAST MACKAY', state: 'QLD' },
  { postCode: '4740', suburb: 'EIMEO', state: 'QLD' },
  { postCode: '4740', suburb: 'ERAKALA', state: 'QLD' },
  { postCode: '4740', suburb: 'FOULDEN', state: 'QLD' },
  { postCode: '4740', suburb: 'GLENELLA', state: 'QLD' },
  { postCode: '4740', suburb: 'GRASSTREE BEACH', state: 'QLD' },
  { postCode: '4740', suburb: 'HABANA', state: 'QLD' },
  { postCode: '4740', suburb: 'HALIDAY BAY', state: 'QLD' },
  { postCode: '4740', suburb: 'HAY POINT', state: 'QLD' },
  { postCode: '4740', suburb: 'HOMEBUSH', state: 'QLD' },
  { postCode: '4740', suburb: 'MACKAY', state: 'QLD' },
  { postCode: '4740', suburb: 'MACKAY CANELAND', state: 'QLD' },
  { postCode: '4740', suburb: 'MACKAY DC', state: 'QLD' },
  { postCode: '4740', suburb: 'MACKAY HARBOUR', state: 'QLD' },
  { postCode: '4740', suburb: 'MACKAY NORTH', state: 'QLD' },
  { postCode: '4740', suburb: 'MACKAY SOUTH', state: 'QLD' },
  { postCode: '4740', suburb: 'MACKAY WEST', state: 'QLD' },
  { postCode: '4740', suburb: 'MCEWENS BEACH', state: 'QLD' },
  { postCode: '4740', suburb: 'MOUNT JUKES', state: 'QLD' },
  { postCode: '4740', suburb: 'MOUNT PLEASANT', state: 'QLD' },
  { postCode: '4740', suburb: 'MUNBURA', state: 'QLD' },
  { postCode: '4740', suburb: 'NINDAROO', state: 'QLD' },
  { postCode: '4740', suburb: 'NORTH MACKAY', state: 'QLD' },
  { postCode: '4740', suburb: 'OORALEA', state: 'QLD' },
  { postCode: '4740', suburb: 'PAGET', state: 'QLD' },
  { postCode: '4740', suburb: 'RACECOURSE', state: 'QLD' },
  { postCode: '4740', suburb: 'RICHMOND', state: 'QLD' },
  { postCode: '4740', suburb: 'ROSELLA', state: 'QLD' },
  { postCode: '4740', suburb: 'RURAL VIEW', state: 'QLD' },
  { postCode: '4740', suburb: 'SANDIFORD', state: 'QLD' },
  { postCode: '4740', suburb: 'SLADE POINT', state: 'QLD' },
  { postCode: '4740', suburb: 'SOUTH MACKAY', state: 'QLD' },
  { postCode: '4740', suburb: 'TE KOWAI', state: 'QLD' },
  { postCode: '4740', suburb: 'THE LEAP', state: 'QLD' },
  { postCode: '4740', suburb: 'WEST MACKAY', state: 'QLD' },
  { postCode: '4741', suburb: 'BALL BAY', state: 'QLD' },
  { postCode: '4741', suburb: 'BRIGHTLY', state: 'QLD' },
  { postCode: '4741', suburb: 'CLAIRVIEW', state: 'QLD' },
  { postCode: '4741', suburb: 'COPPABELLA', state: 'QLD' },
  { postCode: '4741', suburb: 'EPSOM', state: 'QLD' },
  { postCode: '4741', suburb: 'ETON', state: 'QLD' },
  { postCode: '4741', suburb: 'EUNGELLA HINTERLAND', state: 'QLD' },
  { postCode: '4741', suburb: 'FARLEIGH', state: 'QLD' },
  { postCode: '4741', suburb: 'GARGETT', state: 'QLD' },
  { postCode: '4741', suburb: 'HAMPDEN', state: 'QLD' },
  { postCode: '4741', suburb: 'HAZLEDEAN', state: 'QLD' },
  { postCode: '4741', suburb: 'KINCHANT DAM', state: 'QLD' },
  { postCode: '4741', suburb: 'KUTTABUL', state: 'QLD' },
  { postCode: '4741', suburb: 'MACKAY MC', state: 'QLD' },
  { postCode: '4741', suburb: 'MOUNT CHARLTON', state: 'QLD' },
  { postCode: '4741', suburb: 'MOUNT OSSA', state: 'QLD' },
  { postCode: '4741', suburb: 'MOUNT PELION', state: 'QLD' },
  { postCode: '4741', suburb: 'NORTH ETON', state: 'QLD' },
  { postCode: '4741', suburb: 'OAKENDEN', state: 'QLD' },
  { postCode: '4741', suburb: 'ORKABIE', state: 'QLD' },
  { postCode: '4741', suburb: 'OWENS CREEK', state: 'QLD' },
  { postCode: '4741', suburb: 'PINNACLE', state: 'QLD' },
  { postCode: '4741', suburb: 'PLEYSTOWE', state: 'QLD' },
  { postCode: '4741', suburb: 'SEAFORTH', state: 'QLD' },
  { postCode: '4741', suburb: 'YALBOROO', state: 'QLD' },
  { postCode: '4742', suburb: 'BURTON', state: 'QLD' },
  { postCode: '4742', suburb: 'EAGLEFIELD', state: 'QLD' },
  { postCode: '4742', suburb: 'ELPHINSTONE', state: 'QLD' },
  { postCode: '4742', suburb: 'HAIL CREEK', state: 'QLD' },
  { postCode: '4742', suburb: 'KEMMIS', state: 'QLD' },
  { postCode: '4742', suburb: 'MOUNT BRITTON', state: 'QLD' },
  { postCode: '4742', suburb: 'NEBO', state: 'QLD' },
  { postCode: '4742', suburb: 'OXFORD', state: 'QLD' },
  { postCode: '4742', suburb: 'STRATHFIELD', state: 'QLD' },
  { postCode: '4742', suburb: 'TURRAWULLA', state: 'QLD' },
  { postCode: '4742', suburb: 'VALKYRIE', state: 'QLD' },
  { postCode: '4743', suburb: 'GLENDEN', state: 'QLD' },
  { postCode: '4743', suburb: 'SUTTOR', state: 'QLD' },
  { postCode: '4744', suburb: 'MORANBAH', state: 'QLD' },
  { postCode: '4745', suburb: 'DYSART', state: 'QLD' },
  { postCode: '4746', suburb: 'MAY DOWNS', state: 'QLD' },
  { postCode: '4746', suburb: 'MIDDLEMOUNT', state: 'QLD' },
  { postCode: '4750', suburb: 'BUCASIA', state: 'QLD' },
  { postCode: '4750', suburb: 'SHOAL POINT', state: 'QLD' },
  { postCode: '4751', suburb: 'GREENMOUNT', state: 'QLD' },
  { postCode: '4751', suburb: 'PALMYRA', state: 'QLD' },
  { postCode: '4751', suburb: 'VICTORIA PLAINS', state: 'QLD' },
  { postCode: '4751', suburb: 'WALKERSTON', state: 'QLD' },
  { postCode: '4753', suburb: 'DEVEREUX CREEK', state: 'QLD' },
  { postCode: '4753', suburb: 'MARIAN', state: 'QLD' },
  { postCode: '4754', suburb: 'BENHOLME', state: 'QLD' },
  { postCode: '4754', suburb: 'DOWS CREEK', state: 'QLD' },
  { postCode: '4754', suburb: 'MIA MIA', state: 'QLD' },
  { postCode: '4754', suburb: 'MIRANI', state: 'QLD' },
  { postCode: '4754', suburb: 'MOUNT MARTIN', state: 'QLD' },
  { postCode: '4754', suburb: 'PINEVALE', state: 'QLD' },
  { postCode: '4754', suburb: 'SEPTIMUS', state: 'QLD' },
  { postCode: '4756', suburb: 'FINCH HATTON', state: 'QLD' },
  { postCode: '4756', suburb: 'NETHERDALE', state: 'QLD' },
  { postCode: '4757', suburb: 'BROKEN RIVER', state: 'QLD' },
  { postCode: '4757', suburb: 'CREDITON', state: 'QLD' },
  { postCode: '4757', suburb: 'DALRYMPLE HEIGHTS', state: 'QLD' },
  { postCode: '4757', suburb: 'EUNGELLA', state: 'QLD' },
  { postCode: '4757', suburb: 'EUNGELLA DAM', state: 'QLD' },
  { postCode: '4798', suburb: 'CALEN', state: 'QLD' },
  { postCode: '4798', suburb: 'MENTMORE', state: 'QLD' },
  { postCode: '4798', suburb: 'PINDI PINDI', state: 'QLD' },
  { postCode: '4798', suburb: 'ST HELENS BEACH', state: 'QLD' },
  { postCode: '4799', suburb: 'BLOOMSBURY', state: 'QLD' },
  { postCode: '4799', suburb: 'MIDGE POINT', state: 'QLD' },
  { postCode: '4800', suburb: 'ANDROMACHE', state: 'QLD' },
  { postCode: '4800', suburb: 'BRANDY CREEK', state: 'QLD' },
  { postCode: '4800', suburb: 'BREADALBANE', state: 'QLD' },
  { postCode: '4800', suburb: 'CANNON VALLEY', state: 'QLD' },
  { postCode: '4800', suburb: 'CAPE CONWAY', state: 'QLD' },
  { postCode: '4800', suburb: 'CAPE GLOUCESTER', state: 'QLD' },
  { postCode: '4800', suburb: 'CONWAY', state: 'QLD' },
  { postCode: '4800', suburb: 'CONWAY BEACH', state: 'QLD' },
  { postCode: '4800', suburb: 'CRYSTAL BROOK', state: 'QLD' },
  { postCode: '4800', suburb: 'DINGO BEACH', state: 'QLD' },
  { postCode: '4800', suburb: 'DITTMER', state: 'QLD' },
  { postCode: '4800', suburb: 'FOXDALE', state: 'QLD' },
  { postCode: '4800', suburb: 'GLEN ISLA', state: 'QLD' },
  { postCode: '4800', suburb: 'GOORGANGA CREEK', state: 'QLD' },
  { postCode: '4800', suburb: 'GOORGANGA PLAINS', state: 'QLD' },
  { postCode: '4800', suburb: 'GREGORY RIVER', state: 'QLD' },
  { postCode: '4800', suburb: 'GUNYARRA', state: 'QLD' },
  { postCode: '4800', suburb: 'HAMILTON PLAINS', state: 'QLD' },
  { postCode: '4800', suburb: 'HIDEAWAY BAY', state: 'QLD' },
  { postCode: '4800', suburb: 'KELSEY CREEK', state: 'QLD' },
  { postCode: '4800', suburb: 'LAGUNA QUAYS', state: 'QLD' },
  { postCode: '4800', suburb: 'LAKE PROSERPINE', state: 'QLD' },
  { postCode: '4800', suburb: 'LETHEBROOK', state: 'QLD' },
  { postCode: '4800', suburb: 'MOUNT JULIAN', state: 'QLD' },
  { postCode: '4800', suburb: 'MOUNT MARLOW', state: 'QLD' },
  { postCode: '4800', suburb: 'MOUNT PLUTO', state: 'QLD' },
  { postCode: '4800', suburb: 'MYRTLEVALE', state: 'QLD' },
  { postCode: '4800', suburb: 'PALM GROVE', state: 'QLD' },
  { postCode: '4800', suburb: 'PAULS POCKET', state: 'QLD' },
  { postCode: '4800', suburb: 'PRESTON', state: 'QLD' },
  { postCode: '4800', suburb: 'PROSERPINE', state: 'QLD' },
  { postCode: '4800', suburb: 'RIORDANVALE', state: 'QLD' },
  { postCode: '4800', suburb: 'SILVER CREEK', state: 'QLD' },
  { postCode: '4800', suburb: 'STRATHDICKIE', state: 'QLD' },
  { postCode: '4800', suburb: 'SUGARLOAF', state: 'QLD' },
  { postCode: '4800', suburb: 'THOOPARA', state: 'QLD' },
  { postCode: '4800', suburb: 'WILSON BEACH', state: 'QLD' },
  { postCode: '4802', suburb: 'AIRLIE BEACH', state: 'QLD' },
  { postCode: '4802', suburb: 'CANNONVALE', state: 'QLD' },
  { postCode: '4802', suburb: 'FLAMETREE', state: 'QLD' },
  { postCode: '4802', suburb: 'JUBILEE POCKET', state: 'QLD' },
  { postCode: '4802', suburb: 'MANDALAY', state: 'QLD' },
  { postCode: '4802', suburb: 'MOUNT ROOPER', state: 'QLD' },
  { postCode: '4802', suburb: 'SHUTE HARBOUR', state: 'QLD' },
  { postCode: '4802', suburb: 'WHITSUNDAYS', state: 'QLD' },
  { postCode: '4802', suburb: 'WOODWARK', state: 'QLD' },
  { postCode: '4803', suburb: 'HAMILTON ISLAND', state: 'QLD' },
  { postCode: '4804', suburb: 'COLLINSVILLE', state: 'QLD' },
  { postCode: '4804', suburb: 'MOUNT COOLON', state: 'QLD' },
  { postCode: '4804', suburb: 'MOUNT WYATT', state: 'QLD' },
  { postCode: '4804', suburb: 'NEWLANDS', state: 'QLD' },
  { postCode: '4804', suburb: 'SCOTTVILLE', state: 'QLD' },
  { postCode: '4804', suburb: 'SPRINGLANDS', state: 'QLD' },
  { postCode: '4805', suburb: 'BOGIE', state: 'QLD' },
  { postCode: '4805', suburb: 'BOWEN', state: 'QLD' },
  { postCode: '4805', suburb: 'GUMLU', state: 'QLD' },
  { postCode: '4805', suburb: 'GUTHALUNGRA', state: 'QLD' },
  { postCode: '4805', suburb: 'MERINDA', state: 'QLD' },
  { postCode: '4805', suburb: 'QUEENS BEACH', state: 'QLD' },
  { postCode: '4806', suburb: 'CARSTAIRS', state: 'QLD' },
  { postCode: '4806', suburb: 'FREDERICKSFIELD', state: 'QLD' },
  { postCode: '4806', suburb: 'GROPER CREEK', state: 'QLD' },
  { postCode: '4806', suburb: 'HOME HILL', state: 'QLD' },
  { postCode: '4806', suburb: 'INKERMAN', state: 'QLD' },
  { postCode: '4806', suburb: 'KIRKNIE', state: 'QLD' },
  { postCode: '4806', suburb: 'OSBORNE', state: 'QLD' },
  { postCode: '4806', suburb: 'RANGEMORE', state: 'QLD' },
  { postCode: '4806', suburb: 'WANGARATTA', state: 'QLD' },
  { postCode: '4806', suburb: 'WUNJUNGA', state: 'QLD' },
  { postCode: '4807', suburb: 'AIRDMILLAN', state: 'QLD' },
  { postCode: '4807', suburb: 'AIRVILLE', state: 'QLD' },
  { postCode: '4807', suburb: 'ALVA', state: 'QLD' },
  { postCode: '4807', suburb: 'AYR', state: 'QLD' },
  { postCode: '4807', suburb: 'CLARE', state: 'QLD' },
  { postCode: '4807', suburb: 'CLAREDALE', state: 'QLD' },
  { postCode: '4807', suburb: 'DALBEG', state: 'QLD' },
  { postCode: '4807', suburb: 'EIGHT MILE CREEK', state: 'QLD' },
  { postCode: '4807', suburb: 'JARVISFIELD', state: 'QLD' },
  { postCode: '4807', suburb: 'MCDESME', state: 'QLD' },
  { postCode: '4807', suburb: 'MILLAROO', state: 'QLD' },
  { postCode: '4807', suburb: 'MONA PARK', state: 'QLD' },
  { postCode: '4807', suburb: 'MOUNT KELLY', state: 'QLD' },
  { postCode: '4807', suburb: 'MULGRAVE', state: 'QLD' },
  { postCode: '4807', suburb: 'RITA ISLAND', state: 'QLD' },
  { postCode: '4807', suburb: 'SWANS LAGOON', state: 'QLD' },
  { postCode: '4808', suburb: 'BRANDON', state: 'QLD' },
  { postCode: '4808', suburb: 'COLEVALE', state: 'QLD' },
  { postCode: '4809', suburb: 'BARRATTA', state: 'QLD' },
  { postCode: '4809', suburb: 'CROMARTY', state: 'QLD' },
  { postCode: '4809', suburb: 'GIRU', state: 'QLD' },
  { postCode: '4809', suburb: 'HORSESHOE LAGOON', state: 'QLD' },
  { postCode: '4809', suburb: 'JERONA', state: 'QLD' },
  { postCode: '4809', suburb: 'MOUNT SURROUND', state: 'QLD' },
  { postCode: '4809', suburb: 'SHIRBOURNE', state: 'QLD' },
  { postCode: '4809', suburb: 'UPPER HAUGHTON', state: 'QLD' },
  { postCode: '4810', suburb: 'BELGIAN GARDENS', state: 'QLD' },
  { postCode: '4810', suburb: 'CAPE CLEVELAND', state: 'QLD' },
  { postCode: '4810', suburb: 'CASTLE HILL', state: 'QLD' },
  { postCode: '4810', suburb: 'NORTH WARD', state: 'QLD' },
  { postCode: '4810', suburb: 'PALLARENDA', state: 'QLD' },
  { postCode: '4810', suburb: 'RAILWAY ESTATE', state: 'QLD' },
  { postCode: '4810', suburb: 'ROWES BAY', state: 'QLD' },
  { postCode: '4810', suburb: 'SHELLY BEACH', state: 'QLD' },
  { postCode: '4810', suburb: 'SOUTH TOWNSVILLE', state: 'QLD' },
  { postCode: '4810', suburb: 'TOWN COMMON', state: 'QLD' },
  { postCode: '4810', suburb: 'TOWNSVILLE', state: 'QLD' },
  { postCode: '4810', suburb: 'TOWNSVILLE CITY', state: 'QLD' },
  { postCode: '4810', suburb: 'TOWNSVILLE DC', state: 'QLD' },
  { postCode: '4810', suburb: 'TOWNSVILLE MC', state: 'QLD' },
  { postCode: '4810', suburb: 'WEST END', state: 'QLD' },
  { postCode: '4811', suburb: 'CLUDEN', state: 'QLD' },
  { postCode: '4811', suburb: 'IDALIA', state: 'QLD' },
  { postCode: '4811', suburb: 'JAMES COOK UNIVERSITY', state: 'QLD' },
  { postCode: '4811', suburb: 'MOUNT STUART', state: 'QLD' },
  { postCode: '4811', suburb: 'OAK VALLEY', state: 'QLD' },
  { postCode: '4811', suburb: 'OONOONBA', state: 'QLD' },
  { postCode: '4811', suburb: 'ROSENEATH', state: 'QLD' },
  { postCode: '4811', suburb: 'STUART', state: 'QLD' },
  { postCode: '4811', suburb: 'WULGURU', state: 'QLD' },
  { postCode: '4812', suburb: 'CURRAJONG', state: 'QLD' },
  { postCode: '4812', suburb: 'GULLIVER', state: 'QLD' },
  { postCode: '4812', suburb: 'HERMIT PARK', state: 'QLD' },
  { postCode: '4812', suburb: 'HYDE PARK', state: 'QLD' },
  { postCode: '4812', suburb: 'HYDE PARK CASTLETOWN', state: 'QLD' },
  { postCode: '4812', suburb: 'MUNDINGBURRA', state: 'QLD' },
  { postCode: '4812', suburb: 'MYSTERTON', state: 'QLD' },
  { postCode: '4812', suburb: 'PIMLICO', state: 'QLD' },
  { postCode: '4812', suburb: 'ROSSLEA', state: 'QLD' },
  { postCode: '4813', suburb: 'TOWNSVILLE MILPO', state: 'QLD' },
  { postCode: '4814', suburb: 'AITKENVALE', state: 'QLD' },
  { postCode: '4814', suburb: 'ANNANDALE', state: 'QLD' },
  { postCode: '4814', suburb: 'CRANBROOK', state: 'QLD' },
  { postCode: '4814', suburb: 'DOUGLAS', state: 'QLD' },
  { postCode: '4814', suburb: 'GARBUTT', state: 'QLD' },
  { postCode: '4814', suburb: 'GARBUTT EAST', state: 'QLD' },
  { postCode: '4814', suburb: 'HEATLEY', state: 'QLD' },
  { postCode: '4814', suburb: 'MOUNT LOUISA', state: 'QLD' },
  { postCode: '4814', suburb: 'MURRAY', state: 'QLD' },
  { postCode: '4814', suburb: 'THURINGOWA DC', state: 'QLD' },
  { postCode: '4814', suburb: 'VINCENT', state: 'QLD' },
  { postCode: '4815', suburb: 'CONDON', state: 'QLD' },
  { postCode: '4815', suburb: 'GRANITE VALE', state: 'QLD' },
  { postCode: '4815', suburb: 'GUMLOW', state: 'QLD' },
  { postCode: '4815', suburb: 'KELSO', state: 'QLD' },
  { postCode: '4815', suburb: 'PINNACLES', state: 'QLD' },
  { postCode: '4815', suburb: 'RASMUSSEN', state: 'QLD' },
  { postCode: '4816', suburb: 'ALLIGATOR CREEK', state: 'QLD' },
  { postCode: '4816', suburb: 'BALGAL BEACH', state: 'QLD' },
  { postCode: '4816', suburb: 'BARRINGHA', state: 'QLD' },
  { postCode: '4816', suburb: 'BROOKHILL', state: 'QLD' },
  { postCode: '4816', suburb: 'BUCHANAN', state: 'QLD' },
  { postCode: '4816', suburb: 'CALCIUM', state: 'QLD' },
  { postCode: '4816', suburb: 'CARRUCHAN', state: 'QLD' },
  { postCode: '4816', suburb: 'CLEMANT', state: 'QLD' },
  { postCode: '4816', suburb: 'CRYSTAL CREEK', state: 'QLD' },
  { postCode: '4816', suburb: 'CUNGULLA', state: 'QLD' },
  { postCode: '4816', suburb: 'ELLERBECK', state: 'QLD' },
  { postCode: '4816', suburb: 'GREENVALE', state: 'QLD' },
  { postCode: '4816', suburb: 'HOMESTEAD', state: 'QLD' },
  { postCode: '4816', suburb: 'JULAGO', state: 'QLD' },
  { postCode: '4816', suburb: 'KENNEDY', state: 'QLD' },
  { postCode: '4816', suburb: 'MACROSSAN', state: 'QLD' },
  { postCode: '4816', suburb: 'MAJORS CREEK', state: 'QLD' },
  { postCode: '4816', suburb: 'MALPAS-TRENTON', state: 'QLD' },
  { postCode: '4816', suburb: 'MINGELA', state: 'QLD' },
  { postCode: '4816', suburb: 'MOUNT ELLIOT', state: 'QLD' },
  { postCode: '4816', suburb: 'MUTARNEE', state: 'QLD' },
  { postCode: '4816', suburb: 'NOME', state: 'QLD' },
  { postCode: '4816', suburb: 'PALM ISLAND', state: 'QLD' },
  { postCode: '4816', suburb: 'PALUMA', state: 'QLD' },
  { postCode: '4816', suburb: 'PENTLAND', state: 'QLD' },
  { postCode: '4816', suburb: 'RAVENSWOOD', state: 'QLD' },
  { postCode: '4816', suburb: 'REID RIVER', state: 'QLD' },
  { postCode: '4816', suburb: 'ROLLINGSTONE', state: 'QLD' },
  { postCode: '4816', suburb: 'ROSS RIVER', state: 'QLD' },
  { postCode: '4816', suburb: 'SAVANNAH', state: 'QLD' },
  { postCode: '4816', suburb: 'SELLHEIM', state: 'QLD' },
  { postCode: '4816', suburb: 'TOOMULLA', state: 'QLD' },
  { postCode: '4816', suburb: 'TOONPAN', state: 'QLD' },
  { postCode: '4816', suburb: 'TORRENS CREEK', state: 'QLD' },
  { postCode: '4816', suburb: 'WOODSTOCK', state: 'QLD' },
  { postCode: '4817', suburb: 'ALICE RIVER', state: 'QLD' },
  { postCode: '4817', suburb: 'BOHLE PLAINS', state: 'QLD' },
  { postCode: '4817', suburb: 'HERVEY RANGE', state: 'QLD' },
  { postCode: '4817', suburb: 'KIRWAN', state: 'QLD' },
  { postCode: '4817', suburb: 'RANGEWOOD', state: 'QLD' },
  { postCode: '4817', suburb: 'THURINGOWA CENTRAL', state: 'QLD' },
  { postCode: '4818', suburb: 'BEACH HOLM', state: 'QLD' },
  { postCode: '4818', suburb: 'BLACK RIVER', state: 'QLD' },
  { postCode: '4818', suburb: 'BLUE HILLS', state: 'QLD' },
  { postCode: '4818', suburb: 'BLUEWATER', state: 'QLD' },
  { postCode: '4818', suburb: 'BLUEWATER PARK', state: 'QLD' },
  { postCode: '4818', suburb: 'BOHLE', state: 'QLD' },
  { postCode: '4818', suburb: 'BURDELL', state: 'QLD' },
  { postCode: '4818', suburb: 'BUSHLAND BEACH', state: 'QLD' },
  { postCode: '4818', suburb: 'COSGROVE', state: 'QLD' },
  { postCode: '4818', suburb: 'DEERAGUN', state: 'QLD' },
  { postCode: '4818', suburb: 'JENSEN', state: 'QLD' },
  { postCode: '4818', suburb: 'LYNAM', state: 'QLD' },
  { postCode: '4818', suburb: 'MOUNT LOW', state: 'QLD' },
  { postCode: '4818', suburb: 'MOUNT ST JOHN', state: 'QLD' },
  { postCode: '4818', suburb: 'SAUNDERS BEACH', state: 'QLD' },
  { postCode: '4818', suburb: 'SHAW', state: 'QLD' },
  { postCode: '4818', suburb: 'TOOLAKEA', state: 'QLD' },
  { postCode: '4818', suburb: 'YABULU', state: 'QLD' },
  { postCode: '4819', suburb: 'ARCADIA', state: 'QLD' },
  { postCode: '4819', suburb: 'FLORENCE BAY', state: 'QLD' },
  { postCode: '4819', suburb: 'HORSESHOE BAY', state: 'QLD' },
  { postCode: '4819', suburb: 'MAGNETIC ISLAND', state: 'QLD' },
  { postCode: '4819', suburb: 'NELLY BAY', state: 'QLD' },
  { postCode: '4819', suburb: 'PICNIC BAY', state: 'QLD' },
  { postCode: '4819', suburb: 'WEST POINT', state: 'QLD' },
  { postCode: '4820', suburb: 'ALABAMA HILL', state: 'QLD' },
  { postCode: '4820', suburb: 'BALFES CREEK', state: 'QLD' },
  { postCode: '4820', suburb: 'BASALT', state: 'QLD' },
  { postCode: '4820', suburb: 'BLACK JACK', state: 'QLD' },
  { postCode: '4820', suburb: 'BREDDAN', state: 'QLD' },
  { postCode: '4820', suburb: 'BROUGHTON', state: 'QLD' },
  { postCode: '4820', suburb: 'CAMPASPE', state: 'QLD' },
  { postCode: '4820', suburb: 'CHARTERS TOWERS', state: 'QLD' },
  { postCode: '4820', suburb: 'CHARTERS TOWERS CITY', state: 'QLD' },
  { postCode: '4820', suburb: 'COLUMBIA', state: 'QLD' },
  { postCode: '4820', suburb: 'DOTSWOOD', state: 'QLD' },
  { postCode: '4820', suburb: 'GRAND SECRET', state: 'QLD' },
  { postCode: '4820', suburb: 'LLANARTH', state: 'QLD' },
  { postCode: '4820', suburb: 'MILLCHESTER', state: 'QLD' },
  { postCode: '4820', suburb: 'MOSMAN PARK', state: 'QLD' },
  { postCode: '4820', suburb: 'QUEENTON', state: 'QLD' },
  { postCode: '4820', suburb: 'RICHMOND HILL', state: 'QLD' },
  { postCode: '4820', suburb: 'SEVENTY MILE', state: 'QLD' },
  { postCode: '4820', suburb: 'SOUTHERN CROSS', state: 'QLD' },
  { postCode: '4820', suburb: 'TOLL', state: 'QLD' },
  { postCode: '4820', suburb: 'TOWERS HILL', state: 'QLD' },
  { postCode: '4821', suburb: 'DUTTON RIVER', state: 'QLD' },
  { postCode: '4821', suburb: 'HUGHENDEN', state: 'QLD' },
  { postCode: '4821', suburb: 'PORCUPINE', state: 'QLD' },
  { postCode: '4821', suburb: 'PRAIRIE', state: 'QLD' },
  { postCode: '4821', suburb: 'STAMFORD', state: 'QLD' },
  { postCode: '4821', suburb: 'TANGORIN', state: 'QLD' },
  { postCode: '4822', suburb: 'ALBION', state: 'QLD' },
  { postCode: '4822', suburb: 'BELLFIELD', state: 'QLD' },
  { postCode: '4822', suburb: 'BURLEIGH', state: 'QLD' },
  { postCode: '4822', suburb: 'CAMBRIDGE', state: 'QLD' },
  { postCode: '4822', suburb: 'MAXWELTON', state: 'QLD' },
  { postCode: '4822', suburb: 'RICHMOND', state: 'QLD' },
  { postCode: '4822', suburb: 'SAXBY', state: 'QLD' },
  { postCode: '4822', suburb: 'VICTORIA VALE', state: 'QLD' },
  { postCode: '4822', suburb: 'WOOLGAR', state: 'QLD' },
  { postCode: '4823', suburb: 'CARPENTARIA', state: 'QLD' },
  { postCode: '4823', suburb: 'JULIA CREEK', state: 'QLD' },
  { postCode: '4823', suburb: 'KYNUNA', state: 'QLD' },
  { postCode: '4823', suburb: 'MCKINLAY', state: 'QLD' },
  { postCode: '4823', suburb: 'NELIA', state: 'QLD' },
  { postCode: '4823', suburb: 'STOKES', state: 'QLD' },
  { postCode: '4823', suburb: 'TALDORA', state: 'QLD' },
  { postCode: '4823', suburb: 'WARBURTON', state: 'QLD' },
  { postCode: '4824', suburb: 'CLONCURRY', state: 'QLD' },
  { postCode: '4824', suburb: 'FOUR WAYS', state: 'QLD' },
  { postCode: '4824', suburb: 'GIDYA', state: 'QLD' },
  { postCode: '4824', suburb: 'KURIDALA', state: 'QLD' },
  { postCode: '4824', suburb: 'OORINDI', state: 'QLD' },
  { postCode: '4824', suburb: 'THREE RIVERS', state: 'QLD' },
  { postCode: '4825', suburb: 'ALPURRURULAM', state: 'NT' },
  { postCode: '4825', suburb: 'BARKLY', state: 'QLD' },
  { postCode: '4825', suburb: 'BREAKAWAY', state: 'QLD' },
  { postCode: '4825', suburb: 'BUCKINGHAM', state: 'QLD' },
  { postCode: '4825', suburb: 'CARRANDOTTA', state: 'QLD' },
  { postCode: '4825', suburb: 'DAJARRA', state: 'QLD' },
  { postCode: '4825', suburb: 'DUCHESS', state: 'QLD' },
  { postCode: '4825', suburb: 'FIELDING', state: 'QLD' },
  { postCode: '4825', suburb: 'FISHER', state: 'QLD' },
  { postCode: '4825', suburb: 'GEORGINA', state: 'QLD' },
  { postCode: '4825', suburb: 'GUNPOWDER', state: 'QLD' },
  { postCode: '4825', suburb: 'HAPPY VALLEY', state: 'QLD' },
  { postCode: '4825', suburb: 'HEALY', state: 'QLD' },
  { postCode: '4825', suburb: 'KALKADOON', state: 'QLD' },
  { postCode: '4825', suburb: 'LANSKEY', state: 'QLD' },
  { postCode: '4825', suburb: 'LAWN HILL', state: 'QLD' },
  { postCode: '4825', suburb: 'MENZIES', state: 'QLD' },
  { postCode: '4825', suburb: 'MICA CREEK', state: 'QLD' },
  { postCode: '4825', suburb: 'MILES END', state: 'QLD' },
  { postCode: '4825', suburb: 'MORNINGTON', state: 'QLD' },
  { postCode: '4825', suburb: 'MOUNT ISA', state: 'QLD' },
  { postCode: '4825', suburb: 'MOUNT ISA CITY', state: 'QLD' },
  { postCode: '4825', suburb: 'MOUNT ISA DC', state: 'QLD' },
  { postCode: '4825', suburb: 'MOUNT ISA EAST', state: 'QLD' },
  { postCode: '4825', suburb: 'PARKSIDE', state: 'QLD' },
  { postCode: '4825', suburb: 'PIONEER', state: 'QLD' },
  { postCode: '4825', suburb: 'PITURIE', state: 'QLD' },
  { postCode: '4825', suburb: 'RANKEN', state: 'NT' },
  { postCode: '4825', suburb: 'RYAN', state: 'QLD' },
  { postCode: '4825', suburb: 'SOLDIERS HILL', state: 'QLD' },
  { postCode: '4825', suburb: 'SPREADBOROUGH', state: 'QLD' },
  { postCode: '4825', suburb: 'SUNSET', state: 'QLD' },
  { postCode: '4825', suburb: 'THE GAP', state: 'QLD' },
  { postCode: '4825', suburb: 'THE MONUMENT', state: 'QLD' },
  { postCode: '4825', suburb: 'TOWNVIEW', state: 'QLD' },
  { postCode: '4825', suburb: 'WAVERLEY', state: 'QLD' },
  { postCode: '4825', suburb: 'WINSTON', state: 'QLD' },
  { postCode: '4828', suburb: 'CAMOOWEAL', state: 'QLD' },
  { postCode: '4829', suburb: 'AMAROO', state: 'QLD' },
  { postCode: '4829', suburb: 'BEDOURIE', state: 'QLD' },
  { postCode: '4829', suburb: 'BOULIA', state: 'QLD' },
  { postCode: '4829', suburb: 'MIN MIN', state: 'QLD' },
  { postCode: '4829', suburb: 'STURT', state: 'QLD' },
  { postCode: '4829', suburb: 'TOKO', state: 'QLD' },
  { postCode: '4829', suburb: 'WARENDA', state: 'QLD' },
  { postCode: '4829', suburb: 'WILLS', state: 'QLD' },
  { postCode: '4830', suburb: 'BURKETOWN', state: 'QLD' },
  { postCode: '4830', suburb: 'DOOMADGEE', state: 'QLD' },
  { postCode: '4830', suburb: 'GREGORY', state: 'QLD' },
  { postCode: '4830', suburb: 'NICHOLSON', state: 'QLD' },
  { postCode: '4849', suburb: 'CARDWELL', state: 'QLD' },
  { postCode: '4849', suburb: 'DAMPER CREEK', state: 'QLD' },
  { postCode: '4849', suburb: 'HINCHINBROOK', state: 'QLD' },
  { postCode: '4849', suburb: 'LUMHOLTZ', state: 'QLD' },
  { postCode: '4849', suburb: 'RUNGOO', state: 'QLD' },
  { postCode: '4850', suburb: 'ABERGOWRIE', state: 'QLD' },
  { postCode: '4850', suburb: 'ALLINGHAM', state: 'QLD' },
  { postCode: '4850', suburb: 'BAMBAROO', state: 'QLD' },
  { postCode: '4850', suburb: 'BEMERSIDE', state: 'QLD' },
  { postCode: '4850', suburb: 'BLACKROCK', state: 'QLD' },
  { postCode: '4850', suburb: 'BRAEMEADOWS', state: 'QLD' },
  { postCode: '4850', suburb: 'COOLBIE', state: 'QLD' },
  { postCode: '4850', suburb: 'CORDELIA', state: 'QLD' },
  { postCode: '4850', suburb: 'DALRYMPLE CREEK', state: 'QLD' },
  { postCode: '4850', suburb: 'FORESTHOME', state: 'QLD' },
  { postCode: '4850', suburb: 'FORREST BEACH', state: 'QLD' },
  { postCode: '4850', suburb: 'GAIRLOCH', state: 'QLD' },
  { postCode: '4850', suburb: 'GARRAWALT', state: 'QLD' },
  { postCode: '4850', suburb: 'HALIFAX', state: 'QLD' },
  { postCode: '4850', suburb: 'HAWKINS CREEK', state: 'QLD' },
  { postCode: '4850', suburb: 'HELENS HILL', state: 'QLD' },
  { postCode: '4850', suburb: 'INGHAM', state: 'QLD' },
  { postCode: '4850', suburb: 'LANNERCOST', state: 'QLD' },
  { postCode: '4850', suburb: 'LONG POCKET', state: 'QLD' },
  { postCode: '4850', suburb: 'LUCINDA', state: 'QLD' },
  { postCode: '4850', suburb: 'MACKNADE', state: 'QLD' },
  { postCode: '4850', suburb: 'MOUNT FOX', state: 'QLD' },
  { postCode: '4850', suburb: 'ORIENT', state: 'QLD' },
  { postCode: '4850', suburb: 'PEACOCK SIDING', state: 'QLD' },
  { postCode: '4850', suburb: 'TAYLORS BEACH', state: 'QLD' },
  { postCode: '4850', suburb: 'TOOBANNA', state: 'QLD' },
  { postCode: '4850', suburb: 'TREBONNE', state: 'QLD' },
  { postCode: '4850', suburb: 'UPPER STONE', state: 'QLD' },
  { postCode: '4850', suburb: 'VALLEY OF LAGOONS', state: 'QLD' },
  { postCode: '4850', suburb: 'VICTORIA PLANTATION', state: 'QLD' },
  { postCode: '4850', suburb: 'WALLAMAN', state: 'QLD' },
  { postCode: '4850', suburb: 'WHARPS', state: 'QLD' },
  { postCode: '4850', suburb: 'YURUGA', state: 'QLD' },
  { postCode: '4852', suburb: 'BINGIL BAY', state: 'QLD' },
  { postCode: '4852', suburb: 'CARMOO', state: 'QLD' },
  { postCode: '4852', suburb: 'DJIRU', state: 'QLD' },
  { postCode: '4852', suburb: 'DUNK', state: 'QLD' },
  { postCode: '4852', suburb: 'GARNERS BEACH', state: 'QLD' },
  { postCode: '4852', suburb: 'MIDGEREE BAR', state: 'QLD' },
  { postCode: '4852', suburb: 'MISSION BEACH', state: 'QLD' },
  { postCode: '4852', suburb: 'SOUTH MISSION BEACH', state: 'QLD' },
  { postCode: '4852', suburb: "TAM O'SHANTER", state: 'QLD' },
  { postCode: '4852', suburb: 'WONGALING BEACH', state: 'QLD' },
  { postCode: '4854', suburb: 'BILYANA', state: 'QLD' },
  { postCode: '4854', suburb: 'BIRKALLA', state: 'QLD' },
  { postCode: '4854', suburb: 'BULGUN', state: 'QLD' },
  { postCode: '4854', suburb: 'CARDSTONE', state: 'QLD' },
  { postCode: '4854', suburb: 'DINGO POCKET', state: 'QLD' },
  { postCode: '4854', suburb: 'DJARAWONG', state: 'QLD' },
  { postCode: '4854', suburb: 'EAST FELUGA', state: 'QLD' },
  { postCode: '4854', suburb: 'EURAMO', state: 'QLD' },
  { postCode: '4854', suburb: 'FELUGA', state: 'QLD' },
  { postCode: '4854', suburb: 'HULL HEADS', state: 'QLD' },
  { postCode: '4854', suburb: 'JARRA CREEK', state: 'QLD' },
  { postCode: '4854', suburb: 'KOOROOMOOL', state: 'QLD' },
  { postCode: '4854', suburb: 'LOWER TULLY', state: 'QLD' },
  { postCode: '4854', suburb: 'MERRYBURN', state: 'QLD' },
  { postCode: '4854', suburb: 'MIDGENOO', state: 'QLD' },
  { postCode: '4854', suburb: 'MOUNT MACKAY', state: 'QLD' },
  { postCode: '4854', suburb: 'MUNRO PLAINS', state: 'QLD' },
  { postCode: '4854', suburb: 'MURRAY UPPER', state: 'QLD' },
  { postCode: '4854', suburb: 'MURRIGAL', state: 'QLD' },
  { postCode: '4854', suburb: 'ROCKINGHAM', state: 'QLD' },
  { postCode: '4854', suburb: 'SILKY OAK', state: 'QLD' },
  { postCode: '4854', suburb: 'TULLY', state: 'QLD' },
  { postCode: '4854', suburb: 'TULLY HEADS', state: 'QLD' },
  { postCode: '4854', suburb: 'WALTER HILL', state: 'QLD' },
  { postCode: '4854', suburb: 'WARRAMI', state: 'QLD' },
  { postCode: '4855', suburb: 'DAVESON', state: 'QLD' },
  { postCode: '4855', suburb: 'EL ARISH', state: 'QLD' },
  { postCode: '4855', suburb: 'FRIDAY POCKET', state: 'QLD' },
  { postCode: '4855', suburb: 'GRANADILLA', state: 'QLD' },
  { postCode: '4855', suburb: 'JAFFA', state: 'QLD' },
  { postCode: '4855', suburb: 'MAADI', state: 'QLD' },
  { postCode: '4855', suburb: 'MARIA CREEKS', state: 'QLD' },
  { postCode: '4855', suburb: 'SHELL POCKET', state: 'QLD' },
  { postCode: '4856', suburb: 'GOOLBOO', state: 'QLD' },
  { postCode: '4856', suburb: 'JAPOONVALE', state: 'QLD' },
  { postCode: '4856', suburb: 'MCCUTCHEON', state: 'QLD' },
  { postCode: '4856', suburb: 'NO. 4 BRANCH', state: 'QLD' },
  { postCode: '4856', suburb: 'NO. 5 BRANCH', state: 'QLD' },
  { postCode: '4856', suburb: 'SILKWOOD', state: 'QLD' },
  { postCode: '4856', suburb: 'WALTER LEVER ESTATE', state: 'QLD' },
  { postCode: '4857', suburb: 'SILKWOOD EAST', state: 'QLD' },
  { postCode: '4858', suburb: 'COMOON LOOP', state: 'QLD' },
  { postCode: '4858', suburb: 'ETTY BAY', state: 'QLD' },
  { postCode: '4858', suburb: 'MARTYVILLE', state: 'QLD' },
  { postCode: '4858', suburb: 'MOURILYAN', state: 'QLD' },
  { postCode: '4858', suburb: 'MOURILYAN HARBOUR', state: 'QLD' },
  { postCode: '4858', suburb: 'NEW HARBOURLINE', state: 'QLD' },
  { postCode: '4859', suburb: 'NO. 6 BRANCH', state: 'QLD' },
  { postCode: '4859', suburb: 'SOUTH JOHNSTONE', state: 'QLD' },
  { postCode: '4860', suburb: 'BAMBOO CREEK', state: 'QLD' },
  { postCode: '4860', suburb: 'BELVEDERE', state: 'QLD' },
  { postCode: '4860', suburb: 'COCONUTS', state: 'QLD' },
  { postCode: '4860', suburb: 'COOROO LANDS', state: 'QLD' },
  { postCode: '4860', suburb: 'COORUMBA', state: 'QLD' },
  { postCode: '4860', suburb: 'COQUETTE POINT', state: 'QLD' },
  { postCode: '4860', suburb: 'CULLINANE', state: 'QLD' },
  { postCode: '4860', suburb: 'DARADGEE', state: 'QLD' },
  { postCode: '4860', suburb: 'EAST INNISFAIL', state: 'QLD' },
  { postCode: '4860', suburb: 'EAST PALMERSTON', state: 'QLD' },
  { postCode: '4860', suburb: 'EATON', state: 'QLD' },
  { postCode: '4860', suburb: 'EUBENANGEE', state: 'QLD' },
  { postCode: '4860', suburb: 'FITZGERALD CREEK', state: 'QLD' },
  { postCode: '4860', suburb: 'FLYING FISH POINT', state: 'QLD' },
  { postCode: '4860', suburb: 'GARRADUNGA', state: 'QLD' },
  { postCode: '4860', suburb: 'GOONDI', state: 'QLD' },
  { postCode: '4860', suburb: 'GOONDI BEND', state: 'QLD' },
  { postCode: '4860', suburb: 'GOONDI HILL', state: 'QLD' },
  { postCode: '4860', suburb: 'HUDSON', state: 'QLD' },
  { postCode: '4860', suburb: 'INNISFAIL', state: 'QLD' },
  { postCode: '4860', suburb: 'INNISFAIL ESTATE', state: 'QLD' },
  { postCode: '4860', suburb: 'JUBILEE HEIGHTS', state: 'QLD' },
  { postCode: '4860', suburb: 'MIGHELL', state: 'QLD' },
  { postCode: '4860', suburb: 'MUNDOO', state: 'QLD' },
  { postCode: '4860', suburb: 'NERADA', state: 'QLD' },
  { postCode: '4860', suburb: 'NGATJAN', state: 'QLD' },
  { postCode: '4860', suburb: "O'BRIENS HILL", state: 'QLD' },
  { postCode: '4860', suburb: 'PALMERSTON', state: 'QLD' },
  { postCode: '4860', suburb: 'PIN GIN HILL', state: 'QLD' },
  { postCode: '4860', suburb: 'SOUTH INNISFAIL', state: 'QLD' },
  { postCode: '4860', suburb: 'STOTERS HILL', state: 'QLD' },
  { postCode: '4860', suburb: 'SUNDOWN', state: 'QLD' },
  { postCode: '4860', suburb: 'UPPER DARADGEE', state: 'QLD' },
  { postCode: '4860', suburb: 'VASA VIEWS', state: 'QLD' },
  { postCode: '4860', suburb: 'WANJURU', state: 'QLD' },
  { postCode: '4860', suburb: 'WEBB', state: 'QLD' },
  { postCode: '4860', suburb: 'WOOROONOORAN', state: 'QLD' },
  { postCode: '4861', suburb: 'BABINDA', state: 'QLD' },
  { postCode: '4861', suburb: 'BARTLE FRERE', state: 'QLD' },
  { postCode: '4861', suburb: 'EAST RUSSELL', state: 'QLD' },
  { postCode: '4865', suburb: 'GOLDSBOROUGH', state: 'QLD' },
  { postCode: '4865', suburb: 'GORDONVALE', state: 'QLD' },
  { postCode: '4865', suburb: 'GREEN HILL', state: 'QLD' },
  { postCode: '4865', suburb: 'KAMMA', state: 'QLD' },
  { postCode: '4865', suburb: 'LITTLE MULGRAVE', state: 'QLD' },
  { postCode: '4865', suburb: 'PACKERS CAMP', state: 'QLD' },
  { postCode: '4868', suburb: 'BAYVIEW HEIGHTS', state: 'QLD' },
  { postCode: '4868', suburb: 'MOUNT SHERIDAN', state: 'QLD' },
  { postCode: '4868', suburb: 'WHITE ROCK', state: 'QLD' },
  { postCode: '4868', suburb: 'WOREE', state: 'QLD' },
  { postCode: '4869', suburb: 'BENTLEY PARK', state: 'QLD' },
  { postCode: '4869', suburb: 'EDMONTON', state: 'QLD' },
  { postCode: '4869', suburb: 'MOUNT PETER', state: 'QLD' },
  { postCode: '4869', suburb: 'WRIGHTS CREEK', state: 'QLD' },
  { postCode: '4870', suburb: 'AEROGLEN', state: 'QLD' },
  { postCode: '4870', suburb: 'BARRON GORGE', state: 'QLD' },
  { postCode: '4870', suburb: 'BRINSMEAD', state: 'QLD' },
  { postCode: '4870', suburb: 'BUNGALOW', state: 'QLD' },
  { postCode: '4870', suburb: 'CAIRNS', state: 'QLD' },
  { postCode: '4870', suburb: 'CAIRNS CITY', state: 'QLD' },
  { postCode: '4870', suburb: 'CAIRNS DC', state: 'QLD' },
  { postCode: '4870', suburb: 'CAIRNS MC', state: 'QLD' },
  { postCode: '4870', suburb: 'CAIRNS MCLEOD STREET', state: 'QLD' },
  { postCode: '4870', suburb: 'CAIRNS NORTH', state: 'QLD' },
  { postCode: '4870', suburb: 'EARLVILLE', state: 'QLD' },
  { postCode: '4870', suburb: 'EARLVILLE BC', state: 'QLD' },
  { postCode: '4870', suburb: 'EDGE HILL', state: 'QLD' },
  { postCode: '4870', suburb: 'FRESHWATER', state: 'QLD' },
  { postCode: '4870', suburb: 'KAMERUNGA', state: 'QLD' },
  { postCode: '4870', suburb: 'KANIMBLA', state: 'QLD' },
  { postCode: '4870', suburb: 'LAMB RANGE', state: 'QLD' },
  { postCode: '4870', suburb: 'MANOORA', state: 'QLD' },
  { postCode: '4870', suburb: 'MANUNDA', state: 'QLD' },
  { postCode: '4870', suburb: 'MARTYNVALE', state: 'QLD' },
  { postCode: '4870', suburb: 'MOOROOBOOL', state: 'QLD' },
  { postCode: '4870', suburb: 'NORTH CAIRNS', state: 'QLD' },
  { postCode: '4870', suburb: 'PARRAMATTA PARK', state: 'QLD' },
  { postCode: '4870', suburb: 'PORTSMITH', state: 'QLD' },
  { postCode: '4870', suburb: 'REDLYNCH', state: 'QLD' },
  { postCode: '4870', suburb: 'STRATFORD', state: 'QLD' },
  { postCode: '4870', suburb: 'WESTCOURT', state: 'QLD' },
  { postCode: '4870', suburb: 'WHITFIELD', state: 'QLD' },
  { postCode: '4871', suburb: 'ALMADEN', state: 'QLD' },
  { postCode: '4871', suburb: 'ALOOMBA', state: 'QLD' },
  { postCode: '4871', suburb: 'AMBER', state: 'QLD' },
  { postCode: '4871', suburb: 'BASILISK', state: 'QLD' },
  { postCode: '4871', suburb: 'BELLENDEN KER', state: 'QLD' },
  { postCode: '4871', suburb: 'BLACKBULL', state: 'QLD' },
  { postCode: '4871', suburb: 'BOLWARRA', state: 'QLD' },
  { postCode: '4871', suburb: 'BOMBEETA', state: 'QLD' },
  { postCode: '4871', suburb: 'BOOGAN', state: 'QLD' },
  { postCode: '4871', suburb: 'BRAMSTON BEACH', state: 'QLD' },
  { postCode: '4871', suburb: 'BULLERINGA', state: 'QLD' },
  { postCode: '4871', suburb: 'CAMP CREEK', state: 'QLD' },
  { postCode: '4871', suburb: 'CHILLAGOE', state: 'QLD' },
  { postCode: '4871', suburb: 'CLARAVILLE', state: 'QLD' },
  { postCode: '4871', suburb: 'CONJUBOY', state: 'QLD' },
  { postCode: '4871', suburb: 'CORALIE', state: 'QLD' },
  { postCode: '4871', suburb: 'COWLEY', state: 'QLD' },
  { postCode: '4871', suburb: 'COWLEY BEACH', state: 'QLD' },
  { postCode: '4871', suburb: 'COWLEY CREEK', state: 'QLD' },
  { postCode: '4871', suburb: 'CROYDON', state: 'QLD' },
  { postCode: '4871', suburb: 'CRYSTALBROOK', state: 'QLD' },
  { postCode: '4871', suburb: 'CURRAJAH', state: 'QLD' },
  { postCode: '4871', suburb: 'DEERAL', state: 'QLD' },
  { postCode: '4871', suburb: 'DESAILLY', state: 'QLD' },
  { postCode: '4871', suburb: 'EAST CREEK', state: 'QLD' },
  { postCode: '4871', suburb: 'EAST TRINITY', state: 'QLD' },
  { postCode: '4871', suburb: 'EINASLEIGH', state: 'QLD' },
  { postCode: '4871', suburb: 'ESMERALDA', state: 'QLD' },
  { postCode: '4871', suburb: 'FISHERY FALLS', state: 'QLD' },
  { postCode: '4871', suburb: 'FITZROY ISLAND', state: 'QLD' },
  { postCode: '4871', suburb: 'FORSAYTH', state: 'QLD' },
  { postCode: '4871', suburb: 'FOSSILBROOK', state: 'QLD' },
  { postCode: '4871', suburb: 'GEORGETOWN', state: 'QLD' },
  { postCode: '4871', suburb: 'GERMANTOWN', state: 'QLD' },
  { postCode: '4871', suburb: 'GILBERT RIVER', state: 'QLD' },
  { postCode: '4871', suburb: 'GILBERTON', state: 'QLD' },
  { postCode: '4871', suburb: 'GLEN BOUGHTON', state: 'QLD' },
  { postCode: '4871', suburb: 'GREEN ISLAND', state: 'QLD' },
  { postCode: '4871', suburb: 'HURRICANE', state: 'QLD' },
  { postCode: '4871', suburb: 'JULATTEN', state: 'QLD' },
  { postCode: '4871', suburb: 'KARRON', state: 'QLD' },
  { postCode: '4871', suburb: 'KURRIMINE BEACH', state: 'QLD' },
  { postCode: '4871', suburb: 'LAKELAND', state: 'QLD' },
  { postCode: '4871', suburb: 'LAKELAND DOWNS', state: 'QLD' },
  { postCode: '4871', suburb: 'LOWER COWLEY', state: 'QLD' },
  { postCode: '4871', suburb: 'LYNDHURST', state: 'QLD' },
  { postCode: '4871', suburb: 'MACALISTER RANGE', state: 'QLD' },
  { postCode: '4871', suburb: 'MENA CREEK', state: 'QLD' },
  { postCode: '4871', suburb: 'MIRRIWINNI', state: 'QLD' },
  { postCode: '4871', suburb: 'MORESBY', state: 'QLD' },
  { postCode: '4871', suburb: 'MOUNT CARBINE', state: 'QLD' },
  { postCode: '4871', suburb: 'MOUNT MOLLOY', state: 'QLD' },
  { postCode: '4871', suburb: 'MOUNT MULLIGAN', state: 'QLD' },
  { postCode: '4871', suburb: 'MOUNT SURPRISE', state: 'QLD' },
  { postCode: '4871', suburb: 'NORTHHEAD', state: 'QLD' },
  { postCode: '4871', suburb: 'NYCHUM', state: 'QLD' },
  { postCode: '4871', suburb: 'PETFORD', state: 'QLD' },
  { postCode: '4871', suburb: 'PORTLAND ROADS', state: 'QLD' },
  { postCode: '4871', suburb: 'ROOKWOOD', state: 'QLD' },
  { postCode: '4871', suburb: 'SANDY POCKET', state: 'QLD' },
  { postCode: '4871', suburb: 'SOUTHEDGE', state: 'QLD' },
  { postCode: '4871', suburb: 'SPRINGFIELD', state: 'QLD' },
  { postCode: '4871', suburb: 'STOCKTON', state: 'QLD' },
  { postCode: '4871', suburb: 'STRATHMORE', state: 'QLD' },
  { postCode: '4871', suburb: 'TALAROO', state: 'QLD' },
  { postCode: '4871', suburb: 'THORNBOROUGH', state: 'QLD' },
  { postCode: '4871', suburb: 'UTCHEE CREEK', state: 'QLD' },
  { postCode: '4871', suburb: 'WANGAN', state: 'QLD' },
  { postCode: '4871', suburb: 'WARRUBULLEN', state: 'QLD' },
  { postCode: '4871', suburb: 'WAUGH POCKET', state: 'QLD' },
  { postCode: '4871', suburb: 'WOOPEN CREEK', state: 'QLD' },
  { postCode: '4871', suburb: 'YARRABAH', state: 'QLD' },
  { postCode: '4872', suburb: 'BARRINE', state: 'QLD' },
  { postCode: '4872', suburb: 'BARWIDGI', state: 'QLD' },
  { postCode: '4872', suburb: 'CAIRNS MC', state: 'QLD' },
  { postCode: '4872', suburb: 'DANBULLA', state: 'QLD' },
  { postCode: '4872', suburb: 'DIMBULAH', state: 'QLD' },
  { postCode: '4872', suburb: 'FORTY MILE', state: 'QLD' },
  { postCode: '4872', suburb: 'GLEN RUTH', state: 'QLD' },
  { postCode: '4872', suburb: 'GUNNAWARRA', state: 'QLD' },
  { postCode: '4872', suburb: 'INNOT HOT SPRINGS', state: 'QLD' },
  { postCode: '4872', suburb: 'KAIRI', state: 'QLD' },
  { postCode: '4872', suburb: 'KIRRAMA', state: 'QLD' },
  { postCode: '4872', suburb: 'KOOMBOOLOOMBA', state: 'QLD' },
  { postCode: '4872', suburb: 'KOWROWA', state: 'QLD' },
  { postCode: '4872', suburb: 'LAKE TINAROO', state: 'QLD' },
  { postCode: '4872', suburb: 'MINNAMOOLKA', state: 'QLD' },
  { postCode: '4872', suburb: 'MOUNT GARNET', state: 'QLD' },
  { postCode: '4872', suburb: 'MUNDERRA', state: 'QLD' },
  { postCode: '4872', suburb: 'MUTCHILBA', state: 'QLD' },
  { postCode: '4872', suburb: 'SILVER VALLEY', state: 'QLD' },
  { postCode: '4872', suburb: 'TINAROO', state: 'QLD' },
  { postCode: '4872', suburb: 'WAIRUNA', state: 'QLD' },
  { postCode: '4872', suburb: 'WALKAMIN', state: 'QLD' },
  { postCode: '4873', suburb: 'BAMBOO', state: 'QLD' },
  { postCode: '4873', suburb: 'BONNIE DOON', state: 'QLD' },
  { postCode: '4873', suburb: 'CAPE TRIBULATION', state: 'QLD' },
  { postCode: '4873', suburb: 'CASSOWARY', state: 'QLD' },
  { postCode: '4873', suburb: 'COOYA BEACH', state: 'QLD' },
  { postCode: '4873', suburb: 'COW BAY', state: 'QLD' },
  { postCode: '4873', suburb: 'DAGMAR', state: 'QLD' },
  { postCode: '4873', suburb: 'DAINTREE', state: 'QLD' },
  { postCode: '4873', suburb: 'DEDIN', state: 'QLD' },
  { postCode: '4873', suburb: 'DIWAN', state: 'QLD' },
  { postCode: '4873', suburb: 'FINLAYVALE', state: 'QLD' },
  { postCode: '4873', suburb: 'FOREST CREEK', state: 'QLD' },
  { postCode: '4873', suburb: 'KIMBERLEY', state: 'QLD' },
  { postCode: '4873', suburb: 'LOW ISLES', state: 'QLD' },
  { postCode: '4873', suburb: 'LOWER DAINTREE', state: 'QLD' },
  { postCode: '4873', suburb: 'MIALLO', state: 'QLD' },
  { postCode: '4873', suburb: 'MOSSMAN', state: 'QLD' },
  { postCode: '4873', suburb: 'MOSSMAN GORGE', state: 'QLD' },
  { postCode: '4873', suburb: 'NEWELL', state: 'QLD' },
  { postCode: '4873', suburb: 'NOAH', state: 'QLD' },
  { postCode: '4873', suburb: 'ROCKY POINT', state: 'QLD' },
  { postCode: '4873', suburb: 'SHANNONVALE', state: 'QLD' },
  { postCode: '4873', suburb: 'SPURGEON', state: 'QLD' },
  { postCode: '4873', suburb: 'STEWART CREEK VALLEY', state: 'QLD' },
  { postCode: '4873', suburb: 'SYNDICATE', state: 'QLD' },
  { postCode: '4873', suburb: 'THORNTON BEACH', state: 'QLD' },
  { postCode: '4873', suburb: 'UPPER DAINTREE', state: 'QLD' },
  { postCode: '4873', suburb: 'WHYANBEEL', state: 'QLD' },
  { postCode: '4873', suburb: 'WONGA BEACH', state: 'QLD' },
  { postCode: '4874', suburb: 'EVANS LANDING', state: 'QLD' },
  { postCode: '4874', suburb: 'JARDINE RIVER', state: 'QLD' },
  { postCode: '4874', suburb: 'MAPOON', state: 'QLD' },
  { postCode: '4874', suburb: 'MISSION RIVER', state: 'QLD' },
  { postCode: '4874', suburb: 'NANUM', state: 'QLD' },
  { postCode: '4874', suburb: 'NAPRANUM', state: 'QLD' },
  { postCode: '4874', suburb: 'ROCKY POINT', state: 'QLD' },
  { postCode: '4874', suburb: 'SHELBURNE', state: 'QLD' },
  { postCode: '4874', suburb: 'TRUNDING', state: 'QLD' },
  { postCode: '4874', suburb: 'WEIPA', state: 'QLD' },
  { postCode: '4874', suburb: 'WEIPA AIRPORT', state: 'QLD' },
  { postCode: '4874', suburb: 'WENLOCK', state: 'QLD' },
  { postCode: '4875', suburb: 'BADU ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'BOIGU ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'COCONUT ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'DAUAN ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'ERUB ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'HORN', state: 'QLD' },
  { postCode: '4875', suburb: 'KERIRI ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'KUBIN', state: 'QLD' },
  { postCode: '4875', suburb: 'MABUIAG ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'MASIG ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'MOA ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'MURRAY ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'PORUMA ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'PRINCE OF WALES', state: 'QLD' },
  { postCode: '4875', suburb: 'SAIBAI ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'STEPHENS ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'THURSDAY ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'WARRABER ISLET', state: 'QLD' },
  { postCode: '4875', suburb: 'YAM ISLAND', state: 'QLD' },
  { postCode: '4875', suburb: 'YORKE ISLAND', state: 'QLD' },
  { postCode: '4876', suburb: 'BAMAGA', state: 'QLD' },
  { postCode: '4876', suburb: 'INJINOO', state: 'QLD' },
  { postCode: '4876', suburb: 'NEW MAPOON', state: 'QLD' },
  { postCode: '4876', suburb: 'SEISIA', state: 'QLD' },
  { postCode: '4876', suburb: 'UMAGICO', state: 'QLD' },
  { postCode: '4877', suburb: 'CRAIGLIE', state: 'QLD' },
  { postCode: '4877', suburb: 'KILLALOE', state: 'QLD' },
  { postCode: '4877', suburb: 'MOWBRAY', state: 'QLD' },
  { postCode: '4877', suburb: 'OAK BEACH', state: 'QLD' },
  { postCode: '4877', suburb: 'PORT DOUGLAS', state: 'QLD' },
  { postCode: '4877', suburb: 'WANGETTI', state: 'QLD' },
  { postCode: '4878', suburb: 'BARRON', state: 'QLD' },
  { postCode: '4878', suburb: 'CARAVONICA', state: 'QLD' },
  { postCode: '4878', suburb: 'HOLLOWAYS BEACH', state: 'QLD' },
  { postCode: '4878', suburb: 'MACHANS BEACH', state: 'QLD' },
  { postCode: '4878', suburb: 'SMITHFIELD', state: 'QLD' },
  { postCode: '4878', suburb: 'YORKEYS KNOB', state: 'QLD' },
  { postCode: '4879', suburb: 'CLIFTON BEACH', state: 'QLD' },
  { postCode: '4879', suburb: 'ELLIS BEACH', state: 'QLD' },
  { postCode: '4879', suburb: 'KEWARRA BEACH', state: 'QLD' },
  { postCode: '4879', suburb: 'PALM COVE', state: 'QLD' },
  { postCode: '4879', suburb: 'TRINITY BEACH', state: 'QLD' },
  { postCode: '4879', suburb: 'TRINITY PARK', state: 'QLD' },
  { postCode: '4880', suburb: 'ARRIGA', state: 'QLD' },
  { postCode: '4880', suburb: 'BIBOOHRA', state: 'QLD' },
  { postCode: '4880', suburb: 'CHEWKO', state: 'QLD' },
  { postCode: '4880', suburb: 'GLEN RUSSELL', state: 'QLD' },
  { postCode: '4880', suburb: 'MAREEBA', state: 'QLD' },
  { postCode: '4880', suburb: 'PADDYS GREEN', state: 'QLD' },
  { postCode: '4881', suburb: 'KOAH', state: 'QLD' },
  { postCode: '4881', suburb: 'KURANDA', state: 'QLD' },
  { postCode: '4881', suburb: 'MONA MONA', state: 'QLD' },
  { postCode: '4881', suburb: 'SPEEWAH', state: 'QLD' },
  { postCode: '4882', suburb: 'TOLGA', state: 'QLD' },
  { postCode: '4883', suburb: 'ATHERTON', state: 'QLD' },
  { postCode: '4883', suburb: 'CARRINGTON', state: 'QLD' },
  { postCode: '4883', suburb: 'EAST BARRON', state: 'QLD' },
  { postCode: '4883', suburb: 'UPPER BARRON', state: 'QLD' },
  { postCode: '4883', suburb: 'WONGABEL', state: 'QLD' },
  { postCode: '4884', suburb: 'GADGARRA', state: 'QLD' },
  { postCode: '4884', suburb: 'LAKE BARRINE', state: 'QLD' },
  { postCode: '4884', suburb: 'LAKE EACHAM', state: 'QLD' },
  { postCode: '4884', suburb: 'YUNGABURRA', state: 'QLD' },
  { postCode: '4885', suburb: 'BUTCHERS CREEK', state: 'QLD' },
  { postCode: '4885', suburb: 'GLEN ALLYN', state: 'QLD' },
  { postCode: '4885', suburb: 'JAGGAN', state: 'QLD' },
  { postCode: '4885', suburb: 'KUREEN', state: 'QLD' },
  { postCode: '4885', suburb: 'MALANDA', state: 'QLD' },
  { postCode: '4885', suburb: 'NORTH JOHNSTONE', state: 'QLD' },
  { postCode: '4885', suburb: 'PEERAMON', state: 'QLD' },
  { postCode: '4885', suburb: 'TARZALI', state: 'QLD' },
  { postCode: '4885', suburb: 'TOPAZ', state: 'QLD' },
  { postCode: '4886', suburb: 'BEATRICE', state: 'QLD' },
  { postCode: '4886', suburb: 'ELLINJAA', state: 'QLD' },
  { postCode: '4886', suburb: 'MAALAN', state: 'QLD' },
  { postCode: '4886', suburb: 'MIDDLEBROOK', state: 'QLD' },
  { postCode: '4886', suburb: 'MILLAA MILLAA', state: 'QLD' },
  { postCode: '4886', suburb: 'MINBUN', state: 'QLD' },
  { postCode: '4886', suburb: 'MOREGATTA', state: 'QLD' },
  { postCode: '4886', suburb: 'MUNGALLI', state: 'QLD' },
  { postCode: '4887', suburb: 'HERBERTON', state: 'QLD' },
  { postCode: '4887', suburb: 'IRVINEBANK', state: 'QLD' },
  { postCode: '4887', suburb: 'KALUNGA', state: 'QLD' },
  { postCode: '4887', suburb: 'MOOMIN', state: 'QLD' },
  { postCode: '4887', suburb: 'WATSONVILLE', state: 'QLD' },
  { postCode: '4887', suburb: 'WONDECLA', state: 'QLD' },
  { postCode: '4888', suburb: 'EVELYN', state: 'QLD' },
  { postCode: '4888', suburb: 'KABAN', state: 'QLD' },
  { postCode: '4888', suburb: 'MILLSTREAM', state: 'QLD' },
  { postCode: '4888', suburb: 'RAVENSHOE', state: 'QLD' },
  { postCode: '4888', suburb: 'TUMOULIN', state: 'QLD' },
  { postCode: '4890', suburb: 'HOWITT', state: 'QLD' },
  { postCode: '4890', suburb: 'NORMANTON', state: 'QLD' },
  { postCode: '4891', suburb: 'KARUMBA', state: 'QLD' },
  { postCode: '4892', suburb: 'ABINGDON DOWNS', state: 'QLD' },
  { postCode: '4892', suburb: 'ARBOUIN', state: 'QLD' },
  { postCode: '4892', suburb: 'ARCHER RIVER', state: 'QLD' },
  { postCode: '4892', suburb: 'AURUKUN', state: 'QLD' },
  { postCode: '4892', suburb: 'BELLEVUE', state: 'QLD' },
  { postCode: '4892', suburb: 'COEN', state: 'QLD' },
  { postCode: '4892', suburb: 'DIXIE', state: 'QLD' },
  { postCode: '4892', suburb: 'EDWARD RIVER', state: 'QLD' },
  { postCode: '4892', suburb: 'GAMBOOLA', state: 'QLD' },
  { postCode: '4892', suburb: 'GROGANVILLE', state: 'QLD' },
  { postCode: '4892', suburb: 'GUNUNA', state: 'QLD' },
  { postCode: '4892', suburb: 'HIGHBURY', state: 'QLD' },
  { postCode: '4892', suburb: 'HOLROYD RIVER', state: 'QLD' },
  { postCode: '4892', suburb: 'KOWANYAMA', state: 'QLD' },
  { postCode: '4892', suburb: 'LAKEFIELD', state: 'QLD' },
  { postCode: '4892', suburb: 'LAURA', state: 'QLD' },
  { postCode: '4892', suburb: 'LIZARD', state: 'QLD' },
  { postCode: '4892', suburb: 'LOCKHART RIVER', state: 'QLD' },
  { postCode: '4892', suburb: 'LYNDSIDE', state: 'QLD' },
  { postCode: '4892', suburb: 'MARAMIE', state: 'QLD' },
  { postCode: '4892', suburb: 'MOUNT MULGRAVE', state: 'QLD' },
  { postCode: '4892', suburb: 'PALMER', state: 'QLD' },
  { postCode: '4892', suburb: 'PORMPURAAW', state: 'QLD' },
  { postCode: '4892', suburb: 'RAVENSWORTH', state: 'QLD' },
  { postCode: '4892', suburb: 'RED RIVER', state: 'QLD' },
  { postCode: '4892', suburb: 'SOUTH WELLESLEY ISLANDS', state: 'QLD' },
  { postCode: '4892', suburb: 'STAATEN', state: 'QLD' },
  { postCode: '4892', suburb: 'WELLESLEY ISLANDS', state: 'QLD' },
  { postCode: '4892', suburb: 'WEST WELLESLEY ISLANDS', state: 'QLD' },
  { postCode: '4892', suburb: 'WROTHAM', state: 'QLD' },
  { postCode: '4892', suburb: 'YAGOONYA', state: 'QLD' },
  { postCode: '4892', suburb: 'YARRADEN', state: 'QLD' },
  { postCode: '4895', suburb: 'AYTON', state: 'QLD' },
  { postCode: '4895', suburb: 'BLOOMFIELD', state: 'QLD' },
  { postCode: '4895', suburb: 'COOKTOWN', state: 'QLD' },
  { postCode: '4895', suburb: 'DEGARRA', state: 'QLD' },
  { postCode: '4895', suburb: 'HELENVALE', state: 'QLD' },
  { postCode: '4895', suburb: 'HOPE VALE', state: 'QLD' },
  { postCode: '4895', suburb: 'ROSSVILLE', state: 'QLD' },
  { postCode: '4895', suburb: 'STARCKE', state: 'QLD' },
  { postCode: '4895', suburb: 'WUJAL WUJAL', state: 'QLD' },
  { postCode: '5000', suburb: 'ADELAIDE', state: 'SA' },
  { postCode: '5000', suburb: 'ADELAIDE BC', state: 'SA' },
  { postCode: '5000', suburb: 'CITY WEST CAMPUS', state: 'SA' },
  { postCode: '5000', suburb: 'HALIFAX STREET', state: 'SA' },
  { postCode: '5000', suburb: 'HUTT STREET', state: 'SA' },
  { postCode: '5000', suburb: 'RUNDLE MALL', state: 'SA' },
  { postCode: '5000', suburb: 'STATION ARCADE', state: 'SA' },
  { postCode: '5000', suburb: 'STURT STREET', state: 'SA' },
  { postCode: '5001', suburb: 'ADELAIDE', state: 'SA' },
  { postCode: '5005', suburb: 'UNIVERSITY OF ADELAIDE', state: 'SA' },
  { postCode: '5006', suburb: 'NORTH ADELAIDE', state: 'SA' },
  { postCode: '5006', suburb: 'NORTH ADELAIDE MELBOURNE ST', state: 'SA' },
  { postCode: '5007', suburb: 'BOWDEN', state: 'SA' },
  { postCode: '5007', suburb: 'BROMPTON', state: 'SA' },
  { postCode: '5007', suburb: 'HINDMARSH', state: 'SA' },
  { postCode: '5007', suburb: 'WELLAND', state: 'SA' },
  { postCode: '5007', suburb: 'WEST HINDMARSH', state: 'SA' },
  { postCode: '5008', suburb: 'CROYDON', state: 'SA' },
  { postCode: '5008', suburb: 'CROYDON PARK', state: 'SA' },
  { postCode: '5008', suburb: 'DEVON PARK', state: 'SA' },
  { postCode: '5008', suburb: 'DUDLEY PARK', state: 'SA' },
  { postCode: '5008', suburb: 'RENOWN PARK', state: 'SA' },
  { postCode: '5008', suburb: 'RIDLEYTON', state: 'SA' },
  { postCode: '5008', suburb: 'WEST CROYDON', state: 'SA' },
  { postCode: '5009', suburb: 'ALLENBY GARDENS', state: 'SA' },
  { postCode: '5009', suburb: 'BEVERLEY', state: 'SA' },
  { postCode: '5009', suburb: 'KILKENNY', state: 'SA' },
  { postCode: '5010', suburb: 'ANGLE PARK', state: 'SA' },
  { postCode: '5010', suburb: 'FERRYDEN PARK', state: 'SA' },
  { postCode: '5010', suburb: 'REGENCY PARK', state: 'SA' },
  { postCode: '5011', suburb: 'ST CLAIR', state: 'SA' },
  { postCode: '5011', suburb: 'WOODVILLE', state: 'SA' },
  { postCode: '5011', suburb: 'WOODVILLE PARK', state: 'SA' },
  { postCode: '5011', suburb: 'WOODVILLE SOUTH', state: 'SA' },
  { postCode: '5011', suburb: 'WOODVILLE WEST', state: 'SA' },
  { postCode: '5012', suburb: 'ATHOL PARK', state: 'SA' },
  { postCode: '5012', suburb: 'MANSFIELD PARK', state: 'SA' },
  { postCode: '5012', suburb: 'WOODVILLE GARDENS', state: 'SA' },
  { postCode: '5012', suburb: 'WOODVILLE NORTH', state: 'SA' },
  { postCode: '5013', suburb: 'GILLMAN', state: 'SA' },
  { postCode: '5013', suburb: 'OTTOWAY', state: 'SA' },
  { postCode: '5013', suburb: 'PENNINGTON', state: 'SA' },
  { postCode: '5013', suburb: 'ROSEWATER', state: 'SA' },
  { postCode: '5013', suburb: 'ROSEWATER EAST', state: 'SA' },
  { postCode: '5013', suburb: 'WINGFIELD', state: 'SA' },
  { postCode: '5014', suburb: 'ALBERT PARK', state: 'SA' },
  { postCode: '5014', suburb: 'ALBERTON', state: 'SA' },
  { postCode: '5014', suburb: 'CHELTENHAM', state: 'SA' },
  { postCode: '5014', suburb: 'HENDON', state: 'SA' },
  { postCode: '5014', suburb: 'QUEENSTOWN', state: 'SA' },
  { postCode: '5014', suburb: 'ROYAL PARK', state: 'SA' },
  { postCode: '5015', suburb: 'BIRKENHEAD', state: 'SA' },
  { postCode: '5015', suburb: 'ETHELTON', state: 'SA' },
  { postCode: '5015', suburb: 'GLANVILLE', state: 'SA' },
  { postCode: '5015', suburb: 'NEW PORT', state: 'SA' },
  { postCode: '5015', suburb: 'PORT ADELAIDE', state: 'SA' },
  { postCode: '5015', suburb: 'PORT ADELAIDE DC', state: 'SA' },
  { postCode: '5016', suburb: 'LARGS BAY', state: 'SA' },
  { postCode: '5016', suburb: 'LARGS NORTH', state: 'SA' },
  { postCode: '5016', suburb: 'PETERHEAD', state: 'SA' },
  { postCode: '5017', suburb: 'OSBORNE', state: 'SA' },
  { postCode: '5017', suburb: 'TAPEROO', state: 'SA' },
  { postCode: '5018', suburb: 'NORTH HAVEN', state: 'SA' },
  { postCode: '5018', suburb: 'OUTER HARBOR', state: 'SA' },
  { postCode: '5019', suburb: 'EXETER', state: 'SA' },
  { postCode: '5019', suburb: 'SEMAPHORE', state: 'SA' },
  { postCode: '5019', suburb: 'SEMAPHORE PARK', state: 'SA' },
  { postCode: '5019', suburb: 'SEMAPHORE SOUTH', state: 'SA' },
  { postCode: '5020', suburb: 'WEST LAKES SHORE', state: 'SA' },
  { postCode: '5021', suburb: 'WEST LAKES', state: 'SA' },
  { postCode: '5022', suburb: 'GRANGE', state: 'SA' },
  { postCode: '5022', suburb: 'HENLEY BEACH', state: 'SA' },
  { postCode: '5022', suburb: 'HENLEY BEACH SOUTH', state: 'SA' },
  { postCode: '5022', suburb: 'TENNYSON', state: 'SA' },
  { postCode: '5023', suburb: 'FINDON', state: 'SA' },
  { postCode: '5023', suburb: 'SEATON', state: 'SA' },
  { postCode: '5024', suburb: 'FULHAM', state: 'SA' },
  { postCode: '5024', suburb: 'FULHAM GARDENS', state: 'SA' },
  { postCode: '5024', suburb: 'WEST BEACH', state: 'SA' },
  { postCode: '5025', suburb: 'FLINDERS PARK', state: 'SA' },
  { postCode: '5025', suburb: 'KIDMAN PARK', state: 'SA' },
  { postCode: '5031', suburb: 'MILE END', state: 'SA' },
  { postCode: '5031', suburb: 'MILE END SOUTH', state: 'SA' },
  { postCode: '5031', suburb: 'THEBARTON', state: 'SA' },
  { postCode: '5031', suburb: 'TORRENSVILLE', state: 'SA' },
  { postCode: '5031', suburb: 'TORRENSVILLE PLAZA', state: 'SA' },
  { postCode: '5032', suburb: 'BROOKLYN PARK', state: 'SA' },
  { postCode: '5032', suburb: 'LOCKLEYS', state: 'SA' },
  { postCode: '5032', suburb: 'UNDERDALE', state: 'SA' },
  { postCode: '5033', suburb: 'COWANDILLA', state: 'SA' },
  { postCode: '5033', suburb: 'HILTON', state: 'SA' },
  { postCode: '5033', suburb: 'HILTON PLAZA', state: 'SA' },
  { postCode: '5033', suburb: 'MARLESTON', state: 'SA' },
  { postCode: '5033', suburb: 'MARLESTON DC', state: 'SA' },
  { postCode: '5033', suburb: 'RICHMOND', state: 'SA' },
  { postCode: '5033', suburb: 'WEST RICHMOND', state: 'SA' },
  { postCode: '5034', suburb: 'CLARENCE PARK', state: 'SA' },
  { postCode: '5034', suburb: 'GOODWOOD', state: 'SA' },
  { postCode: '5034', suburb: 'KINGS PARK', state: 'SA' },
  { postCode: '5034', suburb: 'MILLSWOOD', state: 'SA' },
  { postCode: '5034', suburb: 'WAYVILLE', state: 'SA' },
  { postCode: '5035', suburb: 'ASHFORD', state: 'SA' },
  { postCode: '5035', suburb: 'BLACK FOREST', state: 'SA' },
  { postCode: '5035', suburb: 'EVERARD PARK', state: 'SA' },
  { postCode: '5035', suburb: 'FORESTVILLE', state: 'SA' },
  { postCode: '5035', suburb: 'KESWICK', state: 'SA' },
  { postCode: '5035', suburb: 'KESWICK TERMINAL', state: 'SA' },
  { postCode: '5037', suburb: 'GLANDORE', state: 'SA' },
  { postCode: '5037', suburb: 'KURRALTA PARK', state: 'SA' },
  { postCode: '5037', suburb: 'NETLEY', state: 'SA' },
  { postCode: '5037', suburb: 'NORTH PLYMPTON', state: 'SA' },
  { postCode: '5038', suburb: 'CAMDEN PARK', state: 'SA' },
  { postCode: '5038', suburb: 'PLYMPTON', state: 'SA' },
  { postCode: '5038', suburb: 'PLYMPTON PARK', state: 'SA' },
  { postCode: '5038', suburb: 'SOUTH PLYMPTON', state: 'SA' },
  { postCode: '5039', suburb: 'CLARENCE GARDENS', state: 'SA' },
  { postCode: '5039', suburb: 'EDWARDSTOWN', state: 'SA' },
  { postCode: '5039', suburb: 'MELROSE PARK', state: 'SA' },
  { postCode: '5039', suburb: 'MELROSE PARK DC', state: 'SA' },
  { postCode: '5040', suburb: 'NOVAR GARDENS', state: 'SA' },
  { postCode: '5041', suburb: 'COLONEL LIGHT GARDENS', state: 'SA' },
  { postCode: '5041', suburb: 'CUMBERLAND PARK', state: 'SA' },
  { postCode: '5041', suburb: 'DAW PARK', state: 'SA' },
  { postCode: '5041', suburb: 'PANORAMA', state: 'SA' },
  { postCode: '5041', suburb: 'WESTBOURNE PARK', state: 'SA' },
  { postCode: '5042', suburb: 'BEDFORD PARK', state: 'SA' },
  { postCode: '5042', suburb: 'CLOVELLY PARK', state: 'SA' },
  { postCode: '5042', suburb: 'FLINDERS UNIVERSITY', state: 'SA' },
  { postCode: '5042', suburb: 'PASADENA', state: 'SA' },
  { postCode: '5042', suburb: 'ST MARYS', state: 'SA' },
  { postCode: '5042', suburb: 'TONSLEY', state: 'SA' },
  { postCode: '5043', suburb: 'ASCOT PARK', state: 'SA' },
  { postCode: '5043', suburb: 'MARION', state: 'SA' },
  { postCode: '5043', suburb: 'MITCHELL PARK', state: 'SA' },
  { postCode: '5043', suburb: 'MORPHETTVILLE', state: 'SA' },
  { postCode: '5043', suburb: 'PARK HOLME', state: 'SA' },
  { postCode: '5044', suburb: 'GLENGOWRIE', state: 'SA' },
  { postCode: '5044', suburb: 'SOMERTON PARK', state: 'SA' },
  { postCode: '5045', suburb: 'GLENELG', state: 'SA' },
  { postCode: '5045', suburb: 'GLENELG EAST', state: 'SA' },
  { postCode: '5045', suburb: 'GLENELG NORTH', state: 'SA' },
  { postCode: '5045', suburb: 'GLENELG SOUTH', state: 'SA' },
  { postCode: '5046', suburb: 'OAKLANDS PARK', state: 'SA' },
  { postCode: '5046', suburb: 'WARRADALE', state: 'SA' },
  { postCode: '5046', suburb: 'WARRADALE NORTH', state: 'SA' },
  { postCode: '5047', suburb: 'DARLINGTON', state: 'SA' },
  { postCode: '5047', suburb: 'SEACOMBE GARDENS', state: 'SA' },
  { postCode: '5047', suburb: 'SEACOMBE HEIGHTS', state: 'SA' },
  { postCode: '5047', suburb: 'STURT', state: 'SA' },
  { postCode: '5048', suburb: 'BRIGHTON', state: 'SA' },
  { postCode: '5048', suburb: 'DOVER GARDENS', state: 'SA' },
  { postCode: '5048', suburb: 'HOVE', state: 'SA' },
  { postCode: '5048', suburb: 'NORTH BRIGHTON', state: 'SA' },
  { postCode: '5048', suburb: 'SOUTH BRIGHTON', state: 'SA' },
  { postCode: '5049', suburb: 'KINGSTON PARK', state: 'SA' },
  { postCode: '5049', suburb: 'MARINO', state: 'SA' },
  { postCode: '5049', suburb: 'SEACLIFF', state: 'SA' },
  { postCode: '5049', suburb: 'SEACLIFF PARK', state: 'SA' },
  { postCode: '5049', suburb: 'SEAVIEW DOWNS', state: 'SA' },
  { postCode: '5050', suburb: 'BELLEVUE HEIGHTS', state: 'SA' },
  { postCode: '5050', suburb: 'EDEN HILLS', state: 'SA' },
  { postCode: '5051', suburb: 'BLACKWOOD', state: 'SA' },
  { postCode: '5051', suburb: 'COROMANDEL VALLEY', state: 'SA' },
  { postCode: '5051', suburb: 'CRAIGBURN FARM', state: 'SA' },
  { postCode: '5051', suburb: 'HAWTHORNDENE', state: 'SA' },
  { postCode: '5052', suburb: 'BELAIR', state: 'SA' },
  { postCode: '5052', suburb: 'GLENALTA', state: 'SA' },
  { postCode: '5061', suburb: 'HYDE PARK', state: 'SA' },
  { postCode: '5061', suburb: 'MALVERN', state: 'SA' },
  { postCode: '5061', suburb: 'UNLEY', state: 'SA' },
  { postCode: '5061', suburb: 'UNLEY BC', state: 'SA' },
  { postCode: '5061', suburb: 'UNLEY DC', state: 'SA' },
  { postCode: '5061', suburb: 'UNLEY PARK', state: 'SA' },
  { postCode: '5062', suburb: 'BROWN HILL CREEK', state: 'SA' },
  { postCode: '5062', suburb: 'CLAPHAM', state: 'SA' },
  { postCode: '5062', suburb: 'HAWTHORN', state: 'SA' },
  { postCode: '5062', suburb: 'KINGSWOOD', state: 'SA' },
  { postCode: '5062', suburb: 'LOWER MITCHAM', state: 'SA' },
  { postCode: '5062', suburb: 'LYNTON', state: 'SA' },
  { postCode: '5062', suburb: 'MITCHAM', state: 'SA' },
  { postCode: '5062', suburb: 'MITCHAM SHOPPING CENTRE', state: 'SA' },
  { postCode: '5062', suburb: 'NETHERBY', state: 'SA' },
  { postCode: '5062', suburb: 'SPRINGFIELD', state: 'SA' },
  { postCode: '5062', suburb: 'TORRENS PARK', state: 'SA' },
  { postCode: '5063', suburb: 'EASTWOOD', state: 'SA' },
  { postCode: '5063', suburb: 'FREWVILLE', state: 'SA' },
  { postCode: '5063', suburb: 'FULLARTON', state: 'SA' },
  { postCode: '5063', suburb: 'HIGHGATE', state: 'SA' },
  { postCode: '5063', suburb: 'PARKSIDE', state: 'SA' },
  { postCode: '5064', suburb: 'GLEN OSMOND', state: 'SA' },
  { postCode: '5064', suburb: 'GLENUNGA', state: 'SA' },
  { postCode: '5064', suburb: 'MOUNT OSMOND', state: 'SA' },
  { postCode: '5064', suburb: 'MYRTLE BANK', state: 'SA' },
  { postCode: '5064', suburb: 'ST GEORGES', state: 'SA' },
  { postCode: '5064', suburb: 'URRBRAE', state: 'SA' },
  { postCode: '5065', suburb: 'DULWICH', state: 'SA' },
  { postCode: '5065', suburb: 'GLENSIDE', state: 'SA' },
  { postCode: '5065', suburb: 'LINDEN PARK', state: 'SA' },
  { postCode: '5065', suburb: 'TOORAK GARDENS', state: 'SA' },
  { postCode: '5065', suburb: 'TUSMORE', state: 'SA' },
  { postCode: '5066', suburb: 'BEAUMONT', state: 'SA' },
  { postCode: '5066', suburb: 'BURNSIDE', state: 'SA' },
  { postCode: '5066', suburb: 'ERINDALE', state: 'SA' },
  { postCode: '5066', suburb: 'HAZELWOOD PARK', state: 'SA' },
  { postCode: '5066', suburb: 'STONYFELL', state: 'SA' },
  { postCode: '5066', suburb: 'WATERFALL GULLY', state: 'SA' },
  { postCode: '5066', suburb: 'WATTLE PARK', state: 'SA' },
  { postCode: '5067', suburb: 'BEULAH PARK', state: 'SA' },
  { postCode: '5067', suburb: 'KENT TOWN', state: 'SA' },
  { postCode: '5067', suburb: 'NORWOOD', state: 'SA' },
  { postCode: '5067', suburb: 'NORWOOD SOUTH', state: 'SA' },
  { postCode: '5067', suburb: 'ROSE PARK', state: 'SA' },
  { postCode: '5068', suburb: 'HEATHPOOL', state: 'SA' },
  { postCode: '5068', suburb: 'KENSINGTON', state: 'SA' },
  { postCode: '5068', suburb: 'KENSINGTON GARDENS', state: 'SA' },
  { postCode: '5068', suburb: 'KENSINGTON PARK', state: 'SA' },
  { postCode: '5068', suburb: 'LEABROOK', state: 'SA' },
  { postCode: '5068', suburb: 'MARRYATVILLE', state: 'SA' },
  { postCode: '5068', suburb: 'ST MORRIS', state: 'SA' },
  { postCode: '5068', suburb: 'TRINITY GARDENS', state: 'SA' },
  { postCode: '5069', suburb: 'COLLEGE PARK', state: 'SA' },
  { postCode: '5069', suburb: 'EVANDALE', state: 'SA' },
  { postCode: '5069', suburb: 'HACKNEY', state: 'SA' },
  { postCode: '5069', suburb: 'MAYLANDS', state: 'SA' },
  { postCode: '5069', suburb: 'ST PETERS', state: 'SA' },
  { postCode: '5069', suburb: 'STEPNEY', state: 'SA' },
  { postCode: '5070', suburb: 'FELIXSTOW', state: 'SA' },
  { postCode: '5070', suburb: 'FIRLE', state: 'SA' },
  { postCode: '5070', suburb: 'GLYNDE', state: 'SA' },
  { postCode: '5070', suburb: 'GLYNDE PLAZA', state: 'SA' },
  { postCode: '5070', suburb: 'JOSLIN', state: 'SA' },
  { postCode: '5070', suburb: 'MARDEN', state: 'SA' },
  { postCode: '5070', suburb: 'PAYNEHAM', state: 'SA' },
  { postCode: '5070', suburb: 'PAYNEHAM SOUTH', state: 'SA' },
  { postCode: '5070', suburb: 'ROYSTON PARK', state: 'SA' },
  { postCode: '5071', suburb: 'KENT TOWN DC', state: 'SA' },
  { postCode: '5072', suburb: 'AULDANA', state: 'SA' },
  { postCode: '5072', suburb: 'MAGILL', state: 'SA' },
  { postCode: '5072', suburb: 'MAGILL NORTH', state: 'SA' },
  { postCode: '5072', suburb: 'MAGILL SOUTH', state: 'SA' },
  { postCode: '5072', suburb: 'ROSSLYN PARK', state: 'SA' },
  { postCode: '5072', suburb: 'SKYE', state: 'SA' },
  { postCode: '5072', suburb: 'TERINGIE', state: 'SA' },
  { postCode: '5072', suburb: 'WOODFORDE', state: 'SA' },
  { postCode: '5073', suburb: 'HECTORVILLE', state: 'SA' },
  { postCode: '5073', suburb: 'ROSTREVOR', state: 'SA' },
  { postCode: '5073', suburb: 'TRANMERE', state: 'SA' },
  { postCode: '5073', suburb: 'TRANMERE NORTH', state: 'SA' },
  { postCode: '5074', suburb: 'CAMPBELLTOWN', state: 'SA' },
  { postCode: '5074', suburb: 'NEWTON', state: 'SA' },
  { postCode: '5075', suburb: 'DERNANCOURT', state: 'SA' },
  { postCode: '5075', suburb: 'PARADISE', state: 'SA' },
  { postCode: '5076', suburb: 'ATHELSTONE', state: 'SA' },
  { postCode: '5076', suburb: 'CASTAMBUL', state: 'SA' },
  { postCode: '5081', suburb: 'COLLINSWOOD', state: 'SA' },
  { postCode: '5081', suburb: 'GILBERTON', state: 'SA' },
  { postCode: '5081', suburb: 'MEDINDIE', state: 'SA' },
  { postCode: '5081', suburb: 'MEDINDIE GARDENS', state: 'SA' },
  { postCode: '5081', suburb: 'VALE PARK', state: 'SA' },
  { postCode: '5081', suburb: 'WALKERVILLE', state: 'SA' },
  { postCode: '5082', suburb: 'FITZROY', state: 'SA' },
  { postCode: '5082', suburb: 'OVINGHAM', state: 'SA' },
  { postCode: '5082', suburb: 'PROSPECT', state: 'SA' },
  { postCode: '5082', suburb: 'PROSPECT EAST', state: 'SA' },
  { postCode: '5082', suburb: 'THORNGATE', state: 'SA' },
  { postCode: '5083', suburb: 'BROADVIEW', state: 'SA' },
  { postCode: '5083', suburb: 'NAILSWORTH', state: 'SA' },
  { postCode: '5083', suburb: 'SEFTON PARK', state: 'SA' },
  { postCode: '5084', suburb: 'BLAIR ATHOL', state: 'SA' },
  { postCode: '5084', suburb: 'KILBURN', state: 'SA' },
  { postCode: '5084', suburb: 'KILBURN NORTH', state: 'SA' },
  { postCode: '5085', suburb: 'CLEARVIEW', state: 'SA' },
  { postCode: '5085', suburb: 'ENFIELD', state: 'SA' },
  { postCode: '5085', suburb: 'ENFIELD PLAZA', state: 'SA' },
  { postCode: '5085', suburb: 'LIGHTSVIEW', state: 'SA' },
  { postCode: '5085', suburb: 'NORTHFIELD', state: 'SA' },
  { postCode: '5085', suburb: 'NORTHGATE', state: 'SA' },
  { postCode: '5086', suburb: 'GILLES PLAINS', state: 'SA' },
  { postCode: '5086', suburb: 'GREENACRES', state: 'SA' },
  { postCode: '5086', suburb: 'HAMPSTEAD GARDENS', state: 'SA' },
  { postCode: '5086', suburb: 'HILLCREST', state: 'SA' },
  { postCode: '5086', suburb: 'MANNINGHAM', state: 'SA' },
  { postCode: '5086', suburb: 'OAKDEN', state: 'SA' },
  { postCode: '5087', suburb: 'KLEMZIG', state: 'SA' },
  { postCode: '5087', suburb: 'WINDSOR GARDENS', state: 'SA' },
  { postCode: '5088', suburb: 'HOLDEN HILL', state: 'SA' },
  { postCode: '5089', suburb: 'HIGHBURY', state: 'SA' },
  { postCode: '5090', suburb: 'HOPE VALLEY', state: 'SA' },
  { postCode: '5091', suburb: 'BANKSIA PARK', state: 'SA' },
  { postCode: '5091', suburb: 'TEA TREE GULLY', state: 'SA' },
  { postCode: '5091', suburb: 'VISTA', state: 'SA' },
  { postCode: '5092', suburb: 'MODBURY', state: 'SA' },
  { postCode: '5092', suburb: 'MODBURY HEIGHTS', state: 'SA' },
  { postCode: '5092', suburb: 'MODBURY NORTH', state: 'SA' },
  { postCode: '5092', suburb: 'MODBURY NORTH DC', state: 'SA' },
  { postCode: '5093', suburb: 'PARA VISTA', state: 'SA' },
  { postCode: '5093', suburb: 'VALLEY VIEW', state: 'SA' },
  { postCode: '5094', suburb: 'CAVAN', state: 'SA' },
  { postCode: '5094', suburb: 'DRY CREEK', state: 'SA' },
  { postCode: '5094', suburb: 'GEPPS CROSS', state: 'SA' },
  { postCode: '5095', suburb: 'MAWSON LAKES', state: 'SA' },
  { postCode: '5095', suburb: 'POORAKA', state: 'SA' },
  { postCode: '5096', suburb: 'GULFVIEW HEIGHTS', state: 'SA' },
  { postCode: '5096', suburb: 'PARA HILLS', state: 'SA' },
  { postCode: '5096', suburb: 'PARA HILLS WEST', state: 'SA' },
  { postCode: '5097', suburb: 'REDWOOD PARK', state: 'SA' },
  { postCode: '5097', suburb: 'RIDGEHAVEN', state: 'SA' },
  { postCode: '5097', suburb: 'ST AGNES', state: 'SA' },
  { postCode: '5098', suburb: 'INGLE FARM', state: 'SA' },
  { postCode: '5098', suburb: 'WALKLEY HEIGHTS', state: 'SA' },
  { postCode: '5106', suburb: 'PARAFIELD', state: 'SA' },
  { postCode: '5106', suburb: 'SALISBURY SOUTH', state: 'SA' },
  { postCode: '5106', suburb: 'SALISBURY SOUTH BC', state: 'SA' },
  { postCode: '5106', suburb: 'SALISBURY SOUTH DC', state: 'SA' },
  { postCode: '5107', suburb: 'GREEN FIELDS', state: 'SA' },
  { postCode: '5107', suburb: 'PARAFIELD GARDENS', state: 'SA' },
  { postCode: '5108', suburb: 'PARALOWIE', state: 'SA' },
  { postCode: '5108', suburb: 'SALISBURY', state: 'SA' },
  { postCode: '5108', suburb: 'SALISBURY DOWNS', state: 'SA' },
  { postCode: '5108', suburb: 'SALISBURY NORTH', state: 'SA' },
  { postCode: '5108', suburb: 'SALISBURY NORTH WHITES ROAD', state: 'SA' },
  { postCode: '5109', suburb: 'BRAHMA LODGE', state: 'SA' },
  { postCode: '5109', suburb: 'SALISBURY EAST', state: 'SA' },
  { postCode: '5109', suburb: 'SALISBURY EAST NORTHBRI AVE', state: 'SA' },
  { postCode: '5109', suburb: 'SALISBURY HEIGHTS', state: 'SA' },
  { postCode: '5109', suburb: 'SALISBURY PARK', state: 'SA' },
  { postCode: '5109', suburb: 'SALISBURY PLAIN', state: 'SA' },
  { postCode: '5110', suburb: 'BOLIVAR', state: 'SA' },
  { postCode: '5110', suburb: 'BURTON', state: 'SA' },
  { postCode: '5110', suburb: 'DIREK', state: 'SA' },
  { postCode: '5110', suburb: 'GLOBE DERBY PARK', state: 'SA' },
  { postCode: '5110', suburb: 'ST KILDA', state: 'SA' },
  { postCode: '5110', suburb: 'WATERLOO CORNER', state: 'SA' },
  { postCode: '5111', suburb: 'EDINBURGH', state: 'SA' },
  { postCode: '5111', suburb: 'EDINBURGH RAAF', state: 'SA' },
  { postCode: '5112', suburb: 'ELIZABETH', state: 'SA' },
  { postCode: '5112', suburb: 'ELIZABETH EAST', state: 'SA' },
  { postCode: '5112', suburb: 'ELIZABETH GROVE', state: 'SA' },
  { postCode: '5112', suburb: 'ELIZABETH SOUTH', state: 'SA' },
  { postCode: '5112', suburb: 'ELIZABETH VALE', state: 'SA' },
  { postCode: '5112', suburb: 'HILLBANK', state: 'SA' },
  { postCode: '5113', suburb: 'DAVOREN PARK', state: 'SA' },
  { postCode: '5113', suburb: 'DAVOREN PARK SOUTH', state: 'SA' },
  { postCode: '5113', suburb: 'EDINBURGH NORTH', state: 'SA' },
  { postCode: '5113', suburb: 'ELIZABETH DOWNS', state: 'SA' },
  { postCode: '5113', suburb: 'ELIZABETH NORTH', state: 'SA' },
  { postCode: '5113', suburb: 'ELIZABETH PARK', state: 'SA' },
  { postCode: '5113', suburb: 'ELIZABETH WEST DC', state: 'SA' },
  { postCode: '5114', suburb: 'ANDREWS FARM', state: 'SA' },
  { postCode: '5114', suburb: 'BLAKEVIEW', state: 'SA' },
  { postCode: '5114', suburb: 'CRAIGMORE', state: 'SA' },
  { postCode: '5114', suburb: 'GOULD CREEK', state: 'SA' },
  { postCode: '5114', suburb: 'HUMBUG SCRUB', state: 'SA' },
  { postCode: '5114', suburb: 'ONE TREE HILL', state: 'SA' },
  { postCode: '5114', suburb: 'SAMPSON FLAT', state: 'SA' },
  { postCode: '5114', suburb: 'SMITHFIELD', state: 'SA' },
  { postCode: '5114', suburb: 'SMITHFIELD PLAINS', state: 'SA' },
  { postCode: '5114', suburb: 'SMITHFIELD WEST', state: 'SA' },
  { postCode: '5114', suburb: 'ULEYBURY', state: 'SA' },
  { postCode: '5114', suburb: 'YATTALUNGA', state: 'SA' },
  { postCode: '5115', suburb: 'KUDLA', state: 'SA' },
  { postCode: '5115', suburb: 'MUNNO PARA', state: 'SA' },
  { postCode: '5115', suburb: 'MUNNO PARA DOWNS', state: 'SA' },
  { postCode: '5115', suburb: 'MUNNO PARA WEST', state: 'SA' },
  { postCode: '5116', suburb: 'EVANSTON', state: 'SA' },
  { postCode: '5116', suburb: 'EVANSTON GARDENS', state: 'SA' },
  { postCode: '5116', suburb: 'EVANSTON PARK', state: 'SA' },
  { postCode: '5116', suburb: 'EVANSTON SOUTH', state: 'SA' },
  { postCode: '5116', suburb: 'HILLIER', state: 'SA' },
  { postCode: '5117', suburb: 'ANGLE VALE', state: 'SA' },
  { postCode: '5118', suburb: 'BIBARINGA', state: 'SA' },
  { postCode: '5118', suburb: 'BUCHFELDE', state: 'SA' },
  { postCode: '5118', suburb: 'CONCORDIA', state: 'SA' },
  { postCode: '5118', suburb: 'GAWLER', state: 'SA' },
  { postCode: '5118', suburb: 'GAWLER BELT', state: 'SA' },
  { postCode: '5118', suburb: 'GAWLER EAST', state: 'SA' },
  { postCode: '5118', suburb: 'GAWLER RIVER', state: 'SA' },
  { postCode: '5118', suburb: 'GAWLER SOUTH', state: 'SA' },
  { postCode: '5118', suburb: 'GAWLER WEST', state: 'SA' },
  { postCode: '5118', suburb: 'HEWETT', state: 'SA' },
  { postCode: '5118', suburb: 'KALBEEBA', state: 'SA' },
  { postCode: '5118', suburb: 'KANGAROO FLAT', state: 'SA' },
  { postCode: '5118', suburb: 'KINGSFORD', state: 'SA' },
  { postCode: '5118', suburb: 'REID', state: 'SA' },
  { postCode: '5118', suburb: 'WARD BELT', state: 'SA' },
  { postCode: '5118', suburb: 'WILLASTON', state: 'SA' },
  { postCode: '5120', suburb: 'BUCKLAND PARK', state: 'SA' },
  { postCode: '5120', suburb: 'VIRGINIA', state: 'SA' },
  { postCode: '5121', suburb: 'EYRE', state: 'SA' },
  { postCode: '5121', suburb: 'MACDONALD PARK', state: 'SA' },
  { postCode: '5121', suburb: 'PENFIELD', state: 'SA' },
  { postCode: '5121', suburb: 'PENFIELD GARDENS', state: 'SA' },
  { postCode: '5125', suburb: 'GOLDEN GROVE', state: 'SA' },
  { postCode: '5125', suburb: 'GOLDEN GROVE VILLAGE', state: 'SA' },
  { postCode: '5125', suburb: 'GREENWITH', state: 'SA' },
  { postCode: '5126', suburb: 'FAIRVIEW PARK', state: 'SA' },
  { postCode: '5126', suburb: 'SURREY DOWNS', state: 'SA' },
  { postCode: '5126', suburb: 'YATALA VALE', state: 'SA' },
  { postCode: '5127', suburb: 'WYNN VALE', state: 'SA' },
  { postCode: '5131', suburb: 'HOUGHTON', state: 'SA' },
  { postCode: '5131', suburb: 'LOWER HERMITAGE', state: 'SA' },
  { postCode: '5131', suburb: 'UPPER HERMITAGE', state: 'SA' },
  { postCode: '5132', suburb: 'PARACOMBE', state: 'SA' },
  { postCode: '5133', suburb: 'INGLEWOOD', state: 'SA' },
  { postCode: '5134', suburb: 'CHERRYVILLE', state: 'SA' },
  { postCode: '5134', suburb: 'MONTACUTE', state: 'SA' },
  { postCode: '5136', suburb: 'NORTON SUMMIT', state: 'SA' },
  { postCode: '5137', suburb: 'ASHTON', state: 'SA' },
  { postCode: '5137', suburb: 'MARBLE HILL', state: 'SA' },
  { postCode: '5138', suburb: 'BASKET RANGE', state: 'SA' },
  { postCode: '5139', suburb: 'FOREST RANGE', state: 'SA' },
  { postCode: '5140', suburb: 'GREENHILL', state: 'SA' },
  { postCode: '5141', suburb: 'HORSNELL GULLY', state: 'SA' },
  { postCode: '5141', suburb: 'SUMMERTOWN', state: 'SA' },
  { postCode: '5142', suburb: 'URAIDLA', state: 'SA' },
  { postCode: '5144', suburb: 'CAREY GULLY', state: 'SA' },
  { postCode: '5150', suburb: 'LEAWOOD GARDENS', state: 'SA' },
  { postCode: '5151', suburb: 'PICCADILLY', state: 'SA' },
  { postCode: '5152', suburb: 'CLELAND', state: 'SA' },
  { postCode: '5152', suburb: 'CRAFERS', state: 'SA' },
  { postCode: '5152', suburb: 'CRAFERS WEST', state: 'SA' },
  { postCode: '5152', suburb: 'STIRLING', state: 'SA' },
  { postCode: '5153', suburb: 'BIGGS FLAT', state: 'SA' },
  { postCode: '5153', suburb: 'BRADBURY', state: 'SA' },
  { postCode: '5153', suburb: 'CHAPEL HILL', state: 'SA' },
  { postCode: '5153', suburb: 'ECHUNGA', state: 'SA' },
  { postCode: '5153', suburb: 'FLAXLEY', state: 'SA' },
  { postCode: '5153', suburb: 'GREEN HILLS RANGE', state: 'SA' },
  { postCode: '5153', suburb: 'HEATHFIELD', state: 'SA' },
  { postCode: '5153', suburb: 'IRONBANK', state: 'SA' },
  { postCode: '5153', suburb: 'JUPITER CREEK', state: 'SA' },
  { postCode: '5153', suburb: 'LONGWOOD', state: 'SA' },
  { postCode: '5153', suburb: 'MACCLESFIELD', state: 'SA' },
  { postCode: '5153', suburb: 'MYLOR', state: 'SA' },
  { postCode: '5153', suburb: 'SCOTT CREEK', state: 'SA' },
  { postCode: '5154', suburb: 'ALDGATE', state: 'SA' },
  { postCode: '5155', suburb: 'BRIDGEWATER', state: 'SA' },
  { postCode: '5155', suburb: 'MOUNT GEORGE', state: 'SA' },
  { postCode: '5156', suburb: 'UPPER STURT', state: 'SA' },
  { postCode: '5157', suburb: 'ASHBOURNE', state: 'SA' },
  { postCode: '5157', suburb: 'BULL CREEK', state: 'SA' },
  { postCode: '5157', suburb: 'CHERRY GARDENS', state: 'SA' },
  { postCode: '5157', suburb: 'CLARENDON', state: 'SA' },
  { postCode: '5157', suburb: 'COROMANDEL EAST', state: 'SA' },
  { postCode: '5157', suburb: 'DORSET VALE', state: 'SA' },
  { postCode: '5157', suburb: 'KANGARILLA', state: 'SA' },
  { postCode: '5157', suburb: 'MCHARG CREEK', state: 'SA' },
  { postCode: '5158', suburb: 'HALLETT COVE', state: 'SA' },
  { postCode: '5158', suburb: "O'HALLORAN HILL", state: 'SA' },
  { postCode: '5158', suburb: 'SHEIDOW PARK', state: 'SA' },
  { postCode: '5158', suburb: 'TROTT PARK', state: 'SA' },
  { postCode: '5159', suburb: 'ABERFOYLE PARK', state: 'SA' },
  { postCode: '5159', suburb: 'CHANDLERS HILL', state: 'SA' },
  { postCode: '5159', suburb: 'FLAGSTAFF HILL', state: 'SA' },
  { postCode: '5159', suburb: 'HAPPY VALLEY', state: 'SA' },
  { postCode: '5160', suburb: 'LONSDALE', state: 'SA' },
  { postCode: '5160', suburb: 'LONSDALE DC', state: 'SA' },
  { postCode: '5161', suburb: 'OLD REYNELLA', state: 'SA' },
  { postCode: '5161', suburb: 'REYNELLA', state: 'SA' },
  { postCode: '5161', suburb: 'REYNELLA EAST', state: 'SA' },
  { postCode: '5162', suburb: 'MORPHETT VALE', state: 'SA' },
  { postCode: '5162', suburb: 'WOODCROFT', state: 'SA' },
  { postCode: '5163', suburb: 'HACKHAM', state: 'SA' },
  { postCode: '5163', suburb: 'HACKHAM WEST', state: 'SA' },
  { postCode: '5163', suburb: 'HUNTFIELD HEIGHTS', state: 'SA' },
  { postCode: '5163', suburb: 'ONKAPARINGA HILLS', state: 'SA' },
  { postCode: '5164', suburb: 'CHRISTIE DOWNS', state: 'SA' },
  { postCode: '5165', suburb: 'CHRISTIES BEACH', state: 'SA' },
  { postCode: '5165', suburb: 'CHRISTIES BEACH NORTH', state: 'SA' },
  { postCode: '5166', suburb: "O'SULLIVAN BEACH", state: 'SA' },
  { postCode: '5167', suburb: 'PORT NOARLUNGA', state: 'SA' },
  { postCode: '5167', suburb: 'PORT NOARLUNGA SOUTH', state: 'SA' },
  { postCode: '5168', suburb: 'NOARLUNGA CENTRE', state: 'SA' },
  { postCode: '5168', suburb: 'NOARLUNGA DOWNS', state: 'SA' },
  { postCode: '5168', suburb: 'OLD NOARLUNGA', state: 'SA' },
  { postCode: '5169', suburb: 'MOANA', state: 'SA' },
  { postCode: '5169', suburb: 'SEAFORD', state: 'SA' },
  { postCode: '5169', suburb: 'SEAFORD HEIGHTS', state: 'SA' },
  { postCode: '5169', suburb: 'SEAFORD MEADOWS', state: 'SA' },
  { postCode: '5169', suburb: 'SEAFORD RISE', state: 'SA' },
  { postCode: '5170', suburb: 'MASLIN BEACH', state: 'SA' },
  { postCode: '5171', suburb: 'BLEWITT SPRINGS', state: 'SA' },
  { postCode: '5171', suburb: 'MCLAREN FLAT', state: 'SA' },
  { postCode: '5171', suburb: 'MCLAREN VALE', state: 'SA' },
  { postCode: '5171', suburb: 'TATACHILLA', state: 'SA' },
  { postCode: '5172', suburb: 'DINGABLEDINGA', state: 'SA' },
  { postCode: '5172', suburb: 'HOPE FOREST', state: 'SA' },
  { postCode: '5172', suburb: 'KUITPO COLONY', state: 'SA' },
  { postCode: '5172', suburb: 'KYEEMA', state: 'SA' },
  { postCode: '5172', suburb: 'MONTARRA', state: 'SA' },
  { postCode: '5172', suburb: 'PAGES FLAT', state: 'SA' },
  { postCode: '5172', suburb: 'THE RANGE', state: 'SA' },
  { postCode: '5172', suburb: 'WHITES VALLEY', state: 'SA' },
  { postCode: '5172', suburb: 'WILLUNGA', state: 'SA' },
  { postCode: '5172', suburb: 'WILLUNGA HILL', state: 'SA' },
  { postCode: '5172', suburb: 'WILLUNGA SOUTH', state: 'SA' },
  { postCode: '5172', suburb: 'YUNDI', state: 'SA' },
  { postCode: '5173', suburb: 'ALDINGA', state: 'SA' },
  { postCode: '5173', suburb: 'ALDINGA BEACH', state: 'SA' },
  { postCode: '5173', suburb: 'PORT WILLUNGA', state: 'SA' },
  { postCode: '5174', suburb: 'SELLICKS BEACH', state: 'SA' },
  { postCode: '5174', suburb: 'SELLICKS HILL', state: 'SA' },
  { postCode: '5201', suburb: 'BLACKFELLOWS CREEK', state: 'SA' },
  { postCode: '5201', suburb: 'KUITPO', state: 'SA' },
  { postCode: '5201', suburb: 'MEADOWS', state: 'SA' },
  { postCode: '5201', suburb: 'PARIS CREEK', state: 'SA' },
  { postCode: '5201', suburb: 'PROSPECT HILL', state: 'SA' },
  { postCode: '5202', suburb: 'HINDMARSH TIERS', state: 'SA' },
  { postCode: '5202', suburb: 'MYPONGA', state: 'SA' },
  { postCode: '5202', suburb: 'MYPONGA BEACH', state: 'SA' },
  { postCode: '5203', suburb: 'BALD HILLS', state: 'SA' },
  { postCode: '5203', suburb: 'PARAWA', state: 'SA' },
  { postCode: '5203', suburb: 'TORRENS VALE', state: 'SA' },
  { postCode: '5203', suburb: 'TUNKALILLA', state: 'SA' },
  { postCode: '5203', suburb: 'WATTLE FLAT', state: 'SA' },
  { postCode: '5203', suburb: 'YANKALILLA', state: 'SA' },
  { postCode: '5204', suburb: 'CAPE JERVIS', state: 'SA' },
  { postCode: '5204', suburb: 'CARRICKALINGA', state: 'SA' },
  { postCode: '5204', suburb: 'DEEP CREEK', state: 'SA' },
  { postCode: '5204', suburb: 'DELAMERE', state: 'SA' },
  { postCode: '5204', suburb: 'HAY FLAT', state: 'SA' },
  { postCode: '5204', suburb: 'NORMANVILLE', state: 'SA' },
  { postCode: '5204', suburb: 'RAPID BAY', state: 'SA' },
  { postCode: '5204', suburb: 'SECOND VALLEY', state: 'SA' },
  { postCode: '5204', suburb: 'SILVERTON', state: 'SA' },
  { postCode: '5204', suburb: 'WIRRINA COVE', state: 'SA' },
  { postCode: '5210', suburb: 'MOUNT COMPASS', state: 'SA' },
  { postCode: '5210', suburb: 'MOUNT MAGNIFICENT', state: 'SA' },
  { postCode: '5210', suburb: 'NANGKITA', state: 'SA' },
  { postCode: '5211', suburb: 'BACK VALLEY', state: 'SA' },
  { postCode: '5211', suburb: 'CHITON', state: 'SA' },
  { postCode: '5211', suburb: 'ENCOUNTER BAY', state: 'SA' },
  { postCode: '5211', suburb: 'HAYBOROUGH', state: 'SA' },
  { postCode: '5211', suburb: 'HINDMARSH VALLEY', state: 'SA' },
  { postCode: '5211', suburb: 'INMAN VALLEY', state: 'SA' },
  { postCode: '5211', suburb: 'LOWER INMAN VALLEY', state: 'SA' },
  { postCode: '5211', suburb: 'MCCRACKEN', state: 'SA' },
  { postCode: '5211', suburb: 'MOUNT JAGGED', state: 'SA' },
  { postCode: '5211', suburb: 'VICTOR HARBOR', state: 'SA' },
  { postCode: '5211', suburb: 'VICTOR HARBOR CENTRAL', state: 'SA' },
  { postCode: '5211', suburb: 'WAITPINGA', state: 'SA' },
  { postCode: '5211', suburb: 'WILLOW CREEK', state: 'SA' },
  { postCode: '5212', suburb: 'PORT ELLIOT', state: 'SA' },
  { postCode: '5213', suburb: 'MIDDLETON', state: 'SA' },
  { postCode: '5214', suburb: 'CURRENCY CREEK', state: 'SA' },
  { postCode: '5214', suburb: 'GOOLWA', state: 'SA' },
  { postCode: '5214', suburb: 'GOOLWA BEACH', state: 'SA' },
  { postCode: '5214', suburb: 'GOOLWA NORTH', state: 'SA' },
  { postCode: '5214', suburb: 'GOOLWA SOUTH', state: 'SA' },
  { postCode: '5214', suburb: 'HINDMARSH ISLAND', state: 'SA' },
  { postCode: '5214', suburb: 'MOSQUITO HILL', state: 'SA' },
  { postCode: '5214', suburb: 'MUNDOO ISLAND', state: 'SA' },
  { postCode: '5220', suburb: 'PARNDANA', state: 'SA' },
  { postCode: '5221', suburb: 'AMERICAN RIVER', state: 'SA' },
  { postCode: '5221', suburb: 'BALLAST HEAD', state: 'SA' },
  { postCode: '5221', suburb: 'MUSTON', state: 'SA' },
  { postCode: '5222', suburb: 'AMERICAN BEACH', state: 'SA' },
  { postCode: '5222', suburb: 'ANTECHAMBER BAY', state: 'SA' },
  { postCode: '5222', suburb: 'BAUDIN BEACH', state: 'SA' },
  { postCode: '5222', suburb: 'BROWN BEACH', state: 'SA' },
  { postCode: '5222', suburb: 'CUTTLEFISH BAY', state: 'SA' },
  { postCode: '5222', suburb: 'DUDLEY EAST', state: 'SA' },
  { postCode: '5222', suburb: 'DUDLEY WEST', state: 'SA' },
  { postCode: '5222', suburb: 'IRONSTONE', state: 'SA' },
  { postCode: '5222', suburb: 'ISLAND BEACH', state: 'SA' },
  { postCode: '5222', suburb: 'KANGAROO HEAD', state: 'SA' },
  { postCode: '5222', suburb: 'PELICAN LAGOON', state: 'SA' },
  { postCode: '5222', suburb: 'PENNESHAW', state: 'SA' },
  { postCode: '5222', suburb: 'PORKY FLAT', state: 'SA' },
  { postCode: '5222', suburb: 'SAPPHIRETOWN', state: 'SA' },
  { postCode: '5222', suburb: 'WILLOUGHBY', state: 'SA' },
  { postCode: '5222', suburb: 'WILLSON RIVER', state: 'SA' },
  { postCode: '5223', suburb: 'BAY OF SHOALS', state: 'SA' },
  { postCode: '5223', suburb: 'BIRCHMORE', state: 'SA' },
  { postCode: '5223', suburb: 'BROWNLOW KI', state: 'SA' },
  { postCode: '5223', suburb: 'CAPE BORDA', state: 'SA' },
  { postCode: '5223', suburb: 'CASSINI', state: 'SA' },
  { postCode: '5223', suburb: 'CYGNET RIVER', state: 'SA' },
  { postCode: '5223', suburb: 'DE MOLE RIVER', state: 'SA' },
  { postCode: '5223', suburb: "D'ESTREES BAY", state: 'SA' },
  { postCode: '5223', suburb: 'DUNCAN', state: 'SA' },
  { postCode: '5223', suburb: 'EMU BAY', state: 'SA' },
  { postCode: '5223', suburb: 'FLINDERS CHASE', state: 'SA' },
  { postCode: '5223', suburb: 'GOSSE', state: 'SA' },
  { postCode: '5223', suburb: 'HAINES', state: 'SA' },
  { postCode: '5223', suburb: 'KARATTA', state: 'SA' },
  { postCode: '5223', suburb: 'KINGSCOTE', state: 'SA' },
  { postCode: '5223', suburb: 'KOHINOOR', state: 'SA' },
  { postCode: '5223', suburb: 'MACGILLIVRAY', state: 'SA' },
  { postCode: '5223', suburb: 'MENZIES', state: 'SA' },
  { postCode: '5223', suburb: 'MIDDLE RIVER', state: 'SA' },
  { postCode: '5223', suburb: 'NEPEAN BAY', state: 'SA' },
  { postCode: '5223', suburb: 'NEWLAND', state: 'SA' },
  { postCode: '5223', suburb: 'NORTH CAPE', state: 'SA' },
  { postCode: '5223', suburb: 'SEAL BAY', state: 'SA' },
  { postCode: '5223', suburb: 'SEDDON', state: 'SA' },
  { postCode: '5223', suburb: 'STOKES BAY', state: 'SA' },
  { postCode: '5223', suburb: "STUN'SAIL BOOM", state: 'SA' },
  { postCode: '5223', suburb: 'VIVONNE BAY', state: 'SA' },
  { postCode: '5223', suburb: 'WESTERN RIVER', state: 'SA' },
  { postCode: '5223', suburb: 'WISANGER', state: 'SA' },
  { postCode: '5231', suburb: 'CHAIN OF PONDS', state: 'SA' },
  { postCode: '5231', suburb: 'KERSBROOK', state: 'SA' },
  { postCode: '5231', suburb: 'MILLBROOK', state: 'SA' },
  { postCode: '5232', suburb: 'CUDLEE CREEK', state: 'SA' },
  { postCode: '5233', suburb: 'FORRESTON', state: 'SA' },
  { postCode: '5233', suburb: 'GUMERACHA', state: 'SA' },
  { postCode: '5233', suburb: 'KENTON VALLEY', state: 'SA' },
  { postCode: '5234', suburb: 'BIRDWOOD', state: 'SA' },
  { postCode: '5235', suburb: 'CROMER', state: 'SA' },
  { postCode: '5235', suburb: 'EDEN VALLEY', state: 'SA' },
  { postCode: '5235', suburb: 'FLAXMAN VALLEY', state: 'SA' },
  { postCode: '5235', suburb: 'MOUNT PLEASANT', state: 'SA' },
  { postCode: '5235', suburb: 'SPRINGTON', state: 'SA' },
  { postCode: '5235', suburb: 'TAUNTON', state: 'SA' },
  { postCode: '5236', suburb: 'TUNGKILLO', state: 'SA' },
  { postCode: '5237', suburb: 'APAMURRA', state: 'SA' },
  { postCode: '5237', suburb: 'MILENDELLA', state: 'SA' },
  { postCode: '5237', suburb: 'PALMER', state: 'SA' },
  { postCode: '5237', suburb: 'SANDERSTON', state: 'SA' },
  { postCode: '5238', suburb: 'ANGAS VALLEY', state: 'SA' },
  { postCode: '5238', suburb: 'BIG BEND', state: 'SA' },
  { postCode: '5238', suburb: 'BOLTO', state: 'SA' },
  { postCode: '5238', suburb: 'BOWHILL', state: 'SA' },
  { postCode: '5238', suburb: 'CAURNAMONT', state: 'SA' },
  { postCode: '5238', suburb: 'CLAYPANS', state: 'SA' },
  { postCode: '5238', suburb: 'COWIRRA', state: 'SA' },
  { postCode: '5238', suburb: 'FIVE MILES', state: 'SA' },
  { postCode: '5238', suburb: 'FORSTER', state: 'SA' },
  { postCode: '5238', suburb: 'FRAHNS', state: 'SA' },
  { postCode: '5238', suburb: 'FRAYVILLE', state: 'SA' },
  { postCode: '5238', suburb: 'JULANKA HOLDINGS', state: 'SA' },
  { postCode: '5238', suburb: 'LAKE CARLET', state: 'SA' },
  { postCode: '5238', suburb: 'MANNUM', state: 'SA' },
  { postCode: '5238', suburb: 'NILDOTTIE', state: 'SA' },
  { postCode: '5238', suburb: 'OLD TEAL FLAT', state: 'SA' },
  { postCode: '5238', suburb: 'PELLARING FLAT', state: 'SA' },
  { postCode: '5238', suburb: 'POMPOOTA', state: 'SA' },
  { postCode: '5238', suburb: 'PONDE', state: 'SA' },
  { postCode: '5238', suburb: 'PORT MANNUM', state: 'SA' },
  { postCode: '5238', suburb: 'PUNTHARI', state: 'SA' },
  { postCode: '5238', suburb: 'PURNONG', state: 'SA' },
  { postCode: '5238', suburb: 'ROCKY POINT', state: 'SA' },
  { postCode: '5238', suburb: 'TEAL FLAT', state: 'SA' },
  { postCode: '5238', suburb: 'WALKER FLAT', state: 'SA' },
  { postCode: '5238', suburb: 'WONGULLA', state: 'SA' },
  { postCode: '5238', suburb: 'YOUNGHUSBAND', state: 'SA' },
  { postCode: '5238', suburb: 'YOUNGHUSBAND HOLDINGS', state: 'SA' },
  { postCode: '5240', suburb: 'LENSWOOD', state: 'SA' },
  { postCode: '5241', suburb: 'LOBETHAL', state: 'SA' },
  { postCode: '5242', suburb: 'BALHANNAH', state: 'SA' },
  { postCode: '5243', suburb: 'OAKBANK', state: 'SA' },
  { postCode: '5244', suburb: 'CHARLESTON', state: 'SA' },
  { postCode: '5244', suburb: 'HARROGATE', state: 'SA' },
  { postCode: '5244', suburb: 'INVERBRACKIE', state: 'SA' },
  { postCode: '5244', suburb: 'MOUNT TORRENS', state: 'SA' },
  { postCode: '5244', suburb: 'WOODSIDE', state: 'SA' },
  { postCode: '5245', suburb: 'HAHNDORF', state: 'SA' },
  { postCode: '5245', suburb: 'PAECHTOWN', state: 'SA' },
  { postCode: '5245', suburb: 'VERDUN', state: 'SA' },
  { postCode: '5250', suburb: 'BLAKISTON', state: 'SA' },
  { postCode: '5250', suburb: 'LITTLEHAMPTON', state: 'SA' },
  { postCode: '5250', suburb: 'TOTNESS', state: 'SA' },
  { postCode: '5251', suburb: 'BUGLE RANGES', state: 'SA' },
  { postCode: '5251', suburb: 'MOUNT BARKER', state: 'SA' },
  { postCode: '5251', suburb: 'MOUNT BARKER JUNCTION', state: 'SA' },
  { postCode: '5251', suburb: 'MOUNT BARKER SPRINGS', state: 'SA' },
  { postCode: '5251', suburb: 'MOUNT BARKER SUMMIT', state: 'SA' },
  { postCode: '5251', suburb: 'WISTOW', state: 'SA' },
  { postCode: '5252', suburb: 'BRUKUNGA', state: 'SA' },
  { postCode: '5252', suburb: 'DAWESLEY', state: 'SA' },
  { postCode: '5252', suburb: 'HAY VALLEY', state: 'SA' },
  { postCode: '5252', suburb: 'KANMANTOO', state: 'SA' },
  { postCode: '5252', suburb: 'NAIRNE', state: 'SA' },
  { postCode: '5252', suburb: 'ST IVES', state: 'SA' },
  { postCode: '5253', suburb: 'AVOCA DELL', state: 'SA' },
  { postCode: '5253', suburb: 'BRINKLEY', state: 'SA' },
  { postCode: '5253', suburb: 'BURDETT', state: 'SA' },
  { postCode: '5253', suburb: 'CHAPMAN BORE', state: 'SA' },
  { postCode: '5253', suburb: 'ETTRICK', state: 'SA' },
  { postCode: '5253', suburb: 'GIFFORD HILL', state: 'SA' },
  { postCode: '5253', suburb: 'GREENBANKS', state: 'SA' },
  { postCode: '5253', suburb: 'LONG FLAT', state: 'SA' },
  { postCode: '5253', suburb: 'MOBILONG', state: 'SA' },
  { postCode: '5253', suburb: 'MONTEITH', state: 'SA' },
  { postCode: '5253', suburb: 'MURRAWONG', state: 'SA' },
  { postCode: '5253', suburb: 'MURRAY BRIDGE', state: 'SA' },
  { postCode: '5253', suburb: 'MURRAY BRIDGE EAST', state: 'SA' },
  { postCode: '5253', suburb: 'MURRAY BRIDGE NORTH', state: 'SA' },
  { postCode: '5253', suburb: 'MURRAY BRIDGE SOUTH', state: 'SA' },
  { postCode: '5253', suburb: 'NORTHERN HEIGHTS', state: 'SA' },
  { postCode: '5253', suburb: 'RIVERGLADES', state: 'SA' },
  { postCode: '5253', suburb: 'RIVERGLEN', state: 'SA' },
  { postCode: '5253', suburb: 'SUNNYSIDE', state: 'SA' },
  { postCode: '5253', suburb: 'SWANPORT', state: 'SA' },
  { postCode: '5253', suburb: 'TOORA', state: 'SA' },
  { postCode: '5253', suburb: 'WHITE SANDS', state: 'SA' },
  { postCode: '5253', suburb: 'WILLOW BANKS', state: 'SA' },
  { postCode: '5253', suburb: 'WOODS POINT', state: 'SA' },
  { postCode: '5254', suburb: 'CALLINGTON', state: 'SA' },
  { postCode: '5254', suburb: 'CALOOTE', state: 'SA' },
  { postCode: '5254', suburb: 'MONARTO', state: 'SA' },
  { postCode: '5254', suburb: 'MONARTO SOUTH', state: 'SA' },
  { postCode: '5254', suburb: 'MURRAY BRIDGE', state: 'SA' },
  { postCode: '5254', suburb: 'MYPOLONGA', state: 'SA' },
  { postCode: '5254', suburb: 'PALLAMANA', state: 'SA' },
  { postCode: '5254', suburb: 'PETWOOD', state: 'SA' },
  { postCode: '5254', suburb: 'ROCKLEIGH', state: 'SA' },
  { postCode: '5254', suburb: 'ROCKY GULLY', state: 'SA' },
  { postCode: '5254', suburb: 'TEPKO', state: 'SA' },
  { postCode: '5254', suburb: 'WALL FLAT', state: 'SA' },
  { postCode: '5254', suburb: 'WHITE HILL', state: 'SA' },
  { postCode: '5254', suburb: 'WOODLANE', state: 'SA' },
  { postCode: '5254', suburb: 'ZADOWS LANDING', state: 'SA' },
  { postCode: '5255', suburb: 'ANGAS PLAINS', state: 'SA' },
  { postCode: '5255', suburb: 'BELVIDERE', state: 'SA' },
  { postCode: '5255', suburb: 'BLETCHLEY', state: 'SA' },
  { postCode: '5255', suburb: 'FINNISS', state: 'SA' },
  { postCode: '5255', suburb: 'GEMMELLS', state: 'SA' },
  { postCode: '5255', suburb: 'HARTLEY', state: 'SA' },
  { postCode: '5255', suburb: 'HIGHLAND VALLEY', state: 'SA' },
  { postCode: '5255', suburb: 'LAKE PLAINS', state: 'SA' },
  { postCode: '5255', suburb: 'LANGHORNE CREEK', state: 'SA' },
  { postCode: '5255', suburb: 'MOUNT OBSERVATION', state: 'SA' },
  { postCode: '5255', suburb: 'MULGUNDAWA', state: 'SA' },
  { postCode: '5255', suburb: 'NALPA', state: 'SA' },
  { postCode: '5255', suburb: 'RED CREEK', state: 'SA' },
  { postCode: '5255', suburb: 'SALEM', state: 'SA' },
  { postCode: '5255', suburb: 'SANDERGROVE', state: 'SA' },
  { postCode: '5255', suburb: 'STRATHALBYN', state: 'SA' },
  { postCode: '5255', suburb: 'TOOPERANG', state: 'SA' },
  { postCode: '5255', suburb: 'WILLYAROO', state: 'SA' },
  { postCode: '5255', suburb: 'WOODCHESTER', state: 'SA' },
  { postCode: '5256', suburb: 'CLAYTON BAY', state: 'SA' },
  { postCode: '5256', suburb: 'MILANG', state: 'SA' },
  { postCode: '5256', suburb: 'NURRAGI', state: 'SA' },
  { postCode: '5256', suburb: 'POINT STURT', state: 'SA' },
  { postCode: '5256', suburb: 'TOLDEROL', state: 'SA' },
  { postCode: '5259', suburb: 'ASHVILLE', state: 'SA' },
  { postCode: '5259', suburb: 'JERVOIS', state: 'SA' },
  { postCode: '5259', suburb: 'KEPA', state: 'SA' },
  { postCode: '5259', suburb: 'LAKE ALBERT', state: 'SA' },
  { postCode: '5259', suburb: 'LAKE ALEXANDRINA', state: 'SA' },
  { postCode: '5259', suburb: 'MALINONG', state: 'SA' },
  { postCode: '5259', suburb: 'NARRUNG', state: 'SA' },
  { postCode: '5259', suburb: 'NATURI', state: 'SA' },
  { postCode: '5259', suburb: 'POINT MCLEAY', state: 'SA' },
  { postCode: '5259', suburb: 'POLTALLOCH', state: 'SA' },
  { postCode: '5259', suburb: 'TAILEM BEND', state: 'SA' },
  { postCode: '5259', suburb: 'WELLINGTON', state: 'SA' },
  { postCode: '5259', suburb: 'WELLINGTON EAST', state: 'SA' },
  { postCode: '5260', suburb: 'ELWOMPLE', state: 'SA' },
  { postCode: '5260', suburb: 'TAILEM BEND', state: 'SA' },
  { postCode: '5261', suburb: 'COOKE PLAINS', state: 'SA' },
  { postCode: '5261', suburb: 'COOMANDOOK', state: 'SA' },
  { postCode: '5261', suburb: 'CULBURRA', state: 'SA' },
  { postCode: '5261', suburb: 'KI KI', state: 'SA' },
  { postCode: '5261', suburb: 'YUMALI', state: 'SA' },
  { postCode: '5262', suburb: 'BINNUM', state: 'SA' },
  { postCode: '5262', suburb: 'FRANCES', state: 'SA' },
  { postCode: '5262', suburb: 'HYNAM', state: 'SA' },
  { postCode: '5262', suburb: 'KYBYBOLITE', state: 'SA' },
  { postCode: '5263', suburb: 'COONAWARRA', state: 'SA' },
  { postCode: '5264', suburb: 'COORONG', state: 'SA' },
  { postCode: '5264', suburb: 'MENINGIE', state: 'SA' },
  { postCode: '5264', suburb: 'MENINGIE EAST', state: 'SA' },
  { postCode: '5264', suburb: 'MENINGIE WEST', state: 'SA' },
  { postCode: '5264', suburb: 'SALT CREEK', state: 'SA' },
  { postCode: '5264', suburb: 'WALTOWA', state: 'SA' },
  { postCode: '5265', suburb: 'COONALPYN', state: 'SA' },
  { postCode: '5265', suburb: 'FIELD', state: 'SA' },
  { postCode: '5266', suburb: 'BUNBURY', state: 'SA' },
  { postCode: '5266', suburb: 'COLEBATCH', state: 'SA' },
  { postCode: '5266', suburb: 'DEEPWATER', state: 'SA' },
  { postCode: '5266', suburb: 'TINTINARA', state: 'SA' },
  { postCode: '5267', suburb: 'BRIMBAGO', state: 'SA' },
  { postCode: '5267', suburb: 'COOMBE', state: 'SA' },
  { postCode: '5267', suburb: 'KEITH', state: 'SA' },
  { postCode: '5267', suburb: 'LAFFER', state: 'SA' },
  { postCode: '5267', suburb: 'MAKIN', state: 'SA' },
  { postCode: '5267', suburb: 'MCCALLUM', state: 'SA' },
  { postCode: '5267', suburb: 'MOUNT CHARLES', state: 'SA' },
  { postCode: '5267', suburb: 'PETHERICK', state: 'SA' },
  { postCode: '5267', suburb: 'SHAUGH', state: 'SA' },
  { postCode: '5267', suburb: 'SHERWOOD', state: 'SA' },
  { postCode: '5267', suburb: 'WILLALOOKA', state: 'SA' },
  { postCode: '5267', suburb: 'WIRREGA', state: 'SA' },
  { postCode: '5268', suburb: 'BANGHAM', state: 'SA' },
  { postCode: '5268', suburb: 'BORDERTOWN', state: 'SA' },
  { postCode: '5268', suburb: 'BORDERTOWN SOUTH', state: 'SA' },
  { postCode: '5268', suburb: 'CANNAWIGARA', state: 'SA' },
  { postCode: '5268', suburb: 'LOWAN VALE', state: 'SA' },
  { postCode: '5268', suburb: 'POOGINAGORIC', state: 'SA' },
  { postCode: '5268', suburb: 'SENIOR', state: 'SA' },
  { postCode: '5268', suburb: 'WESTERN FLAT', state: 'SA' },
  { postCode: '5269', suburb: 'CUSTON', state: 'SA' },
  { postCode: '5269', suburb: 'PINE HILL', state: 'SA' },
  { postCode: '5269', suburb: 'WOLSELEY', state: 'SA' },
  { postCode: '5270', suburb: 'BUCKINGHAM', state: 'SA' },
  { postCode: '5270', suburb: 'CAREW', state: 'SA' },
  { postCode: '5270', suburb: 'KONGAL', state: 'SA' },
  { postCode: '5270', suburb: 'MUNDULLA', state: 'SA' },
  { postCode: '5270', suburb: 'MUNDULLA WEST', state: 'SA' },
  { postCode: '5270', suburb: 'SWEDE FLAT', state: 'SA' },
  { postCode: '5271', suburb: 'BOOL LAGOON', state: 'SA' },
  { postCode: '5271', suburb: 'CADGEE', state: 'SA' },
  { postCode: '5271', suburb: 'JOANNA', state: 'SA' },
  { postCode: '5271', suburb: 'KEPPOCH', state: 'SA' },
  { postCode: '5271', suburb: 'KOPPAMURRA', state: 'SA' },
  { postCode: '5271', suburb: 'LAURIE PARK', state: 'SA' },
  { postCode: '5271', suburb: 'LOCHABER', state: 'SA' },
  { postCode: '5271', suburb: 'MARCOLLAT', state: 'SA' },
  { postCode: '5271', suburb: 'MOUNT LIGHT', state: 'SA' },
  { postCode: '5271', suburb: 'MOYHALL', state: 'SA' },
  { postCode: '5271', suburb: 'NARACOORTE', state: 'SA' },
  { postCode: '5271', suburb: 'PADTHAWAY', state: 'SA' },
  { postCode: '5271', suburb: 'SPENCE', state: 'SA' },
  { postCode: '5271', suburb: 'STEWART RANGE', state: 'SA' },
  { postCode: '5271', suburb: 'STRUAN', state: 'SA' },
  { postCode: '5271', suburb: 'THE GAP', state: 'SA' },
  { postCode: '5271', suburb: 'WILD DOG VALLEY', state: 'SA' },
  { postCode: '5271', suburb: 'WRATTONBULLY', state: 'SA' },
  { postCode: '5272', suburb: 'COLES', state: 'SA' },
  { postCode: '5272', suburb: 'CONMURRA', state: 'SA' },
  { postCode: '5272', suburb: 'FOX', state: 'SA' },
  { postCode: '5272', suburb: 'GREENWAYS', state: 'SA' },
  { postCode: '5272', suburb: 'LUCINDALE', state: 'SA' },
  { postCode: '5272', suburb: 'WOOLUMBOOL', state: 'SA' },
  { postCode: '5273', suburb: 'AVENUE RANGE', state: 'SA' },
  { postCode: '5275', suburb: 'BLACKFORD', state: 'SA' },
  { postCode: '5275', suburb: 'BOATSWAIN POINT', state: 'SA' },
  { postCode: '5275', suburb: 'CAPE JAFFA', state: 'SA' },
  { postCode: '5275', suburb: 'KEILIRA', state: 'SA' },
  { postCode: '5275', suburb: 'KINGSTON SE', state: 'SA' },
  { postCode: '5275', suburb: 'MOUNT BENSON', state: 'SA' },
  { postCode: '5275', suburb: 'PINKS BEACH', state: 'SA' },
  { postCode: '5275', suburb: 'REEDY CREEK', state: 'SA' },
  { postCode: '5275', suburb: 'ROSETOWN', state: 'SA' },
  { postCode: '5275', suburb: 'SANDY GROVE', state: 'SA' },
  { postCode: '5275', suburb: 'TARATAP', state: 'SA' },
  { postCode: '5275', suburb: 'TILLEY SWAMP', state: 'SA' },
  { postCode: '5275', suburb: 'WANGOLINA', state: 'SA' },
  { postCode: '5275', suburb: 'WEST RANGE', state: 'SA' },
  { postCode: '5275', suburb: 'WYOMI', state: 'SA' },
  { postCode: '5276', suburb: 'BRAY', state: 'SA' },
  { postCode: '5276', suburb: 'NORA CREINA', state: 'SA' },
  { postCode: '5276', suburb: 'ROBE', state: 'SA' },
  { postCode: '5277', suburb: 'COMAUM', state: 'SA' },
  { postCode: '5277', suburb: 'GLENROY', state: 'SA' },
  { postCode: '5277', suburb: 'MAAOUPE', state: 'SA' },
  { postCode: '5277', suburb: 'MONBULLA', state: 'SA' },
  { postCode: '5277', suburb: 'NANGWARRY', state: 'SA' },
  { postCode: '5277', suburb: 'PENOLA', state: 'SA' },
  { postCode: '5277', suburb: 'PLEASANT PARK', state: 'SA' },
  { postCode: '5277', suburb: 'TARPEENA', state: 'SA' },
  { postCode: '5278', suburb: 'KALANGADOO', state: 'SA' },
  { postCode: '5278', suburb: 'KRONGART', state: 'SA' },
  { postCode: '5278', suburb: 'MOERLONG', state: 'SA' },
  { postCode: '5278', suburb: 'WEPAR', state: 'SA' },
  { postCode: '5279', suburb: 'KOORINE', state: 'SA' },
  { postCode: '5279', suburb: 'MOUNT BURR', state: 'SA' },
  { postCode: '5279', suburb: 'MOUNT MCINTYRE', state: 'SA' },
  { postCode: '5279', suburb: 'SHORT', state: 'SA' },
  { postCode: '5279', suburb: 'WATTLE RANGE EAST', state: 'SA' },
  { postCode: '5280', suburb: 'BEACHPORT', state: 'SA' },
  { postCode: '5280', suburb: 'CANUNDA', state: 'SA' },
  { postCode: '5280', suburb: 'CLAY WELLS', state: 'SA' },
  { postCode: '5280', suburb: 'FURNER', state: 'SA' },
  { postCode: '5280', suburb: 'GERMAN FLAT', state: 'SA' },
  { postCode: '5280', suburb: 'HATHERLEIGH', state: 'SA' },
  { postCode: '5280', suburb: 'KANGAROO INN', state: 'SA' },
  { postCode: '5280', suburb: 'MAGAREY', state: 'SA' },
  { postCode: '5280', suburb: 'MILLICENT', state: 'SA' },
  { postCode: '5280', suburb: 'RENDELSHAM', state: 'SA' },
  { postCode: '5280', suburb: 'ROCKY CAMP', state: 'SA' },
  { postCode: '5280', suburb: 'SEBASTOPOL', state: 'SA' },
  { postCode: '5280', suburb: 'SOUTHEND', state: 'SA' },
  { postCode: '5280', suburb: 'TANTANOOLA', state: 'SA' },
  { postCode: '5280', suburb: 'THORNLEA', state: 'SA' },
  { postCode: '5280', suburb: 'WATTLE RANGE', state: 'SA' },
  { postCode: '5290', suburb: 'MOUNT GAMBIER', state: 'SA' },
  { postCode: '5291', suburb: 'ALLENDALE EAST', state: 'SA' },
  { postCode: '5291', suburb: 'BLACKFELLOWS CAVES', state: 'SA' },
  { postCode: '5291', suburb: 'BURRUNGULE', state: 'SA' },
  { postCode: '5291', suburb: 'CAPE DOUGLAS', state: 'SA' },
  { postCode: '5291', suburb: 'CAROLINE', state: 'SA' },
  { postCode: '5291', suburb: 'CARPENTER ROCKS', state: 'SA' },
  { postCode: '5291', suburb: 'CAVETON', state: 'SA' },
  { postCode: '5291', suburb: 'COMPTON', state: 'SA' },
  { postCode: '5291', suburb: 'DISMAL SWAMP', state: 'SA' },
  { postCode: '5291', suburb: 'DONOVANS', state: 'SA' },
  { postCode: '5291', suburb: 'EIGHT MILE CREEK', state: 'SA' },
  { postCode: '5291', suburb: 'GERMAN CREEK', state: 'SA' },
  { postCode: '5291', suburb: 'GLENBURNIE', state: 'SA' },
  { postCode: '5291', suburb: 'GLENCOE', state: 'SA' },
  { postCode: '5291', suburb: 'KONGORONG', state: 'SA' },
  { postCode: '5291', suburb: 'MIL-LEL', state: 'SA' },
  { postCode: '5291', suburb: 'MINGBOOL', state: 'SA' },
  { postCode: '5291', suburb: 'MOORAK', state: 'SA' },
  { postCode: '5291', suburb: 'MOUNT GAMBIER', state: 'SA' },
  { postCode: '5291', suburb: 'MOUNT GAMBIER EAST', state: 'SA' },
  { postCode: '5291', suburb: 'MOUNT GAMBIER WEST', state: 'SA' },
  { postCode: '5291', suburb: 'MOUNT SCHANK', state: 'SA' },
  { postCode: '5291', suburb: 'NENE VALLEY', state: 'SA' },
  { postCode: '5291', suburb: 'OB FLAT', state: 'SA' },
  { postCode: '5291', suburb: 'PELICAN POINT', state: 'SA' },
  { postCode: '5291', suburb: 'PORT MACDONNELL', state: 'SA' },
  { postCode: '5291', suburb: 'RACECOURSE BAY', state: 'SA' },
  { postCode: '5291', suburb: 'SQUARE MILE', state: 'SA' },
  { postCode: '5291', suburb: 'SUTTONTOWN', state: 'SA' },
  { postCode: '5291', suburb: 'WANDILO', state: 'SA' },
  { postCode: '5291', suburb: 'WORROLONG', state: 'SA' },
  { postCode: '5291', suburb: 'WYE', state: 'SA' },
  { postCode: '5291', suburb: 'YAHL', state: 'SA' },
  { postCode: '5301', suburb: 'CARCUMA', state: 'SA' },
  { postCode: '5301', suburb: 'GERANIUM', state: 'SA' },
  { postCode: '5301', suburb: 'JABUK', state: 'SA' },
  { postCode: '5301', suburb: 'MOORLANDS', state: 'SA' },
  { postCode: '5301', suburb: 'NETHERTON', state: 'SA' },
  { postCode: '5301', suburb: 'PARRAKIE', state: 'SA' },
  { postCode: '5301', suburb: 'PEAKE', state: 'SA' },
  { postCode: '5301', suburb: 'SHERLOCK', state: 'SA' },
  { postCode: '5301', suburb: 'WILKAWATT', state: 'SA' },
  { postCode: '5302', suburb: 'LAMEROO', state: 'SA' },
  { postCode: '5302', suburb: 'NGARKAT', state: 'SA' },
  { postCode: '5303', suburb: 'PARILLA', state: 'SA' },
  { postCode: '5304', suburb: 'KARTE', state: 'SA' },
  { postCode: '5304', suburb: 'KRINGIN', state: 'SA' },
  { postCode: '5304', suburb: 'PEEBINGA', state: 'SA' },
  { postCode: '5304', suburb: 'PINNAROO', state: 'SA' },
  { postCode: '5306', suburb: 'WYNARKA', state: 'SA' },
  { postCode: '5307', suburb: 'KAROONDA', state: 'SA' },
  { postCode: '5307', suburb: 'MARAMA', state: 'SA' },
  { postCode: '5308', suburb: 'COPEVILLE', state: 'SA' },
  { postCode: '5308', suburb: 'GALGA', state: 'SA' },
  { postCode: '5308', suburb: 'MANTUNG', state: 'SA' },
  { postCode: '5308', suburb: 'MERCUNDA', state: 'SA' },
  { postCode: '5308', suburb: 'PERPONDA', state: 'SA' },
  { postCode: '5309', suburb: 'BORRIKA', state: 'SA' },
  { postCode: '5309', suburb: 'HALIDON', state: 'SA' },
  { postCode: '5309', suburb: 'MINDARIE', state: 'SA' },
  { postCode: '5309', suburb: 'SANDALWOOD', state: 'SA' },
  { postCode: '5310', suburb: 'CALIPH', state: 'SA' },
  { postCode: '5310', suburb: 'WANBI', state: 'SA' },
  { postCode: '5311', suburb: 'ALAWOONA', state: 'SA' },
  { postCode: '5311', suburb: 'BILLIATT', state: 'SA' },
  { postCode: '5311', suburb: 'BUGLE HUT', state: 'SA' },
  { postCode: '5311', suburb: 'MAGGEA', state: 'SA' },
  { postCode: '5311', suburb: 'MALPAS', state: 'SA' },
  { postCode: '5311', suburb: 'MERIBAH', state: 'SA' },
  { postCode: '5311', suburb: 'PARUNA', state: 'SA' },
  { postCode: '5311', suburb: 'SCHELL WELL', state: 'SA' },
  { postCode: '5311', suburb: 'TALDRA', state: 'SA' },
  { postCode: '5311', suburb: 'TAPLAN', state: 'SA' },
  { postCode: '5311', suburb: 'VEITCH', state: 'SA' },
  { postCode: '5311', suburb: 'WOODLEIGH', state: 'SA' },
  { postCode: '5311', suburb: 'WUNKAR', state: 'SA' },
  { postCode: '5320', suburb: 'BEATTY', state: 'SA' },
  { postCode: '5320', suburb: 'BEAUMONTS', state: 'SA' },
  { postCode: '5320', suburb: 'BRENDA PARK', state: 'SA' },
  { postCode: '5320', suburb: 'BUNDEY', state: 'SA' },
  { postCode: '5320', suburb: 'EBA', state: 'SA' },
  { postCode: '5320', suburb: 'LINDLEY', state: 'SA' },
  { postCode: '5320', suburb: 'MAUDE', state: 'SA' },
  { postCode: '5320', suburb: 'MORGAN', state: 'SA' },
  { postCode: '5320', suburb: 'MORPHETTS FLAT', state: 'SA' },
  { postCode: '5320', suburb: 'MURBKO', state: 'SA' },
  { postCode: '5320', suburb: 'NORTH WEST BEND', state: 'SA' },
  { postCode: '5320', suburb: 'STUART', state: 'SA' },
  { postCode: '5320', suburb: 'WESTONS FLAT', state: 'SA' },
  { postCode: '5320', suburb: 'WOMBATS REST', state: 'SA' },
  { postCode: '5321', suburb: 'CADELL', state: 'SA' },
  { postCode: '5321', suburb: 'CADELL LAGOON', state: 'SA' },
  { postCode: '5322', suburb: 'GOLDEN HEIGHTS', state: 'SA' },
  { postCode: '5322', suburb: 'QUALCO', state: 'SA' },
  { postCode: '5322', suburb: 'RAMCO', state: 'SA' },
  { postCode: '5322', suburb: 'RAMCO HEIGHTS', state: 'SA' },
  { postCode: '5322', suburb: 'SUNLANDS', state: 'SA' },
  { postCode: '5330', suburb: 'BOOLGUN', state: 'SA' },
  { postCode: '5330', suburb: 'DEVLINS POUND', state: 'SA' },
  { postCode: '5330', suburb: 'GOOD HOPE LANDING', state: 'SA' },
  { postCode: '5330', suburb: 'HAWKS NEST STATION', state: 'SA' },
  { postCode: '5330', suburb: 'HOLDER', state: 'SA' },
  { postCode: '5330', suburb: 'HOLDER SIDING', state: 'SA' },
  { postCode: '5330', suburb: 'KANNI', state: 'SA' },
  { postCode: '5330', suburb: 'LOWBANK', state: 'SA' },
  { postCode: '5330', suburb: 'MARKARANKA', state: 'SA' },
  { postCode: '5330', suburb: 'OVERLAND CORNER', state: 'SA' },
  { postCode: '5330', suburb: 'POOGINOOK', state: 'SA' },
  { postCode: '5330', suburb: 'STOCKYARD PLAIN', state: 'SA' },
  { postCode: '5330', suburb: 'TAYLORVILLE', state: 'SA' },
  { postCode: '5330', suburb: 'TAYLORVILLE STATION', state: 'SA' },
  { postCode: '5330', suburb: 'WAIKERIE', state: 'SA' },
  { postCode: '5330', suburb: 'WIGLEY FLAT', state: 'SA' },
  { postCode: '5330', suburb: 'WOOLPUNDA', state: 'SA' },
  { postCode: '5331', suburb: 'KINGSTON ON MURRAY', state: 'SA' },
  { postCode: '5332', suburb: 'MOOROOK', state: 'SA' },
  { postCode: '5332', suburb: 'MOOROOK SOUTH', state: 'SA' },
  { postCode: '5332', suburb: 'WAPPILKA', state: 'SA' },
  { postCode: '5332', suburb: 'YINKANIE', state: 'SA' },
  { postCode: '5333', suburb: 'BOOKPURNONG', state: 'SA' },
  { postCode: '5333', suburb: 'LOXTON', state: 'SA' },
  { postCode: '5333', suburb: 'LOXTON NORTH', state: 'SA' },
  { postCode: '5333', suburb: 'NEW RESIDENCE', state: 'SA' },
  { postCode: '5333', suburb: 'PATA', state: 'SA' },
  { postCode: '5333', suburb: 'PYAP', state: 'SA' },
  { postCode: '5333', suburb: 'PYAP WEST', state: 'SA' },
  { postCode: '5340', suburb: 'MUNDIC CREEK', state: 'SA' },
  { postCode: '5340', suburb: 'MURTHO', state: 'SA' },
  { postCode: '5340', suburb: 'PARINGA', state: 'SA' },
  { postCode: '5340', suburb: 'PIKE RIVER', state: 'SA' },
  { postCode: '5340', suburb: 'WONUARRA', state: 'SA' },
  { postCode: '5340', suburb: 'YAMBA', state: 'SA' },
  { postCode: '5341', suburb: 'CALPERUM STATION', state: 'SA' },
  { postCode: '5341', suburb: 'CHAFFEY', state: 'SA' },
  { postCode: '5341', suburb: 'CHOWILLA', state: 'SA' },
  { postCode: '5341', suburb: 'COOLTONG', state: 'SA' },
  { postCode: '5341', suburb: 'CRESCENT', state: 'SA' },
  { postCode: '5341', suburb: 'OLD CALPERUM', state: 'SA' },
  { postCode: '5341', suburb: 'RENMARK', state: 'SA' },
  { postCode: '5341', suburb: 'RENMARK NORTH', state: 'SA' },
  { postCode: '5341', suburb: 'RENMARK SOUTH', state: 'SA' },
  { postCode: '5341', suburb: 'RENMARK WEST', state: 'SA' },
  { postCode: '5342', suburb: 'MONASH', state: 'SA' },
  { postCode: '5343', suburb: 'BERRI', state: 'SA' },
  { postCode: '5343', suburb: 'GERARD', state: 'SA' },
  { postCode: '5343', suburb: 'GURRA GURRA', state: 'SA' },
  { postCode: '5343', suburb: 'KATARAPKO', state: 'SA' },
  { postCode: '5343', suburb: 'LYRUP', state: 'SA' },
  { postCode: '5343', suburb: 'WINKIE', state: 'SA' },
  { postCode: '5344', suburb: 'GLOSSOP', state: 'SA' },
  { postCode: '5345', suburb: 'BARMERA', state: 'SA' },
  { postCode: '5345', suburb: 'LOVEDAY', state: 'SA' },
  { postCode: '5345', suburb: 'SPECTACLE LAKE', state: 'SA' },
  { postCode: '5346', suburb: 'COBDOGLA', state: 'SA' },
  { postCode: '5350', suburb: 'ROSEDALE', state: 'SA' },
  { postCode: '5350', suburb: 'SANDY CREEK', state: 'SA' },
  { postCode: '5351', suburb: 'ALTONA', state: 'SA' },
  { postCode: '5351', suburb: 'BAROSSA GOLDFIELDS', state: 'SA' },
  { postCode: '5351', suburb: 'COCKATOO VALLEY', state: 'SA' },
  { postCode: '5351', suburb: 'LYNDOCH', state: 'SA' },
  { postCode: '5351', suburb: 'MOUNT CRAWFORD', state: 'SA' },
  { postCode: '5351', suburb: 'PEWSEY VALE', state: 'SA' },
  { postCode: '5351', suburb: 'WILLIAMSTOWN', state: 'SA' },
  { postCode: '5352', suburb: 'BETHANY', state: 'SA' },
  { postCode: '5352', suburb: 'GOMERSAL', state: 'SA' },
  { postCode: '5352', suburb: 'KRONDORF', state: 'SA' },
  { postCode: '5352', suburb: 'ROWLAND FLAT', state: 'SA' },
  { postCode: '5352', suburb: 'STONE WELL', state: 'SA' },
  { postCode: '5352', suburb: 'TANUNDA', state: 'SA' },
  { postCode: '5352', suburb: 'VINE VALE', state: 'SA' },
  { postCode: '5353', suburb: 'ANGASTON', state: 'SA' },
  { postCode: '5353', suburb: 'BLACK HILL', state: 'SA' },
  { postCode: '5353', suburb: 'CAMBRAI', state: 'SA' },
  { postCode: '5353', suburb: 'KEYNETON', state: 'SA' },
  { postCode: '5353', suburb: 'KONGOLIA', state: 'SA' },
  { postCode: '5353', suburb: 'LANGS LANDING', state: 'SA' },
  { postCode: '5353', suburb: 'MOCULTA', state: 'SA' },
  { postCode: '5353', suburb: 'MOUNT MCKENZIE', state: 'SA' },
  { postCode: '5353', suburb: 'PENRICE', state: 'SA' },
  { postCode: '5353', suburb: 'PUNYELROO', state: 'SA' },
  { postCode: '5353', suburb: 'SEDAN', state: 'SA' },
  { postCode: '5353', suburb: 'SUNNYDALE', state: 'SA' },
  { postCode: '5353', suburb: 'TOWITTA', state: 'SA' },
  { postCode: '5354', suburb: 'BAKARA', state: 'SA' },
  { postCode: '5354', suburb: 'BAKARA WELL', state: 'SA' },
  { postCode: '5354', suburb: 'FISHER', state: 'SA' },
  { postCode: '5354', suburb: 'MARKS LANDING', state: 'SA' },
  { postCode: '5354', suburb: 'NAIDIA', state: 'SA' },
  { postCode: '5354', suburb: 'SWAN REACH', state: 'SA' },
  { postCode: '5355', suburb: 'DAVEYSTON', state: 'SA' },
  { postCode: '5355', suburb: 'EBENEZER', state: 'SA' },
  { postCode: '5355', suburb: 'LIGHT PASS', state: 'SA' },
  { postCode: '5355', suburb: 'MARANANGA', state: 'SA' },
  { postCode: '5355', suburb: 'MOPPA', state: 'SA' },
  { postCode: '5355', suburb: 'NURIOOTPA', state: 'SA' },
  { postCode: '5355', suburb: 'SEPPELTSFIELD', state: 'SA' },
  { postCode: '5355', suburb: 'STOCKWELL', state: 'SA' },
  { postCode: '5356', suburb: 'ANNADALE', state: 'SA' },
  { postCode: '5356', suburb: 'DUTTON', state: 'SA' },
  { postCode: '5356', suburb: 'DUTTON EAST', state: 'SA' },
  { postCode: '5356', suburb: 'SANDLETON', state: 'SA' },
  { postCode: '5356', suburb: 'ST KITTS', state: 'SA' },
  { postCode: '5356', suburb: 'STEINFELD', state: 'SA' },
  { postCode: '5356', suburb: 'STONEFIELD', state: 'SA' },
  { postCode: '5356', suburb: 'TRURO', state: 'SA' },
  { postCode: '5357', suburb: 'BLANCHETOWN', state: 'SA' },
  { postCode: '5357', suburb: 'MCBEAN POUND', state: 'SA' },
  { postCode: '5357', suburb: 'NEW WELL', state: 'SA' },
  { postCode: '5357', suburb: 'NOTTS WELL', state: 'SA' },
  { postCode: '5357', suburb: 'PAISLEY', state: 'SA' },
  { postCode: '5360', suburb: 'GREENOCK', state: 'SA' },
  { postCode: '5360', suburb: 'NAIN', state: 'SA' },
  { postCode: '5371', suburb: 'MORN HILL', state: 'SA' },
  { postCode: '5371', suburb: 'ROSEWORTHY', state: 'SA' },
  { postCode: '5371', suburb: 'SHEA-OAK LOG', state: 'SA' },
  { postCode: '5371', suburb: 'TEMPLERS', state: 'SA' },
  { postCode: '5372', suburb: 'FREELING', state: 'SA' },
  { postCode: '5373', suburb: 'ALLENDALE NORTH', state: 'SA' },
  { postCode: '5373', suburb: 'BAGOT WELL', state: 'SA' },
  { postCode: '5373', suburb: 'BETHEL', state: 'SA' },
  { postCode: '5373', suburb: 'FORDS', state: 'SA' },
  { postCode: '5373', suburb: 'HAMILTON', state: 'SA' },
  { postCode: '5373', suburb: 'KAPUNDA', state: 'SA' },
  { postCode: '5373', suburb: 'KOONUNGA', state: 'SA' },
  { postCode: '5373', suburb: 'ST JOHNS', state: 'SA' },
  { postCode: '5374', suburb: 'AUSTRALIA PLAINS', state: 'SA' },
  { postCode: '5374', suburb: 'BOWER', state: 'SA' },
  { postCode: '5374', suburb: 'BROWNLOW', state: 'SA' },
  { postCode: '5374', suburb: 'BUCHANAN', state: 'SA' },
  { postCode: '5374', suburb: 'EUDUNDA', state: 'SA' },
  { postCode: '5374', suburb: 'FRANKTON', state: 'SA' },
  { postCode: '5374', suburb: 'HAMPDEN', state: 'SA' },
  { postCode: '5374', suburb: 'HANSBOROUGH', state: 'SA' },
  { postCode: '5374', suburb: 'JULIA', state: 'SA' },
  { postCode: '5374', suburb: 'MOUNT MARY', state: 'SA' },
  { postCode: '5374', suburb: 'NEALES FLAT', state: 'SA' },
  { postCode: '5374', suburb: 'NGAPALA', state: 'SA' },
  { postCode: '5374', suburb: 'PEEP HILL', state: 'SA' },
  { postCode: '5374', suburb: 'POINT PASS', state: 'SA' },
  { postCode: '5374', suburb: 'SUTHERLANDS', state: 'SA' },
  { postCode: '5381', suburb: 'BRADY CREEK', state: 'SA' },
  { postCode: '5381', suburb: 'BRIGHT', state: 'SA' },
  { postCode: '5381', suburb: 'EMU DOWNS', state: 'SA' },
  { postCode: '5381', suburb: 'GERANIUM PLAINS', state: 'SA' },
  { postCode: '5381', suburb: 'HALLELUJAH HILLS', state: 'SA' },
  { postCode: '5381', suburb: 'ROBERTSTOWN', state: 'SA' },
  { postCode: '5381', suburb: 'ROCKY PLAIN', state: 'SA' },
  { postCode: '5381', suburb: 'WORLDS END', state: 'SA' },
  { postCode: '5400', suburb: 'MAGDALA', state: 'SA' },
  { postCode: '5400', suburb: 'PINKERTON PLAINS', state: 'SA' },
  { postCode: '5400', suburb: 'WASLEYS', state: 'SA' },
  { postCode: '5400', suburb: 'WOOLSHEDS', state: 'SA' },
  { postCode: '5401', suburb: 'ALMA', state: 'SA' },
  { postCode: '5401', suburb: 'HAMLEY BRIDGE', state: 'SA' },
  { postCode: '5401', suburb: 'SALTER SPRINGS', state: 'SA' },
  { postCode: '5410', suburb: 'LINWOOD', state: 'SA' },
  { postCode: '5410', suburb: 'STOCKPORT', state: 'SA' },
  { postCode: '5411', suburb: 'GILES CORNER', state: 'SA' },
  { postCode: '5411', suburb: 'TARLEE', state: 'SA' },
  { postCode: '5412', suburb: 'NAVAN', state: 'SA' },
  { postCode: '5412', suburb: 'RHYNIE', state: 'SA' },
  { postCode: '5412', suburb: 'RIVERTON', state: 'SA' },
  { postCode: '5412', suburb: 'WOOLSHED FLAT', state: 'SA' },
  { postCode: '5413', suburb: 'APOINGA', state: 'SA' },
  { postCode: '5413', suburb: 'BLACK SPRINGS', state: 'SA' },
  { postCode: '5413', suburb: 'MARRABEL', state: 'SA' },
  { postCode: '5413', suburb: 'SADDLEWORTH', state: 'SA' },
  { postCode: '5413', suburb: 'STEELTON', state: 'SA' },
  { postCode: '5413', suburb: 'TARNMA', state: 'SA' },
  { postCode: '5413', suburb: 'TOTHILL BELT', state: 'SA' },
  { postCode: '5413', suburb: 'TOTHILL CREEK', state: 'SA' },
  { postCode: '5413', suburb: 'WATERLOO', state: 'SA' },
  { postCode: '5414', suburb: 'MANOORA', state: 'SA' },
  { postCode: '5415', suburb: 'MINTARO', state: 'SA' },
  { postCode: '5415', suburb: 'STANLEY', state: 'SA' },
  { postCode: '5416', suburb: 'FARRELL FLAT', state: 'SA' },
  { postCode: '5416', suburb: 'PORTER LAGOON', state: 'SA' },
  { postCode: '5417', suburb: 'BALAH', state: 'SA' },
  { postCode: '5417', suburb: 'BALDINA', state: 'SA' },
  { postCode: '5417', suburb: 'BOOBOROWIE', state: 'SA' },
  { postCode: '5417', suburb: 'BUNYUNG', state: 'SA' },
  { postCode: '5417', suburb: 'BURRA', state: 'SA' },
  { postCode: '5417', suburb: 'BURRA EASTERN DISTRICTS', state: 'SA' },
  { postCode: '5417', suburb: 'CANEGRASS', state: 'SA' },
  { postCode: '5417', suburb: 'DANGGALI', state: 'SA' },
  { postCode: '5417', suburb: 'FARAWAY HILL', state: 'SA' },
  { postCode: '5417', suburb: 'GLUEPOT', state: 'SA' },
  { postCode: '5417', suburb: 'GUM CREEK', state: 'SA' },
  { postCode: '5417', suburb: 'HANSON', state: 'SA' },
  { postCode: '5417', suburb: 'KOONOONA', state: 'SA' },
  { postCode: '5417', suburb: 'LEIGHTON', state: 'SA' },
  { postCode: '5417', suburb: 'MONGOLATA', state: 'SA' },
  { postCode: '5417', suburb: 'NORTH BOOBOROWIE', state: 'SA' },
  { postCode: '5417', suburb: 'OAKVALE STATION', state: 'SA' },
  { postCode: '5417', suburb: 'OLD KOOMOOLOO', state: 'SA' },
  { postCode: '5417', suburb: 'PARCOOLA', state: 'SA' },
  { postCode: '5417', suburb: 'PINE VALLEY STATION', state: 'SA' },
  { postCode: '5417', suburb: 'QUONDONG', state: 'SA' },
  { postCode: '5417', suburb: 'STURT VALE', state: 'SA' },
  { postCode: '5417', suburb: 'WARNES', state: 'SA' },
  { postCode: '5418', suburb: 'COLLINSVILLE', state: 'SA' },
  { postCode: '5418', suburb: 'MOUNT BRYAN', state: 'SA' },
  { postCode: '5419', suburb: 'CANOWIE', state: 'SA' },
  { postCode: '5419', suburb: 'HALLETT', state: 'SA' },
  { postCode: '5419', suburb: 'MOUNT BRYAN EAST', state: 'SA' },
  { postCode: '5419', suburb: 'PINE CREEK', state: 'SA' },
  { postCode: '5419', suburb: 'ULOOLOO', state: 'SA' },
  { postCode: '5419', suburb: 'WILLALO', state: 'SA' },
  { postCode: '5419', suburb: 'WONNA', state: 'SA' },
  { postCode: '5420', suburb: 'CANOWIE BELT', state: 'SA' },
  { postCode: '5420', suburb: 'WHYTE YARCOWIE', state: 'SA' },
  { postCode: '5421', suburb: 'FRANKLYN', state: 'SA' },
  { postCode: '5421', suburb: 'TEROWIE', state: 'SA' },
  { postCode: '5422', suburb: 'CAVENAGH', state: 'SA' },
  { postCode: '5422', suburb: 'DAWSON', state: 'SA' },
  { postCode: '5422', suburb: 'ERSKINE', state: 'SA' },
  { postCode: '5422', suburb: 'HARDY', state: 'SA' },
  { postCode: '5422', suburb: 'MANNANARIE', state: 'SA' },
  { postCode: '5422', suburb: 'MINVALARA', state: 'SA' },
  { postCode: '5422', suburb: 'OODLA WIRRA', state: 'SA' },
  { postCode: '5422', suburb: 'PARATOO', state: 'SA' },
  { postCode: '5422', suburb: 'PARNAROO', state: 'SA' },
  { postCode: '5422', suburb: 'PETERBOROUGH', state: 'SA' },
  { postCode: '5422', suburb: 'SUNNYBRAE', state: 'SA' },
  { postCode: '5422', suburb: 'UCOLTA', state: 'SA' },
  { postCode: '5422', suburb: 'WAROONEE', state: 'SA' },
  { postCode: '5422', suburb: 'YATINA', state: 'SA' },
  { postCode: '5431', suburb: 'AMYTON', state: 'SA' },
  { postCode: '5431', suburb: 'BLACK ROCK', state: 'SA' },
  { postCode: '5431', suburb: 'COOMOOROO', state: 'SA' },
  { postCode: '5431', suburb: 'EURELIA', state: 'SA' },
  { postCode: '5431', suburb: 'HAMMOND', state: 'SA' },
  { postCode: '5431', suburb: 'JOHNBURGH', state: 'SA' },
  { postCode: '5431', suburb: 'MINBURRA', state: 'SA' },
  { postCode: '5431', suburb: 'MINBURRA PLAIN', state: 'SA' },
  { postCode: '5431', suburb: 'MINBURRA STATION', state: 'SA' },
  { postCode: '5431', suburb: 'MORCHARD', state: 'SA' },
  { postCode: '5431', suburb: 'NORTH HILLS', state: 'SA' },
  { postCode: '5431', suburb: 'ORROROO', state: 'SA' },
  { postCode: '5431', suburb: 'PEKINA', state: 'SA' },
  { postCode: '5431', suburb: 'TARCOWIE', state: 'SA' },
  { postCode: '5431', suburb: 'WALLOWAY', state: 'SA' },
  { postCode: '5431', suburb: 'WILLOWIE', state: 'SA' },
  { postCode: '5431', suburb: 'YALPARA', state: 'SA' },
  { postCode: '5432', suburb: 'BARATTA', state: 'SA' },
  { postCode: '5432', suburb: 'BELTON', state: 'SA' },
  { postCode: '5432', suburb: 'BIBLIANDO', state: 'SA' },
  { postCode: '5432', suburb: 'CARRIETON', state: 'SA' },
  { postCode: '5432', suburb: 'CRADOCK', state: 'SA' },
  { postCode: '5432', suburb: 'HOLOWILIENA', state: 'SA' },
  { postCode: '5432', suburb: 'HOLOWILIENA SOUTH', state: 'SA' },
  { postCode: '5432', suburb: 'MOOCKRA', state: 'SA' },
  { postCode: '5432', suburb: 'THREE CREEKS', state: 'SA' },
  { postCode: '5432', suburb: 'WILCOWIE', state: 'SA' },
  { postCode: '5432', suburb: 'WILLIPPA', state: 'SA' },
  { postCode: '5432', suburb: 'WITCHITIE', state: 'SA' },
  { postCode: '5432', suburb: 'YANYARRIE', state: 'SA' },
  { postCode: '5433', suburb: 'BRUCE', state: 'SA' },
  { postCode: '5433', suburb: 'QUORN', state: 'SA' },
  { postCode: '5433', suburb: 'SALTIA', state: 'SA' },
  { postCode: '5433', suburb: 'STEPHENSTON', state: 'SA' },
  { postCode: '5433', suburb: 'WILLOCHRA', state: 'SA' },
  { postCode: '5433', suburb: 'YARRAH', state: 'SA' },
  { postCode: '5434', suburb: 'BARNDIOOTA', state: 'SA' },
  { postCode: '5434', suburb: 'BLACK HILL STATION', state: 'SA' },
  { postCode: '5434', suburb: 'FLINDERS RANGES', state: 'SA' },
  { postCode: '5434', suburb: 'HAWKER', state: 'SA' },
  { postCode: '5434', suburb: 'KANYAKA', state: 'SA' },
  { postCode: '5434', suburb: 'MOUNT HAVELOCK', state: 'SA' },
  { postCode: '5434', suburb: 'PRELINNA', state: 'SA' },
  { postCode: '5434', suburb: 'SHAGGY RIDGE', state: 'SA' },
  { postCode: '5434', suburb: 'UPALINNA', state: 'SA' },
  { postCode: '5434', suburb: 'WILLOW SPRINGS', state: 'SA' },
  { postCode: '5434', suburb: 'WORUMBA', state: 'SA' },
  { postCode: '5440', suburb: 'ABMINGA STATION', state: 'SA' },
  { postCode: '5440', suburb: 'BENDA', state: 'SA' },
  { postCode: '5440', suburb: 'BIMBOWRIE', state: 'SA' },
  { postCode: '5440', suburb: 'BINDARRAH', state: 'SA' },
  { postCode: '5440', suburb: 'BOOLCOOMATTA', state: 'SA' },
  { postCode: '5440', suburb: 'BULLOO CREEK', state: 'SA' },
  { postCode: '5440', suburb: 'COCKBURN', state: 'SA' },
  { postCode: '5440', suburb: 'CURNAMONA', state: 'SA' },
  { postCode: '5440', suburb: 'DEVONBOROUGH DOWNS', state: 'SA' },
  { postCode: '5440', suburb: 'ERUDINA', state: 'SA' },
  { postCode: '5440', suburb: 'FLORINA STATION', state: 'SA' },
  { postCode: '5440', suburb: 'FROME DOWNS', state: 'SA' },
  { postCode: '5440', suburb: 'GRAMPUS', state: 'SA' },
  { postCode: '5440', suburb: 'KALABITY', state: 'SA' },
  { postCode: '5440', suburb: 'KALKAROO', state: 'SA' },
  { postCode: '5440', suburb: 'KOONAMORE', state: 'SA' },
  { postCode: '5440', suburb: 'LAKE FROME', state: 'SA' },
  { postCode: '5440', suburb: 'MANNA HILL', state: 'SA' },
  { postCode: '5440', suburb: 'MANUNDA STATION', state: 'SA' },
  { postCode: '5440', suburb: 'MARTINS WELL', state: 'SA' },
  { postCode: '5440', suburb: 'MELTON STATION', state: 'SA' },
  { postCode: '5440', suburb: 'MINGARY', state: 'SA' },
  { postCode: '5440', suburb: 'MOOLEULOOLOO', state: 'SA' },
  { postCode: '5440', suburb: 'MOUNT VICTOR STATION', state: 'SA' },
  { postCode: '5440', suburb: 'MULYUNGARIE', state: 'SA' },
  { postCode: '5440', suburb: 'MUNDI MUNDI', state: 'SA' },
  { postCode: '5440', suburb: 'MUTOOROO', state: 'SA' },
  { postCode: '5440', suburb: 'NACKARA', state: 'SA' },
  { postCode: '5440', suburb: 'NETLEY GAP', state: 'SA' },
  { postCode: '5440', suburb: 'OLARY', state: 'SA' },
  { postCode: '5440', suburb: 'OULNINA', state: 'SA' },
  { postCode: '5440', suburb: 'OULNINA PARK', state: 'SA' },
  { postCode: '5440', suburb: 'OUTALPA', state: 'SA' },
  { postCode: '5440', suburb: 'PINE CREEK STATION', state: 'SA' },
  { postCode: '5440', suburb: 'PLUMBAGO', state: 'SA' },
  { postCode: '5440', suburb: 'PUALCO RANGE', state: 'SA' },
  { postCode: '5440', suburb: 'QUINYAMBIE', state: 'SA' },
  { postCode: '5440', suburb: 'TEPCO STATION', state: 'SA' },
  { postCode: '5440', suburb: 'TIKALINA', state: 'SA' },
  { postCode: '5440', suburb: 'WADNAMINGA', state: 'SA' },
  { postCode: '5440', suburb: 'WAUKARINGA', state: 'SA' },
  { postCode: '5440', suburb: 'WEEKEROO', state: 'SA' },
  { postCode: '5440', suburb: 'WIAWERA', state: 'SA' },
  { postCode: '5440', suburb: 'WINNININNIE', state: 'SA' },
  { postCode: '5440', suburb: 'WOMPINIE', state: 'SA' },
  { postCode: '5440', suburb: 'YARRAMBA', state: 'SA' },
  { postCode: '5440', suburb: 'YUNTA', state: 'SA' },
  { postCode: '5451', suburb: 'AUBURN', state: 'SA' },
  { postCode: '5451', suburb: 'UNDALYA', state: 'SA' },
  { postCode: '5452', suburb: 'LEASINGHAM', state: 'SA' },
  { postCode: '5452', suburb: 'WATERVALE', state: 'SA' },
  { postCode: '5453', suburb: 'ARMAGH', state: 'SA' },
  { postCode: '5453', suburb: 'BARINIA', state: 'SA' },
  { postCode: '5453', suburb: 'BENBOURNIE', state: 'SA' },
  { postCode: '5453', suburb: 'BOCONNOC PARK', state: 'SA' },
  { postCode: '5453', suburb: 'CLARE', state: 'SA' },
  { postCode: '5453', suburb: 'EMU FLAT', state: 'SA' },
  { postCode: '5453', suburb: 'GILLENTOWN', state: 'SA' },
  { postCode: '5453', suburb: 'HILL RIVER', state: 'SA' },
  { postCode: '5453', suburb: 'HOYLETON', state: 'SA' },
  { postCode: '5453', suburb: 'KYBUNGA', state: 'SA' },
  { postCode: '5453', suburb: 'PENWORTHAM', state: 'SA' },
  { postCode: '5453', suburb: 'POLISH HILL RIVER', state: 'SA' },
  { postCode: '5453', suburb: 'SEVENHILL', state: 'SA' },
  { postCode: '5453', suburb: 'SPRING FARM', state: 'SA' },
  { postCode: '5453', suburb: 'SPRING GULLY', state: 'SA' },
  { postCode: '5453', suburb: 'STANLEY FLAT', state: 'SA' },
  { postCode: '5454', suburb: 'ANDREWS', state: 'SA' },
  { postCode: '5454', suburb: 'BROUGHTON RIVER VALLEY', state: 'SA' },
  { postCode: '5454', suburb: 'EUROMINA', state: 'SA' },
  { postCode: '5454', suburb: 'HACKLINS CORNER', state: 'SA' },
  { postCode: '5454', suburb: 'MAYFIELD', state: 'SA' },
  { postCode: '5454', suburb: 'SPALDING', state: 'SA' },
  { postCode: '5454', suburb: 'WASHPOOL', state: 'SA' },
  { postCode: '5455', suburb: 'HILLTOWN', state: 'SA' },
  { postCode: '5460', suburb: 'BARABBA', state: 'SA' },
  { postCode: '5460', suburb: 'OWEN', state: 'SA' },
  { postCode: '5460', suburb: 'PINERY', state: 'SA' },
  { postCode: '5460', suburb: 'STOCKYARD CREEK', state: 'SA' },
  { postCode: '5461', suburb: 'BALAKLAVA', state: 'SA' },
  { postCode: '5461', suburb: 'BOWILLIA', state: 'SA' },
  { postCode: '5461', suburb: 'DALKEY', state: 'SA' },
  { postCode: '5461', suburb: 'ERITH', state: 'SA' },
  { postCode: '5461', suburb: 'EVERARD CENTRAL', state: 'SA' },
  { postCode: '5461', suburb: 'GOYDER', state: 'SA' },
  { postCode: '5461', suburb: 'HALBURY', state: 'SA' },
  { postCode: '5461', suburb: 'HOSKIN CORNER', state: 'SA' },
  { postCode: '5461', suburb: 'MOUNT TEMPLETON', state: 'SA' },
  { postCode: '5461', suburb: 'SAINTS', state: 'SA' },
  { postCode: '5461', suburb: 'STOW', state: 'SA' },
  { postCode: '5461', suburb: 'WATCHMAN', state: 'SA' },
  { postCode: '5461', suburb: 'WHITWARTA', state: 'SA' },
  { postCode: '5462', suburb: 'BLYTH', state: 'SA' },
  { postCode: '5464', suburb: 'ANAMA', state: 'SA' },
  { postCode: '5464', suburb: 'BRINKWORTH', state: 'SA' },
  { postCode: '5464', suburb: 'BUNGAREE', state: 'SA' },
  { postCode: '5464', suburb: 'CONDOWIE', state: 'SA' },
  { postCode: '5464', suburb: 'HART', state: 'SA' },
  { postCode: '5464', suburb: 'KOOLUNGA', state: 'SA' },
  { postCode: '5464', suburb: 'MAROLA', state: 'SA' },
  { postCode: '5464', suburb: 'ROCHESTER', state: 'SA' },
  { postCode: '5470', suburb: 'YACKA', state: 'SA' },
  { postCode: '5471', suburb: 'GULNARE', state: 'SA' },
  { postCode: '5472', suburb: 'GEORGETOWN', state: 'SA' },
  { postCode: '5473', suburb: 'GLADSTONE', state: 'SA' },
  { postCode: '5480', suburb: 'APPILA', state: 'SA' },
  { postCode: '5480', suburb: 'LAURA', state: 'SA' },
  { postCode: '5480', suburb: 'STONE HUT', state: 'SA' },
  { postCode: '5481', suburb: 'BANGOR', state: 'SA' },
  { postCode: '5481', suburb: 'MURRAY TOWN', state: 'SA' },
  { postCode: '5481', suburb: 'WIRRABARA', state: 'SA' },
  { postCode: '5481', suburb: 'WONGYARRA', state: 'SA' },
  { postCode: '5482', suburb: 'BOOLEROO CENTRE', state: 'SA' },
  { postCode: '5482', suburb: 'WEPOWIE', state: 'SA' },
  { postCode: '5483', suburb: 'MELROSE', state: 'SA' },
  { postCode: '5485', suburb: 'WILMINGTON', state: 'SA' },
  { postCode: '5490', suburb: 'CALTOWIE', state: 'SA' },
  { postCode: '5490', suburb: 'CALTOWIE NORTH', state: 'SA' },
  { postCode: '5490', suburb: 'CALTOWIE WEST', state: 'SA' },
  { postCode: '5491', suburb: 'BELALIE EAST', state: 'SA' },
  { postCode: '5491', suburb: 'BELALIE NORTH', state: 'SA' },
  { postCode: '5491', suburb: 'BUNDALEER GARDENS', state: 'SA' },
  { postCode: '5491', suburb: 'BUNDALEER NORTH', state: 'SA' },
  { postCode: '5491', suburb: 'HORNSDALE', state: 'SA' },
  { postCode: '5491', suburb: 'JAMESTOWN', state: 'SA' },
  { postCode: '5491', suburb: 'WEST BUNDALEER', state: 'SA' },
  { postCode: '5493', suburb: 'YONGALA', state: 'SA' },
  { postCode: '5495', suburb: 'BAROOTA', state: 'SA' },
  { postCode: '5495', suburb: 'GERMEIN BAY', state: 'SA' },
  { postCode: '5495', suburb: 'MAMBRAY CREEK', state: 'SA' },
  { postCode: '5495', suburb: 'NECTAR BROOK', state: 'SA' },
  { postCode: '5495', suburb: 'PORT GERMEIN', state: 'SA' },
  { postCode: '5495', suburb: 'WEEROONA ISLAND', state: 'SA' },
  { postCode: '5501', suburb: 'AVON', state: 'SA' },
  { postCode: '5501', suburb: 'CALOMBA', state: 'SA' },
  { postCode: '5501', suburb: 'DUBLIN', state: 'SA' },
  { postCode: '5501', suburb: 'LEWISTON', state: 'SA' },
  { postCode: '5501', suburb: 'LONG PLAINS', state: 'SA' },
  { postCode: '5501', suburb: 'LOWER LIGHT', state: 'SA' },
  { postCode: '5501', suburb: 'MIDDLE BEACH', state: 'SA' },
  { postCode: '5501', suburb: 'PARHAM', state: 'SA' },
  { postCode: '5501', suburb: 'PORT GAWLER', state: 'SA' },
  { postCode: '5501', suburb: 'THOMPSON BEACH', state: 'SA' },
  { postCode: '5501', suburb: 'TWO WELLS', state: 'SA' },
  { postCode: '5501', suburb: 'WEBB BEACH', state: 'SA' },
  { postCode: '5501', suburb: 'WILD HORSE PLAINS', state: 'SA' },
  { postCode: '5501', suburb: 'WINDSOR', state: 'SA' },
  { postCode: '5502', suburb: 'FISCHER', state: 'SA' },
  { postCode: '5502', suburb: 'GRACE PLAINS', state: 'SA' },
  { postCode: '5502', suburb: 'KORUNYE', state: 'SA' },
  { postCode: '5502', suburb: 'MALLALA', state: 'SA' },
  { postCode: '5502', suburb: 'REDBANKS', state: 'SA' },
  { postCode: '5502', suburb: 'REEVES PLAINS', state: 'SA' },
  { postCode: '5510', suburb: 'LOCHIEL', state: 'SA' },
  { postCode: '5520', suburb: 'BARUNGA GAP', state: 'SA' },
  { postCode: '5520', suburb: 'BUMBUNGA', state: 'SA' },
  { postCode: '5520', suburb: 'BURNSFIELD', state: 'SA' },
  { postCode: '5520', suburb: 'SNOWTOWN', state: 'SA' },
  { postCode: '5520', suburb: 'WOKURNA', state: 'SA' },
  { postCode: '5521', suburb: 'REDHILL', state: 'SA' },
  { postCode: '5522', suburb: 'FISHERMAN BAY', state: 'SA' },
  { postCode: '5522', suburb: 'PORT BROUGHTON', state: 'SA' },
  { postCode: '5522', suburb: 'WARD HILL', state: 'SA' },
  { postCode: '5523', suburb: 'BEETALOO VALLEY', state: 'SA' },
  { postCode: '5523', suburb: 'CLEMENTS GAP', state: 'SA' },
  { postCode: '5523', suburb: 'CRYSTAL BROOK', state: 'SA' },
  { postCode: '5523', suburb: 'HUDDLESTON', state: 'SA' },
  { postCode: '5523', suburb: 'MERRITON', state: 'SA' },
  { postCode: '5523', suburb: 'NARRIDY', state: 'SA' },
  { postCode: '5523', suburb: 'NUROM', state: 'SA' },
  { postCode: '5523', suburb: 'WANDEARAH', state: 'SA' },
  { postCode: '5523', suburb: 'WANDEARAH EAST', state: 'SA' },
  { postCode: '5523', suburb: 'WANDEARAH WEST', state: 'SA' },
  { postCode: '5540', suburb: 'BUNGAMA', state: 'SA' },
  { postCode: '5540', suburb: 'COONAMIA', state: 'SA' },
  { postCode: '5540', suburb: 'LOWER BROUGHTON', state: 'SA' },
  { postCode: '5540', suburb: 'NAPPERBY', state: 'SA' },
  { postCode: '5540', suburb: 'NELSHABY', state: 'SA' },
  { postCode: '5540', suburb: 'PIRIE EAST', state: 'SA' },
  { postCode: '5540', suburb: 'PORT DAVIS', state: 'SA' },
  { postCode: '5540', suburb: 'PORT PIRIE', state: 'SA' },
  { postCode: '5540', suburb: 'PORT PIRIE SOUTH', state: 'SA' },
  { postCode: '5540', suburb: 'PORT PIRIE WEST', state: 'SA' },
  { postCode: '5540', suburb: 'RISDON PARK', state: 'SA' },
  { postCode: '5540', suburb: 'RISDON PARK SOUTH', state: 'SA' },
  { postCode: '5540', suburb: 'SOLOMONTOWN', state: 'SA' },
  { postCode: '5540', suburb: 'TELOWIE', state: 'SA' },
  { postCode: '5540', suburb: 'WARNERTOWN', state: 'SA' },
  { postCode: '5550', suburb: 'BEAUFORT', state: 'SA' },
  { postCode: '5550', suburb: 'BOWMANS', state: 'SA' },
  { postCode: '5550', suburb: 'INKERMAN', state: 'SA' },
  { postCode: '5550', suburb: 'KALLORA', state: 'SA' },
  { postCode: '5550', suburb: 'NANTAWARRA', state: 'SA' },
  { postCode: '5550', suburb: 'PORT WAKEFIELD', state: 'SA' },
  { postCode: '5550', suburb: 'PROOF RANGE', state: 'SA' },
  { postCode: '5550', suburb: 'SOUTH HUMMOCKS', state: 'SA' },
  { postCode: '5552', suburb: 'KAINTON', state: 'SA' },
  { postCode: '5552', suburb: 'KULPARA', state: 'SA' },
  { postCode: '5552', suburb: 'MELTON', state: 'SA' },
  { postCode: '5552', suburb: 'PASKEVILLE', state: 'SA' },
  { postCode: '5552', suburb: 'PORT ARTHUR', state: 'SA' },
  { postCode: '5552', suburb: 'SUNNYVALE', state: 'SA' },
  { postCode: '5552', suburb: 'THRINGTON', state: 'SA' },
  { postCode: '5554', suburb: 'BOORS PLAIN', state: 'SA' },
  { postCode: '5554', suburb: 'CUNLIFFE', state: 'SA' },
  { postCode: '5554', suburb: 'JERICHO', state: 'SA' },
  { postCode: '5554', suburb: 'JERUSALEM', state: 'SA' },
  { postCode: '5554', suburb: 'KADINA', state: 'SA' },
  { postCode: '5554', suburb: 'MATTA FLAT', state: 'SA' },
  { postCode: '5554', suburb: 'NEW TOWN', state: 'SA' },
  { postCode: '5554', suburb: 'THOMAS PLAIN', state: 'SA' },
  { postCode: '5554', suburb: 'WALLAROO MINES', state: 'SA' },
  { postCode: '5554', suburb: 'WILLAMULKA', state: 'SA' },
  { postCode: '5555', suburb: 'ALFORD', state: 'SA' },
  { postCode: '5555', suburb: 'COLLINSFIELD', state: 'SA' },
  { postCode: '5555', suburb: 'HOPE GAP', state: 'SA' },
  { postCode: '5555', suburb: 'LAKE VIEW', state: 'SA' },
  { postCode: '5555', suburb: 'MUNDOORA', state: 'SA' },
  { postCode: '5555', suburb: 'TICKERA', state: 'SA' },
  { postCode: '5556', suburb: 'NORTH BEACH', state: 'SA' },
  { postCode: '5556', suburb: 'WALLAROO', state: 'SA' },
  { postCode: '5556', suburb: 'WALLAROO PLAIN', state: 'SA' },
  { postCode: '5556', suburb: 'WARBURTO', state: 'SA' },
  { postCode: '5558', suburb: 'AGERY', state: 'SA' },
  { postCode: '5558', suburb: 'CROSS ROADS', state: 'SA' },
  { postCode: '5558', suburb: 'EAST MOONTA', state: 'SA' },
  { postCode: '5558', suburb: 'HAMLEY', state: 'SA' },
  { postCode: '5558', suburb: 'KOOROONA', state: 'SA' },
  { postCode: '5558', suburb: 'MOONTA', state: 'SA' },
  { postCode: '5558', suburb: 'MOONTA BAY', state: 'SA' },
  { postCode: '5558', suburb: 'MOONTA MINES', state: 'SA' },
  { postCode: '5558', suburb: 'NALYAPPA', state: 'SA' },
  { postCode: '5558', suburb: 'NORTH MOONTA', state: 'SA' },
  { postCode: '5558', suburb: 'NORTH YELTA', state: 'SA' },
  { postCode: '5558', suburb: 'PARAMATTA', state: 'SA' },
  { postCode: '5558', suburb: 'PORT HUGHES', state: 'SA' },
  { postCode: '5558', suburb: 'YELTA', state: 'SA' },
  { postCode: '5560', suburb: 'BUTE', state: 'SA' },
  { postCode: '5560', suburb: 'NINNES', state: 'SA' },
  { postCode: '5570', suburb: 'CLINTON', state: 'SA' },
  { postCode: '5570', suburb: 'CLINTON CENTRE', state: 'SA' },
  { postCode: '5570', suburb: 'PRICE', state: 'SA' },
  { postCode: '5570', suburb: 'WINULTA', state: 'SA' },
  { postCode: '5571', suburb: 'ARDROSSAN', state: 'SA' },
  { postCode: '5571', suburb: 'BLACK POINT', state: 'SA' },
  { postCode: '5571', suburb: 'CUNNINGHAM', state: 'SA' },
  { postCode: '5571', suburb: 'DOWLINGVILLE', state: 'SA' },
  { postCode: '5571', suburb: 'JAMES WELL', state: 'SA' },
  { postCode: '5571', suburb: 'PETERSVILLE', state: 'SA' },
  { postCode: '5571', suburb: 'PINE POINT', state: 'SA' },
  { postCode: '5571', suburb: 'ROGUES POINT', state: 'SA' },
  { postCode: '5571', suburb: 'SANDILANDS', state: 'SA' },
  { postCode: '5571', suburb: 'TIDDY WIDDY BEACH', state: 'SA' },
  { postCode: '5572', suburb: 'ARTHURTON', state: 'SA' },
  { postCode: '5573', suburb: 'BALGOWAN', state: 'SA' },
  { postCode: '5573', suburb: 'CHINAMAN WELLS', state: 'SA' },
  { postCode: '5573', suburb: 'MAITLAND', state: 'SA' },
  { postCode: '5573', suburb: 'POINT PEARCE', state: 'SA' },
  { postCode: '5573', suburb: 'PORT VICTORIA', state: 'SA' },
  { postCode: '5573', suburb: 'SOUTH KILKERRAN', state: 'SA' },
  { postCode: '5573', suburb: 'URANIA', state: 'SA' },
  { postCode: '5573', suburb: 'WAURALTEE', state: 'SA' },
  { postCode: '5573', suburb: 'WEETULTA', state: 'SA' },
  { postCode: '5573', suburb: 'YORKE VALLEY', state: 'SA' },
  { postCode: '5575', suburb: 'BLUFF BEACH', state: 'SA' },
  { postCode: '5575', suburb: 'BRENTWOOD', state: 'SA' },
  { postCode: '5575', suburb: 'CORNY POINT', state: 'SA' },
  { postCode: '5575', suburb: 'HARDWICKE BAY', state: 'SA' },
  { postCode: '5575', suburb: 'KOOLYWURTIE', state: 'SA' },
  { postCode: '5575', suburb: 'MARION BAY', state: 'SA' },
  { postCode: '5575', suburb: 'MINLATON', state: 'SA' },
  { postCode: '5575', suburb: 'PARSONS BEACH', state: 'SA' },
  { postCode: '5575', suburb: 'POINT TURTON', state: 'SA' },
  { postCode: '5575', suburb: 'PORT RICKABY', state: 'SA' },
  { postCode: '5575', suburb: 'RAMSAY', state: 'SA' },
  { postCode: '5575', suburb: 'STENHOUSE BAY', state: 'SA' },
  { postCode: '5575', suburb: 'WHITE HUT', state: 'SA' },
  { postCode: '5575', suburb: 'WOOL BAY', state: 'SA' },
  { postCode: '5576', suburb: 'HONITON', state: 'SA' },
  { postCode: '5576', suburb: 'PORT MOOROWIE', state: 'SA' },
  { postCode: '5576', suburb: 'YORKETOWN', state: 'SA' },
  { postCode: '5577', suburb: 'COUCH BEACH', state: 'SA' },
  { postCode: '5577', suburb: 'FOUL BAY', state: 'SA' },
  { postCode: '5577', suburb: 'INNESTON', state: 'SA' },
  { postCode: '5577', suburb: 'POINT SOUTTAR', state: 'SA' },
  { postCode: '5577', suburb: 'THE PINES', state: 'SA' },
  { postCode: '5577', suburb: 'WAROOKA', state: 'SA' },
  { postCode: '5580', suburb: 'CURRAMULKA', state: 'SA' },
  { postCode: '5580', suburb: 'PORT JULIA', state: 'SA' },
  { postCode: '5581', suburb: 'PORT VINCENT', state: 'SA' },
  { postCode: '5581', suburb: 'SHEAOAK FLAT', state: 'SA' },
  { postCode: '5582', suburb: 'PORT GILES', state: 'SA' },
  { postCode: '5582', suburb: 'STANSBURY', state: 'SA' },
  { postCode: '5583', suburb: 'COOBOWIE', state: 'SA' },
  { postCode: '5583', suburb: 'EDITHBURGH', state: 'SA' },
  { postCode: '5583', suburb: 'SULTANA POINT', state: 'SA' },
  { postCode: '5600', suburb: 'WHYALLA', state: 'SA' },
  { postCode: '5600', suburb: 'WHYALLA DC', state: 'SA' },
  { postCode: '5600', suburb: 'WHYALLA PLAYFORD', state: 'SA' },
  { postCode: '5601', suburb: 'BACKY POINT', state: 'SA' },
  { postCode: '5601', suburb: 'DOUGLAS POINT', state: 'SA' },
  { postCode: '5601', suburb: 'DOUGLAS POINT SOUTH', state: 'SA' },
  { postCode: '5601', suburb: 'FALSE BAY', state: 'SA' },
  { postCode: '5601', suburb: 'FITZGERALD BAY', state: 'SA' },
  { postCode: '5601', suburb: 'POINT LOWLY', state: 'SA' },
  { postCode: '5601', suburb: 'POINT LOWLY NORTH', state: 'SA' },
  { postCode: '5601', suburb: 'PORT BONYTHON', state: 'SA' },
  { postCode: '5601', suburb: 'WHYALLA BARSON', state: 'SA' },
  { postCode: '5602', suburb: 'COWELL', state: 'SA' },
  { postCode: '5602', suburb: 'LUCKY BAY', state: 'SA' },
  { postCode: '5602', suburb: 'MANGALO', state: 'SA' },
  { postCode: '5602', suburb: 'MIDGEE', state: 'SA' },
  { postCode: '5602', suburb: 'MILTALIE', state: 'SA' },
  { postCode: '5602', suburb: 'MINBRIE', state: 'SA' },
  { postCode: '5602', suburb: 'MITCHELLVILLE', state: 'SA' },
  { postCode: '5602', suburb: 'PORT GIBBON', state: 'SA' },
  { postCode: '5603', suburb: 'ARNO BAY', state: 'SA' },
  { postCode: '5603', suburb: 'HINCKS', state: 'SA' },
  { postCode: '5603', suburb: 'VERRAN', state: 'SA' },
  { postCode: '5603', suburb: 'WHARMINDA', state: 'SA' },
  { postCode: '5604', suburb: 'PORT NEILL', state: 'SA' },
  { postCode: '5605', suburb: 'BUTLER', state: 'SA' },
  { postCode: '5605', suburb: 'TUMBY BAY', state: 'SA' },
  { postCode: '5606', suburb: 'PORT LINCOLN', state: 'SA' },
  { postCode: '5606', suburb: 'PORT LINCOLN SOUTH', state: 'SA' },
  { postCode: '5606', suburb: 'WEDGE ISLAND', state: 'SA' },
  { postCode: '5607', suburb: 'BOSTON', state: 'SA' },
  { postCode: '5607', suburb: 'BROOKER', state: 'SA' },
  { postCode: '5607', suburb: 'CHARLTON GULLY', state: 'SA' },
  { postCode: '5607', suburb: 'COFFIN BAY', state: 'SA' },
  { postCode: '5607', suburb: 'COOMUNGA', state: 'SA' },
  { postCode: '5607', suburb: 'COULTA', state: 'SA' },
  { postCode: '5607', suburb: 'DUCK PONDS', state: 'SA' },
  { postCode: '5607', suburb: 'FARM BEACH', state: 'SA' },
  { postCode: '5607', suburb: 'FOUNTAIN', state: 'SA' },
  { postCode: '5607', suburb: 'GREEN PATCH', state: 'SA' },
  { postCode: '5607', suburb: 'HAWSON', state: 'SA' },
  { postCode: '5607', suburb: 'KELLIDIE BAY', state: 'SA' },
  { postCode: '5607', suburb: 'KIANA', state: 'SA' },
  { postCode: '5607', suburb: 'KOPPIO', state: 'SA' },
  { postCode: '5607', suburb: 'LINCOLN NATIONAL PARK', state: 'SA' },
  { postCode: '5607', suburb: 'LIPSON', state: 'SA' },
  { postCode: '5607', suburb: 'LITTLE DOUGLAS', state: 'SA' },
  { postCode: '5607', suburb: 'LOUTH BAY', state: 'SA' },
  { postCode: '5607', suburb: 'MOODY', state: 'SA' },
  { postCode: '5607', suburb: 'MOUNT DRUMMOND', state: 'SA' },
  { postCode: '5607', suburb: 'MOUNT DUTTON BAY', state: 'SA' },
  { postCode: '5607', suburb: 'MOUNT HOPE', state: 'SA' },
  { postCode: '5607', suburb: 'MURDINGA', state: 'SA' },
  { postCode: '5607', suburb: 'NORTH SHIELDS', state: 'SA' },
  { postCode: '5607', suburb: 'PEARLAH', state: 'SA' },
  { postCode: '5607', suburb: 'POINT BOSTON', state: 'SA' },
  { postCode: '5607', suburb: 'POONINDIE', state: 'SA' },
  { postCode: '5607', suburb: 'PORT LINCOLN', state: 'SA' },
  { postCode: '5607', suburb: 'SHERINGA', state: 'SA' },
  { postCode: '5607', suburb: 'SLEAFORD', state: 'SA' },
  { postCode: '5607', suburb: 'TIATUKIA', state: 'SA' },
  { postCode: '5607', suburb: 'TOOLIGIE', state: 'SA' },
  { postCode: '5607', suburb: 'TOOTENILLA', state: 'SA' },
  { postCode: '5607', suburb: 'TULKA', state: 'SA' },
  { postCode: '5607', suburb: 'ULEY', state: 'SA' },
  { postCode: '5607', suburb: 'UNGARRA', state: 'SA' },
  { postCode: '5607', suburb: 'VENUS BAY', state: 'SA' },
  { postCode: '5607', suburb: 'WANGARY', state: 'SA' },
  { postCode: '5607', suburb: 'WANILLA', state: 'SA' },
  { postCode: '5607', suburb: 'WARROW', state: 'SA' },
  { postCode: '5607', suburb: 'WHITES FLAT', state: 'SA' },
  { postCode: '5607', suburb: 'WHITES RIVER', state: 'SA' },
  { postCode: '5607', suburb: 'YALLUNDA FLAT', state: 'SA' },
  { postCode: '5608', suburb: 'MULLAQUANA', state: 'SA' },
  { postCode: '5608', suburb: 'WHYALLA NORRIE', state: 'SA' },
  { postCode: '5608', suburb: 'WHYALLA NORRIE EAST', state: 'SA' },
  { postCode: '5608', suburb: 'WHYALLA NORRIE NORTH', state: 'SA' },
  { postCode: '5608', suburb: 'WHYALLA STUART', state: 'SA' },
  { postCode: '5609', suburb: 'COWLEDS LANDING', state: 'SA' },
  { postCode: '5609', suburb: 'MIDDLEBACK RANGE', state: 'SA' },
  { postCode: '5609', suburb: 'MURNINNIE BEACH', state: 'SA' },
  { postCode: '5609', suburb: 'WHYALLA JENKINS', state: 'SA' },
  { postCode: '5611', suburb: 'COOYERDOO', state: 'SA' },
  { postCode: '5611', suburb: 'CORUNNA STATION', state: 'SA' },
  { postCode: '5611', suburb: 'GILLES DOWNS', state: 'SA' },
  { postCode: '5611', suburb: 'IRON BARON', state: 'SA' },
  { postCode: '5611', suburb: 'IRON KNOB', state: 'SA' },
  { postCode: '5611', suburb: 'KATUNGA STATION', state: 'SA' },
  { postCode: '5611', suburb: 'LAKE GILLES', state: 'SA' },
  { postCode: '5611', suburb: 'MYOLA STATION', state: 'SA' },
  { postCode: '5611', suburb: 'SECRET ROCKS', state: 'SA' },
  { postCode: '5630', suburb: 'EDILLILIE', state: 'SA' },
  { postCode: '5631', suburb: 'COCKALEECHIE', state: 'SA' },
  { postCode: '5631', suburb: 'CUMMINS', state: 'SA' },
  { postCode: '5632', suburb: 'KAPINNIE', state: 'SA' },
  { postCode: '5632', suburb: 'KARKOO', state: 'SA' },
  { postCode: '5632', suburb: 'MITCHELL', state: 'SA' },
  { postCode: '5632', suburb: 'YEELANNA', state: 'SA' },
  { postCode: '5633', suburb: 'BOONERDO', state: 'SA' },
  { postCode: '5633', suburb: 'LOCK', state: 'SA' },
  { postCode: '5633', suburb: 'ULYERRA', state: 'SA' },
  { postCode: '5640', suburb: 'CAMPOONA', state: 'SA' },
  { postCode: '5640', suburb: 'CLEVE', state: 'SA' },
  { postCode: '5640', suburb: 'JAMIESON', state: 'SA' },
  { postCode: '5640', suburb: 'WADDIKEE', state: 'SA' },
  { postCode: '5641', suburb: 'BARNA', state: 'SA' },
  { postCode: '5641', suburb: 'BUCKLEBOO', state: 'SA' },
  { postCode: '5641', suburb: 'BUNGEROO', state: 'SA' },
  { postCode: '5641', suburb: 'CARALUE', state: 'SA' },
  { postCode: '5641', suburb: 'CORTLINYE', state: 'SA' },
  { postCode: '5641', suburb: 'CUNYARIE', state: 'SA' },
  { postCode: '5641', suburb: 'KELLY', state: 'SA' },
  { postCode: '5641', suburb: 'KIMBA', state: 'SA' },
  { postCode: '5641', suburb: 'MOSELEY', state: 'SA' },
  { postCode: '5641', suburb: 'PANITYA', state: 'SA' },
  { postCode: '5641', suburb: 'PINKAWILLINIE', state: 'SA' },
  { postCode: '5641', suburb: 'SOLOMON', state: 'SA' },
  { postCode: '5641', suburb: 'WILCHERRY', state: 'SA' },
  { postCode: '5641', suburb: 'YALANDA', state: 'SA' },
  { postCode: '5641', suburb: 'YELTANA', state: 'SA' },
  { postCode: '5642', suburb: 'DARKE PEAK', state: 'SA' },
  { postCode: '5642', suburb: 'HAMBIDGE', state: 'SA' },
  { postCode: '5642', suburb: 'KIELPA', state: 'SA' },
  { postCode: '5642', suburb: 'MURLONG', state: 'SA' },
  { postCode: '5642', suburb: 'RUDALL', state: 'SA' },
  { postCode: '5650', suburb: 'COOTRA', state: 'SA' },
  { postCode: '5650', suburb: 'KOONGAWA', state: 'SA' },
  { postCode: '5650', suburb: 'WARRAMBOO', state: 'SA' },
  { postCode: '5651', suburb: 'KYANCUTTA', state: 'SA' },
  { postCode: '5652', suburb: 'PANEY', state: 'SA' },
  { postCode: '5652', suburb: 'PYGERY', state: 'SA' },
  { postCode: '5652', suburb: 'WUDINNA', state: 'SA' },
  { postCode: '5653', suburb: 'YANINEE', state: 'SA' },
  { postCode: '5654', suburb: 'COCATA', state: 'SA' },
  { postCode: '5654', suburb: 'KARCULTABY', state: 'SA' },
  { postCode: '5654', suburb: 'MINNIPA', state: 'SA' },
  { postCode: '5654', suburb: 'MOUNT DAMPER', state: 'SA' },
  { postCode: '5655', suburb: 'BOCKELBERG', state: 'SA' },
  { postCode: '5655', suburb: 'GAWLER RANGES', state: 'SA' },
  { postCode: '5655', suburb: 'KALDOONERA', state: 'SA' },
  { postCode: '5655', suburb: 'LOCKES CLAYPAN', state: 'SA' },
  { postCode: '5655', suburb: 'NARLABY', state: 'SA' },
  { postCode: '5655', suburb: 'POOCHERA', state: 'SA' },
  { postCode: '5660', suburb: 'CHILPENUNDA', state: 'SA' },
  { postCode: '5660', suburb: 'CUNGENA', state: 'SA' },
  { postCode: '5661', suburb: 'KOOLGERA', state: 'SA' },
  { postCode: '5661', suburb: 'PIMBAACLA', state: 'SA' },
  { postCode: '5661', suburb: 'WALLALA', state: 'SA' },
  { postCode: '5661', suburb: 'WIRRULLA', state: 'SA' },
  { postCode: '5661', suburb: 'YANTANABIE', state: 'SA' },
  { postCode: '5670', suburb: 'BRAMFIELD', state: 'SA' },
  { postCode: '5670', suburb: 'COLTON', state: 'SA' },
  { postCode: '5670', suburb: 'COOLILLIE', state: 'SA' },
  { postCode: '5670', suburb: 'ELLISTON', state: 'SA' },
  { postCode: '5670', suburb: 'KAPPAWANTA', state: 'SA' },
  { postCode: '5670', suburb: 'MOUNT JOY', state: 'SA' },
  { postCode: '5670', suburb: 'MOUNT WEDGE', state: 'SA' },
  { postCode: '5670', suburb: 'PALKAGEE', state: 'SA' },
  { postCode: '5670', suburb: 'POLDA', state: 'SA' },
  { postCode: '5670', suburb: 'TALIA', state: 'SA' },
  { postCode: '5671', suburb: 'BAIRD BAY', state: 'SA' },
  { postCode: '5671', suburb: 'CALCA', state: 'SA' },
  { postCode: '5671', suburb: 'COLLEY', state: 'SA' },
  { postCode: '5671', suburb: 'MORTANA', state: 'SA' },
  { postCode: '5671', suburb: 'MOUNT COOPER', state: 'SA' },
  { postCode: '5671', suburb: 'PORT KENNY', state: 'SA' },
  { postCode: '5671', suburb: 'TYRINGA', state: 'SA' },
  { postCode: '5671', suburb: 'WITERA', state: 'SA' },
  { postCode: '5680', suburb: 'CARAWA', state: 'SA' },
  { postCode: '5680', suburb: 'CHANDADA', state: 'SA' },
  { postCode: '5680', suburb: 'CHINBINGINA', state: 'SA' },
  { postCode: '5680', suburb: 'EBA ANCHORAGE', state: 'SA' },
  { postCode: '5680', suburb: 'HASLAM', state: 'SA' },
  { postCode: '5680', suburb: 'INKSTER', state: 'SA' },
  { postCode: '5680', suburb: 'LAURA BAY', state: 'SA' },
  { postCode: '5680', suburb: 'MARYVALE', state: 'SA' },
  { postCode: '5680', suburb: 'MUDAMUCKLA', state: 'SA' },
  { postCode: '5680', suburb: 'NUNJIKOMPITA', state: 'SA' },
  { postCode: '5680', suburb: 'PERLUBIE', state: 'SA' },
  { postCode: '5680', suburb: 'PETINA', state: 'SA' },
  { postCode: '5680', suburb: 'PIEDNIPPIE', state: 'SA' },
  { postCode: '5680', suburb: 'PINJARRA STATION', state: 'SA' },
  { postCode: '5680', suburb: 'PUNTABIE', state: 'SA' },
  { postCode: '5680', suburb: 'PUREBA', state: 'SA' },
  { postCode: '5680', suburb: 'SCEALE BAY', state: 'SA' },
  { postCode: '5680', suburb: 'SMOKY BAY', state: 'SA' },
  { postCode: '5680', suburb: 'STREAKY BAY', state: 'SA' },
  { postCode: '5680', suburb: 'WESTALL', state: 'SA' },
  { postCode: '5680', suburb: 'YANERBIE', state: 'SA' },
  { postCode: '5690', suburb: 'BOOKABIE', state: 'SA' },
  { postCode: '5690', suburb: 'CEDUNA', state: 'SA' },
  { postCode: '5690', suburb: 'CEDUNA WATERS', state: 'SA' },
  { postCode: '5690', suburb: 'CHARRA', state: 'SA' },
  { postCode: '5690', suburb: 'CHUNDARIA', state: 'SA' },
  { postCode: '5690', suburb: 'COORABIE', state: 'SA' },
  { postCode: '5690', suburb: 'DENIAL BAY', state: 'SA' },
  { postCode: '5690', suburb: 'FOWLERS BAY', state: 'SA' },
  { postCode: '5690', suburb: 'KALANBI', state: 'SA' },
  { postCode: '5690', suburb: 'KOONIBBA', state: 'SA' },
  { postCode: '5690', suburb: 'MALTEE', state: 'SA' },
  { postCode: '5690', suburb: 'MERGHINY', state: 'SA' },
  { postCode: '5690', suburb: 'MITCHIDY MOOLA', state: 'SA' },
  { postCode: '5690', suburb: 'NADIA', state: 'SA' },
  { postCode: '5690', suburb: 'NANBONA', state: 'SA' },
  { postCode: '5690', suburb: 'NULLARBOR', state: 'SA' },
  { postCode: '5690', suburb: 'OAK VALLEY', state: 'SA' },
  { postCode: '5690', suburb: 'PENONG', state: 'SA' },
  { postCode: '5690', suburb: 'THEVENARD', state: 'SA' },
  { postCode: '5690', suburb: 'UWORRA', state: 'SA' },
  { postCode: '5690', suburb: 'WANDANA', state: 'SA' },
  { postCode: '5690', suburb: 'WATRABA', state: 'SA' },
  { postCode: '5690', suburb: 'WHITE WELL CORNER', state: 'SA' },
  { postCode: '5690', suburb: 'YALATA', state: 'SA' },
  { postCode: '5690', suburb: 'YELLABINNA', state: 'SA' },
  { postCode: '5690', suburb: 'YUMBARRA', state: 'SA' },
  { postCode: '5700', suburb: 'BLANCHE HARBOR', state: 'SA' },
  { postCode: '5700', suburb: 'COMMISSARIAT POINT', state: 'SA' },
  { postCode: '5700', suburb: 'CULTANA', state: 'SA' },
  { postCode: '5700', suburb: 'DAVENPORT', state: 'SA' },
  { postCode: '5700', suburb: 'MIRANDA', state: 'SA' },
  { postCode: '5700', suburb: 'MUNDALLIO', state: 'SA' },
  { postCode: '5700', suburb: 'PORT AUGUSTA', state: 'SA' },
  { postCode: '5700', suburb: 'PORT AUGUSTA NORTH', state: 'SA' },
  { postCode: '5700', suburb: 'PORT AUGUSTA WEST', state: 'SA' },
  { postCode: '5700', suburb: 'PORT PATERSON', state: 'SA' },
  { postCode: '5700', suburb: 'WAMI KATA', state: 'SA' },
  { postCode: '5700', suburb: 'WINNINOWIE', state: 'SA' },
  { postCode: '5701', suburb: 'ARKAROOLA VILLAGE', state: 'SA' },
  { postCode: '5701', suburb: 'COOK', state: 'SA' },
  { postCode: '5701', suburb: 'PORT AUGUSTA', state: 'SA' },
  { postCode: '5701', suburb: 'TARCOOLA', state: 'SA' },
  { postCode: '5701', suburb: 'WOOLUNDUNGA', state: 'SA' },
  { postCode: '5710', suburb: 'STIRLING NORTH', state: 'SA' },
  { postCode: '5713', suburb: 'EMEROO', state: 'SA' },
  { postCode: '5713', suburb: 'ISLAND LAGOON', state: 'SA' },
  { postCode: '5713', suburb: 'KOOTABERRA', state: 'SA' },
  { postCode: '5713', suburb: 'LAKE TORRENS', state: 'SA' },
  { postCode: '5713', suburb: 'LAKE TORRENS STATION', state: 'SA' },
  { postCode: '5713', suburb: 'MOUNT ARDEN', state: 'SA' },
  { postCode: '5713', suburb: 'OAKDEN HILLS', state: 'SA' },
  { postCode: '5713', suburb: 'PERNATTY', state: 'SA' },
  { postCode: '5713', suburb: 'SOUTH GAP', state: 'SA' },
  { postCode: '5713', suburb: 'WALLERBERDINA', state: 'SA' },
  { postCode: '5713', suburb: 'WILKATANA STATION', state: 'SA' },
  { postCode: '5713', suburb: 'WINTABATINYANA', state: 'SA' },
  { postCode: '5713', suburb: 'YADLAMALKA', state: 'SA' },
  { postCode: '5715', suburb: 'CARRIEWERLOO', state: 'SA' },
  { postCode: '5715', suburb: 'ILLEROO', state: 'SA' },
  { postCode: '5715', suburb: 'LINCOLN GAP', state: 'SA' },
  { postCode: '5715', suburb: 'PANDURRA', state: 'SA' },
  { postCode: '5715', suburb: 'WARTAKA', state: 'SA' },
  { postCode: '5715', suburb: 'YALYMBOO', state: 'SA' },
  { postCode: '5715', suburb: 'YUDNAPINNA', state: 'SA' },
  { postCode: '5717', suburb: 'HILTABA', state: 'SA' },
  { postCode: '5717', suburb: 'KOKATHA', state: 'SA' },
  { postCode: '5717', suburb: 'KOLENDO', state: 'SA' },
  { postCode: '5717', suburb: 'KONDOOLKA', state: 'SA' },
  { postCode: '5717', suburb: 'LAKE EVERARD', state: 'SA' },
  { postCode: '5717', suburb: 'LAKE GAIRDNER', state: 'SA' },
  { postCode: '5717', suburb: 'LAKE MACFARLANE', state: 'SA' },
  { postCode: '5717', suburb: 'MAHANEWO', state: 'SA' },
  { postCode: '5717', suburb: 'MOONAREE', state: 'SA' },
  { postCode: '5717', suburb: 'MOUNT IVE', state: 'SA' },
  { postCode: '5717', suburb: 'NONNING', state: 'SA' },
  { postCode: '5717', suburb: 'SIAM', state: 'SA' },
  { postCode: '5717', suburb: 'THURLGA', state: 'SA' },
  { postCode: '5717', suburb: 'UNO', state: 'SA' },
  { postCode: '5717', suburb: 'YARDEA', state: 'SA' },
  { postCode: '5719', suburb: 'BON BON', state: 'SA' },
  { postCode: '5719', suburb: 'BULGUNNIA', state: 'SA' },
  { postCode: '5719', suburb: 'COMMONWEALTH HILL', state: 'SA' },
  { postCode: '5719', suburb: 'COONDAMBO', state: 'SA' },
  { postCode: '5719', suburb: 'GLENDAMBO', state: 'SA' },
  { postCode: '5719', suburb: 'KINGOONYA', state: 'SA' },
  { postCode: '5719', suburb: 'LAKE HARRIS', state: 'SA' },
  { postCode: '5719', suburb: 'MULGATHING', state: 'SA' },
  { postCode: '5719', suburb: 'WILGENA', state: 'SA' },
  { postCode: '5719', suburb: 'WIRRAMINNA', state: 'SA' },
  { postCode: '5720', suburb: 'ARCOONA', state: 'SA' },
  { postCode: '5720', suburb: 'BILLA KALINA', state: 'SA' },
  { postCode: '5720', suburb: 'BOSWORTH', state: 'SA' },
  { postCode: '5720', suburb: 'MILLERS CREEK', state: 'SA' },
  { postCode: '5720', suburb: 'MOUNT EBA', state: 'SA' },
  { postCode: '5720', suburb: 'MOUNT VIVIAN', state: 'SA' },
  { postCode: '5720', suburb: 'PARAKYLIA', state: 'SA' },
  { postCode: '5720', suburb: 'PIMBA', state: 'SA' },
  { postCode: '5720', suburb: 'PURPLE DOWNS', state: 'SA' },
  { postCode: '5720', suburb: 'STUARTS CREEK', state: 'SA' },
  { postCode: '5720', suburb: 'WOOMERA', state: 'SA' },
  { postCode: '5722', suburb: 'ANDAMOOKA', state: 'SA' },
  { postCode: '5722', suburb: 'ANDAMOOKA STATION', state: 'SA' },
  { postCode: '5723', suburb: 'ALLANDALE STATION', state: 'SA' },
  { postCode: '5723', suburb: 'ANNA CREEK', state: 'SA' },
  { postCode: '5723', suburb: 'ARCKARINGA', state: 'SA' },
  { postCode: '5723', suburb: 'COOBER PEDY', state: 'SA' },
  { postCode: '5723', suburb: 'EVELYN DOWNS', state: 'SA' },
  { postCode: '5723', suburb: 'INGOMAR', state: 'SA' },
  { postCode: '5723', suburb: 'MABEL CREEK', state: 'SA' },
  { postCode: '5723', suburb: 'MCDOUALL PEAK', state: 'SA' },
  { postCode: '5723', suburb: 'MOUNT BARRY', state: 'SA' },
  { postCode: '5723', suburb: 'MOUNT CLARENCE STATION', state: 'SA' },
  { postCode: '5723', suburb: 'MOUNT WILLOUGHBY', state: 'SA' },
  { postCode: '5723', suburb: 'NILPINNA STATION', state: 'SA' },
  { postCode: '5723', suburb: 'WILLIAM CREEK', state: 'SA' },
  { postCode: '5723', suburb: 'WINTINNA', state: 'SA' },
  { postCode: '5724', suburb: 'MARLA', state: 'SA' },
  { postCode: '5724', suburb: 'MINTABIE', state: 'SA' },
  { postCode: '5724', suburb: 'WELBOURN HILL', state: 'SA' },
  { postCode: '5725', suburb: 'OLYMPIC DAM', state: 'SA' },
  { postCode: '5725', suburb: 'ROXBY DOWNS', state: 'SA' },
  { postCode: '5725', suburb: 'ROXBY DOWNS STATION', state: 'SA' },
  { postCode: '5730', suburb: 'ALPANA', state: 'SA' },
  { postCode: '5730', suburb: 'ANGORIGINA', state: 'SA' },
  { postCode: '5730', suburb: 'BELTANA', state: 'SA' },
  { postCode: '5730', suburb: 'BELTANA STATION', state: 'SA' },
  { postCode: '5730', suburb: 'BLINMAN', state: 'SA' },
  { postCode: '5730', suburb: 'EDIACARA', state: 'SA' },
  { postCode: '5730', suburb: 'GUM CREEK STATION', state: 'SA' },
  { postCode: '5730', suburb: 'MOOLOOLOO', state: 'SA' },
  { postCode: '5730', suburb: 'MOORILLAH', state: 'SA' },
  { postCode: '5730', suburb: 'MOTPENA', state: 'SA' },
  { postCode: '5730', suburb: 'MOUNT FALKLAND', state: 'SA' },
  { postCode: '5730', suburb: 'NARRINA', state: 'SA' },
  { postCode: '5730', suburb: 'NILPENA', state: 'SA' },
  { postCode: '5730', suburb: 'ORATUNGA STATION', state: 'SA' },
  { postCode: '5730', suburb: 'PARACHILNA', state: 'SA' },
  { postCode: '5730', suburb: 'PUTTAPA', state: 'SA' },
  { postCode: '5730', suburb: 'WARRAWEENA', state: 'SA' },
  { postCode: '5730', suburb: 'WIRREALPA', state: 'SA' },
  { postCode: '5731', suburb: 'BOLLARDS LAGOON', state: 'SA' },
  { postCode: '5731', suburb: 'COOPERS CREEK', state: 'SA' },
  { postCode: '5731', suburb: 'CORDILLO DOWNS', state: 'SA' },
  { postCode: '5731', suburb: 'FARINA', state: 'SA' },
  { postCode: '5731', suburb: 'FARINA STATION', state: 'SA' },
  { postCode: '5731', suburb: 'GIDGEALPA', state: 'SA' },
  { postCode: '5731', suburb: 'INNAMINCKA', state: 'SA' },
  { postCode: '5731', suburb: 'LEIGH CREEK', state: 'SA' },
  { postCode: '5731', suburb: 'LEIGH CREEK STATION', state: 'SA' },
  { postCode: '5731', suburb: 'LINDON', state: 'SA' },
  { postCode: '5731', suburb: 'LYNDHURST', state: 'SA' },
  { postCode: '5731', suburb: 'MERTY MERTY', state: 'SA' },
  { postCode: '5731', suburb: 'MOUNT FREELING', state: 'SA' },
  { postCode: '5731', suburb: 'MOUNT LYNDHURST', state: 'SA' },
  { postCode: '5731', suburb: 'MULGARIA', state: 'SA' },
  { postCode: '5731', suburb: 'MURNPEOWIE', state: 'SA' },
  { postCode: '5731', suburb: 'MYRTLE SPRINGS', state: 'SA' },
  { postCode: '5731', suburb: 'STRZELECKI DESERT', state: 'SA' },
  { postCode: '5731', suburb: 'WITCHELINA', state: 'SA' },
  { postCode: '5732', suburb: 'ANGEPENA', state: 'SA' },
  { postCode: '5732', suburb: 'ARKAROOLA', state: 'SA' },
  { postCode: '5732', suburb: 'BURR WELL', state: 'SA' },
  { postCode: '5732', suburb: 'COPLEY', state: 'SA' },
  { postCode: '5732', suburb: 'GAMMON RANGES', state: 'SA' },
  { postCode: '5732', suburb: 'MANNERS WELL', state: 'SA' },
  { postCode: '5732', suburb: 'MOOLAWATANA', state: 'SA' },
  { postCode: '5732', suburb: 'MOUNT SERLE', state: 'SA' },
  { postCode: '5732', suburb: 'MULGA VIEW', state: 'SA' },
  { postCode: '5732', suburb: 'NEPABUNNA', state: 'SA' },
  { postCode: '5732', suburb: 'NORTH MOOLOOLOO', state: 'SA' },
  { postCode: '5732', suburb: 'PINDA SPRINGS', state: 'SA' },
  { postCode: '5732', suburb: 'UMBERATANA', state: 'SA' },
  { postCode: '5732', suburb: 'WERTALOONA', state: 'SA' },
  { postCode: '5732', suburb: 'WOOLTANA', state: 'SA' },
  { postCode: '5732', suburb: 'YANKANINNA', state: 'SA' },
  { postCode: '5733', suburb: 'ALTON DOWNS STATION', state: 'SA' },
  { postCode: '5733', suburb: 'CALLANNA', state: 'SA' },
  { postCode: '5733', suburb: 'CLAYTON STATION', state: 'SA' },
  { postCode: '5733', suburb: 'CLIFTON HILLS STATION', state: 'SA' },
  { postCode: '5733', suburb: 'COWARIE', state: 'SA' },
  { postCode: '5733', suburb: 'DULKANINNA', state: 'SA' },
  { postCode: '5733', suburb: 'ETADUNNA', state: 'SA' },
  { postCode: '5733', suburb: 'KALAMURINA', state: 'SA' },
  { postCode: '5733', suburb: 'LAKE EYRE', state: 'SA' },
  { postCode: '5733', suburb: 'MARREE', state: 'SA' },
  { postCode: '5733', suburb: 'MARREE STATION', state: 'SA' },
  { postCode: '5733', suburb: 'MULKA', state: 'SA' },
  { postCode: '5733', suburb: 'MULOORINA', state: 'SA' },
  { postCode: '5733', suburb: 'MUNDOWDNA', state: 'SA' },
  { postCode: '5733', suburb: 'MUNGERANIE', state: 'SA' },
  { postCode: '5733', suburb: 'PANDIE PANDIE', state: 'SA' },
  { postCode: '5734', suburb: 'CROWN POINT', state: 'SA' },
  { postCode: '5734', suburb: 'ERINGA', state: 'SA' },
  { postCode: '5734', suburb: 'MACUMBA', state: 'SA' },
  { postCode: '5734', suburb: 'MOUNT SARAH', state: 'SA' },
  { postCode: '5734', suburb: 'OODNADATTA', state: 'SA' },
  { postCode: '5734', suburb: 'SIMPSON DESERT', state: 'SA' },
  { postCode: '5734', suburb: 'TODMORDEN', state: 'SA' },
  { postCode: '5734', suburb: 'WITJIRA', state: 'SA' },
  { postCode: '5942', suburb: 'REGENCY PARK', state: 'SA' },
  { postCode: '5950', suburb: 'ADELAIDE AIRPORT', state: 'SA' },
  { postCode: '5950', suburb: 'EXPORT PARK', state: 'SA' },
  { postCode: '6000', suburb: 'CITY DELIVERY CENTRE', state: 'WA' },
  { postCode: '6000', suburb: 'PERTH', state: 'WA' },
  { postCode: '6000', suburb: 'PERTH GPO', state: 'WA' },
  { postCode: '6003', suburb: 'HIGHGATE', state: 'WA' },
  { postCode: '6003', suburb: 'NORTHBRIDGE', state: 'WA' },
  { postCode: '6004', suburb: 'EAST PERTH', state: 'WA' },
  { postCode: '6005', suburb: 'KINGS PARK', state: 'WA' },
  { postCode: '6005', suburb: 'WEST PERTH', state: 'WA' },
  { postCode: '6006', suburb: 'NORTH PERTH', state: 'WA' },
  { postCode: '6007', suburb: 'LEEDERVILLE', state: 'WA' },
  { postCode: '6007', suburb: 'WEST LEEDERVILLE', state: 'WA' },
  { postCode: '6008', suburb: 'DAGLISH', state: 'WA' },
  { postCode: '6008', suburb: 'SHENTON PARK', state: 'WA' },
  { postCode: '6008', suburb: 'SUBIACO', state: 'WA' },
  { postCode: '6008', suburb: 'SUBIACO EAST', state: 'WA' },
  { postCode: '6009', suburb: 'BROADWAY NEDLANDS', state: 'WA' },
  { postCode: '6009', suburb: 'CRAWLEY', state: 'WA' },
  { postCode: '6009', suburb: 'DALKEITH', state: 'WA' },
  { postCode: '6009', suburb: 'NEDLANDS', state: 'WA' },
  { postCode: '6009', suburb: 'NEDLANDS DC', state: 'WA' },
  { postCode: '6010', suburb: 'CLAREMONT', state: 'WA' },
  { postCode: '6010', suburb: 'CLAREMONT NORTH', state: 'WA' },
  { postCode: '6010', suburb: 'KARRAKATTA', state: 'WA' },
  { postCode: '6010', suburb: 'MOUNT CLAREMONT', state: 'WA' },
  { postCode: '6010', suburb: 'SWANBOURNE', state: 'WA' },
  { postCode: '6011', suburb: 'COTTESLOE', state: 'WA' },
  { postCode: '6011', suburb: 'PEPPERMINT GROVE', state: 'WA' },
  { postCode: '6012', suburb: 'MOSMAN PARK', state: 'WA' },
  { postCode: '6014', suburb: 'FLOREAT', state: 'WA' },
  { postCode: '6014', suburb: 'JOLIMONT', state: 'WA' },
  { postCode: '6014', suburb: 'WEMBLEY', state: 'WA' },
  { postCode: '6015', suburb: 'CITY BEACH', state: 'WA' },
  { postCode: '6016', suburb: 'GLENDALOUGH', state: 'WA' },
  { postCode: '6016', suburb: 'MOUNT HAWTHORN', state: 'WA' },
  { postCode: '6017', suburb: 'HERDSMAN', state: 'WA' },
  { postCode: '6017', suburb: 'OSBORNE PARK', state: 'WA' },
  { postCode: '6017', suburb: 'OSBORNE PARK DC', state: 'WA' },
  { postCode: '6018', suburb: 'CHURCHLANDS', state: 'WA' },
  { postCode: '6018', suburb: 'DOUBLEVIEW', state: 'WA' },
  { postCode: '6018', suburb: 'GWELUP', state: 'WA' },
  { postCode: '6018', suburb: 'GWELUP DC', state: 'WA' },
  { postCode: '6018', suburb: 'INNALOO', state: 'WA' },
  { postCode: '6018', suburb: 'KARRINYUP', state: 'WA' },
  { postCode: '6018', suburb: 'WOODLANDS', state: 'WA' },
  { postCode: '6019', suburb: 'SCARBOROUGH', state: 'WA' },
  { postCode: '6019', suburb: 'WEMBLEY DOWNS', state: 'WA' },
  { postCode: '6020', suburb: 'CARINE', state: 'WA' },
  { postCode: '6020', suburb: 'MARMION', state: 'WA' },
  { postCode: '6020', suburb: 'NORTH BEACH', state: 'WA' },
  { postCode: '6020', suburb: 'SORRENTO', state: 'WA' },
  { postCode: '6020', suburb: 'WATERMANS BAY', state: 'WA' },
  { postCode: '6021', suburb: 'BALCATTA', state: 'WA' },
  { postCode: '6021', suburb: 'STIRLING', state: 'WA' },
  { postCode: '6022', suburb: 'HAMERSLEY', state: 'WA' },
  { postCode: '6023', suburb: 'DUNCRAIG', state: 'WA' },
  { postCode: '6024', suburb: 'GREENWOOD', state: 'WA' },
  { postCode: '6024', suburb: 'WARWICK', state: 'WA' },
  { postCode: '6025', suburb: 'CRAIGIE', state: 'WA' },
  { postCode: '6025', suburb: 'HILLARYS', state: 'WA' },
  { postCode: '6025', suburb: 'KALLAROO', state: 'WA' },
  { postCode: '6025', suburb: 'PADBURY', state: 'WA' },
  { postCode: '6026', suburb: 'KINGSLEY', state: 'WA' },
  { postCode: '6026', suburb: 'WOODVALE', state: 'WA' },
  { postCode: '6027', suburb: 'BELDON', state: 'WA' },
  { postCode: '6027', suburb: 'CONNOLLY', state: 'WA' },
  { postCode: '6027', suburb: 'EDGEWATER', state: 'WA' },
  { postCode: '6027', suburb: 'HEATHRIDGE', state: 'WA' },
  { postCode: '6027', suburb: 'JOONDALUP', state: 'WA' },
  { postCode: '6027', suburb: 'JOONDALUP DC', state: 'WA' },
  { postCode: '6027', suburb: 'MULLALOO', state: 'WA' },
  { postCode: '6027', suburb: 'OCEAN REEF', state: 'WA' },
  { postCode: '6028', suburb: 'BURNS BEACH', state: 'WA' },
  { postCode: '6028', suburb: 'CURRAMBINE', state: 'WA' },
  { postCode: '6028', suburb: 'ILUKA', state: 'WA' },
  { postCode: '6028', suburb: 'KINROSS', state: 'WA' },
  { postCode: '6029', suburb: 'TRIGG', state: 'WA' },
  { postCode: '6030', suburb: 'CLARKSON', state: 'WA' },
  { postCode: '6030', suburb: 'MERRIWA', state: 'WA' },
  { postCode: '6030', suburb: 'MINDARIE', state: 'WA' },
  { postCode: '6030', suburb: 'QUINNS ROCKS', state: 'WA' },
  { postCode: '6030', suburb: 'RIDGEWOOD', state: 'WA' },
  { postCode: '6030', suburb: 'TAMALA PARK', state: 'WA' },
  { postCode: '6031', suburb: 'BANKSIA GROVE', state: 'WA' },
  { postCode: '6031', suburb: 'CARRAMAR', state: 'WA' },
  { postCode: '6031', suburb: 'NEERABUP', state: 'WA' },
  { postCode: '6032', suburb: 'NOWERGUP', state: 'WA' },
  { postCode: '6033', suburb: 'CARABOODA', state: 'WA' },
  { postCode: '6034', suburb: 'EGLINTON', state: 'WA' },
  { postCode: '6035', suburb: 'YANCHEP', state: 'WA' },
  { postCode: '6036', suburb: 'BUTLER', state: 'WA' },
  { postCode: '6036', suburb: 'JINDALEE', state: 'WA' },
  { postCode: '6037', suburb: 'TWO ROCKS', state: 'WA' },
  { postCode: '6038', suburb: 'ALKIMOS', state: 'WA' },
  { postCode: '6041', suburb: 'CARABAN', state: 'WA' },
  { postCode: '6041', suburb: 'GABBADAH', state: 'WA' },
  { postCode: '6041', suburb: 'GUILDERTON', state: 'WA' },
  { postCode: '6041', suburb: 'WILBINGA', state: 'WA' },
  { postCode: '6041', suburb: 'WOODRIDGE', state: 'WA' },
  { postCode: '6042', suburb: 'SEABIRD', state: 'WA' },
  { postCode: '6043', suburb: 'BRETON BAY', state: 'WA' },
  { postCode: '6043', suburb: 'LEDGE POINT', state: 'WA' },
  { postCode: '6044', suburb: 'KARAKIN', state: 'WA' },
  { postCode: '6044', suburb: 'LANCELIN', state: 'WA' },
  { postCode: '6044', suburb: 'NILGEN', state: 'WA' },
  { postCode: '6044', suburb: 'WEDGE ISLAND', state: 'WA' },
  { postCode: '6050', suburb: 'COOLBINIA', state: 'WA' },
  { postCode: '6050', suburb: 'MENORA', state: 'WA' },
  { postCode: '6050', suburb: 'MOUNT LAWLEY', state: 'WA' },
  { postCode: '6051', suburb: 'MAYLANDS', state: 'WA' },
  { postCode: '6052', suburb: 'BEDFORD', state: 'WA' },
  { postCode: '6052', suburb: 'INGLEWOOD', state: 'WA' },
  { postCode: '6053', suburb: 'BAYSWATER', state: 'WA' },
  { postCode: '6054', suburb: 'ASHFIELD', state: 'WA' },
  { postCode: '6054', suburb: 'BASSENDEAN', state: 'WA' },
  { postCode: '6054', suburb: 'EDEN HILL', state: 'WA' },
  { postCode: '6054', suburb: 'KIARA', state: 'WA' },
  { postCode: '6054', suburb: 'LOCKRIDGE', state: 'WA' },
  { postCode: '6055', suburb: 'BRABHAM', state: 'WA' },
  { postCode: '6055', suburb: 'BUSHMEAD', state: 'WA' },
  { postCode: '6055', suburb: 'CAVERSHAM', state: 'WA' },
  { postCode: '6055', suburb: 'DAYTON', state: 'WA' },
  { postCode: '6055', suburb: 'GUILDFORD', state: 'WA' },
  { postCode: '6055', suburb: 'HAZELMERE', state: 'WA' },
  { postCode: '6055', suburb: 'HENLEY BROOK', state: 'WA' },
  { postCode: '6055', suburb: 'SOUTH GUILDFORD', state: 'WA' },
  { postCode: '6055', suburb: 'WEST SWAN', state: 'WA' },
  { postCode: '6056', suburb: 'BASKERVILLE', state: 'WA' },
  { postCode: '6056', suburb: 'BELLEVUE', state: 'WA' },
  { postCode: '6056', suburb: 'BOYA', state: 'WA' },
  { postCode: '6056', suburb: 'GREENMOUNT', state: 'WA' },
  { postCode: '6056', suburb: 'HELENA VALLEY', state: 'WA' },
  { postCode: '6056', suburb: 'HERNE HILL', state: 'WA' },
  { postCode: '6056', suburb: 'JANE BROOK', state: 'WA' },
  { postCode: '6056', suburb: 'KOONGAMIA', state: 'WA' },
  { postCode: '6056', suburb: 'MIDDLE SWAN', state: 'WA' },
  { postCode: '6056', suburb: 'MIDLAND', state: 'WA' },
  { postCode: '6056', suburb: 'MIDVALE', state: 'WA' },
  { postCode: '6056', suburb: 'MILLENDON', state: 'WA' },
  { postCode: '6056', suburb: 'RED HILL', state: 'WA' },
  { postCode: '6056', suburb: 'STRATTON', state: 'WA' },
  { postCode: '6056', suburb: 'SWAN VIEW', state: 'WA' },
  { postCode: '6056', suburb: 'VIVEASH', state: 'WA' },
  { postCode: '6056', suburb: 'WOODBRIDGE', state: 'WA' },
  { postCode: '6057', suburb: 'HIGH WYCOMBE', state: 'WA' },
  { postCode: '6057', suburb: 'MAIDA VALE', state: 'WA' },
  { postCode: '6058', suburb: 'FORRESTFIELD', state: 'WA' },
  { postCode: '6059', suburb: 'DIANELLA', state: 'WA' },
  { postCode: '6060', suburb: 'JOONDANNA', state: 'WA' },
  { postCode: '6060', suburb: 'TUART HILL', state: 'WA' },
  { postCode: '6060', suburb: 'YOKINE', state: 'WA' },
  { postCode: '6060', suburb: 'YOKINE SOUTH', state: 'WA' },
  { postCode: '6061', suburb: 'BALGA', state: 'WA' },
  { postCode: '6061', suburb: 'MIRRABOOKA', state: 'WA' },
  { postCode: '6061', suburb: 'NOLLAMARA', state: 'WA' },
  { postCode: '6061', suburb: 'WESTMINSTER', state: 'WA' },
  { postCode: '6062', suburb: 'EMBLETON', state: 'WA' },
  { postCode: '6062', suburb: 'MORLEY', state: 'WA' },
  { postCode: '6062', suburb: 'NORANDA', state: 'WA' },
  { postCode: '6063', suburb: 'BEECHBORO', state: 'WA' },
  { postCode: '6063', suburb: 'BENNETT SPRINGS', state: 'WA' },
  { postCode: '6064', suburb: 'ALEXANDER HEIGHTS', state: 'WA' },
  { postCode: '6064', suburb: 'GIRRAWHEEN', state: 'WA' },
  { postCode: '6064', suburb: 'KOONDOOLA', state: 'WA' },
  { postCode: '6064', suburb: 'MARANGAROO', state: 'WA' },
  { postCode: '6065', suburb: 'ASHBY', state: 'WA' },
  { postCode: '6065', suburb: 'DARCH', state: 'WA' },
  { postCode: '6065', suburb: 'HOCKING', state: 'WA' },
  { postCode: '6065', suburb: 'KINGSWAY', state: 'WA' },
  { postCode: '6065', suburb: 'LANDSDALE', state: 'WA' },
  { postCode: '6065', suburb: 'MADELEY', state: 'WA' },
  { postCode: '6065', suburb: 'PEARSALL', state: 'WA' },
  { postCode: '6065', suburb: 'SINAGRA', state: 'WA' },
  { postCode: '6065', suburb: 'TAPPING', state: 'WA' },
  { postCode: '6065', suburb: 'WANGARA', state: 'WA' },
  { postCode: '6065', suburb: 'WANGARA DC', state: 'WA' },
  { postCode: '6065', suburb: 'WANNEROO', state: 'WA' },
  { postCode: '6066', suburb: 'BALLAJURA', state: 'WA' },
  { postCode: '6067', suburb: 'CULLACABARDEE', state: 'WA' },
  { postCode: '6068', suburb: 'WHITEMAN', state: 'WA' },
  { postCode: '6069', suburb: 'AVELEY', state: 'WA' },
  { postCode: '6069', suburb: 'BELHUS', state: 'WA' },
  { postCode: '6069', suburb: 'BRIGADOON', state: 'WA' },
  { postCode: '6069', suburb: 'ELLENBROOK', state: 'WA' },
  { postCode: '6069', suburb: 'THE VINES', state: 'WA' },
  { postCode: '6069', suburb: 'UPPER SWAN', state: 'WA' },
  { postCode: '6070', suburb: 'DARLINGTON', state: 'WA' },
  { postCode: '6071', suburb: 'GLEN FORREST', state: 'WA' },
  { postCode: '6071', suburb: 'HOVEA', state: 'WA' },
  { postCode: '6072', suburb: 'MAHOGANY CREEK', state: 'WA' },
  { postCode: '6073', suburb: 'MUNDARING', state: 'WA' },
  { postCode: '6073', suburb: 'MUNDARING DC', state: 'WA' },
  { postCode: '6074', suburb: 'SAWYERS VALLEY', state: 'WA' },
  { postCode: '6076', suburb: 'BICKLEY', state: 'WA' },
  { postCode: '6076', suburb: 'CARMEL', state: 'WA' },
  { postCode: '6076', suburb: 'GOOSEBERRY HILL', state: 'WA' },
  { postCode: '6076', suburb: 'HACKETTS GULLY', state: 'WA' },
  { postCode: '6076', suburb: 'KALAMUNDA', state: 'WA' },
  { postCode: '6076', suburb: 'LESMURDIE', state: 'WA' },
  { postCode: '6076', suburb: 'PAULLS VALLEY', state: 'WA' },
  { postCode: '6076', suburb: 'PICKERING BROOK', state: 'WA' },
  { postCode: '6076', suburb: 'PIESSE BROOK', state: 'WA' },
  { postCode: '6076', suburb: 'RESERVOIR', state: 'WA' },
  { postCode: '6076', suburb: 'WALLISTON', state: 'WA' },
  { postCode: '6077', suburb: 'GNANGARA', state: 'WA' },
  { postCode: '6077', suburb: 'JANDABUP', state: 'WA' },
  { postCode: '6078', suburb: 'MARIGINIUP', state: 'WA' },
  { postCode: '6078', suburb: 'PINJAR', state: 'WA' },
  { postCode: '6079', suburb: 'LEXIA', state: 'WA' },
  { postCode: '6079', suburb: 'MELALEUCA', state: 'WA' },
  { postCode: '6081', suburb: 'PARKERVILLE', state: 'WA' },
  { postCode: '6081', suburb: 'STONEVILLE', state: 'WA' },
  { postCode: '6082', suburb: 'BAILUP', state: 'WA' },
  { postCode: '6082', suburb: 'MOUNT HELENA', state: 'WA' },
  { postCode: '6083', suburb: 'GIDGEGANNUP', state: 'WA' },
  { postCode: '6083', suburb: 'MORANGUP', state: 'WA' },
  { postCode: '6084', suburb: 'AVON VALLEY NATIONAL PARK', state: 'WA' },
  { postCode: '6084', suburb: 'BULLSBROOK', state: 'WA' },
  { postCode: '6084', suburb: 'CHITTERING', state: 'WA' },
  { postCode: '6084', suburb: 'LOWER CHITTERING', state: 'WA' },
  { postCode: '6084', suburb: 'WALYUNGA NATIONAL PARK', state: 'WA' },
  { postCode: '6090', suburb: 'MALAGA', state: 'WA' },
  { postCode: '6100', suburb: 'BURSWOOD', state: 'WA' },
  { postCode: '6100', suburb: 'LATHLAIN', state: 'WA' },
  { postCode: '6100', suburb: 'VICTORIA PARK', state: 'WA' },
  { postCode: '6101', suburb: 'CARLISLE', state: 'WA' },
  { postCode: '6101', suburb: 'CARLISLE NORTH', state: 'WA' },
  { postCode: '6101', suburb: 'CARLISLE SOUTH', state: 'WA' },
  { postCode: '6101', suburb: 'EAST VICTORIA PARK', state: 'WA' },
  { postCode: '6102', suburb: 'BENTLEY', state: 'WA' },
  { postCode: '6102', suburb: 'BENTLEY DC', state: 'WA' },
  { postCode: '6102', suburb: 'BENTLEY SOUTH', state: 'WA' },
  { postCode: '6102', suburb: 'ST JAMES', state: 'WA' },
  { postCode: '6103', suburb: 'RIVERVALE', state: 'WA' },
  { postCode: '6104', suburb: 'ASCOT', state: 'WA' },
  { postCode: '6104', suburb: 'BELMONT', state: 'WA' },
  { postCode: '6104', suburb: 'REDCLIFFE', state: 'WA' },
  { postCode: '6105', suburb: 'CLOVERDALE', state: 'WA' },
  { postCode: '6105', suburb: 'KEWDALE', state: 'WA' },
  { postCode: '6105', suburb: 'PERTH AIRPORT', state: 'WA' },
  { postCode: '6106', suburb: 'WELSHPOOL', state: 'WA' },
  { postCode: '6107', suburb: 'BECKENHAM', state: 'WA' },
  { postCode: '6107', suburb: 'CANNINGTON', state: 'WA' },
  { postCode: '6107', suburb: 'EAST CANNINGTON', state: 'WA' },
  { postCode: '6107', suburb: 'KENWICK', state: 'WA' },
  { postCode: '6107', suburb: 'QUEENS PARK', state: 'WA' },
  { postCode: '6107', suburb: 'WATTLE GROVE', state: 'WA' },
  { postCode: '6107', suburb: 'WILSON', state: 'WA' },
  { postCode: '6108', suburb: 'THORNLIE', state: 'WA' },
  { postCode: '6109', suburb: 'MADDINGTON', state: 'WA' },
  { postCode: '6109', suburb: 'ORANGE GROVE', state: 'WA' },
  { postCode: '6110', suburb: 'GOSNELLS', state: 'WA' },
  { postCode: '6110', suburb: 'HUNTINGDALE', state: 'WA' },
  { postCode: '6110', suburb: 'MARTIN', state: 'WA' },
  { postCode: '6110', suburb: 'SOUTHERN RIVER', state: 'WA' },
  { postCode: '6111', suburb: 'ASHENDON', state: 'WA' },
  { postCode: '6111', suburb: 'CAMILLO', state: 'WA' },
  { postCode: '6111', suburb: 'CANNING MILLS', state: 'WA' },
  { postCode: '6111', suburb: 'CHAMPION LAKES', state: 'WA' },
  { postCode: '6111', suburb: 'KARRAGULLEN', state: 'WA' },
  { postCode: '6111', suburb: 'KELMSCOTT', state: 'WA' },
  { postCode: '6111', suburb: 'KELMSCOTT DC', state: 'WA' },
  { postCode: '6111', suburb: 'LESLEY', state: 'WA' },
  { postCode: '6111', suburb: 'ROLEYSTONE', state: 'WA' },
  { postCode: '6112', suburb: 'ARMADALE', state: 'WA' },
  { postCode: '6112', suburb: 'BEDFORDALE', state: 'WA' },
  { postCode: '6112', suburb: 'BROOKDALE', state: 'WA' },
  { postCode: '6112', suburb: 'FORRESTDALE', state: 'WA' },
  { postCode: '6112', suburb: 'HARRISDALE', state: 'WA' },
  { postCode: '6112', suburb: 'HAYNES', state: 'WA' },
  { postCode: '6112', suburb: 'HILBERT', state: 'WA' },
  { postCode: '6112', suburb: 'MOUNT NASURA', state: 'WA' },
  { postCode: '6112', suburb: 'MOUNT RICHON', state: 'WA' },
  { postCode: '6112', suburb: 'PIARA WATERS', state: 'WA' },
  { postCode: '6112', suburb: 'SEVILLE GROVE', state: 'WA' },
  { postCode: '6112', suburb: 'WUNGONG', state: 'WA' },
  { postCode: '6121', suburb: 'OAKFORD', state: 'WA' },
  { postCode: '6121', suburb: 'OLDBURY', state: 'WA' },
  { postCode: '6122', suburb: 'BYFORD', state: 'WA' },
  { postCode: '6122', suburb: 'CARDUP', state: 'WA' },
  { postCode: '6122', suburb: 'DARLING DOWNS', state: 'WA' },
  { postCode: '6122', suburb: 'KARRAKUP', state: 'WA' },
  { postCode: '6123', suburb: 'MUNDIJONG', state: 'WA' },
  { postCode: '6123', suburb: 'WHITBY', state: 'WA' },
  { postCode: '6124', suburb: 'JARRAHDALE', state: 'WA' },
  { postCode: '6125', suburb: 'HOPELAND', state: 'WA' },
  { postCode: '6125', suburb: 'MARDELLA', state: 'WA' },
  { postCode: '6125', suburb: 'SERPENTINE', state: 'WA' },
  { postCode: '6126', suburb: 'KEYSBROOK', state: 'WA' },
  { postCode: '6147', suburb: 'LANGFORD', state: 'WA' },
  { postCode: '6147', suburb: 'LYNWOOD', state: 'WA' },
  { postCode: '6147', suburb: 'PARKWOOD', state: 'WA' },
  { postCode: '6148', suburb: 'FERNDALE', state: 'WA' },
  { postCode: '6148', suburb: 'RIVERTON', state: 'WA' },
  { postCode: '6148', suburb: 'ROSSMOYNE', state: 'WA' },
  { postCode: '6148', suburb: 'SHELLEY', state: 'WA' },
  { postCode: '6149', suburb: 'BULL CREEK', state: 'WA' },
  { postCode: '6149', suburb: 'LEEMING', state: 'WA' },
  { postCode: '6150', suburb: 'BATEMAN', state: 'WA' },
  { postCode: '6150', suburb: 'MURDOCH', state: 'WA' },
  { postCode: '6150', suburb: 'WINTHROP', state: 'WA' },
  { postCode: '6151', suburb: 'KENSINGTON', state: 'WA' },
  { postCode: '6151', suburb: 'SOUTH PERTH', state: 'WA' },
  { postCode: '6151', suburb: 'SOUTH PERTH ANGELO ST', state: 'WA' },
  { postCode: '6152', suburb: 'COMO', state: 'WA' },
  { postCode: '6152', suburb: 'KARAWARA', state: 'WA' },
  { postCode: '6152', suburb: 'MANNING', state: 'WA' },
  { postCode: '6152', suburb: 'SALTER POINT', state: 'WA' },
  { postCode: '6152', suburb: 'WATERFORD', state: 'WA' },
  { postCode: '6153', suburb: 'APPLECROSS', state: 'WA' },
  { postCode: '6153', suburb: 'APPLECROSS NORTH', state: 'WA' },
  { postCode: '6153', suburb: 'ARDROSS', state: 'WA' },
  { postCode: '6153', suburb: 'BRENTWOOD', state: 'WA' },
  { postCode: '6153', suburb: 'CANNING BRIDGE APPLECROSS', state: 'WA' },
  { postCode: '6153', suburb: 'MOUNT PLEASANT', state: 'WA' },
  { postCode: '6154', suburb: 'ALFRED COVE', state: 'WA' },
  { postCode: '6154', suburb: 'BOORAGOON', state: 'WA' },
  { postCode: '6154', suburb: 'MYAREE', state: 'WA' },
  { postCode: '6155', suburb: 'CANNING VALE', state: 'WA' },
  { postCode: '6155', suburb: 'CANNING VALE DC', state: 'WA' },
  { postCode: '6155', suburb: 'CANNING VALE SOUTH', state: 'WA' },
  { postCode: '6155', suburb: 'WILLETTON', state: 'WA' },
  { postCode: '6156', suburb: 'ATTADALE', state: 'WA' },
  { postCode: '6156', suburb: 'MELVILLE', state: 'WA' },
  { postCode: '6156', suburb: 'WILLAGEE', state: 'WA' },
  { postCode: '6156', suburb: 'WILLAGEE CENTRAL', state: 'WA' },
  { postCode: '6157', suburb: 'BICTON', state: 'WA' },
  { postCode: '6157', suburb: 'PALMYRA', state: 'WA' },
  { postCode: '6157', suburb: 'PALMYRA DC', state: 'WA' },
  { postCode: '6158', suburb: 'EAST FREMANTLE', state: 'WA' },
  { postCode: '6159', suburb: 'NORTH FREMANTLE', state: 'WA' },
  { postCode: '6160', suburb: 'FREMANTLE', state: 'WA' },
  { postCode: '6161', suburb: 'ROTTNEST ISLAND', state: 'WA' },
  { postCode: '6162', suburb: 'BEACONSFIELD', state: 'WA' },
  { postCode: '6162', suburb: 'SOUTH FREMANTLE', state: 'WA' },
  { postCode: '6162', suburb: 'WHITE GUM VALLEY', state: 'WA' },
  { postCode: '6163', suburb: 'BIBRA LAKE', state: 'WA' },
  { postCode: '6163', suburb: 'BIBRA LAKE DC', state: 'WA' },
  { postCode: '6163', suburb: 'COOLBELLUP', state: 'WA' },
  { postCode: '6163', suburb: 'HAMILTON HILL', state: 'WA' },
  { postCode: '6163', suburb: 'HILTON', state: 'WA' },
  { postCode: '6163', suburb: 'KARDINYA', state: 'WA' },
  { postCode: '6163', suburb: 'NORTH COOGEE', state: 'WA' },
  { postCode: '6163', suburb: 'NORTH LAKE', state: 'WA' },
  { postCode: '6163', suburb: "O'CONNOR", state: 'WA' },
  { postCode: '6163', suburb: 'SAMSON', state: 'WA' },
  { postCode: '6163', suburb: 'SPEARWOOD', state: 'WA' },
  { postCode: '6164', suburb: 'ATWELL', state: 'WA' },
  { postCode: '6164', suburb: 'AUBIN GROVE', state: 'WA' },
  { postCode: '6164', suburb: 'BANJUP', state: 'WA' },
  { postCode: '6164', suburb: 'BEELIAR', state: 'WA' },
  { postCode: '6164', suburb: 'COCKBURN CENTRAL', state: 'WA' },
  { postCode: '6164', suburb: 'HAMMOND PARK', state: 'WA' },
  { postCode: '6164', suburb: 'JANDAKOT', state: 'WA' },
  { postCode: '6164', suburb: 'SOUTH LAKE', state: 'WA' },
  { postCode: '6164', suburb: 'SUCCESS', state: 'WA' },
  { postCode: '6164', suburb: 'TREEBY', state: 'WA' },
  { postCode: '6164', suburb: 'YANGEBUP', state: 'WA' },
  { postCode: '6165', suburb: 'HOPE VALLEY', state: 'WA' },
  { postCode: '6165', suburb: 'NAVAL BASE', state: 'WA' },
  { postCode: '6166', suburb: 'COOGEE', state: 'WA' },
  { postCode: '6166', suburb: 'HENDERSON', state: 'WA' },
  { postCode: '6166', suburb: 'LAKE COOGEE', state: 'WA' },
  { postCode: '6166', suburb: 'MUNSTER', state: 'WA' },
  { postCode: '6166', suburb: 'WATTLEUP', state: 'WA' },
  { postCode: '6167', suburb: 'ANKETELL', state: 'WA' },
  { postCode: '6167', suburb: 'BERTRAM', state: 'WA' },
  { postCode: '6167', suburb: 'CALISTA', state: 'WA' },
  { postCode: '6167', suburb: 'CASUARINA', state: 'WA' },
  { postCode: '6167', suburb: 'KWINANA BEACH', state: 'WA' },
  { postCode: '6167', suburb: 'KWINANA TOWN CENTRE', state: 'WA' },
  { postCode: '6167', suburb: 'MANDOGALUP', state: 'WA' },
  { postCode: '6167', suburb: 'MEDINA', state: 'WA' },
  { postCode: '6167', suburb: 'ORELIA', state: 'WA' },
  { postCode: '6167', suburb: 'PARMELIA', state: 'WA' },
  { postCode: '6167', suburb: 'POSTANS', state: 'WA' },
  { postCode: '6167', suburb: 'THE SPECTACLES', state: 'WA' },
  { postCode: '6167', suburb: 'WANDI', state: 'WA' },
  { postCode: '6168', suburb: 'COOLOONGUP', state: 'WA' },
  { postCode: '6168', suburb: 'EAST ROCKINGHAM', state: 'WA' },
  { postCode: '6168', suburb: 'GARDEN ISLAND', state: 'WA' },
  { postCode: '6168', suburb: 'HILLMAN', state: 'WA' },
  { postCode: '6168', suburb: 'PERON', state: 'WA' },
  { postCode: '6168', suburb: 'ROCKINGHAM', state: 'WA' },
  { postCode: '6168', suburb: 'ROCKINGHAM BEACH', state: 'WA' },
  { postCode: '6168', suburb: 'ROCKINGHAM DC', state: 'WA' },
  { postCode: '6169', suburb: 'SAFETY BAY', state: 'WA' },
  { postCode: '6169', suburb: 'SHOALWATER', state: 'WA' },
  { postCode: '6169', suburb: 'WAIKIKI', state: 'WA' },
  { postCode: '6169', suburb: 'WARNBRO', state: 'WA' },
  { postCode: '6170', suburb: 'LEDA', state: 'WA' },
  { postCode: '6170', suburb: 'WELLARD', state: 'WA' },
  { postCode: '6171', suburb: 'BALDIVIS', state: 'WA' },
  { postCode: '6172', suburb: 'PORT KENNEDY', state: 'WA' },
  { postCode: '6173', suburb: 'SECRET HARBOUR', state: 'WA' },
  { postCode: '6174', suburb: 'GOLDEN BAY', state: 'WA' },
  { postCode: '6175', suburb: 'SINGLETON', state: 'WA' },
  { postCode: '6176', suburb: 'KARNUP', state: 'WA' },
  { postCode: '6180', suburb: 'LAKELANDS', state: 'WA' },
  { postCode: '6180', suburb: 'PARKLANDS', state: 'WA' },
  { postCode: '6181', suburb: 'STAKE HILL', state: 'WA' },
  { postCode: '6182', suburb: 'KERALUP', state: 'WA' },
  { postCode: '6207', suburb: 'MYARA', state: 'WA' },
  { postCode: '6207', suburb: 'NAMBEELUP', state: 'WA' },
  { postCode: '6207', suburb: 'NORTH DANDALUP', state: 'WA' },
  { postCode: '6207', suburb: 'SOLUS', state: 'WA' },
  { postCode: '6207', suburb: 'WHITTAKER', state: 'WA' },
  { postCode: '6208', suburb: 'BLYTHEWOOD', state: 'WA' },
  { postCode: '6208', suburb: 'FAIRBRIDGE', state: 'WA' },
  { postCode: '6208', suburb: 'MEELON', state: 'WA' },
  { postCode: '6208', suburb: 'NIRIMBA', state: 'WA' },
  { postCode: '6208', suburb: 'NORTH YUNDERUP', state: 'WA' },
  { postCode: '6208', suburb: 'OAKLEY', state: 'WA' },
  { postCode: '6208', suburb: 'PINJARRA', state: 'WA' },
  { postCode: '6208', suburb: 'POINT GREY', state: 'WA' },
  { postCode: '6208', suburb: 'RAVENSWOOD', state: 'WA' },
  { postCode: '6208', suburb: 'SOUTH YUNDERUP', state: 'WA' },
  { postCode: '6208', suburb: 'WEST PINJARRA', state: 'WA' },
  { postCode: '6209', suburb: 'BARRAGUP', state: 'WA' },
  { postCode: '6209', suburb: 'FURNISSDALE', state: 'WA' },
  { postCode: '6210', suburb: 'COODANUP', state: 'WA' },
  { postCode: '6210', suburb: 'DUDLEY PARK', state: 'WA' },
  { postCode: '6210', suburb: 'ERSKINE', state: 'WA' },
  { postCode: '6210', suburb: 'FALCON', state: 'WA' },
  { postCode: '6210', suburb: 'GREENFIELDS', state: 'WA' },
  { postCode: '6210', suburb: 'HALLS HEAD', state: 'WA' },
  { postCode: '6210', suburb: 'MADORA BAY', state: 'WA' },
  { postCode: '6210', suburb: 'MANDURAH', state: 'WA' },
  { postCode: '6210', suburb: 'MANDURAH DC', state: 'WA' },
  { postCode: '6210', suburb: 'MANDURAH EAST', state: 'WA' },
  { postCode: '6210', suburb: 'MANDURAH NORTH', state: 'WA' },
  { postCode: '6210', suburb: 'MEADOW SPRINGS', state: 'WA' },
  { postCode: '6210', suburb: 'SAN REMO', state: 'WA' },
  { postCode: '6210', suburb: 'SILVER SANDS', state: 'WA' },
  { postCode: '6210', suburb: 'WANNANUP', state: 'WA' },
  { postCode: '6211', suburb: 'BOUVARD', state: 'WA' },
  { postCode: '6211', suburb: 'CLIFTON', state: 'WA' },
  { postCode: '6211', suburb: 'DAWESVILLE', state: 'WA' },
  { postCode: '6211', suburb: 'HERRON', state: 'WA' },
  { postCode: '6213', suburb: 'BANKSIADALE', state: 'WA' },
  { postCode: '6213', suburb: 'DWELLINGUP', state: 'WA' },
  { postCode: '6213', suburb: 'ETMILYN', state: 'WA' },
  { postCode: '6213', suburb: 'HOLYOAKE', state: 'WA' },
  { postCode: '6213', suburb: 'INGLEHOPE', state: 'WA' },
  { postCode: '6213', suburb: 'MARRINUP', state: 'WA' },
  { postCode: '6213', suburb: 'TEESDALE', state: 'WA' },
  { postCode: '6214', suburb: 'BIRCHMONT', state: 'WA' },
  { postCode: '6214', suburb: 'COOLUP', state: 'WA' },
  { postCode: '6214', suburb: 'WEST COOLUP', state: 'WA' },
  { postCode: '6215', suburb: 'HAMEL', state: 'WA' },
  { postCode: '6215', suburb: 'LAKE CLIFTON', state: 'WA' },
  { postCode: '6215', suburb: 'NANGA BROOK', state: 'WA' },
  { postCode: '6215', suburb: 'PRESTON BEACH', state: 'WA' },
  { postCode: '6215', suburb: 'WAGERUP', state: 'WA' },
  { postCode: '6215', suburb: 'WAROONA', state: 'WA' },
  { postCode: '6218', suburb: 'YARLOOP', state: 'WA' },
  { postCode: '6219', suburb: 'COOKERNUP', state: 'WA' },
  { postCode: '6220', suburb: 'HARVEY', state: 'WA' },
  { postCode: '6220', suburb: 'HOFFMAN', state: 'WA' },
  { postCode: '6220', suburb: 'MYALUP', state: 'WA' },
  { postCode: '6220', suburb: 'UDUC', state: 'WA' },
  { postCode: '6220', suburb: 'WARAWARRUP', state: 'WA' },
  { postCode: '6221', suburb: 'MORNINGTON', state: 'WA' },
  { postCode: '6221', suburb: 'WOKALUP', state: 'WA' },
  { postCode: '6223', suburb: 'BENGER', state: 'WA' },
  { postCode: '6224', suburb: 'BEELA', state: 'WA' },
  { postCode: '6224', suburb: 'BRUNSWICK', state: 'WA' },
  { postCode: '6225', suburb: 'ALLANSON', state: 'WA' },
  { postCode: '6225', suburb: 'BOWELLING', state: 'WA' },
  { postCode: '6225', suburb: 'BUCKINGHAM', state: 'WA' },
  { postCode: '6225', suburb: 'CARDIFF', state: 'WA' },
  { postCode: '6225', suburb: 'COLLIE', state: 'WA' },
  { postCode: '6225', suburb: 'COLLIE BURN', state: 'WA' },
  { postCode: '6225', suburb: 'HARRIS RIVER', state: 'WA' },
  { postCode: '6225', suburb: 'LYALLS MILL', state: 'WA' },
  { postCode: '6225', suburb: 'MCALINDEN', state: 'WA' },
  { postCode: '6225', suburb: 'MUJA', state: 'WA' },
  { postCode: '6225', suburb: 'MUMBALLUP', state: 'WA' },
  { postCode: '6225', suburb: 'MUNGALUP', state: 'WA' },
  { postCode: '6225', suburb: 'NOGGERUP', state: 'WA' },
  { postCode: '6225', suburb: 'PALMER', state: 'WA' },
  { postCode: '6225', suburb: 'PRESTON SETTLEMENT', state: 'WA' },
  { postCode: '6225', suburb: 'SHOTTS', state: 'WA' },
  { postCode: '6225', suburb: 'WORSLEY', state: 'WA' },
  { postCode: '6225', suburb: 'YOURDAMUNG LAKE', state: 'WA' },
  { postCode: '6226', suburb: 'ROELANDS', state: 'WA' },
  { postCode: '6227', suburb: 'BUREKUP', state: 'WA' },
  { postCode: '6228', suburb: 'WATERLOO', state: 'WA' },
  { postCode: '6229', suburb: 'PICTON', state: 'WA' },
  { postCode: '6229', suburb: 'PICTON EAST', state: 'WA' },
  { postCode: '6230', suburb: 'BUNBURY', state: 'WA' },
  { postCode: '6230', suburb: 'CAREY PARK', state: 'WA' },
  { postCode: '6230', suburb: 'COLLEGE GROVE', state: 'WA' },
  { postCode: '6230', suburb: 'DALYELLUP', state: 'WA' },
  { postCode: '6230', suburb: 'DAVENPORT', state: 'WA' },
  { postCode: '6230', suburb: 'EAST BUNBURY', state: 'WA' },
  { postCode: '6230', suburb: 'GELORUP', state: 'WA' },
  { postCode: '6230', suburb: 'GLEN IRIS', state: 'WA' },
  { postCode: '6230', suburb: 'PELICAN POINT', state: 'WA' },
  { postCode: '6230', suburb: 'SOUTH BUNBURY', state: 'WA' },
  { postCode: '6230', suburb: 'USHER', state: 'WA' },
  { postCode: '6230', suburb: 'VITTORIA', state: 'WA' },
  { postCode: '6230', suburb: 'WITHERS', state: 'WA' },
  { postCode: '6231', suburb: 'BUNBURY', state: 'WA' },
  { postCode: '6232', suburb: 'EATON', state: 'WA' },
  { postCode: '6232', suburb: 'MILLBRIDGE', state: 'WA' },
  { postCode: '6233', suburb: 'AUSTRALIND', state: 'WA' },
  { postCode: '6233', suburb: 'BINNINGUP', state: 'WA' },
  { postCode: '6233', suburb: 'LESCHENAULT', state: 'WA' },
  { postCode: '6233', suburb: 'PARKFIELD', state: 'WA' },
  { postCode: '6233', suburb: 'WELLESLEY', state: 'WA' },
  { postCode: '6236', suburb: 'CROOKED BROOK', state: 'WA' },
  { postCode: '6236', suburb: 'DARDANUP', state: 'WA' },
  { postCode: '6236', suburb: 'DARDANUP WEST', state: 'WA' },
  { postCode: '6236', suburb: 'FERGUSON', state: 'WA' },
  { postCode: '6236', suburb: 'HENTY', state: 'WA' },
  { postCode: '6236', suburb: 'PARADISE', state: 'WA' },
  { postCode: '6236', suburb: 'WELLINGTON FOREST', state: 'WA' },
  { postCode: '6236', suburb: 'WELLINGTON MILL', state: 'WA' },
  { postCode: '6237', suburb: 'BOYANUP', state: 'WA' },
  { postCode: '6237', suburb: 'ELGIN', state: 'WA' },
  { postCode: '6237', suburb: 'GWINDINUP', state: 'WA' },
  { postCode: '6237', suburb: 'NORTH BOYANUP', state: 'WA' },
  { postCode: '6237', suburb: 'STRATHAM', state: 'WA' },
  { postCode: '6237', suburb: 'THE PLAINS', state: 'WA' },
  { postCode: '6239', suburb: 'ARGYLE', state: 'WA' },
  { postCode: '6239', suburb: 'BEELERUP', state: 'WA' },
  { postCode: '6239', suburb: 'BROOKHAMPTON', state: 'WA' },
  { postCode: '6239', suburb: 'CHARLEY CREEK', state: 'WA' },
  { postCode: '6239', suburb: 'DONNYBROOK', state: 'WA' },
  { postCode: '6239', suburb: 'GLEN MERVYN', state: 'WA' },
  { postCode: '6239', suburb: 'PAYNEDALE', state: 'WA' },
  { postCode: '6239', suburb: 'QUEENWOOD', state: 'WA' },
  { postCode: '6239', suburb: 'THOMSON BROOK', state: 'WA' },
  { postCode: '6239', suburb: 'UPPER CAPEL', state: 'WA' },
  { postCode: '6239', suburb: 'YABBERUP', state: 'WA' },
  { postCode: '6240', suburb: 'LOWDEN', state: 'WA' },
  { postCode: '6243', suburb: 'WILGA', state: 'WA' },
  { postCode: '6243', suburb: 'WILGA WEST', state: 'WA' },
  { postCode: '6244', suburb: 'BOYUP BROOK', state: 'WA' },
  { postCode: '6244', suburb: 'CHOWERUP', state: 'WA' },
  { postCode: '6244', suburb: 'DINNINUP', state: 'WA' },
  { postCode: '6244', suburb: 'KULIKUP', state: 'WA' },
  { postCode: '6244', suburb: 'MAYANUP', state: 'WA' },
  { postCode: '6244', suburb: 'SCOTTS BROOK', state: 'WA' },
  { postCode: '6244', suburb: 'TONEBRIDGE', state: 'WA' },
  { postCode: '6244', suburb: 'TRIGWELL', state: 'WA' },
  { postCode: '6251', suburb: 'BRAZIER', state: 'WA' },
  { postCode: '6251', suburb: 'KIRUP', state: 'WA' },
  { postCode: '6251', suburb: 'NEWLANDS', state: 'WA' },
  { postCode: '6252', suburb: 'MULLALYUP', state: 'WA' },
  { postCode: '6253', suburb: 'BALINGUP', state: 'WA' },
  { postCode: '6253', suburb: 'GRIMWADE', state: 'WA' },
  { postCode: '6253', suburb: 'SOUTHAMPTON', state: 'WA' },
  { postCode: '6254', suburb: 'GREENBUSHES', state: 'WA' },
  { postCode: '6254', suburb: 'NORTH GREENBUSHES', state: 'WA' },
  { postCode: '6255', suburb: 'BENJINUP', state: 'WA' },
  { postCode: '6255', suburb: 'BRIDGETOWN', state: 'WA' },
  { postCode: '6255', suburb: 'CATTERICK', state: 'WA' },
  { postCode: '6255', suburb: 'HESTER', state: 'WA' },
  { postCode: '6255', suburb: 'HESTER BROOK', state: 'WA' },
  { postCode: '6255', suburb: 'KANGAROO GULLY', state: 'WA' },
  { postCode: '6255', suburb: 'WINNEJUP', state: 'WA' },
  { postCode: '6256', suburb: 'GLENLYNN', state: 'WA' },
  { postCode: '6256', suburb: 'KINGSTON', state: 'WA' },
  { postCode: '6256', suburb: 'MARANUP', state: 'WA' },
  { postCode: '6256', suburb: 'SUNNYSIDE', state: 'WA' },
  { postCode: '6256', suburb: 'WANDILLUP', state: 'WA' },
  { postCode: '6256', suburb: 'YORNUP', state: 'WA' },
  { postCode: '6258', suburb: 'BALBARRUP', state: 'WA' },
  { postCode: '6258', suburb: 'DEANMILL', state: 'WA' },
  { postCode: '6258', suburb: 'DIAMOND TREE', state: 'WA' },
  { postCode: '6258', suburb: 'DINGUP', state: 'WA' },
  { postCode: '6258', suburb: 'DIXVALE', state: 'WA' },
  { postCode: '6258', suburb: 'DONNELLY RIVER', state: 'WA' },
  { postCode: '6258', suburb: 'GLENORAN', state: 'WA' },
  { postCode: '6258', suburb: 'JARDEE', state: 'WA' },
  { postCode: '6258', suburb: 'LAKE MUIR', state: 'WA' },
  { postCode: '6258', suburb: 'LINFARNE', state: 'WA' },
  { postCode: '6258', suburb: 'MANJIMUP', state: 'WA' },
  { postCode: '6258', suburb: 'MIDDLESEX', state: 'WA' },
  { postCode: '6258', suburb: 'MORDALUP', state: 'WA' },
  { postCode: '6258', suburb: 'PALGARUP', state: 'WA' },
  { postCode: '6258', suburb: 'PERUP', state: 'WA' },
  { postCode: '6258', suburb: 'QUINNINUP', state: 'WA' },
  { postCode: '6258', suburb: 'RINGBARK', state: 'WA' },
  { postCode: '6258', suburb: 'SMITH BROOK', state: 'WA' },
  { postCode: '6258', suburb: 'UPPER WARREN', state: 'WA' },
  { postCode: '6258', suburb: 'WILGARRUP', state: 'WA' },
  { postCode: '6258', suburb: 'YANMAH', state: 'WA' },
  { postCode: '6260', suburb: 'BEEDELUP', state: 'WA' },
  { postCode: '6260', suburb: 'BIDDELIA', state: 'WA' },
  { postCode: '6260', suburb: 'CALLCUP', state: 'WA' },
  { postCode: '6260', suburb: 'CHANNYBEARUP', state: 'WA' },
  { postCode: '6260', suburb: 'COLLINS', state: 'WA' },
  { postCode: '6260', suburb: 'EASTBROOK', state: 'WA' },
  { postCode: '6260', suburb: 'LAKE JASPER', state: 'WA' },
  { postCode: '6260', suburb: 'PEERABEELUP', state: 'WA' },
  { postCode: '6260', suburb: 'PEMBERTON', state: 'WA' },
  { postCode: '6260', suburb: 'YEAGARUP', state: 'WA' },
  { postCode: '6262', suburb: 'BOORARA BROOK', state: 'WA' },
  { postCode: '6262', suburb: 'CROWEA', state: 'WA' },
  { postCode: '6262', suburb: 'MEERUP', state: 'WA' },
  { postCode: '6262', suburb: 'NORTHCLIFFE', state: 'WA' },
  { postCode: '6262', suburb: 'SHANNON', state: 'WA' },
  { postCode: '6262', suburb: 'WINDY HARBOUR', state: 'WA' },
  { postCode: '6271', suburb: 'CAPEL', state: 'WA' },
  { postCode: '6271', suburb: 'CAPEL RIVER', state: 'WA' },
  { postCode: '6271', suburb: 'FORREST BEACH', state: 'WA' },
  { postCode: '6271', suburb: 'PEPPERMINT GROVE BEACH', state: 'WA' },
  { postCode: '6271', suburb: 'STIRLING ESTATE', state: 'WA' },
  { postCode: '6275', suburb: 'BARRABUP', state: 'WA' },
  { postCode: '6275', suburb: 'CARLOTTA', state: 'WA' },
  { postCode: '6275', suburb: 'CUNDINUP', state: 'WA' },
  { postCode: '6275', suburb: 'DARRADUP', state: 'WA' },
  { postCode: '6275', suburb: 'EAST NANNUP', state: 'WA' },
  { postCode: '6275', suburb: 'JALBARRAGUP', state: 'WA' },
  { postCode: '6275', suburb: 'JARRAHWOOD', state: 'WA' },
  { postCode: '6275', suburb: 'NANNUP', state: 'WA' },
  { postCode: '6275', suburb: 'SCOTT RIVER EAST', state: 'WA' },
  { postCode: '6275', suburb: 'YOGANUP', state: 'WA' },
  { postCode: '6280', suburb: 'ABBA RIVER', state: 'WA' },
  { postCode: '6280', suburb: 'ABBEY', state: 'WA' },
  { postCode: '6280', suburb: 'ACTON PARK', state: 'WA' },
  { postCode: '6280', suburb: 'AMBERGATE', state: 'WA' },
  { postCode: '6280', suburb: 'ANNIEBROOK', state: 'WA' },
  { postCode: '6280', suburb: 'BOALLIA', state: 'WA' },
  { postCode: '6280', suburb: 'BOVELL', state: 'WA' },
  { postCode: '6280', suburb: 'BROADWATER', state: 'WA' },
  { postCode: '6280', suburb: 'BUSSELTON', state: 'WA' },
  { postCode: '6280', suburb: 'CARBUNUP RIVER', state: 'WA' },
  { postCode: '6280', suburb: 'CHAPMAN HILL', state: 'WA' },
  { postCode: '6280', suburb: 'GEOGRAPHE', state: 'WA' },
  { postCode: '6280', suburb: 'HITHERGREEN', state: 'WA' },
  { postCode: '6280', suburb: 'JINDONG', state: 'WA' },
  { postCode: '6280', suburb: 'KALGUP', state: 'WA' },
  { postCode: '6280', suburb: 'KALOORUP', state: 'WA' },
  { postCode: '6280', suburb: 'KEALY', state: 'WA' },
  { postCode: '6280', suburb: 'LUDLOW', state: 'WA' },
  { postCode: '6280', suburb: 'MARYBROOK', state: 'WA' },
  { postCode: '6280', suburb: 'METRICUP', state: 'WA' },
  { postCode: '6280', suburb: 'NORTH JINDONG', state: 'WA' },
  { postCode: '6280', suburb: 'REINSCOURT', state: 'WA' },
  { postCode: '6280', suburb: 'RUABON', state: 'WA' },
  { postCode: '6280', suburb: 'SABINA RIVER', state: 'WA' },
  { postCode: '6280', suburb: 'SIESTA PARK', state: 'WA' },
  { postCode: '6280', suburb: 'TUTUNUP', state: 'WA' },
  { postCode: '6280', suburb: 'VASSE', state: 'WA' },
  { postCode: '6280', suburb: 'WALSALL', state: 'WA' },
  { postCode: '6280', suburb: 'WEST BUSSELTON', state: 'WA' },
  { postCode: '6280', suburb: 'WILYABRUP', state: 'WA' },
  { postCode: '6280', suburb: 'WONNERUP', state: 'WA' },
  { postCode: '6280', suburb: 'YALYALUP', state: 'WA' },
  { postCode: '6280', suburb: 'YELVERTON', state: 'WA' },
  { postCode: '6280', suburb: 'YOONGARILLUP', state: 'WA' },
  { postCode: '6281', suburb: 'DUNSBOROUGH', state: 'WA' },
  { postCode: '6281', suburb: 'EAGLE BAY', state: 'WA' },
  { postCode: '6281', suburb: 'NATURALISTE', state: 'WA' },
  { postCode: '6281', suburb: 'QUEDJINUP', state: 'WA' },
  { postCode: '6281', suburb: 'QUINDALUP', state: 'WA' },
  { postCode: '6282', suburb: 'YALLINGUP', state: 'WA' },
  { postCode: '6282', suburb: 'YALLINGUP SIDING', state: 'WA' },
  { postCode: '6284', suburb: 'BAUDIN', state: 'WA' },
  { postCode: '6284', suburb: 'COWARAMUP', state: 'WA' },
  { postCode: '6284', suburb: 'GRACETOWN', state: 'WA' },
  { postCode: '6284', suburb: 'TREETON', state: 'WA' },
  { postCode: '6285', suburb: 'BRAMLEY', state: 'WA' },
  { postCode: '6285', suburb: 'BURNSIDE', state: 'WA' },
  { postCode: '6285', suburb: 'GNARABUP', state: 'WA' },
  { postCode: '6285', suburb: 'MARGARET RIVER', state: 'WA' },
  { postCode: '6285', suburb: 'OSMINGTON', state: 'WA' },
  { postCode: '6285', suburb: 'PREVELLY', state: 'WA' },
  { postCode: '6285', suburb: 'ROSA BROOK', state: 'WA' },
  { postCode: '6285', suburb: 'ROSA GLEN', state: 'WA' },
  { postCode: '6285', suburb: 'SCHROEDER', state: 'WA' },
  { postCode: '6286', suburb: 'BORANUP', state: 'WA' },
  { postCode: '6286', suburb: 'FOREST GROVE', state: 'WA' },
  { postCode: '6286', suburb: 'REDGATE', state: 'WA' },
  { postCode: '6286', suburb: 'WITCHCLIFFE', state: 'WA' },
  { postCode: '6288', suburb: 'ALEXANDRA BRIDGE', state: 'WA' },
  { postCode: '6288', suburb: 'COURTENAY', state: 'WA' },
  { postCode: '6288', suburb: 'HAMELIN BAY', state: 'WA' },
  { postCode: '6288', suburb: 'KARRIDALE', state: 'WA' },
  { postCode: '6288', suburb: 'NILLUP', state: 'WA' },
  { postCode: '6288', suburb: 'SCOTT RIVER', state: 'WA' },
  { postCode: '6288', suburb: 'WARNER GLEN', state: 'WA' },
  { postCode: '6290', suburb: 'AUGUSTA', state: 'WA' },
  { postCode: '6290', suburb: 'DEEPDENE', state: 'WA' },
  { postCode: '6290', suburb: 'EAST AUGUSTA', state: 'WA' },
  { postCode: '6290', suburb: 'KUDARDUP', state: 'WA' },
  { postCode: '6290', suburb: 'LEEUWIN', state: 'WA' },
  { postCode: '6290', suburb: 'MOLLOY ISLAND', state: 'WA' },
  { postCode: '6302', suburb: 'BADGIN', state: 'WA' },
  { postCode: '6302', suburb: 'BALLADONG', state: 'WA' },
  { postCode: '6302', suburb: 'BURGES', state: 'WA' },
  { postCode: '6302', suburb: 'CALJIE', state: 'WA' },
  { postCode: '6302', suburb: 'COLD HARBOUR', state: 'WA' },
  { postCode: '6302', suburb: 'DALIAK', state: 'WA' },
  { postCode: '6302', suburb: 'FLINT', state: 'WA' },
  { postCode: '6302', suburb: 'FLYNN', state: 'WA' },
  { postCode: '6302', suburb: 'GILGERING', state: 'WA' },
  { postCode: '6302', suburb: 'GREENHILLS', state: 'WA' },
  { postCode: '6302', suburb: 'GWAMBYGINE', state: 'WA' },
  { postCode: '6302', suburb: 'INKPEN', state: 'WA' },
  { postCode: '6302', suburb: 'KAURING', state: 'WA' },
  { postCode: '6302', suburb: 'MALEBELLING', state: 'WA' },
  { postCode: '6302', suburb: 'MOUNT HARDEY', state: 'WA' },
  { postCode: '6302', suburb: 'MOUNT OBSERVATION', state: 'WA' },
  { postCode: '6302', suburb: 'NARRALOGGAN', state: 'WA' },
  { postCode: '6302', suburb: 'QUELLINGTON', state: 'WA' },
  { postCode: '6302', suburb: 'ST RONANS', state: 'WA' },
  { postCode: '6302', suburb: 'TALBOT', state: 'WA' },
  { postCode: '6302', suburb: 'TALBOT WEST', state: 'WA' },
  { postCode: '6302', suburb: 'WILBERFORCE', state: 'WA' },
  { postCode: '6302', suburb: 'YORK', state: 'WA' },
  { postCode: '6304', suburb: 'BALLY BALLY', state: 'WA' },
  { postCode: '6304', suburb: 'BEVERLEY', state: 'WA' },
  { postCode: '6304', suburb: 'DALE', state: 'WA' },
  { postCode: '6304', suburb: 'EAST BEVERLEY', state: 'WA' },
  { postCode: '6304', suburb: 'KOKEBY', state: 'WA' },
  { postCode: '6304', suburb: 'MORBINNING', state: 'WA' },
  { postCode: '6304', suburb: 'WESTDALE', state: 'WA' },
  { postCode: '6306', suburb: 'ALDERSYDE', state: 'WA' },
  { postCode: '6306', suburb: 'BROOKTON', state: 'WA' },
  { postCode: '6306', suburb: 'BULYEE', state: 'WA' },
  { postCode: '6306', suburb: 'JELCOBINE', state: 'WA' },
  { postCode: '6306', suburb: 'KWEDA', state: 'WA' },
  { postCode: '6308', suburb: 'CODJATOTINE', state: 'WA' },
  { postCode: '6308', suburb: 'DWARDA', state: 'WA' },
  { postCode: '6308', suburb: 'EAST PINGELLY', state: 'WA' },
  { postCode: '6308', suburb: 'GILLIMANNING', state: 'WA' },
  { postCode: '6308', suburb: 'HASTINGS', state: 'WA' },
  { postCode: '6308', suburb: 'PINGELLY', state: 'WA' },
  { postCode: '6308', suburb: 'PUMPHREYS BRIDGE', state: 'WA' },
  { postCode: '6308', suburb: 'SPRINGS', state: 'WA' },
  { postCode: '6308', suburb: 'WANDERING', state: 'WA' },
  { postCode: '6308', suburb: 'WEST PINGELLY', state: 'WA' },
  { postCode: '6309', suburb: 'EAST POPANYINNING', state: 'WA' },
  { postCode: '6309', suburb: 'POPANYINNING', state: 'WA' },
  { postCode: '6309', suburb: 'STRATHERNE', state: 'WA' },
  { postCode: '6309', suburb: 'WEST POPANYINNING', state: 'WA' },
  { postCode: '6311', suburb: 'COMMODINE', state: 'WA' },
  { postCode: '6311', suburb: 'CONTINE', state: 'WA' },
  { postCode: '6311', suburb: 'CUBALLING', state: 'WA' },
  { postCode: '6311', suburb: 'DRYANDRA', state: 'WA' },
  { postCode: '6311', suburb: 'LOL GRAY', state: 'WA' },
  { postCode: '6311', suburb: 'TOWNSENDALE', state: 'WA' },
  { postCode: '6311', suburb: 'WARDERING', state: 'WA' },
  { postCode: '6311', suburb: 'YORNANING', state: 'WA' },
  { postCode: '6312', suburb: 'BOUNDAIN', state: 'WA' },
  { postCode: '6312', suburb: 'DUMBERNING', state: 'WA' },
  { postCode: '6312', suburb: 'HILLSIDE', state: 'WA' },
  { postCode: '6312', suburb: 'MINIGIN', state: 'WA' },
  { postCode: '6312', suburb: 'NARROGIN', state: 'WA' },
  { postCode: '6312', suburb: 'NARROGIN VALLEY', state: 'WA' },
  { postCode: '6312', suburb: 'NOMANS LAKE', state: 'WA' },
  { postCode: '6312', suburb: 'TOOLIBIN', state: 'WA' },
  { postCode: '6312', suburb: 'YILLIMINNING', state: 'WA' },
  { postCode: '6313', suburb: 'HIGHBURY', state: 'WA' },
  { postCode: '6315', suburb: 'ARTHUR RIVER', state: 'WA' },
  { postCode: '6315', suburb: 'BALLAYING', state: 'WA' },
  { postCode: '6315', suburb: 'CANCANNING', state: 'WA' },
  { postCode: '6315', suburb: 'COLLANILLING', state: 'WA' },
  { postCode: '6315', suburb: 'DONGOLOCKING', state: 'WA' },
  { postCode: '6315', suburb: 'GUNDARING', state: 'WA' },
  { postCode: '6315', suburb: 'JALORAN', state: 'WA' },
  { postCode: '6315', suburb: 'LIME LAKE', state: 'WA' },
  { postCode: '6315', suburb: 'MINDING', state: 'WA' },
  { postCode: '6315', suburb: 'PIESSEVILLE', state: 'WA' },
  { postCode: '6315', suburb: 'WAGIN', state: 'WA' },
  { postCode: '6315', suburb: 'WEDGECARRUP', state: 'WA' },
  { postCode: '6316', suburb: 'BOYERINE', state: 'WA' },
  { postCode: '6316', suburb: 'CARTMETICUP', state: 'WA' },
  { postCode: '6316', suburb: 'GLENCOE', state: 'WA' },
  { postCode: '6316', suburb: 'KENMARE', state: 'WA' },
  { postCode: '6316', suburb: 'WESTWOOD', state: 'WA' },
  { postCode: '6316', suburb: 'WOODANILLING', state: 'WA' },
  { postCode: '6317', suburb: 'BADGEBUP', state: 'WA' },
  { postCode: '6317', suburb: 'BULLOCK HILLS', state: 'WA' },
  { postCode: '6317', suburb: 'CARROLUP', state: 'WA' },
  { postCode: '6317', suburb: 'COBLININE', state: 'WA' },
  { postCode: '6317', suburb: 'COYRECUP', state: 'WA' },
  { postCode: '6317', suburb: 'DATATINE', state: 'WA' },
  { postCode: '6317', suburb: 'EWLYAMARTUP', state: 'WA' },
  { postCode: '6317', suburb: 'KATANNING', state: 'WA' },
  { postCode: '6317', suburb: 'MARRACOONDA', state: 'WA' },
  { postCode: '6317', suburb: 'MOOJEBING', state: 'WA' },
  { postCode: '6317', suburb: 'MURDONG', state: 'WA' },
  { postCode: '6317', suburb: 'PINWERNYING', state: 'WA' },
  { postCode: '6317', suburb: 'SOUTH DATATINE', state: 'WA' },
  { postCode: '6317', suburb: 'SOUTH GLENCOE', state: 'WA' },
  { postCode: '6318', suburb: 'BROOMEHILL', state: 'WA' },
  { postCode: '6318', suburb: 'BROOMEHILL EAST', state: 'WA' },
  { postCode: '6318', suburb: 'BROOMEHILL VILLAGE', state: 'WA' },
  { postCode: '6318', suburb: 'BROOMEHILL WEST', state: 'WA' },
  { postCode: '6320', suburb: 'BOBALONG', state: 'WA' },
  { postCode: '6320', suburb: 'BORDERDALE', state: 'WA' },
  { postCode: '6320', suburb: 'DARTNALL', state: 'WA' },
  { postCode: '6320', suburb: 'LAKE TOOLBRUNUP', state: 'WA' },
  { postCode: '6320', suburb: 'MOONIES HILL', state: 'WA' },
  { postCode: '6320', suburb: 'TAMBELLUP', state: 'WA' },
  { postCode: '6320', suburb: 'WANSBROUGH', state: 'WA' },
  { postCode: '6321', suburb: 'CRANBROOK', state: 'WA' },
  { postCode: '6322', suburb: 'TENTERDEN', state: 'WA' },
  { postCode: '6323', suburb: 'KENDENUP', state: 'WA' },
  { postCode: '6324', suburb: 'DENBARKER', state: 'WA' },
  { postCode: '6324', suburb: 'FOREST HILL', state: 'WA' },
  { postCode: '6324', suburb: 'MOUNT BARKER', state: 'WA' },
  { postCode: '6324', suburb: 'PERILLUP', state: 'WA' },
  { postCode: '6324', suburb: 'PORONGURUP', state: 'WA' },
  { postCode: '6324', suburb: 'SOUTH STIRLING', state: 'WA' },
  { postCode: '6324', suburb: 'TAKALARUP', state: 'WA' },
  { postCode: '6324', suburb: 'WOOGENELLUP', state: 'WA' },
  { postCode: '6326', suburb: 'NARRIKUP', state: 'WA' },
  { postCode: '6327', suburb: 'REDMOND', state: 'WA' },
  { postCode: '6327', suburb: 'REDMOND WEST', state: 'WA' },
  { postCode: '6328', suburb: 'CHEYNES', state: 'WA' },
  { postCode: '6328', suburb: 'GNOWELLEN', state: 'WA' },
  { postCode: '6328', suburb: 'GREEN RANGE', state: 'WA' },
  { postCode: '6328', suburb: 'KOJANEERUP SOUTH', state: 'WA' },
  { postCode: '6328', suburb: 'MANYPEAKS', state: 'WA' },
  { postCode: '6328', suburb: 'METTLER', state: 'WA' },
  { postCode: '6328', suburb: 'PALMDALE', state: 'WA' },
  { postCode: '6328', suburb: 'WELLSTEAD', state: 'WA' },
  { postCode: '6330', suburb: 'ALBANY', state: 'WA' },
  { postCode: '6330', suburb: 'BAYONET HEAD', state: 'WA' },
  { postCode: '6330', suburb: 'BIG GROVE', state: 'WA' },
  { postCode: '6330', suburb: 'BORNHOLM', state: 'WA' },
  { postCode: '6330', suburb: 'CENTENNIAL PARK', state: 'WA' },
  { postCode: '6330', suburb: 'COLLINGWOOD HEIGHTS', state: 'WA' },
  { postCode: '6330', suburb: 'COLLINGWOOD PARK', state: 'WA' },
  { postCode: '6330', suburb: 'CUTHBERT', state: 'WA' },
  { postCode: '6330', suburb: 'DROME', state: 'WA' },
  { postCode: '6330', suburb: 'ELLEKER', state: 'WA' },
  { postCode: '6330', suburb: 'EMU POINT', state: 'WA' },
  { postCode: '6330', suburb: 'FRENCHMAN BAY', state: 'WA' },
  { postCode: '6330', suburb: 'GLEDHOW', state: 'WA' },
  { postCode: '6330', suburb: 'GOODE BEACH', state: 'WA' },
  { postCode: '6330', suburb: 'GREEN VALLEY', state: 'WA' },
  { postCode: '6330', suburb: 'KALGAN', state: 'WA' },
  { postCode: '6330', suburb: 'KING RIVER', state: 'WA' },
  { postCode: '6330', suburb: 'KRONKUP', state: 'WA' },
  { postCode: '6330', suburb: 'LANGE', state: 'WA' },
  { postCode: '6330', suburb: 'LITTLE GROVE', state: 'WA' },
  { postCode: '6330', suburb: 'LOCKYER', state: 'WA' },
  { postCode: '6330', suburb: 'LOWER KING', state: 'WA' },
  { postCode: '6330', suburb: 'LOWLANDS', state: 'WA' },
  { postCode: '6330', suburb: 'MARBELUP', state: 'WA' },
  { postCode: '6330', suburb: 'MCKAIL', state: 'WA' },
  { postCode: '6330', suburb: 'MIDDLETON BEACH', state: 'WA' },
  { postCode: '6330', suburb: 'MILLBROOK', state: 'WA' },
  { postCode: '6330', suburb: 'MILPARA', state: 'WA' },
  { postCode: '6330', suburb: 'MIRA MAR', state: 'WA' },
  { postCode: '6330', suburb: 'MOUNT CLARENCE', state: 'WA' },
  { postCode: '6330', suburb: 'MOUNT ELPHINSTONE', state: 'WA' },
  { postCode: '6330', suburb: 'MOUNT MELVILLE', state: 'WA' },
  { postCode: '6330', suburb: 'NANARUP', state: 'WA' },
  { postCode: '6330', suburb: 'NAPIER', state: 'WA' },
  { postCode: '6330', suburb: 'NULLAKI', state: 'WA' },
  { postCode: '6330', suburb: 'ORANA', state: 'WA' },
  { postCode: '6330', suburb: 'PORT ALBANY', state: 'WA' },
  { postCode: '6330', suburb: 'ROBINSON', state: 'WA' },
  { postCode: '6330', suburb: 'SANDPATCH', state: 'WA' },
  { postCode: '6330', suburb: 'SEPPINGS', state: 'WA' },
  { postCode: '6330', suburb: 'SPENCER PARK', state: 'WA' },
  { postCode: '6330', suburb: 'TORBAY', state: 'WA' },
  { postCode: '6330', suburb: 'TORNDIRRUP', state: 'WA' },
  { postCode: '6330', suburb: 'VANCOUVER PENINSULA', state: 'WA' },
  { postCode: '6330', suburb: 'WALMSLEY', state: 'WA' },
  { postCode: '6330', suburb: 'WARRENUP', state: 'WA' },
  { postCode: '6330', suburb: 'WEST CAPE HOWE', state: 'WA' },
  { postCode: '6330', suburb: 'WILLYUNG', state: 'WA' },
  { postCode: '6330', suburb: 'YAKAMIA', state: 'WA' },
  { postCode: '6330', suburb: 'YOUNGS SIDING', state: 'WA' },
  { postCode: '6331', suburb: 'ALBANY DC', state: 'WA' },
  { postCode: '6332', suburb: 'ALBANY PO', state: 'WA' },
  { postCode: '6333', suburb: 'BOW BRIDGE', state: 'WA' },
  { postCode: '6333', suburb: 'DENMARK', state: 'WA' },
  { postCode: '6333', suburb: 'HAY', state: 'WA' },
  { postCode: '6333', suburb: 'HAZELVALE', state: 'WA' },
  { postCode: '6333', suburb: 'KENTDALE', state: 'WA' },
  { postCode: '6333', suburb: 'KORDABUP', state: 'WA' },
  { postCode: '6333', suburb: 'MOUNT LINDESAY', state: 'WA' },
  { postCode: '6333', suburb: 'MOUNT ROMANCE', state: 'WA' },
  { postCode: '6333', suburb: 'NORNALUP', state: 'WA' },
  { postCode: '6333', suburb: 'OCEAN BEACH', state: 'WA' },
  { postCode: '6333', suburb: 'PARRYVILLE', state: 'WA' },
  { postCode: '6333', suburb: 'PEACEFUL BAY', state: 'WA' },
  { postCode: '6333', suburb: 'SCOTSDALE', state: 'WA' },
  { postCode: '6333', suburb: 'SHADFORTH', state: 'WA' },
  { postCode: '6333', suburb: 'TINGLEDALE', state: 'WA' },
  { postCode: '6333', suburb: 'TRENT', state: 'WA' },
  { postCode: '6333', suburb: 'WILLIAM BAY', state: 'WA' },
  { postCode: '6335', suburb: 'GNOWANGERUP', state: 'WA' },
  { postCode: '6335', suburb: 'JACKITUP', state: 'WA' },
  { postCode: '6335', suburb: 'KEBARINGUP', state: 'WA' },
  { postCode: '6335', suburb: 'PALLINUP', state: 'WA' },
  { postCode: '6336', suburb: 'COWALELLUP', state: 'WA' },
  { postCode: '6336', suburb: 'MILLS LAKE', state: 'WA' },
  { postCode: '6336', suburb: 'MINDARABIN', state: 'WA' },
  { postCode: '6336', suburb: 'NEEDILUP', state: 'WA' },
  { postCode: '6336', suburb: 'ONGERUP', state: 'WA' },
  { postCode: '6336', suburb: 'TOOMPUP', state: 'WA' },
  { postCode: '6337', suburb: 'FITZGERALD', state: 'WA' },
  { postCode: '6337', suburb: 'GAIRDNER', state: 'WA' },
  { postCode: '6337', suburb: 'JACUP', state: 'WA' },
  { postCode: '6337', suburb: 'JERRAMUNGUP', state: 'WA' },
  { postCode: '6337', suburb: 'WEST FITZGERALD', state: 'WA' },
  { postCode: '6338', suburb: 'AMELUP', state: 'WA' },
  { postCode: '6338', suburb: 'BORDEN', state: 'WA' },
  { postCode: '6338', suburb: 'BOXWOOD HILL', state: 'WA' },
  { postCode: '6338', suburb: 'BREMER BAY', state: 'WA' },
  { postCode: '6338', suburb: 'MAGITUP', state: 'WA' },
  { postCode: '6338', suburb: 'MONJEBUP', state: 'WA' },
  { postCode: '6338', suburb: 'NALYERLUP', state: 'WA' },
  { postCode: '6338', suburb: 'NORTH STIRLINGS', state: 'WA' },
  { postCode: '6338', suburb: 'STIRLING RANGE NATIONAL PARK', state: 'WA' },
  { postCode: '6341', suburb: 'NYABING', state: 'WA' },
  { postCode: '6343', suburb: 'PINGRUP', state: 'WA' },
  {
    postCode: '6346',
    suburb: 'FITZGERALD RIVER NATIONAL PARK',
    state: 'WA',
  },
  { postCode: '6346', suburb: 'JERDACUTTUP', state: 'WA' },
  { postCode: '6346', suburb: 'RAVENSTHORPE', state: 'WA' },
  { postCode: '6346', suburb: 'WEST RIVER', state: 'WA' },
  { postCode: '6348', suburb: 'HOPETOUN', state: 'WA' },
  { postCode: '6350', suburb: 'DUMBLEYUNG', state: 'WA' },
  { postCode: '6350', suburb: 'NAIRIBIN', state: 'WA' },
  { postCode: '6350', suburb: 'NIPPERING', state: 'WA' },
  { postCode: '6351', suburb: 'MOULYINNING', state: 'WA' },
  { postCode: '6351', suburb: 'NORTH MOULYINNING', state: 'WA' },
  { postCode: '6352', suburb: 'KUKERIN', state: 'WA' },
  { postCode: '6352', suburb: 'MERILUP', state: 'WA' },
  { postCode: '6352', suburb: 'NORTH KUKERIN', state: 'WA' },
  { postCode: '6352', suburb: 'SOUTH KUKERIN', state: 'WA' },
  { postCode: '6353', suburb: 'BEENONG', state: 'WA' },
  { postCode: '6353', suburb: 'BUNICHE', state: 'WA' },
  { postCode: '6353', suburb: 'KUENDER', state: 'WA' },
  { postCode: '6353', suburb: 'LAKE GRACE', state: 'WA' },
  { postCode: '6353', suburb: 'MALLEE HILL', state: 'WA' },
  { postCode: '6353', suburb: 'NEENDALING', state: 'WA' },
  { postCode: '6353', suburb: 'NORTH BURNGUP', state: 'WA' },
  { postCode: '6353', suburb: 'NORTH LAKE GRACE', state: 'WA' },
  { postCode: '6353', suburb: 'SOUTH LAKE GRACE', state: 'WA' },
  { postCode: '6353', suburb: 'TARIN ROCK', state: 'WA' },
  { postCode: '6355', suburb: 'DUNN ROCK', state: 'WA' },
  { postCode: '6355', suburb: 'EAST NEWDEGATE', state: 'WA' },
  { postCode: '6355', suburb: 'HOLT ROCK', state: 'WA' },
  { postCode: '6355', suburb: 'LAKE BIDDY', state: 'WA' },
  { postCode: '6355', suburb: 'LAKE CAMM', state: 'WA' },
  { postCode: '6355', suburb: 'MAGENTA', state: 'WA' },
  { postCode: '6355', suburb: 'MOUNT SHERIDAN', state: 'WA' },
  { postCode: '6355', suburb: 'NEWDEGATE', state: 'WA' },
  { postCode: '6355', suburb: 'SOUTH NEWDEGATE', state: 'WA' },
  { postCode: '6355', suburb: 'VARLEY', state: 'WA' },
  { postCode: '6356', suburb: 'HATTER HILL', state: 'WA' },
  { postCode: '6356', suburb: 'LAKE KING', state: 'WA' },
  { postCode: '6356', suburb: 'MOUNT MADDEN', state: 'WA' },
  { postCode: '6357', suburb: 'PINGARING', state: 'WA' },
  { postCode: '6358', suburb: 'KARLGARIN', state: 'WA' },
  { postCode: '6359', suburb: 'FORRESTANIA', state: 'WA' },
  { postCode: '6359', suburb: 'HYDEN', state: 'WA' },
  { postCode: '6359', suburb: 'LITTLE ITALY', state: 'WA' },
  { postCode: '6361', suburb: 'HARRISMITH', state: 'WA' },
  { postCode: '6361', suburb: 'TINCURRIN', state: 'WA' },
  { postCode: '6363', suburb: 'DUDININ', state: 'WA' },
  { postCode: '6363', suburb: 'WALYURIN', state: 'WA' },
  { postCode: '6365', suburb: 'JILAKIN', state: 'WA' },
  { postCode: '6365', suburb: 'JITARNING', state: 'WA' },
  { postCode: '6365', suburb: 'KULIN', state: 'WA' },
  { postCode: '6365', suburb: 'KULIN WEST', state: 'WA' },
  { postCode: '6367', suburb: 'KONDININ', state: 'WA' },
  { postCode: '6368', suburb: 'SOUTH KUMMININ', state: 'WA' },
  { postCode: '6369', suburb: 'MOUNT WALKER', state: 'WA' },
  { postCode: '6369', suburb: 'NAREMBEEN', state: 'WA' },
  { postCode: '6369', suburb: 'WADDERIN', state: 'WA' },
  { postCode: '6369', suburb: 'WEST HOLLETON', state: 'WA' },
  { postCode: '6369', suburb: 'WOOLOCUTTY', state: 'WA' },
  { postCode: '6370', suburb: 'EAST WICKEPIN', state: 'WA' },
  { postCode: '6370', suburb: 'MALYALLING', state: 'WA' },
  { postCode: '6370', suburb: 'WICKEPIN', state: 'WA' },
  { postCode: '6370', suburb: 'WOGOLIN', state: 'WA' },
  { postCode: '6372', suburb: 'KIRK ROCK', state: 'WA' },
  { postCode: '6372', suburb: 'YEALERING', state: 'WA' },
  { postCode: '6373', suburb: 'BULLARING', state: 'WA' },
  { postCode: '6375', suburb: 'ADAMSVALE', state: 'WA' },
  { postCode: '6375', suburb: 'BILBARIN', state: 'WA' },
  { postCode: '6375', suburb: 'CORRIGIN', state: 'WA' },
  { postCode: '6375', suburb: 'GORGE ROCK', state: 'WA' },
  { postCode: '6375', suburb: 'KUNJIN', state: 'WA' },
  { postCode: '6375', suburb: 'KURRENKUTTEN', state: 'WA' },
  { postCode: '6383', suburb: 'BADJALING', state: 'WA' },
  { postCode: '6383', suburb: 'BALKULING', state: 'WA' },
  { postCode: '6383', suburb: 'CUBBINE', state: 'WA' },
  { postCode: '6383', suburb: 'DANGIN', state: 'WA' },
  { postCode: '6383', suburb: 'DOODENANNING', state: 'WA' },
  { postCode: '6383', suburb: 'DULBELLING', state: 'WA' },
  { postCode: '6383', suburb: 'MOUNT STIRLING', state: 'WA' },
  { postCode: '6383', suburb: 'QUAIRADING', state: 'WA' },
  { postCode: '6383', suburb: 'SOUTH QUAIRADING', state: 'WA' },
  { postCode: '6383', suburb: 'WAMENUSKING', state: 'WA' },
  { postCode: '6383', suburb: 'YOTING', state: 'WA' },
  { postCode: '6384', suburb: 'PANTAPIN', state: 'WA' },
  { postCode: '6385', suburb: 'KWOLYIN', state: 'WA' },
  { postCode: '6386', suburb: 'SHACKLETON', state: 'WA' },
  { postCode: '6390', suburb: 'BANNISTER', state: 'WA' },
  { postCode: '6390', suburb: 'BODDINGTON', state: 'WA' },
  { postCode: '6390', suburb: 'CROSSMAN', state: 'WA' },
  { postCode: '6390', suburb: 'LOWER HOTHAM', state: 'WA' },
  { postCode: '6390', suburb: 'MARRADONG', state: 'WA' },
  { postCode: '6390', suburb: 'MOUNT COOKE', state: 'WA' },
  { postCode: '6390', suburb: 'MOUNT WELLS', state: 'WA' },
  { postCode: '6390', suburb: 'NORTH BANNISTER', state: 'WA' },
  { postCode: '6390', suburb: 'RANFORD', state: 'WA' },
  { postCode: '6390', suburb: 'UPPER MURRAY', state: 'WA' },
  { postCode: '6390', suburb: 'WURAMING', state: 'WA' },
  { postCode: '6391', suburb: 'QUINDANNING', state: 'WA' },
  { postCode: '6391', suburb: 'WILLIAMS', state: 'WA' },
  { postCode: '6392', suburb: 'BOKAL', state: 'WA' },
  { postCode: '6392', suburb: 'DARDADINE', state: 'WA' },
  { postCode: '6392', suburb: 'DARKAN', state: 'WA' },
  { postCode: '6392', suburb: 'MEEKING', state: 'WA' },
  { postCode: '6393', suburb: 'DURANILLIN', state: 'WA' },
  { postCode: '6393', suburb: 'MOODIARRUP', state: 'WA' },
  { postCode: '6394', suburb: 'BEAUFORT RIVER', state: 'WA' },
  { postCode: '6394', suburb: 'BOILUP', state: 'WA' },
  { postCode: '6394', suburb: 'BOSCABEL', state: 'WA' },
  { postCode: '6394', suburb: 'CHANGERUP', state: 'WA' },
  { postCode: '6394', suburb: 'MOKUP', state: 'WA' },
  { postCode: '6394', suburb: 'MURADUP', state: 'WA' },
  { postCode: '6394', suburb: 'ORCHID VALLEY', state: 'WA' },
  { postCode: '6394', suburb: 'QUALEUP', state: 'WA' },
  { postCode: '6395', suburb: 'CHERRY TREE POOL', state: 'WA' },
  { postCode: '6395', suburb: 'JINGALUP', state: 'WA' },
  { postCode: '6395', suburb: 'KOJONUP', state: 'WA' },
  { postCode: '6395', suburb: 'LUMEAH', state: 'WA' },
  { postCode: '6395', suburb: 'MOBRUP', state: 'WA' },
  { postCode: '6395', suburb: 'RYANSBROOK', state: 'WA' },
  { postCode: '6396', suburb: 'FRANKLAND RIVER', state: 'WA' },
  { postCode: '6397', suburb: 'ROCKY GULLY', state: 'WA' },
  { postCode: '6398', suburb: 'BROKE', state: 'WA' },
  { postCode: '6398', suburb: 'NORTH WALPOLE', state: 'WA' },
  { postCode: '6398', suburb: 'WALPOLE', state: 'WA' },
  { postCode: '6401', suburb: 'BUCKLAND', state: 'WA' },
  { postCode: '6401', suburb: 'BURLONG', state: 'WA' },
  { postCode: '6401', suburb: 'CUNJARDINE', state: 'WA' },
  { postCode: '6401', suburb: 'IRISHTOWN', state: 'WA' },
  { postCode: '6401', suburb: 'JENNACUBBINE', state: 'WA' },
  { postCode: '6401', suburb: 'JENNAPULLIN', state: 'WA' },
  { postCode: '6401', suburb: 'MALABAINE', state: 'WA' },
  { postCode: '6401', suburb: 'MEENAAR', state: 'WA' },
  { postCode: '6401', suburb: 'MOKINE', state: 'WA' },
  { postCode: '6401', suburb: 'MULUCKINE', state: 'WA' },
  { postCode: '6401', suburb: 'MUMBERKINE', state: 'WA' },
  { postCode: '6401', suburb: 'MURESK', state: 'WA' },
  { postCode: '6401', suburb: 'NORTHAM', state: 'WA' },
  { postCode: '6401', suburb: 'ROSSMORE', state: 'WA' },
  { postCode: '6401', suburb: 'SOUTHERN BROOK', state: 'WA' },
  { postCode: '6401', suburb: 'SPENCERS BROOK', state: 'WA' },
  { postCode: '6401', suburb: 'THROSSELL', state: 'WA' },
  { postCode: '6401', suburb: 'WONGAMINE', state: 'WA' },
  { postCode: '6403', suburb: 'GRASS VALLEY', state: 'WA' },
  { postCode: '6405', suburb: 'GREENWOODS VALLEY', state: 'WA' },
  { postCode: '6405', suburb: 'MECKERING', state: 'WA' },
  { postCode: '6405', suburb: 'QUELAGETTING', state: 'WA' },
  { postCode: '6405', suburb: 'WARDING EAST', state: 'WA' },
  { postCode: '6407', suburb: 'CUNDERDIN', state: 'WA' },
  { postCode: '6407', suburb: 'WAEEL', state: 'WA' },
  { postCode: '6407', suburb: 'WATERCARRIN', state: 'WA' },
  { postCode: '6407', suburb: 'WYOLA WEST', state: 'WA' },
  { postCode: '6407', suburb: 'YOUNDEGIN', state: 'WA' },
  { postCode: '6409', suburb: 'NORTH TAMMIN', state: 'WA' },
  { postCode: '6409', suburb: 'SOUTH TAMMIN', state: 'WA' },
  { postCode: '6409', suburb: 'TAMMIN', state: 'WA' },
  { postCode: '6410', suburb: 'DAADENNING CREEK', state: 'WA' },
  { postCode: '6410', suburb: 'KELLERBERRIN', state: 'WA' },
  { postCode: '6410', suburb: 'MOUNT CAROLINE', state: 'WA' },
  { postCode: '6410', suburb: 'NORTH KELLERBERRIN', state: 'WA' },
  { postCode: '6411', suburb: 'DOODLAKINE', state: 'WA' },
  { postCode: '6411', suburb: 'SOUTH DOODLAKINE', state: 'WA' },
  { postCode: '6412', suburb: 'BAANDEE', state: 'WA' },
  { postCode: '6412', suburb: 'NORTH BAANDEE', state: 'WA' },
  { postCode: '6413', suburb: 'HINES HILL', state: 'WA' },
  { postCode: '6414', suburb: 'NANGEENAN', state: 'WA' },
  { postCode: '6415', suburb: 'GOOMARIN', state: 'WA' },
  { postCode: '6415', suburb: 'KORBEL', state: 'WA' },
  { postCode: '6415', suburb: 'MERREDIN', state: 'WA' },
  { postCode: '6415', suburb: 'NOKANING', state: 'WA' },
  { postCode: '6415', suburb: 'NORPA', state: 'WA' },
  { postCode: '6415', suburb: 'TANDEGIN', state: 'WA' },
  { postCode: '6418', suburb: 'BRUCE ROCK', state: 'WA' },
  { postCode: '6419', suburb: 'ARDATH', state: 'WA' },
  { postCode: '6420', suburb: 'CRAMPHORNE', state: 'WA' },
  { postCode: '6420', suburb: 'MUNTADGIN', state: 'WA' },
  { postCode: '6421', suburb: 'BURRACOPPIN', state: 'WA' },
  { postCode: '6421', suburb: 'SOUTH BURRACOPPIN', state: 'WA' },
  { postCode: '6421', suburb: 'WARRALAKIN', state: 'WA' },
  { postCode: '6422', suburb: 'WALGOOLAN', state: 'WA' },
  { postCode: '6423', suburb: 'BOODAROCKIN', state: 'WA' },
  { postCode: '6423', suburb: 'CARRABIN', state: 'WA' },
  { postCode: '6423', suburb: 'WARRACHUPPIN', state: 'WA' },
  { postCode: '6423', suburb: 'WESTONIA', state: 'WA' },
  { postCode: '6424', suburb: 'BODALLIN', state: 'WA' },
  { postCode: '6424', suburb: 'NORTH BODALLIN', state: 'WA' },
  { postCode: '6424', suburb: 'SOUTH BODALLIN', state: 'WA' },
  { postCode: '6425', suburb: 'DULYALBIN', state: 'WA' },
  { postCode: '6425', suburb: 'MOORINE ROCK', state: 'WA' },
  { postCode: '6426', suburb: 'CORINTHIA', state: 'WA' },
  { postCode: '6426', suburb: 'GHOOLI', state: 'WA' },
  { postCode: '6426', suburb: 'HOLLETON', state: 'WA' },
  { postCode: '6426', suburb: 'MARVEL LOCH', state: 'WA' },
  { postCode: '6426', suburb: 'MOUNT HAMPTON', state: 'WA' },
  { postCode: '6426', suburb: 'MOUNT HOLLAND', state: 'WA' },
  { postCode: '6426', suburb: 'MOUNT JACKSON', state: 'WA' },
  { postCode: '6426', suburb: 'MOUNT PALMER', state: 'WA' },
  { postCode: '6426', suburb: 'PARKER RANGE', state: 'WA' },
  { postCode: '6426', suburb: 'SKELETON ROCK', state: 'WA' },
  { postCode: '6426', suburb: 'SOUTH YILGARN', state: 'WA' },
  { postCode: '6426', suburb: 'SOUTHERN CROSS', state: 'WA' },
  { postCode: '6426', suburb: 'TURKEY HILL', state: 'WA' },
  { postCode: '6426', suburb: 'YELLOWDINE', state: 'WA' },
  { postCode: '6427', suburb: 'KOOLYANOBBING', state: 'WA' },
  { postCode: '6428', suburb: 'BABAKIN', state: 'WA' },
  { postCode: '6429', suburb: 'BOORABBIN', state: 'WA' },
  { postCode: '6429', suburb: 'BULLABULLING', state: 'WA' },
  { postCode: '6429', suburb: 'COOLGARDIE', state: 'WA' },
  { postCode: '6429', suburb: 'KARRAMINDIE', state: 'WA' },
  { postCode: '6429', suburb: 'LONDONDERRY', state: 'WA' },
  { postCode: '6429', suburb: 'MOUNT BURGES', state: 'WA' },
  { postCode: '6429', suburb: 'VICTORIA ROCK', state: 'WA' },
  { postCode: '6429', suburb: 'WALLAROO', state: 'WA' },
  { postCode: '6430', suburb: 'BINDULI', state: 'WA' },
  { postCode: '6430', suburb: 'BROADWOOD', state: 'WA' },
  { postCode: '6430', suburb: 'HANNANS', state: 'WA' },
  { postCode: '6430', suburb: 'KALGOORLIE', state: 'WA' },
  { postCode: '6430', suburb: 'KARLKURLA', state: 'WA' },
  { postCode: '6430', suburb: 'LAMINGTON', state: 'WA' },
  { postCode: '6430', suburb: 'MULLINGAR', state: 'WA' },
  { postCode: '6430', suburb: 'PICCADILLY', state: 'WA' },
  { postCode: '6430', suburb: 'SOMERVILLE', state: 'WA' },
  { postCode: '6430', suburb: 'SOUTH KALGOORLIE', state: 'WA' },
  { postCode: '6430', suburb: 'WEST KALGOORLIE', state: 'WA' },
  { postCode: '6430', suburb: 'WEST LAMINGTON', state: 'WA' },
  { postCode: '6430', suburb: 'WILLIAMSTOWN', state: 'WA' },
  { postCode: '6430', suburb: 'YILKARI', state: 'WA' },
  { postCode: '6431', suburb: 'BOORARA', state: 'WA' },
  { postCode: '6431', suburb: 'BROWN HILL', state: 'WA' },
  { postCode: '6431', suburb: 'BULONG', state: 'WA' },
  { postCode: '6431', suburb: 'EMU FLAT', state: 'WA' },
  { postCode: '6431', suburb: 'FEYSVILLE', state: 'WA' },
  { postCode: '6431', suburb: 'KANOWNA', state: 'WA' },
  { postCode: '6431', suburb: 'KOOKYNIE', state: 'WA' },
  { postCode: '6431', suburb: 'KURNALPI', state: 'WA' },
  { postCode: '6431', suburb: 'LAKEWOOD', state: 'WA' },
  { postCode: '6431', suburb: 'ORA BANDA', state: 'WA' },
  { postCode: '6431', suburb: 'PLUMRIDGE LAKES', state: 'WA' },
  { postCode: '6431', suburb: 'TRAFALGAR', state: 'WA' },
  { postCode: '6431', suburb: 'WARBURTON', state: 'WA' },
  { postCode: '6432', suburb: 'BOULDER', state: 'WA' },
  { postCode: '6432', suburb: 'FIMISTON', state: 'WA' },
  { postCode: '6432', suburb: 'SOUTH BOULDER', state: 'WA' },
  { postCode: '6432', suburb: 'VICTORY HEIGHTS', state: 'WA' },
  { postCode: '6433', suburb: 'HANNANS PO', state: 'WA' },
  { postCode: '6433', suburb: 'KALGOORLIE DC', state: 'WA' },
  { postCode: '6433', suburb: 'KALGOORLIE PO', state: 'WA' },
  { postCode: '6434', suburb: 'CUNDEELEE', state: 'WA' },
  { postCode: '6434', suburb: 'FORREST', state: 'WA' },
  { postCode: '6434', suburb: 'PARKESTON', state: 'WA' },
  { postCode: '6434', suburb: 'RAWLINNA', state: 'WA' },
  { postCode: '6434', suburb: 'ZANTHUS', state: 'WA' },
  { postCode: '6436', suburb: 'MENZIES', state: 'WA' },
  { postCode: '6436', suburb: 'ULARRING', state: 'WA' },
  { postCode: '6437', suburb: 'LEINSTER', state: 'WA' },
  { postCode: '6437', suburb: 'SIR SAMUEL', state: 'WA' },
  { postCode: '6438', suburb: 'LAKE DARLOT', state: 'WA' },
  { postCode: '6438', suburb: 'LEONORA', state: 'WA' },
  { postCode: '6440', suburb: 'BANDYA', state: 'WA' },
  { postCode: '6440', suburb: 'BEADELL', state: 'WA' },
  { postCode: '6440', suburb: 'COSMO NEWBERY', state: 'WA' },
  { postCode: '6440', suburb: 'LAKE WELLS', state: 'WA' },
  { postCode: '6440', suburb: 'LAVERTON', state: 'WA' },
  { postCode: '6440', suburb: 'NEALE', state: 'WA' },
  { postCode: '6442', suburb: 'KAMBALDA EAST', state: 'WA' },
  { postCode: '6442', suburb: 'KAMBALDA WEST', state: 'WA' },
  { postCode: '6443', suburb: 'BALLADONIA', state: 'WA' },
  { postCode: '6443', suburb: 'CAIGUNA', state: 'WA' },
  { postCode: '6443', suburb: 'COCKLEBIDDY', state: 'WA' },
  { postCode: '6443', suburb: 'DUNDAS', state: 'WA' },
  { postCode: '6443', suburb: 'EUCLA', state: 'WA' },
  { postCode: '6443', suburb: 'FRASER RANGE', state: 'WA' },
  { postCode: '6443', suburb: 'HIGGINSVILLE', state: 'WA' },
  { postCode: '6443', suburb: 'MADURA', state: 'WA' },
  { postCode: '6443', suburb: 'MUNDRABILLA', state: 'WA' },
  { postCode: '6443', suburb: 'NORSEMAN', state: 'WA' },
  { postCode: '6443', suburb: 'WIDGIEMOOLTHA', state: 'WA' },
  { postCode: '6445', suburb: 'NORTH CASCADE', state: 'WA' },
  { postCode: '6445', suburb: 'SALMON GUMS', state: 'WA' },
  { postCode: '6446', suburb: 'GRASS PATCH', state: 'WA' },
  { postCode: '6447', suburb: 'LORT RIVER', state: 'WA' },
  { postCode: '6447', suburb: 'MOUNT NEY', state: 'WA' },
  { postCode: '6447', suburb: 'SCADDAN', state: 'WA' },
  { postCode: '6447', suburb: 'WITTENOOM HILLS', state: 'WA' },
  { postCode: '6448', suburb: 'GIBSON', state: 'WA' },
  { postCode: '6450', suburb: 'BANDY CREEK', state: 'WA' },
  { postCode: '6450', suburb: 'BEAUMONT', state: 'WA' },
  { postCode: '6450', suburb: 'BOYATUP', state: 'WA' },
  { postCode: '6450', suburb: 'CAPE LE GRAND', state: 'WA' },
  { postCode: '6450', suburb: 'CASCADE', state: 'WA' },
  { postCode: '6450', suburb: 'CASTLETOWN', state: 'WA' },
  { postCode: '6450', suburb: 'CHADWICK', state: 'WA' },
  { postCode: '6450', suburb: 'CONDINGUP', state: 'WA' },
  { postCode: '6450', suburb: 'COOMALBIDGUP', state: 'WA' },
  { postCode: '6450', suburb: 'DALYUP', state: 'WA' },
  { postCode: '6450', suburb: 'EAST MUNGLINUP', state: 'WA' },
  { postCode: '6450', suburb: 'ESPERANCE', state: 'WA' },
  { postCode: '6450', suburb: 'HOWICK', state: 'WA' },
  { postCode: '6450', suburb: 'MERIVALE', state: 'WA' },
  { postCode: '6450', suburb: 'MONJINGUP', state: 'WA' },
  { postCode: '6450', suburb: 'MUNGLINUP', state: 'WA' },
  { postCode: '6450', suburb: 'MYRUP', state: 'WA' },
  { postCode: '6450', suburb: 'NERIDUP', state: 'WA' },
  { postCode: '6450', suburb: 'NULSEN', state: 'WA' },
  { postCode: '6450', suburb: 'PINK LAKE', state: 'WA' },
  { postCode: '6450', suburb: 'SINCLAIR', state: 'WA' },
  { postCode: '6450', suburb: 'WEST BEACH', state: 'WA' },
  { postCode: '6450', suburb: 'WINDABOUT', state: 'WA' },
  { postCode: '6452', suburb: 'BURAMINYA', state: 'WA' },
  { postCode: '6452', suburb: 'CAPE ARID', state: 'WA' },
  { postCode: '6452', suburb: 'ISRAELITE BAY', state: 'WA' },
  { postCode: '6460', suburb: 'GOOMALLING', state: 'WA' },
  { postCode: '6460', suburb: 'HULONGINE', state: 'WA' },
  { postCode: '6460', suburb: 'KARRANADGIN', state: 'WA' },
  { postCode: '6460', suburb: 'UCARTY WEST', state: 'WA' },
  { postCode: '6460', suburb: 'WALYORMOURING', state: 'WA' },
  { postCode: '6461', suburb: 'DOWERIN', state: 'WA' },
  { postCode: '6461', suburb: 'KOOMBERKINE', state: 'WA' },
  { postCode: '6462', suburb: 'HINDMARSH', state: 'WA' },
  { postCode: '6462', suburb: 'MINNIVALE', state: 'WA' },
  { postCode: '6462', suburb: 'UCARTY', state: 'WA' },
  { postCode: '6463', suburb: 'BENJABERRING', state: 'WA' },
  { postCode: '6465', suburb: 'MANMANNING', state: 'WA' },
  { postCode: '6466', suburb: 'CADOUX', state: 'WA' },
  { postCode: '6467', suburb: 'BURAKIN', state: 'WA' },
  { postCode: '6468', suburb: 'GOODLANDS', state: 'WA' },
  { postCode: '6468', suburb: 'KALANNIE', state: 'WA' },
  { postCode: '6468', suburb: 'PETRUDOR', state: 'WA' },
  { postCode: '6470', suburb: 'KULJA', state: 'WA' },
  { postCode: '6472', suburb: 'BEACON', state: 'WA' },
  { postCode: '6472', suburb: 'BIMBIJY', state: 'WA' },
  { postCode: '6472', suburb: 'CLEARY', state: 'WA' },
  { postCode: '6472', suburb: 'KARROUN HILL', state: 'WA' },
  { postCode: '6472', suburb: 'MOUROUBRA', state: 'WA' },
  { postCode: '6472', suburb: 'REMLAP', state: 'WA' },
  { postCode: '6472', suburb: 'TAMPU', state: 'WA' },
  { postCode: '6473', suburb: 'NORTH WIALKI', state: 'WA' },
  { postCode: '6473', suburb: 'WIALKI', state: 'WA' },
  { postCode: '6475', suburb: 'BADGERIN ROCK', state: 'WA' },
  { postCode: '6475', suburb: 'BOORALAMING', state: 'WA' },
  { postCode: '6475', suburb: 'DUKIN', state: 'WA' },
  { postCode: '6475', suburb: 'KOORDA', state: 'WA' },
  { postCode: '6475', suburb: 'LAKE MARGARETTE', state: 'WA' },
  { postCode: '6475', suburb: 'MOLLERIN', state: 'WA' },
  { postCode: '6475', suburb: 'NEWCARLBEON', state: 'WA' },
  { postCode: '6476', suburb: 'GABBIN', state: 'WA' },
  { postCode: '6477', suburb: 'BENCUBBIN', state: 'WA' },
  { postCode: '6477', suburb: 'WELBUNGIN', state: 'WA' },
  { postCode: '6479', suburb: 'BARBALIN', state: 'WA' },
  { postCode: '6479', suburb: 'BONNIE ROCK', state: 'WA' },
  { postCode: '6479', suburb: 'DANDANNING', state: 'WA' },
  { postCode: '6479', suburb: 'ELACHBUTTING', state: 'WA' },
  { postCode: '6479', suburb: 'KARLONING', state: 'WA' },
  { postCode: '6479', suburb: 'LAKE BROWN', state: 'WA' },
  { postCode: '6479', suburb: 'MUKINBUDIN', state: 'WA' },
  { postCode: '6479', suburb: 'WATTONING', state: 'WA' },
  { postCode: '6479', suburb: 'WILGOYNE', state: 'WA' },
  { postCode: '6480', suburb: 'NUKARNI', state: 'WA' },
  { postCode: '6484', suburb: 'BULLFINCH', state: 'WA' },
  { postCode: '6484', suburb: 'ENNUIN', state: 'WA' },
  { postCode: '6484', suburb: 'LAKE DEBORAH', state: 'WA' },
  { postCode: '6485', suburb: 'COWCOWING', state: 'WA' },
  { postCode: '6485', suburb: 'KORRELOCKING', state: 'WA' },
  { postCode: '6485', suburb: 'NALKAIN', state: 'WA' },
  { postCode: '6485', suburb: 'NEMBUDDING', state: 'WA' },
  { postCode: '6485', suburb: 'WYALKATCHEM', state: 'WA' },
  { postCode: '6487', suburb: 'NORTH YELBENI', state: 'WA' },
  { postCode: '6487', suburb: 'SOUTH YELBENI', state: 'WA' },
  { postCode: '6487', suburb: 'YELBENI', state: 'WA' },
  { postCode: '6488', suburb: 'NORTH TRAYNING', state: 'WA' },
  { postCode: '6488', suburb: 'SOUTH TRAYNING', state: 'WA' },
  { postCode: '6488', suburb: 'TRAYNING', state: 'WA' },
  { postCode: '6489', suburb: 'KUNUNOPPIN', state: 'WA' },
  { postCode: '6489', suburb: 'NORTH KUNUNOPPIN', state: 'WA' },
  { postCode: '6489', suburb: 'SOUTH KUNUNOPPIN', state: 'WA' },
  { postCode: '6490', suburb: 'BURRAN ROCK', state: 'WA' },
  { postCode: '6490', suburb: 'CHANDLER', state: 'WA' },
  { postCode: '6490', suburb: 'ELABBIN', state: 'WA' },
  { postCode: '6490', suburb: 'KWELKAN', state: 'WA' },
  { postCode: '6490', suburb: 'NUNGARIN', state: 'WA' },
  { postCode: '6490', suburb: 'TALGOMINE', state: 'WA' },
  { postCode: '6501', suburb: 'MUCHEA', state: 'WA' },
  { postCode: '6502', suburb: 'BINDOON', state: 'WA' },
  { postCode: '6502', suburb: 'BINDOON TRAINING AREA', state: 'WA' },
  { postCode: '6503', suburb: 'BAMBUN', state: 'WA' },
  { postCode: '6503', suburb: 'BEERMULLAH', state: 'WA' },
  { postCode: '6503', suburb: 'BOONANARRING', state: 'WA' },
  { postCode: '6503', suburb: 'BREERA', state: 'WA' },
  { postCode: '6503', suburb: 'COONABIDGEE', state: 'WA' },
  { postCode: '6503', suburb: 'COWALLA', state: 'WA' },
  { postCode: '6503', suburb: 'CULLALLA', state: 'WA' },
  { postCode: '6503', suburb: 'GINGIN', state: 'WA' },
  { postCode: '6503', suburb: 'GINGINUP', state: 'WA' },
  { postCode: '6503', suburb: 'GRANVILLE', state: 'WA' },
  { postCode: '6503', suburb: 'LENNARD BROOK', state: 'WA' },
  { postCode: '6503', suburb: 'MINDARRA', state: 'WA' },
  { postCode: '6503', suburb: 'MOONDAH', state: 'WA' },
  { postCode: '6503', suburb: 'MOORE RIVER NATIONAL PARK', state: 'WA' },
  { postCode: '6503', suburb: 'MUCKENBURRA', state: 'WA' },
  { postCode: '6503', suburb: 'NEERGABBY', state: 'WA' },
  { postCode: '6503', suburb: 'ORANGE SPRINGS', state: 'WA' },
  { postCode: '6503', suburb: 'RED GULLY', state: 'WA' },
  { postCode: '6503', suburb: 'WANERIE', state: 'WA' },
  { postCode: '6503', suburb: 'YEAL', state: 'WA' },
  { postCode: '6504', suburb: 'MOOLIABEENEE', state: 'WA' },
  { postCode: '6505', suburb: 'WANNAMAL', state: 'WA' },
  { postCode: '6506', suburb: 'MOGUMBER', state: 'WA' },
  { postCode: '6507', suburb: 'CATABY', state: 'WA' },
  { postCode: '6507', suburb: 'COOLJARLOO', state: 'WA' },
  { postCode: '6507', suburb: 'DANDARAGAN', state: 'WA' },
  { postCode: '6507', suburb: 'MIMEGARRA', state: 'WA' },
  { postCode: '6507', suburb: 'REGANS FORD', state: 'WA' },
  { postCode: '6507', suburb: 'YATHROO', state: 'WA' },
  { postCode: '6509', suburb: 'GLENTROMIE', state: 'WA' },
  { postCode: '6509', suburb: 'NEW NORCIA', state: 'WA' },
  { postCode: '6509', suburb: 'WADDINGTON', state: 'WA' },
  { postCode: '6509', suburb: 'YARAWINDAH', state: 'WA' },
  { postCode: '6510', suburb: 'BARBERTON', state: 'WA' },
  { postCode: '6510', suburb: 'BERKSHIRE VALLEY', state: 'WA' },
  { postCode: '6510', suburb: 'GILLINGARRA', state: 'WA' },
  { postCode: '6510', suburb: 'KOOJAN', state: 'WA' },
  { postCode: '6510', suburb: 'MOORA', state: 'WA' },
  { postCode: '6510', suburb: 'WALEBING', state: 'WA' },
  { postCode: '6511', suburb: 'CERVANTES', state: 'WA' },
  { postCode: '6512', suburb: 'COOMBERDALE', state: 'WA' },
  { postCode: '6512', suburb: 'NAMBAN', state: 'WA' },
  { postCode: '6513', suburb: 'GUNYIDI', state: 'WA' },
  { postCode: '6513', suburb: 'WATHEROO', state: 'WA' },
  { postCode: '6514', suburb: 'GREEN HEAD', state: 'WA' },
  { postCode: '6514', suburb: 'LEEMAN', state: 'WA' },
  { postCode: '6515', suburb: 'COOROW', state: 'WA' },
  { postCode: '6515', suburb: 'EGANU', state: 'WA' },
  { postCode: '6515', suburb: 'MARCHAGEE', state: 'WA' },
  { postCode: '6515', suburb: 'WADDY FOREST', state: 'WA' },
  { postCode: '6516', suburb: 'JURIEN BAY', state: 'WA' },
  { postCode: '6517', suburb: 'CARNAMAH', state: 'WA' },
  { postCode: '6518', suburb: 'ENEABBA', state: 'WA' },
  { postCode: '6518', suburb: 'WARRADARGE', state: 'WA' },
  { postCode: '6519', suburb: 'ARRINO', state: 'WA' },
  { postCode: '6519', suburb: 'ARROWSMITH EAST', state: 'WA' },
  { postCode: '6519', suburb: 'DUDAWA', state: 'WA' },
  { postCode: '6519', suburb: 'KADATHINNI', state: 'WA' },
  { postCode: '6519', suburb: 'THREE SPRINGS', state: 'WA' },
  { postCode: '6519', suburb: 'WOMARDEN', state: 'WA' },
  { postCode: '6521', suburb: 'BADGINGARRA', state: 'WA' },
  { postCode: '6521', suburb: 'BOOTHENDARRA', state: 'WA' },
  { postCode: '6521', suburb: 'GREY', state: 'WA' },
  { postCode: '6521', suburb: 'HILL RIVER', state: 'WA' },
  { postCode: '6521', suburb: 'NAMBUNG', state: 'WA' },
  { postCode: '6522', suburb: 'BUNDANOON', state: 'WA' },
  { postCode: '6522', suburb: 'HOLMWOOD', state: 'WA' },
  { postCode: '6522', suburb: 'IKEWA', state: 'WA' },
  { postCode: '6522', suburb: 'LOCKIER', state: 'WA' },
  { postCode: '6522', suburb: 'MINGENEW', state: 'WA' },
  { postCode: '6522', suburb: 'MOORIARY', state: 'WA' },
  { postCode: '6522', suburb: 'MOUNT BUDD', state: 'WA' },
  { postCode: '6522', suburb: 'NANGETTY', state: 'WA' },
  { postCode: '6522', suburb: 'YANDANOOKA', state: 'WA' },
  { postCode: '6522', suburb: 'YARRAGADEE', state: 'WA' },
  { postCode: '6525', suburb: 'ALLANOOKA', state: 'WA' },
  { postCode: '6525', suburb: 'ARROWSMITH', state: 'WA' },
  { postCode: '6525', suburb: 'BONNIEFIELD', state: 'WA' },
  { postCode: '6525', suburb: 'BOOKARA', state: 'WA' },
  { postCode: '6525', suburb: 'DONGARA', state: 'WA' },
  { postCode: '6525', suburb: 'IRWIN', state: 'WA' },
  { postCode: '6525', suburb: 'MILO', state: 'WA' },
  { postCode: '6525', suburb: 'MOUNT ADAMS', state: 'WA' },
  { postCode: '6525', suburb: 'MOUNT HORNER', state: 'WA' },
  { postCode: '6525', suburb: 'PORT DENISON', state: 'WA' },
  { postCode: '6525', suburb: 'SPRINGFIELD', state: 'WA' },
  { postCode: '6525', suburb: 'YARDARINO', state: 'WA' },
  { postCode: '6528', suburb: 'MOUNT HILL', state: 'WA' },
  { postCode: '6528', suburb: 'SOUTH GREENOUGH', state: 'WA' },
  { postCode: '6528', suburb: 'WALKAWAY', state: 'WA' },
  { postCode: '6530', suburb: 'BEACHLANDS', state: 'WA' },
  { postCode: '6530', suburb: 'BERESFORD', state: 'WA' },
  { postCode: '6530', suburb: 'BLUFF POINT', state: 'WA' },
  { postCode: '6530', suburb: 'GERALDTON', state: 'WA' },
  { postCode: '6530', suburb: 'HOUTMAN ABROLHOS', state: 'WA' },
  { postCode: '6530', suburb: 'KARLOO', state: 'WA' },
  { postCode: '6530', suburb: 'MAHOMETS FLATS', state: 'WA' },
  { postCode: '6530', suburb: 'MERU', state: 'WA' },
  { postCode: '6530', suburb: 'MORESBY', state: 'WA' },
  { postCode: '6530', suburb: 'MOUNT TARCOOLA', state: 'WA' },
  { postCode: '6530', suburb: 'RANGEWAY', state: 'WA' },
  { postCode: '6530', suburb: 'SPALDING', state: 'WA' },
  { postCode: '6530', suburb: 'STRATHALBYN', state: 'WA' },
  { postCode: '6530', suburb: 'SUNSET BEACH', state: 'WA' },
  { postCode: '6530', suburb: 'TARCOOLA BEACH', state: 'WA' },
  { postCode: '6530', suburb: 'UTAKARRA', state: 'WA' },
  { postCode: '6530', suburb: 'WAGGRAKINE', state: 'WA' },
  { postCode: '6530', suburb: 'WANDINA', state: 'WA' },
  { postCode: '6530', suburb: 'WEBBERTON', state: 'WA' },
  { postCode: '6530', suburb: 'WEST END', state: 'WA' },
  { postCode: '6530', suburb: 'WONTHELLA', state: 'WA' },
  { postCode: '6530', suburb: 'WOORREE', state: 'WA' },
  { postCode: '6531', suburb: 'GERALDTON PO', state: 'WA' },
  { postCode: '6532', suburb: 'AJANA', state: 'WA' },
  { postCode: '6532', suburb: 'BINNU', state: 'WA' },
  { postCode: '6532', suburb: 'BOOTENAL', state: 'WA' },
  { postCode: '6532', suburb: 'BRINGO', state: 'WA' },
  { postCode: '6532', suburb: 'BULLER', state: 'WA' },
  { postCode: '6532', suburb: 'BURMA ROAD', state: 'WA' },
  { postCode: '6532', suburb: 'CAPE BURNEY', state: 'WA' },
  { postCode: '6532', suburb: 'CARRARANG', state: 'WA' },
  { postCode: '6532', suburb: 'COBURN', state: 'WA' },
  { postCode: '6532', suburb: 'COOLCALALAYA', state: 'WA' },
  { postCode: '6532', suburb: 'DARTMOOR', state: 'WA' },
  { postCode: '6532', suburb: 'DEEPDALE', state: 'WA' },
  { postCode: '6532', suburb: 'DINDILOA', state: 'WA' },
  { postCode: '6532', suburb: 'DRUMMOND COVE', state: 'WA' },
  { postCode: '6532', suburb: 'DURAWAH', state: 'WA' },
  { postCode: '6532', suburb: 'EAST CHAPMAN', state: 'WA' },
  { postCode: '6532', suburb: 'EAST NABAWA', state: 'WA' },
  { postCode: '6532', suburb: 'EAST YUNA', state: 'WA' },
  { postCode: '6532', suburb: 'ELLENDALE', state: 'WA' },
  { postCode: '6532', suburb: 'ERADU', state: 'WA' },
  { postCode: '6532', suburb: 'ERADU SOUTH', state: 'WA' },
  { postCode: '6532', suburb: 'EURARDY', state: 'WA' },
  { postCode: '6532', suburb: 'GEORGINA', state: 'WA' },
  { postCode: '6532', suburb: 'GLENFIELD', state: 'WA' },
  { postCode: '6532', suburb: 'GREENOUGH', state: 'WA' },
  { postCode: '6532', suburb: 'HAMELIN POOL', state: 'WA' },
  { postCode: '6532', suburb: 'HICKETY', state: 'WA' },
  { postCode: '6532', suburb: 'HOWATHARRA', state: 'WA' },
  { postCode: '6532', suburb: 'KOJARENA', state: 'WA' },
  { postCode: '6532', suburb: 'MARRAH', state: 'WA' },
  { postCode: '6532', suburb: 'MEADOW', state: 'WA' },
  { postCode: '6532', suburb: 'MINNENOOKA', state: 'WA' },
  { postCode: '6532', suburb: 'MOONYOONOOKA', state: 'WA' },
  { postCode: '6532', suburb: 'MOUNT ERIN', state: 'WA' },
  { postCode: '6532', suburb: 'NABAWA', state: 'WA' },
  { postCode: '6532', suburb: 'NANSON', state: 'WA' },
  { postCode: '6532', suburb: 'NARALING', state: 'WA' },
  { postCode: '6532', suburb: 'NARNGULU', state: 'WA' },
  { postCode: '6532', suburb: 'NARRA TARRA', state: 'WA' },
  { postCode: '6532', suburb: 'NERREN NERREN', state: 'WA' },
  { postCode: '6532', suburb: 'NOLBA', state: 'WA' },
  { postCode: '6532', suburb: 'NORTH ERADU', state: 'WA' },
  { postCode: '6532', suburb: 'NORTHERN GULLY', state: 'WA' },
  { postCode: '6532', suburb: 'OAKAJEE', state: 'WA' },
  { postCode: '6532', suburb: 'ROCKWELL', state: 'WA' },
  { postCode: '6532', suburb: 'RUDDS GULLY', state: 'WA' },
  { postCode: '6532', suburb: 'SANDSPRINGS', state: 'WA' },
  { postCode: '6532', suburb: 'SOUTH YUNA', state: 'WA' },
  { postCode: '6532', suburb: 'TAMALA', state: 'WA' },
  { postCode: '6532', suburb: 'TIBRADDEN', state: 'WA' },
  { postCode: '6532', suburb: 'TOOLONGA', state: 'WA' },
  { postCode: '6532', suburb: 'VALENTINE', state: 'WA' },
  { postCode: '6532', suburb: 'WANDANA', state: 'WA' },
  { postCode: '6532', suburb: 'WEST BINNU', state: 'WA' },
  { postCode: '6532', suburb: 'WHITE PEAK', state: 'WA' },
  { postCode: '6532', suburb: 'WICHERINA', state: 'WA' },
  { postCode: '6532', suburb: 'WICHERINA SOUTH', state: 'WA' },
  { postCode: '6532', suburb: 'YETNA', state: 'WA' },
  { postCode: '6532', suburb: 'YUNA', state: 'WA' },
  { postCode: '6535', suburb: 'ALMA', state: 'WA' },
  { postCode: '6535', suburb: 'BOWES', state: 'WA' },
  { postCode: '6535', suburb: 'EAST BOWES', state: 'WA' },
  { postCode: '6535', suburb: 'GREGORY', state: 'WA' },
  { postCode: '6535', suburb: 'HORROCKS', state: 'WA' },
  { postCode: '6535', suburb: 'ISSEKA', state: 'WA' },
  { postCode: '6535', suburb: 'NORTHAMPTON', state: 'WA' },
  { postCode: '6535', suburb: 'OGILVIE', state: 'WA' },
  { postCode: '6535', suburb: 'SANDY GULLY', state: 'WA' },
  { postCode: '6535', suburb: 'YALLABATHARRA', state: 'WA' },
  { postCode: '6536', suburb: 'KALBARRI', state: 'WA' },
  { postCode: '6536', suburb: 'KALBARRI NATIONAL PARK', state: 'WA' },
  { postCode: '6536', suburb: 'ZUYTDORP', state: 'WA' },
  { postCode: '6537', suburb: 'DENHAM', state: 'WA' },
  { postCode: '6537', suburb: 'DIRK HARTOG ISLAND', state: 'WA' },
  { postCode: '6537', suburb: 'FRANCOIS PERON NATIONAL PARK', state: 'WA' },
  { postCode: '6537', suburb: 'MONKEY MIA', state: 'WA' },
  { postCode: '6537', suburb: 'NANGA', state: 'WA' },
  { postCode: '6537', suburb: 'SHARK BAY', state: 'WA' },
  { postCode: '6537', suburb: 'USELESS LOOP', state: 'WA' },
  { postCode: '6556', suburb: 'BEECHINA', state: 'WA' },
  { postCode: '6556', suburb: 'CHIDLOW', state: 'WA' },
  { postCode: '6556', suburb: 'GORRIE', state: 'WA' },
  { postCode: '6556', suburb: 'MALMALLING', state: 'WA' },
  { postCode: '6556', suburb: 'THE LAKES', state: 'WA' },
  { postCode: '6558', suburb: 'WOOROLOO', state: 'WA' },
  { postCode: '6560', suburb: 'WUNDOWIE', state: 'WA' },
  { postCode: '6562', suburb: 'BAKERS HILL', state: 'WA' },
  { postCode: '6562', suburb: 'COPLEY', state: 'WA' },
  { postCode: '6562', suburb: 'WOOTTATING', state: 'WA' },
  { postCode: '6564', suburb: 'CLACKLINE', state: 'WA' },
  { postCode: '6566', suburb: 'BEJOORDING', state: 'WA' },
  { postCode: '6566', suburb: 'COONDLE', state: 'WA' },
  { postCode: '6566', suburb: 'CULHAM', state: 'WA' },
  { postCode: '6566', suburb: 'DUMBARTON', state: 'WA' },
  { postCode: '6566', suburb: 'HODDYS WELL', state: 'WA' },
  { postCode: '6566', suburb: 'KATRINE', state: 'WA' },
  { postCode: '6566', suburb: 'NUNILE', state: 'WA' },
  { postCode: '6566', suburb: 'TOODYAY', state: 'WA' },
  { postCode: '6566', suburb: 'WEST TOODYAY', state: 'WA' },
  { postCode: '6567', suburb: 'DEWARS POOL', state: 'WA' },
  { postCode: '6567', suburb: 'JULIMAR', state: 'WA' },
  { postCode: '6567', suburb: 'MOONDYNE', state: 'WA' },
  { postCode: '6568', suburb: 'BOLGART', state: 'WA' },
  { postCode: '6568', suburb: 'WATTENING', state: 'WA' },
  { postCode: '6568', suburb: 'WYENING', state: 'WA' },
  { postCode: '6569', suburb: 'CALINGIRI', state: 'WA' },
  { postCode: '6569', suburb: 'CARANI', state: 'WA' },
  { postCode: '6569', suburb: 'OLD PLAINS', state: 'WA' },
  { postCode: '6571', suburb: 'YERECOIN', state: 'WA' },
  { postCode: '6572', suburb: 'PIAWANING', state: 'WA' },
  { postCode: '6574', suburb: 'BINDI BINDI', state: 'WA' },
  { postCode: '6574', suburb: 'GABALONG', state: 'WA' },
  { postCode: '6575', suburb: 'MILING', state: 'WA' },
  { postCode: '6603', suburb: 'KONNONGORRING', state: 'WA' },
  { postCode: '6603', suburb: 'LAKE HINDS', state: 'WA' },
  { postCode: '6603', suburb: 'LAKE NINAN', state: 'WA' },
  { postCode: '6603', suburb: 'MOCARDY', state: 'WA' },
  { postCode: '6603', suburb: 'WONGAN HILLS', state: 'WA' },
  { postCode: '6605', suburb: 'KONDUT', state: 'WA' },
  { postCode: '6606', suburb: 'BALLIDU', state: 'WA' },
  { postCode: '6606', suburb: 'EAST BALLIDU', state: 'WA' },
  { postCode: '6606', suburb: 'WEST BALLIDU', state: 'WA' },
  { postCode: '6608', suburb: 'EAST DAMBORING', state: 'WA' },
  { postCode: '6608', suburb: 'MARNE', state: 'WA' },
  { postCode: '6608', suburb: 'PITHARA', state: 'WA' },
  { postCode: '6609', suburb: 'DALWALLINU', state: 'WA' },
  { postCode: '6609', suburb: 'NUGADONG', state: 'WA' },
  { postCode: '6609', suburb: 'XANTIPPE', state: 'WA' },
  { postCode: '6612', suburb: 'JIBBERDING', state: 'WA' },
  { postCode: '6612', suburb: 'MIAMOON', state: 'WA' },
  { postCode: '6612', suburb: 'PAYNES FIND', state: 'WA' },
  { postCode: '6612', suburb: 'WUBIN', state: 'WA' },
  { postCode: '6613', suburb: 'BUNTINE', state: 'WA' },
  { postCode: '6614', suburb: 'MAYA', state: 'WA' },
  { postCode: '6616', suburb: 'LATHAM', state: 'WA' },
  { postCode: '6620', suburb: 'BUNJIL', state: 'WA' },
  { postCode: '6620', suburb: 'PERENJORI', state: 'WA' },
  { postCode: '6620', suburb: 'ROTHSAY', state: 'WA' },
  { postCode: '6623', suburb: 'BOWGADA', state: 'WA' },
  { postCode: '6623', suburb: 'GUTHA', state: 'WA' },
  { postCode: '6623', suburb: 'KOOLANOOKA', state: 'WA' },
  { postCode: '6623', suburb: 'MORAWA', state: 'WA' },
  { postCode: '6623', suburb: 'PINTHARUKA', state: 'WA' },
  { postCode: '6625', suburb: 'MERKANOOKA', state: 'WA' },
  { postCode: '6627', suburb: 'CANNA', state: 'WA' },
  { postCode: '6628', suburb: 'TARDUN', state: 'WA' },
  { postCode: '6630', suburb: 'DEVILS CREEK', state: 'WA' },
  { postCode: '6630', suburb: 'MULLEWA', state: 'WA' },
  { postCode: '6630', suburb: 'MURCHISON', state: 'WA' },
  { postCode: '6630', suburb: 'NERRAMYNE', state: 'WA' },
  { postCode: '6630', suburb: 'NUNIERRA', state: 'WA' },
  { postCode: '6630', suburb: 'WEST CASUARINAS', state: 'WA' },
  { postCode: '6630', suburb: 'WONGOONDY', state: 'WA' },
  { postCode: '6630', suburb: 'WOOLGORONG', state: 'WA' },
  { postCode: '6631', suburb: 'PINDAR', state: 'WA' },
  { postCode: '6632', suburb: 'AMBANIA', state: 'WA' },
  { postCode: '6632', suburb: 'TENINDEWA', state: 'WA' },
  { postCode: '6635', suburb: 'SOUTH MURCHISON', state: 'WA' },
  { postCode: '6635', suburb: 'YALGOO', state: 'WA' },
  { postCode: '6638', suburb: 'COOLADAR HILL', state: 'WA' },
  { postCode: '6638', suburb: 'DAGGAR HILLS', state: 'WA' },
  { postCode: '6638', suburb: 'MOUNT MAGNET', state: 'WA' },
  { postCode: '6638', suburb: 'PAYNESVILLE', state: 'WA' },
  { postCode: '6639', suburb: 'SANDSTONE', state: 'WA' },
  { postCode: '6640', suburb: 'CUE', state: 'WA' },
  { postCode: '6640', suburb: 'EAST MURCHISON', state: 'WA' },
  { postCode: '6640', suburb: 'LAKE AUSTIN', state: 'WA' },
  { postCode: '6640', suburb: 'REEDY', state: 'WA' },
  { postCode: '6640', suburb: 'WELD RANGE', state: 'WA' },
  { postCode: '6642', suburb: 'ANGELO RIVER', state: 'WA' },
  { postCode: '6642', suburb: 'CAPRICORN', state: 'WA' },
  { postCode: '6642', suburb: 'KARALUNDI', state: 'WA' },
  { postCode: '6642', suburb: 'KUMARINA', state: 'WA' },
  { postCode: '6642', suburb: 'MEEKATHARRA', state: 'WA' },
  { postCode: '6642', suburb: 'PEAK HILL', state: 'WA' },
  { postCode: '6646', suburb: 'LAKE CARNEGIE', state: 'WA' },
  { postCode: '6646', suburb: 'LITTLE SANDY DESERT', state: 'WA' },
  { postCode: '6646', suburb: 'WILUNA', state: 'WA' },
  { postCode: '6701', suburb: 'BABBAGE ISLAND', state: 'WA' },
  { postCode: '6701', suburb: 'BERNIER ISLAND', state: 'WA' },
  { postCode: '6701', suburb: 'BROCKMAN', state: 'WA' },
  { postCode: '6701', suburb: 'BROWN RANGE', state: 'WA' },
  { postCode: '6701', suburb: 'CARBLA', state: 'WA' },
  { postCode: '6701', suburb: 'CARNARVON', state: 'WA' },
  { postCode: '6701', suburb: 'CORAL BAY', state: 'WA' },
  { postCode: '6701', suburb: 'DORRE ISLAND', state: 'WA' },
  { postCode: '6701', suburb: 'EAST CARNARVON', state: 'WA' },
  { postCode: '6701', suburb: 'GILROYD', state: 'WA' },
  { postCode: '6701', suburb: 'GREYS PLAIN', state: 'WA' },
  { postCode: '6701', suburb: 'INGGARDA', state: 'WA' },
  { postCode: '6701', suburb: 'KENNEDY RANGE', state: 'WA' },
  { postCode: '6701', suburb: 'KINGSFORD', state: 'WA' },
  { postCode: '6701', suburb: 'LYNDON', state: 'WA' },
  { postCode: '6701', suburb: 'MACLEOD', state: 'WA' },
  { postCode: '6701', suburb: 'MASSEY BAY', state: 'WA' },
  { postCode: '6701', suburb: 'MINILYA', state: 'WA' },
  { postCode: '6701', suburb: 'MORGANTOWN', state: 'WA' },
  { postCode: '6701', suburb: 'NINGALOO', state: 'WA' },
  { postCode: '6701', suburb: 'NORTH PLANTATIONS', state: 'WA' },
  { postCode: '6701', suburb: 'SOUTH CARNARVON', state: 'WA' },
  { postCode: '6701', suburb: 'SOUTH PLANTATIONS', state: 'WA' },
  { postCode: '6701', suburb: 'TALISKER', state: 'WA' },
  { postCode: '6701', suburb: 'WOODLEIGH', state: 'WA' },
  { postCode: '6701', suburb: 'WOORAMEL', state: 'WA' },
  { postCode: '6701', suburb: 'YALARDY', state: 'WA' },
  { postCode: '6701', suburb: 'YANDOO CREEK', state: 'WA' },
  { postCode: '6705', suburb: 'EAST LYONS RIVER', state: 'WA' },
  { postCode: '6705', suburb: 'GASCOYNE JUNCTION', state: 'WA' },
  { postCode: '6705', suburb: 'GASCOYNE RIVER', state: 'WA' },
  { postCode: '6705', suburb: 'WEST LYONS RIVER', state: 'WA' },
  { postCode: '6707', suburb: 'CAPE RANGE NATIONAL PARK', state: 'WA' },
  { postCode: '6707', suburb: 'EXMOUTH', state: 'WA' },
  { postCode: '6707', suburb: 'EXMOUTH GULF', state: 'WA' },
  { postCode: '6707', suburb: 'LEARMONTH', state: 'WA' },
  { postCode: '6707', suburb: 'NORTH WEST CAPE', state: 'WA' },
  { postCode: '6710', suburb: 'CANE', state: 'WA' },
  { postCode: '6710', suburb: 'ONSLOW', state: 'WA' },
  { postCode: '6710', suburb: 'PEEDAMULLA', state: 'WA' },
  { postCode: '6710', suburb: 'TALANDJI', state: 'WA' },
  { postCode: '6710', suburb: 'YANNARIE', state: 'WA' },
  { postCode: '6711', suburb: 'THEVENARD ISLAND', state: 'WA' },
  { postCode: '6712', suburb: 'BARROW ISLAND', state: 'WA' },
  { postCode: '6713', suburb: 'DAMPIER', state: 'WA' },
  { postCode: '6713', suburb: 'DAMPIER ARCHIPELAGO', state: 'WA' },
  { postCode: '6714', suburb: 'ANTONYMYRE', state: 'WA' },
  { postCode: '6714', suburb: 'BALLA BALLA', state: 'WA' },
  { postCode: '6714', suburb: 'BAYNTON', state: 'WA' },
  { postCode: '6714', suburb: 'BULGARRA', state: 'WA' },
  { postCode: '6714', suburb: 'BURRUP', state: 'WA' },
  { postCode: '6714', suburb: 'CLEAVERVILLE', state: 'WA' },
  { postCode: '6714', suburb: 'COOYA POOYA', state: 'WA' },
  { postCode: '6714', suburb: 'GAP RIDGE', state: 'WA' },
  { postCode: '6714', suburb: 'GNOOREA', state: 'WA' },
  { postCode: '6714', suburb: 'KARRATHA', state: 'WA' },
  { postCode: '6714', suburb: 'KARRATHA INDUSTRIAL ESTATE', state: 'WA' },
  { postCode: '6714', suburb: 'MAITLAND', state: 'WA' },
  { postCode: '6714', suburb: 'MARDIE', state: 'WA' },
  { postCode: '6714', suburb: 'MILLARS WELL', state: 'WA' },
  { postCode: '6714', suburb: 'MOUNT ANKETELL', state: 'WA' },
  { postCode: '6714', suburb: 'MULATAGA', state: 'WA' },
  { postCode: '6714', suburb: 'NICKOL', state: 'WA' },
  { postCode: '6714', suburb: 'PEGS CREEK', state: 'WA' },
  { postCode: '6714', suburb: 'SHERLOCK', state: 'WA' },
  { postCode: '6714', suburb: 'STOVE HILL', state: 'WA' },
  { postCode: '6716', suburb: 'FORTESCUE', state: 'WA' },
  { postCode: '6716', suburb: 'HAMERSLEY RANGE', state: 'WA' },
  { postCode: '6716', suburb: 'MILLSTREAM', state: 'WA' },
  { postCode: '6716', suburb: 'PANNAWONICA', state: 'WA' },
  { postCode: '6718', suburb: 'ROEBOURNE', state: 'WA' },
  { postCode: '6718', suburb: 'WHIM CREEK', state: 'WA' },
  { postCode: '6720', suburb: 'COSSACK', state: 'WA' },
  { postCode: '6720', suburb: 'POINT SAMSON', state: 'WA' },
  { postCode: '6720', suburb: 'WICKHAM', state: 'WA' },
  { postCode: '6721', suburb: 'INDEE', state: 'WA' },
  { postCode: '6721', suburb: 'MUNDABULLANGANA', state: 'WA' },
  { postCode: '6721', suburb: 'PARDOO', state: 'WA' },
  { postCode: '6721', suburb: 'PORT HEDLAND', state: 'WA' },
  { postCode: '6721', suburb: 'REDBANK', state: 'WA' },
  { postCode: '6721', suburb: 'STRELLEY', state: 'WA' },
  { postCode: '6721', suburb: 'WALLAREENYA', state: 'WA' },
  { postCode: '6721', suburb: 'WEDGEFIELD', state: 'WA' },
  { postCode: '6722', suburb: 'BOODARIE', state: 'WA' },
  { postCode: '6722', suburb: 'DE GREY', state: 'WA' },
  { postCode: '6722', suburb: 'FINUCANE', state: 'WA' },
  { postCode: '6722', suburb: 'PIPPINGARRA', state: 'WA' },
  { postCode: '6722', suburb: 'SOUTH HEDLAND', state: 'WA' },
  { postCode: '6725', suburb: 'BILINGURR', state: 'WA' },
  { postCode: '6725', suburb: 'BROOME', state: 'WA' },
  { postCode: '6725', suburb: 'DAMPIER PENINSULA', state: 'WA' },
  { postCode: '6725', suburb: 'DJUGUN', state: 'WA' },
  { postCode: '6725', suburb: 'EIGHTY MILE BEACH', state: 'WA' },
  { postCode: '6725', suburb: 'GINGERAH', state: 'WA' },
  { postCode: '6725', suburb: 'LAGRANGE', state: 'WA' },
  { postCode: '6725', suburb: 'MINYIRR', state: 'WA' },
  { postCode: '6725', suburb: 'ROEBUCK', state: 'WA' },
  { postCode: '6725', suburb: 'WATERBANK', state: 'WA' },
  { postCode: '6726', suburb: 'CABLE BEACH', state: 'WA' },
  { postCode: '6728', suburb: 'CAMBALLIN', state: 'WA' },
  { postCode: '6728', suburb: 'DERBY', state: 'WA' },
  { postCode: '6728', suburb: 'GEEGULLY CREEK', state: 'WA' },
  { postCode: '6728', suburb: 'JARLMADANGAH BURRU', state: 'WA' },
  { postCode: '6728', suburb: 'KIMBOLTON', state: 'WA' },
  { postCode: '6728', suburb: 'KING LEOPOLD RANGES', state: 'WA' },
  { postCode: '6728', suburb: 'MEDA', state: 'WA' },
  { postCode: '6728', suburb: 'ST GEORGE RANGES', state: 'WA' },
  { postCode: '6728', suburb: 'WILLARE', state: 'WA' },
  { postCode: '6733', suburb: 'KOOLAN ISLAND', state: 'WA' },
  { postCode: '6740', suburb: 'DRYSDALE RIVER', state: 'WA' },
  { postCode: '6740', suburb: 'KALUMBURU', state: 'WA' },
  { postCode: '6740', suburb: 'MITCHELL PLATEAU', state: 'WA' },
  { postCode: '6740', suburb: 'OOMBULGURRI', state: 'WA' },
  { postCode: '6740', suburb: 'PRINCE REGENT RIVER', state: 'WA' },
  { postCode: '6740', suburb: 'WYNDHAM', state: 'WA' },
  { postCode: '6743', suburb: 'CAMBRIDGE GULF', state: 'WA' },
  { postCode: '6743', suburb: 'DURACK', state: 'WA' },
  { postCode: '6743', suburb: 'GIBB', state: 'WA' },
  { postCode: '6743', suburb: 'KUNUNURRA', state: 'WA' },
  { postCode: '6743', suburb: 'LAKE ARGYLE', state: 'WA' },
  { postCode: '6743', suburb: 'WARMUN', state: 'WA' },
  { postCode: '6743', suburb: 'WIJILAWARRIM', state: 'WA' },
  { postCode: '6751', suburb: 'CHICHESTER', state: 'WA' },
  { postCode: '6751', suburb: 'INNAWANGA', state: 'WA' },
  { postCode: '6751', suburb: 'JUNA DOWNS', state: 'WA' },
  { postCode: '6751', suburb: 'KARIJINI', state: 'WA' },
  { postCode: '6751', suburb: 'MOUNT SHEILA', state: 'WA' },
  { postCode: '6751', suburb: 'MULGA DOWNS', state: 'WA' },
  { postCode: '6751', suburb: 'NANUTARRA', state: 'WA' },
  { postCode: '6751', suburb: 'ROCKLEA', state: 'WA' },
  { postCode: '6751', suburb: 'TOM PRICE', state: 'WA' },
  { postCode: '6751', suburb: 'WITTENOOM', state: 'WA' },
  { postCode: '6753', suburb: 'JIGALONG', state: 'WA' },
  { postCode: '6753', suburb: 'NEWMAN', state: 'WA' },
  { postCode: '6754', suburb: 'PARABURDOO', state: 'WA' },
  { postCode: '6758', suburb: 'NULLAGINE', state: 'WA' },
  { postCode: '6760', suburb: 'MARBLE BAR', state: 'WA' },
  { postCode: '6762', suburb: 'TELFER', state: 'WA' },
  { postCode: '6765', suburb: 'FITZROY CROSSING', state: 'WA' },
  { postCode: '6765', suburb: 'KUPARTIYA', state: 'WA' },
  { postCode: '6765', suburb: 'MOUNT HARDMAN', state: 'WA' },
  { postCode: '6770', suburb: 'HALLS CREEK', state: 'WA' },
  { postCode: '6770', suburb: 'KUNDAT DJARU', state: 'WA' },
  { postCode: '6770', suburb: 'MCBEATH', state: 'WA' },
  { postCode: '6770', suburb: 'MUELLER RANGES', state: 'WA' },
  { postCode: '6770', suburb: 'ORD RIVER', state: 'WA' },
  { postCode: '6770', suburb: 'PURNULULU', state: 'WA' },
  { postCode: '6770', suburb: 'STURT CREEK', state: 'WA' },
  { postCode: '6770', suburb: 'TANAMI', state: 'WA' },
  { postCode: '6798', suburb: 'CHRISTMAS ISLAND', state: 'WA' },
  {
    postCode: '6799',
    suburb: 'HOME ISLAND COCOS (KEELING) ISLANDS',
    state: 'WA',
  },
  {
    postCode: '6799',
    suburb: 'WEST ISLAND COCOS (KEELING) ISLANDS',
    state: 'WA',
  },
  { postCode: '6831', suburb: 'PERTH ST GEORGES TCE', state: 'WA' },
  { postCode: '6837', suburb: 'PERTH', state: 'WA' },
  { postCode: '6838', suburb: 'PERTH', state: 'WA' },
  { postCode: '6839', suburb: 'PERTH', state: 'WA' },
  { postCode: '6840', suburb: 'PERTH', state: 'WA' },
  { postCode: '6841', suburb: 'PERTH', state: 'WA' },
  { postCode: '6842', suburb: 'PERTH', state: 'WA' },
  { postCode: '6843', suburb: 'PERTH', state: 'WA' },
  { postCode: '6844', suburb: 'PERTH', state: 'WA' },
  { postCode: '6845', suburb: 'PERTH', state: 'WA' },
  { postCode: '6846', suburb: 'PERTH', state: 'WA' },
  { postCode: '6847', suburb: 'PERTH', state: 'WA' },
  { postCode: '6848', suburb: 'PERTH', state: 'WA' },
  { postCode: '6849', suburb: 'PERTH BC', state: 'WA' },
  { postCode: '6850', suburb: 'CLOISTERS SQUARE PO', state: 'WA' },
  { postCode: '6865', suburb: 'NORTHBRIDGE', state: 'WA' },
  { postCode: '6872', suburb: 'WEST PERTH', state: 'WA' },
  { postCode: '6892', suburb: 'EAST PERTH', state: 'WA' },
  { postCode: '6901', suburb: 'WEST LEEDERVILLE', state: 'WA' },
  { postCode: '6902', suburb: 'LEEDERVILLE', state: 'WA' },
  { postCode: '6903', suburb: 'LEEDERVILLE', state: 'WA' },
  { postCode: '6904', suburb: 'SUBIACO PO', state: 'WA' },
  { postCode: '6905', suburb: 'NORTHLANDS PO', state: 'WA' },
  { postCode: '6906', suburb: 'NORTH PERTH', state: 'WA' },
  { postCode: '6907', suburb: 'NEDLANDS', state: 'WA' },
  { postCode: '6909', suburb: 'NEDLANDS', state: 'WA' },
  { postCode: '6910', suburb: 'CLAREMONT', state: 'WA' },
  { postCode: '6911', suburb: 'COTTESLOE', state: 'WA' },
  { postCode: '6912', suburb: 'MOSMAN PARK', state: 'WA' },
  { postCode: '6913', suburb: 'WEMBLEY', state: 'WA' },
  { postCode: '6914', suburb: 'BALCATTA', state: 'WA' },
  { postCode: '6915', suburb: 'MOUNT HAWTHORN', state: 'WA' },
  { postCode: '6916', suburb: 'OSBORNE PARK', state: 'WA' },
  { postCode: '6916', suburb: 'OSBORNE PARK DC', state: 'WA' },
  { postCode: '6917', suburb: 'OSBORNE PARK', state: 'WA' },
  { postCode: '6918', suburb: 'INNALOO', state: 'WA' },
  { postCode: '6919', suburb: 'JOONDALUP DC', state: 'WA' },
  { postCode: '6920', suburb: 'NORTH BEACH', state: 'WA' },
  { postCode: '6921', suburb: 'KARRINYUP', state: 'WA' },
  { postCode: '6922', suburb: 'SCARBOROUGH', state: 'WA' },
  { postCode: '6923', suburb: 'HILLARYS', state: 'WA' },
  { postCode: '6924', suburb: 'GREENWOOD', state: 'WA' },
  { postCode: '6925', suburb: 'WALLISTON DC', state: 'WA' },
  { postCode: '6926', suburb: 'KALAMUNDA', state: 'WA' },
  { postCode: '6929', suburb: 'MOUNT LAWLEY', state: 'WA' },
  { postCode: '6931', suburb: 'MAYLANDS', state: 'WA' },
  { postCode: '6932', suburb: 'INGLEWOOD', state: 'WA' },
  { postCode: '6933', suburb: 'BAYSWATER', state: 'WA' },
  { postCode: '6934', suburb: 'BASSENDEAN', state: 'WA' },
  { postCode: '6935', suburb: 'GUILDFORD', state: 'WA' },
  { postCode: '6936', suburb: 'MIDLAND DC', state: 'WA' },
  { postCode: '6939', suburb: 'TUART HILL', state: 'WA' },
  { postCode: '6941', suburb: 'MIRRABOOKA', state: 'WA' },
  { postCode: '6942', suburb: 'BASSENDEAN DC', state: 'WA' },
  { postCode: '6943', suburb: 'MORLEY', state: 'WA' },
  { postCode: '6944', suburb: 'MALAGA', state: 'WA' },
  { postCode: '6945', suburb: 'MALAGA DC', state: 'WA' },
  { postCode: '6946', suburb: 'WANNEROO', state: 'WA' },
  { postCode: '6947', suburb: 'WANGARA DC', state: 'WA' },
  { postCode: '6951', suburb: 'SOUTH PERTH', state: 'WA' },
  { postCode: '6952', suburb: 'COMO', state: 'WA' },
  { postCode: '6953', suburb: 'APPLECROSS', state: 'WA' },
  { postCode: '6954', suburb: 'BOORAGOON', state: 'WA' },
  { postCode: '6955', suburb: 'WILLETTON', state: 'WA' },
  { postCode: '6956', suburb: 'MELVILLE', state: 'WA' },
  { postCode: '6957', suburb: 'PALMYRA', state: 'WA' },
  {
    postCode: '6958',
    suburb: 'ROYAL AUSTRALIAN NAVY WARSHIPS',
    state: 'WA',
  },
  { postCode: '6959', suburb: 'FREMANTLE', state: 'WA' },
  { postCode: '6960', suburb: 'MYAREE BC', state: 'WA' },
  { postCode: '6961', suburb: 'PALMYRA DC', state: 'WA' },
  { postCode: '6963', suburb: 'HAMILTON HILL', state: 'WA' },
  { postCode: '6964', suburb: 'SUCCESS', state: 'WA' },
  { postCode: '6965', suburb: 'BIBRA LAKE DC', state: 'WA' },
  { postCode: '6966', suburb: 'KWINANA', state: 'WA' },
  { postCode: '6967', suburb: 'ROCKINGHAM DC', state: 'WA' },
  { postCode: '6968', suburb: 'ROCKINGHAM', state: 'WA' },
  { postCode: '6969', suburb: 'ROCKINGHAM BEACH', state: 'WA' },
  { postCode: '6970', suburb: 'CANNING VALE DC', state: 'WA' },
  { postCode: '6979', suburb: 'VICTORIA PARK', state: 'WA' },
  { postCode: '6981', suburb: 'EAST VICTORIA PARK', state: 'WA' },
  { postCode: '6982', suburb: 'BENTLEY', state: 'WA' },
  { postCode: '6983', suburb: 'BENTLEY DC', state: 'WA' },
  { postCode: '6984', suburb: 'BELMONT', state: 'WA' },
  { postCode: '6985', suburb: 'CLOVERDALE', state: 'WA' },
  { postCode: '6986', suburb: 'WELSHPOOL DC', state: 'WA' },
  { postCode: '6987', suburb: 'CANNINGTON', state: 'WA' },
  { postCode: '6988', suburb: 'THORNLIE', state: 'WA' },
  { postCode: '6989', suburb: 'MADDINGTON', state: 'WA' },
  { postCode: '6990', suburb: 'GOSNELLS', state: 'WA' },
  { postCode: '6991', suburb: 'KELMSCOTT', state: 'WA' },
  { postCode: '6992', suburb: 'ARMADALE', state: 'WA' },
  { postCode: '6997', suburb: 'KELMSCOTT DC', state: 'WA' },
  { postCode: '7000', suburb: 'GLEBE', state: 'TAS' },
  { postCode: '7000', suburb: 'HOBART', state: 'TAS' },
  { postCode: '7000', suburb: 'MOUNT STUART', state: 'TAS' },
  { postCode: '7000', suburb: 'NORTH HOBART', state: 'TAS' },
  { postCode: '7000', suburb: 'QUEENS DOMAIN', state: 'TAS' },
  { postCode: '7000', suburb: 'WEST HOBART', state: 'TAS' },
  { postCode: '7001', suburb: 'HOBART', state: 'TAS' },
  { postCode: '7002', suburb: 'NORTH HOBART', state: 'TAS' },
  { postCode: '7004', suburb: 'BATTERY POINT', state: 'TAS' },
  { postCode: '7004', suburb: 'SOUTH HOBART', state: 'TAS' },
  { postCode: '7005', suburb: 'DYNNYRNE', state: 'TAS' },
  { postCode: '7005', suburb: 'LOWER SANDY BAY', state: 'TAS' },
  { postCode: '7005', suburb: 'SANDY BAY', state: 'TAS' },
  { postCode: '7006', suburb: 'SANDY BAY', state: 'TAS' },
  { postCode: '7007', suburb: 'MOUNT NELSON', state: 'TAS' },
  { postCode: '7007', suburb: 'TOLMANS HILL', state: 'TAS' },
  { postCode: '7008', suburb: 'LENAH VALLEY', state: 'TAS' },
  { postCode: '7008', suburb: 'NEW TOWN', state: 'TAS' },
  { postCode: '7009', suburb: 'DERWENT PARK', state: 'TAS' },
  { postCode: '7009', suburb: 'LUTANA', state: 'TAS' },
  { postCode: '7009', suburb: 'MOONAH', state: 'TAS' },
  { postCode: '7009', suburb: 'WEST MOONAH', state: 'TAS' },
  { postCode: '7010', suburb: 'DOWSING POINT', state: 'TAS' },
  { postCode: '7010', suburb: 'GLENORCHY', state: 'TAS' },
  { postCode: '7010', suburb: 'GOODWOOD', state: 'TAS' },
  { postCode: '7010', suburb: 'MONTROSE', state: 'TAS' },
  { postCode: '7010', suburb: 'ROSETTA', state: 'TAS' },
  { postCode: '7011', suburb: 'AUSTINS FERRY', state: 'TAS' },
  { postCode: '7011', suburb: 'BERRIEDALE', state: 'TAS' },
  { postCode: '7011', suburb: 'CHIGWELL', state: 'TAS' },
  { postCode: '7011', suburb: 'CLAREMONT', state: 'TAS' },
  { postCode: '7012', suburb: 'COLLINSVALE', state: 'TAS' },
  { postCode: '7012', suburb: 'GLENLUSK', state: 'TAS' },
  { postCode: '7015', suburb: 'GEILSTON BAY', state: 'TAS' },
  { postCode: '7015', suburb: 'LINDISFARNE', state: 'TAS' },
  { postCode: '7015', suburb: 'ROSE BAY', state: 'TAS' },
  { postCode: '7016', suburb: 'RISDON VALE', state: 'TAS' },
  { postCode: '7017', suburb: 'GRASSTREE HILL', state: 'TAS' },
  { postCode: '7017', suburb: 'HONEYWOOD', state: 'TAS' },
  { postCode: '7017', suburb: 'OLD BEACH', state: 'TAS' },
  { postCode: '7017', suburb: 'OTAGO', state: 'TAS' },
  { postCode: '7017', suburb: 'RISDON', state: 'TAS' },
  { postCode: '7017', suburb: 'TEA TREE', state: 'TAS' },
  { postCode: '7018', suburb: 'BELLERIVE', state: 'TAS' },
  { postCode: '7018', suburb: 'HOWRAH', state: 'TAS' },
  { postCode: '7018', suburb: 'MONTAGU BAY', state: 'TAS' },
  { postCode: '7018', suburb: 'MORNINGTON', state: 'TAS' },
  { postCode: '7018', suburb: 'ROSNY', state: 'TAS' },
  { postCode: '7018', suburb: 'ROSNY PARK', state: 'TAS' },
  { postCode: '7018', suburb: 'TRANMERE', state: 'TAS' },
  { postCode: '7018', suburb: 'WARRANE', state: 'TAS' },
  { postCode: '7019', suburb: 'CLARENDON VALE', state: 'TAS' },
  { postCode: '7019', suburb: 'OAKDOWNS', state: 'TAS' },
  { postCode: '7019', suburb: 'ROKEBY', state: 'TAS' },
  { postCode: '7020', suburb: 'CLIFTON BEACH', state: 'TAS' },
  { postCode: '7020', suburb: 'SANDFORD', state: 'TAS' },
  { postCode: '7021', suburb: 'LAUDERDALE', state: 'TAS' },
  { postCode: '7022', suburb: 'SOUTH ARM', state: 'TAS' },
  { postCode: '7023', suburb: 'OPOSSUM BAY', state: 'TAS' },
  { postCode: '7024', suburb: 'CREMORNE', state: 'TAS' },
  { postCode: '7025', suburb: 'DULCOT', state: 'TAS' },
  { postCode: '7025', suburb: 'RICHMOND', state: 'TAS' },
  { postCode: '7026', suburb: 'CAMPANIA', state: 'TAS' },
  { postCode: '7027', suburb: 'COLEBROOK', state: 'TAS' },
  { postCode: '7030', suburb: 'APSLEY', state: 'TAS' },
  { postCode: '7030', suburb: 'ARTHURS LAKE', state: 'TAS' },
  { postCode: '7030', suburb: 'BAGDAD', state: 'TAS' },
  { postCode: '7030', suburb: 'BOTHWELL', state: 'TAS' },
  { postCode: '7030', suburb: 'BRIDGEWATER', state: 'TAS' },
  { postCode: '7030', suburb: 'BRIGHTON', state: 'TAS' },
  { postCode: '7030', suburb: 'BROADMARSH', state: 'TAS' },
  { postCode: '7030', suburb: 'CRAMPS BAY', state: 'TAS' },
  { postCode: '7030', suburb: 'DROMEDARY', state: 'TAS' },
  { postCode: '7030', suburb: 'DYSART', state: 'TAS' },
  { postCode: '7030', suburb: 'ELDERSLIE', state: 'TAS' },
  { postCode: '7030', suburb: 'FLINTSTONE', state: 'TAS' },
  { postCode: '7030', suburb: 'GAGEBROOK', state: 'TAS' },
  { postCode: '7030', suburb: 'GRANTON', state: 'TAS' },
  { postCode: '7030', suburb: 'HERDSMANS COVE', state: 'TAS' },
  { postCode: '7030', suburb: 'HERMITAGE', state: 'TAS' },
  { postCode: '7030', suburb: 'INTERLAKEN', state: 'TAS' },
  { postCode: '7030', suburb: 'JERICHO', state: 'TAS' },
  { postCode: '7030', suburb: 'KEMPTON', state: 'TAS' },
  { postCode: '7030', suburb: 'LAKE SORELL', state: 'TAS' },
  { postCode: '7030', suburb: 'LIAWENEE', state: 'TAS' },
  { postCode: '7030', suburb: 'LOWER MARSHES', state: 'TAS' },
  { postCode: '7030', suburb: 'MANGALORE', state: 'TAS' },
  { postCode: '7030', suburb: 'MELTON MOWBRAY', state: 'TAS' },
  { postCode: '7030', suburb: 'MIENA', state: 'TAS' },
  { postCode: '7030', suburb: 'MILLERS BLUFF', state: 'TAS' },
  { postCode: '7030', suburb: 'MORASS BAY', state: 'TAS' },
  { postCode: '7030', suburb: 'PELHAM', state: 'TAS' },
  { postCode: '7030', suburb: 'PONTVILLE', state: 'TAS' },
  { postCode: '7030', suburb: 'SHANNON', state: 'TAS' },
  { postCode: '7030', suburb: 'STEPPES', state: 'TAS' },
  { postCode: '7030', suburb: 'TODS CORNER', state: 'TAS' },
  { postCode: '7030', suburb: 'WADDAMANA', state: 'TAS' },
  { postCode: '7030', suburb: 'WILBURVILLE', state: 'TAS' },
  { postCode: '7050', suburb: 'KINGSTON', state: 'TAS' },
  { postCode: '7050', suburb: 'KINGSTON BEACH', state: 'TAS' },
  { postCode: '7051', suburb: 'KINGSTON', state: 'TAS' },
  { postCode: '7052', suburb: 'BLACKMANS BAY', state: 'TAS' },
  { postCode: '7053', suburb: 'BONNET HILL', state: 'TAS' },
  { postCode: '7053', suburb: 'TAROONA', state: 'TAS' },
  { postCode: '7054', suburb: 'BARRETTA', state: 'TAS' },
  { postCode: '7054', suburb: 'CONINGHAM', state: 'TAS' },
  { postCode: '7054', suburb: 'ELECTRONA', state: 'TAS' },
  { postCode: '7054', suburb: 'FERN TREE', state: 'TAS' },
  { postCode: '7054', suburb: 'HOWDEN', state: 'TAS' },
  { postCode: '7054', suburb: 'LESLIE VALE', state: 'TAS' },
  { postCode: '7054', suburb: 'LOWER SNUG', state: 'TAS' },
  { postCode: '7054', suburb: 'MARGATE', state: 'TAS' },
  { postCode: '7054', suburb: 'NEIKA', state: 'TAS' },
  { postCode: '7054', suburb: 'RIDGEWAY', state: 'TAS' },
  { postCode: '7054', suburb: 'SNUG', state: 'TAS' },
  { postCode: '7054', suburb: 'TINDERBOX', state: 'TAS' },
  { postCode: '7054', suburb: 'WELLINGTON PARK', state: 'TAS' },
  { postCode: '7055', suburb: 'HUNTINGFIELD', state: 'TAS' },
  { postCode: '7109', suburb: 'CRABTREE', state: 'TAS' },
  { postCode: '7109', suburb: 'CRADOC', state: 'TAS' },
  { postCode: '7109', suburb: 'GLAZIERS BAY', state: 'TAS' },
  { postCode: '7109', suburb: 'GLEN HUON', state: 'TAS' },
  { postCode: '7109', suburb: 'GLENDEVIE', state: 'TAS' },
  { postCode: '7109', suburb: 'GROVE', state: 'TAS' },
  { postCode: '7109', suburb: 'HASTINGS', state: 'TAS' },
  { postCode: '7109', suburb: 'HUONVILLE', state: 'TAS' },
  { postCode: '7109', suburb: 'IDA BAY', state: 'TAS' },
  { postCode: '7109', suburb: 'JUDBURY', state: 'TAS' },
  { postCode: '7109', suburb: 'LONNAVALE', state: 'TAS' },
  { postCode: '7109', suburb: 'LOWER LONGLEY', state: 'TAS' },
  { postCode: '7109', suburb: 'LOWER WATTLE GROVE', state: 'TAS' },
  { postCode: '7109', suburb: 'LUCASTON', state: 'TAS' },
  { postCode: '7109', suburb: 'LUNE RIVER', state: 'TAS' },
  { postCode: '7109', suburb: 'LYMINGTON', state: 'TAS' },
  { postCode: '7109', suburb: 'MOUNTAIN RIVER', state: 'TAS' },
  { postCode: '7109', suburb: 'PETCHEYS BAY', state: 'TAS' },
  { postCode: '7109', suburb: 'RAMINEA', state: 'TAS' },
  { postCode: '7109', suburb: 'RANELAGH', state: 'TAS' },
  { postCode: '7109', suburb: 'RECHERCHE', state: 'TAS' },
  { postCode: '7109', suburb: 'SOUTHPORT', state: 'TAS' },
  { postCode: '7109', suburb: 'SOUTHPORT LAGOON', state: 'TAS' },
  { postCode: '7109', suburb: 'STRATHBLANE', state: 'TAS' },
  { postCode: '7109', suburb: 'WATERLOO', state: 'TAS' },
  { postCode: '7109', suburb: 'WATTLE GROVE', state: 'TAS' },
  { postCode: '7109', suburb: 'WOODSTOCK', state: 'TAS' },
  { postCode: '7112', suburb: 'ABELS BAY', state: 'TAS' },
  { postCode: '7112', suburb: 'CHARLOTTE COVE', state: 'TAS' },
  { postCode: '7112', suburb: 'CYGNET', state: 'TAS' },
  { postCode: '7112', suburb: 'DEEP BAY', state: 'TAS' },
  { postCode: '7112', suburb: 'EGGS AND BACON BAY', state: 'TAS' },
  { postCode: '7112', suburb: 'GARDEN ISLAND CREEK', state: 'TAS' },
  { postCode: '7112', suburb: 'GARDNERS BAY', state: 'TAS' },
  { postCode: '7112', suburb: 'NICHOLLS RIVULET', state: 'TAS' },
  { postCode: '7112', suburb: 'RANDALLS BAY', state: 'TAS' },
  { postCode: '7112', suburb: 'VERONA SANDS', state: 'TAS' },
  { postCode: '7113', suburb: 'FRANKLIN', state: 'TAS' },
  { postCode: '7116', suburb: 'BROOKS BAY', state: 'TAS' },
  { postCode: '7116', suburb: 'CAIRNS BAY', state: 'TAS' },
  { postCode: '7116', suburb: 'CASTLE FORBES BAY', state: 'TAS' },
  { postCode: '7116', suburb: 'GEEVESTON', state: 'TAS' },
  { postCode: '7116', suburb: 'POLICE POINT', state: 'TAS' },
  { postCode: '7116', suburb: 'PORT HUON', state: 'TAS' },
  { postCode: '7116', suburb: 'SURGES BAY', state: 'TAS' },
  { postCode: '7116', suburb: 'SURVEYORS BAY', state: 'TAS' },
  { postCode: '7117', suburb: 'DOVER', state: 'TAS' },
  { postCode: '7119', suburb: 'STONOR', state: 'TAS' },
  { postCode: '7120', suburb: 'ANDOVER', state: 'TAS' },
  { postCode: '7120', suburb: 'ANTILL PONDS', state: 'TAS' },
  { postCode: '7120', suburb: 'BADEN', state: 'TAS' },
  { postCode: '7120', suburb: 'LEMONT', state: 'TAS' },
  { postCode: '7120', suburb: 'LEVENDALE', state: 'TAS' },
  { postCode: '7120', suburb: 'MOUNT SEYMOUR', state: 'TAS' },
  { postCode: '7120', suburb: 'OATLANDS', state: 'TAS' },
  { postCode: '7120', suburb: 'PARATTAH', state: 'TAS' },
  { postCode: '7120', suburb: 'PAWTELLA', state: 'TAS' },
  { postCode: '7120', suburb: 'RHYNDASTON', state: 'TAS' },
  { postCode: '7120', suburb: 'STONEHENGE', state: 'TAS' },
  { postCode: '7120', suburb: 'SWANSTON', state: 'TAS' },
  { postCode: '7120', suburb: 'TIBERIAS', state: 'TAS' },
  { postCode: '7120', suburb: 'TUNBRIDGE', state: 'TAS' },
  { postCode: '7120', suburb: 'TUNNACK', state: 'TAS' },
  { postCode: '7120', suburb: 'WHITEFOORD', state: 'TAS' },
  { postCode: '7120', suburb: 'WOODBURY', state: 'TAS' },
  { postCode: '7120', suburb: 'WOODSDALE', state: 'TAS' },
  { postCode: '7120', suburb: 'YORK PLAINS', state: 'TAS' },
  { postCode: '7139', suburb: 'STRATHGORDON', state: 'TAS' },
  { postCode: '7140', suburb: 'BLACK HILLS', state: 'TAS' },
  { postCode: '7140', suburb: 'BOYER', state: 'TAS' },
  { postCode: '7140', suburb: 'BRADYS LAKE', state: 'TAS' },
  { postCode: '7140', suburb: 'BRONTE PARK', state: 'TAS' },
  { postCode: '7140', suburb: 'BUSHY PARK', state: 'TAS' },
  { postCode: '7140', suburb: 'BUTLERS GORGE', state: 'TAS' },
  { postCode: '7140', suburb: 'DEE', state: 'TAS' },
  { postCode: '7140', suburb: 'DERWENT BRIDGE', state: 'TAS' },
  { postCode: '7140', suburb: 'ELLENDALE', state: 'TAS' },
  { postCode: '7140', suburb: 'FENTONBURY', state: 'TAS' },
  { postCode: '7140', suburb: 'FITZGERALD', state: 'TAS' },
  { postCode: '7140', suburb: 'FLORENTINE', state: 'TAS' },
  { postCode: '7140', suburb: 'GLENFERN', state: 'TAS' },
  { postCode: '7140', suburb: 'GLENORA', state: 'TAS' },
  { postCode: '7140', suburb: 'GRETNA', state: 'TAS' },
  { postCode: '7140', suburb: 'HAMILTON', state: 'TAS' },
  { postCode: '7140', suburb: 'HAYES', state: 'TAS' },
  { postCode: '7140', suburb: 'HOLLOW TREE', state: 'TAS' },
  { postCode: '7140', suburb: 'KARANJA', state: 'TAS' },
  { postCode: '7140', suburb: 'LACHLAN', state: 'TAS' },
  { postCode: '7140', suburb: 'LAKE ST CLAIR', state: 'TAS' },
  { postCode: '7140', suburb: 'LAWITTA', state: 'TAS' },
  { postCode: '7140', suburb: 'LITTLE PINE LAGOON', state: 'TAS' },
  { postCode: '7140', suburb: 'LONDON LAKES', state: 'TAS' },
  { postCode: '7140', suburb: 'MACQUARIE PLAINS', state: 'TAS' },
  { postCode: '7140', suburb: 'MAGRA', state: 'TAS' },
  { postCode: '7140', suburb: 'MALBINA', state: 'TAS' },
  { postCode: '7140', suburb: 'MAYDENA', state: 'TAS' },
  { postCode: '7140', suburb: 'MEADOWBANK', state: 'TAS' },
  { postCode: '7140', suburb: 'MOLESWORTH', state: 'TAS' },
  { postCode: '7140', suburb: 'MOOGARA', state: 'TAS' },
  { postCode: '7140', suburb: 'MOUNT FIELD', state: 'TAS' },
  { postCode: '7140', suburb: 'MOUNT LLOYD', state: 'TAS' },
  { postCode: '7140', suburb: 'NATIONAL PARK', state: 'TAS' },
  { postCode: '7140', suburb: 'NEW NORFOLK', state: 'TAS' },
  { postCode: '7140', suburb: 'OSTERLEY', state: 'TAS' },
  { postCode: '7140', suburb: 'OUSE', state: 'TAS' },
  { postCode: '7140', suburb: 'PLENTY', state: 'TAS' },
  { postCode: '7140', suburb: 'ROSEGARLAND', state: 'TAS' },
  { postCode: '7140', suburb: 'SORELL CREEK', state: 'TAS' },
  { postCode: '7140', suburb: 'STRICKLAND', state: 'TAS' },
  { postCode: '7140', suburb: 'STYX', state: 'TAS' },
  { postCode: '7140', suburb: 'TARRALEAH', state: 'TAS' },
  { postCode: '7140', suburb: 'TYENNA', state: 'TAS' },
  { postCode: '7140', suburb: 'UXBRIDGE', state: 'TAS' },
  { postCode: '7140', suburb: 'VICTORIA VALLEY', state: 'TAS' },
  { postCode: '7140', suburb: 'WAYATINAH', state: 'TAS' },
  { postCode: '7140', suburb: 'WESTERWAY', state: 'TAS' },
  { postCode: '7150', suburb: 'ADVENTURE BAY', state: 'TAS' },
  { postCode: '7150', suburb: 'ALLENS RIVULET', state: 'TAS' },
  { postCode: '7150', suburb: 'ALONNAH', state: 'TAS' },
  { postCode: '7150', suburb: 'APOLLO BAY', state: 'TAS' },
  { postCode: '7150', suburb: 'BARNES BAY', state: 'TAS' },
  { postCode: '7150', suburb: 'DENNES POINT', state: 'TAS' },
  { postCode: '7150', suburb: 'GORDON', state: 'TAS' },
  { postCode: '7150', suburb: 'GREAT BAY', state: 'TAS' },
  { postCode: '7150', suburb: 'KAOOTA', state: 'TAS' },
  { postCode: '7150', suburb: 'KILLORA', state: 'TAS' },
  { postCode: '7150', suburb: 'LONGLEY', state: 'TAS' },
  { postCode: '7150', suburb: 'LUNAWANNA', state: 'TAS' },
  { postCode: '7150', suburb: 'NORTH BRUNY', state: 'TAS' },
  { postCode: '7150', suburb: 'OYSTER COVE', state: 'TAS' },
  { postCode: '7150', suburb: 'PELVERATA', state: 'TAS' },
  { postCode: '7150', suburb: 'SANDFLY', state: 'TAS' },
  { postCode: '7150', suburb: 'SIMPSONS BAY', state: 'TAS' },
  { postCode: '7150', suburb: 'SOUTH BRUNY', state: 'TAS' },
  { postCode: '7150', suburb: 'UPPER WOODSTOCK', state: 'TAS' },
  { postCode: '7151', suburb: 'CASEY', state: 'TAS' },
  { postCode: '7151', suburb: 'DAVIS', state: 'TAS' },
  { postCode: '7151', suburb: 'HEARD ISLAND', state: 'TAS' },
  { postCode: '7151', suburb: 'MACQUARIE ISLAND', state: 'TAS' },
  { postCode: '7151', suburb: 'MAWSON', state: 'TAS' },
  { postCode: '7151', suburb: 'MCDONALD ISLANDS', state: 'TAS' },
  { postCode: '7155', suburb: 'KETTERING', state: 'TAS' },
  { postCode: '7162', suburb: 'BIRCHS BAY', state: 'TAS' },
  { postCode: '7162', suburb: 'WOODBRIDGE', state: 'TAS' },
  { postCode: '7163', suburb: 'FLOWERPOT', state: 'TAS' },
  { postCode: '7163', suburb: 'MIDDLETON', state: 'TAS' },
  { postCode: '7170', suburb: 'ACTON PARK', state: 'TAS' },
  { postCode: '7170', suburb: 'CAMBRIDGE', state: 'TAS' },
  { postCode: '7170', suburb: 'MOUNT RUMNEY', state: 'TAS' },
  { postCode: '7170', suburb: 'ROCHES BEACH', state: 'TAS' },
  { postCode: '7170', suburb: 'SEVEN MILE BEACH', state: 'TAS' },
  { postCode: '7171', suburb: 'MIDWAY POINT', state: 'TAS' },
  { postCode: '7171', suburb: 'PENNA', state: 'TAS' },
  { postCode: '7172', suburb: 'NUGENT', state: 'TAS' },
  { postCode: '7172', suburb: 'ORIELTON', state: 'TAS' },
  { postCode: '7172', suburb: 'PAWLEENA', state: 'TAS' },
  { postCode: '7172', suburb: 'SORELL', state: 'TAS' },
  { postCode: '7172', suburb: 'WATTLE HILL', state: 'TAS' },
  { postCode: '7173', suburb: 'CARLTON', state: 'TAS' },
  { postCode: '7173', suburb: 'CARLTON RIVER', state: 'TAS' },
  { postCode: '7173', suburb: 'CONNELLYS MARSH', state: 'TAS' },
  { postCode: '7173', suburb: 'DODGES FERRY', state: 'TAS' },
  { postCode: '7173', suburb: 'FORCETT', state: 'TAS' },
  { postCode: '7173', suburb: 'LEWISHAM', state: 'TAS' },
  { postCode: '7173', suburb: 'PRIMROSE SANDS', state: 'TAS' },
  { postCode: '7174', suburb: 'COPPING', state: 'TAS' },
  { postCode: '7175', suburb: 'BREAM CREEK', state: 'TAS' },
  { postCode: '7175', suburb: 'MARION BAY', state: 'TAS' },
  { postCode: '7176', suburb: 'KELLEVIE', state: 'TAS' },
  { postCode: '7177', suburb: 'BOOMER BAY', state: 'TAS' },
  { postCode: '7177', suburb: 'DUNALLEY', state: 'TAS' },
  { postCode: '7178', suburb: 'MURDUNNA', state: 'TAS' },
  { postCode: '7179', suburb: 'EAGLEHAWK NECK', state: 'TAS' },
  { postCode: '7180', suburb: 'TARANNA', state: 'TAS' },
  { postCode: '7182', suburb: 'CAPE PILLAR', state: 'TAS' },
  { postCode: '7182', suburb: 'FORTESCUE', state: 'TAS' },
  { postCode: '7182', suburb: 'PORT ARTHUR', state: 'TAS' },
  { postCode: '7183', suburb: 'HIGHCROFT', state: 'TAS' },
  { postCode: '7184', suburb: 'CAPE RAOUL', state: 'TAS' },
  { postCode: '7184', suburb: 'NUBEENA', state: 'TAS' },
  { postCode: '7184', suburb: 'STORMLEA', state: 'TAS' },
  { postCode: '7184', suburb: 'WHITE BEACH', state: 'TAS' },
  { postCode: '7185', suburb: 'PREMAYDENA', state: 'TAS' },
  { postCode: '7186', suburb: 'SALTWATER RIVER', state: 'TAS' },
  { postCode: '7186', suburb: 'SLOPING MAIN', state: 'TAS' },
  { postCode: '7187', suburb: 'KOONYA', state: 'TAS' },
  { postCode: '7190', suburb: 'APSLAWN', state: 'TAS' },
  { postCode: '7190', suburb: 'BUCKLAND', state: 'TAS' },
  { postCode: '7190', suburb: 'CRANBROOK', state: 'TAS' },
  { postCode: '7190', suburb: 'DOLPHIN SANDS', state: 'TAS' },
  { postCode: '7190', suburb: 'LITTLE SWANPORT', state: 'TAS' },
  { postCode: '7190', suburb: 'ORFORD', state: 'TAS' },
  { postCode: '7190', suburb: 'PONTYPOOL', state: 'TAS' },
  { postCode: '7190', suburb: 'RHEBAN', state: 'TAS' },
  { postCode: '7190', suburb: 'ROCKY HILLS', state: 'TAS' },
  { postCode: '7190', suburb: 'RUNNYMEDE', state: 'TAS' },
  { postCode: '7190', suburb: 'SPRING BEACH', state: 'TAS' },
  { postCode: '7190', suburb: 'SWANSEA', state: 'TAS' },
  { postCode: '7190', suburb: 'TRIABUNNA', state: 'TAS' },
  { postCode: '7209', suburb: 'ROSS', state: 'TAS' },
  { postCode: '7209', suburb: 'TOOMS LAKE', state: 'TAS' },
  { postCode: '7210', suburb: 'CAMPBELL TOWN', state: 'TAS' },
  { postCode: '7210', suburb: 'LAKE LEAKE', state: 'TAS' },
  { postCode: '7211', suburb: 'CLEVELAND', state: 'TAS' },
  { postCode: '7211', suburb: 'CONARA', state: 'TAS' },
  { postCode: '7211', suburb: 'EPPING FOREST', state: 'TAS' },
  { postCode: '7212', suburb: 'BEN LOMOND', state: 'TAS' },
  { postCode: '7212', suburb: 'BLESSINGTON', state: 'TAS' },
  { postCode: '7212', suburb: 'BURNS CREEK', state: 'TAS' },
  { postCode: '7212', suburb: 'DEDDINGTON', state: 'TAS' },
  { postCode: '7212', suburb: 'EVANDALE', state: 'TAS' },
  { postCode: '7212', suburb: 'NILE', state: 'TAS' },
  { postCode: '7212', suburb: 'UPPER BLESSINGTON', state: 'TAS' },
  { postCode: '7212', suburb: 'WESTERN JUNCTION', state: 'TAS' },
  { postCode: '7213', suburb: 'AVOCA', state: 'TAS' },
  { postCode: '7213', suburb: 'ROSSARDEN', state: 'TAS' },
  { postCode: '7213', suburb: 'ROYAL GEORGE', state: 'TAS' },
  { postCode: '7213', suburb: 'STORYS CREEK', state: 'TAS' },
  { postCode: '7214', suburb: 'FINGAL', state: 'TAS' },
  { postCode: '7214', suburb: 'MANGANA', state: 'TAS' },
  { postCode: '7214', suburb: 'MATHINNA', state: 'TAS' },
  { postCode: '7214', suburb: 'UPPER ESK', state: 'TAS' },
  { postCode: '7215', suburb: 'BEAUMARIS', state: 'TAS' },
  { postCode: '7215', suburb: 'BICHENO', state: 'TAS' },
  { postCode: '7215', suburb: 'CHAIN OF LAGOONS', state: 'TAS' },
  { postCode: '7215', suburb: 'COLES BAY', state: 'TAS' },
  { postCode: '7215', suburb: 'CORNWALL', state: 'TAS' },
  { postCode: '7215', suburb: 'DOUGLAS RIVER', state: 'TAS' },
  { postCode: '7215', suburb: 'DOUGLAS-APSLEY', state: 'TAS' },
  { postCode: '7215', suburb: 'FALMOUTH', state: 'TAS' },
  { postCode: '7215', suburb: 'FOUR MILE CREEK', state: 'TAS' },
  { postCode: '7215', suburb: 'FREYCINET', state: 'TAS' },
  { postCode: '7215', suburb: 'FRIENDLY BEACHES', state: 'TAS' },
  { postCode: '7215', suburb: 'GRAY', state: 'TAS' },
  { postCode: '7215', suburb: 'SCAMANDER', state: 'TAS' },
  { postCode: '7215', suburb: 'SEYMOUR', state: 'TAS' },
  { postCode: '7215', suburb: 'ST MARYS', state: 'TAS' },
  { postCode: '7215', suburb: 'UPPER SCAMANDER', state: 'TAS' },
  { postCode: '7216', suburb: 'AKAROA', state: 'TAS' },
  { postCode: '7216', suburb: 'BINALONG BAY', state: 'TAS' },
  { postCode: '7216', suburb: 'GOSHEN', state: 'TAS' },
  { postCode: '7216', suburb: 'GOULDS COUNTRY', state: 'TAS' },
  { postCode: '7216', suburb: 'LOTTAH', state: 'TAS' },
  { postCode: '7216', suburb: 'PYENGANA', state: 'TAS' },
  { postCode: '7216', suburb: 'ST HELENS', state: 'TAS' },
  { postCode: '7216', suburb: 'STIEGLITZ', state: 'TAS' },
  { postCode: '7216', suburb: 'THE GARDENS', state: 'TAS' },
  { postCode: '7248', suburb: 'INVERMAY', state: 'TAS' },
  { postCode: '7248', suburb: 'MAYFIELD', state: 'TAS' },
  { postCode: '7248', suburb: 'MOWBRAY', state: 'TAS' },
  { postCode: '7248', suburb: 'NEWNHAM', state: 'TAS' },
  { postCode: '7248', suburb: 'ROCHERLEA', state: 'TAS' },
  { postCode: '7249', suburb: 'KINGS MEADOWS', state: 'TAS' },
  { postCode: '7249', suburb: 'PUNCHBOWL', state: 'TAS' },
  { postCode: '7249', suburb: 'SOUTH LAUNCESTON', state: 'TAS' },
  { postCode: '7249', suburb: 'YOUNGTOWN', state: 'TAS' },
  { postCode: '7250', suburb: 'BLACKSTONE HEIGHTS', state: 'TAS' },
  { postCode: '7250', suburb: 'EAST LAUNCESTON', state: 'TAS' },
  { postCode: '7250', suburb: 'LAUNCESTON', state: 'TAS' },
  { postCode: '7250', suburb: 'NEWSTEAD', state: 'TAS' },
  { postCode: '7250', suburb: 'NORWOOD', state: 'TAS' },
  { postCode: '7250', suburb: 'PROSPECT', state: 'TAS' },
  { postCode: '7250', suburb: 'PROSPECT VALE', state: 'TAS' },
  { postCode: '7250', suburb: 'RAVENSWOOD', state: 'TAS' },
  { postCode: '7250', suburb: 'RIVERSIDE', state: 'TAS' },
  { postCode: '7250', suburb: 'ST LEONARDS', state: 'TAS' },
  { postCode: '7250', suburb: 'SUMMERHILL', state: 'TAS' },
  { postCode: '7250', suburb: 'TRAVELLERS REST', state: 'TAS' },
  { postCode: '7250', suburb: 'TREVALLYN', state: 'TAS' },
  { postCode: '7250', suburb: 'WAVERLEY', state: 'TAS' },
  { postCode: '7250', suburb: 'WEST LAUNCESTON', state: 'TAS' },
  { postCode: '7252', suburb: 'BEECHFORD', state: 'TAS' },
  { postCode: '7252', suburb: 'DILSTON', state: 'TAS' },
  { postCode: '7252', suburb: 'HILLWOOD', state: 'TAS' },
  { postCode: '7252', suburb: 'LEFROY', state: 'TAS' },
  { postCode: '7252', suburb: 'LULWORTH', state: 'TAS' },
  { postCode: '7252', suburb: 'MOUNT DIRECTION', state: 'TAS' },
  { postCode: '7252', suburb: 'PIPERS RIVER', state: 'TAS' },
  { postCode: '7252', suburb: 'STONY HEAD', state: 'TAS' },
  { postCode: '7252', suburb: 'SWAN BAY', state: 'TAS' },
  { postCode: '7252', suburb: 'WEYMOUTH', state: 'TAS' },
  { postCode: '7252', suburb: 'WINDERMERE', state: 'TAS' },
  { postCode: '7253', suburb: 'BELL BAY', state: 'TAS' },
  { postCode: '7253', suburb: 'GEORGE TOWN', state: 'TAS' },
  { postCode: '7253', suburb: 'LONG REACH', state: 'TAS' },
  { postCode: '7253', suburb: 'LOW HEAD', state: 'TAS' },
  { postCode: '7254', suburb: 'BELLINGHAM', state: 'TAS' },
  { postCode: '7254', suburb: 'GOLCONDA', state: 'TAS' },
  { postCode: '7254', suburb: 'LEBRINA', state: 'TAS' },
  { postCode: '7254', suburb: 'PIPERS BROOK', state: 'TAS' },
  { postCode: '7254', suburb: 'RETREAT', state: 'TAS' },
  { postCode: '7254', suburb: 'TUNNEL', state: 'TAS' },
  { postCode: '7254', suburb: 'WYENA', state: 'TAS' },
  { postCode: '7255', suburb: 'BLUE ROCKS', state: 'TAS' },
  { postCode: '7255', suburb: 'EMITA', state: 'TAS' },
  { postCode: '7255', suburb: 'KILLIECRANKIE', state: 'TAS' },
  { postCode: '7255', suburb: 'LACKRANA', state: 'TAS' },
  { postCode: '7255', suburb: 'LADY BARRON', state: 'TAS' },
  { postCode: '7255', suburb: 'LEEKA', state: 'TAS' },
  { postCode: '7255', suburb: 'LOCCOTA', state: 'TAS' },
  { postCode: '7255', suburb: 'LUGHRATA', state: 'TAS' },
  { postCode: '7255', suburb: 'MEMANA', state: 'TAS' },
  { postCode: '7255', suburb: 'PALANA', state: 'TAS' },
  { postCode: '7255', suburb: 'RANGA', state: 'TAS' },
  { postCode: '7255', suburb: 'STRZELECKI', state: 'TAS' },
  { postCode: '7255', suburb: 'WHITEMARK', state: 'TAS' },
  { postCode: '7255', suburb: 'WINGAROO', state: 'TAS' },
  { postCode: '7256', suburb: 'BUNGAREE', state: 'TAS' },
  { postCode: '7256', suburb: 'CURRIE', state: 'TAS' },
  { postCode: '7256', suburb: 'EGG LAGOON', state: 'TAS' },
  { postCode: '7256', suburb: 'GRASSY', state: 'TAS' },
  { postCode: '7256', suburb: 'LOORANA', state: 'TAS' },
  { postCode: '7256', suburb: 'LYMWOOD', state: 'TAS' },
  { postCode: '7256', suburb: 'NARACOOPA', state: 'TAS' },
  { postCode: '7256', suburb: 'NUGARA', state: 'TAS' },
  { postCode: '7256', suburb: 'PEARSHAPE', state: 'TAS' },
  { postCode: '7256', suburb: 'PEGARAH', state: 'TAS' },
  { postCode: '7256', suburb: 'REEKARA', state: 'TAS' },
  { postCode: '7256', suburb: 'SEA ELEPHANT', state: 'TAS' },
  { postCode: '7256', suburb: 'SURPRISE BAY', state: 'TAS' },
  { postCode: '7256', suburb: 'WICKHAM', state: 'TAS' },
  { postCode: '7256', suburb: 'YAMBACOONA', state: 'TAS' },
  { postCode: '7256', suburb: 'YARRA CREEK', state: 'TAS' },
  { postCode: '7257', suburb: 'CAPE BARREN ISLAND', state: 'TAS' },
  { postCode: '7258', suburb: 'BREADALBANE', state: 'TAS' },
  { postCode: '7258', suburb: 'RELBIA', state: 'TAS' },
  { postCode: '7258', suburb: 'WHITE HILLS', state: 'TAS' },
  { postCode: '7259', suburb: 'MYRTLE BANK', state: 'TAS' },
  { postCode: '7259', suburb: 'NUNAMARA', state: 'TAS' },
  { postCode: '7259', suburb: 'PATERSONIA', state: 'TAS' },
  { postCode: '7259', suburb: 'TARGA', state: 'TAS' },
  { postCode: '7259', suburb: 'TAYENE', state: 'TAS' },
  { postCode: '7260', suburb: 'BLUMONT', state: 'TAS' },
  { postCode: '7260', suburb: 'CUCKOO', state: 'TAS' },
  { postCode: '7260', suburb: 'FORESTER', state: 'TAS' },
  { postCode: '7260', suburb: 'JETSONVILLE', state: 'TAS' },
  { postCode: '7260', suburb: 'KAMONA', state: 'TAS' },
  { postCode: '7260', suburb: 'LIETINNA', state: 'TAS' },
  { postCode: '7260', suburb: 'LISLE', state: 'TAS' },
  { postCode: '7260', suburb: 'NABOWLA', state: 'TAS' },
  { postCode: '7260', suburb: 'NORTH SCOTTSDALE', state: 'TAS' },
  { postCode: '7260', suburb: 'SCOTTSDALE', state: 'TAS' },
  { postCode: '7260', suburb: 'SOUTH SPRINGFIELD', state: 'TAS' },
  { postCode: '7260', suburb: 'SPRINGFIELD', state: 'TAS' },
  { postCode: '7260', suburb: 'TONGANAH', state: 'TAS' },
  { postCode: '7260', suburb: 'TULENDEENA', state: 'TAS' },
  { postCode: '7260', suburb: 'WEST SCOTTSDALE', state: 'TAS' },
  { postCode: '7261', suburb: 'BRANXHOLM', state: 'TAS' },
  { postCode: '7261', suburb: 'WARRENTINNA', state: 'TAS' },
  { postCode: '7262', suburb: 'BRIDPORT', state: 'TAS' },
  { postCode: '7262', suburb: 'TOMAHAWK', state: 'TAS' },
  { postCode: '7262', suburb: 'WATERHOUSE', state: 'TAS' },
  { postCode: '7263', suburb: 'ALBERTON', state: 'TAS' },
  { postCode: '7263', suburb: 'LEGERWOOD', state: 'TAS' },
  { postCode: '7263', suburb: 'RINGAROOMA', state: 'TAS' },
  { postCode: '7263', suburb: 'TALAWA', state: 'TAS' },
  { postCode: '7263', suburb: 'TRENAH', state: 'TAS' },
  { postCode: '7264', suburb: 'ANSONS BAY', state: 'TAS' },
  { postCode: '7264', suburb: 'BOOBYALLA', state: 'TAS' },
  { postCode: '7264', suburb: 'CAPE PORTLAND', state: 'TAS' },
  { postCode: '7264', suburb: 'DERBY', state: 'TAS' },
  { postCode: '7264', suburb: 'EDDYSTONE', state: 'TAS' },
  { postCode: '7264', suburb: 'GLADSTONE', state: 'TAS' },
  { postCode: '7264', suburb: 'HERRICK', state: 'TAS' },
  { postCode: '7264', suburb: 'MOORINA', state: 'TAS' },
  { postCode: '7264', suburb: 'MOUNT WILLIAM', state: 'TAS' },
  { postCode: '7264', suburb: 'MUSSELROE BAY', state: 'TAS' },
  { postCode: '7264', suburb: 'PIONEER', state: 'TAS' },
  { postCode: '7264', suburb: 'RUSHY LAGOON', state: 'TAS' },
  { postCode: '7264', suburb: 'SOUTH MOUNT CAMERON', state: 'TAS' },
  { postCode: '7264', suburb: 'TELITA', state: 'TAS' },
  { postCode: '7264', suburb: 'WELDBOROUGH', state: 'TAS' },
  { postCode: '7265', suburb: 'BANCA', state: 'TAS' },
  { postCode: '7265', suburb: 'WINNALEAH', state: 'TAS' },
  { postCode: '7267', suburb: 'BANGOR', state: 'TAS' },
  { postCode: '7267', suburb: 'KAROOLA', state: 'TAS' },
  { postCode: '7267', suburb: 'LALLA', state: 'TAS' },
  { postCode: '7267', suburb: 'LOWER TURNERS MARSH', state: 'TAS' },
  { postCode: '7267', suburb: 'TURNERS MARSH', state: 'TAS' },
  { postCode: '7268', suburb: 'LILYDALE', state: 'TAS' },
  { postCode: '7268', suburb: 'NORTH LILYDALE', state: 'TAS' },
  { postCode: '7268', suburb: 'UNDERWOOD', state: 'TAS' },
  { postCode: '7270', suburb: 'BADGER HEAD', state: 'TAS' },
  { postCode: '7270', suburb: 'BEACONSFIELD', state: 'TAS' },
  { postCode: '7270', suburb: 'BEAUTY POINT', state: 'TAS' },
  { postCode: '7270', suburb: 'CLARENCE POINT', state: 'TAS' },
  { postCode: '7270', suburb: 'FLOWERY GULLY', state: 'TAS' },
  { postCode: '7270', suburb: 'GREENS BEACH', state: 'TAS' },
  { postCode: '7270', suburb: 'KAYENA', state: 'TAS' },
  { postCode: '7270', suburb: 'KELSO', state: 'TAS' },
  { postCode: '7270', suburb: 'ROWELLA', state: 'TAS' },
  { postCode: '7270', suburb: 'SIDMOUTH', state: 'TAS' },
  { postCode: '7270', suburb: 'YORK TOWN', state: 'TAS' },
  { postCode: '7275', suburb: 'BLACKWALL', state: 'TAS' },
  { postCode: '7275', suburb: 'DEVIOT', state: 'TAS' },
  { postCode: '7275', suburb: 'EXETER', state: 'TAS' },
  { postCode: '7275', suburb: 'FRANKFORD', state: 'TAS' },
  { postCode: '7275', suburb: 'GLENGARRY', state: 'TAS' },
  { postCode: '7275', suburb: 'HOLWELL', state: 'TAS' },
  { postCode: '7275', suburb: 'LANENA', state: 'TAS' },
  { postCode: '7275', suburb: 'LOIRA', state: 'TAS' },
  { postCode: '7275', suburb: 'NOTLEY HILLS', state: 'TAS' },
  { postCode: '7275', suburb: 'ROBIGANA', state: 'TAS' },
  { postCode: '7275', suburb: 'SWAN POINT', state: 'TAS' },
  { postCode: '7275', suburb: 'WINKLEIGH', state: 'TAS' },
  { postCode: '7276', suburb: 'GRAVELLY BEACH', state: 'TAS' },
  { postCode: '7277', suburb: 'BRIDGENORTH', state: 'TAS' },
  { postCode: '7277', suburb: 'GRINDELWALD', state: 'TAS' },
  { postCode: '7277', suburb: 'LEGANA', state: 'TAS' },
  { postCode: '7277', suburb: 'ROSEVEARS', state: 'TAS' },
  { postCode: '7290', suburb: 'HADSPEN', state: 'TAS' },
  { postCode: '7291', suburb: 'CARRICK', state: 'TAS' },
  { postCode: '7292', suburb: 'HAGLEY', state: 'TAS' },
  { postCode: '7292', suburb: 'QUAMBY BEND', state: 'TAS' },
  { postCode: '7292', suburb: 'ROSEVALE', state: 'TAS' },
  { postCode: '7292', suburb: 'SELBOURNE', state: 'TAS' },
  { postCode: '7292', suburb: 'WESTWOOD', state: 'TAS' },
  { postCode: '7300', suburb: 'DEVON HILLS', state: 'TAS' },
  { postCode: '7300', suburb: 'PERTH', state: 'TAS' },
  { postCode: '7300', suburb: 'POWRANNA', state: 'TAS' },
  { postCode: '7301', suburb: 'BISHOPSBOURNE', state: 'TAS' },
  { postCode: '7301', suburb: 'BLACKWOOD CREEK', state: 'TAS' },
  { postCode: '7301', suburb: 'LIFFEY', state: 'TAS' },
  { postCode: '7301', suburb: 'LONGFORD', state: 'TAS' },
  { postCode: '7301', suburb: 'TOIBERRY', state: 'TAS' },
  { postCode: '7302', suburb: 'BRACKNELL', state: 'TAS' },
  { postCode: '7302', suburb: 'CRESSY', state: 'TAS' },
  { postCode: '7302', suburb: 'POATINA', state: 'TAS' },
  { postCode: '7303', suburb: 'BIRRALEE', state: 'TAS' },
  { postCode: '7303', suburb: 'CLUAN', state: 'TAS' },
  { postCode: '7303', suburb: 'EXTON', state: 'TAS' },
  { postCode: '7303', suburb: 'OAKS', state: 'TAS' },
  { postCode: '7303', suburb: 'OSMASTON', state: 'TAS' },
  { postCode: '7303', suburb: 'WESTBURY', state: 'TAS' },
  { postCode: '7303', suburb: 'WHITEMORE', state: 'TAS' },
  { postCode: '7304', suburb: 'BRANDUM', state: 'TAS' },
  { postCode: '7304', suburb: 'BREONA', state: 'TAS' },
  { postCode: '7304', suburb: 'CAVESIDE', state: 'TAS' },
  { postCode: '7304', suburb: 'CENTRAL PLATEAU', state: 'TAS' },
  { postCode: '7304', suburb: 'CHUDLEIGH', state: 'TAS' },
  { postCode: '7304', suburb: 'DAIRY PLAINS', state: 'TAS' },
  { postCode: '7304', suburb: 'DELORAINE', state: 'TAS' },
  { postCode: '7304', suburb: 'DOCTORS POINT', state: 'TAS' },
  { postCode: '7304', suburb: 'DUNORLAN', state: 'TAS' },
  { postCode: '7304', suburb: 'ELIZABETH TOWN', state: 'TAS' },
  { postCode: '7304', suburb: 'GOLDEN VALLEY', state: 'TAS' },
  { postCode: '7304', suburb: 'JACKEYS MARSH', state: 'TAS' },
  { postCode: '7304', suburb: 'KIMBERLEY', state: 'TAS' },
  { postCode: '7304', suburb: 'LIENA', state: 'TAS' },
  { postCode: '7304', suburb: 'MAYBERRY', state: 'TAS' },
  { postCode: '7304', suburb: 'MEANDER', state: 'TAS' },
  { postCode: '7304', suburb: 'MERSEY FOREST', state: 'TAS' },
  { postCode: '7304', suburb: 'MOLE CREEK', state: 'TAS' },
  { postCode: '7304', suburb: 'MOLTEMA', state: 'TAS' },
  { postCode: '7304', suburb: 'MONTANA', state: 'TAS' },
  { postCode: '7304', suburb: 'NEEDLES', state: 'TAS' },
  { postCode: '7304', suburb: 'PARKHAM', state: 'TAS' },
  { postCode: '7304', suburb: 'QUAMBY BROOK', state: 'TAS' },
  { postCode: '7304', suburb: 'RED HILLS', state: 'TAS' },
  { postCode: '7304', suburb: 'REEDY MARSH', state: 'TAS' },
  { postCode: '7304', suburb: 'REYNOLDS NECK', state: 'TAS' },
  { postCode: '7304', suburb: 'WALLS OF JERUSALEM', state: 'TAS' },
  { postCode: '7304', suburb: 'WEEGENA', state: 'TAS' },
  { postCode: '7304', suburb: 'WEETAH', state: 'TAS' },
  { postCode: '7304', suburb: 'WESTERN CREEK', state: 'TAS' },
  { postCode: '7305', suburb: 'MERSEYLEA', state: 'TAS' },
  { postCode: '7305', suburb: 'RAILTON', state: 'TAS' },
  { postCode: '7305', suburb: 'SUNNYSIDE', state: 'TAS' },
  { postCode: '7306', suburb: 'ACACIA HILLS', state: 'TAS' },
  { postCode: '7306', suburb: 'BARRINGTON', state: 'TAS' },
  { postCode: '7306', suburb: 'BEULAH', state: 'TAS' },
  { postCode: '7306', suburb: 'CETHANA', state: 'TAS' },
  { postCode: '7306', suburb: 'CLAUDE ROAD', state: 'TAS' },
  { postCode: '7306', suburb: 'CRADLE MOUNTAIN', state: 'TAS' },
  { postCode: '7306', suburb: 'GOWRIE PARK', state: 'TAS' },
  { postCode: '7306', suburb: 'LORINNA', state: 'TAS' },
  { postCode: '7306', suburb: 'LOWER BARRINGTON', state: 'TAS' },
  { postCode: '7306', suburb: 'LOWER BEULAH', state: 'TAS' },
  { postCode: '7306', suburb: 'MIDDLESEX', state: 'TAS' },
  { postCode: '7306', suburb: 'MOUNT ROLAND', state: 'TAS' },
  { postCode: '7306', suburb: 'NOOK', state: 'TAS' },
  { postCode: '7306', suburb: 'NOWHERE ELSE', state: 'TAS' },
  { postCode: '7306', suburb: 'PARADISE', state: 'TAS' },
  { postCode: '7306', suburb: 'PROMISED LAND', state: 'TAS' },
  { postCode: '7306', suburb: 'ROLAND', state: 'TAS' },
  { postCode: '7306', suburb: 'SHEFFIELD', state: 'TAS' },
  { postCode: '7306', suburb: 'STAVERTON', state: 'TAS' },
  { postCode: '7306', suburb: 'STOODLEY', state: 'TAS' },
  { postCode: '7306', suburb: 'WEST KENTISH', state: 'TAS' },
  { postCode: '7307', suburb: 'BAKERS BEACH', state: 'TAS' },
  { postCode: '7307', suburb: 'HARFORD', state: 'TAS' },
  { postCode: '7307', suburb: 'HAWLEY BEACH', state: 'TAS' },
  { postCode: '7307', suburb: 'LATROBE', state: 'TAS' },
  { postCode: '7307', suburb: 'MORIARTY', state: 'TAS' },
  { postCode: '7307', suburb: 'NORTHDOWN', state: 'TAS' },
  { postCode: '7307', suburb: 'PORT SORELL', state: 'TAS' },
  { postCode: '7307', suburb: 'SASSAFRAS', state: 'TAS' },
  { postCode: '7307', suburb: 'SHEARWATER', state: 'TAS' },
  { postCode: '7307', suburb: 'SQUEAKING POINT', state: 'TAS' },
  { postCode: '7307', suburb: 'THIRLSTANE', state: 'TAS' },
  { postCode: '7307', suburb: 'WESLEY VALE', state: 'TAS' },
  { postCode: '7310', suburb: 'ABERDEEN', state: 'TAS' },
  { postCode: '7310', suburb: 'AMBLESIDE', state: 'TAS' },
  { postCode: '7310', suburb: 'DEVONPORT', state: 'TAS' },
  { postCode: '7310', suburb: 'DON', state: 'TAS' },
  { postCode: '7310', suburb: 'EAST DEVONPORT', state: 'TAS' },
  { postCode: '7310', suburb: 'ERRIBA', state: 'TAS' },
  { postCode: '7310', suburb: 'EUGENANA', state: 'TAS' },
  { postCode: '7310', suburb: 'FORTH', state: 'TAS' },
  { postCode: '7310', suburb: 'FORTHSIDE', state: 'TAS' },
  { postCode: '7310', suburb: 'KINDRED', state: 'TAS' },
  { postCode: '7310', suburb: 'LILLICO', state: 'TAS' },
  { postCode: '7310', suburb: 'LOWER WILMOT', state: 'TAS' },
  { postCode: '7310', suburb: 'MELROSE', state: 'TAS' },
  { postCode: '7310', suburb: 'MIANDETTA', state: 'TAS' },
  { postCode: '7310', suburb: 'MOINA', state: 'TAS' },
  { postCode: '7310', suburb: 'PALOONA', state: 'TAS' },
  { postCode: '7310', suburb: 'QUOIBA', state: 'TAS' },
  { postCode: '7310', suburb: 'SOUTH SPREYTON', state: 'TAS' },
  { postCode: '7310', suburb: 'SPREYTON', state: 'TAS' },
  { postCode: '7310', suburb: 'STONY RISE', state: 'TAS' },
  { postCode: '7310', suburb: 'TARLETON', state: 'TAS' },
  { postCode: '7310', suburb: 'TUGRAH', state: 'TAS' },
  { postCode: '7310', suburb: 'WILMOT', state: 'TAS' },
  { postCode: '7315', suburb: 'ABBOTSHAM', state: 'TAS' },
  { postCode: '7315', suburb: 'CASTRA', state: 'TAS' },
  { postCode: '7315', suburb: 'GAWLER', state: 'TAS' },
  { postCode: '7315', suburb: 'GUNNS PLAINS', state: 'TAS' },
  { postCode: '7315', suburb: 'LEITH', state: 'TAS' },
  { postCode: '7315', suburb: 'LOONGANA', state: 'TAS' },
  { postCode: '7315', suburb: 'NIETTA', state: 'TAS' },
  { postCode: '7315', suburb: 'NORTH MOTTON', state: 'TAS' },
  { postCode: '7315', suburb: 'PRESTON', state: 'TAS' },
  { postCode: '7315', suburb: 'SOUTH NIETTA', state: 'TAS' },
  { postCode: '7315', suburb: 'SOUTH PRESTON', state: 'TAS' },
  { postCode: '7315', suburb: 'SPALFORD', state: 'TAS' },
  { postCode: '7315', suburb: 'SPRENT', state: 'TAS' },
  { postCode: '7315', suburb: 'TURNERS BEACH', state: 'TAS' },
  { postCode: '7315', suburb: 'ULVERSTONE', state: 'TAS' },
  { postCode: '7315', suburb: 'UPPER CASTRA', state: 'TAS' },
  { postCode: '7315', suburb: 'WEST ULVERSTONE', state: 'TAS' },
  { postCode: '7316', suburb: 'CAMENA', state: 'TAS' },
  { postCode: '7316', suburb: 'CUPRONA', state: 'TAS' },
  { postCode: '7316', suburb: 'HEYBRIDGE', state: 'TAS' },
  { postCode: '7316', suburb: 'HOWTH', state: 'TAS' },
  { postCode: '7316', suburb: 'LOYETEA', state: 'TAS' },
  { postCode: '7316', suburb: 'PENGUIN', state: 'TAS' },
  { postCode: '7316', suburb: 'PRESERVATION BAY', state: 'TAS' },
  { postCode: '7316', suburb: 'RIANA', state: 'TAS' },
  { postCode: '7316', suburb: 'SOUTH RIANA', state: 'TAS' },
  { postCode: '7316', suburb: 'SULPHUR CREEK', state: 'TAS' },
  { postCode: '7316', suburb: 'WEST PINE', state: 'TAS' },
  { postCode: '7320', suburb: 'ACTON', state: 'TAS' },
  { postCode: '7320', suburb: 'BROOKLYN', state: 'TAS' },
  { postCode: '7320', suburb: 'BURNIE', state: 'TAS' },
  { postCode: '7320', suburb: 'CAMDALE', state: 'TAS' },
  { postCode: '7320', suburb: 'COOEE', state: 'TAS' },
  { postCode: '7320', suburb: 'DOWNLANDS', state: 'TAS' },
  { postCode: '7320', suburb: 'EMU HEIGHTS', state: 'TAS' },
  { postCode: '7320', suburb: 'HAVENVIEW', state: 'TAS' },
  { postCode: '7320', suburb: 'HILLCREST', state: 'TAS' },
  { postCode: '7320', suburb: 'MONTELLO', state: 'TAS' },
  { postCode: '7320', suburb: 'OCEAN VISTA', state: 'TAS' },
  { postCode: '7320', suburb: 'PARK GROVE', state: 'TAS' },
  { postCode: '7320', suburb: 'PARKLANDS', state: 'TAS' },
  { postCode: '7320', suburb: 'ROMAINE', state: 'TAS' },
  { postCode: '7320', suburb: 'ROUND HILL', state: 'TAS' },
  { postCode: '7320', suburb: 'SHOREWELL PARK', state: 'TAS' },
  { postCode: '7320', suburb: 'SOUTH BURNIE', state: 'TAS' },
  { postCode: '7320', suburb: 'UPPER BURNIE', state: 'TAS' },
  { postCode: '7320', suburb: 'WIVENHOE', state: 'TAS' },
  { postCode: '7321', suburb: 'BLACK RIVER', state: 'TAS' },
  { postCode: '7321', suburb: 'BOAT HARBOUR', state: 'TAS' },
  { postCode: '7321', suburb: 'BOAT HARBOUR BEACH', state: 'TAS' },
  { postCode: '7321', suburb: 'CHASM CREEK', state: 'TAS' },
  { postCode: '7321', suburb: 'CORINNA', state: 'TAS' },
  { postCode: '7321', suburb: 'COWRIE POINT', state: 'TAS' },
  { postCode: '7321', suburb: 'CRAYFISH CREEK', state: 'TAS' },
  { postCode: '7321', suburb: 'DETENTION', state: 'TAS' },
  { postCode: '7321', suburb: 'EAST CAM', state: 'TAS' },
  { postCode: '7321', suburb: 'EAST RIDGLEY', state: 'TAS' },
  { postCode: '7321', suburb: 'EDGCUMBE BEACH', state: 'TAS' },
  { postCode: '7321', suburb: 'GUILDFORD', state: 'TAS' },
  { postCode: '7321', suburb: 'HAMPSHIRE', state: 'TAS' },
  { postCode: '7321', suburb: 'HELLYER', state: 'TAS' },
  { postCode: '7321', suburb: 'HIGHCLERE', state: 'TAS' },
  { postCode: '7321', suburb: 'LUINA', state: 'TAS' },
  { postCode: '7321', suburb: 'MAWBANNA', state: 'TAS' },
  { postCode: '7321', suburb: 'MONTUMANA', state: 'TAS' },
  { postCode: '7321', suburb: 'MOOREVILLE', state: 'TAS' },
  { postCode: '7321', suburb: 'NATONE', state: 'TAS' },
  { postCode: '7321', suburb: 'PARRAWE', state: 'TAS' },
  { postCode: '7321', suburb: 'PORT LATTA', state: 'TAS' },
  { postCode: '7321', suburb: 'RIDGLEY', state: 'TAS' },
  { postCode: '7321', suburb: 'ROCKY CAPE', state: 'TAS' },
  { postCode: '7321', suburb: 'SAVAGE RIVER', state: 'TAS' },
  { postCode: '7321', suburb: 'SISTERS BEACH', state: 'TAS' },
  { postCode: '7321', suburb: 'STOWPORT', state: 'TAS' },
  { postCode: '7321', suburb: 'TEWKESBURY', state: 'TAS' },
  { postCode: '7321', suburb: 'TULLAH', state: 'TAS' },
  { postCode: '7321', suburb: 'UPPER NATONE', state: 'TAS' },
  { postCode: '7321', suburb: 'UPPER STOWPORT', state: 'TAS' },
  { postCode: '7321', suburb: 'WARATAH', state: 'TAS' },
  { postCode: '7321', suburb: 'WEST MOOREVILLE', state: 'TAS' },
  { postCode: '7321', suburb: 'WEST RIDGLEY', state: 'TAS' },
  { postCode: '7321', suburb: 'WILTSHIRE', state: 'TAS' },
  { postCode: '7322', suburb: 'SOMERSET', state: 'TAS' },
  { postCode: '7325', suburb: 'CALDER', state: 'TAS' },
  { postCode: '7325', suburb: 'DOCTORS ROCKS', state: 'TAS' },
  { postCode: '7325', suburb: 'ELLIOTT', state: 'TAS' },
  { postCode: '7325', suburb: 'FLOWERDALE', state: 'TAS' },
  { postCode: '7325', suburb: 'HENRIETTA', state: 'TAS' },
  { postCode: '7325', suburb: 'LAPOINYA', state: 'TAS' },
  { postCode: '7325', suburb: 'MEUNNA', state: 'TAS' },
  { postCode: '7325', suburb: 'MILABENA', state: 'TAS' },
  { postCode: '7325', suburb: 'MOORLEAH', state: 'TAS' },
  { postCode: '7325', suburb: 'MOUNT HICKS', state: 'TAS' },
  { postCode: '7325', suburb: 'MYALLA', state: 'TAS' },
  { postCode: '7325', suburb: 'OLDINA', state: 'TAS' },
  { postCode: '7325', suburb: 'OONAH', state: 'TAS' },
  { postCode: '7325', suburb: 'PREOLENNA', state: 'TAS' },
  { postCode: '7325', suburb: 'SISTERS CREEK', state: 'TAS' },
  { postCode: '7325', suburb: 'TABLE CAPE', state: 'TAS' },
  { postCode: '7325', suburb: 'TAKONE', state: 'TAS' },
  { postCode: '7325', suburb: 'WEST TAKONE', state: 'TAS' },
  { postCode: '7325', suburb: 'WYNYARD', state: 'TAS' },
  { postCode: '7325', suburb: 'YOLLA', state: 'TAS' },
  { postCode: '7330', suburb: 'ALCOMIE', state: 'TAS' },
  { postCode: '7330', suburb: 'ARTHUR RIVER', state: 'TAS' },
  { postCode: '7330', suburb: 'BRITTONS SWAMP', state: 'TAS' },
  { postCode: '7330', suburb: 'BROADMEADOWS', state: 'TAS' },
  { postCode: '7330', suburb: 'CHRISTMAS HILLS', state: 'TAS' },
  { postCode: '7330', suburb: 'COUTA ROCKS', state: 'TAS' },
  { postCode: '7330', suburb: 'EDITH CREEK', state: 'TAS' },
  { postCode: '7330', suburb: 'FOREST', state: 'TAS' },
  { postCode: '7330', suburb: 'IRISHTOWN', state: 'TAS' },
  { postCode: '7330', suburb: 'LILEAH', state: 'TAS' },
  { postCode: '7330', suburb: 'MARRAWAH', state: 'TAS' },
  { postCode: '7330', suburb: 'MELLA', state: 'TAS' },
  { postCode: '7330', suburb: 'MENGHA', state: 'TAS' },
  { postCode: '7330', suburb: 'MONTAGU', state: 'TAS' },
  { postCode: '7330', suburb: 'NABAGEENA', state: 'TAS' },
  { postCode: '7330', suburb: 'NELSON BAY', state: 'TAS' },
  { postCode: '7330', suburb: 'REDPA', state: 'TAS' },
  { postCode: '7330', suburb: 'ROGER RIVER', state: 'TAS' },
  { postCode: '7330', suburb: 'SCOPUS', state: 'TAS' },
  { postCode: '7330', suburb: 'SCOTCHTOWN', state: 'TAS' },
  { postCode: '7330', suburb: 'SMITHTON', state: 'TAS' },
  { postCode: '7330', suburb: 'SOUTH FOREST', state: 'TAS' },
  { postCode: '7330', suburb: 'TEMMA', state: 'TAS' },
  { postCode: '7330', suburb: 'TOGARI', state: 'TAS' },
  { postCode: '7330', suburb: 'TROWUTTA', state: 'TAS' },
  { postCode: '7330', suburb: 'WEST MONTAGU', state: 'TAS' },
  { postCode: '7330', suburb: 'WOOLNORTH', state: 'TAS' },
  { postCode: '7331', suburb: 'STANLEY', state: 'TAS' },
  { postCode: '7466', suburb: 'GORMANSTON', state: 'TAS' },
  { postCode: '7467', suburb: 'LAKE MARGARET', state: 'TAS' },
  { postCode: '7467', suburb: 'QUEENSTOWN', state: 'TAS' },
  { postCode: '7468', suburb: 'MACQUARIE HEADS', state: 'TAS' },
  { postCode: '7468', suburb: 'STRAHAN', state: 'TAS' },
  { postCode: '7469', suburb: 'GRANVILLE HARBOUR', state: 'TAS' },
  { postCode: '7469', suburb: 'RENISON BELL', state: 'TAS' },
  { postCode: '7469', suburb: 'TRIAL HARBOUR', state: 'TAS' },
  { postCode: '7469', suburb: 'ZEEHAN', state: 'TAS' },
  { postCode: '7470', suburb: 'ROSEBERY', state: 'TAS' },
];
